export const longevityData = {
    graphMaxAge: 120,

    baseline: {
        m: {
      survival: [ 1.0, 0.9917033468, 0.9911960605, 0.9908254052, 0.9905773675, 0.9903846828, 0.9902438478, 0.9901261349, 0.9900105241, 0.9899089267, 0.9897912139, 0.989673501, 0.9895627949, 0.9893932324, 0.9891648134, 0.9888179809, 0.9883275108, 0.9876723827, 0.9867208706, 0.9853994039, 0.9839581223, 0.9823528835, 0.9804911989, 0.9785033934, 0.9763705488, 0.9740849578, 0.9716718446, 0.9691031823, 0.9662815775, 0.9634676801, 0.9607259519, 0.9578798236, 0.9551212793, 0.9522380154, 0.9492713715, 0.9462984217, 0.9430956515, 0.939895684, 0.9365478748, 0.9330291017, 0.9295152333, 0.9260363985, 0.9224685784, 0.9189084657, 0.9151381514, 0.9110623444, 0.9066207867, 0.9015759507, 0.8959474552, 0.889932189, 0.883532254, 0.8768513497, 0.8695349362, 0.8612782213, 0.8519347647, 0.8413700373, 0.8297984448, 0.8172592247, 0.8034945299, 0.7889051445, 0.7734574363, 0.7572025544, 0.7399197871, 0.7219160287, 0.702982479, 0.6837777694, 0.6642206219, 0.6441716029, 0.6239256952, 0.6033974168, 0.5815925146, 0.5587401083, 0.5338529514, 0.5131158729, 0.4917699106, 0.4689644493, 0.4441312442, 0.4207379194, 0.3976052444, 0.3748733536, 0.3514141656, 0.327450494, 0.3037867099, 0.2795778033, 0.255235769, 0.2314647821, 0.2073939078, 0.1832718844, 0.1594931902, 0.1359877579, 0.1141576315, 0.093522851, 0.0748044075, 0.0585439202, 0.0442474156, 0.0324361933, 0.0230044521, 0.0154785377, 0.0099607484, 0.0061848288, 0.0038663062 ],
            median: 73.6144428
        },

        w: {
      survival: [ 1.0, 0.9931644194, 0.9927730099, 0.992511329, 0.9923519483, 0.9922311154, 0.9921377109, 0.9920658042, 0.9919931563, 0.9919034583, 0.9918167255, 0.991723321, 0.9916010055, 0.9914831379, 0.9913400659, 0.9911599286, 0.9909301238, 0.9906565819, 0.9902770334, 0.9898048216, 0.9892881315, 0.9887024999, 0.98807239, 0.9874022496, 0.9866653916, 0.9858810901, 0.9850271058, 0.9840448757, 0.982978878, 0.9818350432, 0.9805918734, 0.9793123796, 0.9780150945, 0.9766021657, 0.9751269671, 0.9736243403, 0.9719534371, 0.9702306425, 0.9684070302, 0.9664907548, 0.9644291834, 0.9624054186, 0.9602793537, 0.9580717451, 0.9556558295, 0.953123529, 0.9502257647, 0.9468943365, 0.9432523012, 0.9393233806, 0.9351965313, 0.9307561097, 0.9257300565, 0.9202251197, 0.9140152012, 0.9069639006, 0.8992735945, 0.890758215, 0.8815586102, 0.8717667022, 0.8613810082, 0.8503607565, 0.8385391532, 0.8263706188, 0.8135312027, 0.8003863686, 0.7866521964, 0.772510306, 0.7577034643, 0.7422902346, 0.7258540028, 0.7078439789, 0.6878576337, 0.6707497789, 0.6527597702, 0.633025469, 0.6111206245, 0.5900779187, 0.5689825801, 0.5473142121, 0.5246191356, 0.5007439004, 0.4761355137, 0.450082322, 0.4227503779, 0.3953858163, 0.3664489452, 0.3362941086, 0.3048004738, 0.2721763477, 0.2398168678, 0.20718607, 0.1754440978, 0.1458815645, 0.1181211457, 0.0931191256, 0.07133289, 0.0528017281, 0.0376175618, 0.0261265809, 0.0179648043 ],
            median: 81.03022955
        }
    },

states:{
    "m": [
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.0002839880117,
          0.06330650260761,
          79.71928856
        ],
        [
          0.00022506712978,
          0.0701085358977,
          76.73115514
        ],
        [
          0.00027212947391,
          0.06349906933158,
          80.1925671
        ],
        [
          0.00023277147163,
          0.07005316569587,
          76.30236142
        ],
        [
          0.0003578194434,
          0.05707652286867,
          82.6015716
        ],
        [
          0.00022504284721,
          0.07010790527635,
          76.73324953
        ],
        [
          0.00033967112859,
          0.05741828738973,
          83.11159954
        ],
        [
          0.00023251036022,
          0.06986834545088,
          76.48255866
        ],
        [
          0.00029590711476,
          0.06164936179094,
          80.77229558
        ],
        [
          0.00022468287342,
          0.06993012100791,
          76.91497472
        ],
        [
          0.00028239429944,
          0.06190486694027,
          81.25526695
        ],
        [
          0.00023248572848,
          0.06986769275136,
          76.48464919
        ],
        [
          0.0003616183208,
          0.05589157659202,
          83.79362276
        ],
        [
          0.00022465791559,
          0.06992953975971,
          76.91707694
        ],
        [
          0.00034185256476,
          0.05629348075572,
          84.31108467
        ],
        [
          0.00023279545759,
          0.07005386336444,
          76.30027916
        ],
        [
          0.0002839880117,
          0.06330650260761,
          79.71928856
        ],
        [
          0.00022506712978,
          0.0701085358977,
          76.73115514
        ],
        [
          0.00027212947391,
          0.06349906933158,
          80.1925671
        ],
        [
          0.00023277147163,
          0.07005316569587,
          76.30236142
        ],
        [
          0.0003578194434,
          0.05707652286867,
          82.6015716
        ],
        [
          0.00022504284721,
          0.07010790527635,
          76.73324953
        ],
        [
          0.00035628053165,
          0.05644088245075,
          83.4108755
        ],
        [
          0.00023251036022,
          0.06986834545088,
          76.48255866
        ],
        [
          0.00029590711476,
          0.06164936179094,
          80.77229558
        ],
        [
          0.00022468287342,
          0.06993012100791,
          76.91497472
        ],
        [
          0.00028239429944,
          0.06190486694027,
          81.25526695
        ],
        [
          0.00023248572848,
          0.06986769275136,
          76.48464919
        ],
        [
          0.0003616183208,
          0.05589157659202,
          83.79362276
        ],
        [
          0.00022465791559,
          0.06992953975971,
          76.91707694
        ],
        [
          0.00035796380932,
          0.05533970584134,
          84.63344404
        ],
        [
          0.00024045834185,
          0.06927519041585,
          76.53212486
        ],
        [
          0.0003096821994,
          0.06077041427776,
          80.9624858
        ],
        [
          0.00023243632399,
          0.06933265779009,
          76.96758224
        ],
        [
          0.00036309983951,
          0.05383810091278,
          86.2257171
        ],
        [
          0.00024043315824,
          0.06927452143064,
          76.5342296
        ],
        [
          0.00037612099603,
          0.05509572736255,
          84.03926215
        ],
        [
          0.0002324107183,
          0.06933206532853,
          76.96969864
        ],
        [
          0.00039886015934,
          0.04956369573841,
          90.13519153
        ],
        [
          0.00024010390807,
          0.06909374974003,
          76.7165739
        ],
        [
          0.00031826432694,
          0.05932693945361,
          82.07288805
        ],
        [
          0.00023196877407,
          0.06915922937994,
          77.15352625
        ],
        [
          0.0003580828238,
          0.05299546100157,
          87.56193659
        ],
        [
          0.00024007800221,
          0.06909313001717,
          76.71868671
        ],
        [
          0.00037621205123,
          0.05406048489071,
          85.29673226
        ],
        [
          0.00023194242264,
          0.06915869032582,
          77.15565023
        ],
        [
          0.00038609685851,
          0.04894958920127,
          91.67105067
        ],
        [
          0.00024045834185,
          0.06927519041585,
          76.53212486
        ],
        [
          0.00034383055117,
          0.05804468640841,
          82.19212535
        ],
        [
          0.00023243632399,
          0.06933265779009,
          76.96758224
        ],
        [
          0.00038569620967,
          0.05173893961221,
          87.80814636
        ],
        [
          0.00024043315824,
          0.06927452143064,
          76.5342296
        ],
        [
          0.0004047473011,
          0.05282510133603,
          85.48888918
        ],
        [
          0.0002324107183,
          0.06933206532853,
          76.96969864
        ],
        [
          0.00043295710362,
          0.0467571469176,
          92.58138244
        ],
        [
          0.00024010390807,
          0.06909374974003,
          76.7165739
        ],
        [
          0.00034924221665,
          0.05677946529926,
          83.36616101
        ],
        [
          0.00023196877407,
          0.06915922937994,
          77.15352625
        ],
        [
          0.0003775364601,
          0.05099020975162,
          89.22956168
        ],
        [
          0.00024007800221,
          0.06909313001717,
          76.71868671
        ],
        [
          0.00040156661556,
          0.05190163536629,
          86.82423175
        ],
        [
          0.00023194242264,
          0.06915869032582,
          77.15565023
        ],
        [
          0.00041676495279,
          0.04618353209207,
          94.28205372
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00029708030863,
          0.06286518851738,
          79.45616823
        ],
        [
          0.0002350508475,
          0.06969021135667,
          76.48641574
        ],
        [
          0.0002849424646,
          0.06304717320679,
          79.92963302
        ],
        [
          0.00024303393446,
          0.06963597400294,
          76.05759978
        ],
        [
          0.00037567522534,
          0.05657791548098,
          82.32310934
        ],
        [
          0.00023505682145,
          0.06968829169977,
          76.48776637
        ],
        [
          0.00035707769284,
          0.0569048405782,
          82.83445678
        ],
        [
          0.00024276780486,
          0.06945059001963,
          76.23812563
        ],
        [
          0.000310036004,
          0.06118468832392,
          80.50600376
        ],
        [
          0.00023469284791,
          0.06950956291059,
          76.66985881
        ],
        [
          0.00029619281124,
          0.06142806940799,
          80.98953687
        ],
        [
          0.00024277439864,
          0.06944864576703,
          76.23946975
        ],
        [
          0.00038046628157,
          0.05536304694052,
          83.51460183
        ],
        [
          0.00023469822265,
          0.06950768410755,
          76.67121634
        ],
        [
          0.00036017359866,
          0.0557488314678,
          84.03387347
        ],
        [
          0.00024302677361,
          0.06963795584447,
          76.05626287
        ],
        [
          0.00029708030863,
          0.06286518851738,
          79.45616823
        ],
        [
          0.0002350508475,
          0.06969021135667,
          76.48641574
        ],
        [
          0.0002849424646,
          0.06304717320679,
          79.92963302
        ],
        [
          0.00024303393446,
          0.06963597400294,
          76.05759978
        ],
        [
          0.00037567522534,
          0.05657791548098,
          82.32310934
        ],
        [
          0.00023505682145,
          0.06968829169977,
          76.48776637
        ],
        [
          0.00037448386876,
          0.05592820811344,
          83.13114777
        ],
        [
          0.00024276780486,
          0.06945059001963,
          76.23812563
        ],
        [
          0.000310036004,
          0.06118468832392,
          80.50600376
        ],
        [
          0.00023469284791,
          0.06950956291059,
          76.66985881
        ],
        [
          0.00029619281124,
          0.06142806940799,
          80.98953687
        ],
        [
          0.00024277439864,
          0.06944864576703,
          76.23946975
        ],
        [
          0.00038046628157,
          0.05536304694052,
          83.51460183
        ],
        [
          0.00023469822265,
          0.06950768410755,
          76.67121634
        ],
        [
          0.00037710293857,
          0.05479548327536,
          84.35387969
        ],
        [
          0.00025096995297,
          0.06886273490959,
          76.28608475
        ],
        [
          0.00032454905116,
          0.06030413093594,
          80.6900061
        ],
        [
          0.00024270501652,
          0.06891692412006,
          76.7208535
        ],
        [
          0.00038350620187,
          0.05326024155494,
          85.94424742
        ],
        [
          0.00025097680568,
          0.06886078858452,
          76.2874382
        ],
        [
          0.00039588198962,
          0.05456327598863,
          83.75414032
        ],
        [
          0.00024271056173,
          0.0689150467708,
          76.72222035
        ],
        [
          0.0004240194339,
          0.04889494581934,
          89.85735716
        ],
        [
          0.00025064627719,
          0.0686790288748,
          76.4701394
        ],
        [
          0.00033416893291,
          0.05883335062581,
          81.798258
        ],
        [
          0.00024226775274,
          0.06874084330592,
          76.90644764
        ],
        [
          0.00037925106258,
          0.05238059080691,
          87.28369325
        ],
        [
          0.00025065249785,
          0.06867712318734,
          76.47149993
        ],
        [
          0.00039691349079,
          0.05349527478794,
          85.01245557
        ],
        [
          0.00024227263755,
          0.06873900962539,
          76.90782125
        ],
        [
          0.00041189407351,
          0.04823498053827,
          91.4026493
        ],
        [
          0.00025096995297,
          0.06886273490959,
          76.28608475
        ],
        [
          0.00036085373572,
          0.05755669476091,
          81.91131354
        ],
        [
          0.00024270501652,
          0.06891692412006,
          76.7208535
        ],
        [
          0.00040831242406,
          0.05112920861389,
          87.5237683
        ],
        [
          0.00025097680568,
          0.06886078858452,
          76.2874382
        ],
        [
          0.00042682667278,
          0.05226525052466,
          85.19827225
        ],
        [
          0.00024271056173,
          0.0689150467708,
          76.72222035
        ],
        [
          0.00046160081395,
          0.04604823737492,
          92.30732862
        ],
        [
          0.00025064627719,
          0.0686790288748,
          76.4701394
        ],
        [
          0.00036729982591,
          0.05626156939959,
          83.08424536
        ],
        [
          0.00024226775274,
          0.06874084330592,
          76.90644764
        ],
        [
          0.0004008824856,
          0.05034042347999,
          88.95049797
        ],
        [
          0.00025065249785,
          0.06867712318734,
          76.47149993
        ],
        [
          0.00042456260193,
          0.05130660992869,
          86.53602534
        ],
        [
          0.00024227263755,
          0.06873900962539,
          76.90782125
        ],
        [
          0.00044608142936,
          0.04542365722669,
          94.02242508
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00029731610074,
          0.06285741412762,
          79.45150493
        ],
        [
          0.0002354000763,
          0.06967586981281,
          76.47801483
        ],
        [
          0.00028540322861,
          0.0630312917857,
          79.92033352
        ],
        [
          0.00024320550143,
          0.06962913469214,
          76.05358281
        ],
        [
          0.00037600529207,
          0.0565689208463,
          82.31803787
        ],
        [
          0.00023540607286,
          0.06967394936368,
          76.4793653
        ],
        [
          0.00035771030434,
          0.05688664905,
          82.82453971
        ],
        [
          0.00024293979669,
          0.06944372172622,
          76.23410175
        ],
        [
          0.00031030391759,
          0.06117607824338,
          80.50103385
        ],
        [
          0.00023504299293,
          0.06949514722298,
          76.66144466
        ],
        [
          0.00029670218552,
          0.06141088590228,
          80.9798882
        ],
        [
          0.00024294640153,
          0.06944177711828,
          76.23544579
        ],
        [
          0.00038083271138,
          0.05535302967874,
          83.50925837
        ],
        [
          0.00023504839024,
          0.06949326757436,
          76.66280205
        ],
        [
          0.00036085720986,
          0.05572904081931,
          84.02369265
        ],
        [
          0.00024319832956,
          0.06963111686156,
          76.05224597
        ],
        [
          0.00029731610074,
          0.06285741412762,
          79.45150493
        ],
        [
          0.0002354000763,
          0.06967586981281,
          76.47801483
        ],
        [
          0.00028540322861,
          0.0630312917857,
          79.92033352
        ],
        [
          0.00024320550143,
          0.06962913469214,
          76.05358281
        ],
        [
          0.00037600529207,
          0.0565689208463,
          82.31803787
        ],
        [
          0.00023540607286,
          0.06967394936368,
          76.4793653
        ],
        [
          0.00037514534217,
          0.05591004476405,
          83.1211377
        ],
        [
          0.00024293979669,
          0.06944372172622,
          76.23410175
        ],
        [
          0.00031030391759,
          0.06117607824338,
          80.50103385
        ],
        [
          0.00023504299293,
          0.06949514722298,
          76.66144466
        ],
        [
          0.00029670218552,
          0.06141088590228,
          80.9798882
        ],
        [
          0.00024294640153,
          0.06944177711828,
          76.23544579
        ],
        [
          0.00038083271138,
          0.05535302967874,
          83.50925837
        ],
        [
          0.00023504839024,
          0.06949326757436,
          76.66280205
        ],
        [
          0.00037781689735,
          0.05477571252963,
          84.34361143
        ],
        [
          0.00025114614451,
          0.06885595547535,
          76.28203447
        ],
        [
          0.00032487339677,
          0.06029419315359,
          80.68415427
        ],
        [
          0.00024306408239,
          0.0689026778282,
          76.71238408
        ],
        [
          0.00038431347944,
          0.05323800766032,
          85.93328713
        ],
        [
          0.00025115300894,
          0.06885400877355,
          76.28338784
        ],
        [
          0.00039632222463,
          0.05455171551593,
          83.7478828
        ],
        [
          0.00024306965157,
          0.06890079958044,
          76.71375079
        ],
        [
          0.00042502538954,
          0.04886902106892,
          89.84641858
        ],
        [
          0.0002508229831,
          0.06867221333566,
          76.46608249
        ],
        [
          0.00033453097279,
          0.0588223854819,
          81.79210458
        ],
        [
          0.00024262787851,
          0.06872650861421,
          76.89796588
        ],
        [
          0.0003801090902,
          0.05235638276027,
          87.27259644
        ],
        [
          0.00025082921551,
          0.06867030724336,
          76.46744294
        ],
        [
          0.00039739432845,
          0.05348249460181,
          85.00595248
        ],
        [
          0.00024263278719,
          0.06872467398248,
          76.89933935
        ],
        [
          0.00041295085529,
          0.04820664588677,
          91.39182664
        ],
        [
          0.00025114614451,
          0.06885595547535,
          76.28203447
        ],
        [
          0.00036122237853,
          0.05754637994063,
          81.90532489
        ],
        [
          0.00024306408239,
          0.0689026778282,
          76.71238408
        ],
        [
          0.00040920104976,
          0.051105932177,
          87.51276967
        ],
        [
          0.00025115300894,
          0.06885400877355,
          76.28338784
        ],
        [
          0.00042731505976,
          0.05225319293731,
          85.19193769
        ],
        [
          0.00024306965157,
          0.06890079958044,
          76.71375079
        ],
        [
          0.00046273838319,
          0.0460209761848,
          92.29660408
        ],
        [
          0.0002508229831,
          0.06867221333566,
          76.46608249
        ],
        [
          0.00036770783657,
          0.0562501600035,
          83.07797278
        ],
        [
          0.00024262787851,
          0.06872650861421,
          76.89796588
        ],
        [
          0.00040182231743,
          0.05031504710313,
          88.93944214
        ],
        [
          0.00025082921551,
          0.06867030724336,
          76.46744294
        ],
        [
          0.00042509298114,
          0.05129326389358,
          86.52947692
        ],
        [
          0.00024263278719,
          0.06872467398248,
          76.89933935
        ],
        [
          0.00044727419142,
          0.04539378001949,
          94.01201484
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00029749492047,
          0.06285152217249,
          79.44797012
        ],
        [
          0.00023577147834,
          0.06966063869341,
          76.46909203
        ],
        [
          0.00028588021618,
          0.06301487740805,
          79.91071756
        ],
        [
          0.00024334147927,
          0.06962371717401,
          76.05040079
        ],
        [
          0.00037624836577,
          0.05656229432899,
          82.31431337
        ],
        [
          0.00023577749898,
          0.06965871740295,
          76.47044234
        ],
        [
          0.0003583549189,
          0.0568681449774,
          82.81444539
        ],
        [
          0.00024307611121,
          0.06943828127352,
          76.23091426
        ],
        [
          0.0003105116959,
          0.06116940575739,
          80.49718145
        ],
        [
          0.00023541536915,
          0.06947983753772,
          76.6525078
        ],
        [
          0.00029723039428,
          0.0613930973918,
          80.96989448
        ],
        [
          0.00024308272477,
          0.06943633638809,
          76.23225824
        ],
        [
          0.00038110852232,
          0.05534549598255,
          83.50523833
        ],
        [
          0.00023542079046,
          0.06947795699249,
          76.65386502
        ],
        [
          0.0003615552756,
          0.05570886978041,
          84.01330823
        ],
        [
          0.00024333429864,
          0.06962569960373,
          76.04906403
        ],
        [
          0.00029749492047,
          0.06285152217249,
          79.44797012
        ],
        [
          0.00023577147834,
          0.06966063869341,
          76.46909203
        ],
        [
          0.00028588021618,
          0.06301487740805,
          79.91071756
        ],
        [
          0.00024334147927,
          0.06962371717401,
          76.05040079
        ],
        [
          0.00037624836577,
          0.05656229432899,
          82.31431337
        ],
        [
          0.00023577749898,
          0.06965871740295,
          76.47044234
        ],
        [
          0.00037581935291,
          0.05589156969555,
          83.11094864
        ],
        [
          0.00024307611121,
          0.06943828127352,
          76.23091426
        ],
        [
          0.0003105116959,
          0.06116940575739,
          80.49718145
        ],
        [
          0.00023541536915,
          0.06947983753772,
          76.6525078
        ],
        [
          0.00029723039428,
          0.0613930973918,
          80.96989448
        ],
        [
          0.00024308272477,
          0.06943633638809,
          76.23225824
        ],
        [
          0.00038110852232,
          0.05534549598255,
          83.50523833
        ],
        [
          0.00023542079046,
          0.06947795699249,
          76.65386502
        ],
        [
          0.00037854593918,
          0.05475556209451,
          84.33313777
        ],
        [
          0.00025128578608,
          0.06885058545178,
          76.27882608
        ],
        [
          0.00032510942475,
          0.06028696684722,
          80.67989896
        ],
        [
          0.00024344593646,
          0.06888754832994,
          76.70338852
        ],
        [
          0.00038511282441,
          0.05321603744822,
          85.92244718
        ],
        [
          0.00025129265984,
          0.06884863844871,
          76.28017939
        ],
        [
          0.00039663441204,
          0.05454352523596,
          83.74344777
        ],
        [
          0.00024345153114,
          0.06888566912908,
          76.70475507
        ],
        [
          0.00042600751616,
          0.04884376829465,
          89.83575124
        ],
        [
          0.00025096303235,
          0.06866681473651,
          76.46286883
        ],
        [
          0.00033479995701,
          0.05881424627586,
          81.78753551
        ],
        [
          0.00024301085981,
          0.0687112854132,
          76.88895717
        ],
        [
          0.00038096098916,
          0.05233240056301,
          87.26159236
        ],
        [
          0.00025096927405,
          0.06866490832529,
          76.46422923
        ],
        [
          0.00039774288929,
          0.0534732397317,
          85.00124111
        ],
        [
          0.00024301579385,
          0.06870944977448,
          76.89033049
        ],
        [
          0.00041398576056,
          0.04817896627001,
          91.38124061
        ],
        [
          0.00025128578608,
          0.06885058545178,
          76.27882608
        ],
        [
          0.00036149059344,
          0.05753888166611,
          81.90097009
        ],
        [
          0.00024344593646,
          0.06888754832994,
          76.70338852
        ],
        [
          0.00041008096439,
          0.0510829327736,
          87.50189127
        ],
        [
          0.00025129265984,
          0.06884863844871,
          76.28017939
        ],
        [
          0.00042766139517,
          0.05224465065619,
          85.18744798
        ],
        [
          0.00024345153114,
          0.06888566912908,
          76.70475507
        ],
        [
          0.00046384902565,
          0.04599442337469,
          92.28614439
        ],
        [
          0.00025096303235,
          0.06866681473651,
          76.46286883
        ],
        [
          0.00036801097489,
          0.05624169128895,
          83.07331516
        ],
        [
          0.00024301085981,
          0.0687112854132,
          76.88895717
        ],
        [
          0.00040275546526,
          0.05028990860486,
          88.92847807
        ],
        [
          0.00025096927405,
          0.06866490832529,
          76.46422923
        ],
        [
          0.00042547745811,
          0.0512835994761,
          86.52473259
        ],
        [
          0.00024301579385,
          0.06870944977448,
          76.89033049
        ],
        [
          0.00044844229251,
          0.04536459562543,
          94.00183088
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00029754851899,
          0.0628497568154,
          79.4469109
        ],
        [
          0.00023598255933,
          0.06965199192904,
          76.46402617
        ],
        [
          0.00028614719999,
          0.06300570137348,
          79.90534013
        ],
        [
          0.00024338398744,
          0.06962202415561,
          76.04940637
        ],
        [
          0.00037632106798,
          0.05656031546319,
          82.31319706
        ],
        [
          0.00023598859364,
          0.06965007016283,
          76.46537638
        ],
        [
          0.00035871572651,
          0.05685780209449,
          82.80880012
        ],
        [
          0.00024311872458,
          0.06943658109439,
          76.22991812
        ],
        [
          0.00031059639982,
          0.06116668686911,
          80.49561146
        ],
        [
          0.00023562700371,
          0.0694711462516,
          76.64743393
        ],
        [
          0.00029754418578,
          0.06138254441714,
          80.96396318
        ],
        [
          0.00024312534093,
          0.06943463611878,
          76.23126208
        ],
        [
          0.00038122096109,
          0.05534242629406,
          83.50359999
        ],
        [
          0.00023563243867,
          0.06946926519779,
          76.64879107
        ],
        [
          0.000361969982,
          0.05569690473811,
          84.00714464
        ],
        [
          0.00024337680407,
          0.06962400666695,
          76.04806962
        ],
        [
          0.00029754851899,
          0.0628497568154,
          79.4469109
        ],
        [
          0.00023598255933,
          0.06965199192904,
          76.46402617
        ],
        [
          0.00028614719999,
          0.06300570137348,
          79.90534013
        ],
        [
          0.00024338398744,
          0.06962202415561,
          76.04940637
        ],
        [
          0.00037632106798,
          0.05656031546319,
          82.31319706
        ],
        [
          0.00023598859364,
          0.06965007016283,
          76.46537638
        ],
        [
          0.00037619660843,
          0.0558812431746,
          83.10525037
        ],
        [
          0.00024311872458,
          0.06943658109439,
          76.22991812
        ],
        [
          0.00031059639982,
          0.06116668686911,
          80.49561146
        ],
        [
          0.00023562700371,
          0.0694711462516,
          76.64743393
        ],
        [
          0.00029754418578,
          0.06138254441714,
          80.96396318
        ],
        [
          0.00024312534093,
          0.06943463611878,
          76.23126208
        ],
        [
          0.00038122096109,
          0.05534242629406,
          83.50359999
        ],
        [
          0.00023563243867,
          0.06946926519779,
          76.64879107
        ],
        [
          0.00037897904153,
          0.05474360942699,
          84.32692117
        ],
        [
          0.00025133654673,
          0.06884863408027,
          76.27766018
        ],
        [
          0.00032520879295,
          0.06028392636515,
          80.67810779
        ],
        [
          0.00024366988226,
          0.06887868535344,
          76.69811833
        ],
        [
          0.00038558379703,
          0.05320315180412,
          85.91601786
        ],
        [
          0.00025134342387,
          0.06884668696886,
          76.27901346
        ],
        [
          0.0003967658668,
          0.05454007840948,
          83.74158088
        ],
        [
          0.00024367549189,
          0.06887680559572,
          76.69948479
        ],
        [
          0.00042659000558,
          0.04882881803235,
          89.8294302
        ],
        [
          0.0002510139412,
          0.06866485298626,
          76.46170101
        ],
        [
          0.00033493614378,
          0.05881012784482,
          81.78522308
        ],
        [
          0.00024323546668,
          0.06870236763339,
          76.88367927
        ],
        [
          0.00038149301659,
          0.05231744986957,
          87.25472688
        ],
        [
          0.00025102018629,
          0.06866294645857,
          76.46306139
        ],
        [
          0.00039791936834,
          0.05346855696839,
          84.99885659
        ],
        [
          0.00024324041559,
          0.06870053140488,
          76.8850525
        ],
        [
          0.00041463214584,
          0.04816171225273,
          91.37463505
        ],
        [
          0.00025133654673,
          0.06884863408027,
          76.27766018
        ],
        [
          0.00036160353128,
          0.05753572599231,
          81.89913701
        ],
        [
          0.00024366988226,
          0.06887868535344,
          76.69811833
        ],
        [
          0.00041060279847,
          0.05106931584206,
          87.49544564
        ],
        [
          0.00025134342387,
          0.06884668696886,
          76.27901346
        ],
        [
          0.00042780722934,
          0.05224105573675,
          85.18555805
        ],
        [
          0.00024367549189,
          0.06887680559572,
          76.69948479
        ],
        [
          0.0004645077929,
          0.04597870249109,
          92.27994645
        ],
        [
          0.0002510139412,
          0.06866485298626,
          76.46170101
        ],
        [
          0.00036816445357,
          0.05623740621149,
          83.07095788
        ],
        [
          0.00024323546668,
          0.06870236763339,
          76.88367927
        ],
        [
          0.00040333824858,
          0.05027423763912,
          88.92163724
        ],
        [
          0.00025102018629,
          0.06866294645857,
          76.46306139
        ],
        [
          0.00042567212275,
          0.05127870956359,
          86.52233135
        ],
        [
          0.00024324041559,
          0.06870053140488,
          76.8850525
        ],
        [
          0.00044917188485,
          0.04534640467129,
          93.99547553
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00029758068208,
          0.06284869761717,
          79.44627536
        ],
        [
          0.00023612726244,
          0.06964606462138,
          76.46055883
        ],
        [
          0.00028633010564,
          0.06299941982441,
          79.90165818
        ],
        [
          0.00024340949578,
          0.06962100833515,
          76.04880971
        ],
        [
          0.00037636469459,
          0.05655912818151,
          82.31252726
        ],
        [
          0.00023613321917,
          0.0696441497696,
          76.46190778
        ],
        [
          0.00035896290811,
          0.05685072232924,
          82.80493464
        ],
        [
          0.00024314429609,
          0.06943556097631,
          76.22932043
        ],
        [
          0.00031066065795,
          0.06116462474779,
          80.49442062
        ],
        [
          0.00023577199913,
          0.06946519573301,
          76.64395992
        ],
        [
          0.000297770052,
          0.06137495513459,
          80.95969645
        ],
        [
          0.00024315091404,
          0.06943361595064,
          76.23066438
        ],
        [
          0.00038130625954,
          0.05534009815996,
          83.50235729
        ],
        [
          0.00023577744342,
          0.06946331433352,
          76.64531699
        ],
        [
          0.00036226849024,
          0.05568830058197,
          84.00271062
        ],
        [
          0.00024340231077,
          0.06962299089465,
          76.04747297
        ],
        [
          0.00029758068208,
          0.06284869761717,
          79.44627536
        ],
        [
          0.00023612726244,
          0.06964606462138,
          76.46055883
        ],
        [
          0.00028633010564,
          0.06299941982441,
          79.90165818
        ],
        [
          0.00024340949578,
          0.06962100833515,
          76.04880971
        ],
        [
          0.00037636469459,
          0.05655912818151,
          82.31252726
        ],
        [
          0.00023613321917,
          0.0696441497696,
          76.46190778
        ],
        [
          0.00037645505574,
          0.05587417467008,
          83.10134859
        ],
        [
          0.00024314429609,
          0.06943556097631,
          76.22932043
        ],
        [
          0.00031066065795,
          0.06116462474779,
          80.49442062
        ],
        [
          0.00023577199913,
          0.06946519573301,
          76.64395992
        ],
        [
          0.000297770052,
          0.06137495513459,
          80.95969645
        ],
        [
          0.00024315091404,
          0.06943361595064,
          76.23066438
        ],
        [
          0.00038130625954,
          0.05534009815996,
          83.50235729
        ],
        [
          0.00023577744342,
          0.06946331433352,
          76.64531699
        ],
        [
          0.0003792907884,
          0.0547350142385,
          84.322449
        ],
        [
          0.00025137243609,
          0.06884725461498,
          76.27683597
        ],
        [
          0.00032527478346,
          0.06028190768215,
          80.67691848
        ],
        [
          0.00024382802173,
          0.06887243120908,
          76.6943992
        ],
        [
          0.00038591277574,
          0.05319413327027,
          85.91156366
        ],
        [
          0.00025137931563,
          0.06884530742642,
          76.27818924
        ],
        [
          0.00039685316629,
          0.05453778998641,
          83.74034127
        ],
        [
          0.00024383364194,
          0.06887055105757,
          76.69576559
        ],
        [
          0.00042699423667,
          0.04881845471618,
          89.82504603
        ],
        [
          0.00025104993531,
          0.06866346618743,
          76.46087545
        ],
        [
          0.00033503959934,
          0.05880700034049,
          81.78346682
        ],
        [
          0.00024339407302,
          0.06869607485232,
          76.87995469
        ],
        [
          0.00038187840447,
          0.05230663270786,
          87.24975694
        ],
        [
          0.00025105618279,
          0.06866155957692,
          76.46223581
        ],
        [
          0.00039805343351,
          0.05346500099994,
          84.99704554
        ],
        [
          0.00024339903242,
          0.0686942382088,
          76.88132786
        ],
        [
          0.00041510040375,
          0.0481492293895,
          91.36985282
        ],
        [
          0.00025137243609,
          0.06884725461498,
          76.27683597
        ],
        [
          0.00036167853328,
          0.05753363084659,
          81.89791986
        ],
        [
          0.00024382802173,
          0.06887243120908,
          76.6943992
        ],
        [
          0.00041096492169,
          0.05105987644941,
          87.49097528
        ],
        [
          0.00025137931563,
          0.06884530742642,
          76.27818924
        ],
        [
          0.00042790407842,
          0.05223866900511,
          85.18430314
        ],
        [
          0.00024383364194,
          0.06887055105757,
          76.69576559
        ],
        [
          0.0004649649288,
          0.04596780662936,
          92.27564704
        ],
        [
          0.00025104993531,
          0.06866346618743,
          76.46087545
        ],
        [
          0.00036828104495,
          0.05623415219481,
          83.06916755
        ],
        [
          0.00024339407302,
          0.06869607485232,
          76.87995469
        ],
        [
          0.00040376040974,
          0.05026289961752,
          88.91668499
        ],
        [
          0.00025105618279,
          0.06866155957692,
          76.46223581
        ],
        [
          0.00042582000335,
          0.0512749963229,
          86.52050759
        ],
        [
          0.00024339903242,
          0.0686942382088,
          76.88132786
        ],
        [
          0.00044970042742,
          0.04533324445974,
          93.99087414
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00029760855914,
          0.06284777965654,
          79.44572455
        ],
        [
          0.00023624292077,
          0.0696413323419,
          76.45778612
        ],
        [
          0.0002864763801,
          0.06299439910056,
          79.89871482
        ],
        [
          0.00024343160509,
          0.06962012795174,
          76.04829259
        ],
        [
          0.00037640250759,
          0.05655809922358,
          82.31194676
        ],
        [
          0.00023624897199,
          0.06963940998615,
          76.45913622
        ],
        [
          0.00035916058542,
          0.05684506392333,
          82.80184448
        ],
        [
          0.00024316646013,
          0.06943467686984,
          76.22880242
        ],
        [
          0.00031069075375,
          0.06116365908099,
          80.49386294
        ],
        [
          0.00023588796081,
          0.06946043912048,
          76.64118282
        ],
        [
          0.00029792765798,
          0.06136966277574,
          80.95672047
        ],
        [
          0.00024317307951,
          0.06943273179871,
          76.23014636
        ],
        [
          0.0003813462099,
          0.05533900793188,
          83.50177532
        ],
        [
          0.00023589341259,
          0.06945855744185,
          76.64253985
        ],
        [
          0.00036247678663,
          0.0556823008136,
          83.99961786
        ],
        [
          0.00024342441867,
          0.06962211055346,
          76.04695586
        ],
        [
          0.00029760855914,
          0.06284777965654,
          79.44572455
        ],
        [
          0.00023624292077,
          0.0696413323419,
          76.45778612
        ],
        [
          0.0002864763801,
          0.06299439910056,
          79.89871482
        ],
        [
          0.00024343160509,
          0.06962012795174,
          76.04829259
        ],
        [
          0.00037640250759,
          0.05655809922358,
          82.31194676
        ],
        [
          0.00023624897199,
          0.06963940998615,
          76.45913622
        ],
        [
          0.00037666174102,
          0.05586852530283,
          83.09822941
        ],
        [
          0.00024316646013,
          0.06943467686984,
          76.22880242
        ],
        [
          0.00031069075375,
          0.06116365908099,
          80.49386294
        ],
        [
          0.00023588796081,
          0.06946043912048,
          76.64118282
        ],
        [
          0.00029792765798,
          0.06136966277574,
          80.95672047
        ],
        [
          0.00024317307951,
          0.06943273179871,
          76.23014636
        ],
        [
          0.0003813462099,
          0.05533900793188,
          83.50177532
        ],
        [
          0.00023589341259,
          0.06945855744185,
          76.64253985
        ],
        [
          0.0003795083211,
          0.0547290207604,
          84.31932963
        ],
        [
          0.00025140483676,
          0.06884600939605,
          76.27609196
        ],
        [
          0.00032533967558,
          0.06027992298915,
          80.67574911
        ],
        [
          0.00024395639673,
          0.06886735690494,
          76.69138154
        ],
        [
          0.00038618922832,
          0.05318656051845,
          85.90782227
        ],
        [
          0.00025141171846,
          0.06884406213808,
          76.27744521
        ],
        [
          0.00039693901283,
          0.05453554013527,
          83.73912244
        ],
        [
          0.00024396202549,
          0.06886547643575,
          76.69274787
        ],
        [
          0.00042733394,
          0.04880975312858,
          89.82136327
        ],
        [
          0.00025108243057,
          0.06866221434868,
          76.46013022
        ],
        [
          0.00033510906997,
          0.05880490074704,
          81.78228768
        ],
        [
          0.00024352282699,
          0.06869096922505,
          76.87693261
        ],
        [
          0.00038216556109,
          0.05229857968089,
          87.24605556
        ],
        [
          0.00025108868019,
          0.06866030766519,
          76.46149057
        ],
        [
          0.00039814345918,
          0.05346261380541,
          84.9958296
        ],
        [
          0.00024352779493,
          0.06868913224384,
          76.87830573
        ],
        [
          0.00041544932524,
          0.04813993673642,
          91.366291
        ],
        [
          0.00025140483676,
          0.06884600939605,
          76.27609196
        ],
        [
          0.00036175228671,
          0.05753157099614,
          81.89672312
        ],
        [
          0.00024395639673,
          0.06886735690494,
          76.69138154
        ],
        [
          0.00041126922937,
          0.05105195043852,
          87.48722025
        ],
        [
          0.00025141171846,
          0.06884406213808,
          76.27744521
        ],
        [
          0.00042799931564,
          0.05223632251687,
          85.18306926
        ],
        [
          0.00024396202549,
          0.06886547643575,
          76.69274787
        ],
        [
          0.00046534909415,
          0.04595865811756,
          92.27203533
        ],
        [
          0.00025108243057,
          0.06866221434868,
          76.46013022
        ],
        [
          0.0003683593363,
          0.05623196768615,
          83.06796553
        ],
        [
          0.00024352282699,
          0.06869096922505,
          76.87693261
        ],
        [
          0.00040407497024,
          0.05025445897899,
          88.9129967
        ],
        [
          0.00025108868019,
          0.06866030766519,
          76.46149057
        ],
        [
          0.00042591930633,
          0.05127250356594,
          86.51928311
        ],
        [
          0.00024352779493,
          0.06868913224384,
          76.87830573
        ],
        [
          0.00045009427368,
          0.04532344784792,
          93.98744682
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00029760855914,
          0.06284777965654,
          79.44572455
        ],
        [
          0.00023632851892,
          0.0696378313484,
          76.45573478
        ],
        [
          0.00028658463353,
          0.06299068500669,
          79.8965372
        ],
        [
          0.00024343160509,
          0.06962012795174,
          76.04829259
        ],
        [
          0.00037640250759,
          0.05655809922358,
          82.31194676
        ],
        [
          0.0002363345757,
          0.06963590879941,
          76.45708484
        ],
        [
          0.00035930688016,
          0.05684087829514,
          82.79955821
        ],
        [
          0.00024316646013,
          0.06943467686984,
          76.22880242
        ],
        [
          0.00031070955333,
          0.06116305591517,
          80.4935146
        ],
        [
          0.00023597378347,
          0.06945692013533,
          76.63912824
        ],
        [
          0.00029806264573,
          0.06136513210147,
          80.95417242
        ],
        [
          0.00024317307951,
          0.06943273179871,
          76.23014636
        ],
        [
          0.00038137116515,
          0.05533832697105,
          83.5014118
        ],
        [
          0.0002359792408,
          0.06945503825086,
          76.64048523
        ],
        [
          0.00036265519134,
          0.05567716474518,
          83.99696977
        ],
        [
          0.00024342441867,
          0.06962211055346,
          76.04695586
        ],
        [
          0.00029760855914,
          0.06284777965654,
          79.44572455
        ],
        [
          0.00023632851892,
          0.0696378313484,
          76.45573478
        ],
        [
          0.00028658463353,
          0.06299068500669,
          79.8965372
        ],
        [
          0.00024343160509,
          0.06962012795174,
          76.04829259
        ],
        [
          0.00037640250759,
          0.05655809922358,
          82.31194676
        ],
        [
          0.0002363345757,
          0.06963590879941,
          76.45708484
        ],
        [
          0.00037681470158,
          0.05586434637659,
          83.09592166
        ],
        [
          0.00024316646013,
          0.06943467686984,
          76.22880242
        ],
        [
          0.00031070955333,
          0.06116305591517,
          80.4935146
        ],
        [
          0.00023597378347,
          0.06945692013533,
          76.63912824
        ],
        [
          0.00029806264573,
          0.06136513210147,
          80.95417242
        ],
        [
          0.00024317307951,
          0.06943273179871,
          76.23014636
        ],
        [
          0.00038137116515,
          0.05533832697105,
          83.5014118
        ],
        [
          0.0002359792408,
          0.06945503825086,
          76.64048523
        ],
        [
          0.00037969463583,
          0.0547238900951,
          84.31665873
        ],
        [
          0.00025141711686,
          0.06884553748666,
          76.27580999
        ],
        [
          0.00032537566361,
          0.06027882248193,
          80.67510067
        ],
        [
          0.00024405639458,
          0.06886340594853,
          76.68903184
        ],
        [
          0.00038640907057,
          0.05318054227567,
          85.90484808
        ],
        [
          0.0002514239994,
          0.06884359020115,
          76.27716324
        ],
        [
          0.00039698662199,
          0.05453429261008,
          83.73844656
        ],
        [
          0.00024406203004,
          0.06886152523018,
          76.69039813
        ],
        [
          0.00042760408982,
          0.04880283800385,
          89.81843556
        ],
        [
          0.00025109474651,
          0.06866173993142,
          76.45984779
        ],
        [
          0.00033516848618,
          0.05880310536621,
          81.78127932
        ],
        [
          0.00024362312009,
          0.06868699389098,
          76.87457946
        ],
        [
          0.00038242176645,
          0.05229139965724,
          87.2427544
        ],
        [
          0.00025110099697,
          0.0686598332188,
          76.46120813
        ],
        [
          0.00039822045587,
          0.05346057252103,
          84.99478976
        ],
        [
          0.00024362809467,
          0.06868515664843,
          76.87595254
        ],
        [
          0.00041576065056,
          0.04813165179005,
          91.36311415
        ],
        [
          0.00025141711686,
          0.06884553748666,
          76.27580999
        ],
        [
          0.00036179318905,
          0.05753042881907,
          81.8960595
        ],
        [
          0.00024405639458,
          0.06886340594853,
          76.68903184
        ],
        [
          0.00041151122472,
          0.05104565152594,
          87.48423518
        ],
        [
          0.0002514239994,
          0.06884359020115,
          76.27716324
        ],
        [
          0.00042805213287,
          0.05223502140918,
          85.18238503
        ],
        [
          0.00024406203004,
          0.06886152523018,
          76.69039813
        ],
        [
          0.00046565460416,
          0.04595138796897,
          92.26916402
        ],
        [
          0.00025109474651,
          0.06866173993142,
          76.45984779
        ],
        [
          0.00036842629655,
          0.05623009970521,
          83.0669376
        ],
        [
          0.00024362312009,
          0.06868699389098,
          76.87457946
        ],
        [
          0.00040435562851,
          0.0502469334687,
          88.90970716
        ],
        [
          0.00025110099697,
          0.0686598332188,
          76.46120813
        ],
        [
          0.00042600423795,
          0.05127037201971,
          86.51823596
        ],
        [
          0.00024362809467,
          0.06868515664843,
          76.87595254
        ],
        [
          0.00045044568602,
          0.04531471378989,
          93.98438981
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00029760855914,
          0.06284777965654,
          79.44572455
        ],
        [
          0.00023638589953,
          0.0696354851008,
          76.45436002
        ],
        [
          0.00028665719936,
          0.06298819608843,
          79.89507779
        ],
        [
          0.00024343160509,
          0.06962012795174,
          76.04829259
        ],
        [
          0.00037640250759,
          0.05655809922358,
          82.31194676
        ],
        [
          0.00023639196005,
          0.06963356242152,
          76.45571006
        ],
        [
          0.00035940494624,
          0.05683807347446,
          82.79802597
        ],
        [
          0.00024316646013,
          0.06943467686984,
          76.22880242
        ],
        [
          0.0003107270109,
          0.06116249583868,
          80.49319114
        ],
        [
          0.00023603131458,
          0.06945456183603,
          76.63775131
        ],
        [
          0.00029815787937,
          0.06136193692115,
          80.95237524
        ],
        [
          0.00024317307951,
          0.06943273179871,
          76.23014636
        ],
        [
          0.00038139433902,
          0.05533769465851,
          83.50107425
        ],
        [
          0.0002360367756,
          0.06945267981488,
          76.63910827
        ],
        [
          0.00036278105622,
          0.05567354273556,
          83.99510199
        ],
        [
          0.00024342441867,
          0.06962211055346,
          76.04695586
        ],
        [
          0.00029760855914,
          0.06284777965654,
          79.44572455
        ],
        [
          0.00023638589953,
          0.0696354851008,
          76.45436002
        ],
        [
          0.00028665719936,
          0.06298819608843,
          79.89507779
        ],
        [
          0.00024343160509,
          0.06962012795174,
          76.04829259
        ],
        [
          0.00037640250759,
          0.05655809922358,
          82.31194676
        ],
        [
          0.00023639196005,
          0.06963356242152,
          76.45571006
        ],
        [
          0.00037691723548,
          0.05586154606082,
          83.09437502
        ],
        [
          0.00024316646013,
          0.06943467686984,
          76.22880242
        ],
        [
          0.0003107270109,
          0.06116249583868,
          80.49319114
        ],
        [
          0.00023603131458,
          0.06945456183603,
          76.63775131
        ],
        [
          0.00029815787937,
          0.06136193692115,
          80.95237524
        ],
        [
          0.00024317307951,
          0.06943273179871,
          76.23014636
        ],
        [
          0.00038139433902,
          0.05533769465851,
          83.50107425
        ],
        [
          0.0002360367756,
          0.06945267981488,
          76.63910827
        ],
        [
          0.00037982608067,
          0.05472027191023,
          84.31477487
        ],
        [
          0.00025143780047,
          0.06884474268759,
          76.2753351
        ],
        [
          0.00032542506252,
          0.06027731206465,
          80.67421066
        ],
        [
          0.00024413558869,
          0.06886027799875,
          76.68717154
        ],
        [
          0.00038659119072,
          0.05317555923616,
          85.90238493
        ],
        [
          0.00025144468437,
          0.06884279535858,
          76.27668834
        ],
        [
          0.00039705197259,
          0.05453258043842,
          83.7375189
        ],
        [
          0.00024414122943,
          0.06885839708412,
          76.6885378
        ],
        [
          0.00042782789124,
          0.04879711251483,
          89.81601082
        ],
        [
          0.0002511154905,
          0.06866094090766,
          76.45937212
        ],
        [
          0.00033524077355,
          0.05880092147841,
          81.78005267
        ],
        [
          0.00024370254799,
          0.06868384665296,
          76.87271644
        ],
        [
          0.00038263682403,
          0.05228537641962,
          87.23998436
        ],
        [
          0.0002511217423,
          0.06865903415006,
          76.46073245
        ],
        [
          0.00039831413257,
          0.05345808955181,
          84.9935248
        ],
        [
          0.00024370752781,
          0.06868200920351,
          76.87408948
        ],
        [
          0.00041602198484,
          0.0481247018693,
          91.36044828
        ],
        [
          0.00025143780047,
          0.06884474268759,
          76.2753351
        ],
        [
          0.00036184933347,
          0.05752886122097,
          81.89514866
        ],
        [
          0.00024413558869,
          0.06886027799875,
          76.68717154
        ],
        [
          0.00041171169785,
          0.05104043615336,
          87.48176299
        ],
        [
          0.00025144468437,
          0.06884279535858,
          76.27668834
        ],
        [
          0.00042812463224,
          0.05223323570788,
          85.1814459
        ],
        [
          0.00024414122943,
          0.06885839708412,
          76.6885378
        ],
        [
          0.00046590770031,
          0.04594536862937,
          92.26678593
        ],
        [
          0.0002511154905,
          0.06866094090766,
          76.45937212
        ],
        [
          0.00036850776225,
          0.05622782751849,
          83.06568715
        ],
        [
          0.00024370254799,
          0.06868384665296,
          76.87271644
        ],
        [
          0.00040459121364,
          0.05024062048748,
          88.90694682
        ],
        [
          0.0002511217423,
          0.06865903415006,
          76.46073245
        ],
        [
          0.00042610756863,
          0.05126777927438,
          86.5169621
        ],
        [
          0.00024370752781,
          0.06868200920351,
          76.87408948
        ],
        [
          0.00045074067232,
          0.04530738727402,
          93.98182441
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00029760855914,
          0.06284777965654,
          79.44572455
        ],
        [
          0.00023644848628,
          0.06963292656302,
          76.45286085
        ],
        [
          0.0002867363475,
          0.06298548209979,
          79.8934863
        ],
        [
          0.00024343160509,
          0.06962012795174,
          76.04829259
        ],
        [
          0.00037640250759,
          0.05655809922358,
          82.31194676
        ],
        [
          0.00023645455081,
          0.06963100374557,
          76.45421085
        ],
        [
          0.00035951190749,
          0.05683501510152,
          82.79635503
        ],
        [
          0.00024316646013,
          0.06943467686984,
          76.22880242
        ],
        [
          0.00031074581228,
          0.06116189268359,
          80.49284279
        ],
        [
          0.00023609406547,
          0.06945199016048,
          76.63624976
        ],
        [
          0.00029826152604,
          0.06135846060732,
          80.95041973
        ],
        [
          0.00024317307951,
          0.06943273179871,
          76.23014636
        ],
        [
          0.00038141929667,
          0.05533701371728,
          83.50071072
        ],
        [
          0.00023609953052,
          0.06945010799005,
          76.6376067
        ],
        [
          0.00036291804077,
          0.05566960214229,
          83.99306963
        ],
        [
          0.00024342441867,
          0.06962211055346,
          76.04695586
        ],
        [
          0.00029760855914,
          0.06284777965654,
          79.44572455
        ],
        [
          0.00023644848628,
          0.06963292656302,
          76.45286085
        ],
        [
          0.0002867363475,
          0.06298548209979,
          79.8934863
        ],
        [
          0.00024343160509,
          0.06962012795174,
          76.04829259
        ],
        [
          0.00037640250759,
          0.05655809922358,
          82.31194676
        ],
        [
          0.00023645455081,
          0.06963100374557,
          76.45421085
        ],
        [
          0.00037702906954,
          0.05585849260567,
          83.09268838
        ],
        [
          0.00024316646013,
          0.06943467686984,
          76.22880242
        ],
        [
          0.00031074581228,
          0.06116189268359,
          80.49284279
        ],
        [
          0.00023609406547,
          0.06945199016048,
          76.63624976
        ],
        [
          0.00029826152604,
          0.06135846060732,
          80.95041973
        ],
        [
          0.00024317307951,
          0.06943273179871,
          76.23014636
        ],
        [
          0.00038141929667,
          0.05533701371728,
          83.50071072
        ],
        [
          0.00023609953052,
          0.06945010799005,
          76.6376067
        ],
        [
          0.00037996913769,
          0.05471633548834,
          84.31272501
        ],
        [
          0.00025144146919,
          0.06884460171726,
          76.27525087
        ],
        [
          0.00032545352275,
          0.06027644196958,
          80.67369794
        ],
        [
          0.00024420353028,
          0.06885759522597,
          76.68557596
        ],
        [
          0.00038675492735,
          0.05317108116403,
          85.90017098
        ],
        [
          0.00025144835332,
          0.0688426543814,
          76.27660411
        ],
        [
          0.00039708962322,
          0.05453159412613,
          83.73698448
        ],
        [
          0.00024420917556,
          0.06885571414368,
          76.6869422
        ],
        [
          0.00042802910639,
          0.04879196735008,
          89.81383132
        ],
        [
          0.0002511191699,
          0.06866079919015,
          76.45928775
        ],
        [
          0.00033529214005,
          0.05879936991636,
          81.77918114
        ],
        [
          0.00024377069013,
          0.06868114734487,
          76.87111852
        ],
        [
          0.00038283479653,
          0.05227983462631,
          87.23743512
        ],
        [
          0.00025112542198,
          0.06865889242178,
          76.46064808
        ],
        [
          0.00039838069833,
          0.05345632552803,
          84.99262604
        ],
        [
          0.00024377567448,
          0.0686793097163,
          76.87249154
        ],
        [
          0.00041626256484,
          0.04811830765348,
          91.35799482
        ],
        [
          0.00025144146919,
          0.06884460171726,
          76.27525087
        ],
        [
          0.00036188168,
          0.05752795818843,
          81.89462393
        ],
        [
          0.00024420353028,
          0.06885759522597,
          76.68557596
        ],
        [
          0.00041189193589,
          0.05103574933143,
          87.47954088
        ],
        [
          0.00025144835332,
          0.0688426543814,
          76.27660411
        ],
        [
          0.00042816640151,
          0.05223220704246,
          85.18090488
        ],
        [
          0.00024420917556,
          0.06885571414368,
          76.6869422
        ],
        [
          0.00046613525458,
          0.0459399594747,
          92.2646483
        ],
        [
          0.0002511191699,
          0.06866079919015,
          76.45928775
        ],
        [
          0.00036856565064,
          0.05622621323635,
          83.06479869
        ],
        [
          0.00024377069013,
          0.06868114734487,
          76.87111852
        ],
        [
          0.00040480808463,
          0.05023481216762,
          88.90440648
        ],
        [
          0.00025112542198,
          0.06865889242178,
          76.46064808
        ],
        [
          0.00042618099456,
          0.05126593726701,
          86.51605701
        ],
        [
          0.00024377567448,
          0.0686793097163,
          76.87249154
        ],
        [
          0.00045101223362,
          0.04530064668606,
          93.97946334
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00029760855914,
          0.06284777965654,
          79.44572455
        ],
        [
          0.00023648646414,
          0.06963137433009,
          76.45195131
        ],
        [
          0.00028678437403,
          0.06298383562481,
          79.89252074
        ],
        [
          0.00024343160509,
          0.06962012795174,
          76.04829259
        ],
        [
          0.00037640250759,
          0.05655809922358,
          82.31194676
        ],
        [
          0.00023649253115,
          0.06962945142659,
          76.4533013
        ],
        [
          0.00035957681082,
          0.0568331597399,
          82.79534126
        ],
        [
          0.00024316646013,
          0.06943467686984,
          76.22880242
        ],
        [
          0.00031075924239,
          0.06116146186356,
          80.49259397
        ],
        [
          0.00023613214294,
          0.06945042995963,
          76.63533878
        ],
        [
          0.0002983263967,
          0.06135628544208,
          80.94919604
        ],
        [
          0.00024317307951,
          0.06943273179871,
          76.23014636
        ],
        [
          0.00038143712435,
          0.0553365273362,
          83.50045106
        ],
        [
          0.00023613761042,
          0.06944854769964,
          76.63669571
        ],
        [
          0.00036300377743,
          0.0556671365263,
          83.99179784
        ],
        [
          0.00024342441867,
          0.06962211055346,
          76.04695586
        ],
        [
          0.00029760855914,
          0.06284777965654,
          79.44572455
        ],
        [
          0.00023648646414,
          0.06963137433009,
          76.45195131
        ],
        [
          0.00028678437403,
          0.06298383562481,
          79.89252074
        ],
        [
          0.00024343160509,
          0.06962012795174,
          76.04829259
        ],
        [
          0.00037640250759,
          0.05655809922358,
          82.31194676
        ],
        [
          0.00023649253115,
          0.06962945142659,
          76.4533013
        ],
        [
          0.00037709692947,
          0.05585664023272,
          83.09166508
        ],
        [
          0.00024316646013,
          0.06943467686984,
          76.22880242
        ],
        [
          0.00031075924239,
          0.06116146186356,
          80.49259397
        ],
        [
          0.00023613214294,
          0.06945042995963,
          76.63533878
        ],
        [
          0.0002983263967,
          0.06135628544208,
          80.94919604
        ],
        [
          0.00024317307951,
          0.06943273179871,
          76.23014636
        ],
        [
          0.00038143712435,
          0.0553365273362,
          83.50045106
        ],
        [
          0.00023613761042,
          0.06944854769964,
          76.63669571
        ],
        [
          0.00038005867468,
          0.05471387249209,
          84.31144227
        ],
        [
          0.00025145310458,
          0.06884415464149,
          76.27498374
        ],
        [
          0.00032549664268,
          0.06027512383641,
          80.67292117
        ],
        [
          0.00024425394801,
          0.0688556048464,
          76.68439217
        ],
        [
          0.00038688982966,
          0.05316739308981,
          85.89834729
        ],
        [
          0.00025145998951,
          0.06884220727923,
          76.27633698
        ],
        [
          0.0003971466675,
          0.05453009994625,
          83.73617484
        ],
        [
          0.00024425959662,
          0.06885372364068,
          76.68575838
        ],
        [
          0.00042819489054,
          0.04878772995028,
          89.81203597
        ],
        [
          0.00025113083928,
          0.0686603497369,
          76.45902018
        ],
        [
          0.0003353532369,
          0.05879752474647,
          81.77814461
        ],
        [
          0.0002438212567,
          0.0686791446998,
          76.86993298
        ],
        [
          0.00038299486709,
          0.05227535586546,
          87.23537446
        ],
        [
          0.00025113709212,
          0.06865844294284,
          76.46038051
        ],
        [
          0.00039845987404,
          0.0534542277125,
          84.99155712
        ],
        [
          0.00024382624439,
          0.06867730694007,
          76.87130598
        ],
        [
          0.00041645709083,
          0.04811314011136,
          91.3560115
        ],
        [
          0.00025145310458,
          0.06884415464149,
          76.27498374
        ],
        [
          0.00036193068797,
          0.05752659016298,
          81.89382898
        ],
        [
          0.00024425394801,
          0.0688556048464,
          76.68439217
        ],
        [
          0.00041204043439,
          0.05103188936191,
          87.47771046
        ],
        [
          0.00025145998951,
          0.06884220727923,
          76.27633698
        ],
        [
          0.00042822968598,
          0.05223064870446,
          85.18008523
        ],
        [
          0.00024425959662,
          0.06885372364068,
          76.68575838
        ],
        [
          0.0004663227405,
          0.04593550471596,
          92.26288741
        ],
        [
          0.00025113083928,
          0.0686603497369,
          76.45902018
        ],
        [
          0.0003686345049,
          0.05622429348339,
          83.06374204
        ],
        [
          0.0002438212567,
          0.0686791446998,
          76.86993298
        ],
        [
          0.00040498343645,
          0.05023011805758,
          88.90235299
        ],
        [
          0.00025113709212,
          0.06865844294284,
          76.46038051
        ],
        [
          0.00042626833006,
          0.05126374672316,
          86.51498057
        ],
        [
          0.00024382624439,
          0.06867730694007,
          76.87130598
        ],
        [
          0.00045123181124,
          0.0452951993055,
          93.97755467
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00029766646471,
          0.06284587315738,
          79.44458053
        ],
        [
          0.00023654667002,
          0.06962891405367,
          76.45050967
        ],
        [
          0.00028686050877,
          0.06298122607356,
          79.89099031
        ],
        [
          0.00024347753069,
          0.06961829944258,
          76.04721856
        ],
        [
          0.00037648105161,
          0.05655596223259,
          82.31074106
        ],
        [
          0.00023655274092,
          0.06962699101515,
          76.45185964
        ],
        [
          0.00035967969958,
          0.05683021918337,
          82.7937344
        ],
        [
          0.00024321249938,
          0.0694328406318,
          76.22772655
        ],
        [
          0.00031083520117,
          0.06115902554497,
          80.49118681
        ],
        [
          0.00023619250671,
          0.06944795705721,
          76.63389487
        ],
        [
          0.0002984215645,
          0.06135309522554,
          80.94740117
        ],
        [
          0.00024321912174,
          0.0694308954648,
          76.22907047
        ],
        [
          0.00038153795502,
          0.05533377686068,
          83.49898258
        ],
        [
          0.0002361979781,
          0.06944607465236,
          76.63525177
        ],
        [
          0.00036312955691,
          0.05566352039708,
          83.98993238
        ],
        [
          0.0002434703413,
          0.06962028213269,
          76.04588186
        ],
        [
          0.00029766646471,
          0.06284587315738,
          79.44458053
        ],
        [
          0.00023654667002,
          0.06962891405367,
          76.45050967
        ],
        [
          0.00028686050877,
          0.06298122607356,
          79.89099031
        ],
        [
          0.00024347753069,
          0.06961829944258,
          76.04721856
        ],
        [
          0.00037648105161,
          0.05655596223259,
          82.31074106
        ],
        [
          0.00023655274092,
          0.06962699101515,
          76.45185964
        ],
        [
          0.00037720450497,
          0.05585370441803,
          83.09004312
        ],
        [
          0.00024321249938,
          0.0694328406318,
          76.22772655
        ],
        [
          0.00031083520117,
          0.06115902554497,
          80.49118681
        ],
        [
          0.00023619250671,
          0.06944795705721,
          76.63389487
        ],
        [
          0.0002984215645,
          0.06135309522554,
          80.94740117
        ],
        [
          0.00024321912174,
          0.0694308954648,
          76.22907047
        ],
        [
          0.00038153795502,
          0.05533377686068,
          83.49898258
        ],
        [
          0.0002361979781,
          0.06944607465236,
          76.63525177
        ],
        [
          0.00038019002917,
          0.05471026020923,
          84.30956074
        ],
        [
          0.00025150868555,
          0.06884201926865,
          76.27370784
        ],
        [
          0.00032559838072,
          0.06027201448244,
          80.67108873
        ],
        [
          0.00024432407156,
          0.06885283714512,
          76.68274602
        ],
        [
          0.00038706036997,
          0.05316273252227,
          85.89604234
        ],
        [
          0.00025151557419,
          0.06884007178674,
          76.27506105
        ],
        [
          0.00039728125924,
          0.05452657538061,
          83.73426482
        ],
        [
          0.00024432972487,
          0.06885095576473,
          76.6841122
        ],
        [
          0.000428404475,
          0.04878237532405,
          89.80976676
        ],
        [
          0.0002511865825,
          0.06865820301784,
          76.45774219
        ],
        [
          0.00033547710628,
          0.05879378481359,
          81.77604351
        ],
        [
          0.00024389158728,
          0.06867635994732,
          76.86828442
        ],
        [
          0.00038319198088,
          0.0522698431605,
          87.23283757
        ],
        [
          0.00025119283904,
          0.06865629609725,
          76.45910249
        ],
        [
          0.0003986203979,
          0.05344997578333,
          84.98939033
        ],
        [
          0.00024389657964,
          0.06867452200394,
          76.86965739
        ],
        [
          0.00041669664001,
          0.04810677977423,
          91.35356975
        ],
        [
          0.00025150868555,
          0.06884201926865,
          76.27370784
        ],
        [
          0.00036204631819,
          0.05752336314357,
          81.89195362
        ],
        [
          0.00024432407156,
          0.06885283714512,
          76.68274602
        ],
        [
          0.00041222816331,
          0.05102701161932,
          87.47539698
        ],
        [
          0.00025151557419,
          0.06884007178674,
          76.27506105
        ],
        [
          0.00042837900137,
          0.05222697281237,
          85.17815158
        ],
        [
          0.00024432972487,
          0.06885095576473,
          76.6841122
        ],
        [
          0.00046655894248,
          0.04592989843321,
          92.26066401
        ],
        [
          0.0002511865825,
          0.06865820301784,
          76.45774219
        ],
        [
          0.00036877410157,
          0.05622040242097,
          83.06160013
        ],
        [
          0.00024389158728,
          0.06867635994732,
          76.86828442
        ],
        [
          0.00040519936951,
          0.05022434033256,
          88.89982489
        ],
        [
          0.00025119283904,
          0.06865629609725,
          76.45910249
        ],
        [
          0.00042644539792,
          0.05125930687433,
          86.5127985
        ],
        [
          0.00024389657964,
          0.06867452200394,
          76.86965739
        ],
        [
          0.00045150221177,
          0.0452884946327,
          93.97520473
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00029771365414,
          0.0628443197443,
          79.44364834
        ],
        [
          0.00023662070306,
          0.06962588951038,
          76.44873737
        ],
        [
          0.00028695412683,
          0.06297801819317,
          79.88910883
        ],
        [
          0.00024351495772,
          0.06961680953012,
          76.04634341
        ],
        [
          0.00037654505998,
          0.05655422104618,
          82.3097586
        ],
        [
          0.00023662677876,
          0.06962396630574,
          76.4500873
        ],
        [
          0.00035980621531,
          0.05682660450572,
          82.79175892
        ],
        [
          0.00024325001909,
          0.06943134441933,
          76.22684989
        ],
        [
          0.00031090227996,
          0.06115687452963,
          80.48994434
        ],
        [
          0.00023626673388,
          0.06944491700037,
          76.63211976
        ],
        [
          0.00029853820662,
          0.06134918649801,
          80.94520181
        ],
        [
          0.00024325664384,
          0.06942939917637,
          76.22819379
        ],
        [
          0.0003816269983,
          0.05533134851953,
          83.49768596
        ],
        [
          0.00023627221006,
          0.06944303441812,
          76.63347663
        ],
        [
          0.00036328371879,
          0.05565908996351,
          83.98764649
        ],
        [
          0.00024350776592,
          0.06961879229129,
          76.04500672
        ],
        [
          0.00029771365414,
          0.0628443197443,
          79.44364834
        ],
        [
          0.00023662070306,
          0.06962588951038,
          76.44873737
        ],
        [
          0.00028695412683,
          0.06297801819317,
          79.88910883
        ],
        [
          0.00024351495772,
          0.06961680953012,
          76.04634341
        ],
        [
          0.00037654505998,
          0.05655422104618,
          82.3097586
        ],
        [
          0.00023662677876,
          0.06962396630574,
          76.4500873
        ],
        [
          0.00037733678313,
          0.05585009558389,
          83.08804907
        ],
        [
          0.00024325001909,
          0.06943134441933,
          76.22684989
        ],
        [
          0.00031090227996,
          0.06115687452963,
          80.48994434
        ],
        [
          0.00023626673388,
          0.06944491700037,
          76.63211976
        ],
        [
          0.00029853820662,
          0.06134918649801,
          80.94520181
        ],
        [
          0.00024325664384,
          0.06942939917637,
          76.22819379
        ],
        [
          0.0003816269983,
          0.05533134851953,
          83.49768596
        ],
        [
          0.00023627221006,
          0.06944303441812,
          76.63347663
        ],
        [
          0.0003803510234,
          0.0547058345051,
          84.30725516
        ],
        [
          0.00025155553926,
          0.06884021952008,
          76.27263246
        ],
        [
          0.00032568318849,
          0.06026942328517,
          80.66956151
        ],
        [
          0.0002444084193,
          0.0688495089848,
          76.68076647
        ],
        [
          0.00038725169709,
          0.05315750629313,
          85.89345712
        ],
        [
          0.00025156243102,
          0.06883827193842,
          76.27398565
        ],
        [
          0.00039739345385,
          0.05452363823333,
          83.73267292
        ],
        [
          0.00024441407825,
          0.0688476273958,
          76.68213262
        ],
        [
          0.00042863961092,
          0.04877637094146,
          89.80722155
        ],
        [
          0.00025123357295,
          0.06865639371148,
          76.45666504
        ],
        [
          0.00033558584194,
          0.05879050292533,
          81.77419951
        ],
        [
          0.00024397618404,
          0.06867301129251,
          76.86630196
        ],
        [
          0.00038341469804,
          0.05226361774703,
          87.229972
        ],
        [
          0.00025123983263,
          0.06865448668226,
          76.45802532
        ],
        [
          0.00039876131108,
          0.05344624468896,
          84.98748865
        ],
        [
          0.00024398118202,
          0.06867117312731,
          76.8676749
        ],
        [
          0.00041696731287,
          0.04809959735503,
          91.35081153
        ],
        [
          0.00025155553926,
          0.06884021952008,
          76.27263246
        ],
        [
          0.00036214270611,
          0.05752067391662,
          81.89039063
        ],
        [
          0.0002444084193,
          0.0688495089848,
          76.68076647
        ],
        [
          0.00041243877539,
          0.05102154190165,
          87.47280216
        ],
        [
          0.00025156243102,
          0.06883827193842,
          76.27398565
        ],
        [
          0.00042850346961,
          0.05222390958429,
          85.17653999
        ],
        [
          0.00024441407825,
          0.0688476273958,
          76.68213262
        ],
        [
          0.00046682487085,
          0.04592358592164,
          92.25816752
        ],
        [
          0.00025123357295,
          0.06865639371148,
          76.45666504
        ],
        [
          0.00036889664294,
          0.05621698794931,
          83.0597203
        ],
        [
          0.00024397618404,
          0.06867301129251,
          76.86630196
        ],
        [
          0.0004054433521,
          0.05021781571184,
          88.89696923
        ],
        [
          0.00025123983263,
          0.06865448668226,
          76.45802532
        ],
        [
          0.00042660083429,
          0.05125541091633,
          86.51088339
        ],
        [
          0.00024398118202,
          0.06867117312731,
          76.8676749
        ],
        [
          0.00045180774626,
          0.04528092350533,
          93.97255016
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00029785471934,
          0.06283967748606,
          79.44086232
        ],
        [
          0.00023676167663,
          0.06962013253616,
          76.44536385
        ],
        [
          0.00028713815951,
          0.06297171515119,
          79.8854115
        ],
        [
          0.00024362216593,
          0.06961254287234,
          76.0438372
        ],
        [
          0.00037673640177,
          0.05654901782187,
          82.30682232
        ],
        [
          0.00023676776145,
          0.06961820901651,
          76.44671372
        ],
        [
          0.00036005491686,
          0.0568195025155,
          82.7878768
        ],
        [
          0.00024335749267,
          0.06942705973546,
          76.22433936
        ],
        [
          0.00031108015188,
          0.06115117290281,
          80.48665058
        ],
        [
          0.00023640807712,
          0.0694391305151,
          76.6287409
        ],
        [
          0.00029876150155,
          0.0613417079454,
          80.94099305
        ],
        [
          0.00024336412433,
          0.06942511427208,
          76.22568321
        ],
        [
          0.00038186311366,
          0.05532491201507,
          83.49424857
        ],
        [
          0.00023641356241,
          0.06943724759569,
          76.6300977
        ],
        [
          0.00036357884241,
          0.05565061361723,
          83.98327203
        ],
        [
          0.00024361496727,
          0.06961452583595,
          76.04250056
        ],
        [
          0.00029785471934,
          0.06283967748606,
          79.44086232
        ],
        [
          0.00023676167663,
          0.06962013253616,
          76.44536385
        ],
        [
          0.00028713815951,
          0.06297171515119,
          79.8854115
        ],
        [
          0.00024362216593,
          0.06961254287234,
          76.0438372
        ],
        [
          0.00037673640177,
          0.05654901782187,
          82.30682232
        ],
        [
          0.00023676776145,
          0.06961820901651,
          76.44671372
        ],
        [
          0.00037759681082,
          0.05584300511432,
          83.08413046
        ],
        [
          0.00024335749267,
          0.06942705973546,
          76.22433936
        ],
        [
          0.00031108015188,
          0.06115117290281,
          80.48665058
        ],
        [
          0.00023640807712,
          0.0694391305151,
          76.6287409
        ],
        [
          0.00029876150155,
          0.0613417079454,
          80.94099305
        ],
        [
          0.00024336412433,
          0.06942511427208,
          76.22568321
        ],
        [
          0.00038186311366,
          0.05532491201507,
          83.49424857
        ],
        [
          0.00023641356241,
          0.06943724759569,
          76.6300977
        ],
        [
          0.0003806592251,
          0.05469736724305,
          84.30284301
        ],
        [
          0.00025167925844,
          0.06883546866708,
          76.26979367
        ],
        [
          0.00032588777735,
          0.06026317504413,
          80.66587835
        ],
        [
          0.00024456667392,
          0.06884326744656,
          76.67705394
        ],
        [
          0.00038760545993,
          0.0531478497085,
          85.88867892
        ],
        [
          0.00025168615844,
          0.06883352082092,
          76.2711468
        ],
        [
          0.00039766411161,
          0.05451655604589,
          83.7288337
        ],
        [
          0.00024457234342,
          0.06884138546823,
          76.67842003
        ],
        [
          0.00042907439152,
          0.04876527696119,
          89.80251707
        ],
        [
          0.00025135765326,
          0.06865161763421,
          76.45382159
        ],
        [
          0.00033583332257,
          0.05878303729617,
          81.77000401
        ],
        [
          0.00024413490587,
          0.06866673134379,
          76.86258398
        ],
        [
          0.00038382020365,
          0.0522522921095,
          87.22475694
        ],
        [
          0.00025136392117,
          0.06864971032395,
          76.45518182
        ],
        [
          0.00039908203143,
          0.05343775751306,
          84.98316179
        ],
        [
          0.00024413991432,
          0.06866489276727,
          76.86395685
        ],
        [
          0.00041746015521,
          0.048086531248,
          91.34579151
        ],
        [
          0.00025167925844,
          0.06883546866708,
          76.26979367
        ],
        [
          0.00036237522985,
          0.05751418939691,
          81.88662118
        ],
        [
          0.00024456667392,
          0.06884326744656,
          76.67705394
        ],
        [
          0.00041282819926,
          0.05101143555921,
          87.46800614
        ],
        [
          0.00025168615844,
          0.06883352082092,
          76.2711468
        ],
        [
          0.00042880373706,
          0.05221652346397,
          85.17265322
        ],
        [
          0.00024457234342,
          0.06884138546823,
          76.67842003
        ],
        [
          0.00046731659123,
          0.04591192289084,
          92.25355295
        ],
        [
          0.00025135765326,
          0.06865161763421,
          76.45382159
        ],
        [
          0.00036917554474,
          0.05620922084965,
          83.05544325
        ],
        [
          0.00024413490587,
          0.06866673134379,
          76.86258398
        ],
        [
          0.00040588758079,
          0.05020594594279,
          88.89177206
        ],
        [
          0.00025136392117,
          0.06864971032395,
          76.45518182
        ],
        [
          0.00042695461144,
          0.05124654882764,
          86.50652594
        ],
        [
          0.00024413991432,
          0.06866489276727,
          76.86395685
        ],
        [
          0.00045236406964,
          0.04526715063732,
          93.96771854
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00029811510205,
          0.06283111424006,
          79.43572224
        ],
        [
          0.00023700799766,
          0.0696100808632,
          76.43947339
        ],
        [
          0.00028745443182,
          0.06296089208809,
          79.87906127
        ],
        [
          0.00024382479501,
          0.06960448326668,
          76.03910287
        ],
        [
          0.00037708958343,
          0.05653942048973,
          82.30140484
        ],
        [
          0.00023701409841,
          0.06960815679442,
          76.44082315
        ],
        [
          0.00036048232517,
          0.05680730862617,
          82.78120894
        ],
        [
          0.00024356062318,
          0.06941896611849,
          76.21959687
        ],
        [
          0.00031138691339,
          0.06114134723398,
          80.48097307
        ],
        [
          0.00023665504398,
          0.06942902737831,
          76.62284111
        ],
        [
          0.00029912737308,
          0.0613294660235,
          80.93410151
        ],
        [
          0.00024356726789,
          0.06941702023925,
          76.22094064
        ],
        [
          0.00038227032506,
          0.05531382065949,
          83.48832326
        ],
        [
          0.0002366605452,
          0.06942714387031,
          76.62419781
        ],
        [
          0.0003640624126,
          0.05563673947418,
          83.97610883
        ],
        [
          0.00024381758329,
          0.06960646661744,
          76.03776633
        ],
        [
          0.00029811510205,
          0.06283111424006,
          79.43572224
        ],
        [
          0.00023700799766,
          0.0696100808632,
          76.43947339
        ],
        [
          0.00028745443182,
          0.06296089208809,
          79.87906127
        ],
        [
          0.00024382479501,
          0.06960448326668,
          76.03910287
        ],
        [
          0.00037708958343,
          0.05653942048973,
          82.30140484
        ],
        [
          0.00023701409841,
          0.06960815679442,
          76.44082315
        ],
        [
          0.00037804367919,
          0.05583083111859,
          83.07739988
        ],
        [
          0.00024356062318,
          0.06941896611849,
          76.21959687
        ],
        [
          0.00031138691339,
          0.06114134723398,
          80.48097307
        ],
        [
          0.00023665504398,
          0.06942902737831,
          76.62284111
        ],
        [
          0.00029912737308,
          0.0613294660235,
          80.93410151
        ],
        [
          0.00024356726789,
          0.06941702023925,
          76.22094064
        ],
        [
          0.00038227032506,
          0.05531382065949,
          83.48832326
        ],
        [
          0.0002366605452,
          0.06942714387031,
          76.62419781
        ],
        [
          0.00038116421896,
          0.05468350809504,
          84.29561805
        ],
        [
          0.00025189778394,
          0.06882708237754,
          76.26478234
        ],
        [
          0.00032621927249,
          0.06025305918457,
          80.65991376
        ],
        [
          0.00024483012982,
          0.06883288491369,
          76.67087788
        ],
        [
          0.00038815814465,
          0.05313278053761,
          85.88121877
        ],
        [
          0.00025190469851,
          0.06882513406487,
          76.26613538
        ],
        [
          0.00039810266235,
          0.05450509078775,
          83.72261614
        ],
        [
          0.00024483581694,
          0.06883100228353,
          76.67224385
        ],
        [
          0.00042975369069,
          0.04874796578729,
          89.79517144
        ],
        [
          0.00025157681652,
          0.06864318686669,
          76.44880202
        ],
        [
          0.00033621675756,
          0.05877148107155,
          81.76350756
        ],
        [
          0.00024439913962,
          0.06865628498153,
          76.85639883
        ],
        [
          0.00038443252874,
          0.05223521228786,
          87.2168877
        ],
        [
          0.00025158309899,
          0.0686412790576,
          76.45016216
        ],
        [
          0.00039957895188,
          0.05342462085581,
          84.97646162
        ],
        [
          0.00024440416559,
          0.06865444571712,
          76.8577716
        ],
        [
          0.00041820441671,
          0.04806682808523,
          91.33821581
        ],
        [
          0.00025189778394,
          0.06882708237754,
          76.26478234
        ],
        [
          0.00036275195346,
          0.05750369262387,
          81.88051682
        ],
        [
          0.00024483012982,
          0.06883288491369,
          76.67087788
        ],
        [
          0.00041343660519,
          0.05099566491556,
          87.46051798
        ],
        [
          0.00025190469851,
          0.06882513406487,
          76.26613538
        ],
        [
          0.0004292902672,
          0.05220456641384,
          85.16635853
        ],
        [
          0.00024483581694,
          0.06883100228353,
          76.67224385
        ],
        [
          0.00046808485981,
          0.04589372444545,
          92.24634727
        ],
        [
          0.00025157681652,
          0.06864318686669,
          76.44880202
        ],
        [
          0.00036960766104,
          0.05619719832996,
          83.04882043
        ],
        [
          0.00024439913962,
          0.06865628498153,
          76.85639883
        ],
        [
          0.00040655839103,
          0.05018804600347,
          88.88392956
        ],
        [
          0.00025158309899,
          0.0686412790576,
          76.45016216
        ],
        [
          0.00042750275414,
          0.05123283217804,
          86.49977823
        ],
        [
          0.00024440416559,
          0.06865444571712,
          76.8577716
        ],
        [
          0.00045320420942,
          0.04524638257029,
          93.9604266
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.0002985914658,
          0.06281546670628,
          79.42632674
        ],
        [
          0.00023745221877,
          0.06959197719571,
          76.42886342
        ],
        [
          0.00028802378193,
          0.06294143754811,
          79.86764196
        ],
        [
          0.00024419642084,
          0.06958971739767,
          76.03042865
        ],
        [
          0.00037773571015,
          0.05652188567514,
          82.29150175
        ],
        [
          0.00023745834832,
          0.06959005213508,
          76.43021298
        ],
        [
          0.0003612507861,
          0.05678543390607,
          82.76921687
        ],
        [
          0.00024393316845,
          0.06940413805423,
          76.21090768
        ],
        [
          0.00031193643117,
          0.06112376960653,
          80.470812
        ],
        [
          0.0002371004297,
          0.06941083120967,
          76.6122143
        ],
        [
          0.0002997753403,
          0.06130782109176,
          80.92191027
        ],
        [
          0.00024393983708,
          0.06940219141661,
          76.21225128
        ],
        [
          0.00038299979067,
          0.05529398109254,
          83.47771803
        ],
        [
          0.00023710595962,
          0.0694089466462,
          76.61357082
        ],
        [
          0.00036491884681,
          0.0556122119551,
          83.963436
        ],
        [
          0.00024418918525,
          0.06959170145178,
          76.02909228
        ],
        [
          0.0002985914658,
          0.06281546670628,
          79.42632674
        ],
        [
          0.00023745221877,
          0.06959197719571,
          76.42886342
        ],
        [
          0.00028802378193,
          0.06294143754811,
          79.86764196
        ],
        [
          0.00024419642084,
          0.06958971739767,
          76.03042865
        ],
        [
          0.00037773571015,
          0.05652188567514,
          82.29150175
        ],
        [
          0.00023745834832,
          0.06959005213508,
          76.43021298
        ],
        [
          0.00037884810595,
          0.05580895201722,
          83.06529572
        ],
        [
          0.00024393316845,
          0.06940413805423,
          76.21090768
        ],
        [
          0.00031193643117,
          0.06112376960653,
          80.470812
        ],
        [
          0.0002371004297,
          0.06941083120967,
          76.6122143
        ],
        [
          0.0002997753403,
          0.06130782109176,
          80.92191027
        ],
        [
          0.00024393983708,
          0.06940219141661,
          76.21225128
        ],
        [
          0.00038299979067,
          0.05529398109254,
          83.47771803
        ],
        [
          0.00023710595962,
          0.0694089466462,
          76.61357082
        ],
        [
          0.00038205858022,
          0.05465900745991,
          84.28283589
        ],
        [
          0.00025228929801,
          0.0688120737921,
          76.25581299
        ],
        [
          0.00032679892758,
          0.06023539470178,
          80.64949362
        ],
        [
          0.00024529651007,
          0.06881453017097,
          76.65995824
        ],
        [
          0.00038911791062,
          0.05310666221927,
          85.86827786
        ],
        [
          0.0002522962387,
          0.06881012464495,
          76.25716586
        ],
        [
          0.00039886952791,
          0.05448507221063,
          83.71175331
        ],
        [
          0.00024530222833,
          0.06881264639491,
          76.66132402
        ],
        [
          0.00043093344533,
          0.04871796463285,
          89.78242746
        ],
        [
          0.00025196947313,
          0.06862809881333,
          76.4398179
        ],
        [
          0.00033687654736,
          0.05875162617751,
          81.75233988
        ],
        [
          0.00024486689683,
          0.06863781761434,
          76.84546308
        ],
        [
          0.00038548214259,
          0.05220599695808,
          87.20341446
        ],
        [
          0.00025197578168,
          0.06862619011393,
          76.44117788
        ],
        [
          0.00040043405245,
          0.0534020529717,
          84.96494283
        ],
        [
          0.00024487195378,
          0.06863597713773,
          76.84683567
        ],
        [
          0.00041948034368,
          0.04803312938175,
          91.32524304
        ],
        [
          0.00025228929801,
          0.0688120737921,
          76.25581299
        ],
        [
          0.00036341062904,
          0.05748536633278,
          81.86985231
        ],
        [
          0.00024529651007,
          0.06881453017097,
          76.65995824
        ],
        [
          0.00041449315758,
          0.05096833184196,
          87.44752788
        ],
        [
          0.0002522962387,
          0.06881012464495,
          76.25716586
        ],
        [
          0.00043014103791,
          0.05218368988602,
          85.15536061
        ],
        [
          0.00024530222833,
          0.06881264639491,
          76.66132402
        ],
        [
          0.00046941914986,
          0.04586218756475,
          92.23384489
        ],
        [
          0.00025196947313,
          0.06862809881333,
          76.4398179
        ],
        [
          0.00037035121498,
          0.05617654330659,
          83.03743519
        ],
        [
          0.00024486689683,
          0.06863781761434,
          76.84546308
        ],
        [
          0.00040770829004,
          0.05015742918557,
          88.87050138
        ],
        [
          0.00025197578168,
          0.06862619011393,
          76.44117788
        ],
        [
          0.00042844601036,
          0.05120926877972,
          86.48817728
        ],
        [
          0.00024487195378,
          0.06863597713773,
          76.84683567
        ],
        [
          0.00045464453942,
          0.04521086501477,
          93.94793816
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00029938745853,
          0.06278937386246,
          79.41065053
        ],
        [
          0.00023811874601,
          0.06956487084895,
          76.41297506
        ],
        [
          0.00028889743284,
          0.06291165741061,
          79.85015007
        ],
        [
          0.00024480276428,
          0.06956566869914,
          76.01629969
        ],
        [
          0.00037881534187,
          0.05649265233982,
          82.27497706
        ],
        [
          0.00023812491871,
          0.06956294431128,
          76.41432433
        ],
        [
          0.00036243144644,
          0.05675189374806,
          82.7508467
        ],
        [
          0.00024454101129,
          0.06937998839945,
          76.19675431
        ],
        [
          0.00031282323162,
          0.06109546685105,
          80.45443953
        ],
        [
          0.00023776870384,
          0.06938358683389,
          76.59630068
        ],
        [
          0.00030074360967,
          0.06127556159532,
          80.90372552
        ],
        [
          0.00024454771896,
          0.0693780405266,
          76.19809763
        ],
        [
          0.0003841770046,
          0.05526204249961,
          83.46062805
        ],
        [
          0.00023777427683,
          0.06938170069303,
          76.59765691
        ],
        [
          0.00036619867801,
          0.05557566421964,
          83.94453053
        ],
        [
          0.0002447954897,
          0.06956765389862,
          76.0149636
        ],
        [
          0.00029938745853,
          0.06278937386246,
          79.41065053
        ],
        [
          0.00023811874601,
          0.06956487084895,
          76.41297506
        ],
        [
          0.00028889743284,
          0.06291165741061,
          79.85015007
        ],
        [
          0.00024480276428,
          0.06956566869914,
          76.01629969
        ],
        [
          0.00037881534187,
          0.05649265233982,
          82.27497706
        ],
        [
          0.00023812491871,
          0.06956294431128,
          76.41432433
        ],
        [
          0.00038008242202,
          0.05577546980567,
          83.04675253
        ],
        [
          0.00024454101129,
          0.06937998839945,
          76.19675431
        ],
        [
          0.00031282323162,
          0.06109546685105,
          80.45443953
        ],
        [
          0.00023776870384,
          0.06938358683389,
          76.59630068
        ],
        [
          0.00030074360967,
          0.06127556159532,
          80.90372552
        ],
        [
          0.00024454771896,
          0.0693780405266,
          76.19809763
        ],
        [
          0.0003841770046,
          0.05526204249961,
          83.46062805
        ],
        [
          0.00023777427683,
          0.06938170069303,
          76.59765691
        ],
        [
          0.00038339505144,
          0.05462250066509,
          84.26376711
        ],
        [
          0.00025292457289,
          0.06878776545037,
          76.2412838
        ],
        [
          0.00032775250659,
          0.06020640193374,
          80.63237808
        ],
        [
          0.0002459940944,
          0.06878713525303,
          76.64365728
        ],
        [
          0.00039057876646,
          0.05306702903748,
          85.84861453
        ],
        [
          0.00025293155593,
          0.06878581495567,
          76.24263639
        ],
        [
          0.00040013111606,
          0.05445222186849,
          83.69390861
        ],
        [
          0.00024599985924,
          0.0687852497704,
          76.64502278
        ],
        [
          0.00043272942608,
          0.04867244688009,
          89.76305921
        ],
        [
          0.00025260660145,
          0.06860366213742,
          76.42526475
        ],
        [
          0.00033792804825,
          0.05872006250564,
          81.73457065
        ],
        [
          0.00024556654089,
          0.06861025509966,
          76.82913803
        ],
        [
          0.00038704314823,
          0.05216266645488,
          87.18344604
        ],
        [
          0.0002526129523,
          0.06860175200018,
          76.42662446
        ],
        [
          0.00040179690214,
          0.05336618259234,
          84.94661257
        ],
        [
          0.00024557164418,
          0.06860841281834,
          76.83051035
        ],
        [
          0.00042137570146,
          0.04798325500071,
          91.30600625
        ],
        [
          0.00025292457289,
          0.06878776545037,
          76.2412838
        ],
        [
          0.00036449304282,
          0.05745533922018,
          81.85233316
        ],
        [
          0.0002459940944,
          0.06878713525303,
          76.64365728
        ],
        [
          0.00041610138803,
          0.05092685791987,
          87.42778838
        ],
        [
          0.00025293155593,
          0.06878581495567,
          76.24263639
        ],
        [
          0.000431540679,
          0.05214943364272,
          85.13729305
        ],
        [
          0.00024599985924,
          0.0687852497704,
          76.64502278
        ],
        [
          0.0004714504334,
          0.04581434456046,
          92.21484089
        ],
        [
          0.00025260660145,
          0.06860366213742,
          76.42526475
        ],
        [
          0.00037153620084,
          0.05614371030212,
          83.01931899
        ],
        [
          0.00024556654089,
          0.06861025509966,
          76.82913803
        ],
        [
          0.00040941619033,
          0.05011211088757,
          88.85059272
        ],
        [
          0.0002526129523,
          0.06860175200018,
          76.42662446
        ],
        [
          0.00042994939357,
          0.05117181836183,
          86.46971511
        ],
        [
          0.00024557164418,
          0.06860841281834,
          76.83051035
        ],
        [
          0.00045678289245,
          0.04515834917987,
          93.92940655
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00030040490216,
          0.06275611937012,
          79.39065558
        ],
        [
          0.00023902939633,
          0.06952794673585,
          76.39132775
        ],
        [
          0.00029008943492,
          0.06287116596671,
          79.82634389
        ],
        [
          0.00024557689207,
          0.06953504295269,
          75.99830387
        ],
        [
          0.00038019527782,
          0.05645540737359,
          82.25389707
        ],
        [
          0.00023903562796,
          0.06952601819552,
          76.39267661
        ],
        [
          0.00036404229662,
          0.05670630630744,
          82.72584118
        ],
        [
          0.00024531705207,
          0.06934923468717,
          76.17872732
        ],
        [
          0.00031397514637,
          0.06105881955184,
          80.43321876
        ],
        [
          0.00023868173997,
          0.06934647559818,
          76.57461882
        ],
        [
          0.00030208049473,
          0.06123118722481,
          80.87868224
        ],
        [
          0.00024532380954,
          0.06934728525082,
          76.1800703
        ],
        [
          0.00038570618431,
          0.05522069885541,
          83.43847391
        ],
        [
          0.00023868737182,
          0.06934458731595,
          76.57597466
        ],
        [
          0.00036796582287,
          0.0555254067496,
          83.91849
        ],
        [
          0.00024556956773,
          0.06953702960387,
          75.99696814
        ],
        [
          0.00030040490216,
          0.06275611937012,
          79.39065558
        ],
        [
          0.00023902939633,
          0.06952794673585,
          76.39132775
        ],
        [
          0.00029008943492,
          0.06287116596671,
          79.82634389
        ],
        [
          0.00024557689207,
          0.06953504295269,
          75.99830387
        ],
        [
          0.00038019527782,
          0.05645540737359,
          82.25389707
        ],
        [
          0.00023903562796,
          0.06952601819552,
          76.39267661
        ],
        [
          0.00038176640688,
          0.05572996287509,
          83.02151118
        ],
        [
          0.00024531705207,
          0.06934923468717,
          76.17872732
        ],
        [
          0.00031397514637,
          0.06105881955184,
          80.43321876
        ],
        [
          0.00023868173997,
          0.06934647559818,
          76.57461882
        ],
        [
          0.00030208049473,
          0.06123118722481,
          80.87868224
        ],
        [
          0.00024532380954,
          0.06934728525082,
          76.1800703
        ],
        [
          0.00038570618431,
          0.05522069885541,
          83.43847391
        ],
        [
          0.00023868737182,
          0.06934458731595,
          76.57597466
        ],
        [
          0.00038524032992,
          0.05457230121231,
          84.23750123
        ],
        [
          0.00025372834519,
          0.06875708866533,
          76.22294432
        ],
        [
          0.00032894250693,
          0.06017033674971,
          80.61106496
        ],
        [
          0.0002469389629,
          0.06875014143329,
          76.62163871
        ],
        [
          0.00039252538483,
          0.05301444313107,
          85.82247609
        ],
        [
          0.00025373538184,
          0.06875513647442,
          76.22429656
        ],
        [
          0.00040170554622,
          0.05441136888418,
          83.671684
        ],
        [
          0.0002469447908,
          0.06874825365715,
          76.62300382
        ],
        [
          0.00043512312682,
          0.04861206708215,
          89.73730526
        ],
        [
          0.00025341271803,
          0.06857282405396,
          76.40689495
        ],
        [
          0.00033926167972,
          0.05868016854714,
          81.712084
        ],
        [
          0.00024651419939,
          0.06857303591073,
          76.80708678
        ],
        [
          0.00038914585365,
          0.05210460404536,
          87.15657172
        ],
        [
          0.00025341912242,
          0.0685709121073,
          76.40825432
        ],
        [
          0.00040352556696,
          0.05332085617638,
          84.92341177
        ],
        [
          0.00024651936545,
          0.06857119120125,
          76.80845872
        ],
        [
          0.00042393305008,
          0.04791630689762,
          91.28011439
        ],
        [
          0.00025372834519,
          0.06875708866533,
          76.22294432
        ],
        [
          0.00036584524633,
          0.05741792839468,
          81.83051843
        ],
        [
          0.0002469389629,
          0.06875014143329,
          76.62163871
        ],
        [
          0.00041824865965,
          0.05087168346386,
          87.40155421
        ],
        [
          0.00025373538184,
          0.06875513647442,
          76.22429656
        ],
        [
          0.00043328742753,
          0.05210683572439,
          85.11478922
        ],
        [
          0.0002469447908,
          0.06874825365715,
          76.62300382
        ],
        [
          0.00047415783747,
          0.04575088909676,
          92.18956582
        ],
        [
          0.00025341271803,
          0.06857282405396,
          76.40689495
        ],
        [
          0.00037303911605,
          0.0561022166713,
          82.99639184
        ],
        [
          0.00024651419939,
          0.06857303591073,
          76.80708678
        ],
        [
          0.00041172014607,
          0.05005126893847,
          88.823803
        ],
        [
          0.00025341912242,
          0.0685709121073,
          76.40825432
        ],
        [
          0.0004318563701,
          0.05112449936323,
          86.44634534
        ],
        [
          0.00024651936545,
          0.06857119120125,
          76.80845872
        ],
        [
          0.00045966941886,
          0.04508782181853,
          93.90447185
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00030192039228,
          0.06270678808478,
          79.36096079
        ],
        [
          0.00024038585108,
          0.06947318084638,
          76.35921122
        ],
        [
          0.00029187283141,
          0.06281088510062,
          79.79085404
        ],
        [
          0.00024672356858,
          0.06948983747746,
          75.97173524
        ],
        [
          0.00038225058113,
          0.05640018118477,
          82.22258505
        ],
        [
          0.00024039217049,
          0.06947124935154,
          76.36055948
        ],
        [
          0.00036645226994,
          0.05663847397508,
          82.68855482
        ],
        [
          0.00024646655954,
          0.06930384155272,
          76.15211252
        ],
        [
          0.00031566013496,
          0.06100544868697,
          80.40227124
        ],
        [
          0.00024004174658,
          0.06929143406726,
          76.54245081
        ],
        [
          0.00030405032481,
          0.06116615190383,
          80.84191707
        ],
        [
          0.0002464733908,
          0.06930188981641,
          76.15345498
        ],
        [
          0.00038794308357,
          0.05516051166745,
          83.40615841
        ],
        [
          0.00024004746603,
          0.06928954263083,
          76.54380607
        ],
        [
          0.00037056979652,
          0.0554517817368,
          83.88025095
        ],
        [
          0.0002467161706,
          0.06949182625881,
          75.97040005
        ],
        [
          0.00030192039228,
          0.06270678808478,
          79.36096079
        ],
        [
          0.00024038585108,
          0.06947318084638,
          76.35921122
        ],
        [
          0.00029187283141,
          0.06281088510062,
          79.79085404
        ],
        [
          0.00024672356858,
          0.06948983747746,
          75.97173524
        ],
        [
          0.00038225058113,
          0.05640018118477,
          82.22258505
        ],
        [
          0.00024039217049,
          0.06947124935154,
          76.36055948
        ],
        [
          0.00038428564274,
          0.05566225407397,
          82.98387248
        ],
        [
          0.00024646655954,
          0.06930384155272,
          76.15211252
        ],
        [
          0.00031566013496,
          0.06100544868697,
          80.40227124
        ],
        [
          0.00024004174658,
          0.06929143406726,
          76.54245081
        ],
        [
          0.00030405032481,
          0.06116615190383,
          80.84191707
        ],
        [
          0.0002464733908,
          0.06930188981641,
          76.15345498
        ],
        [
          0.00038794308357,
          0.05516051166745,
          83.40615841
        ],
        [
          0.00024004746603,
          0.06928954263083,
          76.54380607
        ],
        [
          0.00038795928333,
          0.05449876479352,
          84.19893046
        ],
        [
          0.00025491821795,
          0.06871183346842,
          76.19588674
        ],
        [
          0.00033070588616,
          0.06011712879336,
          80.57957555
        ],
        [
          0.00024834551487,
          0.06869530895223,
          76.58899
        ],
        [
          0.00039542559891,
          0.0529365705192,
          85.78366651
        ],
        [
          0.00025492533399,
          0.06870987878403,
          76.19723846
        ],
        [
          0.00040403869505,
          0.05435111920122,
          83.63884075
        ],
        [
          0.00024835143669,
          0.06869341779163,
          76.59035452
        ],
        [
          0.0004386905112,
          0.04852268266182,
          89.69904994
        ],
        [
          0.00025460596745,
          0.06852733921829,
          76.37979142
        ],
        [
          0.00034120419997,
          0.05862233548817,
          81.67943058
        ],
        [
          0.00024792490494,
          0.06851787138509,
          76.77438934
        ],
        [
          0.00039223200334,
          0.05201995323273,
          87.11725313
        ],
        [
          0.00025461245107,
          0.06852542461633,
          76.38115029
        ],
        [
          0.00040604376508,
          0.05325516942858,
          84.88971303
        ],
        [
          0.00024793016449,
          0.06851602309309,
          76.77576072
        ],
        [
          0.0004276897326,
          0.0478186732053,
          91.2422111
        ],
        [
          0.00025491821795,
          0.06871183346842,
          76.19588674
        ],
        [
          0.0003678488889,
          0.05736274496603,
          81.7982855
        ],
        [
          0.00024834551487,
          0.06869530895223,
          76.58899
        ],
        [
          0.00042144165716,
          0.05079021869261,
          87.36258412
        ],
        [
          0.00025492533399,
          0.06870987878403,
          76.19723846
        ],
        [
          0.0004358759981,
          0.05204401962722,
          85.08152997
        ],
        [
          0.00024835143669,
          0.06869341779163,
          76.59035452
        ],
        [
          0.00047819292607,
          0.04565696992708,
          92.15201034
        ],
        [
          0.00025460596745,
          0.06852733921829,
          76.37979142
        ],
        [
          0.00037522817306,
          0.05604207390087,
          82.96309595
        ],
        [
          0.00024792490494,
          0.06851787138509,
          76.77438934
        ],
        [
          0.00041510365139,
          0.0499625203019,
          88.78459869
        ],
        [
          0.00025461245107,
          0.06852542461633,
          76.38115029
        ],
        [
          0.00043463443008,
          0.05105593288788,
          86.41239715
        ],
        [
          0.00024793016449,
          0.06851602309309,
          76.77576072
        ],
        [
          0.00046391102907,
          0.04498495988302,
          93.867953
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00030405248905,
          0.06263778970862,
          79.31936029
        ],
        [
          0.0002422273516,
          0.06939927541558,
          76.31585294
        ],
        [
          0.00029437520988,
          0.06272690038904,
          79.74131099
        ],
        [
          0.00024827381018,
          0.06942902125601,
          75.93598082
        ],
        [
          0.00038514181554,
          0.05632298876016,
          82.17870816
        ],
        [
          0.00024223379013,
          0.06939733996753,
          76.31720039
        ],
        [
          0.0003698336602,
          0.05654403854447,
          82.63648674
        ],
        [
          0.00024802062333,
          0.06924277516326,
          76.11629569
        ],
        [
          0.00031800372046,
          0.06093167793431,
          80.35941067
        ],
        [
          0.00024188806525,
          0.06921716024475,
          76.49902258
        ],
        [
          0.00030678830419,
          0.0610764353471,
          80.79107859
        ],
        [
          0.0002480275543,
          0.06924082035729,
          76.11763746
        ],
        [
          0.00039105440354,
          0.0550773644563,
          83.36138992
        ],
        [
          0.00024189390366,
          0.06921526458339,
          76.50037706
        ],
        [
          0.00037418954023,
          0.0553502794309,
          83.82735517
        ],
        [
          0.00024826631267,
          0.06943101288112,
          75.93464635
        ],
        [
          0.00030405248905,
          0.06263778970862,
          79.31936029
        ],
        [
          0.0002422273516,
          0.06939927541558,
          76.31585294
        ],
        [
          0.00029437520988,
          0.06272690038904,
          79.74131099
        ],
        [
          0.00024827381018,
          0.06942902125601,
          75.93598082
        ],
        [
          0.00038514181554,
          0.05632298876016,
          82.17870816
        ],
        [
          0.00024223379013,
          0.06939733996753,
          76.31720039
        ],
        [
          0.00038782000334,
          0.0555679990505,
          82.93131105
        ],
        [
          0.00024802062333,
          0.06924277516326,
          76.11629569
        ],
        [
          0.00031800372046,
          0.06093167793431,
          80.35941067
        ],
        [
          0.00024188806525,
          0.06921716024475,
          76.49902258
        ],
        [
          0.00030678830419,
          0.0610764353471,
          80.79107859
        ],
        [
          0.0002480275543,
          0.06924082035729,
          76.11763746
        ],
        [
          0.00039105440354,
          0.0550773644563,
          83.36138992
        ],
        [
          0.00024189390366,
          0.06921526458339,
          76.50037706
        ],
        [
          0.00039173855477,
          0.05439739164847,
          84.14557418
        ],
        [
          0.00025652060105,
          0.06865119472305,
          76.1596095
        ],
        [
          0.00033317121363,
          0.06004320486202,
          80.53573553
        ],
        [
          0.0002502489206,
          0.06862155456604,
          76.54505066
        ],
        [
          0.00039947558033,
          0.05282876194109,
          85.72973301
        ],
        [
          0.00025652782388,
          0.06864923672757,
          76.16096052
        ],
        [
          0.00040730080729,
          0.05426745522116,
          83.59310176
        ],
        [
          0.0002502549695,
          0.06861965888852,
          76.54641439
        ],
        [
          0.00044367432578,
          0.04839899294037,
          89.64585474
        ],
        [
          0.00025621302127,
          0.06846638566047,
          76.34345368
        ],
        [
          0.00034389078605,
          0.05854287976985,
          81.63446439
        ],
        [
          0.00024983393194,
          0.06844367412398,
          76.73038389
        ],
        [
          0.00039650586049,
          0.051903778837,
          87.06310122
        ],
        [
          0.00025621961153,
          0.06846446752563,
          76.34481188
        ],
        [
          0.0004095269503,
          0.05316497064199,
          84.84329119
        ],
        [
          0.00024983931798,
          0.06844182105052,
          76.73175452
        ],
        [
          0.00043289215029,
          0.04768483936852,
          91.18997458
        ],
        [
          0.00025652060105,
          0.06865119472305,
          76.1596095
        ],
        [
          0.00037064992971,
          0.05728609583454,
          81.75340563
        ],
        [
          0.0002502489206,
          0.06862155456604,
          76.54505066
        ],
        [
          0.00042589827321,
          0.05067754433419,
          87.30842051
        ],
        [
          0.00025652782388,
          0.06864923672757,
          76.16096052
        ],
        [
          0.00043949535199,
          0.05195680572531,
          85.03520496
        ],
        [
          0.0002502549695,
          0.06861965888852,
          76.54641439
        ],
        [
          0.00048383050605,
          0.04552704103715,
          92.09976547
        ],
        [
          0.00025621302127,
          0.06846638566047,
          76.34345368
        ],
        [
          0.00037825548815,
          0.05595946983097,
          82.91723948
        ],
        [
          0.00024983393194,
          0.06844367412398,
          76.73038389
        ],
        [
          0.00041978744651,
          0.04984082753379,
          88.73059512
        ],
        [
          0.00025621961153,
          0.06846446752563,
          76.34481188
        ],
        [
          0.00043847809699,
          0.05096176651082,
          86.36562464
        ],
        [
          0.00024983931798,
          0.06844182105052,
          76.73175452
        ],
        [
          0.00046978553899,
          0.04484400219219,
          93.81759664
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00030645357354,
          0.06256064416547,
          79.27275589
        ],
        [
          0.0002442220415,
          0.06931979105263,
          76.26919855
        ],
        [
          0.00029712098369,
          0.06263553867961,
          79.68728632
        ],
        [
          0.00024999744241,
          0.06936180205967,
          75.89644722
        ],
        [
          0.00038839748368,
          0.05623674990387,
          82.129536
        ],
        [
          0.00024422860903,
          0.06931785139514,
          76.27054511
        ],
        [
          0.00037354368534,
          0.05644140114645,
          82.57968596
        ],
        [
          0.00024974849846,
          0.06917528250048,
          76.07669271
        ],
        [
          0.00032064277745,
          0.06084923935183,
          80.31139822
        ],
        [
          0.00024388796916,
          0.06913728423974,
          76.45229233
        ],
        [
          0.00030979373886,
          0.06097884991065,
          80.73562214
        ],
        [
          0.0002497555402,
          0.06917332433336,
          76.07803371
        ],
        [
          0.00039455811186,
          0.05498450998902,
          83.31122186
        ],
        [
          0.00024389393638,
          0.06913538407913,
          76.45364596
        ],
        [
          0.0003781632436,
          0.0552399603689,
          83.76962914
        ],
        [
          0.00024998983436,
          0.06936379679684,
          75.89511354
        ],
        [
          0.00030645357354,
          0.06256064416547,
          79.27275589
        ],
        [
          0.0002442220415,
          0.06931979105263,
          76.26919855
        ],
        [
          0.00029712098369,
          0.06263553867961,
          79.68728632
        ],
        [
          0.00024999744241,
          0.06936180205967,
          75.89644722
        ],
        [
          0.00038839748368,
          0.05623674990387,
          82.129536
        ],
        [
          0.00024422860903,
          0.06931785139514,
          76.27054511
        ],
        [
          0.00039169724053,
          0.05546557581844,
          82.87397024
        ],
        [
          0.00024974849846,
          0.06917528250048,
          76.07669271
        ],
        [
          0.00032064277745,
          0.06084923935183,
          80.31139822
        ],
        [
          0.00024388796916,
          0.06913728423974,
          76.45229233
        ],
        [
          0.00030979373886,
          0.06097884991065,
          80.73562214
        ],
        [
          0.0002497555402,
          0.06917332433336,
          76.07803371
        ],
        [
          0.00039455811186,
          0.05498450998902,
          83.31122186
        ],
        [
          0.00024389393638,
          0.06913538407913,
          76.45364596
        ],
        [
          0.00039588697967,
          0.05428722220712,
          84.08734347
        ],
        [
          0.00025829108697,
          0.06858459170498,
          76.11974423
        ],
        [
          0.000335928495,
          0.05996115944938,
          80.48695529
        ],
        [
          0.00025229997607,
          0.06854264704729,
          76.49801041
        ],
        [
          0.00040389797225,
          0.05271226232126,
          85.67118349
        ],
        [
          0.00025829842775,
          0.06858263010228,
          76.12109447
        ],
        [
          0.00041094949587,
          0.05417465880376,
          83.54218925
        ],
        [
          0.00025230616185,
          0.06854074658465,
          76.4993733
        ],
        [
          0.00044911921326,
          0.04826540649695,
          89.58806415
        ],
        [
          0.000257988664,
          0.06839944011518,
          76.3035215
        ],
        [
          0.00034689614272,
          0.05845470749101,
          81.58443522
        ],
        [
          0.00025189104511,
          0.06836429752587,
          76.68327223
        ],
        [
          0.0004011761852,
          0.05177822334161,
          87.00428447
        ],
        [
          0.00025799537209,
          0.06839751813003,
          76.30487895
        ],
        [
          0.00041342379693,
          0.05306495293751,
          84.79161454
        ],
        [
          0.00025189656744,
          0.06836243938349,
          76.68464205
        ],
        [
          0.0004385805031,
          0.04754029033416,
          91.13318892
        ],
        [
          0.00025829108697,
          0.06858459170498,
          76.11974423
        ],
        [
          0.00037378241087,
          0.05720105232409,
          81.7034619
        ],
        [
          0.00025229997607,
          0.06854264704729,
          76.49801041
        ],
        [
          0.00043076825034,
          0.05055571263058,
          87.24960271
        ],
        [
          0.00025829842775,
          0.06858263010228,
          76.12109447
        ],
        [
          0.00044354377662,
          0.05186009075852,
          84.98363102
        ],
        [
          0.00025230616185,
          0.06854074658465,
          76.4993733
        ],
        [
          0.00048998959168,
          0.04538677815269,
          92.0429761
        ],
        [
          0.000257988664,
          0.06839944011518,
          76.3035215
        ],
        [
          0.00038164144027,
          0.05586785209295,
          82.86620636
        ],
        [
          0.00025189104511,
          0.06836429752587,
          76.68327223
        ],
        [
          0.00042490635937,
          0.0497093416562,
          88.6719226
        ],
        [
          0.00025799537209,
          0.06839751813003,
          76.30487895
        ],
        [
          0.00044277749918,
          0.05085740461077,
          86.31354623
        ],
        [
          0.00025189656744,
          0.06836243938349,
          76.68464205
        ],
        [
          0.0004762094518,
          0.04469181442596,
          93.76281842
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00030898401572,
          0.06247997376182,
          79.2239156
        ],
        [
          0.00024624664369,
          0.0692397109274,
          76.22216974
        ],
        [
          0.00030006372991,
          0.06253852477902,
          79.62977295
        ],
        [
          0.00025169572722,
          0.06929597743273,
          75.85771841
        ],
        [
          0.00039182813036,
          0.05614664696732,
          82.0779868
        ],
        [
          0.00024625334201,
          0.06923776707927,
          76.2235154
        ],
        [
          0.0003775194002,
          0.05633252539142,
          82.51919138
        ],
        [
          0.00025145095675,
          0.06910919315258,
          76.03789557
        ],
        [
          0.00032342378034,
          0.06076308081543,
          80.26108781
        ],
        [
          0.00024591785811,
          0.06905681428203,
          76.40518645
        ],
        [
          0.00031301388143,
          0.0608753139049,
          80.67660001
        ],
        [
          0.00025145810761,
          0.06910723172194,
          76.0392358
        ],
        [
          0.00039825084363,
          0.0548875197325,
          83.25863063
        ],
        [
          0.00024592395605,
          0.06905490963316,
          76.40653922
        ],
        [
          0.00038242129774,
          0.05512300883932,
          83.70816244
        ],
        [
          0.00025168801032,
          0.06929797518707,
          75.85638552
        ],
        [
          0.00030898401572,
          0.06247997376182,
          79.2239156
        ],
        [
          0.00024624664369,
          0.0692397109274,
          76.22216974
        ],
        [
          0.00030006372991,
          0.06253852477902,
          79.62977295
        ],
        [
          0.00025169572722,
          0.06929597743273,
          75.85771841
        ],
        [
          0.00039182813036,
          0.05614664696732,
          82.0779868
        ],
        [
          0.00024625334201,
          0.06923776707927,
          76.2235154
        ],
        [
          0.00039585168624,
          0.05535693747767,
          82.81289852
        ],
        [
          0.00025145095675,
          0.06910919315258,
          76.03789557
        ],
        [
          0.00032342378034,
          0.06076308081543,
          80.26108781
        ],
        [
          0.00024591785811,
          0.06905681428203,
          76.40518645
        ],
        [
          0.00031301388143,
          0.0608753139049,
          80.67660001
        ],
        [
          0.00025145810761,
          0.06910723172194,
          76.0392358
        ],
        [
          0.00039825084363,
          0.0548875197325,
          83.25863063
        ],
        [
          0.00024592395605,
          0.06905490963316,
          76.40653922
        ],
        [
          0.00040033178875,
          0.05417043980401,
          84.02533695
        ],
        [
          0.0002600433452,
          0.06851907992637,
          76.08051153
        ],
        [
          0.00033885080889,
          0.05987492131551,
          80.43554104
        ],
        [
          0.0002543893817,
          0.06846286101883,
          76.45041351
        ],
        [
          0.00040866191419,
          0.05258814767339,
          85.6085242
        ],
        [
          0.00026005080259,
          0.06851711481024,
          76.081861
        ],
        [
          0.0004148168466,
          0.05407718747362,
          83.48850565
        ],
        [
          0.00025439570695,
          0.06846095576026,
          76.45177553
        ],
        [
          0.00045498650365,
          0.04812322163046,
          89.52616286
        ],
        [
          0.00025974602182,
          0.06833359472146,
          76.26422252
        ],
        [
          0.00035008075479,
          0.05836210427082,
          81.53170641
        ],
        [
          0.00025398662184,
          0.06828404214782,
          76.63560238
        ],
        [
          0.00040620617865,
          0.05164459315266,
          86.94134718
        ],
        [
          0.00025975284653,
          0.06833166897779,
          76.26557923
        ],
        [
          0.00041755432648,
          0.05295994848055,
          84.73713177
        ],
        [
          0.00025399228309,
          0.06828217892248,
          76.63697138
        ],
        [
          0.000444710821,
          0.04738654617049,
          91.07236804
        ],
        [
          0.0002600433452,
          0.06851907992637,
          76.08051153
        ],
        [
          0.00037710206366,
          0.05711169302062,
          81.65081403
        ],
        [
          0.0002543893817,
          0.06846286101883,
          76.45041351
        ],
        [
          0.00043601384872,
          0.05042598959667,
          87.18663437
        ],
        [
          0.00026005080259,
          0.06851711481024,
          76.081861
        ],
        [
          0.00044783499181,
          0.05175852488284,
          84.92923959
        ],
        [
          0.00025439570695,
          0.06846095576026,
          76.45177553
        ],
        [
          0.00049662706109,
          0.04523753781671,
          91.98211285
        ],
        [
          0.00025974602182,
          0.06833359472146,
          76.26422252
        ],
        [
          0.00038522963393,
          0.0557716342771,
          82.8124182
        ],
        [
          0.00025398662184,
          0.06828404214782,
          76.63560238
        ],
        [
          0.00043042029243,
          0.04956943447636,
          88.60912005
        ],
        [
          0.00025975284653,
          0.06833166897779,
          76.26557923
        ],
        [
          0.00044733503702,
          0.05074786250628,
          86.2586278
        ],
        [
          0.00025399228309,
          0.06828217892248,
          76.63697138
        ],
        [
          0.00048313324628,
          0.04453000854542,
          93.70410556
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00031189532671,
          0.06238794932417,
          79.16806805
        ],
        [
          0.00024854244822,
          0.06914961897728,
          76.16923092
        ],
        [
          0.00030344123345,
          0.06242830965088,
          79.56424286
        ],
        [
          0.00025362268814,
          0.06922177118855,
          75.81403945
        ],
        [
          0.00039578283074,
          0.05604374374416,
          82.01889688
        ],
        [
          0.00024854929481,
          0.0691476704645,
          76.17057557
        ],
        [
          0.00038209033152,
          0.05620874116907,
          82.45010881
        ],
        [
          0.00025338264506,
          0.06903469206615,
          75.99413912
        ],
        [
          0.00032661877551,
          0.06066498531379,
          80.20364256
        ],
        [
          0.00024821965091,
          0.06896628940442,
          76.35216017
        ],
        [
          0.00031670574979,
          0.06075788294232,
          80.60942687
        ],
        [
          0.0002533899196,
          0.06903272699655,
          75.99547848
        ],
        [
          0.00040250174336,
          0.05477697074495,
          83.19842945
        ],
        [
          0.00024822589702,
          0.06896437976148,
          76.35351195
        ],
        [
          0.00038731226563,
          0.05499024870704,
          83.63804719
        ],
        [
          0.00025361484779,
          0.06922377231247,
          75.81270746
        ],
        [
          0.00031189532671,
          0.06238794932417,
          79.16806805
        ],
        [
          0.00024854244822,
          0.06914961897728,
          76.16923092
        ],
        [
          0.00030344123345,
          0.06242830965088,
          79.56424286
        ],
        [
          0.00025362268814,
          0.06922177118855,
          75.81403945
        ],
        [
          0.00039578283074,
          0.05604374374416,
          82.01889688
        ],
        [
          0.00024854929481,
          0.0691476704645,
          76.17057557
        ],
        [
          0.0004006275261,
          0.05523343599876,
          82.74315438
        ],
        [
          0.00025338264506,
          0.06903469206615,
          75.99413912
        ],
        [
          0.00032661877551,
          0.06066498531379,
          80.20364256
        ],
        [
          0.00024821965091,
          0.06896628940442,
          76.35216017
        ],
        [
          0.00031670574979,
          0.06075788294232,
          80.60942687
        ],
        [
          0.0002533899196,
          0.06903272699655,
          75.99547848
        ],
        [
          0.00040250174336,
          0.05477697074495,
          83.19842945
        ],
        [
          0.00024822589702,
          0.06896437976148,
          76.35351195
        ],
        [
          0.00040543667415,
          0.0540378847766,
          83.95460288
        ],
        [
          0.00026202647507,
          0.06844541682644,
          76.03637251
        ],
        [
          0.00034219475953,
          0.05977713134079,
          80.37706355
        ],
        [
          0.00025675360227,
          0.0683732958086,
          76.39694273
        ],
        [
          0.00041413457334,
          0.05244733587855,
          85.53701068
        ],
        [
          0.00026203406441,
          0.06844344779569,
          76.03772112
        ],
        [
          0.00041925162187,
          0.0539665166116,
          83.42729413
        ],
        [
          0.00025676008526,
          0.06837138522391,
          76.39830376
        ],
        [
          0.00046174419456,
          0.04796166961432,
          89.45533503
        ],
        [
          0.00026173491818,
          0.06825956037975,
          76.22000843
        ],
        [
          0.00035372036349,
          0.05825728067141,
          81.47181212
        ],
        [
          0.00025635782505,
          0.06819395595141,
          76.58204884
        ],
        [
          0.00041198160437,
          0.05149314858372,
          86.86959367
        ],
        [
          0.00026174187478,
          0.06825763045088,
          76.2213643
        ],
        [
          0.0004222855838,
          0.05284092570574,
          84.67508872
        ],
        [
          0.00025636364347,
          0.06819208707805,
          76.5834169
        ],
        [
          0.00045176668163,
          0.047212132543,
          91.00283582
        ],
        [
          0.00026202647507,
          0.06844541682644,
          76.03637251
        ],
        [
          0.00038090045744,
          0.05701039358683,
          81.59092453
        ],
        [
          0.00025675360227,
          0.0683732958086,
          76.39694273
        ],
        [
          0.00044204222844,
          0.05027879056299,
          87.11475304
        ],
        [
          0.00026203406441,
          0.06844344779569,
          76.03772112
        ],
        [
          0.0004527560254,
          0.0516432316342,
          84.86720799
        ],
        [
          0.00025676008526,
          0.06837138522391,
          76.39830376
        ],
        [
          0.00050427254691,
          0.04506803126021,
          91.91242927
        ],
        [
          0.00026173491818,
          0.06825956037975,
          76.22000843
        ],
        [
          0.00038933035843,
          0.05566275135179,
          82.75131008
        ],
        [
          0.00025635782505,
          0.06819395595141,
          76.58204884
        ],
        [
          0.00043675238953,
          0.04941091874358,
          88.53749543
        ],
        [
          0.00026174187478,
          0.06825763045088,
          76.2213643
        ],
        [
          0.00045255578236,
          0.05062372497341,
          86.19607355
        ],
        [
          0.00025636364347,
          0.06819208707805,
          76.5834169
        ],
        [
          0.00049110216826,
          0.0443465646979,
          93.63692175
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00031505672256,
          0.06228895291694,
          79.10783791
        ],
        [
          0.00025092844626,
          0.06905677968219,
          76.11464335
        ],
        [
          0.00030703627914,
          0.06231229413167,
          79.49504692
        ],
        [
          0.00025566547761,
          0.06914365601705,
          75.76803772
        ],
        [
          0.00040007420604,
          0.05593322474284,
          81.95517423
        ],
        [
          0.00025093544685,
          0.06905482642253,
          76.11598694
        ],
        [
          0.00038695286072,
          0.0560786571327,
          82.37715819
        ],
        [
          0.00025543043688,
          0.06895627058226,
          75.94805527
        ],
        [
          0.0003300892553,
          0.06055948670935,
          80.14166816
        ],
        [
          0.00025061186485,
          0.06887301017472,
          76.29748161
        ],
        [
          0.0003206378355,
          0.06063427260543,
          80.53845286
        ],
        [
          0.00025543784249,
          0.06895430172088,
          75.94939372
        ],
        [
          0.00040711648403,
          0.05465825798196,
          83.13349038
        ],
        [
          0.00025061826489,
          0.06887109544634,
          76.29883238
        ],
        [
          0.0003925196416,
          0.05485070642421,
          83.56395661
        ],
        [
          0.00025565750655,
          0.06914566064342,
          75.76670667
        ],
        [
          0.00031505672256,
          0.06228895291694,
          79.10783791
        ],
        [
          0.00025092844626,
          0.06905677968219,
          76.11464335
        ],
        [
          0.00030703627914,
          0.06231229413167,
          79.49504692
        ],
        [
          0.00025566547761,
          0.06914365601705,
          75.76803772
        ],
        [
          0.00040007420604,
          0.05593322474284,
          81.95517423
        ],
        [
          0.00025093544685,
          0.06905482642253,
          76.11598694
        ],
        [
          0.00040570670042,
          0.0551036892204,
          82.66950149
        ],
        [
          0.00025543043688,
          0.06895627058226,
          75.94805527
        ],
        [
          0.0003300892553,
          0.06055948670935,
          80.14166816
        ],
        [
          0.00025061186485,
          0.06887301017472,
          76.29748161
        ],
        [
          0.0003206378355,
          0.06063427260543,
          80.53845286
        ],
        [
          0.00025543784249,
          0.06895430172088,
          75.94939372
        ],
        [
          0.00040711648403,
          0.05465825798196,
          83.13349038
        ],
        [
          0.00025061826489,
          0.06887109544634,
          76.29883238
        ],
        [
          0.00041087110869,
          0.05389857312668,
          83.87985489
        ],
        [
          0.00026413495606,
          0.06836764919178,
          75.98974517
        ],
        [
          0.00034584722885,
          0.05967138496922,
          80.31361614
        ],
        [
          0.00025921675426,
          0.06828077649119,
          76.34166315
        ],
        [
          0.00042000227156,
          0.05229838179992,
          85.46090772
        ],
        [
          0.0002641426856,
          0.06836567607008,
          75.99109285
        ],
        [
          0.00042409315559,
          0.05384701148191,
          83.36088562
        ],
        [
          0.00025922340154,
          0.06827886046651,
          76.34302317
        ],
        [
          0.00046899087321,
          0.04779098370824,
          89.37992356
        ],
        [
          0.00026384952419,
          0.06818140524836,
          76.17330119
        ],
        [
          0.00035769628307,
          0.05814398741616,
          81.40681364
        ],
        [
          0.00025882825127,
          0.06810090496638,
          76.52668281
        ],
        [
          0.00041817931538,
          0.05133293295631,
          86.79318625
        ],
        [
          0.00026385662097,
          0.06817947094371,
          76.17465617
        ],
        [
          0.00042745335756,
          0.05271241763085,
          84.60775613
        ],
        [
          0.00025883423349,
          0.06809903031677,
          76.52804989
        ],
        [
          0.00045934068807,
          0.04702784890552,
          90.92874297
        ],
        [
          0.00026413495606,
          0.06836764919178,
          75.98974517
        ],
        [
          0.00038508865281,
          0.0568998413833,
          81.52532213
        ],
        [
          0.00025921675426,
          0.06828077649119,
          76.34166315
        ],
        [
          0.00044856017295,
          0.05012184205204,
          87.03760343
        ],
        [
          0.0002641426856,
          0.06836567607008,
          75.99109285
        ],
        [
          0.00045817981517,
          0.05151758856916,
          84.7992551
        ],
        [
          0.00025922340154,
          0.06827886046651,
          76.34302317
        ],
        [
          0.00051253972442,
          0.04488754768874,
          91.83757402
        ],
        [
          0.00026384952419,
          0.06818140524836,
          76.17330119
        ],
        [
          0.00039385225955,
          0.05554400008463,
          82.68435659
        ],
        [
          0.00025882825127,
          0.06810090496638,
          76.52668281
        ],
        [
          0.00044360411085,
          0.04924191356463,
          88.46057581
        ],
        [
          0.00026385662097,
          0.06817947094371,
          76.17465617
        ],
        [
          0.00045831029599,
          0.05048854243067,
          86.1275289
        ],
        [
          0.00025883423349,
          0.06809903031677,
          76.52804989
        ],
        [
          0.00049972825896,
          0.04415122451139,
          93.56469586
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.0003184699126,
          0.06218314881426,
          79.04327886
        ],
        [
          0.00025341196453,
          0.06896098821019,
          76.05828248
        ],
        [
          0.00031092009397,
          0.06218843075435,
          79.42092135
        ],
        [
          0.00025777621399,
          0.0690635301389,
          75.720828
        ],
        [
          0.00040470560401,
          0.0558152653742,
          81.8868494
        ],
        [
          0.00025341912526,
          0.06895903011758,
          76.05962497
        ],
        [
          0.00039220509972,
          0.0559399482082,
          82.29897476
        ],
        [
          0.00025756687215,
          0.06887505693446,
          75.90030321
        ],
        [
          0.00033385679089,
          0.0604461801284,
          80.0748753
        ],
        [
          0.0002531221934,
          0.06877598554479,
          76.24056903
        ],
        [
          0.00032490658739,
          0.06050174437451,
          80.46205269
        ],
        [
          0.00025757441441,
          0.06887308419007,
          75.90164071
        ],
        [
          0.00041212590237,
          0.05453088992645,
          83.06347442
        ],
        [
          0.00025312875499,
          0.06877406558409,
          76.24191873
        ],
        [
          0.00039817292693,
          0.05470126941807,
          83.48416052
        ],
        [
          0.00025776810799,
          0.06906553831588,
          75.71949794
        ],
        [
          0.0003184699126,
          0.06218314881426,
          79.04327886
        ],
        [
          0.00025341196453,
          0.06896098821019,
          76.05828248
        ],
        [
          0.00031092009397,
          0.06218843075435,
          79.42092135
        ],
        [
          0.00025777621399,
          0.0690635301389,
          75.720828
        ],
        [
          0.00040470560401,
          0.0558152653742,
          81.8868494
        ],
        [
          0.00025341912526,
          0.06895903011758,
          76.05962497
        ],
        [
          0.00041119279591,
          0.05496533265162,
          82.5905624
        ],
        [
          0.00025756687215,
          0.06887505693446,
          75.90030321
        ],
        [
          0.00033385679089,
          0.0604461801284,
          80.0748753
        ],
        [
          0.0002531221934,
          0.06877598554479,
          76.24056903
        ],
        [
          0.00032490658739,
          0.06050174437451,
          80.46205269
        ],
        [
          0.00025757441441,
          0.06887308419007,
          75.90164071
        ],
        [
          0.00041212590237,
          0.05453088992645,
          83.06347442
        ],
        [
          0.00025312875499,
          0.06877406558409,
          76.24191873
        ],
        [
          0.00041677008557,
          0.05374940021471,
          83.79934675
        ],
        [
          0.00026630966825,
          0.06828802556313,
          75.94197375
        ],
        [
          0.00034977886881,
          0.05955877427356,
          80.24580612
        ],
        [
          0.00026177656348,
          0.06818546971089,
          76.28466928
        ],
        [
          0.00042632903303,
          0.05214005487565,
          85.37949812
        ],
        [
          0.0002663175423,
          0.06828604829805,
          75.94332048
        ],
        [
          0.00042930464767,
          0.05371987628475,
          83.28987959
        ],
        [
          0.00026178338145,
          0.06818354814623,
          76.28602823
        ],
        [
          0.00047680894089,
          0.04760971659565,
          89.29917671
        ],
        [
          0.00026605164623,
          0.06810061841162,
          76.12498594
        ],
        [
          0.00036200085906,
          0.05802271199294,
          81.33695873
        ],
        [
          0.00026141645723,
          0.0680042829255,
          76.46913742
        ],
        [
          0.00042489638316,
          0.05116190506537,
          86.71105019
        ],
        [
          0.00026605888894,
          0.06809867962889,
          76.12634
        ],
        [
          0.00043304772555,
          0.05257502071299,
          84.53536587
        ],
        [
          0.00026142261099,
          0.06800240234794,
          76.47050347
        ],
        [
          0.00046755509885,
          0.04683131176347,
          90.84900431
        ],
        [
          0.00026630966825,
          0.06828802556313,
          75.94197375
        ],
        [
          0.00038958249274,
          0.0567825612066,
          81.45538841
        ],
        [
          0.00026177656348,
          0.06818546971089,
          76.28466928
        ],
        [
          0.00045557242576,
          0.04995547835247,
          86.95524353
        ],
        [
          0.0002663175423,
          0.06828604829805,
          75.94332048
        ],
        [
          0.00046400243591,
          0.05138433626807,
          84.72678089
        ],
        [
          0.00026178338145,
          0.06818354814623,
          76.28602823
        ],
        [
          0.00052143871406,
          0.04469642768051,
          91.75755522
        ],
        [
          0.00026605164623,
          0.06810061841162,
          76.12498594
        ],
        [
          0.00039873402247,
          0.0554172917479,
          82.6125954
        ],
        [
          0.00026141645723,
          0.0680042829255,
          76.46913742
        ],
        [
          0.00045101393474,
          0.04906200019268,
          88.3780533
        ],
        [
          0.00026605888894,
          0.06809867962889,
          76.12634
        ],
        [
          0.00046452542605,
          0.05034438826573,
          86.05402174
        ],
        [
          0.00026142261099,
          0.06800240234794,
          76.47050347
        ],
        [
          0.00050906285421,
          0.04394351055056,
          93.48708201
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00032202011705,
          0.06207425680629,
          78.97663691
        ],
        [
          0.00025588179823,
          0.06886656144988,
          76.00268639
        ],
        [
          0.00031497572187,
          0.0620606771341,
          79.34420003
        ],
        [
          0.00025984573208,
          0.06898554013974,
          75.67485294
        ],
        [
          0.00040951537999,
          0.05569416631648,
          81.81638713
        ],
        [
          0.00025588911812,
          0.06886459865379,
          76.00402778
        ],
        [
          0.00039768160416,
          0.05579726469921,
          82.21810681
        ],
        [
          0.00025966781676,
          0.06879578339705,
          75.85366443
        ],
        [
          0.00033780903569,
          0.06032865422732,
          80.00534304
        ],
        [
          0.0002556245466,
          0.06868013584183,
          76.18429753
        ],
        [
          0.00032939727586,
          0.06036415015808,
          80.38239435
        ],
        [
          0.00025967549329,
          0.0687938069066,
          75.85500099
        ],
        [
          0.00041737363628,
          0.05439909553134,
          82.99064874
        ],
        [
          0.00025563126907,
          0.06867821078151,
          76.18564617
        ],
        [
          0.00040411341238,
          0.05454648212136,
          83.40100925
        ],
        [
          0.0002598374939,
          0.06898755173102,
          75.67352383
        ],
        [
          0.00032202011705,
          0.06207425680629,
          78.97663691
        ],
        [
          0.00025588179823,
          0.06886656144988,
          76.00268639
        ],
        [
          0.00031497572187,
          0.0620606771341,
          79.34420003
        ],
        [
          0.00025984573208,
          0.06898554013974,
          75.67485294
        ],
        [
          0.00040951537999,
          0.05569416631648,
          81.81638713
        ],
        [
          0.00025588911812,
          0.06886459865379,
          76.00402778
        ],
        [
          0.00041691257258,
          0.05482301824533,
          82.50890999
        ],
        [
          0.00025966781676,
          0.06879578339705,
          75.85366443
        ],
        [
          0.00033780903569,
          0.06032865422732,
          80.00534304
        ],
        [
          0.0002556245466,
          0.06868013584183,
          76.18429753
        ],
        [
          0.00032939727586,
          0.06036415015808,
          80.38239435
        ],
        [
          0.00025967549329,
          0.0687938069066,
          75.85500099
        ],
        [
          0.00041737363628,
          0.05439909553134,
          82.99064874
        ],
        [
          0.00025563126907,
          0.06867821078151,
          76.18564617
        ],
        [
          0.00042296784077,
          0.05359490513818,
          83.71544913
        ],
        [
          0.0002684535431,
          0.06821010555965,
          75.89519332
        ],
        [
          0.00035389288076,
          0.05944226413336,
          80.17537921
        ],
        [
          0.00026433356855,
          0.06809110979416,
          76.22819203
        ],
        [
          0.00043300138159,
          0.05197557020656,
          85.29435018
        ],
        [
          0.00026846155953,
          0.06820812428232,
          75.89653911
        ],
        [
          0.00043475072382,
          0.05358864315206,
          83.21619446
        ],
        [
          0.00026434055697,
          0.06808918280837,
          76.22954992
        ],
        [
          0.00048504959152,
          0.04742178215184,
          89.21473121
        ],
        [
          0.00026822882901,
          0.06802134198696,
          76.07753867
        ],
        [
          0.00036654232794,
          0.05789628870008,
          81.26382548
        ],
        [
          0.00026400784487,
          0.06790841290352,
          76.41198414
        ],
        [
          0.00043203291863,
          0.05098308445663,
          86.62453154
        ],
        [
          0.00026823621595,
          0.06801939885407,
          76.07889181
        ],
        [
          0.00043894343389,
          0.05243210925198,
          84.45962661
        ],
        [
          0.00026401417044,
          0.06790652650574,
          76.41334916
        ],
        [
          0.00047627915387,
          0.04662624462352,
          90.76500104
        ],
        [
          0.0002684535431,
          0.06821010555965,
          75.89519332
        ],
        [
          0.00039425448257,
          0.05666203485937,
          81.38321198
        ],
        [
          0.00026433356855,
          0.06809110979416,
          76.22819203
        ],
        [
          0.0004629263208,
          0.04978369697355,
          86.86956478
        ],
        [
          0.00026846155953,
          0.06820812428232,
          75.89653911
        ],
        [
          0.00047004727864,
          0.05124774063836,
          84.65205007
        ],
        [
          0.00026434055697,
          0.06808918280837,
          76.22954992
        ],
        [
          0.00053076596128,
          0.04449950793425,
          91.67428616
        ],
        [
          0.00026822882901,
          0.06802134198696,
          76.07753867
        ],
        [
          0.00040385089847,
          0.05528611788189,
          82.53793184
        ],
        [
          0.00026400784487,
          0.06790841290352,
          76.41198414
        ],
        [
          0.0004588436387,
          0.04887501683932,
          88.29158066
        ],
        [
          0.00026823621595,
          0.06801939885407,
          76.07889181
        ],
        [
          0.00047103390369,
          0.05019545404112,
          85.97759006
        ],
        [
          0.00026401417044,
          0.06790652650574,
          76.41334916
        ],
        [
          0.00051892399522,
          0.04372806807646,
          93.40569919
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00032579113718,
          0.06195985791172,
          78.90640747
        ],
        [
          0.00025839978103,
          0.06877113750866,
          75.94646375
        ],
        [
          0.00031924558092,
          0.06192788750603,
          79.26416111
        ],
        [
          0.00026196953388,
          0.06890608369984,
          75.62798866
        ],
        [
          0.00041462970525,
          0.05556693707515,
          81.74199801
        ],
        [
          0.00025840726303,
          0.06876917002255,
          75.94780403
        ],
        [
          0.0004034528829,
          0.05564899080205,
          82.13359637
        ],
        [
          0.00026184166823,
          0.06871436645389,
          75.80573572
        ],
        [
          0.0003419981841,
          0.06020554265215,
          79.93222854
        ],
        [
          0.00025819356089,
          0.06858261335871,
          76.12699847
        ],
        [
          0.00033411794415,
          0.06022147263253,
          80.29942636
        ],
        [
          0.00026184948361,
          0.06871238615679,
          75.80707131
        ],
        [
          0.00042294295725,
          0.05426100741934,
          82.91393037
        ],
        [
          0.00025820044845,
          0.06858068317431,
          76.12834601
        ],
        [
          0.00041036551892,
          0.05438598510068,
          83.31424906
        ],
        [
          0.00026196116015,
          0.06890809872939,
          75.62666053
        ],
        [
          0.00032579113718,
          0.06195985791172,
          78.90640747
        ],
        [
          0.00025839978103,
          0.06877113750866,
          75.94646375
        ],
        [
          0.00031924558092,
          0.06192788750603,
          79.26416111
        ],
        [
          0.00026196953388,
          0.06890608369984,
          75.62798866
        ],
        [
          0.00041462970525,
          0.05556693707515,
          81.74199801
        ],
        [
          0.00025840726303,
          0.06876917002255,
          75.94780403
        ],
        [
          0.00042293923717,
          0.05467514861394,
          82.42357599
        ],
        [
          0.00026184166823,
          0.06871436645389,
          75.80573572
        ],
        [
          0.0003419981841,
          0.06020554265215,
          79.93222854
        ],
        [
          0.00025819356089,
          0.06858261335871,
          76.12699847
        ],
        [
          0.00033411794415,
          0.06022147263253,
          80.29942636
        ],
        [
          0.00026184948361,
          0.06871238615679,
          75.80707131
        ],
        [
          0.00042294295725,
          0.05426100741934,
          82.91393037
        ],
        [
          0.00025820044845,
          0.06858068317431,
          76.12834601
        ],
        [
          0.00042948971917,
          0.05343473118283,
          83.62790546
        ],
        [
          0.00027064919664,
          0.06813088604567,
          75.8476006
        ],
        [
          0.00035826837943,
          0.05931979817401,
          80.10105939
        ],
        [
          0.00026693607248,
          0.06799591974682,
          76.17116705
        ],
        [
          0.00044003737774,
          0.05180480771257,
          85.20532778
        ],
        [
          0.00027065735878,
          0.06812890073455,
          75.84894543
        ],
        [
          0.00044055047926,
          0.05345066850815,
          83.13829209
        ],
        [
          0.0002669432343,
          0.06799398735804,
          76.17252386
        ],
        [
          0.00049375469213,
          0.04722663005278,
          89.12624563
        ],
        [
          0.00027047693108,
          0.06794009502432,
          76.02887516
        ],
        [
          0.00037136296652,
          0.05776377248222,
          81.18681243
        ],
        [
          0.00026666376616,
          0.0678110428109,
          76.35387888
        ],
        [
          0.0004395503747,
          0.05079783367347,
          86.53420217
        ],
        [
          0.00027048446687,
          0.06793814747988,
          76.03022735
        ],
        [
          0.00044521068497,
          0.05228225866945,
          84.37971868
        ],
        [
          0.0002666702678,
          0.06780915056908,
          76.35524284
        ],
        [
          0.00048548616837,
          0.04641377301495,
          90.67708433
        ],
        [
          0.00027064919664,
          0.06813088604567,
          75.8476006
        ],
        [
          0.00039927573505,
          0.05653406138862,
          81.306223
        ],
        [
          0.00026693607248,
          0.06799591974682,
          76.17116705
        ],
        [
          0.00047075460283,
          0.04960376409593,
          86.77911721
        ],
        [
          0.00027065735878,
          0.06812890073455,
          75.84894543
        ],
        [
          0.00047655406283,
          0.05110263983763,
          84.57217486
        ],
        [
          0.0002669432343,
          0.06799398735804,
          76.17252386
        ],
        [
          0.00054071193232,
          0.04429322545473,
          91.58614846
        ],
        [
          0.00027047693108,
          0.06794009502432,
          76.02887516
        ],
        [
          0.00040933914376,
          0.05514723665983,
          82.45846864
        ],
        [
          0.00026666376616,
          0.0678110428109,
          76.35387888
        ],
        [
          0.00046716833645,
          0.04867961740051,
          88.20043418
        ],
        [
          0.00027048446687,
          0.06793814747988,
          76.03022735
        ],
        [
          0.00047802618191,
          0.05003769009166,
          85.89608722
        ],
        [
          0.0002666702678,
          0.06780915056908,
          76.35524284
        ],
        [
          0.00052942460164,
          0.04350302778884,
          93.31964587
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00032986854939,
          0.06183759857611,
          78.83110436
        ],
        [
          0.00026103150253,
          0.06867229704041,
          75.88818532
        ],
        [
          0.00032380915819,
          0.06178785500859,
          79.17942925
        ],
        [
          0.00026421855098,
          0.06882257266257,
          75.57870536
        ],
        [
          0.00042015868877,
          0.05543112259522,
          81.66219483
        ],
        [
          0.00026103915384,
          0.06867032476176,
          75.88952443
        ],
        [
          0.00040961993896,
          0.05549285188139,
          82.04407605
        ],
        [
          0.00026414038622,
          0.06862893462028,
          75.75541142
        ],
        [
          0.00034654286234,
          0.06007364006375,
          79.85357514
        ],
        [
          0.00026087609164,
          0.06848171614122,
          76.06766723
        ],
        [
          0.00033918038942,
          0.06007063953466,
          80.21130585
        ],
        [
          0.00026414834827,
          0.06862695037991,
          75.75674599
        ],
        [
          0.00042898480905,
          0.05411322564712,
          82.83135102
        ],
        [
          0.00026088315149,
          0.06847978072387,
          76.06901363
        ],
        [
          0.00041707104063,
          0.05421651267592,
          83.22203272
        ],
        [
          0.00026421003391,
          0.06882459125848,
          75.57737827
        ],
        [
          0.00032986854939,
          0.06183759857611,
          78.83110436
        ],
        [
          0.00026103150253,
          0.06867229704041,
          75.88818532
        ],
        [
          0.00032380915819,
          0.06178785500859,
          79.17942925
        ],
        [
          0.00026421855098,
          0.06882257266257,
          75.57870536
        ],
        [
          0.00042015868877,
          0.05543112259522,
          81.66219483
        ],
        [
          0.00026103915384,
          0.06867032476176,
          75.88952443
        ],
        [
          0.00042937820295,
          0.05451945607042,
          82.33317681
        ],
        [
          0.00026414038622,
          0.06862893462028,
          75.75541142
        ],
        [
          0.00034654286234,
          0.06007364006375,
          79.85357514
        ],
        [
          0.00026087609164,
          0.06848171614122,
          76.06766723
        ],
        [
          0.00033918038942,
          0.06007063953466,
          80.21130585
        ],
        [
          0.00026414834827,
          0.06862695037991,
          75.75674599
        ],
        [
          0.00042898480905,
          0.05411322564712,
          82.83135102
        ],
        [
          0.00026088315149,
          0.06847978072387,
          76.06901363
        ],
        [
          0.00043648311602,
          0.05326563110486,
          83.53485442
        ],
        [
          0.00027298019693,
          0.06804741833076,
          75.79742007
        ],
        [
          0.00036300480369,
          0.05918887569341,
          80.02127037
        ],
        [
          0.00026966211491,
          0.06789711256003,
          76.11192021
        ],
        [
          0.00044761083318,
          0.05162398686283,
          85.11035876
        ],
        [
          0.0002729885136,
          0.06804542881903,
          75.79876388
        ],
        [
          0.0004468293303,
          0.05330331242282,
          83.05460123
        ],
        [
          0.00026966945829,
          0.06789517463004,
          76.11327588
        ],
        [
          0.00050313120363,
          0.04702017101616,
          89.03173543
        ],
        [
          0.00027286017635,
          0.06785462965931,
          75.97764782
        ],
        [
          0.00037659875833,
          0.05762175184118,
          81.10386921
        ],
        [
          0.00026944305977,
          0.06771009350076,
          76.29357538
        ],
        [
          0.00044767058946,
          0.05060119919798,
          86.43753189
        ],
        [
          0.00027286786998,
          0.06785267751634,
          75.97899901
        ],
        [
          0.00045201922286,
          0.05212181340353,
          84.29359723
        ],
        [
          0.00026944974565,
          0.06770819526905,
          76.29493823
        ],
        [
          0.00049543968426,
          0.04618846588513,
          90.58286074
        ],
        [
          0.00027298019693,
          0.06804741833076,
          75.79742007
        ],
        [
          0.0004046914554,
          0.05639781085445,
          81.2238412
        ],
        [
          0.00026966211491,
          0.06789711256003,
          76.11192021
        ],
        [
          0.00047915715473,
          0.04941388472712,
          86.68287858
        ],
        [
          0.0002729885136,
          0.06804542881903,
          75.79876388
        ],
        [
          0.00048357391121,
          0.05094828582162,
          84.48664402
        ],
        [
          0.00026966945829,
          0.06789517463004,
          76.11327588
        ],
        [
          0.00055139447034,
          0.04407576767218,
          91.49221082
        ],
        [
          0.00027286017635,
          0.06785462965931,
          75.97764782
        ],
        [
          0.00041527913963,
          0.05499899077788,
          82.37316026
        ],
        [
          0.00026944305977,
          0.06771009350076,
          76.29357538
        ],
        [
          0.0004761361975,
          0.04847291161233,
          88.10313059
        ],
        [
          0.00027286786998,
          0.06785267751634,
          75.97899901
        ],
        [
          0.00048559641571,
          0.04986944913608,
          85.80851441
        ],
        [
          0.00026944974565,
          0.06770819526905,
          76.29493823
        ],
        [
          0.00054074645941,
          0.04326520875456,
          93.22759644
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00033427847293,
          0.06170700639518,
          78.75038338
        ],
        [
          0.00026377520334,
          0.06857020549915,
          75.8279431
        ],
        [
          0.00032876973026,
          0.06163779184439,
          79.08825955
        ],
        [
          0.00026653060507,
          0.06873738597901,
          75.52840336
        ],
        [
          0.00042613547132,
          0.05528631056421,
          81.57659575
        ],
        [
          0.00026378303107,
          0.0685682283346,
          75.829281
        ],
        [
          0.00041632187207,
          0.05532579093936,
          81.94768523
        ],
        [
          0.00026652143099,
          0.06854114880187,
          75.70366553
        ],
        [
          0.00035146541752,
          0.05993266660691,
          79.7691456
        ],
        [
          0.00026369005322,
          0.06837688180308,
          76.0059665
        ],
        [
          0.00034469026285,
          0.05990895916837,
          80.11637401
        ],
        [
          0.0002665295448,
          0.06853916056195,
          75.70499904
        ],
        [
          0.00043552879607,
          0.05395547099879,
          82.74265073
        ],
        [
          0.00026369729366,
          0.06837494102216,
          76.0073117
        ],
        [
          0.00042436901676,
          0.05403510480625,
          83.12262025
        ],
        [
          0.00026652194078,
          0.06873940816541,
          75.52707733
        ],
        [
          0.00033427847293,
          0.06170700639518,
          78.75038338
        ],
        [
          0.00026377520334,
          0.06857020549915,
          75.8279431
        ],
        [
          0.00032876973026,
          0.06163779184439,
          79.08825955
        ],
        [
          0.00026653060507,
          0.06873738597901,
          75.52840336
        ],
        [
          0.00042613547132,
          0.05528631056421,
          81.57659575
        ],
        [
          0.00026378303107,
          0.0685682283346,
          75.829281
        ],
        [
          0.00043637410972,
          0.05435290201284,
          82.23584085
        ],
        [
          0.00026652143099,
          0.06854114880187,
          75.70366553
        ],
        [
          0.00035146541752,
          0.05993266660691,
          79.7691456
        ],
        [
          0.00026369005322,
          0.06837688180308,
          76.0059665
        ],
        [
          0.00034469026285,
          0.05990895916837,
          80.11637401
        ],
        [
          0.0002665295448,
          0.06853916056195,
          75.70499904
        ],
        [
          0.00043552879607,
          0.05395547099879,
          82.74265073
        ],
        [
          0.00026369729366,
          0.06837494102216,
          76.0073117
        ],
        [
          0.00044409352254,
          0.0530846350487,
          83.4345324
        ],
        [
          0.00027537280766,
          0.06796241411393,
          75.74627756
        ],
        [
          0.00036814461237,
          0.05904868916474,
          79.93544559
        ],
        [
          0.00027250006201,
          0.06779521078147,
          76.05075812
        ],
        [
          0.0004558326451,
          0.05143107504835,
          85.00823096
        ],
        [
          0.00027538128289,
          0.06796042037012,
          75.74762033
        ],
        [
          0.00045364249877,
          0.0531457270304,
          82.96452514
        ],
        [
          0.00027250759432,
          0.06779326720871,
          76.0521126
        ],
        [
          0.00051331750449,
          0.04680012334636,
          88.92997152
        ],
        [
          0.00027532477544,
          0.06776696119557,
          75.92505165
        ],
        [
          0.00038228898961,
          0.05746959604589,
          81.01453575
        ],
        [
          0.00027235427654,
          0.0676053675189,
          76.23094769
        ],
        [
          0.00045650262398,
          0.05039126591853,
          86.33342769
        ],
        [
          0.00027533263205,
          0.06776500439773,
          75.92640181
        ],
        [
          0.00045942026487,
          0.05195009746567,
          84.20077195
        ],
        [
          0.00027236115533,
          0.06760346315146,
          76.23230938
        ],
        [
          0.00050627372568,
          0.04594821074332,
          90.48123581
        ],
        [
          0.00027537280766,
          0.06796241411393,
          75.74627756
        ],
        [
          0.00041060120932,
          0.05625117858135,
          81.13470325
        ],
        [
          0.00027250006201,
          0.06779521078147,
          76.05075812
        ],
        [
          0.00048832682687,
          0.04921038200511,
          86.57881945
        ],
        [
          0.00027538128289,
          0.06796042037012,
          75.74762033
        ],
        [
          0.00049123600722,
          0.05078232871398,
          84.39402945
        ],
        [
          0.00027250759432,
          0.06779326720871,
          76.0521126
        ],
        [
          0.00056305977124,
          0.0438429730614,
          91.39046045
        ],
        [
          0.00027532477544,
          0.06776696119557,
          75.92505165
        ],
        [
          0.00042177024271,
          0.05483937430345,
          82.28074847
        ],
        [
          0.00027235427654,
          0.0676053675189,
          76.23094769
        ],
        [
          0.00048594021707,
          0.04825126097942,
          87.99777501
        ],
        [
          0.00027533263205,
          0.06776500439773,
          75.92640181
        ],
        [
          0.00049387226938,
          0.04968846932778,
          85.71356784
        ],
        [
          0.00027236115533,
          0.06760346315146,
          76.23230938
        ],
        [
          0.00055313289422,
          0.04301053295463,
          93.12771681
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.0003385698271,
          0.06158151857821,
          78.67253744
        ],
        [
          0.00026633294197,
          0.06847589489813,
          75.77224883
        ],
        [
          0.00033359593315,
          0.061493890486,
          79.00046044
        ],
        [
          0.00026867120246,
          0.06865910837187,
          75.48215389
        ],
        [
          0.00043194894555,
          0.05514736519461,
          81.49402316
        ],
        [
          0.00026634093391,
          0.06847391329011,
          75.7735856
        ],
        [
          0.00042283921043,
          0.05516586913475,
          81.8548183
        ],
        [
          0.00026870580876,
          0.06846123538767,
          75.65652861
        ],
        [
          0.00035624249425,
          0.05979769509202,
          79.68795254
        ],
        [
          0.00026629309688,
          0.0682808052338,
          75.94937054
        ],
        [
          0.00035003864016,
          0.05975441812879,
          80.02517338
        ],
        [
          0.00026871406173,
          0.06845924354788,
          75.65786115
        ],
        [
          0.00044187773135,
          0.0538046490046,
          82.65731269
        ],
        [
          0.00026630050431,
          0.06827885960131,
          75.95071463
        ],
        [
          0.00043145190153,
          0.05386197242263,
          83.02706008
        ],
        [
          0.00026866240198,
          0.06866113381822,
          75.48082885
        ],
        [
          0.0003385698271,
          0.06158151857821,
          78.67253744
        ],
        [
          0.00026633294197,
          0.06847589489813,
          75.77224883
        ],
        [
          0.00033359593315,
          0.061493890486,
          79.00046044
        ],
        [
          0.00026867120246,
          0.06865910837187,
          75.48215389
        ],
        [
          0.00043194894555,
          0.05514736519461,
          81.49402316
        ],
        [
          0.00026634093391,
          0.06847391329011,
          75.7735856
        ],
        [
          0.00044317610497,
          0.05419349147768,
          82.14205538
        ],
        [
          0.00026870580876,
          0.06846123538767,
          75.65652861
        ],
        [
          0.00035624249425,
          0.05979769509202,
          79.68795254
        ],
        [
          0.00026629309688,
          0.0682808052338,
          75.94937054
        ],
        [
          0.00035003864016,
          0.05975441812879,
          80.02517338
        ],
        [
          0.00026871406173,
          0.06845924354788,
          75.65786115
        ],
        [
          0.00044187773135,
          0.0538046490046,
          82.65731269
        ],
        [
          0.00026630050431,
          0.06827885960131,
          75.95071463
        ],
        [
          0.00045147832357,
          0.05291192033109,
          83.33809213
        ],
        [
          0.0002776004765,
          0.06788387024311,
          75.69898697
        ],
        [
          0.00037316769959,
          0.05891353327637,
          79.85231527
        ],
        [
          0.00027515789478,
          0.06770064906053,
          75.99394642
        ],
        [
          0.00046392369207,
          0.05124455911822,
          84.90868394
        ],
        [
          0.00027760909921,
          0.06788187263648,
          75.70032876
        ],
        [
          0.00046029965787,
          0.05299400499781,
          82.877236
        ],
        [
          0.00027516560392,
          0.0676987003181,
          75.99529979
        ],
        [
          0.00052334685615,
          0.046587621378,
          88.83066778
        ],
        [
          0.00027759850334,
          0.06768671356386,
          75.8768677
        ],
        [
          0.00038783560565,
          0.05732341623184,
          80.92824691
        ],
        [
          0.00027505970343,
          0.06750895759773,
          76.17323081
        ],
        [
          0.00046517591232,
          0.05018897342647,
          86.23218934
        ],
        [
          0.00027760651027,
          0.06768475254975,
          75.8782169
        ],
        [
          0.00046663459942,
          0.05178533090089,
          84.11105927
        ],
        [
          0.00027506676147,
          0.06750704764866,
          76.17459141
        ],
        [
          0.00051692141245,
          0.04571694667722,
          90.38227147
        ],
        [
          0.0002776004765,
          0.06788387024311,
          75.69898697
        ],
        [
          0.00041638157408,
          0.05610976761946,
          81.04826448
        ],
        [
          0.00027515789478,
          0.06770064906053,
          75.99394642
        ],
        [
          0.00049736093554,
          0.04901353190978,
          86.47726725
        ],
        [
          0.00027760909921,
          0.06788187263648,
          75.70032876
        ],
        [
          0.00049873063225,
          0.0506224680648,
          84.30416791
        ],
        [
          0.00027516560392,
          0.0676987003181,
          75.99529979
        ],
        [
          0.00057455621218,
          0.04361813192571,
          91.29099855
        ],
        [
          0.00027759850334,
          0.06768671356386,
          75.8768677
        ],
        [
          0.00042810360245,
          0.05468596627153,
          82.19137829
        ],
        [
          0.00027505970343,
          0.06750895759773,
          76.17323081
        ],
        [
          0.00049557956727,
          0.04803757788946,
          87.89518722
        ],
        [
          0.00027760651027,
          0.06768475254975,
          75.8782169
        ],
        [
          0.0005019484806,
          0.04951472609771,
          85.62168325
        ],
        [
          0.00027506676147,
          0.06750704764866,
          76.17459141
        ],
        [
          0.00056531898153,
          0.04276535815087,
          93.03025421
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00034281980944,
          0.06145875042234,
          78.59611188
        ],
        [
          0.00026882391255,
          0.06838483063444,
          75.71843127
        ],
        [
          0.00033831147126,
          0.06135522686741,
          78.91551387
        ],
        [
          0.00027080185565,
          0.06858175098494,
          75.43642193
        ],
        [
          0.0004377111819,
          0.05501147022653,
          81.41281274
        ],
        [
          0.00026883206429,
          0.06838284479078,
          75.71976694
        ],
        [
          0.00042921191964,
          0.05501184335715,
          81.76481781
        ],
        [
          0.00027088938744,
          0.06838193647227,
          75.6097239
        ],
        [
          0.00036098034456,
          0.05966557098737,
          79.60812986
        ],
        [
          0.00026883838701,
          0.06818768121763,
          75.89446757
        ],
        [
          0.00035527348292,
          0.05960538037287,
          79.93678796
        ],
        [
          0.00027089777938,
          0.06837994110291,
          75.61105546
        ],
        [
          0.00044818105556,
          0.0536570230992,
          82.57326904
        ],
        [
          0.00026884595761,
          0.06818573094126,
          75.89581058
        ],
        [
          0.00043839143416,
          0.05369505274569,
          82.93428925
        ],
        [
          0.00027079291979,
          0.06858377961172,
          75.43509787
        ],
        [
          0.00034281980944,
          0.06145875042234,
          78.59611188
        ],
        [
          0.00026882391255,
          0.06838483063444,
          75.71843127
        ],
        [
          0.00033831147126,
          0.06135522686741,
          78.91551387
        ],
        [
          0.00027080185565,
          0.06858175098494,
          75.43642193
        ],
        [
          0.0004377111819,
          0.05501147022653,
          81.41281274
        ],
        [
          0.00026883206429,
          0.06838284479078,
          75.71976694
        ],
        [
          0.00044982593544,
          0.05403998057844,
          82.05116192
        ],
        [
          0.00027088938744,
          0.06838193647227,
          75.6097239
        ],
        [
          0.00036098034456,
          0.05966557098737,
          79.60812986
        ],
        [
          0.00026883838701,
          0.06818768121763,
          75.89446757
        ],
        [
          0.00035527348292,
          0.05960538037287,
          79.93678796
        ],
        [
          0.00027089777938,
          0.06837994110291,
          75.61105546
        ],
        [
          0.00044818105556,
          0.0536570230992,
          82.57326904
        ],
        [
          0.00026884595761,
          0.06818573094126,
          75.89581058
        ],
        [
          0.0004587124243,
          0.05274542611519,
          83.24446151
        ],
        [
          0.00027980985217,
          0.0678065343683,
          75.65239046
        ],
        [
          0.0003781373102,
          0.0587815659128,
          79.77077758
        ],
        [
          0.00027773913285,
          0.06760960323437,
          75.93919972
        ],
        [
          0.00047182378982,
          0.05106552258358,
          84.81237329
        ],
        [
          0.00027981862099,
          0.06780453300232,
          75.65373129
        ],
        [
          0.00046689316559,
          0.05284586859242,
          82.79146898
        ],
        [
          0.00027774701372,
          0.06760764956758,
          75.94055203
        ],
        [
          0.00053315594666,
          0.04638362403007,
          88.7343753
        ],
        [
          0.0002798632923,
          0.06760737431403,
          75.82919114
        ],
        [
          0.00039333186037,
          0.05718058529814,
          80.84349112
        ],
        [
          0.00027769766575,
          0.06741578300645,
          76.11739316
        ],
        [
          0.00047366112426,
          0.04999464856191,
          86.13405991
        ],
        [
          0.00027987144887,
          0.06760540917558,
          75.83053939
        ],
        [
          0.00047379240027,
          0.05162433211904,
          84.02278088
        ],
        [
          0.00027770489855,
          0.06741386772234,
          76.11875271
        ],
        [
          0.0005273583662,
          0.04549474755916,
          90.28611054
        ],
        [
          0.00027980985217,
          0.0678065343683,
          75.65239046
        ],
        [
          0.00042209643701,
          0.05597186114271,
          80.96351399
        ],
        [
          0.00027773913285,
          0.06760960323437,
          75.93919972
        ],
        [
          0.00050617923726,
          0.04882477275271,
          86.37900723
        ],
        [
          0.00027981862099,
          0.06780453300232,
          75.65373129
        ],
        [
          0.00050615001466,
          0.05046654707309,
          84.21589938
        ],
        [
          0.00027774701372,
          0.06760764956758,
          75.94055203
        ],
        [
          0.00058579756495,
          0.04340250949067,
          91.19449751
        ],
        [
          0.0002798632923,
          0.06760737431403,
          75.82919114
        ],
        [
          0.00043437573717,
          0.05453624350568,
          82.10362612
        ],
        [
          0.00027769766575,
          0.06741578300645,
          76.11739316
        ],
        [
          0.00050500988705,
          0.04783245785063,
          87.79573455
        ],
        [
          0.00027987144887,
          0.06760540917558,
          75.83053939
        ],
        [
          0.00050995795047,
          0.04934513135543,
          85.53128897
        ],
        [
          0.00027770489855,
          0.06741386772234,
          76.11875271
        ],
        [
          0.00057726191861,
          0.04253003989019,
          92.93547388
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00034714111898,
          0.06133651764215,
          78.51796115
        ],
        [
          0.00027130020878,
          0.06829594062549,
          75.66454586
        ],
        [
          0.0003431047127,
          0.06121737057785,
          78.82878602
        ],
        [
          0.00027291641793,
          0.06850627992522,
          75.39065286
        ],
        [
          0.00044357126171,
          0.05487607333398,
          81.32971422
        ],
        [
          0.00027130852146,
          0.06829395051593,
          75.66588041
        ],
        [
          0.0004356910976,
          0.05485863625105,
          81.67285279
        ],
        [
          0.00027306261811,
          0.06830435859276,
          75.56275833
        ],
        [
          0.00036582197139,
          0.05953336413514,
          79.52613744
        ],
        [
          0.00027137492092,
          0.06809656455083,
          75.83937178
        ],
        [
          0.00036061955229,
          0.05945653518755,
          79.84617032
        ],
        [
          0.00027307115014,
          0.06830235965322,
          75.5640889
        ],
        [
          0.0004546242935,
          0.05350922531005,
          82.48685996
        ],
        [
          0.00027138265636,
          0.06809460959133,
          75.84071369
        ],
        [
          0.00044548082606,
          0.05352828610225,
          82.83907067
        ],
        [
          0.00027290734605,
          0.0685083117649,
          75.38932979
        ],
        [
          0.00034714111898,
          0.06133651764215,
          78.51796115
        ],
        [
          0.00027130020878,
          0.06829594062549,
          75.66454586
        ],
        [
          0.0003431047127,
          0.06121737057785,
          78.82878602
        ],
        [
          0.00027291641793,
          0.06850627992522,
          75.39065286
        ],
        [
          0.00044357126171,
          0.05487607333398,
          81.32971422
        ],
        [
          0.00027130852146,
          0.06829395051593,
          75.66588041
        ],
        [
          0.00045658483221,
          0.05388734101615,
          81.95826937
        ],
        [
          0.00027306261811,
          0.06830435859276,
          75.56275833
        ],
        [
          0.00036582197139,
          0.05953336413514,
          79.52613744
        ],
        [
          0.00027137492092,
          0.06809656455083,
          75.83937178
        ],
        [
          0.00036061955229,
          0.05945653518755,
          79.84617032
        ],
        [
          0.00027307115014,
          0.06830235965322,
          75.5640889
        ],
        [
          0.0004546242935,
          0.05350922531005,
          82.48685996
        ],
        [
          0.00027138265636,
          0.06809460959133,
          75.84071369
        ],
        [
          0.00046610037063,
          0.05257914637343,
          83.14834435
        ],
        [
          0.00028199935625,
          0.06773120882163,
          75.60581632
        ],
        [
          0.00038320224262,
          0.05864989765859,
          79.68722025
        ],
        [
          0.00028030184157,
          0.06752086472444,
          75.88444339
        ],
        [
          0.00047997511804,
          0.05088497954251,
          84.71247206
        ],
        [
          0.00028200827182,
          0.0677292036674,
          75.60715617
        ],
        [
          0.00047361548545,
          0.05269797604615,
          82.7034856
        ],
        [
          0.0002803098953,
          0.06751890611213,
          75.8857946
        ],
        [
          0.00054328028803,
          0.04617804149336,
          88.63416428
        ],
        [
          0.00028211410971,
          0.06752988270051,
          75.78141212
        ],
        [
          0.00039896100594,
          0.05703739792212,
          80.75625258
        ],
        [
          0.00028032327426,
          0.06732474560745,
          76.0614204
        ],
        [
          0.00048245613181,
          0.04979791318377,
          86.03183584
        ],
        [
          0.00028212241708,
          0.06752791339975,
          75.7827594
        ],
        [
          0.00048112605128,
          0.05146287422542,
          83.93179319
        ],
        [
          0.00028033068359,
          0.06732282495326,
          76.06277887
        ],
        [
          0.00053817819967,
          0.04527006739599,
          90.18551321
        ],
        [
          0.00028199935625,
          0.06773120882163,
          75.60581632
        ],
        [
          0.00042794086962,
          0.05583380777917,
          80.8763361
        ],
        [
          0.00028030184157,
          0.06752086472444,
          75.88444339
        ],
        [
          0.0005153053367,
          0.04863394786016,
          86.27667054
        ],
        [
          0.00028200827182,
          0.0677292036674,
          75.60715617
        ],
        [
          0.00051374070238,
          0.05031038576942,
          84.12497078
        ],
        [
          0.0002803098953,
          0.06751890611213,
          75.8857946
        ],
        [
          0.00059743040101,
          0.04318483469181,
          91.09346
        ],
        [
          0.00028211410971,
          0.06752988270051,
          75.78141212
        ],
        [
          0.00044082089518,
          0.05438567072819,
          82.01296806
        ],
        [
          0.00028032327426,
          0.06732474560745,
          76.0614204
        ],
        [
          0.00051481072038,
          0.0476243869104,
          87.691689
        ],
        [
          0.00028212241708,
          0.06752791339975,
          75.7827594
        ],
        [
          0.0005181914959,
          0.04917455707246,
          85.43772493
        ],
        [
          0.00028033068359,
          0.06732282495326,
          76.06277887
        ],
        [
          0.00058967292066,
          0.04229176388266,
          92.83562948
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00035121572237,
          0.06122372285876,
          78.44375263
        ],
        [
          0.00027360029657,
          0.0682149315972,
          75.61405125
        ],
        [
          0.00034762847939,
          0.06109019584389,
          78.74644007
        ],
        [
          0.0002748751508,
          0.06843761295657,
          75.34783103
        ],
        [
          0.00044909847968,
          0.05475101288384,
          81.25074075
        ],
        [
          0.00027360876091,
          0.06821293745636,
          75.61538473
        ],
        [
          0.00044180875043,
          0.05471716099386,
          81.58545059
        ],
        [
          0.00027509347581,
          0.06823315846485,
          75.51843974
        ],
        [
          0.00037038993907,
          0.0594112961162,
          79.44826561
        ],
        [
          0.0002737487727,
          0.06801290697303,
          75.78736554
        ],
        [
          0.00036566899855,
          0.05931911793689,
          79.76011296
        ],
        [
          0.00027510214061,
          0.06823115612255,
          75.51976937
        ],
        [
          0.00046070712317,
          0.05337260574707,
          82.40470324
        ],
        [
          0.00027375666482,
          0.06801094755733,
          75.78870639
        ],
        [
          0.00045218058876,
          0.053374198466,
          82.74852977
        ],
        [
          0.00027486595124,
          0.06843964783486,
          75.3465089
        ],
        [
          0.00035121572237,
          0.06122372285876,
          78.44375263
        ],
        [
          0.00027360029657,
          0.0682149315972,
          75.61405125
        ],
        [
          0.00034762847939,
          0.06109019584389,
          78.74644007
        ],
        [
          0.0002748751508,
          0.06843761295657,
          75.34783103
        ],
        [
          0.00044909847968,
          0.05475101288384,
          81.25074075
        ],
        [
          0.00027360876091,
          0.06821293745636,
          75.61538473
        ],
        [
          0.00046296454307,
          0.0537464426144,
          81.86997595
        ],
        [
          0.00027509347581,
          0.06823315846485,
          75.51843974
        ],
        [
          0.00037038993907,
          0.0594112961162,
          79.44826561
        ],
        [
          0.0002737487727,
          0.06801290697303,
          75.78736554
        ],
        [
          0.00036566899855,
          0.05931911793689,
          79.76011296
        ],
        [
          0.00027510214061,
          0.06823115612255,
          75.51976937
        ],
        [
          0.00046070712317,
          0.05337260574707,
          82.40470324
        ],
        [
          0.00027375666482,
          0.06801094755733,
          75.78870639
        ],
        [
          0.00047308022589,
          0.05242556287847,
          83.05693048
        ],
        [
          0.00028404117703,
          0.06766222829666,
          75.56194099
        ],
        [
          0.00038801911743,
          0.05852739521839,
          79.60719685
        ],
        [
          0.00028269577686,
          0.06743954915339,
          75.8328319
        ],
        [
          0.00048782137747,
          0.05071520069939,
          84.61566394
        ],
        [
          0.00028405023144,
          0.06766021953909,
          75.56327991
        ],
        [
          0.00048001255002,
          0.052560218167,
          82.61912392
        ],
        [
          0.00028270399457,
          0.06743758584738,
          75.83418206
        ],
        [
          0.00055303041786,
          0.04598478058738,
          88.53671551
        ],
        [
          0.00028423106098,
          0.06745831757637,
          75.73602821
        ],
        [
          0.00040431760589,
          0.05690409965863,
          80.67270325
        ],
        [
          0.00028279402413,
          0.06724071647278,
          76.00828771
        ],
        [
          0.00049092571437,
          0.04961294305261,
          85.93273684
        ],
        [
          0.00028423951245,
          0.06745634428188,
          75.73737455
        ],
        [
          0.00048810875713,
          0.05131245106883,
          83.84452024
        ],
        [
          0.00028280160237,
          0.06723879068478,
          76.00964514
        ],
        [
          0.00054860292437,
          0.04505896776167,
          90.08755251
        ],
        [
          0.00028404117703,
          0.06766222829666,
          75.56194099
        ],
        [
          0.00043350683037,
          0.05570518582068,
          80.79270744
        ],
        [
          0.00028269577686,
          0.06743954915339,
          75.8328319
        ],
        [
          0.000524098245,
          0.04845443110265,
          86.17728114
        ],
        [
          0.00028405023144,
          0.06766021953909,
          75.56327991
        ],
        [
          0.00052097416873,
          0.05016476239114,
          84.03760259
        ],
        [
          0.00028270399457,
          0.06743758584738,
          75.83418206
        ],
        [
          0.00060864058562,
          0.04298025537175,
          90.99478945
        ],
        [
          0.00028423106098,
          0.06745831757637,
          75.73602821
        ],
        [
          0.00044696259059,
          0.05424532038121,
          81.92598663
        ],
        [
          0.00028279402413,
          0.06724071647278,
          76.00828771
        ],
        [
          0.00052425964269,
          0.04742865975817,
          87.59056701
        ],
        [
          0.00028423951245,
          0.06745634428188,
          75.73737455
        ],
        [
          0.0005260416773,
          0.04901548714616,
          85.3477758
        ],
        [
          0.00028280160237,
          0.06723879068478,
          76.00964514
        ],
        [
          0.00060163779254,
          0.04206799156013,
          92.73788912
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00035535945164,
          0.06111158705925,
          78.36759663
        ],
        [
          0.00027584194599,
          0.06813753481749,
          75.56431345
        ],
        [
          0.00035221227834,
          0.0609643283981,
          78.6623547
        ],
        [
          0.00027678636073,
          0.06837186439177,
          75.30555525
        ],
        [
          0.00045472838206,
          0.05462634008042,
          81.16956409
        ],
        [
          0.00027585056047,
          0.06813553666518,
          75.56564588
        ],
        [
          0.00044801603728,
          0.05457682970363,
          81.49605153
        ],
        [
          0.00027708054568,
          0.0681648031138,
          75.47457716
        ],
        [
          0.00037507983047,
          0.05928874056038,
          79.36765739
        ],
        [
          0.0002760680899,
          0.06793278871641,
          75.73602523
        ],
        [
          0.00037083048473,
          0.05918190794378,
          79.67151779
        ],
        [
          0.00027708934243,
          0.06816279736195,
          75.47590585
        ],
        [
          0.00046696007616,
          0.05323518617393,
          82.31949365
        ],
        [
          0.00027607613759,
          0.06793082486434,
          75.73736502
        ],
        [
          0.00045903872849,
          0.05322004201526,
          82.65513429
        ],
        [
          0.00027677703475,
          0.06837390231007,
          75.30423406
        ],
        [
          0.00035535945164,
          0.06111158705925,
          78.36759663
        ],
        [
          0.00027584194599,
          0.06813753481749,
          75.56431345
        ],
        [
          0.00035221227834,
          0.0609643283981,
          78.6623547
        ],
        [
          0.00027678636073,
          0.06837186439177,
          75.30555525
        ],
        [
          0.00045472838206,
          0.05462634008042,
          81.16956409
        ],
        [
          0.00027585056047,
          0.06813553666518,
          75.56564588
        ],
        [
          0.00046943559656,
          0.05360674272664,
          81.77965038
        ],
        [
          0.00027708054568,
          0.0681648031138,
          75.47457716
        ],
        [
          0.00037507983047,
          0.05928874056038,
          79.36765739
        ],
        [
          0.0002760680899,
          0.06793278871641,
          75.73602523
        ],
        [
          0.00037083048473,
          0.05918190794378,
          79.67151779
        ],
        [
          0.00027708934243,
          0.06816279736195,
          75.47590585
        ],
        [
          0.00046696007616,
          0.05323518617393,
          82.31949365
        ],
        [
          0.00027607613759,
          0.06793082486434,
          75.73736502
        ],
        [
          0.00048022249552,
          0.05227197669252,
          82.96262131
        ],
        [
          0.0002860338615,
          0.06759618413992,
          75.51861063
        ],
        [
          0.00039290525678,
          0.05840591780088,
          79.52532336
        ],
        [
          0.0002850293407,
          0.06736186347259,
          75.78197731
        ],
        [
          0.00049579599556,
          0.05054668480921,
          84.51646096
        ],
        [
          0.0002860430536,
          0.06759417178148,
          75.51994861
        ],
        [
          0.00048651148761,
          0.05242329528884,
          82.53263921
        ],
        [
          0.000285037721,
          0.0673598954996,
          75.78332642
        ],
        [
          0.00056295188244,
          0.04579285648824,
          88.4364258
        ],
        [
          0.00028630271472,
          0.06738961761977,
          75.69109823
        ],
        [
          0.00040980147845,
          0.05677068188937,
          80.58648743
        ],
        [
          0.00028520842189,
          0.06716024699475,
          75.95581998
        ],
        [
          0.00049960579204,
          0.04942792987013,
          85.83033444
        ],
        [
          0.00028631130946,
          0.06738764033596,
          75.69244364
        ],
        [
          0.00049526773014,
          0.05116161335204,
          83.75425293
        ],
        [
          0.00028521616811,
          0.06715831609805,
          75.95717637
        ],
        [
          0.0005592983326,
          0.0448478062305,
          89.98580544
        ],
        [
          0.0002860338615,
          0.06759618413992,
          75.51861063
        ],
        [
          0.00043914684654,
          0.05557776380737,
          80.70721688
        ],
        [
          0.0002850293407,
          0.06736186347259,
          75.78197731
        ],
        [
          0.00053302863881,
          0.04827643518484,
          86.07541672
        ],
        [
          0.0002860430536,
          0.06759417178148,
          75.51994861
        ],
        [
          0.00052831493788,
          0.05002020456578,
          83.94807041
        ],
        [
          0.000285037721,
          0.0673598954996,
          75.78332642
        ],
        [
          0.00062003155152,
          0.04277755430106,
          90.89301247
        ],
        [
          0.00028630271472,
          0.06738961761977,
          75.69109823
        ],
        [
          0.00045324296885,
          0.0541050099208,
          81.83630249
        ],
        [
          0.00028520842189,
          0.06716024699475,
          75.95581998
        ],
        [
          0.00053393325772,
          0.04723319955947,
          87.48603793
        ],
        [
          0.00028631130946,
          0.06738764033596,
          75.69244364
        ],
        [
          0.00053408034862,
          0.04885622384414,
          85.25476422
        ],
        [
          0.00028521616811,
          0.06715831609805,
          75.95717637
        ],
        [
          0.00061389438647,
          0.04184472583855,
          92.63604221
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00035934181488,
          0.06100632861765,
          78.29364464
        ],
        [
          0.00027801265491,
          0.06806415318281,
          75.51554916
        ],
        [
          0.00035664641584,
          0.06084552787162,
          78.58024738
        ],
        [
          0.00027862045573,
          0.0683100265585,
          75.26443569
        ],
        [
          0.00046018354897,
          0.05450820847695,
          81.0900721
        ],
        [
          0.00027802141731,
          0.06806215104878,
          75.51688052
        ],
        [
          0.00045406604491,
          0.05444323529566,
          81.40807196
        ],
        [
          0.00027899385092,
          0.06810030366486,
          75.4317831
        ],
        [
          0.00037959850015,
          0.05917338725625,
          79.28923315
        ],
        [
          0.00027832006604,
          0.06785662908239,
          75.68556894
        ],
        [
          0.00037583488922,
          0.05905208245955,
          79.58487037
        ],
        [
          0.00027900277691,
          0.06809829453925,
          75.43311084
        ],
        [
          0.00047303370152,
          0.05310465966433,
          82.23589921
        ],
        [
          0.00027832826758,
          0.06785466081945,
          75.68690767
        ],
        [
          0.00046573760185,
          0.05307298015111,
          82.5630799
        ],
        [
          0.00027861100644,
          0.06831206748044,
          75.26311542
        ],
        [
          0.00035934181488,
          0.06100632861765,
          78.29364464
        ],
        [
          0.00027801265491,
          0.06806415318281,
          75.51554916
        ],
        [
          0.00035664641584,
          0.06084552787162,
          78.58024738
        ],
        [
          0.00027862045573,
          0.0683100265585,
          75.26443569
        ],
        [
          0.00046018354897,
          0.05450820847695,
          81.0900721
        ],
        [
          0.00027802141731,
          0.06806215104878,
          75.51688052
        ],
        [
          0.0004757408225,
          0.05347379327178,
          81.69075223
        ],
        [
          0.00027899385092,
          0.06810030366486,
          75.4317831
        ],
        [
          0.00037959850015,
          0.05917338725625,
          79.28923315
        ],
        [
          0.00027832006604,
          0.06785662908239,
          75.68556894
        ],
        [
          0.00037583488922,
          0.05905208245955,
          79.58487037
        ],
        [
          0.00027900277691,
          0.06809829453925,
          75.43311084
        ],
        [
          0.00047303370152,
          0.05310465966433,
          82.23589921
        ],
        [
          0.00027832826758,
          0.06785466081945,
          75.68690767
        ],
        [
          0.00048719612489,
          0.05212553507564,
          82.86964754
        ],
        [
          0.00028795204944,
          0.06753389544343,
          75.47632967
        ],
        [
          0.00039767325342,
          0.05829015771192,
          79.44461784
        ],
        [
          0.0002872947067,
          0.06728804383139,
          75.73198693
        ],
        [
          0.00050366180912,
          0.05038447003057,
          84.41765944
        ],
        [
          0.00028796137645,
          0.06753187952184,
          75.47766672
        ],
        [
          0.00049290434243,
          0.05229162171028,
          82.4466819
        ],
        [
          0.0002873032479,
          0.06728607121418,
          75.73333499
        ],
        [
          0.00057280443488,
          0.0456069506142,
          88.33556125
        ],
        [
          0.00028830332857,
          0.06732462061242,
          75.6471287
        ],
        [
          0.0004151637425,
          0.05664326081006,
          80.50138621
        ],
        [
          0.00028755835123,
          0.06708358890222,
          75.90412566
        ],
        [
          0.00050818137521,
          0.04924965116885,
          85.72817921
        ],
        [
          0.00028831206426,
          0.06732263937399,
          75.64847317
        ],
        [
          0.00050232121432,
          0.05101637200199,
          83.6644048
        ],
        [
          0.00028756626423,
          0.06708165291759,
          75.905481
        ],
        [
          0.00056993320309,
          0.04464321435268,
          89.88322276
        ],
        [
          0.00028795204944,
          0.06753389544343,
          75.47632967
        ],
        [
          0.00044467641221,
          0.05545574876458,
          80.62253152
        ],
        [
          0.0002872947067,
          0.06728804383139,
          75.73198693
        ],
        [
          0.00054187229108,
          0.0481044782275,
          85.97344822
        ],
        [
          0.00028796137645,
          0.06753187952184,
          75.47766672
        ],
        [
          0.000535567825,
          0.04988060411579,
          83.85861774
        ],
        [
          0.0002873032479,
          0.06728607121418,
          75.73333499
        ],
        [
          0.00063137916824,
          0.04258077064677,
          90.789924
        ],
        [
          0.00028830332857,
          0.06732462061242,
          75.6471287
        ],
        [
          0.00045941196942,
          0.05397039308334,
          81.74734765
        ],
        [
          0.00028755835123,
          0.06708358890222,
          75.90412566
        ],
        [
          0.00054352741048,
          0.0470442257494,
          87.38120637
        ],
        [
          0.00028831206426,
          0.06732263937399,
          75.64847317
        ],
        [
          0.00054203475854,
          0.04870225437106,
          85.16169576
        ],
        [
          0.00028756626423,
          0.06708165291759,
          75.905481
        ],
        [
          0.0006261195361,
          0.04162795690677,
          92.53253321
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00036321682084,
          0.06090641192809,
          78.22078909
        ],
        [
          0.00028006841492,
          0.06799620284807,
          75.46869973
        ],
        [
          0.00036097379636,
          0.06073252524489,
          78.49920123
        ],
        [
          0.00028034217249,
          0.06825321432397,
          75.22523667
        ],
        [
          0.0004654811666,
          0.05439610815563,
          81.01192163
        ],
        [
          0.00028007732011,
          0.06799419683225,
          75.47003007
        ],
        [
          0.00045996061332,
          0.05431617821761,
          81.32138119
        ],
        [
          0.00028078157933,
          0.06804132458111,
          75.39118876
        ],
        [
          0.00038400041739,
          0.05906371314039,
          79.21194122
        ],
        [
          0.00028044406551,
          0.06778639820289,
          75.63730623
        ],
        [
          0.00038072448134,
          0.05892840046376,
          79.4993127
        ],
        [
          0.00028079062838,
          0.06803931220147,
          75.39251561
        ],
        [
          0.00047893959668,
          0.0529806204837,
          82.15365423
        ],
        [
          0.00028045241502,
          0.06778442566673,
          75.63864392
        ],
        [
          0.00047227195958,
          0.05293296604377,
          82.47229842
        ],
        [
          0.00028033260532,
          0.06825525816172,
          75.2239173
        ],
        [
          0.00036321682084,
          0.06090641192809,
          78.22078909
        ],
        [
          0.00028006841492,
          0.06799620284807,
          75.46869973
        ],
        [
          0.00036097379636,
          0.06073252524489,
          78.49920123
        ],
        [
          0.00028034217249,
          0.06825321432397,
          75.22523667
        ],
        [
          0.0004654811666,
          0.05439610815563,
          81.01192163
        ],
        [
          0.00028007732011,
          0.06799419683225,
          75.47003007
        ],
        [
          0.00048188208071,
          0.05334740453145,
          81.60314135
        ],
        [
          0.00028078157933,
          0.06804132458111,
          75.39118876
        ],
        [
          0.00038400041739,
          0.05906371314039,
          79.21194122
        ],
        [
          0.00028044406551,
          0.06778639820289,
          75.63730623
        ],
        [
          0.00038072448134,
          0.05892840046376,
          79.4993127
        ],
        [
          0.00028079062838,
          0.06803931220147,
          75.39251561
        ],
        [
          0.00047893959668,
          0.0529806204837,
          82.15365423
        ],
        [
          0.00028045241502,
          0.06778442566673,
          75.63864392
        ],
        [
          0.00049399692964,
          0.05198614699963,
          82.77794438
        ],
        [
          0.00028974779287,
          0.06747684399987,
          75.43612815
        ],
        [
          0.00040231232795,
          0.05818028099034,
          79.3651515
        ],
        [
          0.00028943490053,
          0.06721987387435,
          75.68406991
        ],
        [
          0.00051143700304,
          0.0502280742991,
          84.31888367
        ],
        [
          0.00028975724863,
          0.06747482463687,
          75.4374643
        ],
        [
          0.00049911307763,
          0.05216670205032,
          82.36217212
        ],
        [
          0.00028944359675,
          0.06721789675506,
          75.68541695
        ],
        [
          0.00058252354605,
          0.04542816518313,
          88.23459215
        ],
        [
          0.00029016789054,
          0.06726535523394,
          75.60552022
        ],
        [
          0.00042038778237,
          0.05652211372705,
          80.41754701
        ],
        [
          0.00028976968112,
          0.06701307837864,
          75.85478571
        ],
        [
          0.00051666501665,
          0.04907770938405,
          85.62596756
        ],
        [
          0.00029017676027,
          0.06726337019881,
          75.60686379
        ],
        [
          0.00050918121888,
          0.05087839350586,
          83.57598195
        ],
        [
          0.00028977775434,
          0.06701113748378,
          75.85614003
        ],
        [
          0.00058043417988,
          0.04444643250431,
          89.78033923
        ],
        [
          0.00028974779287,
          0.06747684399987,
          75.43612815
        ],
        [
          0.00045008304007,
          0.05533933531728,
          80.53872611
        ],
        [
          0.00028943490053,
          0.06721987387435,
          75.68406991
        ],
        [
          0.00055064905183,
          0.04793808553889,
          85.8709913
        ],
        [
          0.00028975724863,
          0.06747482463687,
          75.4374643
        ],
        [
          0.00054264705339,
          0.04974750883027,
          83.77018551
        ],
        [
          0.00028944359675,
          0.06721789675506,
          75.68541695
        ],
        [
          0.00064261276795,
          0.04239101543758,
          90.68598117
        ],
        [
          0.00029016789054,
          0.06726535523394,
          75.60552022
        ],
        [
          0.00046545053523,
          0.0538417846584,
          81.65927341
        ],
        [
          0.00028976968112,
          0.06701307837864,
          75.85478571
        ],
        [
          0.00055305495928,
          0.04686137269201,
          87.27576119
        ],
        [
          0.00029017676027,
          0.06726337019881,
          75.60686379
        ],
        [
          0.00054980704851,
          0.04855534549266,
          85.06959001
        ],
        [
          0.00028977775434,
          0.06701113748378,
          75.85614003
        ],
        [
          0.0006382293871,
          0.04141902226082,
          92.42786908
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00036741582661,
          0.06080100478499,
          78.14072734
        ],
        [
          0.0002823161672,
          0.06792371204899,
          75.41664411
        ],
        [
          0.00036563489295,
          0.06061411367145,
          78.4107776
        ],
        [
          0.00028225308716,
          0.0681916343571,
          75.18097907
        ],
        [
          0.00047124549387,
          0.05427710682471,
          80.92571548
        ],
        [
          0.00028232523178,
          0.06792170165214,
          75.41797328
        ],
        [
          0.00046633398225,
          0.0541822942045,
          81.22644116
        ],
        [
          0.00028276814193,
          0.06797732013251,
          75.34531369
        ],
        [
          0.00038877879523,
          0.0589477293005,
          79.12693217
        ],
        [
          0.00028276999456,
          0.0677113600663,
          75.58361354
        ],
        [
          0.0003860012706,
          0.05879848736809,
          79.4058571
        ],
        [
          0.00028277733056,
          0.06797530401014,
          75.3466395
        ],
        [
          0.00048537622525,
          0.05284870582242,
          82.06282961
        ],
        [
          0.00028277850969,
          0.06770938270524,
          75.58495007
        ],
        [
          0.00047935043392,
          0.05278513318194,
          82.37274444
        ],
        [
          0.00028224338654,
          0.06819368155246,
          75.17966073
        ],
        [
          0.00036741582661,
          0.06080100478499,
          78.14072734
        ],
        [
          0.0002823161672,
          0.06792371204899,
          75.41664411
        ],
        [
          0.00036563489295,
          0.06061411367145,
          78.4107776
        ],
        [
          0.00028225308716,
          0.0681916343571,
          75.18097907
        ],
        [
          0.00047124549387,
          0.05427710682471,
          80.92571548
        ],
        [
          0.00028232523178,
          0.06792170165214,
          75.41797328
        ],
        [
          0.00048852017541,
          0.05321427571541,
          81.5071818
        ],
        [
          0.00028276814193,
          0.06797732013251,
          75.34531369
        ],
        [
          0.00038877879523,
          0.0589477293005,
          79.12693217
        ],
        [
          0.00028276999456,
          0.0677113600663,
          75.58361354
        ],
        [
          0.0003860012706,
          0.05879848736809,
          79.4058571
        ],
        [
          0.00028277733056,
          0.06797530401014,
          75.3466395
        ],
        [
          0.00048537622525,
          0.05284870582242,
          82.06282961
        ],
        [
          0.00028277850969,
          0.06770938270524,
          75.58495007
        ],
        [
          0.00050136168854,
          0.05183903552152,
          82.67736038
        ],
        [
          0.0002917505004,
          0.06741472933627,
          75.39051315
        ],
        [
          0.00040735761435,
          0.05806392608764,
          79.27755471
        ],
        [
          0.00029178515669,
          0.06714685651099,
          75.63058933
        ],
        [
          0.0005199384967,
          0.0500615433082,
          84.2095015
        ],
        [
          0.00029176010288,
          0.06741270599752,
          75.39184828
        ],
        [
          0.00050589185634,
          0.05203367545424,
          82.2686366
        ],
        [
          0.00029179402698,
          0.0671448742951,
          75.63193521
        ],
        [
          0.00059318238345,
          0.04523727357632,
          88.12208199
        ],
        [
          0.00029224952226,
          0.06720076140146,
          75.5582735
        ],
        [
          0.00042607887208,
          0.05639353685203,
          80.32505023
        ],
        [
          0.00029220148312,
          0.06693744569182,
          75.799656
        ],
        [
          0.00052595486762,
          0.04889442683365,
          85.51261262
        ],
        [
          0.00029225854496,
          0.06719877198464,
          75.55961603
        ],
        [
          0.0005166826576,
          0.05073122675081,
          83.47800586
        ],
        [
          0.0002922097367,
          0.06693549923579,
          75.80100916
        ],
        [
          0.00059196523097,
          0.04423623953748,
          89.66541605
        ],
        [
          0.0002917505004,
          0.06741472933627,
          75.39051315
        ],
        [
          0.00045596228424,
          0.05521603586388,
          80.44635351
        ],
        [
          0.00029178515669,
          0.06714685651099,
          75.63058933
        ],
        [
          0.00056024281975,
          0.04776103497828,
          85.75742957
        ],
        [
          0.00029176010288,
          0.06741270599752,
          75.39184828
        ],
        [
          0.00055037471292,
          0.04960580686364,
          83.672277
        ],
        [
          0.00029179402698,
          0.0671448742951,
          75.63193521
        ],
        [
          0.00065492097079,
          0.04218879670808,
          90.56980693
        ],
        [
          0.00029224952226,
          0.06720076140146,
          75.5582735
        ],
        [
          0.00047202813503,
          0.05370528434352,
          81.5620973
        ],
        [
          0.00029220148312,
          0.06693744569182,
          75.799656
        ],
        [
          0.00056348502225,
          0.04666662127937,
          87.15867489
        ],
        [
          0.00029225854496,
          0.06719877198464,
          75.55961603
        ],
        [
          0.00055830317381,
          0.04839875025128,
          84.96747166
        ],
        [
          0.0002922097367,
          0.06693549923579,
          75.80100916
        ],
        [
          0.00065151379618,
          0.04119632628112,
          92.31047595
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.0003713436038,
          0.06070521914198,
          78.06463424
        ],
        [
          0.00028430759238,
          0.06786118852564,
          75.36967837
        ],
        [
          0.00036997416128,
          0.06050711271864,
          78.32720252
        ],
        [
          0.00028394819201,
          0.06813841116259,
          75.14096093
        ],
        [
          0.00047664287069,
          0.05416857478404,
          80.84374635
        ],
        [
          0.00028431680146,
          0.067859174104,
          75.37100646
        ],
        [
          0.00047227459911,
          0.05406085250375,
          81.13665374
        ],
        [
          0.00028452922456,
          0.06792203550775,
          75.30387159
        ],
        [
          0.00039325323771,
          0.05884212590216,
          79.04612826
        ],
        [
          0.00028482982186,
          0.06764666420651,
          75.53520553
        ],
        [
          0.0003909211261,
          0.05868079912093,
          79.31749859
        ],
        [
          0.00028453853979,
          0.06792001593681,
          75.30519645
        ],
        [
          0.000491409426,
          0.05272822128349,
          81.97643084
        ],
        [
          0.00028483848719,
          0.06764468242188,
          75.53654098
        ],
        [
          0.00048595641888,
          0.05265084307796,
          82.27852227
        ],
        [
          0.00028393837038,
          0.06814046145964,
          75.13964353
        ],
        [
          0.0003713436038,
          0.06070521914198,
          78.06463424
        ],
        [
          0.00028430759238,
          0.06786118852564,
          75.36967837
        ],
        [
          0.00036997416128,
          0.06050711271864,
          78.32720252
        ],
        [
          0.00028394819201,
          0.06813841116259,
          75.14096093
        ],
        [
          0.00047664287069,
          0.05416857478404,
          80.84374635
        ],
        [
          0.00028431680146,
          0.067859174104,
          75.37100646
        ],
        [
          0.00049470568019,
          0.0530935688212,
          81.41641626
        ],
        [
          0.00028452922456,
          0.06792203550775,
          75.30387159
        ],
        [
          0.00039325323771,
          0.05884212590216,
          79.04612826
        ],
        [
          0.00028482982186,
          0.06764666420651,
          75.53520553
        ],
        [
          0.0003909211261,
          0.05868079912093,
          79.31749859
        ],
        [
          0.00028453853979,
          0.06792001593681,
          75.30519645
        ],
        [
          0.000491409426,
          0.05272822128349,
          81.97643084
        ],
        [
          0.00028483848719,
          0.06764468242188,
          75.53654098
        ],
        [
          0.00050823317492,
          0.05170543989542,
          82.58214662
        ],
        [
          0.00029353017166,
          0.06736097280629,
          75.34918947
        ],
        [
          0.00041211170916,
          0.05795738856244,
          79.19373605
        ],
        [
          0.00029387064104,
          0.06708380514056,
          75.58225698
        ],
        [
          0.00052799033597,
          0.04990815707502,
          84.1044109
        ],
        [
          0.00029353990752,
          0.06735894580044,
          75.35052365
        ],
        [
          0.00051228665703,
          0.05191144581308,
          82.17906565
        ],
        [
          0.0002938796696,
          0.0670818182439,
          75.58360179
        ],
        [
          0.00060328048873,
          0.04506141007688,
          88.01360013
        ],
        [
          0.00029409811246,
          0.06714489234995,
          75.51551291
        ],
        [
          0.00043144658009,
          0.05627559899651,
          80.23654507
        ],
        [
          0.00029435846093,
          0.0668721556752,
          75.74987061
        ],
        [
          0.00053476027489,
          0.04872552630821,
          85.4036195
        ],
        [
          0.00029410727437,
          0.06714289889558,
          75.51685449
        ],
        [
          0.0005237639911,
          0.05059590620797,
          83.38413868
        ],
        [
          0.00029436687865,
          0.0668702041171,
          75.75122271
        ],
        [
          0.00060289673986,
          0.04404262316752,
          89.5544019
        ],
        [
          0.00029353017166,
          0.06736097280629,
          75.34918947
        ],
        [
          0.00046153854259,
          0.05510233924659,
          80.35739757
        ],
        [
          0.00029387064104,
          0.06708380514056,
          75.58225698
        ],
        [
          0.00056937853029,
          0.04759712989554,
          85.64760745
        ],
        [
          0.00029353990752,
          0.06735894580044,
          75.35052365
        ],
        [
          0.00055771023226,
          0.0494748057327,
          83.57786243
        ],
        [
          0.0002938796696,
          0.0670818182439,
          75.58360179
        ],
        [
          0.00066663651853,
          0.04200181031612,
          90.45681076
        ],
        [
          0.00029409811246,
          0.06714489234995,
          75.51551291
        ],
        [
          0.00047827100066,
          0.05357925715803,
          81.46851891
        ],
        [
          0.00029435846093,
          0.0668721556752,
          75.74987061
        ],
        [
          0.00057342265704,
          0.04648631624232,
          87.04533278
        ],
        [
          0.00029410727437,
          0.06714289889558,
          75.51685449
        ],
        [
          0.00056637202815,
          0.04825392409223,
          84.86895196
        ],
        [
          0.00029436687865,
          0.0668702041171,
          75.75122271
        ],
        [
          0.00066416357067,
          0.04099052607766,
          92.19597742
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00037532238267,
          0.06061115934755,
          77.98613356
        ],
        [
          0.00028631176544,
          0.06780007631863,
          75.32142291
        ],
        [
          0.00037434609764,
          0.0604026459391,
          78.24153753
        ],
        [
          0.00028567340573,
          0.0680857655677,
          75.09934358
        ],
        [
          0.00048214467139,
          0.05406097203146,
          80.75872763
        ],
        [
          0.00028632112366,
          0.06779805767696,
          75.32274988
        ],
        [
          0.0004782950659,
          0.05394123532729,
          81.04413836
        ],
        [
          0.00028633230573,
          0.06786702003575,
          75.26052895
        ],
        [
          0.00039782359272,
          0.05873742702375,
          78.96216882
        ],
        [
          0.0002869144463,
          0.06758306914205,
          75.48520544
        ],
        [
          0.0003959173758,
          0.05856486931856,
          79.22629583
        ],
        [
          0.00028634175387,
          0.06786499677752,
          75.26185279
        ],
        [
          0.00049760824465,
          0.05260774358442,
          81.88616791
        ],
        [
          0.00028692326764,
          0.06758108270388,
          75.48653976
        ],
        [
          0.00049270342581,
          0.05251746636644,
          82.18075248
        ],
        [
          0.00028566345795,
          0.06808781916716,
          75.09802719
        ],
        [
          0.00037532238267,
          0.06061115934755,
          77.98613356
        ],
        [
          0.00028631176544,
          0.06780007631863,
          75.32142291
        ],
        [
          0.00037434609764,
          0.0604026459391,
          78.24153753
        ],
        [
          0.00028567340573,
          0.0680857655677,
          75.09934358
        ],
        [
          0.00048214467139,
          0.05406097203146,
          80.75872763
        ],
        [
          0.00028632112366,
          0.06779805767696,
          75.32274988
        ],
        [
          0.00050097250742,
          0.0529747233335,
          81.32288047
        ],
        [
          0.00028633230573,
          0.06786702003575,
          75.26052895
        ],
        [
          0.00039782359272,
          0.05873742702375,
          78.96216882
        ],
        [
          0.0002869144463,
          0.06758306914205,
          75.48520544
        ],
        [
          0.0003959173758,
          0.05856486931856,
          79.22629583
        ],
        [
          0.00028634175387,
          0.06786499677752,
          75.26185279
        ],
        [
          0.00049760824465,
          0.05260774358442,
          81.88616791
        ],
        [
          0.00028692326764,
          0.06758108270388,
          75.48653976
        ],
        [
          0.00051524921988,
          0.05157280827237,
          82.48332841
        ],
        [
          0.0002953472142,
          0.06730765739485,
          75.30607246
        ],
        [
          0.00041693787976,
          0.05785249026979,
          79.10714461
        ],
        [
          0.00029597579551,
          0.067022018571,
          75.53244234
        ],
        [
          0.00053625567669,
          0.04975519216273,
          83.99476503
        ],
        [
          0.00029535708984,
          0.06730562647873,
          75.30740563
        ],
        [
          0.0005188173742,
          0.05179003042366,
          82.08601357
        ],
        [
          0.00029598498815,
          0.0670200267619,
          75.53378602
        ],
        [
          0.00061369104052,
          0.04488524095323,
          87.89955999
        ],
        [
          0.00029599638623,
          0.06708915608181,
          75.47065441
        ],
        [
          0.00043693888757,
          0.05615842303067,
          80.14448712
        ],
        [
          0.00029654751948,
          0.06680782424242,
          75.69829706
        ],
        [
          0.000543857895,
          0.04855602086186,
          85.28916531
        ],
        [
          0.00029600569488,
          0.06708715830952,
          75.47199496
        ],
        [
          0.00053104933481,
          0.05046044998777,
          83.28594394
        ],
        [
          0.00029655610841,
          0.06680586731046,
          75.69964802
        ],
        [
          0.00061423568469,
          0.04384761929097,
          89.4368384
        ],
        [
          0.0002953472142,
          0.06730765739485,
          75.30607246
        ],
        [
          0.00046718790514,
          0.05499055192586,
          80.26568871
        ],
        [
          0.00029597579551,
          0.067022018571,
          75.53244234
        ],
        [
          0.0005787371262,
          0.04743405556672,
          85.53313467
        ],
        [
          0.00029535708984,
          0.06730562647873,
          75.30740563
        ],
        [
          0.00056518438575,
          0.04934496404767,
          83.47995267
        ],
        [
          0.00029598498815,
          0.0670200267619,
          75.53378602
        ],
        [
          0.00067867981673,
          0.04181522646205,
          90.33788411
        ],
        [
          0.00029599638623,
          0.06708915608181,
          75.47065441
        ],
        [
          0.00048464524097,
          0.0534542611888,
          81.37138
        ],
        [
          0.00029654751948,
          0.06680782424242,
          75.69829706
        ],
        [
          0.00058366875782,
          0.04630582041231,
          86.92638778
        ],
        [
          0.00029600569488,
          0.06708715830952,
          75.47199496
        ],
        [
          0.00057465322768,
          0.04810932759917,
          84.76604598
        ],
        [
          0.00029655610841,
          0.06680586731046,
          75.69964802
        ],
        [
          0.00067724513201,
          0.04078412863923,
          92.07445529
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00037932195954,
          0.06051978176053,
          77.90558648
        ],
        [
          0.00028831307174,
          0.06774100909019,
          75.27210944
        ],
        [
          0.00037876656723,
          0.0603006028759,
          78.15320799
        ],
        [
          0.00028737838576,
          0.06803537351886,
          75.05721635
        ],
        [
          0.00048772229129,
          0.05395511553189,
          80.67085872
        ],
        [
          0.00028832258306,
          0.06773898604135,
          75.27343524
        ],
        [
          0.0004844304056,
          0.05382302222236,
          80.94809607
        ],
        [
          0.00028812709824,
          0.06781397489181,
          75.2163541
        ],
        [
          0.0004024409813,
          0.0586350434215,
          78.87569242
        ],
        [
          0.00028900855641,
          0.0675212274117,
          75.43382152
        ],
        [
          0.00040099245688,
          0.0584509368425,
          79.13194223
        ],
        [
          0.00028813668237,
          0.06781194778623,
          75.21767688
        ],
        [
          0.000503921231,
          0.05248858233291,
          81.79252595
        ],
        [
          0.00028901753904,
          0.06751923609185,
          75.43515465
        ],
        [
          0.00049960777266,
          0.05238501823036,
          82.0789095
        ],
        [
          0.00028736830994,
          0.06803743054651,
          75.05590098
        ],
        [
          0.00037932195954,
          0.06051978176053,
          77.90558648
        ],
        [
          0.00028831307174,
          0.06774100909019,
          75.27210944
        ],
        [
          0.00037876656723,
          0.0603006028759,
          78.15320799
        ],
        [
          0.00028737838576,
          0.06803537351886,
          75.05721635
        ],
        [
          0.00048772229129,
          0.05395511553189,
          80.67085872
        ],
        [
          0.00028832258306,
          0.06773898604135,
          75.27343524
        ],
        [
          0.0005073571039,
          0.05285732379644,
          81.22576203
        ],
        [
          0.00028812709824,
          0.06781397489181,
          75.2163541
        ],
        [
          0.0004024409813,
          0.0586350434215,
          78.87569242
        ],
        [
          0.00028900855641,
          0.0675212274117,
          75.43382152
        ],
        [
          0.00040099245688,
          0.0584509368425,
          79.13194223
        ],
        [
          0.00028813668237,
          0.06781194778623,
          75.21767688
        ],
        [
          0.000503921231,
          0.05248858233291,
          81.79252595
        ],
        [
          0.00028901753904,
          0.06751923609185,
          75.43515465
        ],
        [
          0.00052242601166,
          0.05144118012907,
          82.38036946
        ],
        [
          0.0002971467161,
          0.06725654725145,
          75.2623303
        ],
        [
          0.00042181705475,
          0.05774991655723,
          79.01786592
        ],
        [
          0.00029808130583,
          0.06696223464017,
          75.48144855
        ],
        [
          0.00054481439203,
          0.04960162816378,
          83.87915948
        ],
        [
          0.00029715673408,
          0.06725451227954,
          75.26366242
        ],
        [
          0.00052547224958,
          0.0516699394666,
          81.98938302
        ],
        [
          0.00029809066745,
          0.06696023770266,
          75.48279105
        ],
        [
          0.00062453186428,
          0.04470731656034,
          87.77825615
        ],
        [
          0.00029788944574,
          0.06703534456925,
          75.42484505
        ],
        [
          0.00044251710963,
          0.05604316999492,
          80.04923075
        ],
        [
          0.00029874970359,
          0.06674520522387,
          75.64521521
        ],
        [
          0.00055330830519,
          0.04838532336355,
          85.16811524
        ],
        [
          0.00029789890503,
          0.06703334229478,
          75.42618454
        ],
        [
          0.00053850380705,
          0.05032586082089,
          83.18359953
        ],
        [
          0.00029875846986,
          0.0667432426685,
          75.64656498
        ],
        [
          0.00062607555257,
          0.0436502752168,
          89.31128733
        ],
        [
          0.0002971467161,
          0.06725654725145,
          75.2623303
        ],
        [
          0.00047289431486,
          0.05488123436102,
          80.17123836
        ],
        [
          0.00029808130583,
          0.06696223464017,
          75.48144855
        ],
        [
          0.00058841414754,
          0.04727059781619,
          85.41247652
        ],
        [
          0.00029715673408,
          0.06725451227954,
          75.26366242
        ],
        [
          0.00057279128259,
          0.04921666500268,
          83.37834674
        ],
        [
          0.00029809066745,
          0.06696023770266,
          75.48279105
        ],
        [
          0.00069119189058,
          0.04162740444538,
          90.2111503
        ],
        [
          0.00029788944574,
          0.06703534456925,
          75.42484505
        ],
        [
          0.00049111361836,
          0.05333132450085,
          81.27097282
        ],
        [
          0.00029874970359,
          0.06674520522387,
          75.64521521
        ],
        [
          0.00059429492058,
          0.04612443307195,
          86.80057623
        ],
        [
          0.00029789890503,
          0.06703334229478,
          75.42618454
        ],
        [
          0.00058311521304,
          0.04796585565911,
          84.6588386
        ],
        [
          0.00029875846986,
          0.0667432426685,
          75.64656498
        ],
        [
          0.00069087175644,
          0.04057600755281,
          91.94429582
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00038300566518,
          0.06043870071448,
          77.8296541
        ],
        [
          0.00029009786758,
          0.0676902114878,
          75.22696956
        ],
        [
          0.00038285548947,
          0.0602096900385,
          78.06965787
        ],
        [
          0.00028888068842,
          0.06799252997602,
          75.01908419
        ],
        [
          0.00049285870681,
          0.05386071056467,
          80.58817321
        ],
        [
          0.00029010751965,
          0.06768818430767,
          75.22829427
        ],
        [
          0.00049010561844,
          0.05371719183957,
          80.85738275
        ],
        [
          0.00028970758757,
          0.06776889528958,
          75.17640719
        ],
        [
          0.00040670652517,
          0.05854372773392,
          78.79404384
        ],
        [
          0.00029087453531,
          0.0674680787084,
          75.38684404
        ],
        [
          0.00040569982582,
          0.05834895256254,
          79.0425722
        ],
        [
          0.00028971729512,
          0.06776686461511,
          75.177729
        ],
        [
          0.00050975177868,
          0.0523818793921,
          81.70422873
        ],
        [
          0.00029088366619,
          0.0674660828278,
          75.38817606
        ],
        [
          0.0005060114007,
          0.05226600759163,
          81.9825412
        ],
        [
          0.0002888704964,
          0.06799459019526,
          75.01776977
        ],
        [
          0.00038300566518,
          0.06043870071448,
          77.8296541
        ],
        [
          0.00029009786758,
          0.0676902114878,
          75.22696956
        ],
        [
          0.00038285548947,
          0.0602096900385,
          78.06965787
        ],
        [
          0.00028888068842,
          0.06799252997602,
          75.01908419
        ],
        [
          0.00049285870681,
          0.05386071056467,
          80.58817321
        ],
        [
          0.00029010751965,
          0.06768818430767,
          75.22829427
        ],
        [
          0.00051326136949,
          0.05275226311523,
          81.13401953
        ],
        [
          0.00028970758757,
          0.06776889528958,
          75.17640719
        ],
        [
          0.00040670652517,
          0.05854372773392,
          78.79404384
        ],
        [
          0.00029087453531,
          0.0674680787084,
          75.38684404
        ],
        [
          0.00040569982582,
          0.05834895256254,
          79.0425722
        ],
        [
          0.00028971729512,
          0.06776686461511,
          75.177729
        ],
        [
          0.00050975177868,
          0.0523818793921,
          81.70422873
        ],
        [
          0.00029088366619,
          0.0674660828278,
          75.38817606
        ],
        [
          0.0005290797848,
          0.05132297626756,
          82.28292552
        ],
        [
          0.0002987301269,
          0.06721318183169,
          75.22278576
        ],
        [
          0.00042635718054,
          0.05765786219655,
          78.93291586
        ],
        [
          0.00029995635034,
          0.06691092361546,
          75.43483216
        ],
        [
          0.00055298334836,
          0.0494597725042,
          83.76656865
        ],
        [
          0.00029874027415,
          0.06721114309724,
          75.22411692
        ],
        [
          0.00053166396198,
          0.05156168355143,
          81.89755735
        ],
        [
          0.00029996586729,
          0.06690892188998,
          75.43617356
        ],
        [
          0.00063486457193,
          0.044543063289,
          87.65991225
        ],
        [
          0.00029955435986,
          0.06698969857091,
          75.38346824
        ],
        [
          0.00044772132093,
          0.05593925662973,
          79.95849049
        ],
        [
          0.00030070938249,
          0.06669148706635,
          75.59674546
        ],
        [
          0.0005623392229,
          0.04822742748898,
          85.05009123
        ],
        [
          0.00029956395592,
          0.06698769213474,
          75.38480675
        ],
        [
          0.00054545531324,
          0.05020417126028,
          83.08617428
        ],
        [
          0.00030071831186,
          0.06668951927063,
          75.59809411
        ],
        [
          0.00063737202919,
          0.04346801451009,
          89.18851857
        ],
        [
          0.0002987301269,
          0.06721318183169,
          75.22278576
        ],
        [
          0.00047827596745,
          0.05478167170982,
          80.08019659
        ],
        [
          0.00029995635034,
          0.06691092361546,
          75.43483216
        ],
        [
          0.00059774590968,
          0.0471180541884,
          85.29362385
        ],
        [
          0.00029874027415,
          0.06721114309724,
          75.22411692
        ],
        [
          0.00057996102896,
          0.04909945832315,
          83.2804899
        ],
        [
          0.00029996586729,
          0.06690892188998,
          75.43617356
        ],
        [
          0.00070322954442,
          0.04145256886792,
          90.08582831
        ],
        [
          0.00029955435986,
          0.06698969857091,
          75.38346824
        ],
        [
          0.00049722514755,
          0.05321898280783,
          81.17411149
        ],
        [
          0.00030070938249,
          0.06669148706635,
          75.59674546
        ],
        [
          0.00060454923524,
          0.04595506146811,
          86.67651041
        ],
        [
          0.00029956395592,
          0.06698769213474,
          75.38480675
        ],
        [
          0.00059110339783,
          0.04783453233646,
          84.55543963
        ],
        [
          0.00030071831186,
          0.06668951927063,
          75.59809411
        ],
        [
          0.00070398826482,
          0.04038233973703,
          91.81520402
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00038643752983,
          0.06036618083362,
          77.757019
        ],
        [
          0.00029177107689,
          0.06764449473477,
          75.18338833
        ],
        [
          0.00038665139202,
          0.06012866289426,
          77.99009039
        ],
        [
          0.00029030343105,
          0.06795355966905,
          74.98186438
        ],
        [
          0.00049770071262,
          0.05377470339108,
          80.50831589
        ],
        [
          0.00029178086541,
          0.06764246345995,
          75.18471197
        ],
        [
          0.00049543289715,
          0.05362121876617,
          80.77020836
        ],
        [
          0.00029122331675,
          0.06772736232508,
          75.1369373
        ],
        [
          0.00041073941217,
          0.05846061107951,
          78.71491137
        ],
        [
          0.0002926438449,
          0.06741968516172,
          75.34098892
        ],
        [
          0.00041013128081,
          0.05825653700719,
          78.95640677
        ],
        [
          0.00029123314671,
          0.06772532802362,
          75.13825813
        ],
        [
          0.00051532408766,
          0.052283171505,
          81.61785944
        ],
        [
          0.00029265312128,
          0.06741768471824,
          75.34231984
        ],
        [
          0.00051210119797,
          0.0521565193929,
          81.88880538
        ],
        [
          0.00029029312501,
          0.06795562311749,
          74.98055091
        ],
        [
          0.00038643752983,
          0.06036618083362,
          77.757019
        ],
        [
          0.00029177107689,
          0.06764449473477,
          75.18338833
        ],
        [
          0.00038665139202,
          0.06012866289426,
          77.99009039
        ],
        [
          0.00029030343105,
          0.06795355966905,
          74.98186438
        ],
        [
          0.00049770071262,
          0.05377470339108,
          80.50831589
        ],
        [
          0.00029178086541,
          0.06764246345995,
          75.18471197
        ],
        [
          0.00051880227192,
          0.0526570316085,
          81.04584
        ],
        [
          0.00029122331675,
          0.06772736232508,
          75.1369373
        ],
        [
          0.00041073941217,
          0.05846061107951,
          78.71491137
        ],
        [
          0.0002926438449,
          0.06741968516172,
          75.34098892
        ],
        [
          0.00041013128081,
          0.05825653700719,
          78.95640677
        ],
        [
          0.00029123314671,
          0.06772532802362,
          75.13825813
        ],
        [
          0.00051532408766,
          0.052283171505,
          81.61785944
        ],
        [
          0.00029265312128,
          0.06741768471824,
          75.34231984
        ],
        [
          0.00053540627165,
          0.05121426230456,
          82.188126
        ],
        [
          0.00030022885372,
          0.06717378937346,
          75.18420264
        ],
        [
          0.00043060555093,
          0.05757502108734,
          78.85139732
        ],
        [
          0.00030171384235,
          0.06686478282654,
          75.38982862
        ],
        [
          0.00056073674208,
          0.04932963940594,
          83.65725512
        ],
        [
          0.0003002391275,
          0.06717174687165,
          75.18553285
        ],
        [
          0.0005375210817,
          0.05146263316616,
          81.80861462
        ],
        [
          0.00030172351013,
          0.06686277636563,
          75.39116894
        ],
        [
          0.00064474642925,
          0.04439104503122,
          87.54379514
        ],
        [
          0.00030114979332,
          0.06694770477079,
          75.34261341
        ],
        [
          0.00045265785135,
          0.05584422905575,
          79.8703522
        ],
        [
          0.00030256680696,
          0.06664262138296,
          75.54944814
        ],
        [
          0.00057100271532,
          0.04808096841607,
          84.93429066
        ],
        [
          0.0003011595251,
          0.06694569412145,
          75.34395093
        ],
        [
          0.00055211441077,
          0.05009130326404,
          82.99067329
        ],
        [
          0.00030257589659,
          0.06664064835809,
          75.55079569
        ],
        [
          0.00064828341591,
          0.04329772298028,
          89.06670373
        ],
        [
          0.00030022885372,
          0.06717378937346,
          75.18420264
        ],
        [
          0.00048333181112,
          0.05469157589359,
          79.99253403
        ],
        [
          0.00030171384235,
          0.06686478282654,
          75.38982862
        ],
        [
          0.0006066262867,
          0.04697774589153,
          85.17781236
        ],
        [
          0.0003002391275,
          0.06717174687165,
          75.18553285
        ],
        [
          0.00058676534483,
          0.04899181312832,
          83.18536527
        ],
        [
          0.00030172351013,
          0.06686277636563,
          75.39116894
        ],
        [
          0.00071475890156,
          0.04129069988578,
          89.9621772
        ],
        [
          0.00030114979332,
          0.06694770477079,
          75.34261341
        ],
        [
          0.00050304149651,
          0.05311578865824,
          81.07974664
        ],
        [
          0.00030256680696,
          0.06664262138296,
          75.54944814
        ],
        [
          0.00061440722253,
          0.04579767529401,
          86.55434038
        ],
        [
          0.0003011595251,
          0.06694569412145,
          75.34395093
        ],
        [
          0.00059877514285,
          0.04771240090793,
          84.45374551
        ],
        [
          0.00030257589659,
          0.06664064835809,
          75.55079569
        ],
        [
          0.00071666987262,
          0.04020146647682,
          91.68631267
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00038979031417,
          0.06029849464803,
          77.68391975
        ],
        [
          0.0002933953992,
          0.06760214831555,
          75.13966468
        ],
        [
          0.00039037101695,
          0.06005278596067,
          77.90984379
        ],
        [
          0.00029167768126,
          0.06791763318732,
          74.94468088
        ],
        [
          0.00050251025552,
          0.05369239818866,
          80.42683525
        ],
        [
          0.00029340532521,
          0.06760011281335,
          75.14098722
        ],
        [
          0.00050073413121,
          0.05352922780572,
          80.68116002
        ],
        [
          0.00029266673708,
          0.06768959647392,
          75.09807891
        ],
        [
          0.00041464797504,
          0.05838336547018,
          78.63605564
        ],
        [
          0.00029434039495,
          0.06737538876476,
          75.29556738
        ],
        [
          0.00041444194716,
          0.05817033401634,
          78.87029058
        ],
        [
          0.00029267668799,
          0.06768755849455,
          75.09939876
        ],
        [
          0.00052081036136,
          0.05218934666982,
          81.53060707
        ],
        [
          0.00029434981622,
          0.06737338368197,
          75.29689718
        ],
        [
          0.00051811273198,
          0.05205221687979,
          81.79392138
        ],
        [
          0.0002916672614,
          0.06791969994409,
          74.94336837
        ],
        [
          0.00038979031417,
          0.06029849464803,
          77.68391975
        ],
        [
          0.0002933953992,
          0.06760214831555,
          75.13966468
        ],
        [
          0.00039037101695,
          0.06005278596067,
          77.90984379
        ],
        [
          0.00029167768126,
          0.06791763318732,
          74.94468088
        ],
        [
          0.00050251025552,
          0.05369239818866,
          80.42683525
        ],
        [
          0.00029340532521,
          0.06760011281335,
          75.14098722
        ],
        [
          0.00052431488742,
          0.05256579059311,
          80.95574996
        ],
        [
          0.00029266673708,
          0.06768959647392,
          75.09807891
        ],
        [
          0.00041464797504,
          0.05838336547018,
          78.63605564
        ],
        [
          0.00029434039495,
          0.06737538876476,
          75.29556738
        ],
        [
          0.00041444194716,
          0.05817033401634,
          78.87029058
        ],
        [
          0.00029267668799,
          0.06768755849455,
          75.09939876
        ],
        [
          0.00052081036136,
          0.05218934666982,
          81.53060707
        ],
        [
          0.00029434981622,
          0.06737338368197,
          75.29689718
        ],
        [
          0.00054164997435,
          0.05111074583797,
          82.09214002
        ],
        [
          0.00030168471126,
          0.06713729987126,
          75.14543435
        ],
        [
          0.00043476327107,
          0.05749737724013,
          78.76932859
        ],
        [
          0.00030342811473,
          0.06682187276751,
          75.34445807
        ],
        [
          0.00056849742858,
          0.04920401884794,
          83.54504974
        ],
        [
          0.00030169511271,
          0.06713525347209,
          75.14676357
        ],
        [
          0.00054334171467,
          0.05136767997842,
          81.71788087
        ],
        [
          0.00030343793543,
          0.06681986140877,
          75.34579727
        ],
        [
          0.0006547446467,
          0.0442424497895,
          87.42299616
        ],
        [
          0.0003026779748,
          0.06690932754767,
          75.30215286
        ],
        [
          0.00045745429382,
          0.05575551136848,
          79.78240777
        ],
        [
          0.00030435660463,
          0.06659770238328,
          75.50236401
        ],
        [
          0.00057961521677,
          0.04794044990473,
          84.81626224
        ],
        [
          0.0003026878417,
          0.06690731261099,
          75.30348938
        ],
        [
          0.00055867835911,
          0.04998382424923,
          82.8941077
        ],
        [
          0.00030436585485,
          0.06659572402897,
          75.50371043
        ],
        [
          0.00065924015997,
          0.04313256813588,
          88.94076113
        ],
        [
          0.00030168471126,
          0.06713729987126,
          75.14543435
        ],
        [
          0.00048831940983,
          0.05460627395875,
          79.90364415
        ],
        [
          0.00030342811473,
          0.06682187276751,
          75.34445807
        ],
        [
          0.00061556367218,
          0.04684153917041,
          85.05817693
        ],
        [
          0.00030169511271,
          0.06713525347209,
          75.14676357
        ],
        [
          0.00059357351848,
          0.04888783506108,
          83.08763844
        ],
        [
          0.00030343793543,
          0.06681986140877,
          75.34579727
        ],
        [
          0.00072647022783,
          0.04113204180244,
          89.83249162
        ],
        [
          0.0003026779748,
          0.06690932754767,
          75.30215286
        ],
        [
          0.00050873744057,
          0.05301853422189,
          80.98489163
        ],
        [
          0.00030435660463,
          0.06659770238328,
          75.50236401
        ],
        [
          0.00062425899787,
          0.04564591587678,
          86.42897012
        ],
        [
          0.0003026878417,
          0.06690731261099,
          75.30348938
        ],
        [
          0.00060638823895,
          0.04759528126523,
          84.3501546
        ],
        [
          0.00030436585485,
          0.06659572402897,
          75.50371043
        ],
        [
          0.00072945470234,
          0.04002561069641,
          91.55182173
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00039284753349,
          0.06023989516807,
          77.61500902
        ],
        [
          0.00029485774859,
          0.0675660554818,
          75.09882267
        ],
        [
          0.00039377780159,
          0.05998676302594,
          77.83392752
        ],
        [
          0.00029290389297,
          0.06788727957307,
          74.910231
        ],
        [
          0.00050690934598,
          0.05362014296122,
          80.35005853
        ],
        [
          0.00029486780354,
          0.06756401591051,
          75.10014415
        ],
        [
          0.00050560418354,
          0.05344811814921,
          80.59694188
        ],
        [
          0.00029396070094,
          0.06765751814527,
          75.06192361
        ],
        [
          0.00041827817801,
          0.05831491193558,
          78.56049595
        ],
        [
          0.00029587358383,
          0.06733746310683,
          75.25299622
        ],
        [
          0.0004184574856,
          0.05809368555129,
          78.78760516
        ],
        [
          0.00029397076479,
          0.06765547663348,
          75.06324252
        ],
        [
          0.0005259170787,
          0.05210528994005,
          81.44704528
        ],
        [
          0.00029588314166,
          0.06733545354906,
          75.25432494
        ],
        [
          0.00052372487186,
          0.05195851797558,
          81.7028444
        ],
        [
          0.00029289336738,
          0.06788934950295,
          74.9089194
        ],
        [
          0.00039284753349,
          0.06023989516807,
          77.61500902
        ],
        [
          0.00029485774859,
          0.0675660554818,
          75.09882267
        ],
        [
          0.00039377780159,
          0.05998676302594,
          77.83392752
        ],
        [
          0.00029290389297,
          0.06788727957307,
          74.910231
        ],
        [
          0.00050690934598,
          0.05362014296122,
          80.35005853
        ],
        [
          0.00029486780354,
          0.06756401591051,
          75.10014415
        ],
        [
          0.00052937817629,
          0.05248537679664,
          80.87053207
        ],
        [
          0.00029396070094,
          0.06765751814527,
          75.06192361
        ],
        [
          0.00041827817801,
          0.05831491193558,
          78.56049595
        ],
        [
          0.00029587358383,
          0.06733746310683,
          75.25299622
        ],
        [
          0.0004184574856,
          0.05809368555129,
          78.78760516
        ],
        [
          0.00029397076479,
          0.06765547663348,
          75.06324252
        ],
        [
          0.0005259170787,
          0.05210528994005,
          81.44704528
        ],
        [
          0.00029588314166,
          0.06733545354906,
          75.25432494
        ],
        [
          0.0005474773146,
          0.05101780351602,
          81.99998421
        ],
        [
          0.00030298305114,
          0.06710652115336,
          75.10953053
        ],
        [
          0.00043857203622,
          0.05742961196129,
          78.69172971
        ],
        [
          0.00030497044698,
          0.06678535687109,
          75.30210095
        ],
        [
          0.00057579383467,
          0.04909042080895,
          83.43657875
        ],
        [
          0.00030299357131,
          0.06710447103179,
          75.11085882
        ],
        [
          0.00054868861163,
          0.05128380389195,
          81.63208478
        ],
        [
          0.00030498041125,
          0.06678334081292,
          75.30343908
        ],
        [
          0.00066414491904,
          0.04410776494243,
          87.30590569
        ],
        [
          0.00030404710125,
          0.0668767805071,
          75.26452591
        ],
        [
          0.00046192352659,
          0.05567640794069,
          79.69799121
        ],
        [
          0.0003059729672,
          0.06655929969534,
          75.45826161
        ],
        [
          0.00058781380464,
          0.04781164294191,
          84.70076765
        ],
        [
          0.00030405709446,
          0.06687476146672,
          75.26586148
        ],
        [
          0.00056480521835,
          0.0498871580951,
          82.80140509
        ],
        [
          0.00030598236889,
          0.06655731621766,
          75.45960693
        ],
        [
          0.00066966500806,
          0.04298107113674,
          88.81708678
        ],
        [
          0.00030298305114,
          0.06710652115336,
          75.10953053
        ],
        [
          0.00049297012476,
          0.05453028257909,
          79.81818261
        ],
        [
          0.00030497044698,
          0.06678535687109,
          75.30210095
        ],
        [
          0.00062407510383,
          0.04671673923319,
          84.94093165
        ],
        [
          0.00030299357131,
          0.06710447103179,
          75.11085882
        ],
        [
          0.00059993302101,
          0.04879434495877,
          82.99366275
        ],
        [
          0.00030498041125,
          0.06678334081292,
          75.30343908
        ],
        [
          0.00073761062487,
          0.04098672279012,
          89.70481431
        ],
        [
          0.00030404710125,
          0.0668767805071,
          75.26452591
        ],
        [
          0.0005141300555,
          0.05293024905974,
          80.89244409
        ],
        [
          0.0003059729672,
          0.06655929969534,
          75.45826161
        ],
        [
          0.00063374866375,
          0.04550517135372,
          86.30467567
        ],
        [
          0.00030405709446,
          0.06687476146672,
          75.26586148
        ],
        [
          0.00061360166531,
          0.04748831014849,
          84.24914602
        ],
        [
          0.00030598236889,
          0.06655731621766,
          75.45960693
        ],
        [
          0.0007417463792,
          0.03986287345997,
          91.41767608
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00039593200239,
          0.0601842283825,
          77.54284774
        ],
        [
          0.00029625610884,
          0.0675337177347,
          75.05812008
        ],
        [
          0.00039715251228,
          0.05992511190314,
          77.75594407
        ],
        [
          0.00029411258597,
          0.06785924969208,
          74.87481577
        ],
        [
          0.00051142645578,
          0.05354928871237,
          80.26858408
        ],
        [
          0.00029626629279,
          0.0675316739776,
          75.05944049
        ],
        [
          0.00051051241716,
          0.05337002245398,
          80.50928584
        ],
        [
          0.00029525316052,
          0.06762746999916,
          75.02428133
        ],
        [
          0.00042193674775,
          0.05824952606688,
          78.48165123
        ],
        [
          0.00029735861388,
          0.06730301058805,
          75.21004358
        ],
        [
          0.00042243676537,
          0.05802163870686,
          78.70283791
        ],
        [
          0.00029526334423,
          0.0676254245829,
          75.02559924
        ],
        [
          0.00053114873901,
          0.05202274880424,
          81.35871039
        ],
        [
          0.00029736831021,
          0.0673009963793,
          75.21137119
        ],
        [
          0.00052937588236,
          0.05186809156291,
          81.60825605
        ],
        [
          0.0002941019514,
          0.06786132300305,
          74.87350513
        ],
        [
          0.00039593200239,
          0.0601842283825,
          77.54284774
        ],
        [
          0.00029625610884,
          0.0675337177347,
          75.05812008
        ],
        [
          0.00039715251228,
          0.05992511190314,
          77.75594407
        ],
        [
          0.00029411258597,
          0.06785924969208,
          74.87481577
        ],
        [
          0.00051142645578,
          0.05354928871237,
          80.26858408
        ],
        [
          0.00029626629279,
          0.0675316739776,
          75.05944049
        ],
        [
          0.00053448037297,
          0.05240798460161,
          80.78181992
        ],
        [
          0.00029525316052,
          0.06762746999916,
          75.02428133
        ],
        [
          0.00042193674775,
          0.05824952606688,
          78.48165123
        ],
        [
          0.00029735861388,
          0.06730301058805,
          75.21004358
        ],
        [
          0.00042243676537,
          0.05802163870686,
          78.70283791
        ],
        [
          0.00029526334423,
          0.0676254245829,
          75.02559924
        ],
        [
          0.00053114873901,
          0.05202274880424,
          81.35871039
        ],
        [
          0.00029736831021,
          0.0673009963793,
          75.21137119
        ],
        [
          0.00055334414376,
          0.05092813554498,
          81.90426163
        ],
        [
          0.0003042578946,
          0.06707824736697,
          75.07275813
        ],
        [
          0.00044244432581,
          0.05736443131502,
          78.61000149
        ],
        [
          0.00030644160018,
          0.06675275834115,
          75.25998988
        ],
        [
          0.00058335690781,
          0.04897757886735,
          83.32064207
        ],
        [
          0.00030426853681,
          0.0670761933098,
          75.07408544
        ],
        [
          0.00055421223065,
          0.05120083305061,
          81.54058579
        ],
        [
          0.00030645170794,
          0.06675073747492,
          75.26132692
        ],
        [
          0.00067399062374,
          0.04397214465004,
          87.17916202
        ],
        [
          0.00030540903941,
          0.06684645700239,
          75.22550443
        ],
        [
          0.00046646202305,
          0.0555999704775,
          79.60938407
        ],
        [
          0.00030753439212,
          0.06652453891858,
          75.41387963
        ],
        [
          0.00059629600097,
          0.04768373132048,
          84.57760656
        ],
        [
          0.00030541916427,
          0.06684443357641,
          75.22683898
        ],
        [
          0.00057111886069,
          0.04979152211357,
          82.70288079
        ],
        [
          0.00030754394726,
          0.0665225501418,
          75.41522384
        ],
        [
          0.00068055423988,
          0.04282890311694,
          88.68342273
        ],
        [
          0.0003042578946,
          0.06707824736697,
          75.07275813
        ],
        [
          0.00049768977714,
          0.0544570494441,
          79.72845701
        ],
        [
          0.00030644160018,
          0.06675275834115,
          75.25998988
        ],
        [
          0.00063287473988,
          0.04659302759647,
          84.81585326
        ],
        [
          0.00030426853681,
          0.0670761933098,
          75.07408544
        ],
        [
          0.00060648255769,
          0.04870202238162,
          82.89374942
        ],
        [
          0.00030645170794,
          0.06675073747492,
          75.26132692
        ],
        [
          0.0007492320559,
          0.04084118107434,
          89.56662142
        ],
        [
          0.00030540903941,
          0.06684645700239,
          75.22550443
        ],
        [
          0.00051959726668,
          0.05284485191639,
          80.79565206
        ],
        [
          0.00030753439212,
          0.06652453891858,
          75.41387963
        ],
        [
          0.00064354238803,
          0.04536575594725,
          86.17228739
        ],
        [
          0.00030541916427,
          0.06684443357641,
          75.22683898
        ],
        [
          0.00062101396431,
          0.04738270814397,
          84.14204701
        ],
        [
          0.00030754394726,
          0.0665225501418,
          75.41522384
        ],
        [
          0.00075453525199,
          0.03970034472921,
          91.27252143
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00039894759823,
          0.06013357886412,
          77.46930435
        ],
        [
          0.00029760122721,
          0.06750499146221,
          75.01711299
        ],
        [
          0.00040047071469,
          0.05986859159216,
          77.67608634
        ],
        [
          0.00029526172323,
          0.0678346524484,
          74.83952693
        ],
        [
          0.00051589656678,
          0.05348278076827,
          80.18498832
        ],
        [
          0.00029761154166,
          0.06750294334528,
          75.01843227
        ],
        [
          0.00051539382127,
          0.0532962981611,
          80.4189599
        ],
        [
          0.00029650492406,
          0.06760058170703,
          74.98608598
        ],
        [
          0.00042557477176,
          0.05818847387267,
          78.40015196
        ],
        [
          0.00029880998118,
          0.06727187359751,
          75.16610153
        ],
        [
          0.0004264113355,
          0.05795397319604,
          78.61490487
        ],
        [
          0.00029651522796,
          0.06759853230027,
          74.98740285
        ],
        [
          0.00053640531208,
          0.05194371286513,
          81.26683862
        ],
        [
          0.00029881981994,
          0.06726985447972,
          75.16742796
        ],
        [
          0.00053507577778,
          0.05178113416945,
          81.5095663
        ],
        [
          0.00029525097981,
          0.06783672925441,
          74.83821727
        ],
        [
          0.00039894759823,
          0.06013357886412,
          77.46930435
        ],
        [
          0.00029760122721,
          0.06750499146221,
          75.01711299
        ],
        [
          0.00040047071469,
          0.05986859159216,
          77.67608634
        ],
        [
          0.00029526172323,
          0.0678346524484,
          74.83952693
        ],
        [
          0.00051589656678,
          0.05348278076827,
          80.18498832
        ],
        [
          0.00029761154166,
          0.06750294334528,
          75.01843227
        ],
        [
          0.00053955378193,
          0.05233496834667,
          80.69038534
        ],
        [
          0.00029650492406,
          0.06760058170703,
          74.98608598
        ],
        [
          0.00042557477176,
          0.05818847387267,
          78.40015196
        ],
        [
          0.00029880998118,
          0.06727187359751,
          75.16610153
        ],
        [
          0.0004264113355,
          0.05795397319604,
          78.61490487
        ],
        [
          0.00029651522796,
          0.06759853230027,
          74.98740285
        ],
        [
          0.00053640531208,
          0.05194371286513,
          81.26683862
        ],
        [
          0.00029881981994,
          0.06726985447972,
          75.16742796
        ],
        [
          0.00055926046319,
          0.05084196152269,
          81.80435924
        ],
        [
          0.00030548475386,
          0.06705317802121,
          75.03566347
        ],
        [
          0.00044627523415,
          0.05730401762746,
          78.52590882
        ],
        [
          0.00030787144611,
          0.06672354223588,
          75.21711912
        ],
        [
          0.00059100276586,
          0.04886882792342,
          83.19942505
        ],
        [
          0.00030549551971,
          0.06705111985753,
          75.03698977
        ],
        [
          0.0005597351299,
          0.05112187167961,
          81.44583937
        ],
        [
          0.00030788170079,
          0.06672151632255,
          75.21845502
        ],
        [
          0.00068400146217,
          0.04384013054238,
          87.04562386
        ],
        [
          0.00030674275309,
          0.06681905528247,
          75.18547287
        ],
        [
          0.00047102028293,
          0.05552748902622,
          79.51706579
        ],
        [
          0.00030907480837,
          0.06649286532635,
          75.36804512
        ],
        [
          0.00060496298262,
          0.04755886428927,
          84.44752615
        ],
        [
          0.00030675301372,
          0.06681702721428,
          75.18680635
        ],
        [
          0.00057751715953,
          0.04969894417596,
          82.59961152
        ],
        [
          0.00030908452306,
          0.06649087091966,
          75.36938813
        ],
        [
          0.00069173357157,
          0.04267926931525,
          88.54107536
        ],
        [
          0.00030548475386,
          0.06705317802121,
          75.03566347
        ],
        [
          0.00050239154323,
          0.05438834552815,
          79.63564174
        ],
        [
          0.00030787144611,
          0.06672354223588,
          75.21711912
        ],
        [
          0.00064180752632,
          0.04647320091057,
          84.68445841
        ],
        [
          0.00030549551971,
          0.06705111985753,
          75.03698977
        ],
        [
          0.00061306825615,
          0.04861348973605,
          82.78972698
        ],
        [
          0.00030788170079,
          0.06672151632255,
          75.21845502
        ],
        [
          0.00076107958003,
          0.04069933568169,
          89.42006318
        ],
        [
          0.00030674275309,
          0.06681905528247,
          75.18547287
        ],
        [
          0.00052511975663,
          0.05276310356515,
          80.69434998
        ],
        [
          0.00030907480837,
          0.06649286532635,
          75.36804512
        ],
        [
          0.00065358241127,
          0.04522918782262,
          86.031826
        ],
        [
          0.00030675301372,
          0.06681702721428,
          75.18680635
        ],
        [
          0.00062855867759,
          0.04727993341016,
          84.02924482
        ],
        [
          0.00030908452306,
          0.06649087091966,
          75.36938813
        ],
        [
          0.00076768855139,
          0.03954054186701,
          91.11685701
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00040190054783,
          0.06008814802742,
          77.3938571
        ],
        [
          0.00029888481301,
          0.067480192348,
          74.97589619
        ],
        [
          0.0004037299328,
          0.05981759930225,
          77.59399097
        ],
        [
          0.00029634960266,
          0.06781360758085,
          74.80431203
        ],
        [
          0.00052039296827,
          0.05341988459465,
          80.0974667
        ],
        [
          0.00029889526101,
          0.06747813959187,
          74.97721433
        ],
        [
          0.00052031046594,
          0.05322641651606,
          80.32432399
        ],
        [
          0.00029768709635,
          0.06757758591977,
          74.948089
        ],
        [
          0.00042917925141,
          0.05813235883732,
          78.31584747
        ],
        [
          0.0003001914389,
          0.06724500956295,
          75.12207296
        ],
        [
          0.0004303579269,
          0.05789153325062,
          78.52381333
        ],
        [
          0.0002976975185,
          0.06757553249501,
          74.94940482
        ],
        [
          0.00054173970252,
          0.05186782874561,
          81.16999603
        ],
        [
          0.00030020142111,
          0.06724298536507,
          75.12339819
        ],
        [
          0.00054086526997,
          0.05169752301545,
          81.4055033
        ],
        [
          0.00029633875038,
          0.0678156880089,
          74.80300337
        ],
        [
          0.00040190054783,
          0.06008814802742,
          77.3938571
        ],
        [
          0.00029888481301,
          0.067480192348,
          74.97589619
        ],
        [
          0.0004037299328,
          0.05981759930225,
          77.59399097
        ],
        [
          0.00029634960266,
          0.06781360758085,
          74.80431203
        ],
        [
          0.00052039296827,
          0.05341988459465,
          80.0974667
        ],
        [
          0.00029889526101,
          0.06747813959187,
          74.97721433
        ],
        [
          0.00054466386269,
          0.0522657727771,
          80.59457468
        ],
        [
          0.00029768709635,
          0.06757758591977,
          74.948089
        ],
        [
          0.00042917925141,
          0.05813235883732,
          78.31584747
        ],
        [
          0.0003001914389,
          0.06724500956295,
          75.12207296
        ],
        [
          0.0004303579269,
          0.05789153325062,
          78.52381333
        ],
        [
          0.0002976975185,
          0.06757553249501,
          74.94940482
        ],
        [
          0.00054173970252,
          0.05186782874561,
          81.16999603
        ],
        [
          0.00030020142111,
          0.06724298536507,
          75.12339819
        ],
        [
          0.00056526894023,
          0.0507591450405,
          81.69899475
        ],
        [
          0.0003066455671,
          0.06703179505739,
          74.99866218
        ],
        [
          0.00045006082252,
          0.05724881454895,
          78.43908189
        ],
        [
          0.0003092348967,
          0.06669839119673,
          75.17405518
        ],
        [
          0.00059889630999,
          0.04876249555539,
          83.06956419
        ],
        [
          0.00030665645679,
          0.0670297326526,
          74.99998745
        ],
        [
          0.00056532546908,
          0.05104636905127,
          81.34616462
        ],
        [
          0.00030924529979,
          0.06669636005002,
          75.17538991
        ],
        [
          0.00069448891036,
          0.04370841092418,
          86.90023332
        ],
        [
          0.00030800179429,
          0.06679568193997,
          75.14565953
        ],
        [
          0.00047557145481,
          0.05545985769299,
          79.42104735
        ],
        [
          0.00031054032565,
          0.06646559599127,
          75.32214097
        ],
        [
          0.00061395960304,
          0.04743574981353,
          84.30751
        ],
        [
          0.0003080121907,
          0.06679364910095,
          75.14699192
        ],
        [
          0.00058404298646,
          0.04960933966139,
          82.49029138
        ],
        [
          0.00031055020124,
          0.06646359577437,
          75.32348276
        ],
        [
          0.00070349084975,
          0.04252928399932,
          88.38531488
        ],
        [
          0.0003066455671,
          0.06703179505739,
          74.99866218
        ],
        [
          0.00050708561654,
          0.05432445372527,
          79.53901939
        ],
        [
          0.0003092348967,
          0.06669839119673,
          75.17405518
        ],
        [
          0.00065107907067,
          0.04635525463024,
          84.54287739
        ],
        [
          0.00030665645679,
          0.0670297326526,
          74.99998745
        ],
        [
          0.00061978620695,
          0.04852793994437,
          82.67949379
        ],
        [
          0.00030924529979,
          0.06669636005002,
          75.17538991
        ],
        [
          0.00077353153193,
          0.040557563589,
          89.25935996
        ],
        [
          0.00030800179429,
          0.06679568193997,
          75.14565953
        ],
        [
          0.00053068326054,
          0.05268574007278,
          80.58820049
        ],
        [
          0.00031054032565,
          0.06646559599127,
          75.32214097
        ],
        [
          0.00066405298768,
          0.04509384764587,
          85.87976102
        ],
        [
          0.0003080121907,
          0.06679364910095,
          75.14699192
        ],
        [
          0.00063630607542,
          0.04717962228167,
          83.90900818
        ],
        [
          0.00031055020124,
          0.06646359577437,
          75.32348276
        ],
        [
          0.00078155930347,
          0.03938026088377,
          90.94521231
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.0004049141156,
          0.06004665797552,
          77.31272592
        ],
        [
          0.00030017904169,
          0.06745827494574,
          74.9318267
        ],
        [
          0.00040706119596,
          0.05977076143795,
          77.50566755
        ],
        [
          0.00029744412963,
          0.06779507624663,
          74.76671661
        ],
        [
          0.00052503475043,
          0.05335957120931,
          80.00302193
        ],
        [
          0.00030018962921,
          0.06745621726534,
          74.93314358
        ],
        [
          0.00052539205696,
          0.05315921594787,
          80.22215893
        ],
        [
          0.000298886401,
          0.06755710539929,
          74.90721363
        ],
        [
          0.00043287436025,
          0.05807994671141,
          78.22511323
        ],
        [
          0.00030159458855,
          0.0672210109628,
          75.07468883
        ],
        [
          0.00043441046549,
          0.05783291912848,
          78.42573373
        ],
        [
          0.00029889695274,
          0.06755504738248,
          74.90852827
        ],
        [
          0.00054726510784,
          0.05179418279668,
          81.0653889
        ],
        [
          0.00030160472597,
          0.06721898111277,
          75.07601273
        ],
        [
          0.00054686844882,
          0.05161621918588,
          81.29304425
        ],
        [
          0.00029743316081,
          0.06779716069662,
          74.76540904
        ],
        [
          0.0004049141156,
          0.06004665797552,
          77.31272592
        ],
        [
          0.00030017904169,
          0.06745827494574,
          74.9318267
        ],
        [
          0.00040706119596,
          0.05977076143795,
          77.50566755
        ],
        [
          0.00029744412963,
          0.06779507624663,
          74.76671661
        ],
        [
          0.00052503475043,
          0.05335957120931,
          80.00302193
        ],
        [
          0.00030018962921,
          0.06745621726534,
          74.93314358
        ],
        [
          0.00054994518819,
          0.05219926360611,
          80.4911218
        ],
        [
          0.000298886401,
          0.06755710539929,
          74.90721363
        ],
        [
          0.00043287436025,
          0.05807994671141,
          78.22511323
        ],
        [
          0.00030159458855,
          0.0672210109628,
          75.07468883
        ],
        [
          0.00043441046549,
          0.05783291912848,
          78.42573373
        ],
        [
          0.00029889695274,
          0.06755504738248,
          74.90852827
        ],
        [
          0.00054726510784,
          0.05179418279668,
          81.0653889
        ],
        [
          0.00030160472597,
          0.06721898111277,
          75.07601273
        ],
        [
          0.00057149863249,
          0.05067865485243,
          81.58510345
        ],
        [
          0.00030781145167,
          0.06701306798232,
          74.95922223
        ],
        [
          0.00045398133928,
          0.05719692658617,
          78.34463385
        ],
        [
          0.00031060777083,
          0.06667625359844,
          75.12807431
        ],
        [
          0.0006073687018,
          0.04865538513826,
          82.92438419
        ],
        [
          0.00030782247388,
          0.06701100089521,
          74.96054637
        ],
        [
          0.00057117155316,
          0.05097253230777,
          81.23740915
        ],
        [
          0.00031061833322,
          0.06667421668183,
          75.12940775
        ],
        [
          0.00070578423228,
          0.04357425252954,
          86.73695799
        ],
        [
          0.00030927673812,
          0.06677496637507,
          75.10290483
        ],
        [
          0.00048030192257,
          0.05539508983017,
          79.31659079
        ],
        [
          0.00031202657828,
          0.06644132901096,
          75.27281271
        ],
        [
          0.00062362248808,
          0.04731114637316,
          84.15101786
        ],
        [
          0.00030928728108,
          0.06677292824007,
          75.10423602
        ],
        [
          0.00059088218419,
          0.04952097386195,
          82.3709507
        ],
        [
          0.00031203662796,
          0.06643932235629,
          75.27415314
        ],
        [
          0.0007161531362,
          0.04237634030337,
          88.21024498
        ],
        [
          0.00030781145167,
          0.06701306798232,
          74.95922223
        ],
        [
          0.00051197700597,
          0.05426338553712,
          79.4335328
        ],
        [
          0.00031060777083,
          0.06667625359844,
          75.12807431
        ],
        [
          0.0006610545444,
          0.04623592226178,
          84.3841718
        ],
        [
          0.00030782247388,
          0.06701100089521,
          74.96054637
        ],
        [
          0.0006268438777,
          0.04844357462424,
          82.5587393
        ],
        [
          0.00031061833322,
          0.06667421668183,
          75.12940775
        ],
        [
          0.0007869546393,
          0.04041327652909,
          89.07804998
        ],
        [
          0.00030927673812,
          0.06677496637507,
          75.10290483
        ],
        [
          0.00053649814629,
          0.05261068924473,
          80.47230248
        ],
        [
          0.00031202657828,
          0.06644132901096,
          75.27281271
        ],
        [
          0.00067532241811,
          0.04495647510031,
          85.709281
        ],
        [
          0.00030928728108,
          0.06677292824007,
          75.10423602
        ],
        [
          0.00064445851054,
          0.04708007838239,
          83.77721414
        ],
        [
          0.00031203662796,
          0.06643932235629,
          75.27415314
        ],
        [
          0.00079650541717,
          0.03921712700051,
          90.75122344
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00040803081191,
          0.06000963379498,
          77.22370857
        ],
        [
          0.00030153880562,
          0.06743910308512,
          74.88235156
        ],
        [
          0.00041052451563,
          0.05972846212194,
          77.40836226
        ],
        [
          0.00029858819223,
          0.06777900064604,
          74.72469074
        ],
        [
          0.00052995020639,
          0.05330125320476,
          79.89795838
        ],
        [
          0.00030154955242,
          0.06743703955763,
          74.88366699
        ],
        [
          0.00053079383814,
          0.05309382991265,
          80.10816696
        ],
        [
          0.00030015521294,
          0.06753902824034,
          74.86100291
        ],
        [
          0.00043676621819,
          0.05803093028346,
          78.12420428
        ],
        [
          0.00030308400809,
          0.06719968551375,
          75.02098605
        ],
        [
          0.00043869464818,
          0.05777766973242,
          78.3163405
        ],
        [
          0.00030016591189,
          0.0675369648291,
          74.86231619
        ],
        [
          0.00055320347926,
          0.0517210295736,
          80.94761559
        ],
        [
          0.00030309432414,
          0.06719764893944,
          75.0223084
        ],
        [
          0.00055333800629,
          0.05153512419655,
          81.16616775
        ],
        [
          0.00029857709281,
          0.0677810897735,
          74.72338443
        ],
        [
          0.00040803081191,
          0.06000963379498,
          77.22370857
        ],
        [
          0.00030153880562,
          0.06743910308512,
          74.88235156
        ],
        [
          0.00041052451563,
          0.05972846212194,
          77.40836226
        ],
        [
          0.00029858819223,
          0.06777900064604,
          74.72469074
        ],
        [
          0.00052995020639,
          0.05330125320476,
          79.89795838
        ],
        [
          0.00030154955242,
          0.06743703955763,
          74.88366699
        ],
        [
          0.00055555924931,
          0.05213459026441,
          80.37566738
        ],
        [
          0.00030015521294,
          0.06753902824034,
          74.86100291
        ],
        [
          0.00043676621819,
          0.05803093028346,
          78.12420428
        ],
        [
          0.00030308400809,
          0.06719968551375,
          75.02098605
        ],
        [
          0.00043869464818,
          0.05777766973242,
          78.3163405
        ],
        [
          0.00030016591189,
          0.0675369648291,
          74.86231619
        ],
        [
          0.00055320347926,
          0.0517210295736,
          80.94761559
        ],
        [
          0.00030309432414,
          0.06719764893944,
          75.0223084
        ],
        [
          0.00057821194425,
          0.05059841808579,
          81.45658048
        ],
        [
          0.0003090417006,
          0.06699676857708,
          74.91470751
        ],
        [
          0.00045806310186,
          0.05714926141411,
          78.24071413
        ],
        [
          0.00031206177384,
          0.06665682858692,
          75.07603104
        ],
        [
          0.00061644091191,
          0.04854908647739,
          82.761759
        ],
        [
          0.00030905287296,
          0.06699469601292,
          74.91603033
        ],
        [
          0.00057738747079,
          0.05090015910917,
          81.11620276
        ],
        [
          0.00031207251754,
          0.06665478492106,
          75.07736297
        ],
        [
          0.00071802208644,
          0.04343808018488,
          86.55184625
        ],
        [
          0.00031063686332,
          0.06675662092293,
          75.05415951
        ],
        [
          0.0004853081351,
          0.05533323366528,
          79.20025142
        ],
        [
          0.00031361564111,
          0.0664196927533,
          75.2164982
        ],
        [
          0.00063407747053,
          0.04718548313339,
          83.97410838
        ],
        [
          0.00031064757425,
          0.06675457654384,
          75.05548928
        ],
        [
          0.00059824966752,
          0.0494324618914,
          82.23646385
        ],
        [
          0.0003136258908,
          0.06641767852191,
          75.21783702
        ],
        [
          0.00072998985483,
          0.04221949130664,
          88.00988039
        ],
        [
          0.0003090417006,
          0.06699676857708,
          74.91470751
        ],
        [
          0.00051707272344,
          0.05420634017196,
          79.31774562
        ],
        [
          0.00031206177384,
          0.06665682858692,
          75.07603104
        ],
        [
          0.0006717220539,
          0.04611728824883,
          84.20663081
        ],
        [
          0.00030905287296,
          0.06699469601292,
          74.91603033
        ],
        [
          0.00063433800898,
          0.04836052192148,
          82.42448318
        ],
        [
          0.00031207251754,
          0.06665478492106,
          75.07736297
        ],
        [
          0.00080144979568,
          0.04026757462478,
          88.87240397
        ],
        [
          0.00031063686332,
          0.06675662092293,
          75.05415951
        ],
        [
          0.00054264945788,
          0.05253825929172,
          80.34357605
        ],
        [
          0.00031361564111,
          0.0664196927533,
          75.2164982
        ],
        [
          0.000687491777,
          0.04481800537826,
          85.51678084
        ],
        [
          0.00031064757425,
          0.06675457654384,
          75.05548928
        ],
        [
          0.00065322145575,
          0.04698025427054,
          83.62905949
        ],
        [
          0.0003136258908,
          0.06641767852191,
          75.21783702
        ],
        [
          0.00081277566368,
          0.03905091148363,
          90.52896498
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00041103952411,
          0.05998061575121,
          77.13179361
        ],
        [
          0.0003027787094,
          0.06742587539897,
          74.83368308
        ],
        [
          0.00041382693043,
          0.05969531387037,
          77.30924386
        ],
        [
          0.00029965304164,
          0.06776775639896,
          74.68245753
        ],
        [
          0.00053478567179,
          0.05325013086054,
          79.78875129
        ],
        [
          0.00030278959183,
          0.0674238069738,
          74.83499713
        ],
        [
          0.00053604454471,
          0.05303697734888,
          79.99118147
        ],
        [
          0.0003013207152,
          0.06752641584644,
          74.81521148
        ],
        [
          0.00044052940711,
          0.05799052599125,
          78.020412
        ],
        [
          0.00030442875258,
          0.06718495885051,
          74.96872266
        ],
        [
          0.00044279250296,
          0.05773226765001,
          78.20516796
        ],
        [
          0.00030133156023,
          0.06752434690179,
          74.81652337
        ],
        [
          0.00055904364491,
          0.05165575595059,
          80.82563644
        ],
        [
          0.0003044392395,
          0.06718291571362,
          74.97004345
        ],
        [
          0.00055963297566,
          0.05146336760706,
          81.03624528
        ],
        [
          0.00029964181079,
          0.06776985041286,
          74.68115253
        ],
        [
          0.00041103952411,
          0.05998061575121,
          77.13179361
        ],
        [
          0.0003027787094,
          0.06742587539897,
          74.83368308
        ],
        [
          0.00041382693043,
          0.05969531387037,
          77.30924386
        ],
        [
          0.00029965304164,
          0.06776775639896,
          74.68245753
        ],
        [
          0.00053478567179,
          0.05325013086054,
          79.78875129
        ],
        [
          0.00030278959183,
          0.0674238069738,
          74.83499713
        ],
        [
          0.00056101700964,
          0.0520783864806,
          80.25715471
        ],
        [
          0.0003013207152,
          0.06752641584644,
          74.81521148
        ],
        [
          0.00044052940711,
          0.05799052599125,
          78.020412
        ],
        [
          0.00030442875258,
          0.06718495885051,
          74.96872266
        ],
        [
          0.00044279250296,
          0.05773226765001,
          78.20516796
        ],
        [
          0.00030133156023,
          0.06752434690179,
          74.81652337
        ],
        [
          0.00055904364491,
          0.05165575595059,
          80.82563644
        ],
        [
          0.0003044392395,
          0.06718291571362,
          74.97004345
        ],
        [
          0.0005847440275,
          0.05052747434917,
          81.324935
        ],
        [
          0.00031018979652,
          0.06698547586183,
          74.86984647
        ],
        [
          0.00046203851639,
          0.05711007600274,
          78.13295385
        ],
        [
          0.00031339194403,
          0.06664350776803,
          75.02466358
        ],
        [
          0.00062545961995,
          0.04845271104176,
          82.59178413
        ],
        [
          0.00031020112074,
          0.06698339757576,
          74.87116793
        ],
        [
          0.00058354279749,
          0.05083536276861,
          80.98972319
        ],
        [
          0.00031340286754,
          0.0666414572177,
          75.02599397
        ],
        [
          0.00073028798951,
          0.04331166581388,
          86.35686947
        ],
        [
          0.00031189020796,
          0.06674390251153,
          75.00569925
        ],
        [
          0.00049019117036,
          0.05528041074422,
          79.08004311
        ],
        [
          0.00031505558806,
          0.06640479986148,
          75.16149616
        ],
        [
          0.00064446823023,
          0.04707062956556,
          83.78953555
        ],
        [
          0.00031190108665,
          0.06674185171139,
          75.00702757
        ],
        [
          0.00060554124928,
          0.0493522413566,
          82.09656645
        ],
        [
          0.00031506603432,
          0.06640277799537,
          75.16283338
        ],
        [
          0.00074383825036,
          0.042073678512,
          87.79900822
        ],
        [
          0.00031018979652,
          0.06698547586183,
          74.86984647
        ],
        [
          0.00052210067775,
          0.05415753470216,
          79.19657696
        ],
        [
          0.00031339194403,
          0.06664350776803,
          75.02466358
        ],
        [
          0.0006824112822,
          0.04600835782592,
          84.01964084
        ],
        [
          0.00031020112074,
          0.06698339757576,
          74.87116793
        ],
        [
          0.00064183347139,
          0.0482848126655,
          82.28314491
        ],
        [
          0.00031340286754,
          0.0666414572177,
          75.02599397
        ],
        [
          0.00081605942913,
          0.04013181591482,
          88.65382484
        ],
        [
          0.00031189020796,
          0.06674390251153,
          75.00569925
        ],
        [
          0.00054872133213,
          0.0524745919509,
          80.20937407
        ],
        [
          0.00031505558806,
          0.06640479986148,
          75.16149616
        ],
        [
          0.00069967436156,
          0.04469021660052,
          85.31436842
        ],
        [
          0.00031190108665,
          0.06674185171139,
          75.00702757
        ],
        [
          0.00066197424433,
          0.04688850782706,
          83.47358201
        ],
        [
          0.00031506603432,
          0.06640277799537,
          75.16283338
        ],
        [
          0.00082913958882,
          0.03889611887951,
          90.29277452
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00041378132869,
          0.05996151564622,
          77.04131739
        ],
        [
          0.00030384007688,
          0.06741903978806,
          74.78820741
        ],
        [
          0.00041685162734,
          0.05967280309309,
          77.21132248
        ],
        [
          0.00030054962705,
          0.06776215605573,
          74.64360818
        ],
        [
          0.00053939514944,
          0.05320825172836,
          79.67799361
        ],
        [
          0.00030385112822,
          0.06741696451503,
          74.78951993
        ],
        [
          0.00054106260389,
          0.05298997171184,
          79.87234824
        ],
        [
          0.00030232814679,
          0.06751976594334,
          74.77201285
        ],
        [
          0.00044404200853,
          0.05796049905656,
          77.91646044
        ],
        [
          0.00030560552321,
          0.06717693300406,
          74.91885514
        ],
        [
          0.00044663099377,
          0.05769791657349,
          78.09357329
        ],
        [
          0.00030233913003,
          0.06751769157555,
          74.77332338
        ],
        [
          0.00056471000251,
          0.05159976157998,
          80.70023042
        ],
        [
          0.0003056161756,
          0.06717488328362,
          74.92017439
        ],
        [
          0.0005657498038,
          0.05140147720169,
          80.9025696
        ],
        [
          0.00030053827509,
          0.06776425475076,
          74.64230441
        ],
        [
          0.00041378132869,
          0.05996151564622,
          77.04131739
        ],
        [
          0.00030384007688,
          0.06741903978806,
          74.78820741
        ],
        [
          0.00041685162734,
          0.05967280309309,
          77.21132248
        ],
        [
          0.00030054962705,
          0.06776215605573,
          74.64360818
        ],
        [
          0.00053939514944,
          0.05320825172836,
          79.67799361
        ],
        [
          0.00030385112822,
          0.06741696451503,
          74.78951993
        ],
        [
          0.00056623420359,
          0.05203193873073,
          80.13674834
        ],
        [
          0.00030232814679,
          0.06751976594334,
          74.77201285
        ],
        [
          0.00044404200853,
          0.05796049905656,
          77.91646044
        ],
        [
          0.00030560552321,
          0.06717693300406,
          74.91885514
        ],
        [
          0.00044663099377,
          0.05769791657349,
          78.09357329
        ],
        [
          0.00030233913003,
          0.06751769157555,
          74.77332338
        ],
        [
          0.00056471000251,
          0.05159976157998,
          80.70023042
        ],
        [
          0.0003056161756,
          0.06717488328362,
          74.92017439
        ],
        [
          0.00059109198915,
          0.05046632795087,
          81.18945333
        ],
        [
          0.00031115448097,
          0.06698004892374,
          74.82865983
        ],
        [
          0.00046570510949,
          0.05708180387481,
          78.02620812
        ],
        [
          0.00031452785558,
          0.06663681019805,
          74.9767781
        ],
        [
          0.00063419925835,
          0.0483693472075,
          82.41758542
        ],
        [
          0.00031116594701,
          0.0669779650821,
          74.82998
        ],
        [
          0.00058944921017,
          0.05078066378719,
          80.86103859
        ],
        [
          0.00031453894747,
          0.06663475300647,
          74.97810702
        ],
        [
          0.00074244190343,
          0.0431972624995,
          86.15287559
        ],
        [
          0.00031297032604,
          0.06673738576472,
          74.96011527
        ],
        [
          0.00049479106088,
          0.05523885849522,
          78.95915004
        ],
        [
          0.0003163118824,
          0.06639685462681,
          75.10917202
        ],
        [
          0.00065465875932,
          0.04696881211904,
          83.59847472
        ],
        [
          0.00031298136325,
          0.06673532870931,
          74.96144218
        ],
        [
          0.00061264575181,
          0.04928215430864,
          81.95245013
        ],
        [
          0.0003163225167,
          0.06639482525925,
          75.11050765
        ],
        [
          0.00075768598033,
          0.04193990723872,
          87.57627839
        ],
        [
          0.00031115448097,
          0.06698004892374,
          74.82865983
        ],
        [
          0.00052679689868,
          0.0541200767311,
          79.07560462
        ],
        [
          0.00031452785558,
          0.06663681019805,
          74.9767781
        ],
        [
          0.00069282969563,
          0.04591288208333,
          83.82703306
        ],
        [
          0.00031116594701,
          0.0669779650821,
          74.82998
        ],
        [
          0.00064908371929,
          0.04821952881209,
          82.13847841
        ],
        [
          0.00031453894747,
          0.06663475300647,
          74.97810702
        ],
        [
          0.00083057318226,
          0.04000888431215,
          88.42381174
        ],
        [
          0.00031297032604,
          0.06673738576472,
          74.96011527
        ],
        [
          0.00055449942543,
          0.05242252822668,
          80.07354858
        ],
        [
          0.0003163118824,
          0.06639685462681,
          75.10917202
        ],
        [
          0.00071167601329,
          0.04457596871004,
          85.10384915
        ],
        [
          0.00031298136325,
          0.06673532870931,
          74.96144218
        ],
        [
          0.0006705547434,
          0.04680722980564,
          83.31259715
        ],
        [
          0.0003163225167,
          0.06639482525925,
          75.11050765
        ],
        [
          0.00084552663597,
          0.03875442754684,
          90.04180351
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00041631429577,
          0.05995219064918,
          76.94994316
        ],
        [
          0.00030480745408,
          0.06741799137266,
          74.74229603
        ],
        [
          0.00041964762661,
          0.05966085547625,
          77.1125334
        ],
        [
          0.00030136826914,
          0.06776152725664,
          74.6042779
        ],
        [
          0.00054380848488,
          0.05317581030319,
          79.56427752
        ],
        [
          0.00030481865437,
          0.06741591004133,
          74.74360706
        ],
        [
          0.0005458632421,
          0.05295316255279,
          79.75055462
        ],
        [
          0.00030323452249,
          0.06751862930675,
          74.72897293
        ],
        [
          0.00044730218489,
          0.05794120532839,
          77.81185558
        ],
        [
          0.00030666485775,
          0.06717524087662,
          74.86919394
        ],
        [
          0.00045019652114,
          0.05767509941535,
          77.98134878
        ],
        [
          0.00030324564371,
          0.06751654932307,
          74.73028206
        ],
        [
          0.00057013823588,
          0.05155420757017,
          80.57201078
        ],
        [
          0.00030667567551,
          0.06717318435955,
          74.8705116
        ],
        [
          0.0005716069516,
          0.05135081112222,
          80.76606849
        ],
        [
          0.00030135679446,
          0.06776363088897,
          74.60297542
        ],
        [
          0.00041631429577,
          0.05995219064918,
          76.94994316
        ],
        [
          0.00030480745408,
          0.06741799137266,
          74.74229603
        ],
        [
          0.00041964762661,
          0.05966085547625,
          77.1125334
        ],
        [
          0.00030136826914,
          0.06776152725664,
          74.6042779
        ],
        [
          0.00054380848488,
          0.05317581030319,
          79.56427752
        ],
        [
          0.00030481865437,
          0.06741591004133,
          74.74360706
        ],
        [
          0.00057122717469,
          0.0519955912721,
          80.0133138
        ],
        [
          0.00030323452249,
          0.06751862930675,
          74.72897293
        ],
        [
          0.00044730218489,
          0.05794120532839,
          77.81185558
        ],
        [
          0.00030666485775,
          0.06717524087662,
          74.86919394
        ],
        [
          0.00045019652114,
          0.05767509941535,
          77.98134878
        ],
        [
          0.00030324564371,
          0.06751654932307,
          74.73028206
        ],
        [
          0.00057013823588,
          0.05155420757017,
          80.57201078
        ],
        [
          0.00030667567551,
          0.06717318435955,
          74.8705116
        ],
        [
          0.00059717180117,
          0.05041631582613,
          81.05107209
        ],
        [
          0.0003120447071,
          0.06697981292893,
          74.78650159
        ],
        [
          0.00046913696834,
          0.05706421133306,
          77.91776226
        ],
        [
          0.00031557320405,
          0.06663609979937,
          74.92796246
        ],
        [
          0.00064273055066,
          0.04829903671535,
          82.23652259
        ],
        [
          0.0003120563148,
          0.06697772339426,
          74.78782039
        ],
        [
          0.00059515119158,
          0.050736165554,
          80.72836174
        ],
        [
          0.00031558446829,
          0.06663403559405,
          74.92928982
        ],
        [
          0.0007544883697,
          0.04309572724081,
          85.93822477
        ],
        [
          0.00031395263349,
          0.0667365772089,
          74.91420226
        ],
        [
          0.00049911318698,
          0.05520891747563,
          78.83676101
        ],
        [
          0.00031745373519,
          0.06639542829992,
          75.0565636
        ],
        [
          0.00066460429592,
          0.04688121742094,
          83.40042501
        ],
        [
          0.00031396383101,
          0.06673451362159,
          74.91552771
        ],
        [
          0.00061950390051,
          0.049223318438,
          81.80442177
        ],
        [
          0.00031746455958,
          0.06639339113344,
          75.05789757
        ],
        [
          0.00077138115433,
          0.04182060915507,
          87.34238182
        ],
        [
          0.0003120447071,
          0.06697981292893,
          74.78650159
        ],
        [
          0.00053126845823,
          0.05409356935579,
          78.95134183
        ],
        [
          0.00031557320405,
          0.06663609979937,
          74.92796246
        ],
        [
          0.00070309151669,
          0.0458306275926,
          83.62527911
        ],
        [
          0.0003120563148,
          0.06697772339426,
          74.78782039
        ],
        [
          0.00065616720186,
          0.04816461871751,
          81.98788495
        ],
        [
          0.00031558446829,
          0.06663403559405,
          74.92928982
        ],
        [
          0.00084503910014,
          0.03989941936971,
          88.17970157
        ],
        [
          0.00031395263349,
          0.0667365772089,
          74.91420226
        ],
        [
          0.00056001300953,
          0.05238231069994,
          79.93456539
        ],
        [
          0.00031745373519,
          0.06639542829992,
          75.0565636
        ],
        [
          0.00072348430127,
          0.04447622240466,
          84.8838968
        ],
        [
          0.00031396383101,
          0.06673451362159,
          74.91552771
        ],
        [
          0.00067892816565,
          0.04673741075973,
          83.14565439
        ],
        [
          0.00031746455958,
          0.06639339113344,
          75.05789757
        ],
        [
          0.00086181504896,
          0.03862797498332,
          89.77583532
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00041868199157,
          0.05995332564585,
          76.85514685
        ],
        [
          0.00030565695991,
          0.06742304671371,
          74.69678578
        ],
        [
          0.00042225654067,
          0.05966013087301,
          77.01043229
        ],
        [
          0.00030208765367,
          0.06776616280114,
          74.56521918
        ],
        [
          0.00054816612383,
          0.05315283966963,
          79.44268768
        ],
        [
          0.00030566830805,
          0.06742095914337,
          74.69809528
        ],
        [
          0.00055058524432,
          0.05292653721181,
          79.62096594
        ],
        [
          0.00030407108871,
          0.06752345461281,
          74.68414645
        ],
        [
          0.00045048403214,
          0.0579327507758,
          77.69971987
        ],
        [
          0.00030763633858,
          0.06718033567005,
          74.81786558
        ],
        [
          0.00045366387077,
          0.05766381927925,
          77.8616836
        ],
        [
          0.00030408235385,
          0.06752136854829,
          74.68545408
        ],
        [
          0.00057567328403,
          0.05151747588746,
          80.43126483
        ],
        [
          0.00030764732768,
          0.06717827187086,
          74.81918154
        ],
        [
          0.0005775501149,
          0.05130964919919,
          80.61709264
        ],
        [
          0.00030207605709,
          0.06776827154311,
          74.56391803
        ],
        [
          0.00041868199157,
          0.05995332564585,
          76.85514685
        ],
        [
          0.00030565695991,
          0.06742304671371,
          74.69678578
        ],
        [
          0.00042225654067,
          0.05966013087301,
          77.01043229
        ],
        [
          0.00030208765367,
          0.06776616280114,
          74.56521918
        ],
        [
          0.00054816612383,
          0.05315283966963,
          79.44268768
        ],
        [
          0.00030566830805,
          0.06742095914337,
          74.69809528
        ],
        [
          0.00057614136527,
          0.05196931289205,
          79.88195158
        ],
        [
          0.00030407108871,
          0.06752345461281,
          74.68414645
        ],
        [
          0.00045048403214,
          0.0579327507758,
          77.69971987
        ],
        [
          0.00030763633858,
          0.06718033567005,
          74.81786558
        ],
        [
          0.00045366387077,
          0.05766381927925,
          77.8616836
        ],
        [
          0.00030408235385,
          0.06752136854829,
          74.68545408
        ],
        [
          0.00057567328403,
          0.05151747588746,
          80.43126483
        ],
        [
          0.00030764732768,
          0.06717827187086,
          74.81918154
        ],
        [
          0.00060334325122,
          0.05037573218251,
          80.90000562
        ],
        [
          0.00031282823772,
          0.06698512331485,
          74.74456033
        ],
        [
          0.00047238807085,
          0.05705796908671,
          77.80477966
        ],
        [
          0.00031649263893,
          0.0666417726778,
          74.87949376
        ],
        [
          0.00065112125113,
          0.04824245829352,
          82.04537703
        ],
        [
          0.00031283998859,
          0.06698302778834,
          74.74587772
        ],
        [
          0.0006008162727,
          0.0507016832949,
          80.58635337
        ],
        [
          0.00031650407486,
          0.06663970125691,
          74.88081952
        ],
        [
          0.00076664765844,
          0.04300668335647,
          85.70675476
        ],
        [
          0.00031485847245,
          0.06674202381885,
          74.86642669
        ],
        [
          0.00050336652649,
          0.05519033175789,
          78.705523
        ],
        [
          0.00031850053829,
          0.06640107720957,
          75.00221237
        ],
        [
          0.00067461933693,
          0.04680653635216,
          83.18703249
        ],
        [
          0.00031486983923,
          0.06673995308563,
          74.86775056
        ],
        [
          0.00062651357932,
          0.04917367909398,
          81.64214535
        ],
        [
          0.00031851155988,
          0.06639903171066,
          75.00354457
        ],
        [
          0.00078546824116,
          0.04171277979448,
          87.08539599
        ],
        [
          0.00031282823772,
          0.06698512331485,
          74.74456033
        ],
        [
          0.00053551260043,
          0.05407900110931,
          78.8226278
        ],
        [
          0.00031649263893,
          0.0666417726778,
          74.87949376
        ],
        [
          0.00071316700274,
          0.04576307677659,
          83.4130567
        ],
        [
          0.00031283998859,
          0.06698302778834,
          74.74587772
        ],
        [
          0.00066318207265,
          0.04812043296434,
          81.82776343
        ],
        [
          0.00031650407486,
          0.06663970125691,
          74.88081952
        ],
        [
          0.0008595682884,
          0.03980408422428,
          87.91713665
        ],
        [
          0.00031485847245,
          0.06674202381885,
          74.86642669
        ],
        [
          0.00056543251567,
          0.05235386963787,
          79.7866241
        ],
        [
          0.00031850053829,
          0.06640107720957,
          75.00221237
        ],
        [
          0.00073533594549,
          0.04439045214597,
          84.64785838
        ],
        [
          0.00031486983923,
          0.06673995308563,
          74.86775056
        ],
        [
          0.00068744139622,
          0.04667751862057,
          82.96398778
        ],
        [
          0.00031851155988,
          0.06639903171066,
          75.00354457
        ],
        [
          0.00087846553734,
          0.03851499514005,
          89.48434474
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00042095385081,
          0.05996689093259,
          76.7521564
        ],
        [
          0.00030645695858,
          0.06743554997927,
          74.64715889
        ],
        [
          0.00042476081528,
          0.05967257397923,
          76.89974397
        ],
        [
          0.00030276820276,
          0.06777731757574,
          74.52237137
        ],
        [
          0.00055259714135,
          0.05314086548045,
          79.30714102
        ],
        [
          0.00030646846802,
          0.06743345533982,
          74.64846667
        ],
        [
          0.00055537870663,
          0.05291146126197,
          79.47695184
        ],
        [
          0.00030485693119,
          0.06753557818683,
          74.63540979
        ],
        [
          0.00045357250181,
          0.05793750449697,
          77.57812907
        ],
        [
          0.00030854641786,
          0.06719365074465,
          74.76229718
        ],
        [
          0.00045703089105,
          0.05766643240218,
          77.73214895
        ],
        [
          0.00030486835282,
          0.06753348525287,
          74.63671573
        ],
        [
          0.00058132045091,
          0.0514920587157,
          80.27497863
        ],
        [
          0.00030855759266,
          0.06719157877578,
          74.76361123
        ],
        [
          0.00058360566126,
          0.05128033631582,
          80.45208052
        ],
        [
          0.00030275647258,
          0.06777943215598,
          74.52107173
        ],
        [
          0.00042095385081,
          0.05996689093259,
          76.7521564
        ],
        [
          0.00030645695858,
          0.06743554997927,
          74.64715889
        ],
        [
          0.00042476081528,
          0.05967257397923,
          76.89974397
        ],
        [
          0.00030276820276,
          0.06777731757574,
          74.52237137
        ],
        [
          0.00055259714135,
          0.05314086548045,
          79.30714102
        ],
        [
          0.00030646846802,
          0.06743345533982,
          74.64846667
        ],
        [
          0.00058113377541,
          0.05195446602057,
          79.73592534
        ],
        [
          0.00030485693119,
          0.06753557818683,
          74.63540979
        ],
        [
          0.00045357250181,
          0.05793750449697,
          77.57812907
        ],
        [
          0.00030854641786,
          0.06719365074465,
          74.76229718
        ],
        [
          0.00045703089105,
          0.05766643240218,
          77.73214895
        ],
        [
          0.00030486835282,
          0.06753348525287,
          74.63671573
        ],
        [
          0.00058132045091,
          0.0514920587157,
          80.27497863
        ],
        [
          0.00030855759266,
          0.06719157877578,
          74.76361123
        ],
        [
          0.00060963485453,
          0.05034689776433,
          80.73263053
        ],
        [
          0.00031356792457,
          0.06699732880156,
          74.69862984
        ],
        [
          0.00047554756336,
          0.0570649479033,
          77.68195001
        ],
        [
          0.00031735752015,
          0.06665525096803,
          74.82670301
        ],
        [
          0.00065976780568,
          0.04819959263745,
          81.83182159
        ],
        [
          0.00031357983242,
          0.06699522645913,
          74.69994565
        ],
        [
          0.00060660615045,
          0.05067849765568,
          80.42830264
        ],
        [
          0.00031736914532,
          0.06665317131134,
          74.82802696
        ],
        [
          0.00077948437459,
          0.04292905973641,
          85.44368827
        ],
        [
          0.00031570818487,
          0.06675514248243,
          74.81453892
        ],
        [
          0.00050754247875,
          0.05518552055854,
          78.56306797
        ],
        [
          0.00031948061233,
          0.0664152973093,
          74.94341325
        ],
        [
          0.00068496120059,
          0.04674582896528,
          82.94910116
        ],
        [
          0.00031571973187,
          0.06675306391912,
          74.81586101
        ],
        [
          0.00063369601067,
          0.04913566463875,
          81.46207911
        ],
        [
          0.00031949184796,
          0.06641324248813,
          74.94474346
        ],
        [
          0.00080032385664,
          0.04161700911325,
          86.79386281
        ],
        [
          0.00031356792457,
          0.06699732880156,
          74.69862984
        ],
        [
          0.0005397079779,
          0.05407774988179,
          78.68176328
        ],
        [
          0.00031735752015,
          0.06665525096803,
          74.82670301
        ],
        [
          0.00072362283031,
          0.04570908351843,
          83.17496805
        ],
        [
          0.00031357983242,
          0.06699522645913,
          74.69994565
        ],
        [
          0.00067041729663,
          0.04808743129689,
          81.64871073
        ],
        [
          0.00031736914532,
          0.06665317131134,
          74.82802696
        ],
        [
          0.00087494864879,
          0.03972088688462,
          87.61734573
        ],
        [
          0.00031570818487,
          0.06675514248243,
          74.81453892
        ],
        [
          0.00057083089355,
          0.05233915723135,
          79.62501588
        ],
        [
          0.00031948061233,
          0.0664152973093,
          74.94341325
        ],
        [
          0.0007476465259,
          0.04431865975241,
          84.38351675
        ],
        [
          0.00031571973187,
          0.06675306391912,
          74.81586101
        ],
        [
          0.00069623294526,
          0.04662918497089,
          82.76141288
        ],
        [
          0.00031949184796,
          0.06641324248813,
          74.94474346
        ],
        [
          0.00089605798593,
          0.03841518223627,
          89.15193713
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00042304922951,
          0.05999538983259,
          76.64160712
        ],
        [
          0.00030713118187,
          0.06745564506187,
          74.59694289
        ],
        [
          0.00042707738262,
          0.05970087154545,
          76.78097887
        ],
        [
          0.00030333664718,
          0.06779489699597,
          74.47935789
        ],
        [
          0.00055696010165,
          0.05314337813934,
          79.15847958
        ],
        [
          0.0003071428543,
          0.06745354299703,
          74.59824886
        ],
        [
          0.00056010020327,
          0.05291158849659,
          79.31920943
        ],
        [
          0.00030550974038,
          0.06755487155711,
          74.58683591
        ],
        [
          0.00045650733589,
          0.05795856932,
          77.44610161
        ],
        [
          0.00030931009316,
          0.06721527312785,
          74.70646688
        ],
        [
          0.00046023614264,
          0.05768618242133,
          77.59162781
        ],
        [
          0.00030552131778,
          0.06755277151054,
          74.5881401
        ],
        [
          0.00058697828958,
          0.05148167347505,
          80.10220883
        ],
        [
          0.00030932145454,
          0.06721319265152,
          74.70777894
        ],
        [
          0.00058967119679,
          0.0512667363085,
          80.2699261
        ],
        [
          0.00030332478184,
          0.06779701774802,
          74.47805981
        ],
        [
          0.00042304922951,
          0.05999538983259,
          76.64160712
        ],
        [
          0.00030713118187,
          0.06745564506187,
          74.59694289
        ],
        [
          0.00042707738262,
          0.05970087154545,
          76.78097887
        ],
        [
          0.00030333664718,
          0.06779489699597,
          74.47935789
        ],
        [
          0.00055696010165,
          0.05314337813934,
          79.15847958
        ],
        [
          0.0003071428543,
          0.06745354299703,
          74.59824886
        ],
        [
          0.00058605722071,
          0.05195462838402,
          79.57594372
        ],
        [
          0.00030550974038,
          0.06755487155711,
          74.58683591
        ],
        [
          0.00045650733589,
          0.05795856932,
          77.44610161
        ],
        [
          0.00030931009316,
          0.06721527312785,
          74.70646688
        ],
        [
          0.00046023614264,
          0.05768618242133,
          77.59162781
        ],
        [
          0.00030552131778,
          0.06755277151054,
          74.5881401
        ],
        [
          0.00058697828958,
          0.05148167347505,
          80.10220883
        ],
        [
          0.00030932145454,
          0.06721319265152,
          74.70777894
        ],
        [
          0.00061594263986,
          0.05033360318926,
          80.54781881
        ],
        [
          0.00031418563339,
          0.06701634981252,
          74.65246693
        ],
        [
          0.00047852535145,
          0.05708808566489,
          77.5494399
        ],
        [
          0.00031808669076,
          0.06667668908296,
          74.77324972
        ],
        [
          0.00066836861269,
          0.04817579949817,
          81.59858226
        ],
        [
          0.00031419769908,
          0.06701424035265,
          74.65378107
        ],
        [
          0.00061237198093,
          0.05067041922927,
          80.25451707
        ],
        [
          0.00031809850582,
          0.06667460088377,
          74.77457177
        ],
        [
          0.00079258178025,
          0.04286960583792,
          85.15200907
        ],
        [
          0.00031641506115,
          0.06677578079038,
          74.76274814
        ],
        [
          0.00051158003671,
          0.05519783625585,
          78.40786563
        ],
        [
          0.00032030396503,
          0.066438175663,
          74.88428114
        ],
        [
          0.00069537557396,
          0.0467046296422,
          82.68743665
        ],
        [
          0.00031642679007,
          0.06677369402415,
          74.76406839
        ],
        [
          0.00064095250125,
          0.04911318537913,
          81.26264628
        ],
        [
          0.00032031541633,
          0.06643611114698,
          74.88560927
        ],
        [
          0.0008155972745,
          0.04154009522791,
          86.46857538
        ],
        [
          0.00031418563339,
          0.06701634981252,
          74.65246693
        ],
        [
          0.00054373273844,
          0.05409307678028,
          78.52924105
        ],
        [
          0.00031808669076,
          0.06667668908296,
          74.77324972
        ],
        [
          0.00073409685355,
          0.04567450374875,
          82.91418787
        ],
        [
          0.00031419769908,
          0.06701424035265,
          74.65378107
        ],
        [
          0.00067768320117,
          0.04806980273568,
          81.45137454
        ],
        [
          0.00031809850582,
          0.06667460088377,
          74.77457177
        ],
        [
          0.00089067649019,
          0.03965704175372,
          87.28381542
        ],
        [
          0.00031641506115,
          0.06677578079038,
          74.76274814
        ],
        [
          0.00057612187089,
          0.05234175674894,
          79.4484697
        ],
        [
          0.00032030396503,
          0.066438175663,
          74.88428114
        ],
        [
          0.00076010760747,
          0.0442668466718,
          84.09203149
        ],
        [
          0.00031642679007,
          0.06677369402415,
          74.76406839
        ],
        [
          0.00070516946529,
          0.04659667126124,
          82.53661196
        ],
        [
          0.00032031541633,
          0.06643611114698,
          74.88560927
        ],
        [
          0.00091416356942,
          0.03833579255378,
          88.77972461
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00042491981295,
          0.06004208458265,
          76.52209065
        ],
        [
          0.00030770793196,
          0.0674859695049,
          74.54242119
        ],
        [
          0.00042915103232,
          0.05974840294845,
          76.6528428
        ],
        [
          0.0003038261749,
          0.06782161593483,
          74.43216552
        ],
        [
          0.00056128004185,
          0.05316472844328,
          78.99097654
        ],
        [
          0.00030772198458,
          0.06748397606355,
          74.54351598
        ],
        [
          0.00056476860237,
          0.05293132610871,
          79.14212541
        ],
        [
          0.00030607929568,
          0.06758460596782,
          74.53310983
        ],
        [
          0.00045924038854,
          0.05800013801763,
          77.30106337
        ],
        [
          0.00030997371043,
          0.06724855994913,
          74.64514311
        ],
        [
          0.00046322433737,
          0.05772737218336,
          77.43765837
        ],
        [
          0.000306093251,
          0.06758261401915,
          74.53420311
        ],
        [
          0.00059270154264,
          0.05149097385061,
          79.90581219
        ],
        [
          0.00030998753762,
          0.06724658450554,
          74.64624299
        ],
        [
          0.00059579530584,
          0.05127355597029,
          80.06359839
        ],
        [
          0.00030381201365,
          0.06782362513722,
          74.43107735
        ],
        [
          0.00042491981295,
          0.06004208458265,
          76.52209065
        ],
        [
          0.00030770793196,
          0.0674859695049,
          74.54242119
        ],
        [
          0.00042915103232,
          0.05974840294845,
          76.6528428
        ],
        [
          0.0003038261749,
          0.06782161593483,
          74.43216552
        ],
        [
          0.00056128004185,
          0.05316472844328,
          78.99097654
        ],
        [
          0.00030772198458,
          0.06748397606355,
          74.54351598
        ],
        [
          0.0005909393375,
          0.05197416844249,
          79.39609459
        ],
        [
          0.00030607929568,
          0.06758460596782,
          74.53310983
        ],
        [
          0.00045924038854,
          0.05800013801763,
          77.30106337
        ],
        [
          0.00030997371043,
          0.06724855994913,
          74.64514311
        ],
        [
          0.00046322433737,
          0.05772737218336,
          77.43765837
        ],
        [
          0.000306093251,
          0.06758261401915,
          74.53420311
        ],
        [
          0.00059270154264,
          0.05149097385061,
          79.90581219
        ],
        [
          0.00030998753762,
          0.06724658450554,
          74.64624299
        ],
        [
          0.0006223259326,
          0.05034050736205,
          80.33821207
        ],
        [
          0.00031472132103,
          0.06704521459036,
          74.60146848
        ],
        [
          0.00048125974789,
          0.05713103929897,
          77.40560191
        ],
        [
          0.00031871681429,
          0.06670918217899,
          74.71461872
        ],
        [
          0.00067689599478,
          0.04817589593479,
          81.34049921
        ],
        [
          0.00031473576101,
          0.06704321664554,
          74.60257042
        ],
        [
          0.0006181468272,
          0.05068181314244,
          80.05882605
        ],
        [
          0.00031873109634,
          0.0667072022386,
          74.7157273
        ],
        [
          0.00080610877111,
          0.04283290357599,
          84.82076155
        ],
        [
          0.00031703741516,
          0.06680769519084,
          74.70492481
        ],
        [
          0.00051542189594,
          0.05523173368825,
          78.23704513
        ],
        [
          0.00032102596426,
          0.06647352736288,
          74.81876617
        ],
        [
          0.00070586672142,
          0.04668811315943,
          82.39533688
        ],
        [
          0.00031705160854,
          0.06680571617392,
          74.70603186
        ],
        [
          0.00064835063648,
          0.04911088231737,
          81.03618147
        ],
        [
          0.00032103998076,
          0.06647156698314,
          74.81987984
        ],
        [
          0.00083151629137,
          0.04148680897704,
          86.09658603
        ],
        [
          0.00031472132103,
          0.06704521459036,
          74.60146848
        ],
        [
          0.00054749082577,
          0.05412858490636,
          78.36425001
        ],
        [
          0.00031871681429,
          0.06670918217899,
          74.71461872
        ],
        [
          0.00074451993159,
          0.04566423046336,
          82.62632767
        ],
        [
          0.00031473576101,
          0.06704321664554,
          74.60257042
        ],
        [
          0.00068498507045,
          0.04807186150146,
          81.23028704
        ],
        [
          0.00031873109634,
          0.0667072022386,
          74.7157273
        ],
        [
          0.00090689685277,
          0.03961742244786,
          86.90555944
        ],
        [
          0.00031703741516,
          0.06680769519084,
          74.70492481
        ],
        [
          0.00058121440039,
          0.0523660478228,
          79.25491774
        ],
        [
          0.00032102596426,
          0.06647352736288,
          74.81876617
        ],
        [
          0.00077268182059,
          0.0442403243147,
          83.76740007
        ],
        [
          0.00031705160854,
          0.06680571617392,
          74.70603186
        ],
        [
          0.00071429120529,
          0.04658462822717,
          82.28255537
        ],
        [
          0.00032103998076,
          0.06647156698314,
          74.81987984
        ],
        [
          0.000932980907,
          0.03828210471686,
          88.3545041
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.0004263973032,
          0.06010660391439,
          76.40047374
        ],
        [
          0.00030811874262,
          0.06752505910256,
          74.48815962
        ],
        [
          0.00043079797967,
          0.05981483056323,
          76.52272272
        ],
        [
          0.00030417228176,
          0.06785587042163,
          74.38531418
        ],
        [
          0.00056513562761,
          0.05320731777586,
          78.81584581
        ],
        [
          0.00030813294795,
          0.06752305832229,
          74.48925254
        ],
        [
          0.00056893564193,
          0.05297330297034,
          78.95748738
        ],
        [
          0.00030648682982,
          0.06762308845222,
          74.47950949
        ],
        [
          0.00046151903758,
          0.05806298263708,
          77.15155721
        ],
        [
          0.00031045018063,
          0.06729170976821,
          74.58407284
        ],
        [
          0.00046572356444,
          0.05779088404593,
          77.27932381
        ],
        [
          0.00030650093419,
          0.06762108932353,
          74.48060091
        ],
        [
          0.00059793783813,
          0.05152400921139,
          79.69890993
        ],
        [
          0.00031046418502,
          0.0672897258497,
          74.58517064
        ],
        [
          0.00060139526516,
          0.05130511262362,
          79.84682105
        ],
        [
          0.00030415799537,
          0.06785788567446,
          74.38422765
        ],
        [
          0.0004263973032,
          0.06010660391439,
          76.40047374
        ],
        [
          0.00030811874262,
          0.06752505910256,
          74.48815962
        ],
        [
          0.00043079797967,
          0.05981483056323,
          76.52272272
        ],
        [
          0.00030417228176,
          0.06785587042163,
          74.38531418
        ],
        [
          0.00056513562761,
          0.05320731777586,
          78.81584581
        ],
        [
          0.00030813294795,
          0.06752305832229,
          74.48925254
        ],
        [
          0.00059530988385,
          0.05201566080547,
          79.20848469
        ],
        [
          0.00030648682982,
          0.06762308845222,
          74.47950949
        ],
        [
          0.00046151903758,
          0.05806298263708,
          77.15155721
        ],
        [
          0.00031045018063,
          0.06729170976821,
          74.58407284
        ],
        [
          0.00046572356444,
          0.05779088404593,
          77.27932381
        ],
        [
          0.00030650093419,
          0.06762108932353,
          74.48060091
        ],
        [
          0.00059793783813,
          0.05152400921139,
          79.69890993
        ],
        [
          0.00031046418502,
          0.0672897258497,
          74.58517064
        ],
        [
          0.00062817550836,
          0.05037185838611,
          80.1178896
        ],
        [
          0.00031510923913,
          0.06708297775333,
          74.54957134
        ],
        [
          0.00048355600693,
          0.05719530419214,
          77.25582567
        ],
        [
          0.00031917357959,
          0.06675168853687,
          74.65521158
        ],
        [
          0.00068483131333,
          0.04820506838189,
          81.06663308
        ],
        [
          0.00031512384085,
          0.0670809720898,
          74.55067148
        ],
        [
          0.00062347247521,
          0.05071664901832,
          79.85093716
        ],
        [
          0.00031918804534,
          0.06674969993233,
          74.65631812
        ],
        [
          0.00081914954328,
          0.04282718046079,
          84.4643282
        ],
        [
          0.00031749047923,
          0.06684960461763,
          74.64619133
        ],
        [
          0.00051878265436,
          0.05528976948433,
          78.05768126
        ],
        [
          0.00032155283875,
          0.06651998074735,
          74.75246484
        ],
        [
          0.00071577317022,
          0.04670291191312,
          82.08386543
        ],
        [
          0.00031750485219,
          0.06684761710819,
          74.64729637
        ],
        [
          0.00065529772415,
          0.04913423287711,
          80.79432088
        ],
        [
          0.00032156706464,
          0.06651801055458,
          74.75357627
        ],
        [
          0.00084697887464,
          0.04146709922351,
          85.69465153
        ],
        [
          0.00031510923913,
          0.06708297775333,
          74.54957134
        ],
        [
          0.00055076017104,
          0.05418647193476,
          78.19168421
        ],
        [
          0.00031917357959,
          0.06675168853687,
          74.65521158
        ],
        [
          0.00075433236098,
          0.04568385320313,
          82.32004149
        ],
        [
          0.00031512384085,
          0.0670809720898,
          74.55067148
        ],
        [
          0.00069181969302,
          0.04809815737567,
          80.99477625
        ],
        [
          0.00031918804534,
          0.06674969993233,
          74.65631812
        ],
        [
          0.00092260355372,
          0.03961027451968,
          86.49731306
        ],
        [
          0.00031749047923,
          0.06684960461763,
          74.64619133
        ],
        [
          0.00058578685355,
          0.05241527687098,
          79.05098458
        ],
        [
          0.00032155283875,
          0.06651998074735,
          74.75246484
        ],
        [
          0.00078465915167,
          0.04424606174959,
          83.42035615
        ],
        [
          0.00031750485219,
          0.06684761710819,
          74.64729637
        ],
        [
          0.0007229526302,
          0.04659904502278,
          82.01057186
        ],
        [
          0.00032156706464,
          0.06651801055458,
          74.75357627
        ],
        [
          0.00095130952112,
          0.03826383386997,
          87.89364488
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00042747420918,
          0.060193011852,
          76.27294292
        ],
        [
          0.00030836270492,
          0.0675745561206,
          74.43273527
        ],
        [
          0.00043201319859,
          0.05990431865415,
          76.38656915
        ],
        [
          0.00030437672689,
          0.06789945813151,
          74.33712745
        ],
        [
          0.00056853193064,
          0.05327598684804,
          78.62733596
        ],
        [
          0.0003083781584,
          0.06757277354757,
          74.4335742
        ],
        [
          0.00057261253924,
          0.05304235519669,
          78.7592898
        ],
        [
          0.00030673314339,
          0.06767235963457,
          74.42418111
        ],
        [
          0.00046331741632,
          0.05815132405844,
          76.99407927
        ],
        [
          0.00031074052512,
          0.06734696976032,
          74.52119402
        ],
        [
          0.00046771067148,
          0.05788102250117,
          77.11288082
        ],
        [
          0.00030674850314,
          0.06767057800011,
          74.42501887
        ],
        [
          0.00060267227328,
          0.05158570710184,
          79.47604313
        ],
        [
          0.00031075585994,
          0.06734520013857,
          74.52203669
        ],
        [
          0.0006064623337,
          0.05136633289404,
          79.61387081
        ],
        [
          0.00030436126305,
          0.06790125214534,
          74.33629343
        ],
        [
          0.00042747420918,
          0.060193011852,
          76.27294292
        ],
        [
          0.00030836270492,
          0.0675745561206,
          74.43273527
        ],
        [
          0.00043201319859,
          0.05990431865415,
          76.38656915
        ],
        [
          0.00030437672689,
          0.06789945813151,
          74.33712745
        ],
        [
          0.00056853193064,
          0.05327598684804,
          78.62733596
        ],
        [
          0.0003083781584,
          0.06757277354757,
          74.4335742
        ],
        [
          0.00059918350673,
          0.05208389772082,
          79.00697323
        ],
        [
          0.00030673314339,
          0.06767235963457,
          74.42418111
        ],
        [
          0.00046331741632,
          0.05815132405844,
          76.99407927
        ],
        [
          0.00031074052512,
          0.06734696976032,
          74.52119402
        ],
        [
          0.00046771067148,
          0.05788102250117,
          77.11288082
        ],
        [
          0.00030674850314,
          0.06767057800011,
          74.42501887
        ],
        [
          0.00060267227328,
          0.05158570710184,
          79.47604313
        ],
        [
          0.00031075585994,
          0.06734520013857,
          74.52203669
        ],
        [
          0.00063348618513,
          0.05043252014498,
          79.88099557
        ],
        [
          0.00031533409893,
          0.06713040474465,
          74.49680515
        ],
        [
          0.00048533820805,
          0.05728353751981,
          77.09996734
        ],
        [
          0.00031944308832,
          0.06680511260271,
          74.59485538
        ],
        [
          0.0006919984346,
          0.04826794292707,
          80.77615109
        ],
        [
          0.00031534991477,
          0.06712862039544,
          74.49764994
        ],
        [
          0.00062824247896,
          0.05077909966688,
          79.62907421
        ],
        [
          0.00031945885806,
          0.06680334139055,
          74.59570511
        ],
        [
          0.00083151064299,
          0.04285802461011,
          84.07986812
        ],
        [
          0.00031776160344,
          0.06690284205676,
          74.58593803
        ],
        [
          0.0005215496754,
          0.05537513627023,
          77.87005722
        ],
        [
          0.00032187253377,
          0.06657904971428,
          74.68456135
        ],
        [
          0.00072486822714,
          0.04675414565064,
          81.75266958
        ],
        [
          0.0003177772856,
          0.06690107134643,
          74.58678657
        ],
        [
          0.00066164672646,
          0.04918783013037,
          80.5357185
        ],
        [
          0.00032188815604,
          0.06657729261176,
          74.68541482
        ],
        [
          0.00086173463436,
          0.04148704785838,
          85.26040515
        ],
        [
          0.00031533409893,
          0.06713040474465,
          74.49680515
        ],
        [
          0.0005534524474,
          0.05426988508541,
          78.01088253
        ],
        [
          0.00031944308832,
          0.06680511260271,
          74.59485538
        ],
        [
          0.00076335094375,
          0.04573819524184,
          81.99385332
        ],
        [
          0.00031534991477,
          0.06712862039544,
          74.49764994
        ],
        [
          0.0006980773818,
          0.0481530920542,
          80.7424131
        ],
        [
          0.00031945885806,
          0.06680334139055,
          74.59570511
        ],
        [
          0.00093760156784,
          0.03964128600512,
          86.05528046
        ],
        [
          0.00031776160344,
          0.06690284205676,
          74.58593803
        ],
        [
          0.00058971239577,
          0.05249305524139,
          78.83644252
        ],
        [
          0.00032187253377,
          0.06657904971428,
          74.68456135
        ],
        [
          0.00079580249912,
          0.04428936240069,
          83.04992566
        ],
        [
          0.0003177772856,
          0.06690107134643,
          74.58678657
        ],
        [
          0.0007310005047,
          0.04664474480703,
          81.71866118
        ],
        [
          0.00032188815604,
          0.06657729261176,
          74.68541482
        ],
        [
          0.00096889002029,
          0.03828718679936,
          87.39384645
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00042807852196,
          0.06030422476098,
          76.13939154
        ],
        [
          0.00030842287298,
          0.06763493508562,
          74.37654064
        ],
        [
          0.00043272045872,
          0.06001978179082,
          76.24439936
        ],
        [
          0.00030442217867,
          0.06795243988229,
          74.28838915
        ],
        [
          0.00057132924763,
          0.05337585866549,
          78.42421253
        ],
        [
          0.00030843844553,
          0.06763314606855,
          74.37737785
        ],
        [
          0.00057565285842,
          0.05314363338552,
          78.54642322
        ],
        [
          0.00030679547144,
          0.06773227312962,
          74.36834858
        ],
        [
          0.00046454036028,
          0.05826913723806,
          76.82802064
        ],
        [
          0.00031082053289,
          0.06741413218217,
          74.45784544
        ],
        [
          0.00046908554024,
          0.05800176304566,
          76.93784727
        ],
        [
          0.00030681094739,
          0.06773048518475,
          74.36918461
        ],
        [
          0.00060674546977,
          0.05168190689731,
          79.23539172
        ],
        [
          0.00031083600693,
          0.06741235511133,
          74.45868617
        ],
        [
          0.00061082982387,
          0.05146308036695,
          79.36305774
        ],
        [
          0.00030440661685,
          0.06795423927885,
          74.28755665
        ],
        [
          0.00042807852196,
          0.06030422476098,
          76.13939154
        ],
        [
          0.00030842287298,
          0.06763493508562,
          74.37654064
        ],
        [
          0.00043272045872,
          0.06001978179082,
          76.24439936
        ],
        [
          0.00030442217867,
          0.06795243988229,
          74.28838915
        ],
        [
          0.00057132924763,
          0.05337585866549,
          78.42421253
        ],
        [
          0.00030843844553,
          0.06763314606855,
          74.37737785
        ],
        [
          0.00060240959247,
          0.0521838993812,
          78.79050979
        ],
        [
          0.00030679547144,
          0.06773227312962,
          74.36834858
        ],
        [
          0.00046454036028,
          0.05826913723806,
          76.82802064
        ],
        [
          0.00031082053289,
          0.06741413218217,
          74.45784544
        ],
        [
          0.00046908554024,
          0.05800176304566,
          76.93784727
        ],
        [
          0.00030681094739,
          0.06773048518475,
          74.36918461
        ],
        [
          0.00060674546977,
          0.05168190689731,
          79.23539172
        ],
        [
          0.00031083600693,
          0.06741235511133,
          74.45868617
        ],
        [
          0.00063808685406,
          0.05052823147442,
          79.62588234
        ],
        [
          0.00031538270328,
          0.0671883695351,
          74.44301618
        ],
        [
          0.00048653804017,
          0.05740018821343,
          76.93579862
        ],
        [
          0.00031950888263,
          0.0668703631387,
          74.53350801
        ],
        [
          0.00069815489241,
          0.04836910470079,
          80.47022042
        ],
        [
          0.00031539864032,
          0.06718657872085,
          74.44385932
        ],
        [
          0.00063234574756,
          0.05087506407182,
          79.38961759
        ],
        [
          0.00031952479693,
          0.06686858433395,
          74.53435586
        ],
        [
          0.00084286103046,
          0.04293167885584,
          83.66736448
        ],
        [
          0.0003178297479,
          0.0669676221348,
          74.52496178
        ],
        [
          0.00052363923938,
          0.05549301121414,
          77.6713681
        ],
        [
          0.00032196144003,
          0.0666509425238,
          74.6159683
        ],
        [
          0.0007328798705,
          0.0468471468136,
          81.40238232
        ],
        [
          0.00031784560739,
          0.06696584225488,
          74.52580832
        ],
        [
          0.00066727572342,
          0.04927809515691,
          80.25606237
        ],
        [
          0.00032197722897,
          0.06664917676937,
          74.61681969
        ],
        [
          0.00087542787634,
          0.04155347339698,
          84.79319897
        ],
        [
          0.00031538270328,
          0.0671883695351,
          74.44301618
        ],
        [
          0.00055547935055,
          0.05438353316847,
          77.81952389
        ],
        [
          0.00031950888263,
          0.0668703631387,
          74.53350801
        ],
        [
          0.00077129103142,
          0.04583214370783,
          81.64904495
        ],
        [
          0.00031539864032,
          0.06718657872085,
          74.44385932
        ],
        [
          0.00070362889528,
          0.04824266423537,
          80.46941001
        ],
        [
          0.00031952479693,
          0.06686858433395,
          74.53435586
        ],
        [
          0.00095150622024,
          0.03971680839516,
          85.57962991
        ],
        [
          0.0003178297479,
          0.0669676221348,
          74.52496178
        ],
        [
          0.00059288793179,
          0.05260473154171,
          78.60837226
        ],
        [
          0.00032196144003,
          0.0666509425238,
          74.6159683
        ],
        [
          0.00080579946727,
          0.04437578579877,
          82.65682065
        ],
        [
          0.00031784560739,
          0.06696584225488,
          74.52580832
        ],
        [
          0.00073829565552,
          0.0467282106388,
          81.40231291
        ],
        [
          0.00032197722897,
          0.06664917676937,
          74.61681969
        ],
        [
          0.0009853147368,
          0.03835901743794,
          86.85464228
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00042813122462,
          0.0604353376627,
          76.00776524
        ],
        [
          0.00030829276947,
          0.06770249421014,
          74.3231632
        ],
        [
          0.00043283433303,
          0.06015569995568,
          76.10501633
        ],
        [
          0.00030430311388,
          0.06801236697738,
          74.24152485
        ],
        [
          0.00057325915068,
          0.0535058848206,
          78.21634662
        ],
        [
          0.00030830804697,
          0.06770090337043,
          74.32383766
        ],
        [
          0.00057777063314,
          0.05327569238641,
          78.32972528
        ],
        [
          0.0003066670353,
          0.0678006902844,
          74.31423393
        ],
        [
          0.00046505151947,
          0.05841266502154,
          76.66226882
        ],
        [
          0.00031068298838,
          0.06749024253182,
          74.39700099
        ],
        [
          0.00046970164572,
          0.05814882816616,
          76.76399733
        ],
        [
          0.00030668222637,
          0.06779910008175,
          74.31490737
        ],
        [
          0.00060980335366,
          0.05181273341024,
          78.98789671
        ],
        [
          0.00031069821324,
          0.0674886609596,
          74.39767821
        ],
        [
          0.00061412198862,
          0.05159514873937,
          79.10632547
        ],
        [
          0.00030428787885,
          0.06801396614723,
          74.24085414
        ],
        [
          0.00042813122462,
          0.0604353376627,
          76.00776524
        ],
        [
          0.00030829276947,
          0.06770249421014,
          74.3231632
        ],
        [
          0.00043283433303,
          0.06015569995568,
          76.10501633
        ],
        [
          0.00030430311388,
          0.06801236697738,
          74.24152485
        ],
        [
          0.00057325915068,
          0.0535058848206,
          78.21634662
        ],
        [
          0.00030830804697,
          0.06770090337043,
          74.32383766
        ],
        [
          0.00060469187664,
          0.0523143592722,
          78.56987255
        ],
        [
          0.0003066670353,
          0.0678006902844,
          74.31423393
        ],
        [
          0.00046505151947,
          0.05841266502154,
          76.66226882
        ],
        [
          0.00031068298838,
          0.06749024253182,
          74.39700099
        ],
        [
          0.00046970164572,
          0.05814882816616,
          76.76399733
        ],
        [
          0.00030668222637,
          0.06779910008175,
          74.31490737
        ],
        [
          0.00060980335366,
          0.05181273341024,
          78.98789671
        ],
        [
          0.00031069821324,
          0.0674886609596,
          74.39767821
        ],
        [
          0.00064159003523,
          0.05065886974592,
          79.36446017
        ],
        [
          0.00031524539534,
          0.06725447472497,
          74.39080035
        ],
        [
          0.00048702131521,
          0.05754101914894,
          76.77252638
        ],
        [
          0.00031936203353,
          0.06694416732617,
          74.47452185
        ],
        [
          0.00070298035854,
          0.04851068729122,
          80.15529491
        ],
        [
          0.00031526100877,
          0.06725288323253,
          74.39147978
        ],
        [
          0.00063542370585,
          0.05100422456425,
          79.14388815
        ],
        [
          0.00031937766386,
          0.066942585445,
          74.47520504
        ],
        [
          0.00085265220794,
          0.04305227767528,
          83.23549891
        ],
        [
          0.00031768405832,
          0.06704231594577,
          74.46523831
        ],
        [
          0.00052484526616,
          0.05564043380988,
          77.47182456
        ],
        [
          0.00032180921944,
          0.06673316488506,
          74.54941777
        ],
        [
          0.00073940538345,
          0.04698473749255,
          81.04054731
        ],
        [
          0.00031769960733,
          0.06704073429295,
          74.46592051
        ],
        [
          0.00067173040469,
          0.04940584884898,
          79.96784634
        ],
        [
          0.0003218247762,
          0.06673159315694,
          74.55010373
        ],
        [
          0.0008874085094,
          0.04167112903753,
          84.30311338
        ],
        [
          0.00031524539534,
          0.06725447472497,
          74.39080035
        ],
        [
          0.0005566356747,
          0.05452316030459,
          77.62899758
        ],
        [
          0.00031936203353,
          0.06694416732617,
          74.47452185
        ],
        [
          0.00077773593026,
          0.04596754597712,
          81.29446582
        ],
        [
          0.00031526100877,
          0.06725288323253,
          74.39147978
        ],
        [
          0.00070800370471,
          0.04836664459769,
          80.1896043
        ],
        [
          0.00031937766386,
          0.066942585445,
          74.47520504
        ],
        [
          0.00096363519148,
          0.03984054563945,
          85.08203173
        ],
        [
          0.00031768405832,
          0.06704231594577,
          74.46523831
        ],
        [
          0.00059502016463,
          0.05274744383441,
          78.37926278
        ],
        [
          0.00032180921944,
          0.06673316488506,
          74.54941777
        ],
        [
          0.0008141356355,
          0.04450793795595,
          82.25117951
        ],
        [
          0.00031769960733,
          0.06704073429295,
          74.46592051
        ],
        [
          0.000744259679,
          0.04685034564529,
          81.07668163
        ],
        [
          0.0003218247762,
          0.06673159315694,
          74.55010373
        ],
        [
          0.00099978272402,
          0.038483654635,
          86.2894405
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00042762133262,
          0.06058735346153,
          75.87757446
        ],
        [
          0.00030799641612,
          0.06777369617461,
          74.27458671
        ],
        [
          0.00043234949551,
          0.06031299495045,
          75.96778135
        ],
        [
          0.00030403902098,
          0.06807541127187,
          74.19896553
        ],
        [
          0.00057423912107,
          0.05367048374119,
          78.00148876
        ],
        [
          0.00030801176785,
          0.06777210036627,
          74.27525981
        ],
        [
          0.00057889135845,
          0.05344281635073,
          78.10677731
        ],
        [
          0.00030636520347,
          0.06787390191307,
          74.26428702
        ],
        [
          0.00046481588804,
          0.05858477732081,
          76.49525181
        ],
        [
          0.0003103499492,
          0.06757151264702,
          74.34098231
        ],
        [
          0.00046953054303,
          0.05832497252313,
          76.58960287
        ],
        [
          0.00030638047011,
          0.06787230659717,
          74.26495909
        ],
        [
          0.00061174590426,
          0.05198387059764,
          78.73007362
        ],
        [
          0.0003103652634,
          0.06756992521824,
          74.34165796
        ],
        [
          0.00061624809899,
          0.05176805911914,
          78.84000668
        ],
        [
          0.00030402372108,
          0.06807701484839,
          74.19829603
        ],
        [
          0.00042762133262,
          0.06058735346153,
          75.87757446
        ],
        [
          0.00030799641612,
          0.06777369617461,
          74.27458671
        ],
        [
          0.00043234949551,
          0.06031299495045,
          75.96778135
        ],
        [
          0.00030403902098,
          0.06807541127187,
          74.19896553
        ],
        [
          0.00057423912107,
          0.05367048374119,
          78.00148876
        ],
        [
          0.00030801176785,
          0.06777210036627,
          74.27525981
        ],
        [
          0.00060595207404,
          0.05247933338034,
          78.34287286
        ],
        [
          0.00030636520347,
          0.06787390191307,
          74.26428702
        ],
        [
          0.00046481588804,
          0.05858477732081,
          76.49525181
        ],
        [
          0.0003103499492,
          0.06757151264702,
          74.34098231
        ],
        [
          0.00046953054303,
          0.05832497252313,
          76.58960287
        ],
        [
          0.00030638047011,
          0.06787230659717,
          74.26495909
        ],
        [
          0.00061174590426,
          0.05198387059764,
          78.73007362
        ],
        [
          0.0003103652634,
          0.06756992521824,
          74.34165796
        ],
        [
          0.00064390120981,
          0.05082971643352,
          79.09327992
        ],
        [
          0.00031493969715,
          0.06732517915308,
          74.34249168
        ],
        [
          0.00048676185716,
          0.05770724455119,
          76.60989231
        ],
        [
          0.00031902376719,
          0.06702295739124,
          74.4201061
        ],
        [
          0.00070625192643,
          0.04869304350358,
          79.8371884
        ],
        [
          0.00031495539084,
          0.06732358244006,
          74.34316976
        ],
        [
          0.00063737405776,
          0.05117096297964,
          78.88982346
        ],
        [
          0.0003190394926,
          0.06702136947715,
          74.42078778
        ],
        [
          0.00086052066177,
          0.04322315315816,
          82.78892985
        ],
        [
          0.00031734040755,
          0.06712311127746,
          74.40944209
        ],
        [
          0.00052511632416,
          0.0558203541065,
          77.27005176
        ],
        [
          0.00032143514482,
          0.06682189373313,
          74.48746101
        ],
        [
          0.00074418013571,
          0.04716878277234,
          80.67195027
        ],
        [
          0.00031735605266,
          0.06712152349304,
          74.41012274
        ],
        [
          0.00067489183225,
          0.04957664021829,
          79.66773983
        ],
        [
          0.0003214508136,
          0.06682031502917,
          74.48814525
        ],
        [
          0.00089728438198,
          0.04184438479747,
          83.7936678
        ],
        [
          0.00031493969715,
          0.06732517915308,
          74.34249168
        ],
        [
          0.0005568910673,
          0.05469200791782,
          77.4367879
        ],
        [
          0.00031902376719,
          0.06702295739124,
          74.4201061
        ],
        [
          0.00078246092713,
          0.04614618391766,
          80.93368592
        ],
        [
          0.00031495539084,
          0.06732358244006,
          74.34316976
        ],
        [
          0.00071112204753,
          0.04853056224786,
          79.89834507
        ],
        [
          0.0003190394926,
          0.06702136947715,
          74.42078778
        ],
        [
          0.00097364037119,
          0.04001644480793,
          84.56500933
        ],
        [
          0.00031734040755,
          0.06712311127746,
          74.40944209
        ],
        [
          0.00059606244826,
          0.05292578524559,
          78.14536775
        ],
        [
          0.00032143514482,
          0.06682189373313,
          74.48746101
        ],
        [
          0.00082055852419,
          0.04468878961009,
          81.8354057
        ],
        [
          0.00031735605266,
          0.06712152349304,
          74.41012274
        ],
        [
          0.00074880657288,
          0.0470176080384,
          80.73571771
        ],
        [
          0.0003214508136,
          0.06682031502917,
          74.48814525
        ],
        [
          0.00101193527868,
          0.03866579851965,
          85.69950526
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00042653864088,
          0.0607605620137,
          75.74908684
        ],
        [
          0.00030753013122,
          0.06785234929817,
          74.22765541
        ],
        [
          0.00043125024898,
          0.06049344446603,
          75.83170576
        ],
        [
          0.00030363303809,
          0.06814413454792,
          74.15833116
        ],
        [
          0.00057415052323,
          0.05387078866565,
          77.78238177
        ],
        [
          0.00030754355496,
          0.06785108382667,
          74.22812759
        ],
        [
          0.00057889982166,
          0.05364724932192,
          77.87894337
        ],
        [
          0.000305894702,
          0.06795386070214,
          74.21658804
        ],
        [
          0.00046380416841,
          0.05878387502831,
          76.32987922
        ],
        [
          0.00030981802667,
          0.06766161835079,
          74.28673343
        ],
        [
          0.00046853899775,
          0.05852999490398,
          76.41629109
        ],
        [
          0.0003059080573,
          0.06795259532645,
          74.21705945
        ],
        [
          0.00061239108237,
          0.052195371934,
          78.46768671
        ],
        [
          0.00030983144409,
          0.06766035857813,
          74.28720735
        ],
        [
          0.00061703199771,
          0.05198288120618,
          78.56847332
        ],
        [
          0.00030361967837,
          0.06814540558971,
          74.15786149
        ],
        [
          0.00042653864088,
          0.0607605620137,
          75.74908684
        ],
        [
          0.00030753013122,
          0.06785234929817,
          74.22765541
        ],
        [
          0.00043125024898,
          0.06049344446603,
          75.83170576
        ],
        [
          0.00030363303809,
          0.06814413454792,
          74.15833116
        ],
        [
          0.00057415052323,
          0.05387078866565,
          77.78238177
        ],
        [
          0.00030754355496,
          0.06785108382667,
          74.22812759
        ],
        [
          0.00060607219952,
          0.05268131109765,
          78.11053238
        ],
        [
          0.000305894702,
          0.06795386070214,
          74.21658804
        ],
        [
          0.00046380416841,
          0.05878387502831,
          76.32987922
        ],
        [
          0.00030981802667,
          0.06766161835079,
          74.28673343
        ],
        [
          0.00046853899775,
          0.05852999490398,
          76.41629109
        ],
        [
          0.0003059080573,
          0.06795259532645,
          74.21705945
        ],
        [
          0.00061239108237,
          0.052195371934,
          78.46768671
        ],
        [
          0.00030983144409,
          0.06766035857813,
          74.28720735
        ],
        [
          0.00064484022643,
          0.05104206716511,
          78.8164025
        ],
        [
          0.00031446662802,
          0.06740271751541,
          74.29608548
        ],
        [
          0.00048573069576,
          0.05790019669076,
          76.44773781
        ],
        [
          0.00031848784826,
          0.06711063759291,
          74.36710582
        ],
        [
          0.00070786689786,
          0.0489198325456,
          79.51437607
        ],
        [
          0.00031448033316,
          0.06740145216605,
          74.29656133
        ],
        [
          0.00063804469086,
          0.05137730463248,
          78.6298255
        ],
        [
          0.00031850160488,
          0.06710937848426,
          74.36758419
        ],
        [
          0.00086619461504,
          0.04344825344323,
          82.32918852
        ],
        [
          0.00031680007396,
          0.06721211479849,
          74.35567274
        ],
        [
          0.00052439428065,
          0.05603238886988,
          77.06863853
        ],
        [
          0.00032083352862,
          0.06692088825407,
          74.42704424
        ],
        [
          0.00074702900217,
          0.04740174831287,
          80.2982837
        ],
        [
          0.00031681376556,
          0.06721085551789,
          74.35615034
        ],
        [
          0.00067653366369,
          0.04979147641794,
          79.36130804
        ],
        [
          0.00032084726662,
          0.06691963539405,
          74.42752435
        ],
        [
          0.0009046720125,
          0.04207624448385,
          83.27028602
        ],
        [
          0.00031446662802,
          0.06740271751541,
          74.29608548
        ],
        [
          0.0005561836546,
          0.0548926685976,
          77.24229086
        ],
        [
          0.00031848784826,
          0.06711063759291,
          74.36710582
        ],
        [
          0.00078533371997,
          0.04637243618068,
          80.56461998
        ],
        [
          0.00031448033316,
          0.06740145216605,
          74.29656133
        ],
        [
          0.0007127843279,
          0.04873749300625,
          79.59769167
        ],
        [
          0.00031850160488,
          0.06710937848426,
          74.36758419
        ],
        [
          0.00098121839632,
          0.04024903329098,
          84.02934533
        ],
        [
          0.00031680007396,
          0.06721211479849,
          74.35567274
        ],
        [
          0.00059591236575,
          0.05314076445936,
          77.90896116
        ],
        [
          0.00032083352862,
          0.06692088825407,
          74.42704424
        ],
        [
          0.00082485231787,
          0.04492155960069,
          81.41083976
        ],
        [
          0.00031681376556,
          0.06721085551789,
          74.35615034
        ],
        [
          0.00075165006357,
          0.04723211364984,
          80.38481931
        ],
        [
          0.00032084726662,
          0.06691963539405,
          74.42752435
        ],
        [
          0.00102133920652,
          0.03890906590794,
          85.08993915
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00042486822093,
          0.06095624759638,
          75.62186453
        ],
        [
          0.00030692703236,
          0.06793437749298,
          74.18440622
        ],
        [
          0.00042953091942,
          0.06069673499798,
          75.69758494
        ],
        [
          0.00030311086531,
          0.06821563317763,
          74.12094999
        ],
        [
          0.00057289947405,
          0.05410946603193,
          77.55945504
        ],
        [
          0.00030694049342,
          0.06793310846538,
          74.18487742
        ],
        [
          0.00057769973053,
          0.05389046911712,
          77.64803281
        ],
        [
          0.00030527574068,
          0.06803849278752,
          74.17202481
        ],
        [
          0.00046197135151,
          0.05901422613431,
          76.1638104
        ],
        [
          0.00030911976854,
          0.0677565979187,
          74.23624949
        ],
        [
          0.00046668888409,
          0.0587666668952,
          76.24298657
        ],
        [
          0.00030528913569,
          0.06803722367118,
          74.1724952
        ],
        [
          0.00061161966927,
          0.05245221486742,
          78.19911757
        ],
        [
          0.00030913323116,
          0.06775533397292,
          74.23672226
        ],
        [
          0.00061634876384,
          0.05224348880585,
          78.29151312
        ],
        [
          0.00030309747545,
          0.06821690722198,
          74.12048117
        ],
        [
          0.00042486822093,
          0.06095624759638,
          75.62186453
        ],
        [
          0.00030692703236,
          0.06793437749298,
          74.18440622
        ],
        [
          0.00042953091942,
          0.06069673499798,
          75.69758494
        ],
        [
          0.00030311086531,
          0.06821563317763,
          74.12094999
        ],
        [
          0.00057289947405,
          0.05410946603193,
          77.55945504
        ],
        [
          0.00030694049342,
          0.06793310846538,
          74.18487742
        ],
        [
          0.00060494990861,
          0.05292174103629,
          77.87476067
        ],
        [
          0.00030527574068,
          0.06803849278752,
          74.17202481
        ],
        [
          0.00046197135151,
          0.05901422613431,
          76.1638104
        ],
        [
          0.00030911976854,
          0.0677565979187,
          74.23624949
        ],
        [
          0.00046668888409,
          0.0587666668952,
          76.24298657
        ],
        [
          0.00030528913569,
          0.06803722367118,
          74.1724952
        ],
        [
          0.00061161966927,
          0.05245221486742,
          78.19911757
        ],
        [
          0.00030913323116,
          0.06775533397292,
          74.23672226
        ],
        [
          0.000644276224,
          0.05129973111943,
          78.53368674
        ],
        [
          0.00031383836138,
          0.067486073535,
          74.25194564
        ],
        [
          0.00048389262176,
          0.05812189252128,
          76.2855631
        ],
        [
          0.00031777733425,
          0.06720438753928,
          74.31700216
        ],
        [
          0.00070769484457,
          0.04919235907266,
          79.18933566
        ],
        [
          0.00031385210852,
          0.06748480438608,
          74.25242049
        ],
        [
          0.00063730967896,
          0.05162648331422,
          78.36431988
        ],
        [
          0.00031779114166,
          0.06720312402091,
          74.3174794
        ],
        [
          0.00086939943264,
          0.04372989033913,
          81.86049138
        ],
        [
          0.00031607430607,
          0.06730843230066,
          74.30424835
        ],
        [
          0.0005226146974,
          0.05628129636453,
          76.86510457
        ],
        [
          0.00032002637471,
          0.06702746217758,
          74.36960635
        ],
        [
          0.00074780132938,
          0.04768692857064,
          79.91988424
        ],
        [
          0.0003160880488,
          0.06730716853371,
          74.30472478
        ],
        [
          0.00067650879261,
          0.05005568124288,
          79.04684095
        ],
        [
          0.00032004017342,
          0.06702620419744,
          74.37008518
        ],
        [
          0.00090928820954,
          0.04237055959666,
          82.73492778
        ],
        [
          0.00031383836138,
          0.067486073535,
          74.25194564
        ],
        [
          0.00055446083716,
          0.05512552632904,
          77.04716698
        ],
        [
          0.00031777733425,
          0.06720438753928,
          74.31700216
        ],
        [
          0.00078616047233,
          0.0466465435032,
          80.19252086
        ],
        [
          0.00031385210852,
          0.06748480438608,
          74.25242049
        ],
        [
          0.00071281535775,
          0.04898942570392,
          79.29055793
        ],
        [
          0.00031779114166,
          0.06720312402091,
          74.3174794
        ],
        [
          0.00098598983778,
          0.04053955572752,
          83.48294921
        ],
        [
          0.00031607430607,
          0.06730843230066,
          74.30424835
        ],
        [
          0.00059448380003,
          0.05339546832919,
          77.66969101
        ],
        [
          0.00032002637471,
          0.06702746217758,
          74.36960635
        ],
        [
          0.00082680228363,
          0.04520839173361,
          80.98059406
        ],
        [
          0.0003160880488,
          0.06730716853371,
          74.30472478
        ],
        [
          0.00075259165743,
          0.0474978779954,
          80.02476191
        ],
        [
          0.00032004017342,
          0.06702620419744,
          74.37008518
        ],
        [
          0.00102761558489,
          0.03921604958713,
          84.46641871
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00042261752282,
          0.06117333951691,
          75.49700318
        ],
        [
          0.00030619506616,
          0.06802026767356,
          74.14406337
        ],
        [
          0.00042718906992,
          0.06092307075942,
          75.56567326
        ],
        [
          0.00030248507869,
          0.06828970191194,
          74.08641777
        ],
        [
          0.00057039357379,
          0.05438954202239,
          77.33295773
        ],
        [
          0.00030620512413,
          0.06801939816313,
          74.14434465
        ],
        [
          0.00057519399865,
          0.05417647431111,
          77.4133576
        ],
        [
          0.00030452937795,
          0.06812661015949,
          74.13066476
        ],
        [
          0.00045930648942,
          0.05927482061833,
          75.99898698
        ],
        [
          0.0003082644758,
          0.06785678430138,
          74.18884154
        ],
        [
          0.00046396022828,
          0.05903517973666,
          76.07076813
        ],
        [
          0.00030453938837,
          0.06812574045408,
          74.13094552
        ],
        [
          0.000609303043,
          0.05275750380218,
          77.92554434
        ],
        [
          0.00030827454537,
          0.06785591776867,
          74.18912372
        ],
        [
          0.00061406700552,
          0.05255387703467,
          78.00935171
        ],
        [
          0.00030247508325,
          0.06829057443879,
          74.08613791
        ],
        [
          0.00042261752282,
          0.06117333951691,
          75.49700318
        ],
        [
          0.00030619506616,
          0.06802026767356,
          74.14406337
        ],
        [
          0.00042718906992,
          0.06092307075942,
          75.56567326
        ],
        [
          0.00030248507869,
          0.06828970191194,
          74.08641777
        ],
        [
          0.00057039357379,
          0.05438954202239,
          77.33295773
        ],
        [
          0.00030620512413,
          0.06801939816313,
          74.14434465
        ],
        [
          0.00060248244629,
          0.05320465327577,
          77.63483663
        ],
        [
          0.00030452937795,
          0.06812661015949,
          74.13066476
        ],
        [
          0.00045930648942,
          0.05927482061833,
          75.99898698
        ],
        [
          0.0003082644758,
          0.06785678430138,
          74.18884154
        ],
        [
          0.00046396022828,
          0.05903517973666,
          76.07076813
        ],
        [
          0.00030453938837,
          0.06812574045408,
          74.13094552
        ],
        [
          0.000609303043,
          0.05275750380218,
          77.92554434
        ],
        [
          0.00030827454537,
          0.06785591776867,
          74.18912372
        ],
        [
          0.00064207165157,
          0.05160669532684,
          78.24535444
        ],
        [
          0.0003130857588,
          0.06757242642793,
          74.21114997
        ],
        [
          0.00048125999815,
          0.05836963370821,
          76.12614793
        ],
        [
          0.00031691336962,
          0.0673027947446,
          74.27011068
        ],
        [
          0.00070562180064,
          0.0495146540552,
          78.86115164
        ],
        [
          0.00031309601834,
          0.06757155743613,
          74.21143356
        ],
        [
          0.00063505906852,
          0.05192012844974,
          78.09540137
        ],
        [
          0.00031692368453,
          0.06730192919152,
          74.2703957
        ],
        [
          0.00086991362476,
          0.04407424088933,
          81.38089556
        ],
        [
          0.00031519502668,
          0.06740911738115,
          74.25633848
        ],
        [
          0.00051976118429,
          0.05656467522149,
          76.66316658
        ],
        [
          0.0003190359872,
          0.06714007108202,
          74.31555287
        ],
        [
          0.00074634285561,
          0.04802826112467,
          79.53688459
        ],
        [
          0.00031520529607,
          0.06740825146696,
          74.25662298
        ],
        [
          0.00067466091105,
          0.05037106376863,
          78.72749955
        ],
        [
          0.00031904630973,
          0.06713920868998,
          74.3158388
        ],
        [
          0.00091086342253,
          0.04273325717315,
          82.18691805
        ],
        [
          0.0003130857588,
          0.06757242642793,
          74.21114997
        ],
        [
          0.00055168518421,
          0.05539138669344,
          76.85230147
        ],
        [
          0.00031691336962,
          0.0673027947446,
          74.27011068
        ],
        [
          0.00078480339947,
          0.0469745607232,
          79.81410466
        ],
        [
          0.00031309601834,
          0.06757155743613,
          74.21143356
        ],
        [
          0.00071106306112,
          0.04929049134677,
          78.97691782
        ],
        [
          0.00031692368453,
          0.06730192919152,
          74.2703957
        ],
        [
          0.00098772869722,
          0.04089557614408,
          82.9211326
        ],
        [
          0.00031519502668,
          0.06740911738115,
          74.25633848
        ],
        [
          0.00059170842616,
          0.05369077994544,
          77.42938468
        ],
        [
          0.0003190359872,
          0.06714007108202,
          74.31555287
        ],
        [
          0.00082623004052,
          0.04555514535762,
          80.54243367
        ],
        [
          0.00031520529607,
          0.06740825146696,
          74.25662298
        ],
        [
          0.00075143722523,
          0.04781895743557,
          79.65657767
        ],
        [
          0.00031904630973,
          0.06713920868998,
          74.3158388
        ],
        [
          0.00103049323919,
          0.03959394392518,
          83.82560425
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00041978598832,
          0.06141231367726,
          75.3744762
        ],
        [
          0.0003053366483,
          0.06811077524175,
          74.10588895
        ],
        [
          0.00042423509309,
          0.06117191635052,
          75.43655034
        ],
        [
          0.00030175003005,
          0.06836788626001,
          74.05368537
        ],
        [
          0.0005665751922,
          0.05471147258743,
          77.10513686
        ],
        [
          0.00030534321969,
          0.06811027234747,
          74.10601445
        ],
        [
          0.00057133070767,
          0.05450494674318,
          77.1778571
        ],
        [
          0.00030364669902,
          0.06822017226555,
          74.09126246
        ],
        [
          0.00045580178983,
          0.05956600212001,
          75.83601734
        ],
        [
          0.00030725453836,
          0.06796292335324,
          74.14379818
        ],
        [
          0.00046035500213,
          0.05933494078152,
          75.90087398
        ],
        [
          0.0003036532417,
          0.06821966908647,
          74.09138769
        ],
        [
          0.00060535564501,
          0.05311183548837,
          77.65003298
        ],
        [
          0.00030726112387,
          0.06796242185688,
          74.1439241
        ],
        [
          0.000610104808,
          0.05291392976031,
          77.72576858
        ],
        [
          0.00030174350314,
          0.06836839075702,
          74.05356054
        ],
        [
          0.00041978598832,
          0.06141231367726,
          75.3744762
        ],
        [
          0.0003053366483,
          0.06811077524175,
          74.10588895
        ],
        [
          0.00042423509309,
          0.06117191635052,
          75.43655034
        ],
        [
          0.00030175003005,
          0.06836788626001,
          74.05368537
        ],
        [
          0.0005665751922,
          0.05471147258743,
          77.10513686
        ],
        [
          0.00030534321969,
          0.06811027234747,
          74.10601445
        ],
        [
          0.00059860784181,
          0.05353011905635,
          77.39352316
        ],
        [
          0.00030364669902,
          0.06822017226555,
          74.09126246
        ],
        [
          0.00045580178983,
          0.05956600212001,
          75.83601734
        ],
        [
          0.00030725453836,
          0.06796292335324,
          74.14379818
        ],
        [
          0.00046035500213,
          0.05933494078152,
          75.90087398
        ],
        [
          0.0003036532417,
          0.06821966908647,
          74.09138769
        ],
        [
          0.00060535564501,
          0.05311183548837,
          77.65003298
        ],
        [
          0.00030726112387,
          0.06796242185688,
          74.1439241
        ],
        [
          0.000638133825,
          0.05196320839151,
          77.95500494
        ],
        [
          0.00031218495339,
          0.06766534543234,
          74.17171568
        ],
        [
          0.00047780625498,
          0.05864597767265,
          75.96840779
        ],
        [
          0.0003158823462,
          0.06740827285652,
          74.22498678
        ],
        [
          0.000701546866,
          0.0498885261354,
          78.53168931
        ],
        [
          0.00031219164696,
          0.06766484332949,
          74.17184236
        ],
        [
          0.00063120240196,
          0.05226043274964,
          77.82427227
        ],
        [
          0.00031588908122,
          0.06740777254996,
          74.22511414
        ],
        [
          0.00086751112358,
          0.04448279027232,
          80.89563477
        ],
        [
          0.00031413940413,
          0.06751766487128,
          74.20998315
        ],
        [
          0.00051579782055,
          0.05688488999325,
          76.46237703
        ],
        [
          0.00031784982809,
          0.06726105964705,
          74.26346386
        ],
        [
          0.00074251807069,
          0.04842758990982,
          79.15206866
        ],
        [
          0.00031414611143,
          0.06751716419531,
          74.21011024
        ],
        [
          0.00067087146561,
          0.05073981783626,
          78.40530969
        ],
        [
          0.00031785657597,
          0.06726056080079,
          74.26359163
        ],
        [
          0.00090911705299,
          0.04316586609715,
          81.63280437
        ],
        [
          0.00031218495339,
          0.06766534543234,
          74.17171568
        ],
        [
          0.00054788616668,
          0.05568679546454,
          76.66112401
        ],
        [
          0.0003158823462,
          0.06740827285652,
          74.22498678
        ],
        [
          0.00078115703787,
          0.04735381474272,
          79.43676203
        ],
        [
          0.00031219164696,
          0.06766484332949,
          74.17184236
        ],
        [
          0.00070744653327,
          0.04963812884266,
          78.66316743
        ],
        [
          0.00031588908122,
          0.06740777254996,
          74.22511414
        ],
        [
          0.00098615298902,
          0.04131471921927,
          82.35578519
        ],
        [
          0.00031413940413,
          0.06751766487128,
          74.20998315
        ],
        [
          0.00058759187033,
          0.05402352612576,
          77.19227964
        ],
        [
          0.00031784982809,
          0.06726105964705,
          74.26346386
        ],
        [
          0.00082298228802,
          0.04595934166677,
          80.10494907
        ],
        [
          0.00031414611143,
          0.06751716419531,
          74.21011024
        ],
        [
          0.00074805965601,
          0.04819309440638,
          79.28774995
        ],
        [
          0.00031785657597,
          0.06726056080079,
          74.26359163
        ],
        [
          0.0010296268188,
          0.04004039009787,
          83.18116362
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00041649679477,
          0.06166431289497,
          75.25853948
        ],
        [
          0.00030441457049,
          0.0682003359525,
          74.07177929
        ],
        [
          0.0004207879731,
          0.06143495220021,
          75.31421487
        ],
        [
          0.00030097638392,
          0.06844371414028,
          74.02500646
        ],
        [
          0.00056159044297,
          0.0550633411804,
          76.88528236
        ],
        [
          0.00030442114068,
          0.06819983204087,
          74.07190451
        ],
        [
          0.00056625074726,
          0.05486447353697,
          76.95055218
        ],
        [
          0.0003027057677,
          0.06831204183461,
          74.0563386
        ],
        [
          0.00045160749674,
          0.05987703944668,
          75.68083651
        ],
        [
          0.00030616341644,
          0.06806847242635,
          74.10340532
        ],
        [
          0.00045601894579,
          0.05965576301194,
          75.73897934
        ],
        [
          0.00030271230887,
          0.06831153762692,
          74.05646353
        ],
        [
          0.00059992139834,
          0.05350229959955,
          77.38388577
        ],
        [
          0.00030617000177,
          0.06806796967108,
          74.10353089
        ],
        [
          0.00060460087262,
          0.05331121501146,
          77.45180271
        ],
        [
          0.00030096985857,
          0.06844421947272,
          74.02488188
        ],
        [
          0.00041649679477,
          0.06166431289497,
          75.25853948
        ],
        [
          0.00030441457049,
          0.0682003359525,
          74.07177929
        ],
        [
          0.0004207879731,
          0.06143495220021,
          75.31421487
        ],
        [
          0.00030097638392,
          0.06844371414028,
          74.02500646
        ],
        [
          0.00056159044297,
          0.0550633411804,
          76.88528236
        ],
        [
          0.00030442114068,
          0.06819983204087,
          74.07190451
        ],
        [
          0.00059347215566,
          0.05388620363357,
          77.1605788
        ],
        [
          0.0003027057677,
          0.06831204183461,
          74.0563386
        ],
        [
          0.00045160749674,
          0.05987703944668,
          75.68083651
        ],
        [
          0.00030616341644,
          0.06806847242635,
          74.10340532
        ],
        [
          0.00045601894579,
          0.05965576301194,
          75.73897934
        ],
        [
          0.00030271230887,
          0.06831153762692,
          74.05646353
        ],
        [
          0.00059992139834,
          0.05350229959955,
          77.38388577
        ],
        [
          0.00030617000177,
          0.06806796967108,
          74.10353089
        ],
        [
          0.00063260389776,
          0.05235634759942,
          77.67448763
        ],
        [
          0.00031121145521,
          0.06775791557694,
          74.13621611
        ],
        [
          0.00047367676591,
          0.05894084160905,
          75.81803756
        ],
        [
          0.0003147560806,
          0.0675144463322,
          74.18396565
        ],
        [
          0.00069558675279,
          0.05030280282349,
          78.21235374
        ],
        [
          0.00031121814853,
          0.06775741236967,
          74.13634248
        ],
        [
          0.0006258772433,
          0.05263502029059,
          77.56203395
        ],
        [
          0.00031476281609,
          0.06751394472697,
          74.18409266
        ],
        [
          0.00086220079242,
          0.04494265208798,
          80.42344029
        ],
        [
          0.00031299421031,
          0.06762616731068,
          74.16814963
        ],
        [
          0.00051088882887,
          0.05723034519912,
          76.27022256
        ],
        [
          0.00031655109182,
          0.06738306170651,
          74.21606941
        ],
        [
          0.0007364298785,
          0.04887276207718,
          78.77914924
        ],
        [
          0.0003130009178,
          0.06762566532131,
          74.16827636
        ],
        [
          0.00066526602394,
          0.05114867668601,
          78.09356558
        ],
        [
          0.00031655784078,
          0.06738256134752,
          74.21619678
        ],
        [
          0.00090403801313,
          0.04365426027775,
          81.09428548
        ],
        [
          0.00031121145521,
          0.06775791557694,
          74.13621611
        ],
        [
          0.00054310358305,
          0.05600999063141,
          76.47500997
        ],
        [
          0.0003147560806,
          0.0675144463322,
          74.18396565
        ],
        [
          0.00077525139301,
          0.04777952901367,
          79.06714812
        ],
        [
          0.00031121814853,
          0.06775741236967,
          74.13634248
        ],
        [
          0.0007020073215,
          0.05002690713497,
          78.35587501
        ],
        [
          0.00031476281609,
          0.06751394472697,
          74.18409266
        ],
        [
          0.00098121161241,
          0.04178868566246,
          81.80189448
        ],
        [
          0.00031299421031,
          0.06762616731068,
          74.16814963
        ],
        [
          0.00058219443359,
          0.05439011724214,
          76.96150003
        ],
        [
          0.00031655109182,
          0.06738306170651,
          74.21606941
        ],
        [
          0.00081708483168,
          0.04641481698021,
          79.67710358
        ],
        [
          0.0003130009178,
          0.06762566532131,
          74.16827636
        ],
        [
          0.00074249665075,
          0.04861356543398,
          78.92698764
        ],
        [
          0.00031655784078,
          0.06738256134752,
          74.21619678
        ],
        [
          0.00102494885871,
          0.04054563810149,
          82.55124786
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00041267782656,
          0.06193646405276,
          75.14557
        ],
        [
          0.00030341123471,
          0.06829169969573,
          74.0401948
        ],
        [
          0.00041679052057,
          0.06171831544093,
          75.19542352
        ],
        [
          0.0003001315161,
          0.06852134777436,
          73.99834346
        ],
        [
          0.0005553260887,
          0.05545492558067,
          76.66769289
        ],
        [
          0.00030341780172,
          0.06829119478083,
          74.04031973
        ],
        [
          0.00055985618342,
          0.05526398278725,
          76.72616344
        ],
        [
          0.00030168902726,
          0.06840510534025,
          74.02423579
        ],
        [
          0.00044664113341,
          0.06021615083424,
          75.52909824
        ],
        [
          0.00030498694222,
          0.06817519081026,
          74.06634777
        ],
        [
          0.00045088501925,
          0.06000490765612,
          75.58112821
        ],
        [
          0.00030169556499,
          0.06840460012197,
          74.02436043
        ],
        [
          0.00059288361537,
          0.05393941456696,
          77.12057932
        ],
        [
          0.00030499352424,
          0.0681746868664,
          74.066473
        ],
        [
          0.00059745347776,
          0.05375544319197,
          77.18135981
        ],
        [
          0.00030012499391,
          0.06852185393638,
          73.99821912
        ],
        [
          0.00041267782656,
          0.06193646405276,
          75.14557
        ],
        [
          0.00030341123471,
          0.06829169969573,
          74.0401948
        ],
        [
          0.00041679052057,
          0.06171831544093,
          75.19542352
        ],
        [
          0.0003001315161,
          0.06852134777436,
          73.99834346
        ],
        [
          0.0005553260887,
          0.05545492558067,
          76.66769289
        ],
        [
          0.00030341780172,
          0.06829119478083,
          74.04031973
        ],
        [
          0.00058696157816,
          0.05428263180043,
          76.93007324
        ],
        [
          0.00030168902726,
          0.06840510534025,
          74.02423579
        ],
        [
          0.00044664113341,
          0.06021615083424,
          75.52909824
        ],
        [
          0.00030498694222,
          0.06817519081026,
          74.06634777
        ],
        [
          0.00045088501925,
          0.06000490765612,
          75.58112821
        ],
        [
          0.00030169556499,
          0.06840460012197,
          74.02436043
        ],
        [
          0.00059288361537,
          0.05393941456696,
          77.12057932
        ],
        [
          0.00030499352424,
          0.0681746868664,
          74.066473
        ],
        [
          0.0006253658759,
          0.05279656534025,
          77.39699902
        ],
        [
          0.00031013026464,
          0.06785434843305,
          74.1026296
        ],
        [
          0.00046879102214,
          0.05926186134429,
          75.67091095
        ],
        [
          0.00031351146408,
          0.06762448651436,
          74.14537236
        ],
        [
          0.00068780136735,
          0.05075744437435,
          77.90308544
        ],
        [
          0.00031013695557,
          0.06785384411351,
          74.10275568
        ],
        [
          0.00061896863042,
          0.05305381911066,
          77.30237423
        ],
        [
          0.00031351819757,
          0.06762398360749,
          74.14549904
        ],
        [
          0.00085400716489,
          0.04545641028927,
          79.96232549
        ],
        [
          0.00031173644357,
          0.06773793015191,
          74.12904434
        ],
        [
          0.00050494568256,
          0.05760966118193,
          76.08181599
        ],
        [
          0.00031512884441,
          0.06750834604808,
          74.17192428
        ],
        [
          0.00072812990496,
          0.049364803405,
          78.4173496
        ],
        [
          0.0003117431487,
          0.06773742685678,
          74.12917072
        ],
        [
          0.00065772939333,
          0.05160823486534,
          77.78506076
        ],
        [
          0.00031513559153,
          0.06750784419069,
          74.17205126
        ],
        [
          0.00089564600667,
          0.04420184975765,
          80.56851552
        ],
        [
          0.00031013026464,
          0.06785434843305,
          74.1026296
        ],
        [
          0.00053733665511,
          0.05636262448107,
          76.29318419
        ],
        [
          0.00031351146408,
          0.06762448651436,
          74.14537236
        ],
        [
          0.00076719254063,
          0.04824745566633,
          78.70941598
        ],
        [
          0.00031013695557,
          0.06785384411351,
          74.10275568
        ],
        [
          0.00069469184383,
          0.05046168672602,
          78.05238277
        ],
        [
          0.00031351819757,
          0.06762398360749,
          74.14549904
        ],
        [
          0.0009729486722,
          0.04231678847815,
          81.26153384
        ],
        [
          0.00031173644357,
          0.06773793015191,
          74.12904434
        ],
        [
          0.00057550251334,
          0.05479347338939,
          76.73558064
        ],
        [
          0.00031512884441,
          0.06750834604808,
          74.17192428
        ],
        [
          0.00080862655424,
          0.04691855838421,
          79.26242608
        ],
        [
          0.0003117431487,
          0.06773742685678,
          74.12917072
        ],
        [
          0.00073468583127,
          0.04908612726799,
          78.57086005
        ],
        [
          0.00031513559153,
          0.06750784419069,
          74.17205126
        ],
        [
          0.00101650992466,
          0.04110964486207,
          81.93713214
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00040840983346,
          0.06222426928088,
          75.03729574
        ],
        [
          0.00030231881991,
          0.06838614714013,
          74.01042827
        ],
        [
          0.00041231878308,
          0.0620180499571,
          75.08163989
        ],
        [
          0.00029921255321,
          0.06860150827584,
          73.97323403
        ],
        [
          0.00054783292149,
          0.05588432750336,
          76.45434428
        ],
        [
          0.00030232538188,
          0.06838564122054,
          74.01055293
        ],
        [
          0.00055219379777,
          0.05570203580566,
          76.50637106
        ],
        [
          0.00030059716596,
          0.06849999192538,
          73.99440187
        ],
        [
          0.00044107327776,
          0.06057372487482,
          75.38487824
        ],
        [
          0.00030372024612,
          0.06828430055096,
          74.0318286
        ],
        [
          0.00044511928533,
          0.06037332071748,
          75.43113087
        ],
        [
          0.0003006036984,
          0.06849948570991,
          73.99452623
        ],
        [
          0.00058437297664,
          0.05441710882367,
          76.86471411
        ],
        [
          0.0003037268226,
          0.06828379543339,
          74.03195352
        ],
        [
          0.00058878957581,
          0.05424100114486,
          76.91874588
        ],
        [
          0.00029920603567,
          0.06860201527312,
          73.97310993
        ],
        [
          0.00040840983346,
          0.06222426928088,
          75.03729574
        ],
        [
          0.00030231881991,
          0.06838614714013,
          74.01042827
        ],
        [
          0.00041231878308,
          0.0620180499571,
          75.08163989
        ],
        [
          0.00029921255321,
          0.06860150827584,
          73.97323403
        ],
        [
          0.00054783292149,
          0.05588432750336,
          76.45434428
        ],
        [
          0.00030232538188,
          0.06838564122054,
          74.01055293
        ],
        [
          0.0005791228722,
          0.05471781787633,
          76.7039157
        ],
        [
          0.00030059716596,
          0.06849999192538,
          73.99440187
        ],
        [
          0.00044107327776,
          0.06057372487482,
          75.38487824
        ],
        [
          0.00030372024612,
          0.06828430055096,
          74.0318286
        ],
        [
          0.00044511928533,
          0.06037332071748,
          75.43113087
        ],
        [
          0.0003006036984,
          0.06849948570991,
          73.99452623
        ],
        [
          0.00058437297664,
          0.05441710882367,
          76.86471411
        ],
        [
          0.0003037268226,
          0.06828379543339,
          74.03195352
        ],
        [
          0.00061654578993,
          0.05327817515693,
          77.12715111
        ],
        [
          0.00030893795008,
          0.0679553592965,
          74.07054162
        ],
        [
          0.00046322645226,
          0.05960543519662,
          75.52872754
        ],
        [
          0.0003121400538,
          0.06773966685593,
          74.10854512
        ],
        [
          0.00067805407521,
          0.05126291493705,
          77.597726
        ],
        [
          0.00030894463653,
          0.06795485384949,
          74.0706674
        ],
        [
          0.00061051452265,
          0.05351574994324,
          77.04723863
        ],
        [
          0.0003121467828,
          0.06773916263473,
          74.10867145
        ],
        [
          0.00084278201911,
          0.04603446115363,
          79.50552129
        ],
        [
          0.00031036638266,
          0.06785357784614,
          74.09216215
        ],
        [
          0.00049813540993,
          0.05801447291435,
          75.90130806
        ],
        [
          0.00031357845666,
          0.06763809167683,
          74.13027478
        ],
        [
          0.00071757312393,
          0.04990979816781,
          78.06312581
        ],
        [
          0.00031037308298,
          0.06785307324709,
          74.0922882
        ],
        [
          0.00064837613981,
          0.05211345268159,
          77.48449907
        ],
        [
          0.00031358519911,
          0.06763758832372,
          74.13040138
        ],
        [
          0.00088387357054,
          0.0448151778722,
          80.05171091
        ],
        [
          0.00030893795008,
          0.0679553592965,
          74.07054162
        ],
        [
          0.00053058207101,
          0.05674640279745,
          76.11511694
        ],
        [
          0.0003121400538,
          0.06773966685593,
          74.10854512
        ],
        [
          0.00075678168063,
          0.04877135922228,
          78.35438975
        ],
        [
          0.00030894463653,
          0.06795485384949,
          74.0706674
        ],
        [
          0.00068545953222,
          0.05094568757436,
          77.75217597
        ],
        [
          0.0003121467828,
          0.06773916263473,
          74.10867145
        ],
        [
          0.00096117928918,
          0.04291175501746,
          80.72452277
        ],
        [
          0.00031036638266,
          0.06785357784614,
          74.09216215
        ],
        [
          0.00056760269489,
          0.05523065230312,
          76.51650399
        ],
        [
          0.00031357845666,
          0.06763809167683,
          74.13027478
        ],
        [
          0.00079750385914,
          0.04747999968717,
          78.85441738
        ],
        [
          0.00031037308298,
          0.06785307324709,
          74.0922882
        ],
        [
          0.00072466609833,
          0.04961002357092,
          78.22167404
        ],
        [
          0.00031358519911,
          0.06763758832372,
          74.13040138
        ],
        [
          0.0010041835099,
          0.04174175283792,
          81.33181395
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00040378440678,
          0.06252318641987,
          74.93496444
        ],
        [
          0.00030125551195,
          0.06847425483161,
          73.9850118
        ],
        [
          0.00040748697708,
          0.06232831426284,
          74.97454442
        ],
        [
          0.00029831920944,
          0.06867617239882,
          73.95181908
        ],
        [
          0.00053930946483,
          0.05634283211675,
          76.24967658
        ],
        [
          0.00030126206771,
          0.06847374800493,
          73.9851362
        ],
        [
          0.000543485411,
          0.05616884885479,
          76.29611011
        ],
        [
          0.00029952675928,
          0.06858914544397,
          73.96874974
        ],
        [
          0.00043497217049,
          0.06094794189097,
          75.24821686
        ],
        [
          0.00030247842151,
          0.06838684644293,
          74.00215132
        ],
        [
          0.00043881365914,
          0.06075790461302,
          75.28946945
        ],
        [
          0.00029953328524,
          0.0685886383225,
          73.96887385
        ],
        [
          0.0005745648311,
          0.05492931184422,
          76.6194654
        ],
        [
          0.000302484991,
          0.06838634025941,
          74.00227595
        ],
        [
          0.0005788080917,
          0.05476077594827,
          76.66763885
        ],
        [
          0.00029831269747,
          0.06867668014834,
          73.95169519
        ],
        [
          0.00040378440678,
          0.06252318641987,
          74.93496444
        ],
        [
          0.00030125551195,
          0.06847425483161,
          73.9850118
        ],
        [
          0.00040748697708,
          0.06232831426284,
          74.97454442
        ],
        [
          0.00029831920944,
          0.06867617239882,
          73.95181908
        ],
        [
          0.00053930946483,
          0.05634283211675,
          76.24967658
        ],
        [
          0.00030126206771,
          0.06847374800493,
          73.9851362
        ],
        [
          0.00057018029477,
          0.05518207065292,
          76.48724878
        ],
        [
          0.00029952675928,
          0.06858914544397,
          73.96874974
        ],
        [
          0.00043497217049,
          0.06094794189097,
          75.24821686
        ],
        [
          0.00030247842151,
          0.06838684644293,
          74.00215132
        ],
        [
          0.00043881365914,
          0.06075790461302,
          75.28946945
        ],
        [
          0.00029953328524,
          0.0685886383225,
          73.96887385
        ],
        [
          0.0005745648311,
          0.05492931184422,
          76.6194654
        ],
        [
          0.000302484991,
          0.06838634025941,
          74.00227595
        ],
        [
          0.00060634418619,
          0.05379411491063,
          76.8688041
        ],
        [
          0.00030774123552,
          0.068052566234,
          74.04226804
        ],
        [
          0.00045707695837,
          0.05996771457898,
          75.39278788
        ],
        [
          0.00031076757098,
          0.06785021316742,
          74.07619631
        ],
        [
          0.0006667786696,
          0.05180055135488,
          77.30776963
        ],
        [
          0.0003077479159,
          0.06805205973885,
          74.04239354
        ],
        [
          0.00060070624649,
          0.05401320665467,
          76.80126195
        ],
        [
          0.0003107742936,
          0.0678497077296,
          74.07632233
        ],
        [
          0.00082899566014,
          0.0466570894238,
          79.06971721
        ],
        [
          0.00030898756604,
          0.06796519712421,
          74.05958866
        ],
        [
          0.00049052811592,
          0.05844356736711,
          75.72873594
        ],
        [
          0.00031202253346,
          0.06776299283304,
          74.09360252
        ],
        [
          0.00070516304268,
          0.05049191960772,
          77.72678963
        ],
        [
          0.00030899425963,
          0.06796469131152,
          74.05971438
        ],
        [
          0.00063737502685,
          0.05265918680463,
          77.19519506
        ],
        [
          0.00031202926897,
          0.06776248809395,
          74.09372876
        ],
        [
          0.000869166579,
          0.04547686681927,
          79.55937789
        ],
        [
          0.00030774123552,
          0.068052566234,
          74.04226804
        ],
        [
          0.00052299705331,
          0.05715444546717,
          75.94402851
        ],
        [
          0.00031076757098,
          0.06785021316742,
          74.07619631
        ],
        [
          0.00074449347317,
          0.04933112041053,
          78.01632184
        ],
        [
          0.0003077479159,
          0.06805205973885,
          74.04239354
        ],
        [
          0.00067454766907,
          0.05146915230254,
          77.46220233
        ],
        [
          0.0003107742936,
          0.0678497077296,
          74.07632233
        ],
        [
          0.00094638919075,
          0.04355256884329,
          80.21169315
        ],
        [
          0.00030898756604,
          0.06796519712421,
          74.05958866
        ],
        [
          0.00055862631957,
          0.05569745788051,
          76.30621403
        ],
        [
          0.00031202253346,
          0.06776299283304,
          74.09360252
        ],
        [
          0.00078415751881,
          0.04808174050638,
          78.46619204
        ],
        [
          0.00030899425963,
          0.06796469131152,
          74.05971438
        ],
        [
          0.00071265141565,
          0.05017788646391,
          77.88504926
        ],
        [
          0.00031202926897,
          0.06776248809395,
          74.09372876
        ],
        [
          0.00098846770821,
          0.04242256408002,
          80.75489402
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00039877372453,
          0.06283654418061,
          74.83700879
        ],
        [
          0.0003002244835,
          0.06855671541112,
          73.96315904
        ],
        [
          0.00040225261172,
          0.06265352915364,
          74.87211036
        ],
        [
          0.00029746766108,
          0.06874484290939,
          73.93371877
        ],
        [
          0.00052954916542,
          0.05684422265797,
          76.04785627
        ],
        [
          0.00030023103212,
          0.06855620776745,
          73.96328323
        ],
        [
          0.00053351121823,
          0.05667908512032,
          76.0890195
        ],
        [
          0.00029850777949,
          0.06867106271872,
          73.9471003
        ],
        [
          0.00042835858009,
          0.0613398663446,
          75.1181314
        ],
        [
          0.00030127855052,
          0.06848251331238,
          73.97673006
        ],
        [
          0.00043197452028,
          0.06116079150733,
          75.15468742
        ],
        [
          0.00029851429824,
          0.06867055479303,
          73.9472242
        ],
        [
          0.00056330677567,
          0.05548759825242,
          76.37954413
        ],
        [
          0.00030128511187,
          0.06848200617336,
          73.97685442
        ],
        [
          0.00056734424229,
          0.05532719153011,
          76.42220803
        ],
        [
          0.00029746115531,
          0.06874535132569,
          73.93359506
        ],
        [
          0.00039877372453,
          0.06283654418061,
          74.83700879
        ],
        [
          0.0003002244835,
          0.06855671541112,
          73.96315904
        ],
        [
          0.00040225261172,
          0.06265352915364,
          74.87211036
        ],
        [
          0.00029746766108,
          0.06874484290939,
          73.93371877
        ],
        [
          0.00052954916542,
          0.05684422265797,
          76.04785627
        ],
        [
          0.00030023103212,
          0.06855620776745,
          73.96328323
        ],
        [
          0.00055990663303,
          0.05568996525104,
          76.27357872
        ],
        [
          0.00029850777949,
          0.06867106271872,
          73.9471003
        ],
        [
          0.00042835858009,
          0.0613398663446,
          75.1181314
        ],
        [
          0.00030127855052,
          0.06848251331238,
          73.97673006
        ],
        [
          0.00043197452028,
          0.06116079150733,
          75.15468742
        ],
        [
          0.00029851429824,
          0.06867055479303,
          73.9472242
        ],
        [
          0.00056330677567,
          0.05548759825242,
          76.37954413
        ],
        [
          0.00030128511187,
          0.06848200617336,
          73.97685442
        ],
        [
          0.00059459063,
          0.05435673459117,
          76.61600166
        ],
        [
          0.00030655465023,
          0.06814563949929,
          74.01739201
        ],
        [
          0.00045037938499,
          0.06034856089638,
          75.2627457
        ],
        [
          0.00030939520616,
          0.06795698469181,
          74.04749788
        ],
        [
          0.00065389495457,
          0.05237903223461,
          77.02800212
        ],
        [
          0.00030656132344,
          0.06814513208658,
          74.01751721
        ],
        [
          0.00058940033451,
          0.05455659503366,
          76.55978554
        ],
        [
          0.00030940192077,
          0.06795647812249,
          74.0476236
        ],
        [
          0.0008124089693,
          0.04734072352088,
          78.64404088
        ],
        [
          0.00030762869724,
          0.0680714560135,
          74.03111043
        ],
        [
          0.00048221311541,
          0.05889483176387,
          75.56440068
        ],
        [
          0.00031047660248,
          0.06788290242268,
          74.06128236
        ],
        [
          0.00069088236365,
          0.05111795638618,
          77.40371322
        ],
        [
          0.00030763538263,
          0.06807094908709,
          74.03123587
        ],
        [
          0.00062463782165,
          0.05325389198008,
          76.91309517
        ],
        [
          0.00031048332921,
          0.0678823964034,
          74.06140827
        ],
        [
          0.00085135653596,
          0.04620141997698,
          79.08110389
        ],
        [
          0.00030655465023,
          0.06814563949929,
          74.01739201
        ],
        [
          0.00051464244796,
          0.05758597330409,
          75.77990981
        ],
        [
          0.00030939520616,
          0.06795698469181,
          74.04749788
        ],
        [
          0.00073027217933,
          0.04993446535027,
          77.69014502
        ],
        [
          0.00030656132344,
          0.06814513208658,
          74.01751721
        ],
        [
          0.00066183285626,
          0.05204141949996,
          77.17795499
        ],
        [
          0.00030940192077,
          0.06795647812249,
          74.0476236
        ],
        [
          0.00092837347005,
          0.04425417401731,
          79.71167111
        ],
        [
          0.00030762869724,
          0.0680714560135,
          74.03111043
        ],
        [
          0.00054868830192,
          0.05619133642824,
          76.10538903
        ],
        [
          0.00031047660248,
          0.06788290242268,
          74.06128236
        ],
        [
          0.00076860064186,
          0.04872968456846,
          78.09325009
        ],
        [
          0.00030763538263,
          0.06807094908709,
          74.03123587
        ],
        [
          0.00069857425929,
          0.0507972591716,
          77.55712258
        ],
        [
          0.00031048332921,
          0.0678823964034,
          74.06140827
        ],
        [
          0.00096920787904,
          0.04316560163923,
          80.19549405
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.0003933261376,
          0.06316880031917,
          74.74190858
        ],
        [
          0.00029913230083,
          0.06864150421574,
          73.94245306
        ],
        [
          0.00039657592061,
          0.06299751233553,
          74.77296875
        ],
        [
          0.0002965495058,
          0.06881668350372,
          73.91626346
        ],
        [
          0.00051833744236,
          0.05740162126782,
          75.84510288
        ],
        [
          0.00029913230083,
          0.06864150421574,
          73.94245306
        ],
        [
          0.00052206981114,
          0.05724529513208,
          75.88148302
        ],
        [
          0.00029744670018,
          0.06875385806686,
          73.9269384
        ],
        [
          0.00042120935152,
          0.0617529241251,
          74.99314599
        ],
        [
          0.00030003568211,
          0.0685787355718,
          73.95317878
        ],
        [
          0.00042459166511,
          0.06158477610621,
          75.0254664
        ],
        [
          0.00029744670018,
          0.06875385806686,
          73.9269384
        ],
        [
          0.00055041590571,
          0.05610409389791,
          76.14117197
        ],
        [
          0.00030003568211,
          0.0685787355718,
          73.95317878
        ],
        [
          0.00055422878733,
          0.05595182450688,
          76.1788428
        ],
        [
          0.0002965495058,
          0.06881668350372,
          73.91626346
        ],
        [
          0.0003933261376,
          0.06316880031917,
          74.74190858
        ],
        [
          0.00029913230083,
          0.06864150421574,
          73.94245306
        ],
        [
          0.00039657592061,
          0.06299751233553,
          74.77296875
        ],
        [
          0.0002965495058,
          0.06881668350372,
          73.91626346
        ],
        [
          0.00051833744236,
          0.05740162126782,
          75.84510288
        ],
        [
          0.00029913230083,
          0.06864150421574,
          73.94245306
        ],
        [
          0.00054807615695,
          0.05625474541974,
          76.05894282
        ],
        [
          0.00029744670018,
          0.06875385806686,
          73.9269384
        ],
        [
          0.00042120935152,
          0.0617529241251,
          74.99314599
        ],
        [
          0.00030003568211,
          0.0685787355718,
          73.95317878
        ],
        [
          0.00042459166511,
          0.06158477610621,
          75.0254664
        ],
        [
          0.00029744670018,
          0.06875385806686,
          73.9269384
        ],
        [
          0.00055041590571,
          0.05610409389791,
          76.14117197
        ],
        [
          0.00030003568211,
          0.0685787355718,
          73.95317878
        ],
        [
          0.00058109146406,
          0.05497830420035,
          76.36478276
        ],
        [
          0.00030526582411,
          0.06824382119077,
          73.99320399
        ],
        [
          0.0004429277172,
          0.06076133262868,
          75.13415161
        ],
        [
          0.00030791916015,
          0.06806855196654,
          74.01987126
        ],
        [
          0.00063878230069,
          0.05302928436071,
          76.74537174
        ],
        [
          0.00030526582411,
          0.06824382119077,
          73.99320399
        ],
        [
          0.00057621533063,
          0.05516657795956,
          76.31567763
        ],
        [
          0.00030791916015,
          0.06806855196654,
          74.01987126
        ],
        [
          0.00079223324015,
          0.04812040876774,
          78.21145343
        ],
        [
          0.00030618590847,
          0.06818106151898,
          74.00404957
        ],
        [
          0.00047301462624,
          0.05938036202371,
          75.4038239
        ],
        [
          0.00030884560766,
          0.06800584872243,
          74.03076692
        ],
        [
          0.00067415410889,
          0.05181721759467,
          77.08059428
        ],
        [
          0.00030618590847,
          0.06818106151898,
          74.00404957
        ],
        [
          0.00060981889825,
          0.05391698562865,
          76.63098197
        ],
        [
          0.00030884560766,
          0.06800584872243,
          74.03076692
        ],
        [
          0.00082969988496,
          0.04702247543181,
          78.59946437
        ],
        [
          0.00030526582411,
          0.06824382119077,
          73.99320399
        ],
        [
          0.00050517782807,
          0.05806052573172,
          75.61578892
        ],
        [
          0.00030791916015,
          0.06806855196654,
          74.01987126
        ],
        [
          0.00071336376248,
          0.0506163745672,
          77.35944692
        ],
        [
          0.00030526582411,
          0.06824382119077,
          73.99320399
        ],
        [
          0.00064679676043,
          0.05268809130525,
          76.88938919
        ],
        [
          0.00030791916015,
          0.06806855196654,
          74.01987126
        ],
        [
          0.00090618890222,
          0.04505509001933,
          79.20268968
        ],
        [
          0.00030618590847,
          0.06818106151898,
          74.00404957
        ],
        [
          0.00053748217306,
          0.05673040660332,
          75.90696679
        ],
        [
          0.00030884560766,
          0.06800584872243,
          74.03076692
        ],
        [
          0.00075012343461,
          0.04945721161343,
          77.71885854
        ],
        [
          0.00030618590847,
          0.06818106151898,
          74.00404957
        ],
        [
          0.00068195648346,
          0.05149237136001,
          77.22768723
        ],
        [
          0.00030884560766,
          0.06800584872243,
          74.03076692
        ],
        [
          0.00094551418694,
          0.04400796837886,
          79.63125829
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00038739788134,
          0.0635237299441,
          74.64869234
        ],
        [
          0.00029803618414,
          0.06872448004763,
          73.92373051
        ],
        [
          0.00039040132495,
          0.0633648457867,
          74.67588199
        ],
        [
          0.00029564474299,
          0.06888568283672,
          73.90076807
        ],
        [
          0.00050580312522,
          0.05801135311087,
          75.6444006
        ],
        [
          0.00029803618414,
          0.06872448004763,
          73.92373051
        ],
        [
          0.0005092777209,
          0.05786458429353,
          75.67620091
        ],
        [
          0.00029642655114,
          0.06883146787276,
          73.90947622
        ],
        [
          0.00041341090544,
          0.06219551547487,
          74.87078511
        ],
        [
          0.00029882316181,
          0.06867030095077,
          73.93247854
        ],
        [
          0.00041653957498,
          0.06203902931804,
          74.89905128
        ],
        [
          0.00029642655114,
          0.06883146787276,
          73.90947622
        ],
        [
          0.00053594767268,
          0.05677976405551,
          75.90576845
        ],
        [
          0.00029882316181,
          0.06867030095077,
          73.93247854
        ],
        [
          0.00053950505645,
          0.05663637738498,
          75.93866509
        ],
        [
          0.00029564474299,
          0.06888568283672,
          73.90076807
        ],
        [
          0.00038739788134,
          0.0635237299441,
          74.64869234
        ],
        [
          0.00029803618414,
          0.06872448004763,
          73.92373051
        ],
        [
          0.00039040132495,
          0.0633648457867,
          74.67588199
        ],
        [
          0.00029564474299,
          0.06888568283672,
          73.90076807
        ],
        [
          0.00050580312522,
          0.05801135311087,
          75.6444006
        ],
        [
          0.00029803618414,
          0.06872448004763,
          73.92373051
        ],
        [
          0.0005347718943,
          0.05687513892291,
          75.84569137
        ],
        [
          0.00029642655114,
          0.06883146787276,
          73.90947622
        ],
        [
          0.00041341090544,
          0.06219551547487,
          74.87078511
        ],
        [
          0.00029882316181,
          0.06867030095077,
          73.93247854
        ],
        [
          0.00041653957498,
          0.06203902931804,
          74.89905128
        ],
        [
          0.00029642655114,
          0.06883146787276,
          73.90947622
        ],
        [
          0.00053594767268,
          0.05677976405551,
          75.90576845
        ],
        [
          0.00029882316181,
          0.06867030095077,
          73.93247854
        ],
        [
          0.00056585408834,
          0.05566202677833,
          76.11587814
        ],
        [
          0.00030393146737,
          0.06834299755623,
          73.97063039
        ],
        [
          0.0004347745572,
          0.06120468645782,
          75.00789469
        ],
        [
          0.00030638634885,
          0.06818164295811,
          73.99400634
        ],
        [
          0.0006217983486,
          0.0537394059372,
          76.46768843
        ],
        [
          0.00030393146737,
          0.06834299755623,
          73.97063039
        ],
        [
          0.00056137411985,
          0.05583593361372,
          76.07418398
        ],
        [
          0.00030638634885,
          0.06818164295811,
          73.99400634
        ],
        [
          0.00076894687289,
          0.04898146669591,
          77.78571249
        ],
        [
          0.00030473279945,
          0.06828880777871,
          73.97947551
        ],
        [
          0.00046291376169,
          0.05990354155965,
          75.24637192
        ],
        [
          0.00030719297899,
          0.06812748840839,
          74.00289198
        ],
        [
          0.0006552532173,
          0.05258245927006,
          76.76365118
        ],
        [
          0.00030473279945,
          0.06828880777871,
          73.97947551
        ],
        [
          0.00059306434061,
          0.0546458607133,
          76.35251688
        ],
        [
          0.00030719297899,
          0.06812748840839,
          74.00289198
        ],
        [
          0.00080459570524,
          0.04792941411721,
          78.12659376
        ],
        [
          0.00030393146737,
          0.06834299755623,
          73.97063039
        ],
        [
          0.0004945230587,
          0.05858391789442,
          75.45096995
        ],
        [
          0.00030638634885,
          0.06818164295811,
          73.99400634
        ],
        [
          0.00069396621331,
          0.05137196850206,
          77.0305919
        ],
        [
          0.00030393146737,
          0.06834299755623,
          73.97063039
        ],
        [
          0.00062951072214,
          0.05340897087754,
          76.60023507
        ],
        [
          0.00030638634885,
          0.06818164295811,
          73.99400634
        ],
        [
          0.00088011106862,
          0.04594783215669,
          78.69707922
        ],
        [
          0.00030473279945,
          0.06828880777871,
          73.97947551
        ],
        [
          0.00052484953931,
          0.05732489477155,
          75.70861046
        ],
        [
          0.00030719297899,
          0.06812748840839,
          74.00289198
        ],
        [
          0.00072884179479,
          0.05026358627774,
          77.34765212
        ],
        [
          0.00030473279945,
          0.06828880777871,
          73.97947551
        ],
        [
          0.00066278855192,
          0.0522672148844,
          76.89877519
        ],
        [
          0.00030719297899,
          0.06812748840839,
          74.00289198
        ],
        [
          0.00091758910856,
          0.04494565076862,
          79.07271474
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00038072196726,
          0.06391837551403,
          74.55346553
        ],
        [
          0.00029688883005,
          0.06880948872519,
          73.90596524
        ],
        [
          0.00038346037186,
          0.06377266079236,
          74.57691135
        ],
        [
          0.00029470092971,
          0.06895609431617,
          73.88611748
        ],
        [
          0.00049110681141,
          0.0587177920657,
          75.43399722
        ],
        [
          0.00029688883005,
          0.06880948872519,
          73.90596524
        ],
        [
          0.00049429373434,
          0.05858135782857,
          75.4613528
        ],
        [
          0.00029535910611,
          0.06891093390305,
          73.89291506
        ],
        [
          0.00040468827402,
          0.06268507139292,
          74.74697376
        ],
        [
          0.00029755114309,
          0.06876434710987,
          73.91279279
        ],
        [
          0.00040754209298,
          0.06254107646875,
          74.77132171
        ],
        [
          0.00029535910611,
          0.06891093390305,
          73.89291506
        ],
        [
          0.00051904877642,
          0.05755894635232,
          75.66121738
        ],
        [
          0.00029755114309,
          0.06876434710987,
          73.91279279
        ],
        [
          0.00052231828818,
          0.05742522160568,
          75.68948901
        ],
        [
          0.00029470092971,
          0.06895609431617,
          73.88611748
        ],
        [
          0.00038072196726,
          0.06391837551403,
          74.55346553
        ],
        [
          0.00029688883005,
          0.06880948872519,
          73.90596524
        ],
        [
          0.00038346037186,
          0.06377266079236,
          74.57691135
        ],
        [
          0.00029470092971,
          0.06895609431617,
          73.88611748
        ],
        [
          0.00049110681141,
          0.0587177920657,
          75.43399722
        ],
        [
          0.00029688883005,
          0.06880948872519,
          73.90596524
        ],
        [
          0.00051910495168,
          0.05759609395245,
          75.62162142
        ],
        [
          0.00029535910611,
          0.06891093390305,
          73.89291506
        ],
        [
          0.00040468827402,
          0.06268507139292,
          74.74697376
        ],
        [
          0.00029755114309,
          0.06876434710987,
          73.91279279
        ],
        [
          0.00040754209298,
          0.06254107646875,
          74.77132171
        ],
        [
          0.00029535910611,
          0.06891093390305,
          73.89291506
        ],
        [
          0.00051904877642,
          0.05755894635232,
          75.66121738
        ],
        [
          0.00029755114309,
          0.06876434710987,
          73.91279279
        ],
        [
          0.00054797592718,
          0.05645278157673,
          75.85671158
        ],
        [
          0.00030250028105,
          0.06844718418936,
          73.94867054
        ],
        [
          0.00042548436688,
          0.06170405618919,
          74.8777819
        ],
        [
          0.00030474428946,
          0.06830036776133,
          73.96886823
        ],
        [
          0.0006024256614,
          0.05453579816828,
          76.18750484
        ],
        [
          0.00030250028105,
          0.06844718418936,
          73.94867054
        ],
        [
          0.00054383587325,
          0.05661576213041,
          75.82067476
        ],
        [
          0.00030474428946,
          0.06830036776133,
          73.96886823
        ],
        [
          0.00074139762612,
          0.04997252448075,
          77.34963925
        ],
        [
          0.00030317439716,
          0.06840201711581,
          73.95557465
        ],
        [
          0.00045146471454,
          0.06049007768908,
          75.08561052
        ],
        [
          0.00030542258342,
          0.06825522068004,
          73.97580426
        ],
        [
          0.00063365948245,
          0.05344040520536,
          76.44514582
        ],
        [
          0.00030317439716,
          0.06840201711581,
          73.95557465
        ],
        [
          0.00057331985439,
          0.0554913871748,
          76.0626488
        ],
        [
          0.00030542258342,
          0.06825522068004,
          73.97580426
        ],
        [
          0.00077488412878,
          0.04897076600653,
          77.64477352
        ],
        [
          0.00030250028105,
          0.06844718418936,
          73.94867054
        ],
        [
          0.00048241797449,
          0.05917129927023,
          75.28247042
        ],
        [
          0.00030474428946,
          0.06830036776133,
          73.96886823
        ],
        [
          0.00067175028199,
          0.05221900423746,
          76.69987384
        ],
        [
          0.00030250028105,
          0.06844718418936,
          73.94867054
        ],
        [
          0.00060909284601,
          0.05424517448265,
          76.29904854
        ],
        [
          0.00030474428946,
          0.06830036776133,
          73.96886823
        ],
        [
          0.0008491199165,
          0.0469724126396,
          78.18094726
        ],
        [
          0.00030317439716,
          0.06840201711581,
          73.95557465
        ],
        [
          0.00051052320497,
          0.05799061675057,
          75.50718695
        ],
        [
          0.00030542258342,
          0.06825522068004,
          73.97580426
        ],
        [
          0.00070441944333,
          0.05116722117027,
          76.97573423
        ],
        [
          0.00030317439716,
          0.06840201711581,
          73.95557465
        ],
        [
          0.00064017692638,
          0.05316297783455,
          76.55860575
        ],
        [
          0.00030542258342,
          0.06825522068004,
          73.97580426
        ],
        [
          0.00088439901647,
          0.04601885574351,
          78.50551176
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00037516968648,
          0.06424358481457,
          74.48114206
        ],
        [
          0.00029597537799,
          0.06887591163404,
          73.893077
        ],
        [
          0.0003776758069,
          0.06410951825342,
          74.50160772
        ],
        [
          0.00029396572883,
          0.06900989706617,
          73.87571992
        ],
        [
          0.00047852680294,
          0.05931920488922,
          75.2713096
        ],
        [
          0.00029597537799,
          0.06887591163404,
          73.893077
        ],
        [
          0.00048145393435,
          0.05919224754124,
          75.29513996
        ],
        [
          0.00029452641598,
          0.06897176023858,
          73.88114436
        ],
        [
          0.00039745522484,
          0.06308809382682,
          74.65338987
        ],
        [
          0.00029653941183,
          0.06883778313954,
          73.89852448
        ],
        [
          0.00040006716276,
          0.06295525934441,
          74.67462637
        ],
        [
          0.00029452641598,
          0.06897176023858,
          73.88114436
        ],
        [
          0.00050459955716,
          0.05822152479035,
          75.47309174
        ],
        [
          0.00029653941183,
          0.06883778313954,
          73.89852448
        ],
        [
          0.00050760689687,
          0.05809674905098,
          75.49770417
        ],
        [
          0.00029396572883,
          0.06900989706617,
          73.87571992
        ],
        [
          0.00037516968648,
          0.06424358481457,
          74.48114206
        ],
        [
          0.00029597537799,
          0.06887591163404,
          73.893077
        ],
        [
          0.0003776758069,
          0.06410951825342,
          74.50160772
        ],
        [
          0.00029396572883,
          0.06900989706617,
          73.87571992
        ],
        [
          0.00047852680294,
          0.05931920488922,
          75.2713096
        ],
        [
          0.00029597537799,
          0.06887591163404,
          73.893077
        ],
        [
          0.0005055897623,
          0.05821408242135,
          75.44731176
        ],
        [
          0.00029452641598,
          0.06897176023858,
          73.88114436
        ],
        [
          0.00039745522484,
          0.06308809382682,
          74.65338987
        ],
        [
          0.00029653941183,
          0.06883778313954,
          73.89852448
        ],
        [
          0.00040006716276,
          0.06295525934441,
          74.67462637
        ],
        [
          0.00029452641598,
          0.06897176023858,
          73.88114436
        ],
        [
          0.00050459955716,
          0.05822152479035,
          75.47309174
        ],
        [
          0.00029653941183,
          0.06883778313954,
          73.89852448
        ],
        [
          0.0005325756463,
          0.05712941198454,
          75.65623194
        ],
        [
          0.00030137126822,
          0.06852789262753,
          73.93288617
        ],
        [
          0.00041770113703,
          0.06211934930022,
          74.77843727
        ],
        [
          0.00030343185167,
          0.06839361181894,
          73.95054599
        ],
        [
          0.00058534629573,
          0.05523182213184,
          75.9662057
        ],
        [
          0.00030137126822,
          0.06852789262753,
          73.93288617
        ],
        [
          0.00052873916363,
          0.05728261137387,
          75.62457156
        ],
        [
          0.00030343185167,
          0.06839361181894,
          73.95054599
        ],
        [
          0.00071676473916,
          0.05084524807754,
          77.00650719
        ],
        [
          0.0003019459723,
          0.06848968878654,
          73.93839459
        ],
        [
          0.00044189108714,
          0.06097751249026,
          74.96344977
        ],
        [
          0.00030400907971,
          0.06835546593666,
          73.95607799
        ],
        [
          0.0006146606616,
          0.05418793706931,
          76.19523406
        ],
        [
          0.0003019459723,
          0.06848968878654,
          73.93839459
        ],
        [
          0.0005563287926,
          0.05621375423007,
          75.83946867
        ],
        [
          0.00030400907971,
          0.06835546593666,
          73.95607799
        ],
        [
          0.00074834613496,
          0.04988513490597,
          77.26773437
        ],
        [
          0.00030137126822,
          0.06852789262753,
          73.93288617
        ],
        [
          0.00047204221061,
          0.05967121387913,
          75.15134185
        ],
        [
          0.00030343185167,
          0.06839361181894,
          73.95054599
        ],
        [
          0.0006519116667,
          0.05296647716794,
          76.43690121
        ],
        [
          0.00030137126822,
          0.06852789262753,
          73.93288617
        ],
        [
          0.00059123704326,
          0.05496974655689,
          76.06377277
        ],
        [
          0.00030343185167,
          0.06839361181894,
          73.95054599
        ],
        [
          0.00082105187908,
          0.047880891246,
          77.77237323
        ],
        [
          0.0003019459723,
          0.06848968878654,
          73.93839459
        ],
        [
          0.00049827968547,
          0.05855574358232,
          75.35147862
        ],
        [
          0.00030400907971,
          0.06835546593666,
          73.95607799
        ],
        [
          0.00068265992525,
          0.05196169144357,
          76.6820432
        ],
        [
          0.0003019459723,
          0.06848968878654,
          73.93839459
        ],
        [
          0.00062041901927,
          0.05393764940259,
          76.29428611
        ],
        [
          0.00030400907971,
          0.06835546593666,
          73.95607799
        ],
        [
          0.00085439540767,
          0.04696687648122,
          78.05920606
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00036938859216,
          0.06457983721092,
          74.41198056
        ],
        [
          0.00029508168182,
          0.06893982899711,
          73.8815349
        ],
        [
          0.00037165426554,
          0.06445785626842,
          74.42962242
        ],
        [
          0.00029325640656,
          0.0690609261679,
          73.8665393
        ],
        [
          0.00046516196226,
          0.05995734036821,
          75.11374853
        ],
        [
          0.00029508168182,
          0.06893982899711,
          73.8815349
        ],
        [
          0.00046781413101,
          0.05984048201037,
          75.1342393
        ],
        [
          0.00029373018858,
          0.06902895205182,
          73.87084332
        ],
        [
          0.0003898883692,
          0.06350770905588,
          74.56356569
        ],
        [
          0.00029555812288,
          0.06890785597287,
          73.88585637
        ],
        [
          0.00039224890035,
          0.06338653468626,
          74.58185438
        ],
        [
          0.00029373018858,
          0.06902895205182,
          73.87084332
        ],
        [
          0.0004891979667,
          0.05892730440499,
          75.29082496
        ],
        [
          0.00029555812288,
          0.06890785597287,
          73.88585637
        ],
        [
          0.00049192600377,
          0.05881212366337,
          75.31197298
        ],
        [
          0.00029325640656,
          0.0690609261679,
          73.8665393
        ],
        [
          0.00036938859216,
          0.06457983721092,
          74.41198056
        ],
        [
          0.00029508168182,
          0.06893982899711,
          73.8815349
        ],
        [
          0.00037165426554,
          0.06445785626842,
          74.42962242
        ],
        [
          0.00029325640656,
          0.0690609261679,
          73.8665393
        ],
        [
          0.00046516196226,
          0.05995734036821,
          75.11374853
        ],
        [
          0.00029508168182,
          0.06893982899711,
          73.8815349
        ],
        [
          0.00049115028621,
          0.05887318315108,
          75.27776654
        ],
        [
          0.00029373018858,
          0.06902895205182,
          73.87084332
        ],
        [
          0.0003898883692,
          0.06350770905588,
          74.56356569
        ],
        [
          0.00029555812288,
          0.06890785597287,
          73.88585637
        ],
        [
          0.00039224890035,
          0.06338653468626,
          74.58185438
        ],
        [
          0.00029373018858,
          0.06902895205182,
          73.87084332
        ],
        [
          0.0004891979667,
          0.05892730440499,
          75.29082496
        ],
        [
          0.00029555812288,
          0.06890785597287,
          73.88585637
        ],
        [
          0.00051607281875,
          0.05785346253278,
          75.46125722
        ],
        [
          0.00030022023007,
          0.06860888797478,
          73.91813836
        ],
        [
          0.00040949820322,
          0.06255500014515,
          74.68237347
        ],
        [
          0.00030209035286,
          0.06848746188879,
          73.93339095
        ],
        [
          0.0005671142443,
          0.05597269428279,
          75.75224248
        ],
        [
          0.00030022023007,
          0.06860888797478,
          73.91813836
        ],
        [
          0.00051256441174,
          0.05799603786354,
          75.43378226
        ],
        [
          0.00030209035286,
          0.06848746188879,
          73.93339095
        ],
        [
          0.00069003583425,
          0.05178627098821,
          76.67408468
        ],
        [
          0.00030070492699,
          0.06857687142622,
          73.92250913
        ],
        [
          0.00043177012214,
          0.06149123048813,
          74.84518866
        ],
        [
          0.00030257768735,
          0.06845545113701,
          73.9377794
        ],
        [
          0.0005943032392,
          0.05498638863254,
          75.9535413
        ],
        [
          0.00030070492699,
          0.06857687142622,
          73.92250913
        ],
        [
          0.0005380699599,
          0.05698894307376,
          75.6223979
        ],
        [
          0.00030257768735,
          0.06845545113701,
          73.9377794
        ],
        [
          0.00071946999793,
          0.05087275003423,
          76.90272221
        ],
        [
          0.00030022023007,
          0.06860888797478,
          73.91813836
        ],
        [
          0.00046104073698,
          0.06019940314176,
          75.02411199
        ],
        [
          0.00030209035286,
          0.06848746188879,
          73.93339095
        ],
        [
          0.00063059494492,
          0.05376571736815,
          76.18225993
        ],
        [
          0.00030022023007,
          0.06860888797478,
          73.91813836
        ],
        [
          0.00057199253695,
          0.05574840654888,
          75.83461892
        ],
        [
          0.00030209035286,
          0.06848746188879,
          73.93339095
        ],
        [
          0.00079035662838,
          0.04886356925752,
          77.37579148
        ],
        [
          0.00030070492699,
          0.06857687142622,
          73.92250913
        ],
        [
          0.00048525604256,
          0.05915528734879,
          75.2003233
        ],
        [
          0.00030257768735,
          0.06845545113701,
          73.9377794
        ],
        [
          0.00065919895779,
          0.05281354323177,
          76.39766895
        ],
        [
          0.00030070492699,
          0.06857687142622,
          73.92250913
        ],
        [
          0.00059906106348,
          0.05477227879644,
          76.03698652
        ],
        [
          0.00030257768735,
          0.06845545113701,
          73.9377794
        ],
        [
          0.00082151691666,
          0.04799317718485,
          77.62653054
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00036332464307,
          0.06493120900918,
          74.34505359
        ],
        [
          0.00029417094732,
          0.06900402885704,
          73.87072606
        ],
        [
          0.00036533408442,
          0.06482224158721,
          74.35992408
        ],
        [
          0.00029254301905,
          0.06911148243143,
          73.85805617
        ],
        [
          0.00045067599711,
          0.06065217068752,
          74.95711952
        ],
        [
          0.00029417094732,
          0.06900402885704,
          73.87072606
        ],
        [
          0.00045302952808,
          0.06054650063753,
          74.97433489
        ],
        [
          0.00029295509676,
          0.06908380721003,
          73.86162987
        ],
        [
          0.00038200032853,
          0.06394464218248,
          74.47723673
        ],
        [
          0.0002945851601,
          0.06897635024993,
          73.87431321
        ],
        [
          0.00038409256768,
          0.06383612046597,
          74.49263749
        ],
        [
          0.00029295509676,
          0.06908380721003,
          73.86162987
        ],
        [
          0.00047258114799,
          0.05969315499085,
          75.11090834
        ],
        [
          0.0002945851601,
          0.06897635024993,
          73.87431321
        ],
        [
          0.00047500443642,
          0.05958868908735,
          75.12866472
        ],
        [
          0.00029254301905,
          0.06911148243143,
          73.85805617
        ],
        [
          0.00036332464307,
          0.06493120900918,
          74.34505359
        ],
        [
          0.00029417094732,
          0.06900402885704,
          73.87072606
        ],
        [
          0.00036533408442,
          0.06482224158721,
          74.35992408
        ],
        [
          0.00029254301905,
          0.06911148243143,
          73.85805617
        ],
        [
          0.00045067599711,
          0.06065217068752,
          74.95711952
        ],
        [
          0.00029417094732,
          0.06900402885704,
          73.87072606
        ],
        [
          0.00047539040692,
          0.05959574640819,
          75.10825855
        ],
        [
          0.00029295509676,
          0.06908380721003,
          73.86162987
        ],
        [
          0.00038200032853,
          0.06394464218248,
          74.47723673
        ],
        [
          0.0002945851601,
          0.06897635024993,
          73.87431321
        ],
        [
          0.00038409256768,
          0.06383612046597,
          74.49263749
        ],
        [
          0.00029295509676,
          0.06908380721003,
          73.86162987
        ],
        [
          0.00047258114799,
          0.05969315499085,
          75.11090834
        ],
        [
          0.0002945851601,
          0.06897635024993,
          73.87431321
        ],
        [
          0.00049814410008,
          0.05864429483292,
          75.26773956
        ],
        [
          0.00029901059045,
          0.06869285082441,
          73.90388743
        ],
        [
          0.00040078388749,
          0.06301748316964,
          74.58828102
        ],
        [
          0.0003006771716,
          0.0685850384764,
          73.91676931
        ],
        [
          0.0005475007234,
          0.05677286071952,
          75.54232705
        ],
        [
          0.00029901059045,
          0.06869285082441,
          73.90388743
        ],
        [
          0.00049491952082,
          0.05877840608624,
          75.24355397
        ],
        [
          0.0003006771716,
          0.0685850384764,
          73.91676931
        ],
        [
          0.00066062781554,
          0.05282503028842,
          76.34483716
        ],
        [
          0.00029943175071,
          0.06866512602665,
          73.90751482
        ],
        [
          0.00042108131512,
          0.06203452110447,
          74.73020668
        ],
        [
          0.00030110036754,
          0.06855731851113,
          73.9204104
        ],
        [
          0.00057243960131,
          0.05584757727847,
          75.71753123
        ],
        [
          0.00029943175071,
          0.06866512602665,
          73.90751482
        ],
        [
          0.00051822471087,
          0.05783648399686,
          75.40736999
        ],
        [
          0.00030110036754,
          0.06855731851113,
          73.9204104
        ],
        [
          0.00068774974706,
          0.05196062546112,
          76.54293941
        ],
        [
          0.00029901059045,
          0.06869285082441,
          73.90388743
        ],
        [
          0.0004492035335,
          0.06076844515662,
          74.89816352
        ],
        [
          0.0003006771716,
          0.0685850384764,
          73.91676931
        ],
        [
          0.00060742683946,
          0.0546368361851,
          75.93102311
        ],
        [
          0.00029901059045,
          0.06869285082441,
          73.90388743
        ],
        [
          0.00055082037667,
          0.05660911461513,
          75.60520579
        ],
        [
          0.0003006771716,
          0.0685850384764,
          73.91676931
        ],
        [
          0.00075622123853,
          0.04995580009647,
          76.98107465
        ],
        [
          0.00029943175071,
          0.06866512602665,
          73.90751482
        ],
        [
          0.00047131628536,
          0.05979875526441,
          75.05180558
        ],
        [
          0.00030110036754,
          0.06855731851113,
          73.9204104
        ],
        [
          0.00063374542547,
          0.05374027601588,
          76.11847751
        ],
        [
          0.00029943175071,
          0.06866512602665,
          73.90751482
        ],
        [
          0.00057563923253,
          0.05569206020206,
          75.78101021
        ],
        [
          0.00030110036754,
          0.06855731851113,
          73.9204104
        ],
        [
          0.00078502752336,
          0.04913073552534,
          77.19808274
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00035653703932,
          0.0653243903188,
          74.27567245
        ],
        [
          0.0002932186844,
          0.06907031675255,
          73.86030429
        ],
        [
          0.00035828724367,
          0.06522858800773,
          74.28795439
        ],
        [
          0.00029179002303,
          0.06916414780593,
          73.84980094
        ],
        [
          0.00043473019339,
          0.06142524937951,
          74.79817378
        ],
        [
          0.0002932186844,
          0.06907031675255,
          73.86030429
        ],
        [
          0.00043677754977,
          0.06133117924477,
          74.81233272
        ],
        [
          0.00029213852023,
          0.0691408529707,
          73.85268048
        ],
        [
          0.00037327973304,
          0.06442901761726,
          74.3888748
        ],
        [
          0.00029356882809,
          0.06904701576167,
          73.86319376
        ],
        [
          0.00037510018706,
          0.06433336745469,
          74.40158001
        ],
        [
          0.00029213852023,
          0.0691408529707,
          73.85268048
        ],
        [
          0.00045434101566,
          0.06054431560925,
          74.92921569
        ],
        [
          0.00029356882809,
          0.06904701576167,
          73.86319376
        ],
        [
          0.00045645057805,
          0.06045102334582,
          74.94380915
        ],
        [
          0.00029179002303,
          0.06916414780593,
          73.84980094
        ],
        [
          0.00035653703932,
          0.0653243903188,
          74.27567245
        ],
        [
          0.0002932186844,
          0.06907031675255,
          73.86030429
        ],
        [
          0.00035828724367,
          0.06522858800773,
          74.28795439
        ],
        [
          0.00029179002303,
          0.06916414780593,
          73.84980094
        ],
        [
          0.00043473019339,
          0.06142524937951,
          74.79817378
        ],
        [
          0.0002932186844,
          0.06907031675255,
          73.86030429
        ],
        [
          0.00045793698892,
          0.06040478346423,
          74.93540564
        ],
        [
          0.00029213852023,
          0.0691408529707,
          73.85268048
        ],
        [
          0.00037327973304,
          0.06442901761726,
          74.3888748
        ],
        [
          0.00029356882809,
          0.06904701576167,
          73.86319376
        ],
        [
          0.00037510018706,
          0.06433336745469,
          74.40158001
        ],
        [
          0.00029213852023,
          0.0691408529707,
          73.85268048
        ],
        [
          0.00045434101566,
          0.06054431560925,
          74.92921569
        ],
        [
          0.00029356882809,
          0.06904701576167,
          73.86319376
        ],
        [
          0.00047834482958,
          0.05952855989802,
          75.0714087
        ],
        [
          0.00029775482587,
          0.06877900084666,
          73.89023659
        ],
        [
          0.00039109124234,
          0.06353370644734,
          74.49138155
        ],
        [
          0.00029921527081,
          0.06868484771621,
          73.90091234
        ],
        [
          0.0005257574085,
          0.05766980106768,
          75.32890494
        ],
        [
          0.00029775482587,
          0.06877900084666,
          73.89023659
        ],
        [
          0.00047545006671,
          0.05965233908209,
          75.05065352
        ],
        [
          0.00029921527081,
          0.06868484771621,
          73.90091234
        ],
        [
          0.00062789681988,
          0.05399642522058,
          76.01283839
        ],
        [
          0.00029811063801,
          0.06875565396241,
          73.89315793
        ],
        [
          0.00040928600956,
          0.06263770505723,
          74.61285882
        ],
        [
          0.00029957273416,
          0.06866149653382,
          73.9038437
        ],
        [
          0.00054824052476,
          0.05681219759457,
          75.47860391
        ],
        [
          0.00029811063801,
          0.06875565396241,
          73.89315793
        ],
        [
          0.00049636693865,
          0.05878265180963,
          75.19025105
        ],
        [
          0.00029957273416,
          0.06866149653382,
          73.9038437
        ],
        [
          0.00065245845243,
          0.05318692780084,
          76.18132608
        ],
        [
          0.00029775482587,
          0.06877900084666,
          73.89023659
        ],
        [
          0.00043583797683,
          0.06141522135331,
          74.76673615
        ],
        [
          0.00029921527081,
          0.06868484771621,
          73.90091234
        ],
        [
          0.00058139256149,
          0.05562655172527,
          75.67326658
        ],
        [
          0.00029775482587,
          0.06877900084666,
          73.89023659
        ],
        [
          0.00052712660958,
          0.05758478134651,
          75.37025732
        ],
        [
          0.00029921527081,
          0.06868484771621,
          73.90091234
        ],
        [
          0.00071764247761,
          0.05120292402025,
          76.57933935
        ],
        [
          0.00029811063801,
          0.06875565396241,
          73.89315793
        ],
        [
          0.00045568980235,
          0.06052627958238,
          74.89822438
        ],
        [
          0.00029957273416,
          0.06866149653382,
          73.9038437
        ],
        [
          0.00060519732541,
          0.0547916216266,
          75.83339437
        ],
        [
          0.00029811063801,
          0.06875565396241,
          73.89315793
        ],
        [
          0.0005494796341,
          0.05673337183095,
          75.52009207
        ],
        [
          0.00029957273416,
          0.06866149653382,
          73.9038437
        ],
        [
          0.00074383436711,
          0.05042775355706,
          76.76373801
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00035030714097,
          0.0656859666355,
          74.21648988
        ],
        [
          0.00029236374403,
          0.06912917214742,
          73.85164976
        ],
        [
          0.00035184324397,
          0.0656010651715,
          74.22678987
        ],
        [
          0.00029109983708,
          0.06921186178566,
          73.84280276
        ],
        [
          0.00042014054227,
          0.06214282053239,
          74.66341191
        ],
        [
          0.00029236374403,
          0.06912917214742,
          73.85164976
        ],
        [
          0.00042193183641,
          0.06205857606475,
          74.67522746
        ],
        [
          0.00029137288696,
          0.06919373102893,
          73.84492024
        ],
        [
          0.00036518930484,
          0.06488078283378,
          74.31269092
        ],
        [
          0.00029263812618,
          0.06911102533085,
          73.85377477
        ],
        [
          0.00036678457346,
          0.06479583823766,
          74.32332948
        ],
        [
          0.00029137288696,
          0.06919373102893,
          73.84492024
        ],
        [
          0.00043752431632,
          0.06134218999481,
          74.77423617
        ],
        [
          0.00029263812618,
          0.06911102533085,
          73.85377477
        ],
        [
          0.00043937019319,
          0.06125840207982,
          74.78640192
        ],
        [
          0.00029109983708,
          0.06921186178566,
          73.84280276
        ],
        [
          0.00035030714097,
          0.0656859666355,
          74.21648988
        ],
        [
          0.00029236374403,
          0.06912917214742,
          73.85164976
        ],
        [
          0.00035184324397,
          0.0656010651715,
          74.22678987
        ],
        [
          0.00029109983708,
          0.06921186178566,
          73.84280276
        ],
        [
          0.00042014054227,
          0.06214282053239,
          74.66341191
        ],
        [
          0.00029236374403,
          0.06912917214742,
          73.85164976
        ],
        [
          0.00044183361942,
          0.06116257446879,
          74.787768
        ],
        [
          0.00029137288696,
          0.06919373102893,
          73.84492024
        ],
        [
          0.00036518930484,
          0.06488078283378,
          74.31269092
        ],
        [
          0.00029263812618,
          0.06911102533085,
          73.85377477
        ],
        [
          0.00036678457346,
          0.06479583823766,
          74.32332948
        ],
        [
          0.00029137288696,
          0.06919373102893,
          73.84492024
        ],
        [
          0.00043752431632,
          0.06134218999481,
          74.77423617
        ],
        [
          0.00029263812618,
          0.06911102533085,
          73.85377477
        ],
        [
          0.00045995209909,
          0.06036414327413,
          74.90287857
        ],
        [
          0.00029657984338,
          0.06885879098897,
          73.87841529
        ],
        [
          0.00038207546418,
          0.06401691524325,
          74.40760309
        ],
        [
          0.00029787057168,
          0.0687757810676,
          73.88740342
        ],
        [
          0.00050528382757,
          0.05852810066451,
          75.1435143
        ],
        [
          0.00029657984338,
          0.06885879098897,
          73.87841529
        ],
        [
          0.00045744327722,
          0.0604742793005,
          74.88574422
        ],
        [
          0.00029787057168,
          0.0687757810676,
          73.88740342
        ],
        [
          0.00059706496865,
          0.0551224761799,
          75.7273644
        ],
        [
          0.00029685849827,
          0.06884060232378,
          73.88056353
        ],
        [
          0.00039823751976,
          0.06320794273291,
          74.51076649
        ],
        [
          0.00029815042327,
          0.06875758636593,
          73.88955861
        ],
        [
          0.0005253359252,
          0.05774136026258,
          75.27045647
        ],
        [
          0.00029685849827,
          0.06884060232378,
          73.88056353
        ],
        [
          0.00047601914264,
          0.05967992662833,
          75.00380431
        ],
        [
          0.00029815042327,
          0.06875758636593,
          73.88955861
        ],
        [
          0.00061905580224,
          0.05437200823385,
          75.86971657
        ],
        [
          0.00029657984338,
          0.06885879098897,
          73.87841529
        ],
        [
          0.00042328934541,
          0.06202873745223,
          74.65218998
        ],
        [
          0.00029787057168,
          0.0687757810676,
          73.88740342
        ],
        [
          0.00055667810265,
          0.05658226735438,
          75.44845826
        ],
        [
          0.00029657984338,
          0.06885879098897,
          73.87841529
        ],
        [
          0.00050498877275,
          0.05851330872298,
          75.16810337
        ],
        [
          0.00029787057168,
          0.0687757810676,
          73.88740342
        ],
        [
          0.00068082366217,
          0.05241547013935,
          76.23143551
        ],
        [
          0.00029685849827,
          0.06884060232378,
          73.88056353
        ],
        [
          0.00044093716977,
          0.06122187358541,
          74.76382734
        ],
        [
          0.00029815042327,
          0.06875758636593,
          73.88955861
        ],
        [
          0.000577973266,
          0.05581243705837,
          75.58424642
        ],
        [
          0.00029685849827,
          0.06884060232378,
          73.88056353
        ],
        [
          0.00052489987325,
          0.05773123363465,
          75.29485828
        ],
        [
          0.00029815042327,
          0.06875758636593,
          73.88955861
        ],
        [
          0.00070437609846,
          0.0516936454991,
          76.38718713
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00034438387816,
          0.06603067198709,
          74.16403379
        ],
        [
          0.00029160690899,
          0.069180751938,
          73.84454416
        ],
        [
          0.00034573165125,
          0.06595542500808,
          74.17270986
        ],
        [
          0.00029048814166,
          0.06925370572071,
          73.83705213
        ],
        [
          0.00040616995975,
          0.06284078962478,
          74.54324955
        ],
        [
          0.00029160690899,
          0.069180751938,
          73.84454416
        ],
        [
          0.00040773375237,
          0.06276544237686,
          74.5531418
        ],
        [
          0.00029069878066,
          0.06923981044295,
          73.83858354
        ],
        [
          0.00035752686185,
          0.06531128864177,
          74.24540889
        ],
        [
          0.00029181839766,
          0.06916684951111,
          73.8460803
        ],
        [
          0.00035892394195,
          0.06523587303301,
          74.25435472
        ],
        [
          0.00029069878066,
          0.06923981044295,
          73.83858354
        ],
        [
          0.0004214522563,
          0.06211875875309,
          74.63646271
        ],
        [
          0.00029181839766,
          0.06916684951111,
          73.8460803
        ],
        [
          0.00042306313343,
          0.06204362816194,
          74.6466361
        ],
        [
          0.00029048814166,
          0.06925370572071,
          73.83705213
        ],
        [
          0.00034438387816,
          0.06603067198709,
          74.16403379
        ],
        [
          0.00029160690899,
          0.069180751938,
          73.84454416
        ],
        [
          0.00034573165125,
          0.06595542500808,
          74.17270986
        ],
        [
          0.00029048814166,
          0.06925370572071,
          73.83705213
        ],
        [
          0.00040616995975,
          0.06284078962478,
          74.54324955
        ],
        [
          0.00029160690899,
          0.069180751938,
          73.84454416
        ],
        [
          0.00042631942764,
          0.06190495757263,
          74.65541135
        ],
        [
          0.00029069878066,
          0.06923981044295,
          73.83858354
        ],
        [
          0.00035752686185,
          0.06531128864177,
          74.24540889
        ],
        [
          0.00029181839766,
          0.06916684951111,
          73.8460803
        ],
        [
          0.00035892394195,
          0.06523587303301,
          74.25435472
        ],
        [
          0.00029069878066,
          0.06923981044295,
          73.83858354
        ],
        [
          0.0004214522563,
          0.06211875875309,
          74.63646271
        ],
        [
          0.00029181839766,
          0.06916684951111,
          73.8460803
        ],
        [
          0.00044226726793,
          0.06118304324872,
          74.75229195
        ],
        [
          0.00029548752511,
          0.06893229631737,
          73.86821682
        ],
        [
          0.00037341954773,
          0.0644842567957,
          74.33257162
        ],
        [
          0.00029662870624,
          0.06885903895595,
          73.87582356
        ],
        [
          0.00048531510145,
          0.05938113157301,
          74.97571029
        ],
        [
          0.00029548752511,
          0.06893229631737,
          73.86821682
        ],
        [
          0.00044008404838,
          0.06128161815712,
          74.73797003
        ],
        [
          0.00029662870624,
          0.06885903895595,
          73.87582356
        ],
        [
          0.00056684086851,
          0.0562538503331,
          75.46987183
        ],
        [
          0.00029570215874,
          0.06891835746787,
          73.86976949
        ],
        [
          0.00038767391698,
          0.06375888804852,
          74.41974471
        ],
        [
          0.00029684419166,
          0.06884509387844,
          73.87738099
        ],
        [
          0.00050303764182,
          0.05866476157742,
          75.08274773
        ],
        [
          0.00029570215874,
          0.06891835746787,
          73.86976949
        ],
        [
          0.00045643544543,
          0.06056171348701,
          74.83725598
        ],
        [
          0.00029684419166,
          0.06884509387844,
          73.87738099
        ],
        [
          0.00058633388441,
          0.05556303989962,
          75.58946815
        ],
        [
          0.00029548752511,
          0.06893229631737,
          73.86821682
        ],
        [
          0.00041113905991,
          0.06262983762979,
          74.54879286
        ],
        [
          0.00029662870624,
          0.06885903895595,
          73.87582356
        ],
        [
          0.00053241022499,
          0.05754021211015,
          75.24429719
        ],
        [
          0.00029548752511,
          0.06893229631737,
          73.86821682
        ],
        [
          0.0004834821736,
          0.05943467128455,
          74.98608304
        ],
        [
          0.00029662870624,
          0.06885903895595,
          73.87582356
        ],
        [
          0.00064434583577,
          0.05364605493597,
          75.91601232
        ],
        [
          0.00029570215874,
          0.06891835746787,
          73.86976949
        ],
        [
          0.00042670519719,
          0.0619027079593,
          74.64307571
        ],
        [
          0.00029684419166,
          0.06884509387844,
          73.87738099
        ],
        [
          0.00055128229398,
          0.05683546813895,
          75.35879696
        ],
        [
          0.00029570215874,
          0.06891835746787,
          73.86976949
        ],
        [
          0.00050105116848,
          0.05872183210702,
          75.09269339
        ],
        [
          0.00029684419166,
          0.06884509387844,
          73.87738099
        ],
        [
          0.00066531920224,
          0.05297793259864,
          76.04688387
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00033860723131,
          0.06636808553049,
          74.11621728
        ],
        [
          0.00029092496157,
          0.0692268040929,
          73.83859174
        ],
        [
          0.0003397780019,
          0.06630203615159,
          74.12346534
        ],
        [
          0.00028994364361,
          0.06929059736045,
          73.83229395
        ],
        [
          0.00039280621437,
          0.06352001387789,
          74.43579963
        ],
        [
          0.00029092496157,
          0.0692268040929,
          73.83859174
        ],
        [
          0.00039415591836,
          0.06345336402975,
          74.44400799
        ],
        [
          0.00029010928534,
          0.06927972735709,
          73.833433
        ],
        [
          0.0003501727677,
          0.06572739524088,
          74.1850227
        ],
        [
          0.00029109121345,
          0.06921592770047,
          73.83973407
        ],
        [
          0.0003513839952,
          0.06566110381665,
          74.19248338
        ],
        [
          0.00029010928534,
          0.06927972735709,
          73.833433
        ],
        [
          0.00040617243591,
          0.06287186418608,
          74.51410089
        ],
        [
          0.00029109121345,
          0.06921592770047,
          73.83973407
        ],
        [
          0.00040756202002,
          0.06280525178471,
          74.52253324
        ],
        [
          0.00028994364361,
          0.06929059736045,
          73.83229395
        ],
        [
          0.00033860723131,
          0.06636808553049,
          74.11621728
        ],
        [
          0.00029092496157,
          0.0692268040929,
          73.83859174
        ],
        [
          0.0003397780019,
          0.06630203615159,
          74.12346534
        ],
        [
          0.00028994364361,
          0.06929059736045,
          73.83229395
        ],
        [
          0.00039280621437,
          0.06352001387789,
          74.43579963
        ],
        [
          0.00029092496157,
          0.0692268040929,
          73.83859174
        ],
        [
          0.00041133764261,
          0.06263535731375,
          74.53597992
        ],
        [
          0.00029010928534,
          0.06927972735709,
          73.833433
        ],
        [
          0.0003501727677,
          0.06572739524088,
          74.1850227
        ],
        [
          0.00029109121345,
          0.06921592770047,
          73.83973407
        ],
        [
          0.0003513839952,
          0.06566110381665,
          74.19248338
        ],
        [
          0.00029010928534,
          0.06927972735709,
          73.833433
        ],
        [
          0.00040617243591,
          0.06287186418608,
          74.51410089
        ],
        [
          0.00029109121345,
          0.06921592770047,
          73.83973407
        ],
        [
          0.00042529721694,
          0.06198564262892,
          74.61738994
        ],
        [
          0.00029448520466,
          0.06899919630138,
          73.85951139
        ],
        [
          0.00036499761746,
          0.06494287690408,
          74.26426874
        ],
        [
          0.00029548502238,
          0.0689351227078,
          73.86590141
        ],
        [
          0.00046608410027,
          0.06022039289008,
          74.82500792
        ],
        [
          0.00029448520466,
          0.06899919630138,
          73.85951139
        ],
        [
          0.00042342661571,
          0.06207257427884,
          74.60556691
        ],
        [
          0.00029548502238,
          0.0689351227078,
          73.86590141
        ],
        [
          0.00053773421209,
          0.05737515699669,
          75.24023078
        ],
        [
          0.00029465380668,
          0.06898828876037,
          73.86066572
        ],
        [
          0.00037751779908,
          0.06429480227261,
          74.33787203
        ],
        [
          0.0002956542361,
          0.06892420940626,
          73.86705903
        ],
        [
          0.00048165545367,
          0.0595711783389,
          74.91512755
        ],
        [
          0.00029465380668,
          0.06898828876037,
          73.86066572
        ],
        [
          0.00043773571956,
          0.0614233839029,
          74.68892537
        ],
        [
          0.0002956542361,
          0.06892420940626,
          73.86705903
        ],
        [
          0.0005548906499,
          0.0567423946385,
          75.34053933
        ],
        [
          0.00029448520466,
          0.06899919630138,
          73.85951139
        ],
        [
          0.00039914179862,
          0.06323152346576,
          74.45327834
        ],
        [
          0.00029548502238,
          0.0689351227078,
          73.86590141
        ],
        [
          0.00050871738157,
          0.0584982052634,
          75.0589499
        ],
        [
          0.00029448520466,
          0.06899919630138,
          73.85951139
        ],
        [
          0.00046255771109,
          0.06035300553259,
          74.821099
        ],
        [
          0.00029548502238,
          0.0689351227078,
          73.86590141
        ],
        [
          0.0006085722783,
          0.05488897392353,
          75.63100421
        ],
        [
          0.00029465380668,
          0.06898828876037,
          73.86066572
        ],
        [
          0.00041280118666,
          0.0625788464401,
          74.53277864
        ],
        [
          0.0002956542361,
          0.06892420940626,
          73.86705903
        ],
        [
          0.00052533212005,
          0.05785595915537,
          75.15531366
        ],
        [
          0.00029465380668,
          0.06898828876037,
          73.86066572
        ],
        [
          0.00047795608508,
          0.05970648706805,
          74.91056882
        ],
        [
          0.0002956542361,
          0.06892420940626,
          73.86705903
        ],
        [
          0.000627113582,
          0.05427291320829,
          75.7407768
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00033300344357,
          0.06669692848558,
          74.07276152
        ],
        [
          0.00029026725861,
          0.06927085289017,
          73.83324224
        ],
        [
          0.00033398094994,
          0.06664124650947,
          74.07854142
        ],
        [
          0.00028943958832,
          0.06932445175956,
          73.82819054
        ],
        [
          0.00037991859178,
          0.06418727654616,
          74.33861586
        ],
        [
          0.00029026725861,
          0.06927085289017,
          73.83324224
        ],
        [
          0.00038103722838,
          0.06413068816533,
          74.34511878
        ],
        [
          0.00028956821089,
          0.06931605135429,
          73.8290288
        ],
        [
          0.00034301065187,
          0.06613590024617,
          74.12989271
        ],
        [
          0.00029039629662,
          0.06926244734194,
          73.83408265
        ],
        [
          0.00034401966632,
          0.06607994374855,
          74.13583155
        ],
        [
          0.00028956821089,
          0.06931605135429,
          73.8290288
        ],
        [
          0.00039139635632,
          0.06361586516762,
          74.40316194
        ],
        [
          0.00029039629662,
          0.06926244734194,
          73.83408265
        ],
        [
          0.00039254674955,
          0.06355919590812,
          74.40983298
        ],
        [
          0.00028943958832,
          0.06932445175956,
          73.82819054
        ],
        [
          0.00033300344357,
          0.06669692848558,
          74.07276152
        ],
        [
          0.00029026725861,
          0.06927085289017,
          73.83324224
        ],
        [
          0.00033398094994,
          0.06664124650947,
          74.07854142
        ],
        [
          0.00028943958832,
          0.06932445175956,
          73.82819054
        ],
        [
          0.00037991859178,
          0.06418727654616,
          74.33861586
        ],
        [
          0.00029026725861,
          0.06927085289017,
          73.83324224
        ],
        [
          0.00039671892947,
          0.06336278574194,
          74.4267039
        ],
        [
          0.00028956821089,
          0.06931605135429,
          73.8290288
        ],
        [
          0.00034301065187,
          0.06613590024617,
          74.12989271
        ],
        [
          0.00029039629662,
          0.06926244734194,
          73.83408265
        ],
        [
          0.00034401966632,
          0.06607994374855,
          74.13583155
        ],
        [
          0.00028956821089,
          0.06931605135429,
          73.8290288
        ],
        [
          0.00039139635632,
          0.06361586516762,
          74.40316194
        ],
        [
          0.00029039629662,
          0.06926244734194,
          73.83408265
        ],
        [
          0.0004087091302,
          0.06278855209664,
          74.49381046
        ],
        [
          0.00029349087875,
          0.06906508049483,
          73.85146021
        ],
        [
          0.00035669280201,
          0.06539959516448,
          74.20109009
        ],
        [
          0.00029433292254,
          0.06901124336226,
          73.85658152
        ],
        [
          0.00044666873899,
          0.06108845757553,
          74.68254613
        ],
        [
          0.00029349087875,
          0.06906508049483,
          73.85146021
        ],
        [
          0.00040718275015,
          0.06286158856614,
          74.48455019
        ],
        [
          0.00029433292254,
          0.06901124336226,
          73.85658152
        ],
        [
          0.00050860259083,
          0.05853496349232,
          75.02622128
        ],
        [
          0.00029362163493,
          0.06905664906447,
          73.85230914
        ],
        [
          0.00036749753215,
          0.06483047379241,
          74.26208744
        ],
        [
          0.00029446409759,
          0.06900280703707,
          73.85743263
        ],
        [
          0.00046007763827,
          0.06051042114792,
          74.75691141
        ],
        [
          0.00029362163493,
          0.06905664906447,
          73.85230914
        ],
        [
          0.00041946649175,
          0.06228674903952,
          74.55319699
        ],
        [
          0.00029446409759,
          0.06900280703707,
          73.85743263
        ],
        [
          0.0005233872994,
          0.05796549112524,
          75.10866898
        ],
        [
          0.00029349087875,
          0.06906508049483,
          73.85146021
        ],
        [
          0.00038732507133,
          0.06383339447388,
          74.36499933
        ],
        [
          0.00029433292254,
          0.06901124336226,
          73.85658152
        ],
        [
          0.00048481876191,
          0.05949166075665,
          74.88430772
        ],
        [
          0.00029349087875,
          0.06906508049483,
          73.85146021
        ],
        [
          0.00044209107614,
          0.06127573342627,
          74.67010215
        ],
        [
          0.00029433292254,
          0.06901124336226,
          73.85658152
        ],
        [
          0.0005724838351,
          0.05618747435518,
          75.36455641
        ],
        [
          0.00029362163493,
          0.06905664906447,
          73.85230914
        ],
        [
          0.00039909386069,
          0.06325776125178,
          74.43077763
        ],
        [
          0.00029446409759,
          0.06900280703707,
          73.85743263
        ],
        [
          0.00049915063328,
          0.05891649381867,
          74.96379874
        ],
        [
          0.00029362163493,
          0.06905664906447,
          73.85230914
        ],
        [
          0.00045532254705,
          0.06069997625885,
          74.74374268
        ],
        [
          0.00029446409759,
          0.06900280703707,
          73.85743263
        ],
        [
          0.00058853453383,
          0.05562870708244,
          75.4548202
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00032751925948,
          0.06702052773005,
          74.03283918
        ],
        [
          0.00028971284596,
          0.06930770288412,
          73.82903263
        ],
        [
          0.00032832324876,
          0.06697427435151,
          74.03738046
        ],
        [
          0.00028902444848,
          0.06935211098353,
          73.82503589
        ],
        [
          0.00036724403801,
          0.06485677417039,
          74.24872902
        ],
        [
          0.00028971284596,
          0.06930770288412,
          73.82903263
        ],
        [
          0.00036815531344,
          0.06480950332396,
          74.25379618
        ],
        [
          0.00028913811861,
          0.06934469588731,
          73.82576085
        ],
        [
          0.00033610687137,
          0.0665331725486,
          74.07997107
        ],
        [
          0.00028982683224,
          0.06930028335385,
          73.82975919
        ],
        [
          0.00033693483096,
          0.0664866462371,
          74.08462876
        ],
        [
          0.00028913811861,
          0.06934469588731,
          73.82576085
        ],
        [
          0.0003769964231,
          0.06435779547426,
          74.30149263
        ],
        [
          0.00028982683224,
          0.06930028335385,
          73.82975919
        ],
        [
          0.00037793233897,
          0.06431037498122,
          74.30668358
        ],
        [
          0.00028902444848,
          0.06935211098353,
          73.82503589
        ],
        [
          0.00032751925948,
          0.06702052773005,
          74.03283918
        ],
        [
          0.00028971284596,
          0.06930770288412,
          73.82903263
        ],
        [
          0.00032832324876,
          0.06697427435151,
          74.03738046
        ],
        [
          0.00028902444848,
          0.06935211098353,
          73.82503589
        ],
        [
          0.00036724403801,
          0.06485677417039,
          74.24872902
        ],
        [
          0.00028971284596,
          0.06930770288412,
          73.82903263
        ],
        [
          0.00038229854898,
          0.06409658582468,
          74.32532592
        ],
        [
          0.00028913811861,
          0.06934469588731,
          73.82576085
        ],
        [
          0.00033610687137,
          0.0665331725486,
          74.07997107
        ],
        [
          0.00028982683224,
          0.06930028335385,
          73.82975919
        ],
        [
          0.00033693483096,
          0.0664866462371,
          74.08462876
        ],
        [
          0.00028913811861,
          0.06934469588731,
          73.82576085
        ],
        [
          0.0003769964231,
          0.06435779547426,
          74.30149263
        ],
        [
          0.00028982683224,
          0.06930028335385,
          73.82975919
        ],
        [
          0.0003924845113,
          0.06359394323866,
          74.38016565
        ],
        [
          0.00029260174642,
          0.06912360955624,
          73.84473505
        ],
        [
          0.0003485119454,
          0.06585451633722,
          74.14258116
        ],
        [
          0.00029330114351,
          0.06907899947217,
          73.84878353
        ],
        [
          0.00042745455646,
          0.06197134193233,
          74.55007838
        ],
        [
          0.00029260174642,
          0.06912360955624,
          73.84473505
        ],
        [
          0.00039115841767,
          0.06365950954812,
          74.37229894
        ],
        [
          0.00029330114351,
          0.06907899947217,
          73.84878353
        ],
        [
          0.00047966202169,
          0.05973131656167,
          74.8273443
        ],
        [
          0.00029271713472,
          0.06911616703805,
          73.84546842
        ],
        [
          0.00035775191181,
          0.06535897087779,
          74.1927699
        ],
        [
          0.00029341685061,
          0.06907155267971,
          73.84951852
        ],
        [
          0.00043886499489,
          0.06146173008567,
          74.61088433
        ],
        [
          0.00029271713472,
          0.06911616703805,
          73.84546842
        ],
        [
          0.00040158246831,
          0.06315555657482,
          74.42832064
        ],
        [
          0.00029341685061,
          0.06907155267971,
          73.84951852
        ],
        [
          0.00049222655757,
          0.05922405504849,
          74.89440486
        ],
        [
          0.00029260174642,
          0.06912360955624,
          73.84473505
        ],
        [
          0.00037563101251,
          0.06443932176842,
          74.282807
        ],
        [
          0.00029330114351,
          0.06907899947217,
          73.84878353
        ],
        [
          0.0004610581597,
          0.06051108317889,
          74.72147184
        ],
        [
          0.00029260174642,
          0.06912360955624,
          73.84473505
        ],
        [
          0.00042182064832,
          0.06221722879603,
          74.52964146
        ],
        [
          0.00029330114351,
          0.06907899947217,
          73.84878353
        ],
        [
          0.00053631809935,
          0.05754320622545,
          75.1158646
        ],
        [
          0.00029271713472,
          0.06911616703805,
          73.84546842
        ],
        [
          0.000385669177,
          0.06393620624374,
          74.33680104
        ],
        [
          0.00029341685061,
          0.06907155267971,
          73.84951852
        ],
        [
          0.00047326408869,
          0.06000109998596,
          74.78640931
        ],
        [
          0.00029271713472,
          0.06911616703805,
          73.84546842
        ],
        [
          0.00043304815252,
          0.06170973258234,
          74.58966528
        ],
        [
          0.00029341685061,
          0.06907155267971,
          73.84951852
        ],
        [
          0.00055001418847,
          0.05704119240642,
          75.18929672
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00032230495371,
          0.06733007933856,
          73.99714488
        ],
        [
          0.00028924210405,
          0.06933877090057,
          73.82568957
        ],
        [
          0.00032296755135,
          0.06729157146871,
          74.00073694
        ],
        [
          0.00028866783014,
          0.06937569425489,
          73.82250164
        ],
        [
          0.00035561421472,
          0.06548388516544,
          74.17098215
        ],
        [
          0.00028924210405,
          0.06933877090057,
          73.82568957
        ],
        [
          0.00035635733736,
          0.06544438317319,
          74.17495386
        ],
        [
          0.00028875542632,
          0.06936999540737,
          73.82304154
        ],
        [
          0.00032955538771,
          0.06691370442704,
          74.0353867
        ],
        [
          0.00028932991169,
          0.06933306870192,
          73.8262305
        ],
        [
          0.00033023592201,
          0.06687494667582,
          74.0390629
        ],
        [
          0.00028875542632,
          0.06936999540737,
          73.82304154
        ],
        [
          0.00036376132937,
          0.06505601130367,
          74.21339534
        ],
        [
          0.00028932991169,
          0.06933306870192,
          73.8262305
        ],
        [
          0.00036452315403,
          0.06501633377597,
          74.21745685
        ],
        [
          0.00028866783014,
          0.06937569425489,
          73.82250164
        ],
        [
          0.00032230495371,
          0.06733007933856,
          73.99714488
        ],
        [
          0.00028924210405,
          0.06933877090057,
          73.82568957
        ],
        [
          0.00032296755135,
          0.06729157146871,
          74.00073694
        ],
        [
          0.00028866783014,
          0.06937569425489,
          73.82250164
        ],
        [
          0.00035561421472,
          0.06548388516544,
          74.17098215
        ],
        [
          0.00028924210405,
          0.06933877090057,
          73.82568957
        ],
        [
          0.00036894465239,
          0.06479213864425,
          74.23680788
        ],
        [
          0.00028875542632,
          0.06936999540737,
          73.82304154
        ],
        [
          0.00032955538771,
          0.06691370442704,
          74.0353867
        ],
        [
          0.00028932991169,
          0.06933306870192,
          73.8262305
        ],
        [
          0.00033023592201,
          0.06687494667582,
          74.0390629
        ],
        [
          0.00028875542632,
          0.06936999540737,
          73.82304154
        ],
        [
          0.00036376132937,
          0.06505601130367,
          74.21339534
        ],
        [
          0.00028932991169,
          0.06933306870192,
          73.8262305
        ],
        [
          0.00037744694948,
          0.0643602372138,
          74.28085695
        ],
        [
          0.00029180376042,
          0.06917582170923,
          73.83908681
        ],
        [
          0.00034076411763,
          0.06629047290178,
          74.09038731
        ],
        [
          0.00029238640861,
          0.06913873046492,
          73.84231307
        ],
        [
          0.00040929846211,
          0.06283027733131,
          74.43209459
        ],
        [
          0.00029180376042,
          0.06917582170923,
          73.83908681
        ],
        [
          0.00037641141335,
          0.06441302450897,
          74.27489831
        ],
        [
          0.00029238640861,
          0.06913873046492,
          73.84231307
        ],
        [
          0.00045272849838,
          0.06089068896833,
          74.65344155
        ],
        [
          0.00029189256152,
          0.0691701016458,
          73.83963245
        ],
        [
          0.00034853497471,
          0.06586632929588,
          74.13099079
        ],
        [
          0.00029247542293,
          0.06913300713958,
          73.84285975
        ],
        [
          0.00041882509658,
          0.06238944722734,
          74.48091996
        ],
        [
          0.00029189256152,
          0.0691701016458,
          73.83963245
        ],
        [
          0.00038510225099,
          0.06397943722575,
          74.31983989
        ],
        [
          0.00029247542293,
          0.06913300713958,
          73.84285975
        ],
        [
          0.00046318794262,
          0.06044799023923,
          74.70698187
        ],
        [
          0.00029180376042,
          0.06917582170923,
          73.83908681
        ],
        [
          0.00036461056244,
          0.06502077843819,
          74.2097686
        ],
        [
          0.00029238640861,
          0.06913873046492,
          73.84231307
        ],
        [
          0.00043862201912,
          0.06150699411016,
          74.57673623
        ],
        [
          0.00029180376042,
          0.06917582170923,
          73.83908681
        ],
        [
          0.00040313064593,
          0.06311290808113,
          74.40759849
        ],
        [
          0.00029238640861,
          0.06913873046492,
          73.84231307
        ],
        [
          0.00050232760933,
          0.05887630116281,
          74.8970676
        ],
        [
          0.00029189256152,
          0.0691701016458,
          73.83963245
        ],
        [
          0.00037302559938,
          0.06458880327223,
          74.25333411
        ],
        [
          0.00029247542293,
          0.06913300713958,
          73.84285975
        ],
        [
          0.00044881374235,
          0.06106349470667,
          74.62881939
        ],
        [
          0.00029189256152,
          0.0691701016458,
          73.83963245
        ],
        [
          0.00041248154469,
          0.06267422224965,
          74.45567031
        ],
        [
          0.00029247542293,
          0.06913300713958,
          73.84285975
        ],
        [
          0.00051376674136,
          0.05843424636856,
          74.95570021
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00031733651315,
          0.06762691843219,
          73.96511312
        ],
        [
          0.00028883070887,
          0.06936574382634,
          73.8229524
        ],
        [
          0.00031787534493,
          0.06759528679373,
          73.96792128
        ],
        [
          0.00028835761245,
          0.06939606741972,
          73.82043656
        ],
        [
          0.0003449342814,
          0.06607144108159,
          74.10355389
        ],
        [
          0.00028883070887,
          0.06936574382634,
          73.8229524
        ],
        [
          0.00034553188414,
          0.06603892202009,
          74.10662938
        ],
        [
          0.00028841445909,
          0.06939238289907,
          73.82077188
        ],
        [
          0.00032331214727,
          0.06727982390525,
          73.99533973
        ],
        [
          0.00028888767396,
          0.06936205718359,
          73.82328828
        ],
        [
          0.00032386391512,
          0.06724797925623,
          73.99820654
        ],
        [
          0.00028841445909,
          0.06939238289907,
          73.82077188
        ],
        [
          0.00035157506186,
          0.0657139448212,
          74.13676339
        ],
        [
          0.00028888767396,
          0.06936205718359,
          73.82328828
        ],
        [
          0.00035218628202,
          0.06568125397853,
          74.1399016
        ],
        [
          0.00028835761245,
          0.06939606741972,
          73.82043656
        ],
        [
          0.00031733651315,
          0.06762691843219,
          73.96511312
        ],
        [
          0.00028883070887,
          0.06936574382634,
          73.8229524
        ],
        [
          0.00031787534493,
          0.06759528679373,
          73.96792128
        ],
        [
          0.00028835761245,
          0.06939606741972,
          73.82043656
        ],
        [
          0.0003449342814,
          0.06607144108159,
          74.10355389
        ],
        [
          0.00028883070887,
          0.06936574382634,
          73.8229524
        ],
        [
          0.00035656582139,
          0.06545193710249,
          74.15927664
        ],
        [
          0.00028841445909,
          0.06939238289907,
          73.82077188
        ],
        [
          0.00032331214727,
          0.06727982390525,
          73.99533973
        ],
        [
          0.00028888767396,
          0.06936205718359,
          73.82328828
        ],
        [
          0.00032386391512,
          0.06724797925623,
          73.99820654
        ],
        [
          0.00028841445909,
          0.06939238289907,
          73.82077188
        ],
        [
          0.00035157506186,
          0.0657139448212,
          74.13676339
        ],
        [
          0.00028888767396,
          0.06936205718359,
          73.82328828
        ],
        [
          0.00036348593023,
          0.0650904628889,
          74.19372644
        ],
        [
          0.00029105320769,
          0.06922465845572,
          73.83410713
        ],
        [
          0.00033329917943,
          0.06671564955152,
          74.04294211
        ],
        [
          0.000291532491,
          0.0691942002434,
          73.83665052
        ],
        [
          0.00039183894597,
          0.0636815845422,
          74.32485837
        ],
        [
          0.00029105320769,
          0.06922465845572,
          73.83410713
        ],
        [
          0.0003627125158,
          0.06513108827559,
          74.18939442
        ],
        [
          0.000291532491,
          0.0691942002434,
          73.83665052
        ],
        [
          0.00042738399252,
          0.06202814787626,
          74.49906582
        ],
        [
          0.00029111075802,
          0.06922096017216,
          73.8344457
        ],
        [
          0.00033967412092,
          0.06636161904751,
          74.07492391
        ],
        [
          0.00029159016074,
          0.06919049987782,
          73.83698966
        ],
        [
          0.00039957611239,
          0.06331045215899,
          74.3629615
        ],
        [
          0.00029111075802,
          0.06922096017216,
          73.8344457
        ],
        [
          0.00036977449172,
          0.0647678652454,
          74.22448639
        ],
        [
          0.00029159016074,
          0.06919049987782,
          73.83698966
        ],
        [
          0.00043584348019,
          0.06165259763927,
          74.54060268
        ],
        [
          0.00029105320769,
          0.06922465845572,
          73.83410713
        ],
        [
          0.000353874212,
          0.06559793389737,
          74.14254348
        ],
        [
          0.000291532491,
          0.0691942002434,
          73.83665052
        ],
        [
          0.00041687891731,
          0.06250722394486,
          74.44426651
        ],
        [
          0.00029105320769,
          0.06922465845572,
          73.83410713
        ],
        [
          0.00038554078907,
          0.06398286826439,
          74.29905094
        ],
        [
          0.000291532491,
          0.0691942002434,
          73.83665052
        ],
        [
          0.00046985456898,
          0.06021238059499,
          74.70045117
        ],
        [
          0.00029111075802,
          0.06922096017216,
          73.8344457
        ],
        [
          0.00036074748438,
          0.06523647936812,
          74.17673693
        ],
        [
          0.00029159016074,
          0.06919049987782,
          73.83698966
        ],
        [
          0.00042514722042,
          0.06213199373291,
          74.48483569
        ],
        [
          0.00029111075802,
          0.06922096017216,
          73.8344457
        ],
        [
          0.0003931207334,
          0.06361389204589,
          74.33649091
        ],
        [
          0.00029159016074,
          0.06919049987782,
          73.83698966
        ],
        [
          0.00047912131322,
          0.05983404919311,
          74.74589533
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00031264980843,
          0.06790875554685,
          73.93661851
        ],
        [
          0.0002884011668,
          0.06939373758684,
          73.82027061
        ],
        [
          0.0003130673996,
          0.06788401551246,
          73.93869965
        ],
        [
          0.00028802973162,
          0.06941746456764,
          73.81838865
        ],
        [
          0.00033515249973,
          0.06662010046742,
          74.04514124
        ],
        [
          0.0002884011668,
          0.06939373758684,
          73.82027061
        ],
        [
          0.00033561038084,
          0.06659463926113,
          74.0473992
        ],
        [
          0.0002880521616,
          0.06941602306823,
          73.81850907
        ],
        [
          0.00031752765084,
          0.06762229670901,
          73.96031996
        ],
        [
          0.00028842363666,
          0.06939229523524,
          73.82039122
        ],
        [
          0.000317954063,
          0.06759738886483,
          73.96243975
        ],
        [
          0.0002880521616,
          0.06941602306823,
          73.81850907
        ],
        [
          0.00034050970872,
          0.06632485261056,
          74.07092003
        ],
        [
          0.00028842363666,
          0.06939229523524,
          73.82039122
        ],
        [
          0.00034097691798,
          0.06629924425894,
          74.07321928
        ],
        [
          0.00028802973162,
          0.06941746456764,
          73.81838865
        ],
        [
          0.00031264980843,
          0.06790875554685,
          73.93661851
        ],
        [
          0.0002884011668,
          0.06939373758684,
          73.82027061
        ],
        [
          0.0003130673996,
          0.06788401551246,
          73.93869965
        ],
        [
          0.00028802973162,
          0.06941746456764,
          73.81838865
        ],
        [
          0.00033515249973,
          0.06662010046742,
          74.04514124
        ],
        [
          0.0002884011668,
          0.06939373758684,
          73.82027061
        ],
        [
          0.00034509094254,
          0.0660775692182,
          74.09125405
        ],
        [
          0.0002880521616,
          0.06941602306823,
          73.81850907
        ],
        [
          0.00031752765084,
          0.06762229670901,
          73.96031996
        ],
        [
          0.00028842363666,
          0.06939229523524,
          73.82039122
        ],
        [
          0.000317954063,
          0.06759738886483,
          73.96243975
        ],
        [
          0.0002880521616,
          0.06941602306823,
          73.81850907
        ],
        [
          0.00034050970872,
          0.06632485261056,
          74.07092003
        ],
        [
          0.00028842363666,
          0.06939229523524,
          73.82039122
        ],
        [
          0.00035066060475,
          0.06577868351632,
          74.11794473
        ],
        [
          0.00029032811848,
          0.06927160194032,
          73.82959077
        ],
        [
          0.00032625266449,
          0.06712199568007,
          74.00062912
        ],
        [
          0.00029070389134,
          0.06924777282845,
          73.83149151
        ],
        [
          0.00037543053972,
          0.06450681338862,
          74.22938657
        ],
        [
          0.00029032811848,
          0.06927160194032,
          73.82959077
        ],
        [
          0.00035011988632,
          0.06580792769197,
          74.11498158
        ],
        [
          0.00029070389134,
          0.06924777282845,
          73.83149151
        ],
        [
          0.00040395042731,
          0.06312554070579,
          74.36396227
        ],
        [
          0.00029035080403,
          0.06927015466008,
          73.82971232
        ],
        [
          0.00033142923534,
          0.06682963222937,
          74.0256045
        ],
        [
          0.00029072661709,
          0.06924632470525,
          73.83161324
        ],
        [
          0.00038163315143,
          0.06419847051636,
          74.25880321
        ],
        [
          0.00029035080403,
          0.06927015466008,
          73.82971232
        ],
        [
          0.0003557938519,
          0.065507422169,
          74.14212616
        ],
        [
          0.00029072661709,
          0.06924632470525,
          73.83161324
        ],
        [
          0.00041069002395,
          0.06281182126124,
          74.39579938
        ],
        [
          0.00029032811848,
          0.06927160194032,
          73.82959077
        ],
        [
          0.00034361367163,
          0.06616028679052,
          74.08174799
        ],
        [
          0.00029070389134,
          0.06924777282845,
          73.83149151
        ],
        [
          0.00039628764318,
          0.06349044100602,
          74.32545556
        ],
        [
          0.00029032811848,
          0.06927160194032,
          73.82959077
        ],
        [
          0.00036917756706,
          0.06481825869367,
          74.20340284
        ],
        [
          0.00029070389134,
          0.06924777282845,
          73.83149151
        ],
        [
          0.00043938253614,
          0.061530862969,
          74.52618036
        ],
        [
          0.00029035080403,
          0.06927015466008,
          73.82971232
        ],
        [
          0.00034916292301,
          0.06586136107403,
          74.10832244
        ],
        [
          0.00029072661709,
          0.06924632470525,
          73.83161324
        ],
        [
          0.00040289634133,
          0.06317751925955,
          74.3566689
        ],
        [
          0.00029035080403,
          0.06927015466008,
          73.82971232
        ],
        [
          0.00037524255567,
          0.06451211466602,
          74.23224892
        ],
        [
          0.00029072661709,
          0.06924632470525,
          73.83161324
        ],
        [
          0.00044675879765,
          0.06121231773597,
          74.56091514
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00030835029104,
          0.06816895721717,
          73.91193857
        ],
        [
          0.00028805250859,
          0.06941633443203,
          73.81822494
        ],
        [
          0.00030866784494,
          0.06814998378763,
          73.9134523
        ],
        [
          0.00028776626841,
          0.06943455778866,
          73.81684236
        ],
        [
          0.00032647354609,
          0.0671158176772,
          73.9960652
        ],
        [
          0.00028805250859,
          0.06941633443203,
          73.81822494
        ],
        [
          0.00032681778007,
          0.06709629584456,
          73.99769213
        ],
        [
          0.00028777280141,
          0.06943414683035,
          73.8168695
        ],
        [
          0.00031228622691,
          0.06793543818775,
          73.93033808
        ],
        [
          0.00028805905214,
          0.06941592318478,
          73.81825213
        ],
        [
          0.00031260960406,
          0.06791633975581,
          73.93187651
        ],
        [
          0.00028777280141,
          0.06943414683035,
          73.8168695
        ],
        [
          0.00033074572552,
          0.06687526709691,
          74.01587628
        ],
        [
          0.00028805905214,
          0.06941592318478,
          73.81825213
        ],
        [
          0.00033109613407,
          0.06685562904863,
          74.01752958
        ],
        [
          0.00028776626841,
          0.06943455778866,
          73.81684236
        ],
        [
          0.00030835029104,
          0.06816895721717,
          73.91193857
        ],
        [
          0.00028805250859,
          0.06941633443203,
          73.81822494
        ],
        [
          0.00030866784494,
          0.06814998378763,
          73.9134523
        ],
        [
          0.00028776626841,
          0.06943455778866,
          73.81684236
        ],
        [
          0.00032647354609,
          0.0671158176772,
          73.9960652
        ],
        [
          0.00028805250859,
          0.06941633443203,
          73.81822494
        ],
        [
          0.00033481358107,
          0.06665018275642,
          74.03351657
        ],
        [
          0.00028777280141,
          0.06943414683035,
          73.8168695
        ],
        [
          0.00031228622691,
          0.06793543818775,
          73.93033808
        ],
        [
          0.00028805905214,
          0.06941592318478,
          73.81825213
        ],
        [
          0.00031260960406,
          0.06791633975581,
          73.93187651
        ],
        [
          0.00028777280141,
          0.06943414683035,
          73.8168695
        ],
        [
          0.00033074572552,
          0.06687526709691,
          74.01587628
        ],
        [
          0.00028805905214,
          0.06941592318478,
          73.81825213
        ],
        [
          0.00033924158249,
          0.06640654347734,
          74.05397534
        ],
        [
          0.00028968856434,
          0.06931281685893,
          73.82584556
        ],
        [
          0.00031978591241,
          0.06749943624454,
          73.96389964
        ],
        [
          0.00028997773771,
          0.06929451923716,
          73.82724047
        ],
        [
          0.00036060169574,
          0.06527564079335,
          74.14749966
        ],
        [
          0.00028968856434,
          0.06931281685893,
          73.82584556
        ],
        [
          0.00033890503059,
          0.06642526064521,
          74.05215349
        ],
        [
          0.00028997773771,
          0.06929451923716,
          73.82724047
        ],
        [
          0.00038313864976,
          0.06414160634782,
          74.25008041
        ],
        [
          0.00028969517015,
          0.06931240384782,
          73.825873
        ],
        [
          0.00032393918112,
          0.0672611245911,
          73.98319946
        ],
        [
          0.00028998435416,
          0.06929410593838,
          73.82726795
        ],
        [
          0.00036550459251,
          0.06502350504643,
          74.16993563
        ],
        [
          0.00028969517015,
          0.06931240384782,
          73.825873
        ],
        [
          0.00034340780306,
          0.06618023655984,
          74.07292645
        ],
        [
          0.00028998435416,
          0.06929410593838,
          73.82726795
        ],
        [
          0.00038842566815,
          0.06388420309571,
          74.27417079
        ],
        [
          0.00028968856434,
          0.06931281685893,
          73.82584556
        ],
        [
          0.00033432971066,
          0.06667884682036,
          74.02962666
        ],
        [
          0.00028997773771,
          0.06929451923716,
          73.82724047
        ],
        [
          0.00037781332727,
          0.06440580015666,
          74.22426626
        ],
        [
          0.00028968856434,
          0.06931281685893,
          73.82584556
        ],
        [
          0.00035469338418,
          0.06558070282147,
          74.1230646
        ],
        [
          0.00028997773771,
          0.06929451923716,
          73.82724047
        ],
        [
          0.00041225260188,
          0.06276553901196,
          74.37908673
        ],
        [
          0.00028969517015,
          0.06931240384782,
          73.825873
        ],
        [
          0.00033875515598,
          0.06643504366525,
          74.05005876
        ],
        [
          0.00028998435416,
          0.06929410593838,
          73.82726795
        ],
        [
          0.00038301670709,
          0.06414926881855,
          74.2479775
        ],
        [
          0.00028969517015,
          0.06931240384782,
          73.825873
        ],
        [
          0.00035948304558,
          0.06533064946895,
          74.14504194
        ],
        [
          0.00028998435416,
          0.06929410593838,
          73.82726795
        ],
        [
          0.00041802215307,
          0.06250253586295,
          74.40526382
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00030431335588,
          0.06841476769607,
          73.89003843
        ],
        [
          0.00028774981115,
          0.06943585023955,
          73.8165536
        ],
        [
          0.00030456573087,
          0.06839955057928,
          73.8912032
        ],
        [
          0.00028751901763,
          0.06945051196915,
          73.81547685
        ],
        [
          0.00031861112333,
          0.06757249534191,
          73.95392859
        ],
        [
          0.00028774981115,
          0.06943585023955,
          73.8165536
        ],
        [
          0.00031888143898,
          0.06755686737145,
          73.9551673
        ],
        [
          0.00028752554217,
          0.06945010122156,
          73.81550396
        ],
        [
          0.00030742988834,
          0.06822805649443,
          73.90406604
        ],
        [
          0.0002877563443,
          0.06943543925183,
          73.81658075
        ],
        [
          0.00030768617672,
          0.0682127470364,
          73.90524695
        ],
        [
          0.00028752554217,
          0.06945010122156,
          73.81550396
        ],
        [
          0.00032195384319,
          0.06738049452661,
          73.96887684
        ],
        [
          0.0002877563443,
          0.06943543925183,
          73.81658075
        ],
        [
          0.00032222830014,
          0.06736477766337,
          73.97013271
        ],
        [
          0.00028751901763,
          0.06945051196915,
          73.81547685
        ],
        [
          0.00030431335588,
          0.06841476769607,
          73.89003843
        ],
        [
          0.00028774981115,
          0.06943585023955,
          73.8165536
        ],
        [
          0.00030456573087,
          0.06839955057928,
          73.8912032
        ],
        [
          0.00028751901763,
          0.06945051196915,
          73.81547685
        ],
        [
          0.00031861112333,
          0.06757249534191,
          73.95392859
        ],
        [
          0.00028774981115,
          0.06943585023955,
          73.8165536
        ],
        [
          0.00032547648727,
          0.06718108632612,
          73.98375591
        ],
        [
          0.00028752554217,
          0.06945010122156,
          73.81550396
        ],
        [
          0.00030742988834,
          0.06822805649443,
          73.90406604
        ],
        [
          0.0002877563443,
          0.06943543925183,
          73.81658075
        ],
        [
          0.00030768617672,
          0.0682127470364,
          73.90524695
        ],
        [
          0.00028752554217,
          0.06945010122156,
          73.81550396
        ],
        [
          0.00032195384319,
          0.06738049452661,
          73.96887684
        ],
        [
          0.0002877563443,
          0.06943543925183,
          73.81658075
        ],
        [
          0.00032892904694,
          0.06698661380545,
          73.99914713
        ],
        [
          0.00028908318753,
          0.06935166246701,
          73.82250799
        ],
        [
          0.00031370993189,
          0.06785822276182,
          73.93122621
        ],
        [
          0.00028931598436,
          0.06933694717866,
          73.82359294
        ],
        [
          0.00034682438147,
          0.06601132356826,
          74.07519195
        ],
        [
          0.00028908318753,
          0.06935166246701,
          73.82250799
        ],
        [
          0.00032870301572,
          0.06699954556104,
          73.99791296
        ],
        [
          0.00028931598436,
          0.06933694717866,
          73.82359294
        ],
        [
          0.00036421082464,
          0.06510348774449,
          74.15157446
        ],
        [
          0.00028908977229,
          0.06935124998585,
          73.82253534
        ],
        [
          0.00031697809213,
          0.06766782559861,
          73.94586407
        ],
        [
          0.00028932257784,
          0.06933653445472,
          73.82362033
        ],
        [
          0.00035061621038,
          0.06580978881362,
          74.09195076
        ],
        [
          0.00028908977229,
          0.06935124998585,
          73.82253534
        ],
        [
          0.00033220619372,
          0.06680399437826,
          74.01350967
        ],
        [
          0.00028932257784,
          0.06933653445472,
          73.82362033
        ],
        [
          0.00036826376688,
          0.06489742941496,
          74.1694131
        ],
        [
          0.00028908318753,
          0.06935166246701,
          73.82250799
        ],
        [
          0.0003255933262,
          0.06717580257583,
          73.98310662
        ],
        [
          0.00028931598436,
          0.06933694717866,
          73.82359294
        ],
        [
          0.00036064423426,
          0.06528768305225,
          74.13483385
        ],
        [
          0.00028908318753,
          0.06935166246701,
          73.82250799
        ],
        [
          0.00034145613293,
          0.06629799810402,
          74.05330268
        ],
        [
          0.00028931598436,
          0.06933694717866,
          73.82359294
        ],
        [
          0.00038746555507,
          0.06395084124644,
          74.25130018
        ],
        [
          0.00028908977229,
          0.06935124998585,
          73.82253534
        ],
        [
          0.0003290515625,
          0.06698108419537,
          73.99851168
        ],
        [
          0.00028932257784,
          0.06933653445472,
          73.82362033
        ],
        [
          0.00036464802234,
          0.06508230961042,
          74.1524592
        ],
        [
          0.00028908977229,
          0.06935124998585,
          73.82253534
        ],
        [
          0.00034515985331,
          0.06609831682532,
          74.06971341
        ],
        [
          0.00028932257784,
          0.06933653445472,
          73.82362033
        ],
        [
          0.00039186281224,
          0.06373944791452,
          74.27056197
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00030082265611,
          0.06862850126387,
          73.872126
        ],
        [
          0.00028750043857,
          0.06945184919193,
          73.81525611
        ],
        [
          0.00030099821023,
          0.06861784637062,
          73.87289936
        ],
        [
          0.00028733778411,
          0.06946214666327,
          73.81453372
        ],
        [
          0.00031179059742,
          0.06797473593425,
          73.91926185
        ],
        [
          0.00028750043857,
          0.06945184919193,
          73.81525611
        ],
        [
          0.00031197648802,
          0.06796381809463,
          73.9200764
        ],
        [
          0.00028734430224,
          0.06946173608227,
          73.81456081
        ],
        [
          0.00030320597823,
          0.06848454472067,
          73.88243766
        ],
        [
          0.00028750696296,
          0.06945143842992,
          73.81528321
        ],
        [
          0.00030338377578,
          0.0684738315148,
          73.88321998
        ],
        [
          0.00028734430224,
          0.06946173608227,
          73.81456081
        ],
        [
          0.00031431662646,
          0.06782709831821,
          73.93013647
        ],
        [
          0.00028750696296,
          0.06945143842992,
          73.81528321
        ],
        [
          0.00031450487889,
          0.06781612310913,
          73.93096047
        ],
        [
          0.00028733778411,
          0.06946214666327,
          73.81453372
        ],
        [
          0.00030082265611,
          0.06862850126387,
          73.872126
        ],
        [
          0.00028750043857,
          0.06945184919193,
          73.81525611
        ],
        [
          0.00030099821023,
          0.06861784637062,
          73.87289936
        ],
        [
          0.00028733778411,
          0.06946214666327,
          73.81453372
        ],
        [
          0.00031179059742,
          0.06797473593425,
          73.91926185
        ],
        [
          0.00028750043857,
          0.06945184919193,
          73.81525611
        ],
        [
          0.00031729985947,
          0.06765478800734,
          73.9423891
        ],
        [
          0.00028734430224,
          0.06946173608227,
          73.81456081
        ],
        [
          0.00030320597823,
          0.06848454472067,
          73.88243766
        ],
        [
          0.00028750696296,
          0.06945143842992,
          73.81528321
        ],
        [
          0.00030338377578,
          0.0684738315148,
          73.88321998
        ],
        [
          0.00028734430224,
          0.06946173608227,
          73.81456081
        ],
        [
          0.00031431662646,
          0.06782709831821,
          73.93013647
        ],
        [
          0.00028750696296,
          0.06945143842992,
          73.81528321
        ],
        [
          0.00031989852881,
          0.06750532806874,
          73.95354785
        ],
        [
          0.00028857312825,
          0.0693842603187,
          73.81985728
        ],
        [
          0.00030837011727,
          0.06817698050082,
          73.90401847
        ],
        [
          0.0002887369593,
          0.06937392925902,
          73.82058432
        ],
        [
          0.00033451198247,
          0.06668763925665,
          74.01371492
        ],
        [
          0.00028857312825,
          0.0693842603187,
          73.81985728
        ],
        [
          0.00031979828664,
          0.06751126307498,
          73.95295064
        ],
        [
          0.0002887369593,
          0.06937392925902,
          73.82058432
        ],
        [
          0.00034751681459,
          0.06598490923721,
          74.0688261
        ],
        [
          0.00028857969508,
          0.06938384829665,
          73.81988455
        ],
        [
          0.00031085323177,
          0.06803037779515,
          73.91472013
        ],
        [
          0.00028874353245,
          0.06937351705509,
          73.82061162
        ],
        [
          0.0003373376059,
          0.06653280530179,
          74.0257598
        ],
        [
          0.00028857969508,
          0.06938384829665,
          73.81988455
        ],
        [
          0.00032242958121,
          0.06736101110199,
          73.96423768
        ],
        [
          0.00028874353245,
          0.06937351705509,
          73.82061162
        ],
        [
          0.00035050744254,
          0.06582663208442,
          74.081528
        ],
        [
          0.00028857312825,
          0.0693842603187,
          73.81985728
        ],
        [
          0.00031784877677,
          0.06762401980496,
          73.94396264
        ],
        [
          0.0002887369593,
          0.06937392925902,
          73.82058432
        ],
        [
          0.00034532000021,
          0.06610271017116,
          74.05882357
        ],
        [
          0.00028857312825,
          0.0693842603187,
          73.81985728
        ],
        [
          0.00032985190537,
          0.06694412769472,
          73.99514352
        ],
        [
          0.0002887369593,
          0.06937392925902,
          73.82058432
        ],
        [
          0.00036559719373,
          0.06504801995511,
          74.14386815
        ],
        [
          0.00028857969508,
          0.06938384829665,
          73.81988455
        ],
        [
          0.00032045672219,
          0.06747426916735,
          73.95515301
        ],
        [
          0.00028874353245,
          0.06937351705509,
          73.82061162
        ],
        [
          0.00034828506701,
          0.06594488230072,
          74.07141861
        ],
        [
          0.00028857969508,
          0.06938384829665,
          73.81988455
        ],
        [
          0.00033261442705,
          0.0667907914087,
          74.00694594
        ],
        [
          0.00028874353245,
          0.06937351705509,
          73.82061162
        ],
        [
          0.00036881546294,
          0.0648853705279,
          74.15747305
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00029765925074,
          0.0688231265422,
          73.8567589
        ],
        [
          0.00028728497402,
          0.06946560889028,
          73.81419833
        ],
        [
          0.00029778228797,
          0.06881561211475,
          73.85727881
        ],
        [
          0.00028716945302,
          0.06947290118563,
          73.81370724
        ],
        [
          0.0003058272457,
          0.0683311677137,
          73.89050119
        ],
        [
          0.00028728497402,
          0.06946560889028,
          73.81419833
        ],
        [
          0.00030595608267,
          0.06832349221999,
          73.89104347
        ],
        [
          0.0002871759651,
          0.06947249076638,
          73.8137343
        ],
        [
          0.00029941192072,
          0.06871649675596,
          73.86403634
        ],
        [
          0.00028729149064,
          0.06946519833693,
          73.8142254
        ],
        [
          0.00029953619916,
          0.06870894734366,
          73.86456104
        ],
        [
          0.0002871759651,
          0.06947249076638,
          73.8137343
        ],
        [
          0.0003076639676,
          0.06822217245441,
          73.89809976
        ],
        [
          0.00028729149064,
          0.06946519833693,
          73.8142254
        ],
        [
          0.00030779410368,
          0.06821446201284,
          73.89864707
        ],
        [
          0.00028716945302,
          0.06947290118563,
          73.81370724
        ],
        [
          0.00029765925074,
          0.0688231265422,
          73.8567589
        ],
        [
          0.00028728497402,
          0.06946560889028,
          73.81419833
        ],
        [
          0.00029778228797,
          0.06881561211475,
          73.85727881
        ],
        [
          0.00028716945302,
          0.06947290118563,
          73.81370724
        ],
        [
          0.0003058272457,
          0.0683311677137,
          73.89050119
        ],
        [
          0.00028728497402,
          0.06946560889028,
          73.81419833
        ],
        [
          0.00031012932233,
          0.06807721468106,
          73.90793444
        ],
        [
          0.0002871759651,
          0.06947249076638,
          73.8137343
        ],
        [
          0.00029941192072,
          0.06871649675596,
          73.86403634
        ],
        [
          0.00028729149064,
          0.06946519833693,
          73.8142254
        ],
        [
          0.00029953619916,
          0.06870894734366,
          73.86456104
        ],
        [
          0.0002871759651,
          0.06947249076638,
          73.8137343
        ],
        [
          0.0003076639676,
          0.06822217245441,
          73.89809976
        ],
        [
          0.00028729149064,
          0.06946519833693,
          73.8142254
        ],
        [
          0.00031201093032,
          0.06796698085072,
          73.91570324
        ],
        [
          0.00028812699856,
          0.06941266302508,
          73.81766905
        ],
        [
          0.0003035821059,
          0.0684655838442,
          73.88088759
        ],
        [
          0.00028824320152,
          0.06940535014088,
          73.81816276
        ],
        [
          0.00032375380694,
          0.06729415471103,
          73.96257893
        ],
        [
          0.00028812699856,
          0.06941266302508,
          73.81766905
        ],
        [
          0.00031203855765,
          0.06796547543416,
          73.91572253
        ],
        [
          0.00028824320152,
          0.06940535014088,
          73.81816276
        ],
        [
          0.00033319058094,
          0.06676829665882,
          74.00113452
        ],
        [
          0.0002881335493,
          0.06941225143134,
          73.81769626
        ],
        [
          0.00030539647374,
          0.06835718519461,
          73.88839904
        ],
        [
          0.00028824975686,
          0.06940493841095,
          73.81818998
        ],
        [
          0.00032577798141,
          0.06718015835764,
          73.97088723
        ],
        [
          0.0002881335493,
          0.06941225143134,
          73.81769626
        ],
        [
          0.00031393994958,
          0.06785470870264,
          73.92356667
        ],
        [
          0.00028824975686,
          0.06940493841095,
          73.81818998
        ],
        [
          0.00033531130223,
          0.06665195973778,
          74.0098136
        ],
        [
          0.00028812699856,
          0.06941266302508,
          73.81766905
        ],
        [
          0.00031091382002,
          0.06803175643771,
          73.91067226
        ],
        [
          0.00028824320152,
          0.06940535014088,
          73.81816276
        ],
        [
          0.00033194700141,
          0.06683732030384,
          73.99560921
        ],
        [
          0.00028812699856,
          0.06941266302508,
          73.81766905
        ],
        [
          0.000319727335,
          0.0675219240793,
          73.94686077
        ],
        [
          0.00028824320152,
          0.06940535014088,
          73.81816276
        ],
        [
          0.00034681149321,
          0.06603363462591,
          74.05580146
        ],
        [
          0.0002881335493,
          0.06941225143134,
          73.81769626
        ],
        [
          0.00031280462556,
          0.0679212430843,
          73.91847371
        ],
        [
          0.00028824975686,
          0.06940493841095,
          73.81818998
        ],
        [
          0.00033405616281,
          0.06672122408725,
          74.00424143
        ],
        [
          0.0002881335493,
          0.06941225143134,
          73.81769626
        ],
        [
          0.00032170869397,
          0.06740904888519,
          73.95500891
        ],
        [
          0.00028824975686,
          0.06940493841095,
          73.81818998
        ],
        [
          0.00034907208664,
          0.06591407857664,
          74.06501531
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00029498131722,
          0.06898855307111,
          73.84443405
        ],
        [
          0.00028713252658,
          0.06947530161849,
          73.81349128
        ],
        [
          0.00029506878147,
          0.06898318128094,
          73.84479124
        ],
        [
          0.00028704934199,
          0.06948054037486,
          73.81315013
        ],
        [
          0.00030083479447,
          0.0686330049137,
          73.86764446
        ],
        [
          0.00028713252658,
          0.06947530161849,
          73.81349128
        ],
        [
          0.00030092543813,
          0.06862753764769,
          73.86801347
        ],
        [
          0.00028705584962,
          0.06948013007941,
          73.81317717
        ],
        [
          0.00029621822922,
          0.06891287103723,
          73.84935504
        ],
        [
          0.00028713903755,
          0.06947489122147,
          73.81351833
        ],
        [
          0.00029630637947,
          0.0689074780297,
          73.84971471
        ],
        [
          0.00028705584962,
          0.06948013007941,
          73.81317717
        ],
        [
          0.00030211750459,
          0.06855592821765,
          73.87273422
        ],
        [
          0.00028713903755,
          0.06947489122147,
          73.81351833
        ],
        [
          0.00030220884041,
          0.06855044069381,
          73.87310582
        ],
        [
          0.00028704934199,
          0.06948054037486,
          73.81315013
        ],
        [
          0.00029498131722,
          0.06898855307111,
          73.84443405
        ],
        [
          0.00028713252658,
          0.06947530161849,
          73.81349128
        ],
        [
          0.00029506878147,
          0.06898318128094,
          73.84479124
        ],
        [
          0.00028704934199,
          0.06948054037486,
          73.81315013
        ],
        [
          0.00030083479447,
          0.0686330049137,
          73.86764446
        ],
        [
          0.00028713252658,
          0.06947530161849,
          73.81349128
        ],
        [
          0.00030407299255,
          0.06843923493863,
          73.88028576
        ],
        [
          0.00028705584962,
          0.06948013007941,
          73.81317717
        ],
        [
          0.00029621822922,
          0.06891287103723,
          73.84935504
        ],
        [
          0.00028713903755,
          0.06947489122147,
          73.81351833
        ],
        [
          0.00029630637947,
          0.0689074780297,
          73.84971471
        ],
        [
          0.00028705584962,
          0.06948013007941,
          73.81317717
        ],
        [
          0.00030211750459,
          0.06855592821765,
          73.87273422
        ],
        [
          0.00028713903755,
          0.06947489122147,
          73.81351833
        ],
        [
          0.00030538131278,
          0.06836139028681,
          73.88546961
        ],
        [
          0.00028776935228,
          0.06943534848809,
          73.81601137
        ],
        [
          0.00029945337398,
          0.06871657651259,
          73.86196534
        ],
        [
          0.00028785292443,
          0.06943009746286,
          73.81635397
        ],
        [
          0.00031447153188,
          0.06782979421471,
          73.92056451
        ],
        [
          0.00028776935228,
          0.06943534848809,
          73.81601137
        ],
        [
          0.00030547427629,
          0.06835592576094,
          73.88578999
        ],
        [
          0.00028785292443,
          0.06943009746286,
          73.81635397
        ],
        [
          0.00032105652828,
          0.06745281164954,
          73.94646199
        ],
        [
          0.00028777588976,
          0.06943493726111,
          73.81603852
        ],
        [
          0.00030072563822,
          0.06863980387024,
          73.86701571
        ],
        [
          0.00028785946527,
          0.06942968613398,
          73.81638113
        ],
        [
          0.00031586269569,
          0.0677495404163,
          73.92605207
        ],
        [
          0.00028777588976,
          0.06943493726111,
          73.81603852
        ],
        [
          0.00030679363258,
          0.0682777557015,
          73.89101452
        ],
        [
          0.00028785946527,
          0.06942968613398,
          73.81638113
        ],
        [
          0.00032249935415,
          0.0673711438067,
          73.952141
        ],
        [
          0.00028776935228,
          0.06943534848809,
          73.81601137
        ],
        [
          0.00030493478156,
          0.06838826892711,
          73.88340155
        ],
        [
          0.00028785292443,
          0.06943009746286,
          73.81635397
        ],
        [
          0.00032047218844,
          0.06748628338943,
          73.94389712
        ],
        [
          0.00028776935228,
          0.06943534848809,
          73.81601137
        ],
        [
          0.00031116132176,
          0.06802151358772,
          73.90798129
        ],
        [
          0.00028785292443,
          0.06943009746286,
          73.81635397
        ],
        [
          0.00033094986622,
          0.06690005451069,
          73.98479475
        ],
        [
          0.00028777588976,
          0.06943493726111,
          73.81603852
        ],
        [
          0.00030625037963,
          0.06831019585654,
          73.88861117
        ],
        [
          0.00028785946527,
          0.06942968613398,
          73.81638113
        ],
        [
          0.00032191094839,
          0.06740471078965,
          73.94955997
        ],
        [
          0.00028777588976,
          0.06943493726111,
          73.81603852
        ],
        [
          0.00031252570801,
          0.0679420347469,
          73.91337143
        ],
        [
          0.00028785946527,
          0.06942968613398,
          73.81638113
        ],
        [
          0.00033247101726,
          0.06681631347297,
          73.99076261
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00029277058957,
          0.06912552950067,
          73.83478875
        ],
        [
          0.0002870160543,
          0.06948267605083,
          73.81298029
        ],
        [
          0.0002928293905,
          0.06912190729324,
          73.83501673
        ],
        [
          0.00028696025232,
          0.06948618233836,
          73.81275925
        ],
        [
          0.00029686884396,
          0.06887496367966,
          73.85040255
        ],
        [
          0.0002870160543,
          0.06948267605083,
          73.81298029
        ],
        [
          0.00029692843036,
          0.06887133491203,
          73.85063731
        ],
        [
          0.0002869667565,
          0.06948577214308,
          73.81278628
        ],
        [
          0.00029363389061,
          0.06907247522432,
          73.83808453
        ],
        [
          0.00028702256079,
          0.06948226578378,
          73.81300732
        ],
        [
          0.0002936922454,
          0.06906888525632,
          73.83831496
        ],
        [
          0.0002869667565,
          0.06948577214308,
          73.81278628
        ],
        [
          0.0002977554905,
          0.06882116453164,
          73.85378469
        ],
        [
          0.00028702256079,
          0.06948226578378,
          73.81300732
        ],
        [
          0.00029781541515,
          0.06881752516581,
          73.85402068
        ],
        [
          0.00028696025232,
          0.06948618233836,
          73.81275925
        ],
        [
          0.00029277058957,
          0.06912552950067,
          73.83478875
        ],
        [
          0.0002870160543,
          0.06948267605083,
          73.81298029
        ],
        [
          0.0002928293905,
          0.06912190729324,
          73.83501673
        ],
        [
          0.00028696025232,
          0.06948618233836,
          73.81275925
        ],
        [
          0.00029686884396,
          0.06887496367966,
          73.85040255
        ],
        [
          0.0002870160543,
          0.06948267605083,
          73.81298029
        ],
        [
          0.00029925408928,
          0.06873070586451,
          73.85937916
        ],
        [
          0.0002869667565,
          0.06948577214308,
          73.81278628
        ],
        [
          0.00029363389061,
          0.06907247522432,
          73.83808453
        ],
        [
          0.00028702256079,
          0.06948226578378,
          73.81300732
        ],
        [
          0.0002936922454,
          0.06906888525632,
          73.83831496
        ],
        [
          0.0002869667565,
          0.06948577214308,
          73.81278628
        ],
        [
          0.0002977554905,
          0.06882116453164,
          73.85378469
        ],
        [
          0.00028702256079,
          0.06948226578378,
          73.81300732
        ],
        [
          0.0003001548074,
          0.06867645433564,
          73.86281142
        ],
        [
          0.00028748177167,
          0.06945352437041,
          73.81475027
        ],
        [
          0.000296053854,
          0.06892467969322,
          73.84717688
        ],
        [
          0.00028753777154,
          0.0694500115361,
          73.81497202
        ],
        [
          0.00030695532791,
          0.06827221120359,
          73.88816545
        ],
        [
          0.00028748177167,
          0.06945352437041,
          73.81475027
        ],
        [
          0.00030024400669,
          0.06867112857867,
          73.86311779
        ],
        [
          0.00028753777154,
          0.0694500115361,
          73.81497202
        ],
        [
          0.00031145257717,
          0.0680090300776,
          73.90519995
        ],
        [
          0.00028748829813,
          0.06945311345963,
          73.81477738
        ],
        [
          0.00029693590841,
          0.06887102387648,
          73.85054225
        ],
        [
          0.0002875443003,
          0.06944960055408,
          73.81499914
        ],
        [
          0.00030790183471,
          0.06821651974084,
          73.89176049
        ],
        [
          0.00028748829813,
          0.06945311345963,
          73.81477738
        ],
        [
          0.00030115055862,
          0.06861669145057,
          73.86657086
        ],
        [
          0.0002875443003,
          0.06944960055408,
          73.81499914
        ],
        [
          0.00031242557035,
          0.06795253988855,
          73.90888994
        ],
        [
          0.00028748177167,
          0.06945352437041,
          73.81475027
        ],
        [
          0.00030003259403,
          0.06868403233136,
          73.86215062
        ],
        [
          0.00028753777154,
          0.0694500115361,
          73.81497202
        ],
        [
          0.00031122853705,
          0.06802225307117,
          73.90418212
        ],
        [
          0.00028748177167,
          0.06945352437041,
          73.81475027
        ],
        [
          0.00030433458911,
          0.06842691103681,
          73.87848961
        ],
        [
          0.00028753777154,
          0.0694500115361,
          73.81497202
        ],
        [
          0.00031847055121,
          0.06760554200387,
          73.93144556
        ],
        [
          0.00028748829813,
          0.06945311345963,
          73.81477738
        ],
        [
          0.00030093813367,
          0.06862962122862,
          73.8655996
        ],
        [
          0.0002875443003,
          0.06944960055408,
          73.81499914
        ],
        [
          0.00031220045568,
          0.06796578849544,
          73.90786776
        ],
        [
          0.00028748829813,
          0.06945311345963,
          73.81477738
        ],
        [
          0.0003052653385,
          0.0683717126742,
          73.88202892
        ],
        [
          0.0002875443003,
          0.06944960055408,
          73.81499914
        ],
        [
          0.00031948540166,
          0.06754781471717,
          73.9352849
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00029096967724,
          0.06923734107271,
          73.82733309
        ],
        [
          0.00028692543057,
          0.06948839122114,
          73.81260372
        ],
        [
          0.00029099520764,
          0.06923576434381,
          73.82742784
        ],
        [
          0.00028690064249,
          0.06948994210899,
          73.81251155
        ],
        [
          0.00029371188673,
          0.06906887490071,
          73.83736154
        ],
        [
          0.00028692543057,
          0.06948839122114,
          73.81260372
        ],
        [
          0.00029373790774,
          0.06906728176748,
          73.83745794
        ],
        [
          0.00028690064249,
          0.06948994210899,
          73.81251155
        ],
        [
          0.00029153624013,
          0.06920241289705,
          73.82940783
        ],
        [
          0.00028692543057,
          0.06948839122114,
          73.81260372
        ],
        [
          0.00029156187348,
          0.06920083264467,
          73.82950294
        ],
        [
          0.00028690064249,
          0.06948994210899,
          73.81251155
        ],
        [
          0.00029428940629,
          0.06903357566915,
          73.83947593
        ],
        [
          0.00028692543057,
          0.06948839122114,
          73.81260372
        ],
        [
          0.0002943155356,
          0.06903197869041,
          73.83957279
        ],
        [
          0.00028690064249,
          0.06948994210899,
          73.81251155
        ],
        [
          0.00029096967724,
          0.06923734107271,
          73.82733309
        ],
        [
          0.00028692543057,
          0.06948839122114,
          73.81260372
        ],
        [
          0.00029099520764,
          0.06923576434381,
          73.82742784
        ],
        [
          0.00028690064249,
          0.06948994210899,
          73.81251155
        ],
        [
          0.00029371188673,
          0.06906887490071,
          73.83736154
        ],
        [
          0.00028692543057,
          0.06948839122114,
          73.81260372
        ],
        [
          0.00029539441503,
          0.06896628047939,
          73.84346166
        ],
        [
          0.00028690064249,
          0.06948994210899,
          73.81251155
        ],
        [
          0.00029153624013,
          0.06920241289705,
          73.82940783
        ],
        [
          0.00028692543057,
          0.06948839122114,
          73.81260372
        ],
        [
          0.00029156187348,
          0.06920083264467,
          73.82950294
        ],
        [
          0.00028690064249,
          0.06948994210899,
          73.81251155
        ],
        [
          0.00029428940629,
          0.06903357566915,
          73.83947593
        ],
        [
          0.00028692543057,
          0.06948839122114,
          73.81260372
        ],
        [
          0.00029597915487,
          0.06893072967725,
          73.84559924
        ],
        [
          0.00028725423552,
          0.06946785556086,
          73.81380507
        ],
        [
          0.00029328306359,
          0.06909520196346,
          73.83572662
        ],
        [
          0.00028727908767,
          0.06946630242893,
          73.81389746
        ],
        [
          0.00030092393428,
          0.0686329457044,
          73.86340618
        ],
        [
          0.00028725423552,
          0.06946785556086,
          73.81380507
        ],
        [
          0.00029607052689,
          0.0689252002002,
          73.84591607
        ],
        [
          0.00028727908767,
          0.06946630242893,
          73.81389746
        ],
        [
          0.00030386574179,
          0.06845775125131,
          73.87412541
        ],
        [
          0.00028725423552,
          0.06946785556086,
          73.81380507
        ],
        [
          0.00029385888276,
          0.06905996000572,
          73.83783445
        ],
        [
          0.00028727908767,
          0.06946630242893,
          73.81389746
        ],
        [
          0.00030153173176,
          0.06859661905232,
          73.86562317
        ],
        [
          0.00028725423552,
          0.06946785556086,
          73.81380507
        ],
        [
          0.00029665806438,
          0.06888955447865,
          73.84806332
        ],
        [
          0.00028727908767,
          0.06946630242893,
          73.81389746
        ],
        [
          0.00030448574474,
          0.0684210252026,
          73.87638469
        ],
        [
          0.00028725423552,
          0.06946785556086,
          73.81380507
        ],
        [
          0.0002960617287,
          0.06892584899623,
          73.84578518
        ],
        [
          0.00028727908767,
          0.06946630242893,
          73.81389746
        ],
        [
          0.00030385778183,
          0.06845834030703,
          73.87399486
        ],
        [
          0.00028725423552,
          0.06946785556086,
          73.81380507
        ],
        [
          0.00029890559654,
          0.06875391756764,
          73.85616629
        ],
        [
          0.00028727908767,
          0.06946630242893,
          73.81389746
        ],
        [
          0.00030867417819,
          0.06817490162956,
          73.89146539
        ],
        [
          0.00028725423552,
          0.06946785556086,
          73.81380507
        ],
        [
          0.00029664932709,
          0.06889019880777,
          73.84793244
        ],
        [
          0.00028727908767,
          0.06946630242893,
          73.81389746
        ],
        [
          0.00030447785556,
          0.06842160939013,
          73.87625419
        ],
        [
          0.00028725423552,
          0.06946785556086,
          73.81380507
        ],
        [
          0.00029950493109,
          0.06871787398654,
          73.85835419
        ],
        [
          0.00028727908767,
          0.06946630242893,
          73.81389746
        ],
        [
          0.0003093143761,
          0.06813752292588,
          73.89379436
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00028956283036,
          0.06932478326229,
          73.82180211
        ],
        [
          0.00028685627916,
          0.06949273602805,
          73.8123312
        ],
        [
          0.00028957752195,
          0.06932387458716,
          73.82185432
        ],
        [
          0.00028684189327,
          0.06949363357519,
          73.81228003
        ],
        [
          0.00029132199349,
          0.06921635985401,
          73.82798224
        ],
        [
          0.00028685627916,
          0.06949273602805,
          73.8123312
        ],
        [
          0.00029133688213,
          0.06921544411645,
          73.82803511
        ],
        [
          0.00028684189327,
          0.06949363357519,
          73.81228003
        ],
        [
          0.00028991977063,
          0.06930273677653,
          73.82305469
        ],
        [
          0.00028685627916,
          0.06949273602805,
          73.8123312
        ],
        [
          0.0002899345022,
          0.06930182666253,
          73.82310703
        ],
        [
          0.00028684189327,
          0.06949363357519,
          73.81228003
        ],
        [
          0.00029168377799,
          0.06919413859505,
          73.82925104
        ],
        [
          0.00028685627916,
          0.06949273602805,
          73.8123312
        ],
        [
          0.00029169870727,
          0.06919322140739,
          73.82930404
        ],
        [
          0.00028684189327,
          0.06949363357519,
          73.81228003
        ],
        [
          0.00028956283036,
          0.06932478326229,
          73.82180211
        ],
        [
          0.00028685627916,
          0.06949273602805,
          73.8123312
        ],
        [
          0.00028957752195,
          0.06932387458716,
          73.82185432
        ],
        [
          0.00028684189327,
          0.06949363357519,
          73.81228003
        ],
        [
          0.00029132199349,
          0.06921635985401,
          73.82798224
        ],
        [
          0.00028685627916,
          0.06949273602805,
          73.8123312
        ],
        [
          0.00029246547532,
          0.06914623615446,
          73.83197145
        ],
        [
          0.00028684189327,
          0.06949363357519,
          73.81228003
        ],
        [
          0.00028991977063,
          0.06930273677653,
          73.82305469
        ],
        [
          0.00028685627916,
          0.06949273602805,
          73.8123312
        ],
        [
          0.0002899345022,
          0.06930182666253,
          73.82310703
        ],
        [
          0.00028684189327,
          0.06949363357519,
          73.81228003
        ],
        [
          0.00029168377799,
          0.06919413859505,
          73.82925104
        ],
        [
          0.00028685627916,
          0.06949273602805,
          73.8123312
        ],
        [
          0.00029283039184,
          0.06912390310996,
          73.83325089
        ],
        [
          0.00028707503719,
          0.06947910472801,
          73.81309901
        ],
        [
          0.00029112364324,
          0.06922859465023,
          73.82725125
        ],
        [
          0.00028708944908,
          0.06947820623165,
          73.81315028
        ],
        [
          0.00029623354061,
          0.06891697905364,
          73.84506725
        ],
        [
          0.00028707503719,
          0.06947910472801,
          73.81309901
        ],
        [
          0.00029290466895,
          0.06911937170331,
          73.83350162
        ],
        [
          0.00028708944908,
          0.06947820623165,
          73.81315028
        ],
        [
          0.00029808403678,
          0.06880530177535,
          73.85155348
        ],
        [
          0.00028707503719,
          0.06947910472801,
          73.81309901
        ],
        [
          0.00029148490324,
          0.06920639171678,
          73.82851825
        ],
        [
          0.00028708944908,
          0.06947820623165,
          73.81315028
        ],
        [
          0.00029660920996,
          0.06889425880578,
          73.84638158
        ],
        [
          0.00028707503719,
          0.06947910472801,
          73.81309901
        ],
        [
          0.00029327074432,
          0.06909699978925,
          73.83478399
        ],
        [
          0.00028708944908,
          0.06947820623165,
          73.81315028
        ],
        [
          0.00029846471478,
          0.06878240932024,
          73.85288534
        ],
        [
          0.00028707503719,
          0.06947910472801,
          73.81309901
        ],
        [
          0.00029300543144,
          0.06911327296959,
          73.83380152
        ],
        [
          0.00028708944908,
          0.06947820623165,
          73.81315028
        ],
        [
          0.00029818931573,
          0.06879903076232,
          73.85186766
        ],
        [
          0.00028707503719,
          0.06947910472801,
          73.81309901
        ],
        [
          0.00029481116469,
          0.06900318565426,
          73.84014004
        ],
        [
          0.00028708944908,
          0.06947820623165,
          73.81315028
        ],
        [
          0.00030127166368,
          0.06861450962855,
          73.86263636
        ],
        [
          0.00028707503719,
          0.06947910472801,
          73.81309901
        ],
        [
          0.00029337177005,
          0.06909089087694,
          73.83508577
        ],
        [
          0.00028708944908,
          0.06947820623165,
          73.81315028
        ],
        [
          0.0002985703265,
          0.06877612581653,
          73.85320057
        ],
        [
          0.00028707503719,
          0.06947910472801,
          73.81309901
        ],
        [
          0.00029518267114,
          0.06898061635348,
          73.84144127
        ],
        [
          0.00028708944908,
          0.06947820623165,
          73.81315028
        ],
        [
          0.00030166133126,
          0.06859130493224,
          73.86399824
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00028855533162,
          0.06938741383877,
          73.81803693
        ],
        [
          0.00028681784648,
          0.06949514227834,
          73.81218736
        ],
        [
          0.00028856389331,
          0.06938688388583,
          73.81806625
        ],
        [
          0.00028680940644,
          0.06949566763386,
          73.81215844
        ],
        [
          0.00028962497546,
          0.06932137941092,
          73.82164578
        ],
        [
          0.00028681784648,
          0.06949514227834,
          73.81218736
        ],
        [
          0.00028963361137,
          0.06932084668555,
          73.82167535
        ],
        [
          0.00028680940644,
          0.06949566763386,
          73.81215844
        ],
        [
          0.00028877924728,
          0.06937357099655,
          73.81879315
        ],
        [
          0.00028681784648,
          0.06949514227834,
          73.81218736
        ],
        [
          0.00028878782451,
          0.06937304046201,
          73.81882253
        ],
        [
          0.00028680940644,
          0.06949566763386,
          73.81215844
        ],
        [
          0.00028985085671,
          0.06930746263085,
          73.82240838
        ],
        [
          0.00028681784648,
          0.06949514227834,
          73.81218736
        ],
        [
          0.00028985950831,
          0.06930692932128,
          73.82243799
        ],
        [
          0.00028680940644,
          0.06949566763386,
          73.81215844
        ],
        [
          0.00028855533162,
          0.06938741383877,
          73.81803693
        ],
        [
          0.00028681784648,
          0.06949514227834,
          73.81218736
        ],
        [
          0.00028856389331,
          0.06938688388583,
          73.81806625
        ],
        [
          0.00028680940644,
          0.06949566763386,
          73.81215844
        ],
        [
          0.00028962497546,
          0.06932137941092,
          73.82164578
        ],
        [
          0.00028681784648,
          0.06949514227834,
          73.81218736
        ],
        [
          0.00029036348546,
          0.06927592547091,
          73.82413079
        ],
        [
          0.00028680940644,
          0.06949566763386,
          73.81215844
        ],
        [
          0.00028877924728,
          0.06937357099655,
          73.81879315
        ],
        [
          0.00028681784648,
          0.06949514227834,
          73.81218736
        ],
        [
          0.00028878782451,
          0.06937304046201,
          73.81882253
        ],
        [
          0.00028680940644,
          0.06949566763386,
          73.81215844
        ],
        [
          0.00028985085671,
          0.06930746263085,
          73.82240838
        ],
        [
          0.00028681784648,
          0.06949514227834,
          73.81218736
        ],
        [
          0.00029059072999,
          0.06926195754715,
          73.8248978
        ],
        [
          0.0002869555098,
          0.069486583981,
          73.81265173
        ],
        [
          0.00028956305279,
          0.06932521119552,
          73.82142392
        ],
        [
          0.00028696395995,
          0.06948605824325,
          73.81268069
        ],
        [
          0.00029284777147,
          0.06912383604795,
          73.8324552
        ],
        [
          0.0002869555098,
          0.069486583981,
          73.81265173
        ],
        [
          0.00029064158774,
          0.06925884210735,
          73.82506152
        ],
        [
          0.00028696395995,
          0.06948605824325,
          73.81268069
        ],
        [
          0.00029395494142,
          0.06905640708124,
          73.83618894
        ],
        [
          0.0002869555098,
          0.069486583981,
          73.81265173
        ],
        [
          0.00028978882614,
          0.06931129833146,
          73.82218615
        ],
        [
          0.00028696395995,
          0.06948605824325,
          73.81268069
        ],
        [
          0.00029307949739,
          0.06910970210895,
          73.83323843
        ],
        [
          0.0002869555098,
          0.069486583981,
          73.81265173
        ],
        [
          0.00029086934845,
          0.06924485481575,
          73.8258302
        ],
        [
          0.00028696395995,
          0.06948605824325,
          73.81268069
        ],
        [
          0.00029418886277,
          0.06904219082486,
          73.83697754
        ],
        [
          0.0002869555098,
          0.069486583981,
          73.81265173
        ],
        [
          0.00029078864302,
          0.06924983614841,
          73.82553534
        ],
        [
          0.00028696395995,
          0.06948605824325,
          73.81268069
        ],
        [
          0.00029410612888,
          0.06904724415442,
          73.83667584
        ],
        [
          0.0002869555098,
          0.069486583981,
          73.81265173
        ],
        [
          0.00029187881968,
          0.06918301638123,
          73.82920703
        ],
        [
          0.00028696395995,
          0.06948605824325,
          73.81268069
        ],
        [
          0.00029598868318,
          0.06893319646413,
          73.84300848
        ],
        [
          0.0002869555098,
          0.069486583981,
          73.81265173
        ],
        [
          0.0002910166854,
          0.06923583810883,
          73.82630491
        ],
        [
          0.00028696395995,
          0.06948605824325,
          73.81268069
        ],
        [
          0.00029434034246,
          0.06903301690209,
          73.83746537
        ],
        [
          0.0002869555098,
          0.069486583981,
          73.81265173
        ],
        [
          0.00029210875995,
          0.06916894982303,
          73.82998327
        ],
        [
          0.00028696395995,
          0.06948605824325,
          73.81268069
        ],
        [
          0.00029622641588,
          0.06891884010336,
          73.84380941
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00028783270138,
          0.06943230616677,
          73.81546711
        ],
        [
          0.00028679242664,
          0.06949672852571,
          73.81209689
        ],
        [
          0.00028783695941,
          0.06943204264766,
          73.81548113
        ],
        [
          0.00028678820697,
          0.06949699054869,
          73.81208298
        ],
        [
          0.00028845125056,
          0.06939409888101,
          73.81747347
        ],
        [
          0.00028679242664,
          0.06949672852571,
          73.81209689
        ],
        [
          0.00028845553155,
          0.06939383446463,
          73.81748757
        ],
        [
          0.00028678820697,
          0.06949699054869,
          73.81208298
        ],
        [
          0.00028796097821,
          0.0694243760922,
          73.81588348
        ],
        [
          0.00028679242664,
          0.06949672852571,
          73.81209689
        ],
        [
          0.00028796524093,
          0.06942411239107,
          73.81589752
        ],
        [
          0.00028678820697,
          0.06949699054869,
          73.81208298
        ],
        [
          0.0002885802291,
          0.06938614119348,
          73.81789205
        ],
        [
          0.00028679242664,
          0.06949672852571,
          73.81209689
        ],
        [
          0.00028858451485,
          0.06938587659265,
          73.81790616
        ],
        [
          0.00028678820697,
          0.06949699054869,
          73.81208298
        ],
        [
          0.00028783270138,
          0.06943230616677,
          73.81546711
        ],
        [
          0.00028679242664,
          0.06949672852571,
          73.81209689
        ],
        [
          0.00028783695941,
          0.06943204264766,
          73.81548113
        ],
        [
          0.00028678820697,
          0.06949699054869,
          73.81208298
        ],
        [
          0.00028845125056,
          0.06939409888101,
          73.81747347
        ],
        [
          0.00028679242664,
          0.06949672852571,
          73.81209689
        ],
        [
          0.00028888551706,
          0.06936732333849,
          73.81887876
        ],
        [
          0.00028678820697,
          0.06949699054869,
          73.81208298
        ],
        [
          0.00028796097821,
          0.0694243760922,
          73.81588348
        ],
        [
          0.00028679242664,
          0.06949672852571,
          73.81209689
        ],
        [
          0.00028796524093,
          0.06942411239107,
          73.81589752
        ],
        [
          0.00028678820697,
          0.06949699054869,
          73.81208298
        ],
        [
          0.0002885802291,
          0.06938614119348,
          73.81789205
        ],
        [
          0.00028679242664,
          0.06949672852571,
          73.81209689
        ],
        [
          0.00028901498368,
          0.06935934661913,
          73.81929887
        ],
        [
          0.00028687478912,
          0.06949161932147,
          73.81236443
        ],
        [
          0.00028844245853,
          0.06939464668842,
          73.81744044
        ],
        [
          0.00028687901195,
          0.06949135717524,
          73.81237835
        ],
        [
          0.0002904095269,
          0.06927365557251,
          73.82380461
        ],
        [
          0.00028687478912,
          0.06949161932147,
          73.81236443
        ],
        [
          0.0002890644724,
          0.0693563001609,
          73.81945793
        ],
        [
          0.00028687901195,
          0.06949135717524,
          73.81237835
        ],
        [
          0.00029104224378,
          0.06923489335974,
          73.82585561
        ],
        [
          0.00028687478912,
          0.06949161932147,
          73.81236443
        ],
        [
          0.00028857142858,
          0.06938668930339,
          73.817859
        ],
        [
          0.00028687901195,
          0.06949135717524,
          73.81237835
        ],
        [
          0.0002905407132,
          0.06926561204576,
          73.82423011
        ],
        [
          0.00028687478912,
          0.06949161932147,
          73.81236443
        ],
        [
          0.00028919414026,
          0.06934831560623,
          73.81987867
        ],
        [
          0.00028687901195,
          0.06949135717524,
          73.81237835
        ],
        [
          0.00029117414451,
          0.0692268222451,
          73.82628334
        ],
        [
          0.00028687478912,
          0.06949161932147,
          73.81236443
        ],
        [
          0.00028919495516,
          0.06934827462642,
          73.81987343
        ],
        [
          0.00028687901195,
          0.06949135717524,
          73.81237835
        ],
        [
          0.00029117500991,
          0.06922677855825,
          73.8262782
        ],
        [
          0.00028687478912,
          0.06949161932147,
          73.81236443
        ],
        [
          0.00028982105789,
          0.06930976883292,
          73.82190371
        ],
        [
          0.00028687901195,
          0.06949135717524,
          73.81237835
        ],
        [
          0.00029225520477,
          0.0691608167808,
          73.82977233
        ],
        [
          0.00028687478912,
          0.06949161932147,
          73.81236443
        ],
        [
          0.00028932477187,
          0.06934028423748,
          73.82029463
        ],
        [
          0.00028687901195,
          0.06949135717524,
          73.81237835
        ],
        [
          0.00029130707748,
          0.06921870056705,
          73.82670651
        ],
        [
          0.00028687478912,
          0.06949161932147,
          73.81236443
        ],
        [
          0.00028995157878,
          0.06930175111337,
          73.82232712
        ],
        [
          0.00028687901195,
          0.06949135717524,
          73.81237835
        ],
        [
          0.00029238844069,
          0.06915269570417,
          73.83020379
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00028736317826,
          0.06946143818809,
          73.81387592
        ],
        [
          0.00028678076644,
          0.06949745388727,
          73.81205735
        ],
        [
          0.00028736516502,
          0.06946131529851,
          73.81388224
        ],
        [
          0.00028677879027,
          0.06949757635172,
          73.81205106
        ],
        [
          0.00028770190078,
          0.06944052137225,
          73.81493478
        ],
        [
          0.00028678076644,
          0.06949745388727,
          73.81205735
        ],
        [
          0.00028770389367,
          0.06944039823726,
          73.81494113
        ],
        [
          0.00028677879027,
          0.06949757635172,
          73.81205106
        ],
        [
          0.00028743382136,
          0.06945707359984,
          73.81409706
        ],
        [
          0.00028678076644,
          0.06949745388727,
          73.81205735
        ],
        [
          0.0002874358094,
          0.06945695065902,
          73.81410339
        ],
        [
          0.00028677879027,
          0.06949757635172,
          73.81205106
        ],
        [
          0.00028777276559,
          0.06943614784427,
          73.8151566
        ],
        [
          0.00028678076644,
          0.06949745388727,
          73.81205735
        ],
        [
          0.00028777475978,
          0.06943602465743,
          73.81516295
        ],
        [
          0.00028677879027,
          0.06949757635172,
          73.81205106
        ],
        [
          0.00028736317826,
          0.06946143818809,
          73.81387592
        ],
        [
          0.00028678076644,
          0.06949745388727,
          73.81205735
        ],
        [
          0.00028736516502,
          0.06946131529851,
          73.81388224
        ],
        [
          0.00028677879027,
          0.06949757635172,
          73.81205106
        ],
        [
          0.00028770190078,
          0.06944052137225,
          73.81493478
        ],
        [
          0.00028678076644,
          0.06949745388727,
          73.81205735
        ],
        [
          0.00028794493697,
          0.06942552944016,
          73.8156927
        ],
        [
          0.00028677879027,
          0.06949757635172,
          73.81205106
        ],
        [
          0.00028743382136,
          0.06945707359984,
          73.81409706
        ],
        [
          0.00028678076644,
          0.06949745388727,
          73.81205735
        ],
        [
          0.0002874358094,
          0.06945695065902,
          73.81410339
        ],
        [
          0.00028677879027,
          0.06949757635172,
          73.81205106
        ],
        [
          0.00028777276559,
          0.06943614784427,
          73.8151566
        ],
        [
          0.00028678076644,
          0.06949745388727,
          73.81205735
        ],
        [
          0.00028801596134,
          0.06942114948053,
          73.815915
        ],
        [
          0.00028682589519,
          0.06949466030533,
          73.81219867
        ],
        [
          0.00028770521299,
          0.06944031969988,
          73.81494277
        ],
        [
          0.0002868278722,
          0.06949453780739,
          73.81220497
        ],
        [
          0.00028880448784,
          0.06937260303083,
          73.81837088
        ],
        [
          0.00028682589519,
          0.06949466030533,
          73.81219867
        ],
        [
          0.00028804501267,
          0.06941935941401,
          73.81600491
        ],
        [
          0.0002868278722,
          0.06949453780739,
          73.81220497
        ],
        [
          0.00028914777645,
          0.0693515019693,
          73.81944363
        ],
        [
          0.00028682589519,
          0.06949466030533,
          73.81219867
        ],
        [
          0.00028777608039,
          0.06943594605964,
          73.8151646
        ],
        [
          0.0002868278722,
          0.06949453780739,
          73.81220497
        ],
        [
          0.00028887608184,
          0.06936820006822,
          73.81859492
        ],
        [
          0.00028682589519,
          0.06949466030533,
          73.81219867
        ],
        [
          0.00028811610276,
          0.06941497680783,
          73.81622741
        ],
        [
          0.0002868278722,
          0.06949453780739,
          73.81220497
        ],
        [
          0.00028921959584,
          0.06934708998479,
          73.81966835
        ],
        [
          0.00028682589519,
          0.06949466030533,
          73.81219867
        ],
        [
          0.00028813401874,
          0.06941387636462,
          73.81628015
        ],
        [
          0.0002868278722,
          0.06949453780739,
          73.81220497
        ],
        [
          0.00028923770521,
          0.06934598156864,
          73.81972166
        ],
        [
          0.00028682589519,
          0.06949466030533,
          73.81219867
        ],
        [
          0.00028847505913,
          0.06939286871709,
          73.81734582
        ],
        [
          0.0002868278722,
          0.06949453780739,
          73.81220497
        ],
        [
          0.00028982763765,
          0.06930978647429,
          73.82156298
        ],
        [
          0.00028682589519,
          0.06949466030533,
          73.81219867
        ],
        [
          0.0002882050388,
          0.06940949959988,
          73.81650219
        ],
        [
          0.0002868278722,
          0.06949453780739,
          73.81220497
        ],
        [
          0.00028930958424,
          0.06934156718827,
          73.81994656
        ],
        [
          0.00028682589519,
          0.06949466030533,
          73.81219867
        ],
        [
          0.00028854643632,
          0.06938847446036,
          73.8175692
        ],
        [
          0.0002868278722,
          0.06949453780739,
          73.81220497
        ],
        [
          0.00028989990521,
          0.06930535657116,
          73.82178907
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00028707136467,
          0.06947951332077,
          73.81293211
        ],
        [
          0.0002867752678,
          0.06949779495934,
          73.81203957
        ],
        [
          0.00028707204757,
          0.06947947111526,
          73.81293422
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028724007701,
          0.06946910370321,
          73.81344129
        ],
        [
          0.0002867752678,
          0.06949779495934,
          73.81203957
        ],
        [
          0.00028724076101,
          0.06946906145288,
          73.8134434
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028710515068,
          0.06947742826433,
          73.81303407
        ],
        [
          0.0002867752678,
          0.06949779495934,
          73.81203957
        ],
        [
          0.00028710583375,
          0.06947738605251,
          73.81303619
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028727391889,
          0.06946701633128,
          73.81354342
        ],
        [
          0.0002867752678,
          0.06949779495934,
          73.81203957
        ],
        [
          0.0002872746031,
          0.06946697407259,
          73.81354553
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028707136467,
          0.06947951332077,
          73.81293211
        ],
        [
          0.0002867752678,
          0.06949779495934,
          73.81203957
        ],
        [
          0.00028707204757,
          0.06947947111526,
          73.81293422
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028724007701,
          0.06946910370321,
          73.81344129
        ],
        [
          0.0002867752678,
          0.06949779495934,
          73.81203957
        ],
        [
          0.00028736519895,
          0.06946138826373,
          73.81381805
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028710515068,
          0.06947742826433,
          73.81303407
        ],
        [
          0.0002867752678,
          0.06949779495934,
          73.81203957
        ],
        [
          0.00028710583375,
          0.06947738605251,
          73.81303619
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028727391889,
          0.06946701633128,
          73.81354342
        ],
        [
          0.0002867752678,
          0.06949779495934,
          73.81203957
        ],
        [
          0.00028739908239,
          0.0694592991685,
          73.8139203
        ],
        [
          0.0002867972162,
          0.0694964390256,
          73.8121059
        ],
        [
          0.00028724878888,
          0.06946856729481,
          73.81346675
        ],
        [
          0.00028679789728,
          0.06949639689558,
          73.812108
        ],
        [
          0.00028781168074,
          0.06943388277701,
          73.81516168
        ],
        [
          0.0002867972162,
          0.0694964390256,
          73.8121059
        ],
        [
          0.00028741779523,
          0.06945814548784,
          73.8139768
        ],
        [
          0.00028679789728,
          0.06949639689558,
          73.812108
        ],
        [
          0.0002879816219,
          0.06942342226074,
          73.81567448
        ],
        [
          0.0002867972162,
          0.0694964390256,
          73.8121059
        ],
        [
          0.00028728263373,
          0.06946647979876,
          73.81356889
        ],
        [
          0.00028679789728,
          0.06949639689558,
          73.812108
        ],
        [
          0.00028784571273,
          0.06943178752939,
          73.81526437
        ],
        [
          0.0002867972162,
          0.0694964390256,
          73.8121059
        ],
        [
          0.00028745169611,
          0.06945605567098,
          73.8140791
        ],
        [
          0.00028679789728,
          0.06949639689558,
          73.812108
        ],
        [
          0.00028801571037,
          0.0694213246792,
          73.81577733
        ],
        [
          0.0002867972162,
          0.0694964390256,
          73.8121059
        ],
        [
          0.00028746960364,
          0.06945495337757,
          73.81413183
        ],
        [
          0.00028679789728,
          0.06949639689558,
          73.812108
        ],
        [
          0.00028803371905,
          0.06942021816158,
          73.81583036
        ],
        [
          0.0002867972162,
          0.0694964390256,
          73.8121059
        ],
        [
          0.00028763897639,
          0.06944451638818,
          73.81464296
        ],
        [
          0.00028679789728,
          0.06949639689558,
          73.812108
        ],
        [
          0.00028832953394,
          0.06940202759201,
          73.81672178
        ],
        [
          0.0002867972162,
          0.0694964390256,
          73.8121059
        ],
        [
          0.00028750352185,
          0.06945286284045,
          73.81423419
        ],
        [
          0.00028679789728,
          0.06949639689558,
          73.812108
        ],
        [
          0.00028806782497,
          0.06941811985707,
          73.81593326
        ],
        [
          0.0002867972162,
          0.0694964390256,
          73.8121059
        ],
        [
          0.00028767295077,
          0.06944242352754,
          73.81474547
        ],
        [
          0.00028679789728,
          0.06949639689558,
          73.812108
        ],
        [
          0.00028836374064,
          0.069399925077,
          73.81682499
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00028690287153,
          0.06948992959237,
          73.81241112
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028690287153,
          0.06948992959237,
          73.81241112
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028697254684,
          0.06948563610906,
          73.81261411
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028697254684,
          0.06948563610906,
          73.81261411
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028691717515,
          0.06948904803927,
          73.81245285
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028691717515,
          0.06948904803927,
          73.81245285
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.0002869868608,
          0.06948475411674,
          73.81265587
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.0002869868608,
          0.06948475411674,
          73.81265587
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028690287153,
          0.06948992959237,
          73.81241112
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028690287153,
          0.06948992959237,
          73.81241112
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028697254684,
          0.06948563610906,
          73.81261411
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028702805471,
          0.06948221650858,
          73.81277567
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028691717515,
          0.06948904803927,
          73.81245285
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028691717515,
          0.06948904803927,
          73.81245285
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.0002869868608,
          0.06948475411674,
          73.81265587
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028704237693,
          0.06948133416529,
          73.81281746
        ],
        [
          0.00028678344886,
          0.06949729066476,
          73.81206332
        ],
        [
          0.00028698078348,
          0.0694851286152,
          73.81263811
        ],
        [
          0.00028678344886,
          0.06949729066476,
          73.81206332
        ],
        [
          0.00028723114877,
          0.06946970966406,
          73.81336704
        ],
        [
          0.00028678344886,
          0.06949729066476,
          73.81206332
        ],
        [
          0.00028705051516,
          0.06948083273599,
          73.81284127
        ],
        [
          0.00028678344886,
          0.06949729066476,
          73.81206332
        ],
        [
          0.00028730106176,
          0.06946540608426,
          73.81357071
        ],
        [
          0.00028678344886,
          0.06949729066476,
          73.81206332
        ],
        [
          0.00028699509869,
          0.06948424656968,
          73.81267988
        ],
        [
          0.00028678344886,
          0.06949729066476,
          73.81206332
        ],
        [
          0.00028724550112,
          0.0694688260416,
          73.81340891
        ],
        [
          0.00028678344886,
          0.06949729066476,
          73.81206332
        ],
        [
          0.00028706484069,
          0.06947995025272,
          73.81288306
        ],
        [
          0.00028678344886,
          0.06949729066476,
          73.81206332
        ],
        [
          0.0002873154245,
          0.06946452202157,
          73.81361261
        ],
        [
          0.00028678344886,
          0.06949729066476,
          73.81206332
        ],
        [
          0.00028707864641,
          0.06947910007774,
          73.81292312
        ],
        [
          0.00028678344886,
          0.06949729066476,
          73.81206332
        ],
        [
          0.00028732926624,
          0.06946367031494,
          73.81365277
        ],
        [
          0.00028678344886,
          0.06949729066476,
          73.81206332
        ],
        [
          0.00028714844891,
          0.06947480119059,
          73.81312647
        ],
        [
          0.00028678344886,
          0.06949729066476,
          73.81206332
        ],
        [
          0.00028745500446,
          0.06945593365888,
          73.8140189
        ],
        [
          0.00028678344886,
          0.06949729066476,
          73.81206332
        ],
        [
          0.00028709297613,
          0.06947821741601,
          73.81296492
        ],
        [
          0.00028678344886,
          0.06949729066476,
          73.81206332
        ],
        [
          0.00028734363319,
          0.06946278607327,
          73.81369468
        ],
        [
          0.00028678344886,
          0.06949729066476,
          73.81206332
        ],
        [
          0.00028716278899,
          0.06947391808928,
          73.8131683
        ],
        [
          0.00028678344886,
          0.06949729066476,
          73.81206332
        ],
        [
          0.0002874693901,
          0.06945504862485,
          73.81406087
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00028681938731,
          0.06949507999548,
          73.81216385
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028681938731,
          0.06949507999548,
          73.81216385
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028684300764,
          0.06949362658667,
          73.81223044
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028684300764,
          0.06949362658667,
          73.81223044
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028682393147,
          0.06949480035956,
          73.81217667
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028682393147,
          0.06949480035956,
          73.81217667
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028684755296,
          0.06949334690091,
          73.81224326
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028684755296,
          0.06949334690091,
          73.81224326
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028681938731,
          0.06949507999548,
          73.81216385
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028681938731,
          0.06949507999548,
          73.81216385
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028684300764,
          0.06949362658667,
          73.81223044
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028686328624,
          0.0694923788217,
          73.81228766
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028682393147,
          0.06949480035956,
          73.81217667
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028682393147,
          0.06949480035956,
          73.81217667
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028684755296,
          0.06949334690091,
          73.81224326
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028686783257,
          0.06949209909192,
          73.81230049
        ],
        [
          0.0002867774281,
          0.0694976622012,
          73.81204549
        ],
        [
          0.0002868459225,
          0.06949344721121,
          73.81223868
        ],
        [
          0.0002867774281,
          0.0694976622012,
          73.81204549
        ],
        [
          0.00028693417224,
          0.06948801799901,
          73.81248749
        ],
        [
          0.0002867774281,
          0.0694976622012,
          73.81204549
        ],
        [
          0.00028686954968,
          0.06949199350505,
          73.81230528
        ],
        [
          0.0002867774281,
          0.0694976622012,
          73.81204549
        ],
        [
          0.00028695782226,
          0.06948656330111,
          73.81255415
        ],
        [
          0.0002867774281,
          0.0694976622012,
          73.81204549
        ],
        [
          0.00028685046798,
          0.06949316751782,
          73.8122515
        ],
        [
          0.0002867774281,
          0.0694976622012,
          73.81204549
        ],
        [
          0.00028693872212,
          0.06948773811486,
          73.81250033
        ],
        [
          0.0002867774281,
          0.0694976622012,
          73.81204549
        ],
        [
          0.00028687409632,
          0.06949171376152,
          73.81231811
        ],
        [
          0.0002867774281,
          0.0694976622012,
          73.81204549
        ],
        [
          0.00028696237331,
          0.06948628336675,
          73.812567
        ],
        [
          0.0002867774281,
          0.0694976622012,
          73.81204549
        ],
        [
          0.00028687991806,
          0.06949135558336,
          73.81233453
        ],
        [
          0.0002867774281,
          0.0694976622012,
          73.81204549
        ],
        [
          0.00028696820067,
          0.06948592494455,
          73.81258343
        ],
        [
          0.0002867774281,
          0.0694976622012,
          73.81204549
        ],
        [
          0.00028690355403,
          0.06948990149561,
          73.81240115
        ],
        [
          0.0002867774281,
          0.0694976622012,
          73.81204549
        ],
        [
          0.00028701217113,
          0.0694832206668,
          73.81270743
        ],
        [
          0.0002867774281,
          0.0694976622012,
          73.81204549
        ],
        [
          0.00028688446524,
          0.06949107581662,
          73.81234736
        ],
        [
          0.0002867774281,
          0.0694976622012,
          73.81204549
        ],
        [
          0.00028697275223,
          0.06948564498763,
          73.81259627
        ],
        [
          0.0002867774281,
          0.0694976622012,
          73.81204549
        ],
        [
          0.00028690810239,
          0.06948962167727,
          73.81241399
        ],
        [
          0.0002867774281,
          0.0694976622012,
          73.81204549
        ],
        [
          0.0002870167249,
          0.06948294061375,
          73.81272028
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00028678398265,
          0.06949725974489,
          73.81206317
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028678398265,
          0.06949725974489,
          73.81206317
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028678943138,
          0.06949692494782,
          73.81207809
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028678943138,
          0.06949692494782,
          73.81207809
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028678490784,
          0.06949720289628,
          73.81206571
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028678490784,
          0.06949720289628,
          73.81206571
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028679035662,
          0.06949686809676,
          73.81208062
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028679035662,
          0.06949686809676,
          73.81208062
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028678398265,
          0.06949725974489,
          73.81206317
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028678398265,
          0.06949725974489,
          73.81206317
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028678943138,
          0.06949692494782,
          73.81207809
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028679356774,
          0.0694966707929,
          73.81208941
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028678490784,
          0.06949720289628,
          73.81206571
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028678490784,
          0.06949720289628,
          73.81206571
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028679035662,
          0.06949686809676,
          73.81208062
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028679449303,
          0.06949661393965,
          73.81209194
        ],
        [
          0.00028677505017,
          0.06949780861468,
          73.81203873
        ],
        [
          0.00028678989897,
          0.06949689621714,
          73.81207937
        ],
        [
          0.00028677505017,
          0.06949780861468,
          73.81203873
        ],
        [
          0.00028680986561,
          0.06949566941804,
          73.81213401
        ],
        [
          0.00028677505017,
          0.06949780861468,
          73.81203873
        ],
        [
          0.00028679534805,
          0.0694965614041,
          73.81209428
        ],
        [
          0.00028677505017,
          0.06949780861468,
          73.81203873
        ],
        [
          0.00028681531594,
          0.06949533455016,
          73.81214893
        ],
        [
          0.00028677505017,
          0.06949780861468,
          73.81203873
        ],
        [
          0.00028679082422,
          0.06949683936566,
          73.8120819
        ],
        [
          0.00028677505017,
          0.06949780861468,
          73.81203873
        ],
        [
          0.00028681079107,
          0.06949561255737,
          73.81213655
        ],
        [
          0.00028677505017,
          0.06949780861468,
          73.81203873
        ],
        [
          0.00028679627337,
          0.06949650454938,
          73.81209681
        ],
        [
          0.00028677505017,
          0.06949780861468,
          73.81203873
        ],
        [
          0.00028681624148,
          0.06949527768571,
          73.81215146
        ],
        [
          0.00028677505017,
          0.06949780861468,
          73.81203873
        ],
        [
          0.00028679756066,
          0.0694964254545,
          73.81210034
        ],
        [
          0.00028677505017,
          0.06949780861468,
          73.81203873
        ],
        [
          0.00028681752905,
          0.06949519857839,
          73.81215499
        ],
        [
          0.00028677505017,
          0.06949780861468,
          73.81203873
        ],
        [
          0.00028680301024,
          0.06949609061942,
          73.81211525
        ],
        [
          0.00028677505017,
          0.06949780861468,
          73.81203873
        ],
        [
          0.00028682711785,
          0.06949460946143,
          73.81218123
        ],
        [
          0.00028677505017,
          0.06949780861468,
          73.81203873
        ],
        [
          0.00028679848601,
          0.06949636859841,
          73.81210287
        ],
        [
          0.00028677505017,
          0.06949780861468,
          73.81203873
        ],
        [
          0.00028681845462,
          0.06949514171231,
          73.81215752
        ],
        [
          0.00028677505017,
          0.06949780861468,
          73.81203873
        ],
        [
          0.00028680393564,
          0.06949603376123,
          73.81211778
        ],
        [
          0.00028677505017,
          0.06949780861468,
          73.81203873
        ],
        [
          0.00028682804351,
          0.06949455259225,
          73.81218376
        ]
      ],
      [
        [
          null,
          null,
          73.6144428
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ],
        [
          0.00028677458686,
          0.06949783708375,
          73.81203746
        ]
      ]
    ],
    "w": [
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00010192367068,
          0.07451305811695,
          83.60902318
        ],
        [
          0.00008681998507,
          0.07918204226573,
          81.4671544
        ],
        [
          0.00010136769304,
          0.07454165832758,
          83.65531675
        ],
        [
          0.00008721132096,
          0.07916608843295,
          81.42431202
        ],
        [
          0.00011952369482,
          0.06957940342526,
          86.27081038
        ],
        [
          0.00008680577434,
          0.07918378989422,
          81.46769866
        ],
        [
          0.00011869952455,
          0.06962777917119,
          86.31996015
        ],
        [
          0.0000865053741,
          0.07919667616744,
          81.50019742
        ],
        [
          0.00010090857038,
          0.07374339222014,
          84.47660058
        ],
        [
          0.00008609950663,
          0.0792149127786,
          81.54361188
        ],
        [
          0.00010030445415,
          0.07377910803562,
          84.52348479
        ],
        [
          0.00008649118748,
          0.07919842762688,
          81.50074148
        ],
        [
          0.00011490516884,
          0.06920973332821,
          87.22283371
        ],
        [
          0.00008608537023,
          0.07921666603856,
          81.54415563
        ],
        [
          0.00011403898117,
          0.06926637207691,
          87.27227652
        ],
        [
          0.00008722558175,
          0.07916434257403,
          81.42376746
        ],
        [
          0.00010192367068,
          0.07451305811695,
          83.60902318
        ],
        [
          0.00008681998507,
          0.07918204226573,
          81.4671544
        ],
        [
          0.00010136769304,
          0.07454165832758,
          83.65531675
        ],
        [
          0.00008721132096,
          0.07916608843295,
          81.42431202
        ],
        [
          0.00011952369482,
          0.06957940342526,
          86.27081038
        ],
        [
          0.00008680577434,
          0.07918378989422,
          81.46769866
        ],
        [
          0.00013495694903,
          0.06730420319077,
          86.89498759
        ],
        [
          0.0000865053741,
          0.07919667616744,
          81.50019742
        ],
        [
          0.00010090857038,
          0.07374339222014,
          84.47660058
        ],
        [
          0.00008609950663,
          0.0792149127786,
          81.54361188
        ],
        [
          0.00010030445415,
          0.07377910803562,
          84.52348479
        ],
        [
          0.00008649118748,
          0.07919842762688,
          81.50074148
        ],
        [
          0.00011490516884,
          0.06920973332821,
          87.22283371
        ],
        [
          0.00008608537023,
          0.07921666603856,
          81.54415563
        ],
        [
          0.00012947275551,
          0.06696012970925,
          87.88296786
        ],
        [
          0.00008710511446,
          0.07906842917499,
          81.52468141
        ],
        [
          0.00011262863277,
          0.072000529784,
          84.66707276
        ],
        [
          0.00008669608182,
          0.0790867308692,
          81.56815893
        ],
        [
          0.00014149864593,
          0.06630375496914,
          87.26915793
        ],
        [
          0.00008709083765,
          0.07907017949059,
          81.52522605
        ],
        [
          0.00012776293712,
          0.06750685439977,
          87.48773394
        ],
        [
          0.00008668185542,
          0.07908848301564,
          81.56870325
        ],
        [
          0.00015029440541,
          0.06264072769814,
          90.50848633
        ],
        [
          0.00008637815399,
          0.07910196099072,
          81.60125626
        ],
        [
          0.00011042232398,
          0.07136348610134,
          85.57522249
        ],
        [
          0.00008596885116,
          0.07912081033551,
          81.64476022
        ],
        [
          0.00013581733876,
          0.06594716740834,
          88.27903359
        ],
        [
          0.00008636395214,
          0.0791037170055,
          81.60180037
        ],
        [
          0.00012163867872,
          0.0672609174982,
          88.481879
        ],
        [
          0.00008595469988,
          0.07912256821345,
          81.64530401
        ],
        [
          0.00014031796548,
          0.06262880328874,
          91.615733
        ],
        [
          0.00008710511446,
          0.07906842917499,
          81.52468141
        ],
        [
          0.00013387586054,
          0.06824870186741,
          86.0135597
        ],
        [
          0.00008669608182,
          0.0790867308692,
          81.56815893
        ],
        [
          0.00016249916419,
          0.06297659261251,
          88.87505768
        ],
        [
          0.00008709083765,
          0.07907017949059,
          81.52522605
        ],
        [
          0.00014655045464,
          0.06420945990312,
          89.07270858
        ],
        [
          0.00008668185542,
          0.07908848301564,
          81.56870325
        ],
        [
          0.00018739827148,
          0.05745401062921,
          93.35615705
        ],
        [
          0.00008637815399,
          0.07910196099072,
          81.60125626
        ],
        [
          0.00012989160186,
          0.06775169946811,
          86.98163667
        ],
        [
          0.00008596885116,
          0.07912081033551,
          81.64476022
        ],
        [
          0.00015461707318,
          0.06272636510235,
          89.95615315
        ],
        [
          0.00008636395214,
          0.0791037170055,
          81.60180037
        ],
        [
          0.00013829339059,
          0.06407060613226,
          90.13430818
        ],
        [
          0.00008595469988,
          0.07912256821345,
          81.64530401
        ],
        [
          0.00017385144872,
          0.05748658170152,
          94.61244844
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00010765007739,
          0.07392819186885,
          83.42621495
        ],
        [
          0.00009152841942,
          0.07861746321112,
          81.29065279
        ],
        [
          0.00010710039912,
          0.07395302000456,
          83.47181554
        ],
        [
          0.00009192780086,
          0.07860297355614,
          81.24799793
        ],
        [
          0.00012687157549,
          0.06892931314261,
          86.08529772
        ],
        [
          0.00009152841942,
          0.07861746321112,
          81.29065279
        ],
        [
          0.00012604963327,
          0.06897306801285,
          86.13384875
        ],
        [
          0.00009118354129,
          0.07863350286972,
          81.32458965
        ],
        [
          0.00010676637532,
          0.07313695039557,
          84.29442101
        ],
        [
          0.00009078371705,
          0.07864851166848,
          81.36727447
        ],
        [
          0.0001061666609,
          0.07316864218531,
          84.34064276
        ],
        [
          0.00009118354129,
          0.07863350286972,
          81.32458965
        ],
        [
          0.00012229280629,
          0.0685273220055,
          87.04014389
        ],
        [
          0.00009078371705,
          0.07864851166848,
          81.36727447
        ],
        [
          0.00012142533718,
          0.06857901758769,
          87.08903671
        ],
        [
          0.00009192780086,
          0.07860297355614,
          81.24799793
        ],
        [
          0.00010765007739,
          0.07392819186885,
          83.42621495
        ],
        [
          0.00009152841942,
          0.07861746321112,
          81.29065279
        ],
        [
          0.00010710039912,
          0.07395302000456,
          83.47181554
        ],
        [
          0.00009192780086,
          0.07860297355614,
          81.24799793
        ],
        [
          0.00012687157549,
          0.06892931314261,
          86.08529772
        ],
        [
          0.00009152841942,
          0.07861746321112,
          81.29065279
        ],
        [
          0.00014322574549,
          0.06665534746934,
          86.70648381
        ],
        [
          0.00009118354129,
          0.07863350286972,
          81.32458965
        ],
        [
          0.00010676637532,
          0.07313695039557,
          84.29442101
        ],
        [
          0.00009078371705,
          0.07864851166848,
          81.36727447
        ],
        [
          0.0001061666609,
          0.07316864218531,
          84.34064276
        ],
        [
          0.00009118354129,
          0.07863350286972,
          81.32458965
        ],
        [
          0.00012229280629,
          0.0685273220055,
          87.04014389
        ],
        [
          0.00009078371705,
          0.07864851166848,
          81.36727447
        ],
        [
          0.00013778710307,
          0.06627728993948,
          87.69783293
        ],
        [
          0.00009181281262,
          0.07850564393186,
          81.34888802
        ],
        [
          0.0001191180548,
          0.07139953518713,
          84.47985893
        ],
        [
          0.00009140990844,
          0.07852070964483,
          81.39163565
        ],
        [
          0.00015009603157,
          0.06566246576368,
          87.07846786
        ],
        [
          0.00009181281262,
          0.07850564393186,
          81.34888802
        ],
        [
          0.0001359378803,
          0.06682777644715,
          87.30042839
        ],
        [
          0.00009140990844,
          0.07852070964483,
          81.39163565
        ],
        [
          0.00016069665802,
          0.06189743062554,
          90.32589867
        ],
        [
          0.00009106155118,
          0.07853733871673,
          81.42562919
        ],
        [
          0.00011703153059,
          0.07073649237441,
          85.38937141
        ],
        [
          0.00009065820077,
          0.07855293414799,
          81.46840574
        ],
        [
          0.00014447193512,
          0.06527163772623,
          88.09190425
        ],
        [
          0.00009106155118,
          0.07853733871673,
          81.42562919
        ],
        [
          0.00012981291167,
          0.06654515472517,
          88.29852795
        ],
        [
          0.00009065820077,
          0.07855293414799,
          81.46840574
        ],
        [
          0.00015061483377,
          0.06183847216061,
          91.4406476
        ],
        [
          0.00009181281262,
          0.07850564393186,
          81.34888802
        ],
        [
          0.00014173749841,
          0.06763307696711,
          85.82164102
        ],
        [
          0.00009140990844,
          0.07852070964483,
          81.39163565
        ],
        [
          0.00017269827361,
          0.06230974792946,
          88.68283131
        ],
        [
          0.00009181281262,
          0.07850564393186,
          81.34888802
        ],
        [
          0.00015624202607,
          0.06350338470304,
          88.88459443
        ],
        [
          0.00009140990844,
          0.07852070964483,
          81.39163565
        ],
        [
          0.00020090469185,
          0.05667296894746,
          93.18040831
        ],
        [
          0.00009106155118,
          0.07853733871673,
          81.42562919
        ],
        [
          0.00013785886206,
          0.06710559323414,
          86.79215069
        ],
        [
          0.00009065820077,
          0.07855293414799,
          81.46840574
        ],
        [
          0.00016484031994,
          0.0620208987274,
          89.76915394
        ],
        [
          0.00009106155118,
          0.07853733871673,
          81.42562919
        ],
        [
          0.00014794579392,
          0.06332282656934,
          89.95187988
        ],
        [
          0.00009065820077,
          0.07855293414799,
          81.46840574
        ],
        [
          0.00018722532892,
          0.05665070946445,
          94.44878455
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00010775053804,
          0.07391820016968,
          83.42307454
        ],
        [
          0.0000916578015,
          0.07860234227283,
          81.28590682
        ],
        [
          0.00010728177037,
          0.0739348941933,
          83.46613312
        ],
        [
          0.00009198958848,
          0.07859578039365,
          81.24573691
        ],
        [
          0.00012700310554,
          0.06891801097697,
          86.08204703
        ],
        [
          0.0000916578015,
          0.07860234227283,
          81.28590682
        ],
        [
          0.0001262843863,
          0.06895277099536,
          86.12803262
        ],
        [
          0.00009124501809,
          0.07862628655009,
          81.32233068
        ],
        [
          0.00010686920871,
          0.07312659260676,
          84.29129075
        ],
        [
          0.00009091244469,
          0.0786333418473,
          81.36253285
        ],
        [
          0.00010635225214,
          0.07314984921806,
          84.33497955
        ],
        [
          0.00009124501809,
          0.07862628655009,
          81.32233068
        ],
        [
          0.00012242519035,
          0.06851546058699,
          87.0369418
        ],
        [
          0.00009091244469,
          0.0786333418473,
          81.36253285
        ],
        [
          0.00012166150861,
          0.06855771342242,
          87.08330875
        ],
        [
          0.00009198958848,
          0.07859578039365,
          81.24573691
        ],
        [
          0.00010775053804,
          0.07391820016968,
          83.42307454
        ],
        [
          0.0000916578015,
          0.07860234227283,
          81.28590682
        ],
        [
          0.00010728177037,
          0.0739348941933,
          83.46613312
        ],
        [
          0.00009198958848,
          0.07859578039365,
          81.24573691
        ],
        [
          0.00012700310554,
          0.06891801097697,
          86.08204703
        ],
        [
          0.0000916578015,
          0.07860234227283,
          81.28590682
        ],
        [
          0.00014348964368,
          0.06663524165558,
          86.70059219
        ],
        [
          0.00009124501809,
          0.07862628655009,
          81.32233068
        ],
        [
          0.00010686920871,
          0.07312659260676,
          84.29129075
        ],
        [
          0.00009091244469,
          0.0786333418473,
          81.36253285
        ],
        [
          0.00010635225214,
          0.07314984921806,
          84.33497955
        ],
        [
          0.00009124501809,
          0.07862628655009,
          81.32233068
        ],
        [
          0.00012242519035,
          0.06851546058699,
          87.0369418
        ],
        [
          0.00009091244469,
          0.0786333418473,
          81.36253285
        ],
        [
          0.00013805275968,
          0.06625613571893,
          87.69204489
        ],
        [
          0.0000918746748,
          0.07849843283764,
          81.34662666
        ],
        [
          0.00011925751953,
          0.07138696815666,
          84.47591905
        ],
        [
          0.00009153944424,
          0.07850555054086,
          81.38688902
        ],
        [
          0.00015040029643,
          0.0656404271004,
          87.07185741
        ],
        [
          0.0000918746748,
          0.07849843283764,
          81.34662666
        ],
        [
          0.00013611640875,
          0.06681339161562,
          87.2964255
        ],
        [
          0.00009153944424,
          0.07850555054086,
          81.38688902
        ],
        [
          0.00016106825512,
          0.06187174842479,
          90.31951779
        ],
        [
          0.00009112309931,
          0.0785301040491,
          81.42336993
        ],
        [
          0.00011717368232,
          0.07072338528459,
          85.38545928
        ],
        [
          0.00009078707528,
          0.07853772529038,
          81.46366359
        ],
        [
          0.00014477857822,
          0.06524842753093,
          88.08541526
        ],
        [
          0.00009112309931,
          0.0785301040491,
          81.42336993
        ],
        [
          0.00012999165524,
          0.06652999543882,
          88.29460839
        ],
        [
          0.00009078707528,
          0.07853772529038,
          81.46366359
        ],
        [
          0.00015098328293,
          0.06181117099769,
          91.43452654
        ],
        [
          0.0000918746748,
          0.07849843283764,
          81.34662666
        ],
        [
          0.0001419051113,
          0.06762031410235,
          85.81763156
        ],
        [
          0.00009153944424,
          0.07850555054086,
          81.38688902
        ],
        [
          0.00017305652374,
          0.06228702436357,
          88.67621476
        ],
        [
          0.0000918746748,
          0.07849843283764,
          81.34662666
        ],
        [
          0.00015645210025,
          0.06348855437802,
          88.88060264
        ],
        [
          0.00009153944424,
          0.07850555054086,
          81.38688902
        ],
        [
          0.00020138349049,
          0.05664622345259,
          93.17430508
        ],
        [
          0.00009112309931,
          0.0785301040491,
          81.42336993
        ],
        [
          0.00013802889236,
          0.0670922016769,
          86.78819096
        ],
        [
          0.00009078707528,
          0.07853772529038,
          81.46366359
        ],
        [
          0.00016519988929,
          0.06199686456698,
          89.76271501
        ],
        [
          0.00009112309931,
          0.0785301040491,
          81.42336993
        ],
        [
          0.00014815531976,
          0.06330712378365,
          89.94800741
        ],
        [
          0.00009078707528,
          0.07853772529038,
          81.46366359
        ],
        [
          0.00018770030132,
          0.05662209669201,
          94.4430976
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00010782757419,
          0.0739105442956,
          83.42066789
        ],
        [
          0.00009176678057,
          0.07858962158115,
          81.28191344
        ],
        [
          0.00010743995483,
          0.07391910969332,
          83.46118302
        ],
        [
          0.00009203080202,
          0.07859098496928,
          81.24422944
        ],
        [
          0.00012710156453,
          0.06890955795714,
          86.07961522
        ],
        [
          0.00009176678057,
          0.07858962158115,
          81.28191344
        ],
        [
          0.00012648641819,
          0.06893533226447,
          86.12303327
        ],
        [
          0.0000912860244,
          0.078621475684,
          81.32082458
        ],
        [
          0.00010696053634,
          0.07311740175347,
          84.28851263
        ],
        [
          0.00009102087299,
          0.07862058002854,
          81.35854312
        ],
        [
          0.00010652656772,
          0.07313222671044,
          84.32966716
        ],
        [
          0.0000912860244,
          0.078621475684,
          81.32082458
        ],
        [
          0.00012253996419,
          0.06850518705028,
          87.03416763
        ],
        [
          0.00009102087299,
          0.07862058002854,
          81.35854312
        ],
        [
          0.00012188039824,
          0.06853800385946,
          87.0780069
        ],
        [
          0.00009203080202,
          0.07859098496928,
          81.24422944
        ],
        [
          0.00010782757419,
          0.0739105442956,
          83.42066789
        ],
        [
          0.00009176678057,
          0.07858962158115,
          81.28191344
        ],
        [
          0.00010743995483,
          0.07391910969332,
          83.46118302
        ],
        [
          0.00009203080202,
          0.07859098496928,
          81.24422944
        ],
        [
          0.00012710156453,
          0.06890955795714,
          86.07961522
        ],
        [
          0.00009176678057,
          0.07858962158115,
          81.28191344
        ],
        [
          0.00014371674869,
          0.06661796766638,
          86.69552793
        ],
        [
          0.0000912860244,
          0.078621475684,
          81.32082458
        ],
        [
          0.00010696053634,
          0.07311740175347,
          84.28851263
        ],
        [
          0.00009102087299,
          0.07862058002854,
          81.35854312
        ],
        [
          0.00010652656772,
          0.07313222671044,
          84.32966716
        ],
        [
          0.0000912860244,
          0.078621475684,
          81.32082458
        ],
        [
          0.00012253996419,
          0.06850518705028,
          87.03416763
        ],
        [
          0.00009102087299,
          0.07862058002854,
          81.35854312
        ],
        [
          0.00013829896661,
          0.06623656542376,
          87.68668737
        ],
        [
          0.00009191593813,
          0.07849362545636,
          81.34511897
        ],
        [
          0.00011936142401,
          0.07137761461783,
          84.47298595
        ],
        [
          0.00009164855302,
          0.07849279775957,
          81.38289508
        ],
        [
          0.00015065792722,
          0.06562179996,
          87.06626724
        ],
        [
          0.00009191593813,
          0.07849362545636,
          81.34511897
        ],
        [
          0.00013624685574,
          0.06680289246032,
          87.29350294
        ],
        [
          0.00009164855302,
          0.07849279775957,
          81.38289508
        ],
        [
          0.00016137924309,
          0.06185029916591,
          90.31418485
        ],
        [
          0.00009116415322,
          0.07852528095702,
          81.42186364
        ],
        [
          0.00011729348905,
          0.07071235041117,
          85.38216479
        ],
        [
          0.00009089562751,
          0.07852493065031,
          81.45967341
        ],
        [
          0.00014505639127,
          0.06522744054069,
          88.07954437
        ],
        [
          0.00009116415322,
          0.07852528095702,
          81.42186364
        ],
        [
          0.00013013940445,
          0.06651748000969,
          88.29137127
        ],
        [
          0.00009089562751,
          0.07852493065031,
          81.45967341
        ],
        [
          0.00015131322578,
          0.06178677770992,
          91.42905324
        ],
        [
          0.00009191593813,
          0.07849362545636,
          81.34511897
        ],
        [
          0.00014202998453,
          0.0676108151099,
          85.81464662
        ],
        [
          0.00009164855302,
          0.07849279775957,
          81.38289508
        ],
        [
          0.00017335986382,
          0.06226781930423,
          88.67061926
        ],
        [
          0.00009191593813,
          0.07849362545636,
          81.34511897
        ],
        [
          0.00015660559673,
          0.06347773038302,
          88.87768814
        ],
        [
          0.00009164855302,
          0.07849279775957,
          81.38289508
        ],
        [
          0.00020178418636,
          0.05662388800707,
          93.1692038
        ],
        [
          0.00009116415322,
          0.07852528095702,
          81.42186364
        ],
        [
          0.00013817219347,
          0.06708092768329,
          86.78485633
        ],
        [
          0.00009089562751,
          0.07852493065031,
          81.45967341
        ],
        [
          0.0001655256537,
          0.06197513366114,
          89.75688921
        ],
        [
          0.00009116415322,
          0.07852528095702,
          81.42186364
        ],
        [
          0.00014832851428,
          0.06329416004659,
          89.9448091
        ],
        [
          0.00009089562751,
          0.07852493065031,
          81.45967341
        ],
        [
          0.00018812563024,
          0.0565965338265,
          94.43801201
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00010786332629,
          0.07390699302382,
          83.41955142
        ],
        [
          0.00009182543314,
          0.07858278124642,
          81.27976577
        ],
        [
          0.00010752498372,
          0.07391063426025,
          83.45852448
        ],
        [
          0.00009204832306,
          0.07858894691772,
          81.24358874
        ],
        [
          0.00012714725963,
          0.06890563703615,
          86.07848706
        ],
        [
          0.00009182543314,
          0.07858278124642,
          81.27976577
        ],
        [
          0.0001265950204,
          0.0689259692007,
          86.1203482
        ],
        [
          0.00009130345735,
          0.07861943107077,
          81.32018446
        ],
        [
          0.00010700741184,
          0.07311268731722,
          84.2870874
        ],
        [
          0.00009107922929,
          0.07861371757869,
          81.35639742
        ],
        [
          0.00010662384597,
          0.07312240437229,
          84.32670537
        ],
        [
          0.00009130345735,
          0.07861943107077,
          81.32018446
        ],
        [
          0.00012259887566,
          0.06849991743063,
          87.0327444
        ],
        [
          0.00009107922929,
          0.07861371757869,
          81.35639742
        ],
        [
          0.00012200255888,
          0.06852701897683,
          87.07505088
        ],
        [
          0.00009204832306,
          0.07858894691772,
          81.24358874
        ],
        [
          0.00010786332629,
          0.07390699302382,
          83.41955142
        ],
        [
          0.00009182543314,
          0.07858278124642,
          81.27976577
        ],
        [
          0.00010752498372,
          0.07391063426025,
          83.45852448
        ],
        [
          0.00009204832306,
          0.07858894691772,
          81.24358874
        ],
        [
          0.00012714725963,
          0.06890563703615,
          86.07848706
        ],
        [
          0.00009182543314,
          0.07858278124642,
          81.27976577
        ],
        [
          0.00014383882526,
          0.06660869323239,
          86.69280798
        ],
        [
          0.00009130345735,
          0.07861943107077,
          81.32018446
        ],
        [
          0.00010700741184,
          0.07311268731722,
          84.2870874
        ],
        [
          0.00009107922929,
          0.07861371757869,
          81.35639742
        ],
        [
          0.00010662384597,
          0.07312240437229,
          84.32670537
        ],
        [
          0.00009130345735,
          0.07861943107077,
          81.32018446
        ],
        [
          0.00012259887566,
          0.06849991743063,
          87.0327444
        ],
        [
          0.00009107922929,
          0.07861371757869,
          81.35639742
        ],
        [
          0.00013843636849,
          0.0662256583901,
          87.68370029
        ],
        [
          0.00009193348034,
          0.07849158232441,
          81.34447817
        ],
        [
          0.00011941191599,
          0.07137307213155,
          84.4715613
        ],
        [
          0.00009170727548,
          0.07848594017603,
          81.38074712
        ],
        [
          0.00015079770745,
          0.06561170650691,
          87.06323695
        ],
        [
          0.00009193348034,
          0.07849158232441,
          81.34447817
        ],
        [
          0.00013631024795,
          0.06679779378779,
          87.29208338
        ],
        [
          0.00009170727548,
          0.07848594017603,
          81.38074712
        ],
        [
          0.00016154798992,
          0.0618386772148,
          90.31129385
        ],
        [
          0.00009118160643,
          0.0785232311464,
          81.42122344
        ],
        [
          0.00011735641207,
          0.07070655919832,
          85.38043548
        ],
        [
          0.0000909540506,
          0.07851805055727,
          81.45752746
        ],
        [
          0.00014521225705,
          0.065215682904,
          88.07625386
        ],
        [
          0.00009118160643,
          0.0785232311464,
          81.42122344
        ],
        [
          0.00013021700678,
          0.06651091203484,
          88.28967204
        ],
        [
          0.0000909540506,
          0.07851805055727,
          81.45752746
        ],
        [
          0.00015149836353,
          0.06177311266324,
          91.42598538
        ],
        [
          0.00009193348034,
          0.07849158232441,
          81.34447817
        ],
        [
          0.00014209066544,
          0.06760620208277,
          85.81319679
        ],
        [
          0.00009170727548,
          0.07848594017603,
          81.38074712
        ],
        [
          0.00017352444342,
          0.06225741306207,
          88.66758602
        ],
        [
          0.00009193348034,
          0.07849158232441,
          81.34447817
        ],
        [
          0.00015668019002,
          0.06347247405381,
          88.87627248
        ],
        [
          0.00009170727548,
          0.07848594017603,
          81.38074712
        ],
        [
          0.00020200160674,
          0.05661178659785,
          93.16643823
        ],
        [
          0.00009118160643,
          0.0785232311464,
          81.42122344
        ],
        [
          0.00013824745514,
          0.06707501111445,
          86.78310595
        ],
        [
          0.0000909540506,
          0.07851805055727,
          81.45752746
        ],
        [
          0.00016570842282,
          0.06196295972528,
          89.75362389
        ],
        [
          0.00009118160643,
          0.0785232311464,
          81.42122344
        ],
        [
          0.0001484194815,
          0.0632873569507,
          89.94313022
        ],
        [
          0.0000909540506,
          0.07851805055727,
          81.45752746
        ],
        [
          0.00018836428912,
          0.05658221455255,
          94.43516127
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00010789229828,
          0.0739041160509,
          83.41864689
        ],
        [
          0.00009186352481,
          0.07857834104329,
          81.27837157
        ],
        [
          0.00010758353625,
          0.07390480165048,
          83.45669469
        ],
        [
          0.00009206172364,
          0.07858738840632,
          81.24309878
        ],
        [
          0.00012718428938,
          0.06890246065563,
          86.07757305
        ],
        [
          0.00009186352481,
          0.07857834104329,
          81.27837157
        ],
        [
          0.00012666980761,
          0.06891952598651,
          86.11850011
        ],
        [
          0.00009131679055,
          0.07861786754476,
          81.31969494
        ],
        [
          0.00010704808654,
          0.07310859812543,
          84.28585108
        ],
        [
          0.00009111712864,
          0.07860926301792,
          81.3550045
        ],
        [
          0.00010669477209,
          0.07311524827857,
          84.32454719
        ],
        [
          0.00009131679055,
          0.07861786754476,
          81.31969494
        ],
        [
          0.00012264999518,
          0.0684953467835,
          87.03150981
        ],
        [
          0.00009111712864,
          0.07860926301792,
          81.3550045
        ],
        [
          0.00012209163025,
          0.06851901623796,
          87.07289685
        ],
        [
          0.00009206172364,
          0.07858738840632,
          81.24309878
        ],
        [
          0.00010789229828,
          0.0739041160509,
          83.41864689
        ],
        [
          0.00009186352481,
          0.07857834104329,
          81.27837157
        ],
        [
          0.00010758353625,
          0.07390480165048,
          83.45669469
        ],
        [
          0.00009206172364,
          0.07858738840632,
          81.24309878
        ],
        [
          0.00012718428938,
          0.06890246065563,
          86.07757305
        ],
        [
          0.00009186352481,
          0.07857834104329,
          81.27837157
        ],
        [
          0.0001439228899,
          0.06660231107933,
          86.69093588
        ],
        [
          0.00009131679055,
          0.07861786754476,
          81.31969494
        ],
        [
          0.00010704808654,
          0.07310859812543,
          84.28585108
        ],
        [
          0.00009111712864,
          0.07860926301792,
          81.3550045
        ],
        [
          0.00010669477209,
          0.07311524827857,
          84.32454719
        ],
        [
          0.00009131679055,
          0.07861786754476,
          81.31969494
        ],
        [
          0.00012264999518,
          0.0684953467835,
          87.03150981
        ],
        [
          0.00009111712864,
          0.07860926301792,
          81.3550045
        ],
        [
          0.00013853655081,
          0.06621771246787,
          87.68152363
        ],
        [
          0.00009195262559,
          0.07848935291204,
          81.34377892
        ],
        [
          0.00011946250537,
          0.07136852273704,
          84.47013434
        ],
        [
          0.00009175113445,
          0.0784808210697,
          81.37914355
        ],
        [
          0.00015090843823,
          0.06560371712187,
          87.06083778
        ],
        [
          0.00009195262559,
          0.07848935291204,
          81.34377892
        ],
        [
          0.00013637376375,
          0.06679268747397,
          87.2906615
        ],
        [
          0.00009175113445,
          0.0784808210697,
          81.37914355
        ],
        [
          0.00016168167592,
          0.06182947831959,
          90.30900487
        ],
        [
          0.00009120065229,
          0.07852099486641,
          81.42052479
        ],
        [
          0.0001174202632,
          0.07070068562463,
          85.37868137
        ],
        [
          0.00009099768605,
          0.07851291464838,
          81.4559254
        ],
        [
          0.00014533993354,
          0.06520606080147,
          88.07356023
        ],
        [
          0.00009120065229,
          0.07852099486641,
          81.42052479
        ],
        [
          0.00013029575645,
          0.0665042508245,
          88.28794839
        ],
        [
          0.00009099768605,
          0.07851291464838,
          81.4559254
        ],
        [
          0.00015165003118,
          0.06176193008517,
          91.42347392
        ],
        [
          0.00009195262559,
          0.07848935291204,
          81.34377892
        ],
        [
          0.00014215146295,
          0.06760158209938,
          85.8117446
        ],
        [
          0.00009175113445,
          0.0784808210697,
          81.37914355
        ],
        [
          0.00017365481934,
          0.06224917627777,
          88.66518449
        ],
        [
          0.00009195262559,
          0.07848935291204,
          81.34377892
        ],
        [
          0.00015675492866,
          0.0634672099132,
          88.8748545
        ],
        [
          0.00009175113445,
          0.0784808210697,
          81.37914355
        ],
        [
          0.00020217385169,
          0.05660220855506,
          93.1642485
        ],
        [
          0.00009120065229,
          0.07852099486641,
          81.42052479
        ],
        [
          0.00013832382644,
          0.06706901049505,
          86.78133044
        ],
        [
          0.00009099768605,
          0.07851291464838,
          81.4559254
        ],
        [
          0.00016585813718,
          0.0619529971914,
          89.75095084
        ],
        [
          0.00009120065229,
          0.07852099486641,
          81.42052479
        ],
        [
          0.00014851179385,
          0.06328045738286,
          89.94142721
        ],
        [
          0.00009099768605,
          0.07851291464838,
          81.4559254
        ],
        [
          0.00018855980109,
          0.05657049710792,
          94.43282745
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00010790735564,
          0.07390262112019,
          83.41817685
        ],
        [
          0.00009187794177,
          0.07857666097036,
          81.27784401
        ],
        [
          0.0001076158612,
          0.07390158296127,
          83.45568484
        ],
        [
          0.00009206172364,
          0.07858738840632,
          81.24309878
        ],
        [
          0.00012720353465,
          0.06890081016465,
          86.07709809
        ],
        [
          0.00009187794177,
          0.07857666097036,
          81.27784401
        ],
        [
          0.00012671109576,
          0.06891597042435,
          86.11748016
        ],
        [
          0.00009131679055,
          0.07861786754476,
          81.31969494
        ],
        [
          0.00010706350456,
          0.07310704847953,
          84.28538254
        ],
        [
          0.00009113147281,
          0.07860757751156,
          81.35447742
        ],
        [
          0.00010672786193,
          0.07311191124246,
          84.32354068
        ],
        [
          0.00009131679055,
          0.07861786754476,
          81.31969494
        ],
        [
          0.00012266937263,
          0.06849361470777,
          87.03104191
        ],
        [
          0.00009113147281,
          0.07860757751156,
          81.35447742
        ],
        [
          0.00012213318655,
          0.06851528448564,
          87.07189226
        ],
        [
          0.00009206172364,
          0.07858738840632,
          81.24309878
        ],
        [
          0.00010790735564,
          0.07390262112019,
          83.41817685
        ],
        [
          0.00009187794177,
          0.07857666097036,
          81.27784401
        ],
        [
          0.0001076158612,
          0.07390158296127,
          83.45568484
        ],
        [
          0.00009206172364,
          0.07858738840632,
          81.24309878
        ],
        [
          0.00012720353465,
          0.06890081016465,
          86.07709809
        ],
        [
          0.00009187794177,
          0.07857666097036,
          81.27784401
        ],
        [
          0.00014396929937,
          0.06659878923761,
          86.68990268
        ],
        [
          0.00009131679055,
          0.07861786754476,
          81.31969494
        ],
        [
          0.00010706350456,
          0.07310704847953,
          84.28538254
        ],
        [
          0.00009113147281,
          0.07860757751156,
          81.35447742
        ],
        [
          0.00010672786193,
          0.07311191124246,
          84.32354068
        ],
        [
          0.00009131679055,
          0.07861786754476,
          81.31969494
        ],
        [
          0.00012266937263,
          0.06849361470777,
          87.03104191
        ],
        [
          0.00009113147281,
          0.07860757751156,
          81.35447742
        ],
        [
          0.00013858329037,
          0.06621400723945,
          87.68050848
        ],
        [
          0.00009196102797,
          0.07848837461623,
          81.34347207
        ],
        [
          0.00011949749659,
          0.07136537713555,
          84.46914762
        ],
        [
          0.00009177396337,
          0.07847815745729,
          81.37830912
        ],
        [
          0.00015098029613,
          0.06559853550618,
          87.05928149
        ],
        [
          0.00009196102797,
          0.07848837461623,
          81.34347207
        ],
        [
          0.00013641769657,
          0.06678915686936,
          87.28967828
        ],
        [
          0.00009177396337,
          0.07847815745729,
          81.37830912
        ],
        [
          0.00016176843446,
          0.06182351242881,
          90.30752004
        ],
        [
          0.00009120901205,
          0.07852001337179,
          81.42021823
        ],
        [
          0.00011745594114,
          0.07069740500194,
          85.37770152
        ],
        [
          0.00009102039866,
          0.07851024229195,
          81.45509176
        ],
        [
          0.0001454123866,
          0.06520060414623,
          88.07203238
        ],
        [
          0.00009120901205,
          0.07852001337179,
          81.42021823
        ],
        [
          0.00013033976038,
          0.06650053035256,
          88.28698556
        ],
        [
          0.00009102039866,
          0.07851024229195,
          81.45509176
        ],
        [
          0.0001517361039,
          0.0617555886855,
          91.42204935
        ],
        [
          0.00009196102797,
          0.07848837461623,
          81.34347207
        ],
        [
          0.00014219351455,
          0.06759838772931,
          85.81074043
        ],
        [
          0.00009177396337,
          0.07847815745729,
          81.37830912
        ],
        [
          0.00017373942561,
          0.06224383429577,
          88.66362665
        ],
        [
          0.00009196102797,
          0.07848837461623,
          81.34347207
        ],
        [
          0.00015680662411,
          0.06346357021814,
          88.87387397
        ],
        [
          0.00009177396337,
          0.07847815745729,
          81.37830912
        ],
        [
          0.00020228563316,
          0.05659599693645,
          93.16282801
        ],
        [
          0.00009120901205,
          0.07852001337179,
          81.42021823
        ],
        [
          0.00013836650003,
          0.06706565895611,
          86.78033864
        ],
        [
          0.00009102039866,
          0.07851024229195,
          81.45509176
        ],
        [
          0.00016594309629,
          0.06194734757546,
          89.74943465
        ],
        [
          0.00009120901205,
          0.07852001337179,
          81.42021823
        ],
        [
          0.00014856337642,
          0.0632766038294,
          89.94047589
        ],
        [
          0.00009102039866,
          0.07851024229195,
          81.45509176
        ],
        [
          0.00018867075545,
          0.05656385260235,
          94.43150361
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.0001079188292,
          0.07390148213169,
          83.41781873
        ],
        [
          0.00009187794177,
          0.07857666097036,
          81.27784401
        ],
        [
          0.00010762732152,
          0.07390044204652,
          83.45532687
        ],
        [
          0.00009206172364,
          0.07858738840632,
          81.24309878
        ],
        [
          0.00012721819941,
          0.06889955266514,
          86.07673621
        ],
        [
          0.00009187794177,
          0.07857666097036,
          81.27784401
        ],
        [
          0.00012672573394,
          0.06891471011471,
          86.1171186
        ],
        [
          0.00009131679055,
          0.07861786754476,
          81.31969494
        ],
        [
          0.00010707525296,
          0.07310586780725,
          84.28502554
        ],
        [
          0.00009113147281,
          0.07860757751156,
          81.35447742
        ],
        [
          0.0001067395935,
          0.07311072837911,
          84.32318389
        ],
        [
          0.00009131679055,
          0.07861786754476,
          81.31969494
        ],
        [
          0.00012268413816,
          0.06849229505098,
          87.03068542
        ],
        [
          0.00009113147281,
          0.07860757751156,
          81.35447742
        ],
        [
          0.00012214791992,
          0.06851396172557,
          87.07153616
        ],
        [
          0.00009206172364,
          0.07858738840632,
          81.24309878
        ],
        [
          0.0001079188292,
          0.07390148213169,
          83.41781873
        ],
        [
          0.00009187794177,
          0.07857666097036,
          81.27784401
        ],
        [
          0.00010762732152,
          0.07390044204652,
          83.45532687
        ],
        [
          0.00009206172364,
          0.07858738840632,
          81.24309878
        ],
        [
          0.00012721819941,
          0.06889955266514,
          86.07673621
        ],
        [
          0.00009187794177,
          0.07857666097036,
          81.27784401
        ],
        [
          0.00014398575315,
          0.06659754088542,
          86.68953642
        ],
        [
          0.00009131679055,
          0.07861786754476,
          81.31969494
        ],
        [
          0.00010707525296,
          0.07310586780725,
          84.28502554
        ],
        [
          0.00009113147281,
          0.07860757751156,
          81.35447742
        ],
        [
          0.0001067395935,
          0.07311072837911,
          84.32318389
        ],
        [
          0.00009131679055,
          0.07861786754476,
          81.31969494
        ],
        [
          0.00012268413816,
          0.06849229505098,
          87.03068542
        ],
        [
          0.00009113147281,
          0.07860757751156,
          81.35447742
        ],
        [
          0.00013859986133,
          0.06621269388521,
          87.68014863
        ],
        [
          0.00009196752123,
          0.07848761865919,
          81.34323496
        ],
        [
          0.0001195280911,
          0.07136262751152,
          84.46828506
        ],
        [
          0.00009178045006,
          0.07847740072303,
          81.37807206
        ],
        [
          0.00015102073706,
          0.06559562039158,
          87.05840585
        ],
        [
          0.00009196752123,
          0.07848761865919,
          81.34323496
        ],
        [
          0.00013645610969,
          0.06678607074883,
          87.28881877
        ],
        [
          0.00009178045006,
          0.07847740072303,
          81.37807206
        ],
        [
          0.0001618172627,
          0.06182015615225,
          90.30668458
        ],
        [
          0.00009121547238,
          0.07851925494322,
          81.41998134
        ],
        [
          0.00011748713634,
          0.07069453735965,
          85.37684497
        ],
        [
          0.00009102685232,
          0.07850948307205,
          81.45485492
        ],
        [
          0.00014545316306,
          0.06519753430664,
          88.07117273
        ],
        [
          0.00009121547238,
          0.07851925494322,
          81.41998134
        ],
        [
          0.00013037823614,
          0.06649727827692,
          88.28614387
        ],
        [
          0.00009102685232,
          0.07850948307205,
          81.45485492
        ],
        [
          0.00015178454713,
          0.0617520211664,
          91.42124781
        ],
        [
          0.00009196752123,
          0.07848761865919,
          81.34323496
        ],
        [
          0.00014223028211,
          0.06759559549862,
          85.8098626
        ],
        [
          0.00009178045006,
          0.07847740072303,
          81.37807206
        ],
        [
          0.00017378704116,
          0.06224082899051,
          88.66275013
        ],
        [
          0.00009196752123,
          0.07848761865919,
          81.34323496
        ],
        [
          0.00015685182452,
          0.06346038876826,
          88.87301681
        ],
        [
          0.00009178045006,
          0.07847740072303,
          81.37807206
        ],
        [
          0.00020234854419,
          0.05659250247476,
          93.16202875
        ],
        [
          0.00009121547238,
          0.07851925494322,
          81.41998134
        ],
        [
          0.00013840381177,
          0.06706272934933,
          86.77947163
        ],
        [
          0.00009102685232,
          0.07850948307205,
          81.45485492
        ],
        [
          0.00016599091112,
          0.06194416921357,
          89.74858155
        ],
        [
          0.00009121547238,
          0.07851925494322,
          81.41998134
        ],
        [
          0.00014860847878,
          0.06327323545092,
          89.93964426
        ],
        [
          0.00009102685232,
          0.07850948307205,
          81.45485492
        ],
        [
          0.00018873320236,
          0.05656011462835,
          94.43075872
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00010792707651,
          0.07390066348685,
          83.41756132
        ],
        [
          0.00009187794177,
          0.07857666097036,
          81.27784401
        ],
        [
          0.0001076355593,
          0.07389962201863,
          83.45506958
        ],
        [
          0.00009206172364,
          0.07858738840632,
          81.24309878
        ],
        [
          0.00012722874061,
          0.06889864884577,
          86.0764761
        ],
        [
          0.00009187794177,
          0.07857666097036,
          81.27784401
        ],
        [
          0.00012673625605,
          0.06891380427543,
          86.11685873
        ],
        [
          0.00009131679055,
          0.07861786754476,
          81.31969494
        ],
        [
          0.00010709251056,
          0.07310413370518,
          84.2845012
        ],
        [
          0.00009113147281,
          0.07860757751156,
          81.35447742
        ],
        [
          0.00010675682633,
          0.07310899106415,
          84.32265985
        ],
        [
          0.00009131679055,
          0.07861786754476,
          81.31969494
        ],
        [
          0.00012270582786,
          0.06849035683178,
          87.0301618
        ],
        [
          0.00009113147281,
          0.07860757751156,
          81.35447742
        ],
        [
          0.00012216956235,
          0.06851201895044,
          87.07101311
        ],
        [
          0.00009206172364,
          0.07858738840632,
          81.24309878
        ],
        [
          0.00010792707651,
          0.07390066348685,
          83.41756132
        ],
        [
          0.00009187794177,
          0.07857666097036,
          81.27784401
        ],
        [
          0.0001076355593,
          0.07389962201863,
          83.45506958
        ],
        [
          0.00009206172364,
          0.07858738840632,
          81.24309878
        ],
        [
          0.00012722874061,
          0.06889864884577,
          86.0764761
        ],
        [
          0.00009187794177,
          0.07857666097036,
          81.27784401
        ],
        [
          0.0001439975803,
          0.06659664364144,
          86.68927317
        ],
        [
          0.00009131679055,
          0.07861786754476,
          81.31969494
        ],
        [
          0.00010709251056,
          0.07310413370518,
          84.2845012
        ],
        [
          0.00009113147281,
          0.07860757751156,
          81.35447742
        ],
        [
          0.00010675682633,
          0.07310899106415,
          84.32265985
        ],
        [
          0.00009131679055,
          0.07861786754476,
          81.31969494
        ],
        [
          0.00012270582786,
          0.06849035683178,
          87.0301618
        ],
        [
          0.00009113147281,
          0.07860757751156,
          81.35447742
        ],
        [
          0.000138624203,
          0.06621076492787,
          87.67962008
        ],
        [
          0.00009197554291,
          0.07848668483113,
          81.34294206
        ],
        [
          0.00011955712788,
          0.07136001851219,
          84.46746656
        ],
        [
          0.00009178846365,
          0.07847646593339,
          81.37777921
        ],
        [
          0.00015105911886,
          0.06559285440424,
          87.05757495
        ],
        [
          0.00009197554291,
          0.07848668483113,
          81.34294206
        ],
        [
          0.00013649256738,
          0.06678314250623,
          87.28800317
        ],
        [
          0.00009178846365,
          0.07847646593339,
          81.37777921
        ],
        [
          0.00016186360571,
          0.06181697160715,
          90.3058918
        ],
        [
          0.00009122345336,
          0.07851831806407,
          81.41968871
        ],
        [
          0.00011752657075,
          0.07069091337107,
          85.37576243
        ],
        [
          0.00009103482507,
          0.07850854521583,
          81.45456235
        ],
        [
          0.00014550470943,
          0.06519365484967,
          88.07008627
        ],
        [
          0.00009122345336,
          0.07851831806407,
          81.41968871
        ],
        [
          0.00013042687495,
          0.06649316851941,
          88.28508009
        ],
        [
          0.00009103482507,
          0.07850854521583,
          81.45456235
        ],
        [
          0.00015184578704,
          0.06174751283289,
          91.42023476
        ],
        [
          0.00009197554291,
          0.07848668483113,
          81.34294206
        ],
        [
          0.00014226517746,
          0.06759294609429,
          85.80902963
        ],
        [
          0.00009178846365,
          0.07847646593339,
          81.37777921
        ],
        [
          0.00017383223223,
          0.06223797744694,
          88.66191839
        ],
        [
          0.00009197554291,
          0.07848668483113,
          81.34294206
        ],
        [
          0.00015689472401,
          0.06345737009115,
          88.87220342
        ],
        [
          0.00009178846365,
          0.07847646593339,
          81.37777921
        ],
        [
          0.00020240825302,
          0.05658918685555,
          93.1612703
        ],
        [
          0.00009122345336,
          0.07851831806407,
          81.41968871
        ],
        [
          0.00013845097804,
          0.06705902708663,
          86.77837587
        ],
        [
          0.00009103482507,
          0.07850854521583,
          81.45456235
        ],
        [
          0.00016605135492,
          0.06194015264381,
          89.74750336
        ],
        [
          0.00009122345336,
          0.07851831806407,
          81.41968871
        ],
        [
          0.00014866549461,
          0.06326897875516,
          89.9385932
        ],
        [
          0.00009103482507,
          0.07850854521583,
          81.45456235
        ],
        [
          0.00018881214498,
          0.05655539095766,
          94.42981727
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00010794177966,
          0.07389920417146,
          83.41710246
        ],
        [
          0.00009187794177,
          0.07857666097036,
          81.27784401
        ],
        [
          0.00010765024548,
          0.07389816023537,
          83.45461091
        ],
        [
          0.00009206172364,
          0.07858738840632,
          81.24309878
        ],
        [
          0.00012724753334,
          0.06889703770711,
          86.07601243
        ],
        [
          0.00009187794177,
          0.07857666097036,
          81.27784401
        ],
        [
          0.00012675501472,
          0.06891218953738,
          86.11639547
        ],
        [
          0.00009131679055,
          0.07861786754476,
          81.31969494
        ],
        [
          0.00010711564702,
          0.07310180929672,
          84.28379834
        ],
        [
          0.00009113147281,
          0.07860757751156,
          81.35447742
        ],
        [
          0.00010677992961,
          0.07310666234682,
          84.32195739
        ],
        [
          0.00009131679055,
          0.07861786754476,
          81.31969494
        ],
        [
          0.00012273490648,
          0.0684877588483,
          87.0294599
        ],
        [
          0.00009113147281,
          0.07860757751156,
          81.35447742
        ],
        [
          0.00012219857763,
          0.06850941485862,
          87.07031198
        ],
        [
          0.00009206172364,
          0.07858738840632,
          81.24309878
        ],
        [
          0.00010794177966,
          0.07389920417146,
          83.41710246
        ],
        [
          0.00009187794177,
          0.07857666097036,
          81.27784401
        ],
        [
          0.00010765024548,
          0.07389816023537,
          83.45461091
        ],
        [
          0.00009206172364,
          0.07858738840632,
          81.24309878
        ],
        [
          0.00012724753334,
          0.06889703770711,
          86.07601243
        ],
        [
          0.00009187794177,
          0.07857666097036,
          81.27784401
        ],
        [
          0.00014401866554,
          0.06659504422781,
          86.68880389
        ],
        [
          0.00009131679055,
          0.07861786754476,
          81.31969494
        ],
        [
          0.00010711564702,
          0.07310180929672,
          84.28379834
        ],
        [
          0.00009113147281,
          0.07860757751156,
          81.35447742
        ],
        [
          0.00010677992961,
          0.07310666234682,
          84.32195739
        ],
        [
          0.00009131679055,
          0.07861786754476,
          81.31969494
        ],
        [
          0.00012273490648,
          0.0684877588483,
          87.0294599
        ],
        [
          0.00009113147281,
          0.07860757751156,
          81.35447742
        ],
        [
          0.00013865683687,
          0.06620817936858,
          87.67891158
        ],
        [
          0.00009198127308,
          0.07848601781266,
          81.34273284
        ],
        [
          0.00011959322107,
          0.07135677633345,
          84.46644936
        ],
        [
          0.00009179418804,
          0.07847579822641,
          81.37757003
        ],
        [
          0.00015110682809,
          0.06558941718352,
          87.05654231
        ],
        [
          0.00009198127308,
          0.07848601781266,
          81.34273284
        ],
        [
          0.00013653788556,
          0.06677950365268,
          87.28698955
        ],
        [
          0.00009179418804,
          0.07847579822641,
          81.37757003
        ],
        [
          0.00016192121212,
          0.06181301430793,
          90.30490654
        ],
        [
          0.00009122915448,
          0.07851764886283,
          81.41947969
        ],
        [
          0.00011757238737,
          0.07068670433508,
          85.37450501
        ],
        [
          0.0000910405203,
          0.07850787531734,
          81.45435336
        ],
        [
          0.00014556459851,
          0.06518914917743,
          88.06882429
        ],
        [
          0.00009122915448,
          0.07851764886283,
          81.41947969
        ],
        [
          0.00013048338696,
          0.06648839537619,
          88.28384446
        ],
        [
          0.0000910405203,
          0.07850787531734,
          81.45435336
        ],
        [
          0.00015191694095,
          0.06174227686348,
          91.41905804
        ],
        [
          0.00009198127308,
          0.07848601781266,
          81.34273284
        ],
        [
          0.00014230855277,
          0.06758965373083,
          85.80799442
        ],
        [
          0.00009179418804,
          0.07847579822641,
          81.37757003
        ],
        [
          0.00017388840544,
          0.06223443393394,
          88.66088471
        ],
        [
          0.00009198127308,
          0.07848601781266,
          81.34273284
        ],
        [
          0.00015694804946,
          0.06345361889226,
          88.87119257
        ],
        [
          0.00009179418804,
          0.07847579822641,
          81.37757003
        ],
        [
          0.00020248247349,
          0.05658506672653,
          93.16032769
        ],
        [
          0.00009122915448,
          0.07851764886283,
          81.41947969
        ],
        [
          0.00013850577768,
          0.06705472718212,
          86.77710309
        ],
        [
          0.0000910405203,
          0.07850787531734,
          81.45435336
        ],
        [
          0.0001661215815,
          0.06193548777164,
          89.74625099
        ],
        [
          0.00009122915448,
          0.07851764886283,
          81.41947969
        ],
        [
          0.00014873173971,
          0.06326403500377,
          89.93737233
        ],
        [
          0.0000910405203,
          0.07850787531734,
          81.45435336
        ],
        [
          0.00018890386724,
          0.05654990499184,
          94.4287237
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00010795648463,
          0.07389774486639,
          83.41664358
        ],
        [
          0.00009187794177,
          0.07857666097036,
          81.27784401
        ],
        [
          0.00010766493349,
          0.07389669846193,
          83.45415224
        ],
        [
          0.00009206172364,
          0.07858738840632,
          81.24309878
        ],
        [
          0.00012726632848,
          0.06889542659195,
          86.07554874
        ],
        [
          0.00009187794177,
          0.07857666097036,
          81.27784401
        ],
        [
          0.00012677377581,
          0.06891057482179,
          86.1159322
        ],
        [
          0.00009131679055,
          0.07861786754476,
          81.31969494
        ],
        [
          0.00010714025742,
          0.0730993373391,
          84.28305082
        ],
        [
          0.00009113147281,
          0.07860757751156,
          81.35447742
        ],
        [
          0.00010680450472,
          0.07310418580671,
          84.3212103
        ],
        [
          0.00009131679055,
          0.07861786754476,
          81.31969494
        ],
        [
          0.00012276583793,
          0.06848499597975,
          87.0287134
        ],
        [
          0.00009113147281,
          0.07860757751156,
          81.35447742
        ],
        [
          0.00012222944171,
          0.06850664549412,
          87.0695663
        ],
        [
          0.00009206172364,
          0.07858738840632,
          81.24309878
        ],
        [
          0.00010795648463,
          0.07389774486639,
          83.41664358
        ],
        [
          0.00009187794177,
          0.07857666097036,
          81.27784401
        ],
        [
          0.00010766493349,
          0.07389669846193,
          83.45415224
        ],
        [
          0.00009206172364,
          0.07858738840632,
          81.24309878
        ],
        [
          0.00012726632848,
          0.06889542659195,
          86.07554874
        ],
        [
          0.00009187794177,
          0.07857666097036,
          81.27784401
        ],
        [
          0.00014403975343,
          0.06659344484052,
          86.6883346
        ],
        [
          0.00009131679055,
          0.07861786754476,
          81.31969494
        ],
        [
          0.00010714025742,
          0.0730993373391,
          84.28305082
        ],
        [
          0.00009113147281,
          0.07860757751156,
          81.35447742
        ],
        [
          0.00010680450472,
          0.07310418580671,
          84.3212103
        ],
        [
          0.00009131679055,
          0.07861786754476,
          81.31969494
        ],
        [
          0.00012276583793,
          0.06848499597975,
          87.0287134
        ],
        [
          0.00009113147281,
          0.07860757751156,
          81.35447742
        ],
        [
          0.00013869154993,
          0.06620542972316,
          87.67815806
        ],
        [
          0.00009198738563,
          0.07848530632544,
          81.34250967
        ],
        [
          0.00011962875068,
          0.07135358569944,
          84.46544826
        ],
        [
          0.00009180029442,
          0.07847508600843,
          81.3773469
        ],
        [
          0.00015115379234,
          0.06558603465992,
          87.05552602
        ],
        [
          0.00009198738563,
          0.07848530632544,
          81.34250967
        ],
        [
          0.00013658249675,
          0.06677592270975,
          87.28599197
        ],
        [
          0.00009180029442,
          0.07847508600843,
          81.3773469
        ],
        [
          0.00016197792033,
          0.06180912004262,
          90.30393685
        ],
        [
          0.00009123523602,
          0.07851693505139,
          81.41925673
        ],
        [
          0.00011761927423,
          0.07068239861543,
          85.37321859
        ],
        [
          0.00009104659559,
          0.07850716075942,
          81.45413044
        ],
        [
          0.00014562588679,
          0.06518454009488,
          88.06753319
        ],
        [
          0.00009123523602,
          0.07851693505139,
          81.41925673
        ],
        [
          0.00013054122044,
          0.06648351268737,
          88.28258032
        ],
        [
          0.00009104659559,
          0.07850716075942,
          81.45413044
        ],
        [
          0.0001519897599,
          0.06173692082655,
          91.41785414
        ],
        [
          0.00009198738563,
          0.07848530632544,
          81.34250967
        ],
        [
          0.00014235125053,
          0.06758641374228,
          85.80697561
        ],
        [
          0.00009180029442,
          0.07847508600843,
          81.3773469
        ],
        [
          0.00017394370144,
          0.06223094684055,
          88.65986739
        ],
        [
          0.00009198738563,
          0.07848530632544,
          81.34250967
        ],
        [
          0.00015700054303,
          0.06344992741766,
          88.8701977
        ],
        [
          0.00009180029442,
          0.07847508600843,
          81.3773469
        ],
        [
          0.00020255553643,
          0.05658101228287,
          93.15939998
        ],
        [
          0.00009123523602,
          0.07851693505139,
          81.41925673
        ],
        [
          0.00013856185709,
          0.06705032856204,
          86.77580096
        ],
        [
          0.00009104659559,
          0.07850716075942,
          81.45413044
        ],
        [
          0.0001661934488,
          0.06193071588928,
          89.7449697
        ],
        [
          0.00009123523602,
          0.07851693505139,
          81.41925673
        ],
        [
          0.00014879953399,
          0.06325897784574,
          89.93612328
        ],
        [
          0.00009104659559,
          0.07850716075942,
          81.45413044
        ],
        [
          0.00018899773569,
          0.05654429332567,
          94.42760485
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00010797190888,
          0.07389621438534,
          83.41616231
        ],
        [
          0.00009187794177,
          0.07857666097036,
          81.27784401
        ],
        [
          0.00010768033994,
          0.07389516539331,
          83.45367118
        ],
        [
          0.00009206172364,
          0.07858738840632,
          81.24309878
        ],
        [
          0.00012728604306,
          0.06889373691034,
          86.07506242
        ],
        [
          0.00009187794177,
          0.07857666097036,
          81.27784401
        ],
        [
          0.00012679345467,
          0.06890888136532,
          86.11544632
        ],
        [
          0.00009131679055,
          0.07861786754476,
          81.31969494
        ],
        [
          0.00010716634268,
          0.07309671783587,
          84.28225865
        ],
        [
          0.00009113147281,
          0.07860757751156,
          81.35447742
        ],
        [
          0.00010683055259,
          0.07310156144774,
          84.32041859
        ],
        [
          0.00009131679055,
          0.07861786754476,
          81.31969494
        ],
        [
          0.00012279862342,
          0.06848206823938,
          87.02792231
        ],
        [
          0.00009113147281,
          0.07860757751156,
          81.35447742
        ],
        [
          0.00012226215581,
          0.06850371087123,
          87.06877607
        ],
        [
          0.00009206172364,
          0.07858738840632,
          81.24309878
        ],
        [
          0.00010797190888,
          0.07389621438534,
          83.41616231
        ],
        [
          0.00009187794177,
          0.07857666097036,
          81.27784401
        ],
        [
          0.00010768033994,
          0.07389516539331,
          83.45367118
        ],
        [
          0.00009206172364,
          0.07858738840632,
          81.24309878
        ],
        [
          0.00012728604306,
          0.06889373691034,
          86.07506242
        ],
        [
          0.00009187794177,
          0.07857666097036,
          81.27784401
        ],
        [
          0.00014406187281,
          0.06659176746441,
          86.6878424
        ],
        [
          0.00009131679055,
          0.07861786754476,
          81.31969494
        ],
        [
          0.00010716634268,
          0.07309671783587,
          84.28225865
        ],
        [
          0.00009113147281,
          0.07860757751156,
          81.35447742
        ],
        [
          0.00010683055259,
          0.07310156144774,
          84.32041859
        ],
        [
          0.00009131679055,
          0.07861786754476,
          81.31969494
        ],
        [
          0.00012279862342,
          0.06848206823938,
          87.02792231
        ],
        [
          0.00009113147281,
          0.07860757751156,
          81.35447742
        ],
        [
          0.00013872834351,
          0.06620251600528,
          87.67735952
        ],
        [
          0.00009199388065,
          0.07848455037049,
          81.34227255
        ],
        [
          0.00011966669249,
          0.07135017945333,
          84.46437944
        ],
        [
          0.00009180678288,
          0.07847432927563,
          81.37710982
        ],
        [
          0.00015120394508,
          0.06558242361359,
          87.05444097
        ],
        [
          0.00009199388065,
          0.07848455037049,
          81.34227255
        ],
        [
          0.00013663013744,
          0.06677209983736,
          87.2849269
        ],
        [
          0.00009180678288,
          0.07847432927563,
          81.37710982
        ],
        [
          0.00016203848011,
          0.06180496273933,
          90.30290155
        ],
        [
          0.00009124169811,
          0.07851617662297,
          81.41901983
        ],
        [
          0.0001176694483,
          0.07067779285712,
          85.37184239
        ],
        [
          0.000091053051,
          0.07850640154141,
          81.45389359
        ],
        [
          0.00014569147223,
          0.06517960992927,
          88.06615197
        ],
        [
          0.00009124169811,
          0.07851617662297,
          81.41901983
        ],
        [
          0.00013060311023,
          0.06647828985669,
          88.28122793
        ],
        [
          0.000091053051,
          0.07850640154141,
          81.45389359
        ],
        [
          0.00015206768753,
          0.0617311917808,
          91.41656619
        ],
        [
          0.00009199388065,
          0.07848455037049,
          81.34227255
        ],
        [
          0.00014239684691,
          0.06758295483848,
          85.80588786
        ],
        [
          0.00009180678288,
          0.07847432927563,
          81.37710982
        ],
        [
          0.00017400275155,
          0.06222722418883,
          88.65878122
        ],
        [
          0.00009199388065,
          0.07848455037049,
          81.34227255
        ],
        [
          0.00015705660131,
          0.06344598658455,
          88.86913551
        ],
        [
          0.00009180678288,
          0.07847432927563,
          81.37710982
        ],
        [
          0.00020263356145,
          0.05657668404328,
          93.15840948
        ],
        [
          0.00009124169811,
          0.07851617662297,
          81.41901983
        ],
        [
          0.00013862186792,
          0.06704562348405,
          86.77440794
        ],
        [
          0.000091053051,
          0.07850640154141,
          81.45389359
        ],
        [
          0.00016627035506,
          0.06192561163889,
          89.74359898
        ],
        [
          0.00009124169811,
          0.07851617662297,
          81.41901983
        ],
        [
          0.00014887208326,
          0.06325356845659,
          89.93478703
        ],
        [
          0.000091053051,
          0.07850640154141,
          81.45389359
        ],
        [
          0.00018909818927,
          0.05653829097026,
          94.42640785
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00010801328102,
          0.07389211024349,
          83.41487168
        ],
        [
          0.00009190163141,
          0.07857390085212,
          81.27697728
        ],
        [
          0.00010772166436,
          0.0738910543127,
          83.45238111
        ],
        [
          0.00009208543685,
          0.0785846310489,
          81.2422319
        ],
        [
          0.00012733892348,
          0.0688892059246,
          86.07375822
        ],
        [
          0.00009190163141,
          0.07857390085212,
          81.27697728
        ],
        [
          0.00012684623932,
          0.06890434025595,
          86.1141433
        ],
        [
          0.00009134038459,
          0.07861510130618,
          81.31882885
        ],
        [
          0.0001072190121,
          0.07309143059784,
          84.2806596
        ],
        [
          0.00009115504288,
          0.07860480846933,
          81.35361148
        ],
        [
          0.00010688314654,
          0.07309626441059,
          84.31882045
        ],
        [
          0.00009134038459,
          0.07861510130618,
          81.31882885
        ],
        [
          0.00012286482256,
          0.06847615896618,
          87.02632542
        ],
        [
          0.00009115504288,
          0.07860480846933,
          81.35361148
        ],
        [
          0.00012232821087,
          0.06849778770455,
          87.06718093
        ],
        [
          0.00009208543685,
          0.0785846310489,
          81.2422319
        ],
        [
          0.00010801328102,
          0.07389211024349,
          83.41487168
        ],
        [
          0.00009190163141,
          0.07857390085212,
          81.27697728
        ],
        [
          0.00010772166436,
          0.0738910543127,
          83.45238111
        ],
        [
          0.00009208543685,
          0.0785846310489,
          81.2422319
        ],
        [
          0.00012733892348,
          0.0688892059246,
          86.07375822
        ],
        [
          0.00009190163141,
          0.07857390085212,
          81.27697728
        ],
        [
          0.0001441212033,
          0.06658726949265,
          86.68652245
        ],
        [
          0.00009134038459,
          0.07861510130618,
          81.31882885
        ],
        [
          0.0001072190121,
          0.07309143059784,
          84.2806596
        ],
        [
          0.00009115504288,
          0.07860480846933,
          81.35361148
        ],
        [
          0.00010688314654,
          0.07309626441059,
          84.31882045
        ],
        [
          0.00009134038459,
          0.07861510130618,
          81.31882885
        ],
        [
          0.00012286482256,
          0.06847615896618,
          87.02632542
        ],
        [
          0.00009115504288,
          0.07860480846933,
          81.35361148
        ],
        [
          0.00013880263503,
          0.06619663506959,
          87.67574759
        ],
        [
          0.0000920218379,
          0.07848129700345,
          81.34125204
        ],
        [
          0.00011973245091,
          0.07134427841544,
          84.46252761
        ],
        [
          0.00009183471192,
          0.07847107256087,
          81.3760895
        ],
        [
          0.0001512908667,
          0.06557616791504,
          87.052561
        ],
        [
          0.0000920218379,
          0.07848129700345,
          81.34125204
        ],
        [
          0.00013671270706,
          0.06676547718727,
          87.28308154
        ],
        [
          0.00009183471192,
          0.07847107256087,
          81.3760895
        ],
        [
          0.00016214344215,
          0.06179776087565,
          90.30110774
        ],
        [
          0.00009126951357,
          0.07851291262355,
          81.41800027
        ],
        [
          0.00011774800573,
          0.0706705854324,
          85.36968854
        ],
        [
          0.00009108083779,
          0.07850313413736,
          81.45287423
        ],
        [
          0.00014579415971,
          0.06517189505359,
          88.06399023
        ],
        [
          0.00009126951357,
          0.07851291262355,
          81.41800027
        ],
        [
          0.00013070001424,
          0.06647011701021,
          88.27911131
        ],
        [
          0.00009108083779,
          0.07850313413736,
          81.45287423
        ],
        [
          0.00015218970555,
          0.06172222702418,
          91.41455038
        ],
        [
          0.0000920218379,
          0.07848129700345,
          81.34125204
        ],
        [
          0.00014247587112,
          0.06757696266105,
          85.80400325
        ],
        [
          0.00009183471192,
          0.07847107256087,
          81.3760895
        ],
        [
          0.00017410509336,
          0.06222077522981,
          88.65689932
        ],
        [
          0.0000920218379,
          0.07848129700345,
          81.34125204
        ],
        [
          0.00015715376004,
          0.06343915966163,
          88.86729513
        ],
        [
          0.00009183471192,
          0.07847107256087,
          81.3760895
        ],
        [
          0.00020276879349,
          0.056569186209,
          93.15669326
        ],
        [
          0.00009126951357,
          0.07851291262355,
          81.41800027
        ],
        [
          0.00013871582609,
          0.06703826075924,
          86.77222774
        ],
        [
          0.00009108083779,
          0.07850313413736,
          81.45287423
        ],
        [
          0.00016639076777,
          0.06191762446487,
          89.74145364
        ],
        [
          0.00009126951357,
          0.07851291262355,
          81.41800027
        ],
        [
          0.00014898567764,
          0.06324510380095,
          89.93269564
        ],
        [
          0.00009108083779,
          0.07850313413736,
          81.45287423
        ],
        [
          0.00018925547767,
          0.05652889877874,
          94.42453435
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00010805994095,
          0.073887483358,
          83.41341654
        ],
        [
          0.00009193150919,
          0.07857042071033,
          81.27588441
        ],
        [
          0.00010776827051,
          0.07388641960464,
          83.45092661
        ],
        [
          0.00009211534435,
          0.07858115438533,
          81.24113883
        ],
        [
          0.00012739856336,
          0.06888409794565,
          86.07228777
        ],
        [
          0.00009193150919,
          0.07857042071033,
          81.27588441
        ],
        [
          0.00012690577125,
          0.06889922086421,
          86.11267418
        ],
        [
          0.00009137014177,
          0.07861161345062,
          81.31773677
        ],
        [
          0.00010727637183,
          0.07308567536139,
          84.27891882
        ],
        [
          0.00009118476986,
          0.07860131707507,
          81.35251961
        ],
        [
          0.00010694042411,
          0.07309049850704,
          84.31708066
        ],
        [
          0.00009137014177,
          0.07861161345062,
          81.31773677
        ],
        [
          0.00012293691861,
          0.06846972680631,
          87.02458696
        ],
        [
          0.00009118476986,
          0.07860131707507,
          81.35251961
        ],
        [
          0.00012240015008,
          0.06849134042315,
          87.06544437
        ],
        [
          0.00009211534435,
          0.07858115438533,
          81.24113883
        ],
        [
          0.00010805994095,
          0.073887483358,
          83.41341654
        ],
        [
          0.00009193150919,
          0.07857042071033,
          81.27588441
        ],
        [
          0.00010776827051,
          0.07388641960464,
          83.45092661
        ],
        [
          0.00009211534435,
          0.07858115438533,
          81.24113883
        ],
        [
          0.00012739856336,
          0.06888409794565,
          86.07228777
        ],
        [
          0.00009193150919,
          0.07857042071033,
          81.27588441
        ],
        [
          0.00014418811706,
          0.06658219876777,
          86.68503423
        ],
        [
          0.00009137014177,
          0.07861161345062,
          81.31773677
        ],
        [
          0.00010727637183,
          0.07308567536139,
          84.27891882
        ],
        [
          0.00009118476986,
          0.07860131707507,
          81.35251961
        ],
        [
          0.00010694042411,
          0.07309049850704,
          84.31708066
        ],
        [
          0.00009137014177,
          0.07861161345062,
          81.31773677
        ],
        [
          0.00012293691861,
          0.06846972680631,
          87.02458696
        ],
        [
          0.00009118476986,
          0.07860131707507,
          81.35251961
        ],
        [
          0.00013888354337,
          0.06619023381002,
          87.67399277
        ],
        [
          0.00009205676731,
          0.07847723361223,
          81.33997737
        ],
        [
          0.00011980843994,
          0.07133746318718,
          84.46038861
        ],
        [
          0.0000918696061,
          0.07846700498657,
          81.37481507
        ],
        [
          0.00015139131138,
          0.06556894329993,
          87.05038946
        ],
        [
          0.00009205676731,
          0.07847723361223,
          81.33997737
        ],
        [
          0.00013680812553,
          0.06675782879165,
          87.28094997
        ],
        [
          0.0000918696061,
          0.07846700498657,
          81.37481507
        ],
        [
          0.00016226473968,
          0.06178944378995,
          90.29903568
        ],
        [
          0.00009130426591,
          0.07850883594769,
          81.41672679
        ],
        [
          0.00011783619308,
          0.07066250000983,
          85.3672719
        ],
        [
          0.00009111555431,
          0.07849905320958,
          81.45160099
        ],
        [
          0.00014590943592,
          0.06516324065065,
          88.0615647
        ],
        [
          0.00009130426591,
          0.07850883594769,
          81.41672679
        ],
        [
          0.00013080880202,
          0.06646094887361,
          88.2767364
        ],
        [
          0.00009111555431,
          0.07849905320958,
          81.45160099
        ],
        [
          0.00015232669117,
          0.06171217086769,
          91.41228851
        ],
        [
          0.00009205676731,
          0.07847723361223,
          81.33997737
        ],
        [
          0.00014256718881,
          0.06757004230275,
          85.80182636
        ],
        [
          0.0000918696061,
          0.07846700498657,
          81.37481507
        ],
        [
          0.00017422335702,
          0.06221332754359,
          88.65472553
        ],
        [
          0.00009205676731,
          0.07847723361223,
          81.33997737
        ],
        [
          0.00015726603771,
          0.06343127548649,
          88.8651693
        ],
        [
          0.0000918696061,
          0.07846700498657,
          81.37481507
        ],
        [
          0.00020292507089,
          0.05656052755644,
          93.15471078
        ],
        [
          0.00009130426591,
          0.07850883594769,
          81.41672679
        ],
        [
          0.0001388213012,
          0.06703000128783,
          86.76978154
        ],
        [
          0.00009111555431,
          0.07849905320958,
          81.45160099
        ],
        [
          0.00016652594226,
          0.06190866478191,
          89.73904648
        ],
        [
          0.00009130426591,
          0.07850883594769,
          81.41672679
        ],
        [
          0.00014911320287,
          0.06323560850887,
          89.930349
        ],
        [
          0.00009111555431,
          0.07849905320958,
          81.45160099
        ],
        [
          0.0001894320594,
          0.05651836350803,
          94.4224321
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00010814769154,
          0.07387878703637,
          83.41068123
        ],
        [
          0.00009199438551,
          0.07856310043094,
          81.27358543
        ],
        [
          0.00010785592001,
          0.07387770858085,
          83.4481925
        ],
        [
          0.00009217828318,
          0.07857384142643,
          81.23883946
        ],
        [
          0.00012751072679,
          0.06887449773927,
          86.06952365
        ],
        [
          0.00009199438551,
          0.07856310043094,
          81.27358543
        ],
        [
          0.00012701773179,
          0.06888959920799,
          86.10991255
        ],
        [
          0.00009143276442,
          0.07860427694313,
          81.31543948
        ],
        [
          0.00010737584076,
          0.0730757020712,
          84.27590174
        ],
        [
          0.00009124732896,
          0.07859397312589,
          81.35022274
        ],
        [
          0.0001070397507,
          0.07308050673258,
          84.31406531
        ],
        [
          0.00009143276442,
          0.07860427694313,
          81.31543948
        ],
        [
          0.00012306194647,
          0.06845858089475,
          87.02157384
        ],
        [
          0.00009124732896,
          0.07859397312589,
          81.35022274
        ],
        [
          0.00012252490615,
          0.06848016830931,
          87.06243455
        ],
        [
          0.00009217828318,
          0.07857384142643,
          81.23883946
        ],
        [
          0.00010814769154,
          0.07387878703637,
          83.41068123
        ],
        [
          0.00009199438551,
          0.07856310043094,
          81.27358543
        ],
        [
          0.00010785592001,
          0.07387770858085,
          83.4481925
        ],
        [
          0.00009217828318,
          0.07857384142643,
          81.23883946
        ],
        [
          0.00012751072679,
          0.06887449773927,
          86.06952365
        ],
        [
          0.00009199438551,
          0.07856310043094,
          81.27358543
        ],
        [
          0.00014431395837,
          0.06657266867919,
          86.68223669
        ],
        [
          0.00009143276442,
          0.07860427694313,
          81.31543948
        ],
        [
          0.00010737584076,
          0.0730757020712,
          84.27590174
        ],
        [
          0.00009124732896,
          0.07859397312589,
          81.35022274
        ],
        [
          0.0001070397507,
          0.07308050673258,
          84.31406531
        ],
        [
          0.00009143276442,
          0.07860427694313,
          81.31543948
        ],
        [
          0.00012306194647,
          0.06845858089475,
          87.02157384
        ],
        [
          0.00009124732896,
          0.07859397312589,
          81.35022274
        ],
        [
          0.00013902385105,
          0.06617914157842,
          87.67095127
        ],
        [
          0.00009212479211,
          0.07846932438961,
          81.33749608
        ],
        [
          0.00011993014659,
          0.07132655634616,
          84.45696479
        ],
        [
          0.00009193756233,
          0.07845908762419,
          81.37233424
        ],
        [
          0.00015155218681,
          0.06555738178071,
          87.0469135
        ],
        [
          0.00009212479211,
          0.07846932438961,
          81.33749608
        ],
        [
          0.00013696095719,
          0.06674558911201,
          87.27753795
        ],
        [
          0.00009193756233,
          0.07845908762419,
          81.37233424
        ],
        [
          0.00016245902661,
          0.06177613452873,
          90.29571882
        ],
        [
          0.00009137194598,
          0.07850090086645,
          81.41424781
        ],
        [
          0.00011797095425,
          0.07065015355487,
          85.36358373
        ],
        [
          0.00009118316464,
          0.0784911098556,
          81.4491225
        ],
        [
          0.00014608570659,
          0.06515001984865,
          88.05785829
        ],
        [
          0.00009137194598,
          0.07850090086645,
          81.41424781
        ],
        [
          0.00013097515944,
          0.06644694328893,
          88.2731073
        ],
        [
          0.00009118316464,
          0.0784911098556,
          81.4491225
        ],
        [
          0.00015253617665,
          0.06169680938497,
          91.40883205
        ],
        [
          0.00009212479211,
          0.07846932438961,
          81.33749608
        ],
        [
          0.00014271344416,
          0.06755896750515,
          85.79834186
        ],
        [
          0.00009193756233,
          0.07845908762419,
          81.37233424
        ],
        [
          0.00017441277135,
          0.06220140932313,
          88.65124591
        ],
        [
          0.00009212479211,
          0.07846932438961,
          81.33749608
        ],
        [
          0.00015744587241,
          0.06341865878723,
          88.86176643
        ],
        [
          0.00009193756233,
          0.07845908762419,
          81.37233424
        ],
        [
          0.00020317538385,
          0.05654667224094,
          93.1515372
        ],
        [
          0.00009137194598,
          0.07850090086645,
          81.41424781
        ],
        [
          0.00013898258151,
          0.06701738358644,
          86.76604357
        ],
        [
          0.00009118316464,
          0.0784911098556,
          81.4491225
        ],
        [
          0.00016673264002,
          0.06189497797267,
          89.73536807
        ],
        [
          0.00009137194598,
          0.07850090086645,
          81.41424781
        ],
        [
          0.00014930821411,
          0.06322110352268,
          89.92676306
        ],
        [
          0.00009118316464,
          0.0784911098556,
          81.4491225
        ],
        [
          0.00018970209577,
          0.05650227086561,
          94.4192194
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00010828723506,
          0.07386497182213,
          83.40633493
        ],
        [
          0.00009209651714,
          0.0785512200498,
          81.26985383
        ],
        [
          0.00010799530299,
          0.0738638700142,
          83.4438481
        ],
        [
          0.00009228051631,
          0.07856197291455,
          81.23510721
        ],
        [
          0.00012768909826,
          0.06885924750446,
          86.06513144
        ],
        [
          0.00009209651714,
          0.0785512200498,
          81.26985383
        ],
        [
          0.000127195781,
          0.0688743149016,
          86.1055243
        ],
        [
          0.00009153448423,
          0.07859237021509,
          81.31171061
        ],
        [
          0.00010753060918,
          0.07306020180161,
          84.27121149
        ],
        [
          0.00009134894563,
          0.07858205432225,
          81.34649455
        ],
        [
          0.00010719429792,
          0.07306497773953,
          84.30937774
        ],
        [
          0.00009153448423,
          0.07859237021509,
          81.31171061
        ],
        [
          0.00012325649402,
          0.06844125923798,
          87.01688959
        ],
        [
          0.00009134894563,
          0.07858205432225,
          81.34649455
        ],
        [
          0.00012271903135,
          0.06846280593022,
          87.05775542
        ],
        [
          0.00009228051631,
          0.07856197291455,
          81.23510721
        ],
        [
          0.00010828723506,
          0.07386497182213,
          83.40633493
        ],
        [
          0.00009209651714,
          0.0785512200498,
          81.26985383
        ],
        [
          0.00010799530299,
          0.0738638700142,
          83.4438481
        ],
        [
          0.00009228051631,
          0.07856197291455,
          81.23510721
        ],
        [
          0.00012768909826,
          0.06885924750446,
          86.06513144
        ],
        [
          0.00009209651714,
          0.0785512200498,
          81.26985383
        ],
        [
          0.00014451407637,
          0.06655753009677,
          86.67779136
        ],
        [
          0.00009153448423,
          0.07859237021509,
          81.31171061
        ],
        [
          0.00010753060918,
          0.07306020180161,
          84.27121149
        ],
        [
          0.00009134894563,
          0.07858205432225,
          81.34649455
        ],
        [
          0.00010719429792,
          0.07306497773953,
          84.30937774
        ],
        [
          0.00009153448423,
          0.07859237021509,
          81.31171061
        ],
        [
          0.00012325649402,
          0.06844125923798,
          87.01688959
        ],
        [
          0.00009134894563,
          0.07858205432225,
          81.34649455
        ],
        [
          0.00013924216873,
          0.06616190367792,
          87.66622286
        ],
        [
          0.00009223142624,
          0.07845693724669,
          81.33360942
        ],
        [
          0.00012010601908,
          0.07131081419765,
          84.45202171
        ],
        [
          0.00009204408905,
          0.07844668773495,
          81.3684483
        ],
        [
          0.00015178465977,
          0.06554069577504,
          87.04189498
        ],
        [
          0.00009223142624,
          0.07845693724669,
          81.33360942
        ],
        [
          0.00013718182026,
          0.06672792439875,
          87.27261172
        ],
        [
          0.00009204408905,
          0.07844668773495,
          81.3684483
        ],
        [
          0.00016273980859,
          0.06175692729436,
          90.29092977
        ],
        [
          0.00009147804002,
          0.07848847322359,
          81.41036476
        ],
        [
          0.00011816356634,
          0.07063253364861,
          85.35831447
        ],
        [
          0.00009128914947,
          0.07847866925511,
          81.4452402
        ],
        [
          0.00014633748982,
          0.06513116213064,
          88.05256932
        ],
        [
          0.00009147804002,
          0.07848847322359,
          81.41036476
        ],
        [
          0.0001312128001,
          0.06642696621109,
          88.2679286
        ],
        [
          0.00009128914947,
          0.07847866925511,
          81.4452402
        ],
        [
          0.00015283544252,
          0.06167489971567,
          91.40389945
        ],
        [
          0.00009223142624,
          0.07845693724669,
          81.33360942
        ],
        [
          0.00014292478591,
          0.06754298357421,
          85.7933111
        ],
        [
          0.00009204408905,
          0.07844668773495,
          81.3684483
        ],
        [
          0.00017468648327,
          0.06218420910889,
          88.64622201
        ],
        [
          0.00009223142624,
          0.07845693724669,
          81.33360942
        ],
        [
          0.00015770575793,
          0.06340045058547,
          88.8568533
        ],
        [
          0.00009204408905,
          0.07844668773495,
          81.3684483
        ],
        [
          0.00020353712873,
          0.05652667811103,
          93.14695478
        ],
        [
          0.00009147804002,
          0.07848847322359,
          81.41036476
        ],
        [
          0.00013921294563,
          0.06699938566621,
          86.76070966
        ],
        [
          0.00009128914947,
          0.07847866925511,
          81.4452402
        ],
        [
          0.00016702788553,
          0.06187545629917,
          89.73011894
        ],
        [
          0.00009147804002,
          0.07848847322359,
          81.41036476
        ],
        [
          0.0001495867878,
          0.06320041492051,
          89.92164582
        ],
        [
          0.00009128914947,
          0.07847866925511,
          81.4452402
        ],
        [
          0.00019008785989,
          0.05647931987478,
          94.41463437
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00010846361216,
          0.07384753438986,
          83.40084748
        ],
        [
          0.00009222252367,
          0.07853657969136,
          81.26525448
        ],
        [
          0.00010817147752,
          0.07384640311063,
          83.43836305
        ],
        [
          0.00009240664789,
          0.07854734718493,
          81.23050706
        ],
        [
          0.00012791456265,
          0.06884000040349,
          86.05958579
        ],
        [
          0.00009222252367,
          0.07853657969136,
          81.26525448
        ],
        [
          0.00012742083875,
          0.06885502479995,
          86.09998365
        ],
        [
          0.00009165998302,
          0.07857769738475,
          81.30711462
        ],
        [
          0.00010772389797,
          0.07304087375257,
          84.26536099
        ],
        [
          0.00009147431729,
          0.07856736661672,
          81.3418994
        ],
        [
          0.00010738731093,
          0.07304561387789,
          84.30353058
        ],
        [
          0.00009165998302,
          0.07857769738475,
          81.30711462
        ],
        [
          0.000123499481,
          0.06841966183865,
          87.01104629
        ],
        [
          0.00009147431729,
          0.07856736661672,
          81.3418994
        ],
        [
          0.0001229614917,
          0.06844115775782,
          87.05191851
        ],
        [
          0.00009240664789,
          0.07854734718493,
          81.23050706
        ],
        [
          0.00010846361216,
          0.07384753438986,
          83.40084748
        ],
        [
          0.00009222252367,
          0.07853657969136,
          81.26525448
        ],
        [
          0.00010817147752,
          0.07384640311063,
          83.43836305
        ],
        [
          0.00009240664789,
          0.07854734718493,
          81.23050706
        ],
        [
          0.00012791456265,
          0.06884000040349,
          86.05958579
        ],
        [
          0.00009222252367,
          0.07853657969136,
          81.26525448
        ],
        [
          0.00014476701962,
          0.06653842438352,
          86.67217861
        ],
        [
          0.00009165998302,
          0.07857769738475,
          81.30711462
        ],
        [
          0.00010772389797,
          0.07304087375257,
          84.26536099
        ],
        [
          0.00009147431729,
          0.07856736661672,
          81.3418994
        ],
        [
          0.00010738731093,
          0.07304561387789,
          84.30353058
        ],
        [
          0.00009165998302,
          0.07857769738475,
          81.30711462
        ],
        [
          0.000123499481,
          0.06841966183865,
          87.01104629
        ],
        [
          0.00009147431729,
          0.07856736661672,
          81.3418994
        ],
        [
          0.00013951483435,
          0.06614041128,
          87.66032443
        ],
        [
          0.00009236201411,
          0.07844178606123,
          81.32885458
        ],
        [
          0.00012032505409,
          0.07129123961828,
          84.44587293
        ],
        [
          0.00009217454551,
          0.07843152096631,
          81.36369433
        ],
        [
          0.00015207418531,
          0.06551994929651,
          87.03565213
        ],
        [
          0.00009236201411,
          0.07844178606123,
          81.32885458
        ],
        [
          0.00013745690936,
          0.06670596111393,
          87.2664836
        ],
        [
          0.00009217454551,
          0.07843152096631,
          81.36369433
        ],
        [
          0.00016308954486,
          0.06173304798542,
          90.28497195
        ],
        [
          0.00009160796702,
          0.07847327249867,
          81.40561434
        ],
        [
          0.000118401098,
          0.0706108426401,
          85.35182495
        ],
        [
          0.00009141894287,
          0.07846345268682,
          81.4404907
        ],
        [
          0.00014664799227,
          0.06510794986563,
          88.04605517
        ],
        [
          0.00009160796702,
          0.07847327249867,
          81.40561434
        ],
        [
          0.0001315058948,
          0.06640237559101,
          88.26155025
        ],
        [
          0.00009141894287,
          0.07846345268682,
          81.4404907
        ],
        [
          0.00015320457034,
          0.06164793246171,
          91.39782379
        ],
        [
          0.00009236201411,
          0.07844178606123,
          81.32885458
        ],
        [
          0.00014318798698,
          0.06752310939036,
          85.78705315
        ],
        [
          0.00009217454551,
          0.07843152096631,
          81.36369433
        ],
        [
          0.00017502736642,
          0.06216282428592,
          88.63997229
        ],
        [
          0.00009236201411,
          0.07844178606123,
          81.32885458
        ],
        [
          0.00015802944904,
          0.06337781261084,
          88.85074129
        ],
        [
          0.00009217454551,
          0.07843152096631,
          81.36369433
        ],
        [
          0.00020398770147,
          0.0565018223884,
          93.14125362
        ],
        [
          0.00009160796702,
          0.07847327249867,
          81.40561434
        ],
        [
          0.00013949702725,
          0.06697723050095,
          86.75414039
        ],
        [
          0.00009141894287,
          0.07846345268682,
          81.4404907
        ],
        [
          0.00016739199327,
          0.06185142739308,
          89.7236537
        ],
        [
          0.00009160796702,
          0.07847327249867,
          81.40561434
        ],
        [
          0.00014993036941,
          0.06317494973287,
          89.91534295
        ],
        [
          0.00009141894287,
          0.07846345268682,
          81.4404907
        ],
        [
          0.00019056367306,
          0.05645107336399,
          94.40898632
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00010870858604,
          0.07382336023968,
          83.39323707
        ],
        [
          0.00009238491921,
          0.07851773941983,
          81.25933432
        ],
        [
          0.00010841617069,
          0.07382218811248,
          83.43075596
        ],
        [
          0.0000925692044,
          0.07852852573261,
          81.22458588
        ],
        [
          0.0001282277341,
          0.06881332040026,
          86.05189426
        ],
        [
          0.00009238491921,
          0.07851773941983,
          81.25933432
        ],
        [
          0.00012773344665,
          0.06882828519293,
          86.09229905
        ],
        [
          0.00009182172481,
          0.07855881531566,
          81.30119879
        ],
        [
          0.00010798828428,
          0.07301449017362,
          84.25737122
        ],
        [
          0.00009163589545,
          0.07854846540994,
          81.33598464
        ],
        [
          0.00010765132089,
          0.07301918142039,
          84.29554536
        ],
        [
          0.00009182172481,
          0.07855881531566,
          81.30119879
        ],
        [
          0.00012383187901,
          0.06839018377686,
          87.00306588
        ],
        [
          0.00009163589545,
          0.07854846540994,
          81.33598464
        ],
        [
          0.00012329317093,
          0.06841161039644,
          87.04394681
        ],
        [
          0.0000925692044,
          0.07852852573261,
          81.22458588
        ],
        [
          0.00010870858604,
          0.07382336023968,
          83.39323707
        ],
        [
          0.00009238491921,
          0.07851773941983,
          81.25933432
        ],
        [
          0.00010841617069,
          0.07382218811248,
          83.43075596
        ],
        [
          0.0000925692044,
          0.07852852573261,
          81.22458588
        ],
        [
          0.0001282277341,
          0.06881332040026,
          86.05189426
        ],
        [
          0.00009238491921,
          0.07851773941983,
          81.25933432
        ],
        [
          0.00014511834255,
          0.06651194123813,
          86.66439394
        ],
        [
          0.00009182172481,
          0.07855881531566,
          81.30119879
        ],
        [
          0.00010798828428,
          0.07301449017362,
          84.25737122
        ],
        [
          0.00009163589545,
          0.07854846540994,
          81.33598464
        ],
        [
          0.00010765132089,
          0.07301918142039,
          84.29554536
        ],
        [
          0.00009182172481,
          0.07855881531566,
          81.30119879
        ],
        [
          0.00012383187901,
          0.06839018377686,
          87.00306588
        ],
        [
          0.00009163589545,
          0.07854846540994,
          81.33598464
        ],
        [
          0.00013988781384,
          0.06611107756335,
          87.65226863
        ],
        [
          0.00009252488435,
          0.07842291791026,
          81.32293184
        ],
        [
          0.00012061685119,
          0.07126521570171,
          84.43769434
        ],
        [
          0.00009233725211,
          0.07841263340902,
          81.35777268
        ],
        [
          0.00015245988797,
          0.06549237036423,
          87.02734799
        ],
        [
          0.00009252488435,
          0.07842291791026,
          81.32293184
        ],
        [
          0.00013782341902,
          0.06667676474958,
          87.25833193
        ],
        [
          0.00009233725211,
          0.07841263340902,
          81.35777268
        ],
        [
          0.00016355553835,
          0.061701307796,
          90.27704624
        ],
        [
          0.00009177001389,
          0.07845434264558,
          81.3996971
        ],
        [
          0.0001187137887,
          0.07058235209618,
          85.34329645
        ],
        [
          0.00009158082333,
          0.07844450310915,
          81.43457461
        ],
        [
          0.00014705673512,
          0.0650774615894,
          88.03749888
        ],
        [
          0.00009177001389,
          0.07845434264558,
          81.3996971
        ],
        [
          0.00013189178537,
          0.06637008015006,
          88.25316722
        ],
        [
          0.00009158082333,
          0.07844450310915,
          81.43457461
        ],
        [
          0.00015369061261,
          0.06161251955617,
          91.38983791
        ],
        [
          0.00009252488435,
          0.07842291791026,
          81.32293184
        ],
        [
          0.000143538608,
          0.06749668893926,
          85.77872916
        ],
        [
          0.00009233725211,
          0.07841263340902,
          81.35777268
        ],
        [
          0.0001754814836,
          0.0621343984769,
          88.63165871
        ],
        [
          0.00009252488435,
          0.07842291791026,
          81.32293184
        ],
        [
          0.00015846071054,
          0.06334772117358,
          88.84261078
        ],
        [
          0.00009233725211,
          0.07841263340902,
          81.35777268
        ],
        [
          0.00020458803483,
          0.05646878760146,
          93.13366865
        ],
        [
          0.00009177001389,
          0.07845434264558,
          81.3996971
        ],
        [
          0.00013987098633,
          0.06694813231577,
          86.74550685
        ],
        [
          0.00009158082333,
          0.07844450310915,
          81.43457461
        ],
        [
          0.00016787132266,
          0.06181987158955,
          89.71515627
        ],
        [
          0.00009177001389,
          0.07845434264558,
          81.3996971
        ],
        [
          0.0001503827347,
          0.06314150785461,
          89.90705879
        ],
        [
          0.00009158082333,
          0.07844450310915,
          81.43457461
        ],
        [
          0.00019119018201,
          0.05641398465313,
          94.40156168
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00010898392547,
          0.0737962518943,
          83.38469884
        ],
        [
          0.00009255276966,
          0.07849829936902,
          81.25322406
        ],
        [
          0.00010869119549,
          0.07379503397575,
          83.42222145
        ],
        [
          0.00009273722096,
          0.07850910509358,
          81.21847456
        ],
        [
          0.0001285797509,
          0.06878340613763,
          86.04326445
        ],
        [
          0.00009255276966,
          0.07849829936902,
          81.25322406
        ],
        [
          0.00012808483173,
          0.06879830410711,
          86.08367701
        ],
        [
          0.00009198890025,
          0.078539332122,
          81.295093
        ],
        [
          0.00010828387051,
          0.07298506651641,
          84.24845592
        ],
        [
          0.00009180290205,
          0.07852896247322,
          81.32987995
        ],
        [
          0.00010794648752,
          0.07298970326443,
          84.28663515
        ],
        [
          0.00009198890025,
          0.078539332122,
          81.295093
        ],
        [
          0.00012420354775,
          0.0683573135352,
          86.99416035
        ],
        [
          0.00009180290205,
          0.07852896247322,
          81.32987995
        ],
        [
          0.00012366403817,
          0.0683786628849,
          87.035051
        ],
        [
          0.00009273722096,
          0.07850910509358,
          81.21847456
        ],
        [
          0.00010898392547,
          0.0737962518943,
          83.38469884
        ],
        [
          0.00009255276966,
          0.07849829936902,
          81.25322406
        ],
        [
          0.00010869119549,
          0.07379503397575,
          83.42222145
        ],
        [
          0.00009273722096,
          0.07850910509358,
          81.21847456
        ],
        [
          0.0001285797509,
          0.06878340613763,
          86.04326445
        ],
        [
          0.00009255276966,
          0.07849829936902,
          81.25322406
        ],
        [
          0.00014551321638,
          0.06648224916364,
          86.65565958
        ],
        [
          0.00009198890025,
          0.078539332122,
          81.295093
        ],
        [
          0.00010828387051,
          0.07298506651641,
          84.24845592
        ],
        [
          0.00009180290205,
          0.07852896247322,
          81.32987995
        ],
        [
          0.00010794648752,
          0.07298970326443,
          84.28663515
        ],
        [
          0.00009198890025,
          0.078539332122,
          81.295093
        ],
        [
          0.00012420354775,
          0.0683573135352,
          86.99416035
        ],
        [
          0.00009180290205,
          0.07852896247322,
          81.32987995
        ],
        [
          0.00014030483416,
          0.06607836967007,
          87.64327885
        ],
        [
          0.0000926985484,
          0.07840283759575,
          81.3166227
        ],
        [
          0.00012095111106,
          0.07123547911847,
          84.42834344
        ],
        [
          0.00009251074567,
          0.07839253180651,
          81.35146475
        ],
        [
          0.00015290171644,
          0.06546086110205,
          87.01785297
        ],
        [
          0.0000926985484,
          0.07840283759575,
          81.3166227
        ],
        [
          0.00013824331628,
          0.06664340770598,
          87.24901106
        ],
        [
          0.00009251074567,
          0.07839253180651,
          81.35146475
        ],
        [
          0.00016408945124,
          0.06166504888561,
          90.26798291
        ],
        [
          0.00009194280924,
          0.07843419522348,
          81.39339393
        ],
        [
          0.00011906992016,
          0.07054999146227,
          85.333603
        ],
        [
          0.0000917534427,
          0.07842433452438,
          81.42827263
        ],
        [
          0.00014752228718,
          0.06504284037138,
          88.02776757
        ],
        [
          0.00009194280924,
          0.07843419522348,
          81.39339393
        ],
        [
          0.00013233136275,
          0.06633340282589,
          88.24363824
        ],
        [
          0.0000917534427,
          0.07842433452438,
          81.42827263
        ],
        [
          0.00015424433844,
          0.06157230705286,
          91.38075943
        ],
        [
          0.0000926985484,
          0.07840283759575,
          81.3166227
        ],
        [
          0.0001439402324,
          0.06746650174587,
          85.76921175
        ],
        [
          0.00009251074567,
          0.07839253180651,
          81.35146475
        ],
        [
          0.00017600167689,
          0.06210192402576,
          88.62215248
        ],
        [
          0.0000926985484,
          0.07840283759575,
          81.3166227
        ],
        [
          0.00015895478864,
          0.06331334402982,
          88.8333137
        ],
        [
          0.00009251074567,
          0.07839253180651,
          81.35146475
        ],
        [
          0.00020527584522,
          0.05643105430983,
          93.12499401
        ],
        [
          0.00009194280924,
          0.07843419522348,
          81.39339393
        ],
        [
          0.00014029688295,
          0.06691508427511,
          86.73569369
        ],
        [
          0.0000917534427,
          0.07842433452438,
          81.42827263
        ],
        [
          0.00016841725921,
          0.06178403689685,
          89.70549696
        ],
        [
          0.00009194280924,
          0.07843419522348,
          81.39339393
        ],
        [
          0.00015089803947,
          0.06310353150851,
          89.89764171
        ],
        [
          0.0000917534427,
          0.07842433452438,
          81.42827263
        ],
        [
          0.00019190392197,
          0.05637187485141,
          94.39312008
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00010932135269,
          0.07376312018466,
          83.37425757
        ],
        [
          0.00009275051774,
          0.07847543961509,
          81.24603681
        ],
        [
          0.0001090282384,
          0.07376184631858,
          83.41178472
        ],
        [
          0.00009293516438,
          0.0784862681609,
          81.21128608
        ],
        [
          0.00012901118372,
          0.06874685091854,
          86.03271037
        ],
        [
          0.00009275051774,
          0.07847543961509,
          81.24603681
        ],
        [
          0.00012851549287,
          0.06876166723546,
          86.07313241
        ],
        [
          0.000092185854,
          0.07851642161967,
          81.287911
        ],
        [
          0.00010864171091,
          0.07294954900864,
          84.23768732
        ],
        [
          0.00009199965722,
          0.07850602876283,
          81.32269925
        ],
        [
          0.00010830382162,
          0.0729541199859,
          84.27587266
        ],
        [
          0.000092185854,
          0.07851642161967,
          81.287911
        ],
        [
          0.00012465355755,
          0.06831764189881,
          86.9834026
        ],
        [
          0.00009199965722,
          0.07850602876283,
          81.32269925
        ],
        [
          0.00012411308061,
          0.06833889799291,
          87.02430497
        ],
        [
          0.00009293516438,
          0.0784862681609,
          81.21128608
        ],
        [
          0.00010932135269,
          0.07376312018466,
          83.37425757
        ],
        [
          0.00009275051774,
          0.07847543961509,
          81.24603681
        ],
        [
          0.0001090282384,
          0.07376184631858,
          83.41178472
        ],
        [
          0.00009293516438,
          0.0784862681609,
          81.21128608
        ],
        [
          0.00012901118372,
          0.06874685091854,
          86.03271037
        ],
        [
          0.00009275051774,
          0.07847543961509,
          81.24603681
        ],
        [
          0.00014599714567,
          0.06644596683226,
          86.64497743
        ],
        [
          0.000092185854,
          0.07851642161967,
          81.287911
        ],
        [
          0.00010864171091,
          0.07294954900864,
          84.23768732
        ],
        [
          0.00009199965722,
          0.07850602876283,
          81.32269925
        ],
        [
          0.00010830382162,
          0.0729541199859,
          84.27587266
        ],
        [
          0.000092185854,
          0.07851642161967,
          81.287911
        ],
        [
          0.00012465355755,
          0.06831764189881,
          86.9834026
        ],
        [
          0.00009199965722,
          0.07850602876283,
          81.32269925
        ],
        [
          0.00014080972037,
          0.06603889593727,
          87.63241914
        ],
        [
          0.00009290112631,
          0.07837945519755,
          81.3092786
        ],
        [
          0.00012135796932,
          0.07119939057151,
          84.4169872
        ],
        [
          0.00009271312075,
          0.07836912537177,
          81.344122
        ],
        [
          0.00015343950279,
          0.06542262721204,
          87.00632084
        ],
        [
          0.00009290112631,
          0.07837945519755,
          81.3092786
        ],
        [
          0.00013875448682,
          0.06660293190729,
          87.2376902
        ],
        [
          0.00009271312075,
          0.07836912537177,
          81.344122
        ],
        [
          0.00016473947889,
          0.06162105833271,
          90.25697366
        ],
        [
          0.00009214436567,
          0.07841073632759,
          81.38605663
        ],
        [
          0.00011949862802,
          0.07051115955102,
          85.32196202
        ],
        [
          0.0000919547929,
          0.07840085119231,
          81.42093675
        ],
        [
          0.00014808273181,
          0.06500130231116,
          88.01608015
        ],
        [
          0.00009214436567,
          0.07841073632759,
          81.38605663
        ],
        [
          0.00013286062977,
          0.06628939809977,
          88.23219356
        ],
        [
          0.0000919547929,
          0.07840085119231,
          81.42093675
        ],
        [
          0.0001549111328,
          0.0615240682905,
          91.3698545
        ],
        [
          0.00009290112631,
          0.07837945519755,
          81.3092786
        ],
        [
          0.00014442905803,
          0.06742986990906,
          85.7576529
        ],
        [
          0.00009271312075,
          0.07836912537177,
          81.344122
        ],
        [
          0.00017663484021,
          0.06206252235645,
          88.61060616
        ],
        [
          0.00009290112631,
          0.07837945519755,
          81.3092786
        ],
        [
          0.00015955626015,
          0.06327163405291,
          88.82202113
        ],
        [
          0.00009271312075,
          0.07836912537177,
          81.344122
        ],
        [
          0.00020611320677,
          0.05638528146917,
          93.11445552
        ],
        [
          0.00009214436567,
          0.07841073632759,
          81.38605663
        ],
        [
          0.00014080955228,
          0.06687543139009,
          86.72390849
        ],
        [
          0.0000919547929,
          0.07840085119231,
          81.42093675
        ],
        [
          0.0001690744747,
          0.06174104684741,
          89.69389534
        ],
        [
          0.00009214436567,
          0.07841073632759,
          81.38605663
        ],
        [
          0.00015151849101,
          0.06305797240485,
          89.88633077
        ],
        [
          0.0000919547929,
          0.07840085119231,
          81.42093675
        ],
        [
          0.00019276338554,
          0.05632136800165,
          94.38297854
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00010971791189,
          0.07372430751068,
          83.36201773
        ],
        [
          0.0000930032676,
          0.07844629306914,
          81.23686482
        ],
        [
          0.00010942434774,
          0.07372296813099,
          83.3995502
        ],
        [
          0.00009318815895,
          0.07845715146305,
          81.20211246
        ],
        [
          0.00012951827517,
          0.0687040359382,
          86.02033713
        ],
        [
          0.0000930032676,
          0.07844629306914,
          81.23686482
        ],
        [
          0.00012902168082,
          0.0687187566315,
          86.06077028
        ],
        [
          0.00009243759528,
          0.07848720943045,
          81.27874576
        ],
        [
          0.00010906327207,
          0.07290785088537,
          84.22503516
        ],
        [
          0.00009225114904,
          0.0784767863289,
          81.31353572
        ],
        [
          0.00010872478863,
          0.07291234466824,
          84.26322769
        ],
        [
          0.00009243759528,
          0.07848720943045,
          81.27874576
        ],
        [
          0.00012518378845,
          0.06827107552319,
          86.97076188
        ],
        [
          0.00009225114904,
          0.0784767863289,
          81.31353572
        ],
        [
          0.00012464217607,
          0.06829222215739,
          87.01167802
        ],
        [
          0.00009318815895,
          0.07845715146305,
          81.20211246
        ],
        [
          0.00010971791189,
          0.07372430751068,
          83.36201773
        ],
        [
          0.0000930032676,
          0.07844629306914,
          81.23686482
        ],
        [
          0.00010942434774,
          0.07372296813099,
          83.3995502
        ],
        [
          0.00009318815895,
          0.07845715146305,
          81.20211246
        ],
        [
          0.00012951827517,
          0.0687040359382,
          86.02033713
        ],
        [
          0.0000930032676,
          0.07844629306914,
          81.23686482
        ],
        [
          0.00014656589235,
          0.06640347388072,
          86.63245386
        ],
        [
          0.00009243759528,
          0.07848720943045,
          81.27874576
        ],
        [
          0.00010906327207,
          0.07290785088537,
          84.22503516
        ],
        [
          0.00009225114904,
          0.0784767863289,
          81.31353572
        ],
        [
          0.00010872478863,
          0.07291234466824,
          84.26322769
        ],
        [
          0.00009243759528,
          0.07848720943045,
          81.27874576
        ],
        [
          0.00012518378845,
          0.06827107552319,
          86.97076188
        ],
        [
          0.00009225114904,
          0.0784767863289,
          81.31353572
        ],
        [
          0.00014140456193,
          0.06599256459329,
          87.61965838
        ],
        [
          0.00009315471387,
          0.07835025331506,
          81.30010327
        ],
        [
          0.00012182963666,
          0.07115769891923,
          84.40385694
        ],
        [
          0.00009296645497,
          0.07833989348023,
          81.33494835
        ],
        [
          0.00015406294874,
          0.06537846531724,
          86.99298608
        ],
        [
          0.00009315471387,
          0.07835025331506,
          81.30010327
        ],
        [
          0.00013934718498,
          0.06655618081314,
          87.22459936
        ],
        [
          0.00009296645497,
          0.07833989348023,
          81.33494835
        ],
        [
          0.00016549325934,
          0.06157025630655,
          90.24424155
        ],
        [
          0.00009239667658,
          0.07838143888931,
          81.3768898
        ],
        [
          0.00011999698809,
          0.07046618705119,
          85.30846779
        ],
        [
          0.0000922068462,
          0.07837152324966,
          81.41177168
        ],
        [
          0.00014873425485,
          0.0649532045996,
          88.00253078
        ],
        [
          0.00009239667658,
          0.07838143888931,
          81.3768898
        ],
        [
          0.00013347603363,
          0.06623844448651,
          88.21892522
        ],
        [
          0.0000922068462,
          0.07837152324966,
          81.41177168
        ],
        [
          0.00015568656657,
          0.06146822212519,
          91.35721011
        ],
        [
          0.00009315471387,
          0.07835025331506,
          81.30010327
        ],
        [
          0.00014499571066,
          0.06738755549582,
          85.74428786
        ],
        [
          0.00009296645497,
          0.07833989348023,
          81.33494835
        ],
        [
          0.00017736884443,
          0.06201701626931,
          88.59725417
        ],
        [
          0.00009315471387,
          0.07835025331506,
          81.30010327
        ],
        [
          0.00016025365498,
          0.06322346237714,
          88.80896223
        ],
        [
          0.00009296645497,
          0.07833989348023,
          81.33494835
        ],
        [
          0.00020708417595,
          0.0563324300358,
          93.10226595
        ],
        [
          0.00009239667658,
          0.07838143888931,
          81.3768898
        ],
        [
          0.0001414054858,
          0.0668295134047,
          86.71024646
        ],
        [
          0.0000922068462,
          0.07837152324966,
          81.41177168
        ],
        [
          0.00016983849705,
          0.06169127318933,
          89.6804445
        ],
        [
          0.00009239667658,
          0.07838143888931,
          81.3768898
        ],
        [
          0.00015223992726,
          0.06300522463534,
          89.87321656
        ],
        [
          0.0000922068462,
          0.07837152324966,
          81.41177168
        ],
        [
          0.00019376285244,
          0.05626290684544,
          94.37121711
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00011016459486,
          0.07368074987261,
          83.34827092
        ],
        [
          0.00009329434742,
          0.07841281503719,
          81.22633054
        ],
        [
          0.0001098705263,
          0.07367933700406,
          83.38580933
        ],
        [
          0.00009347952492,
          0.0784237068313,
          81.19157638
        ],
        [
          0.00013008952878,
          0.06865599726487,
          86.00643903
        ],
        [
          0.00009329434742,
          0.07841281503719,
          81.22633054
        ],
        [
          0.00012959192119,
          0.06867061068149,
          86.04688463
        ],
        [
          0.00009272750974,
          0.07845365698132,
          81.26821916
        ],
        [
          0.00010953113617,
          0.07286175379051,
          84.21103611
        ],
        [
          0.00009254077261,
          0.07844319991272,
          81.30301101
        ],
        [
          0.00010919199625,
          0.07286616226333,
          84.24923657
        ],
        [
          0.00009272750974,
          0.07845365698132,
          81.26821916
        ],
        [
          0.00012577236828,
          0.06821960761523,
          86.95677383
        ],
        [
          0.00009254077261,
          0.07844319991272,
          81.30301101
        ],
        [
          0.00012522950097,
          0.06824063327574,
          86.99770518
        ],
        [
          0.00009347952492,
          0.0784237068313,
          81.19157638
        ],
        [
          0.00011016459486,
          0.07368074987261,
          83.34827092
        ],
        [
          0.00009329434742,
          0.07841281503719,
          81.22633054
        ],
        [
          0.0001098705263,
          0.07367933700406,
          83.38580933
        ],
        [
          0.00009347952492,
          0.0784237068313,
          81.19157638
        ],
        [
          0.00013008952878,
          0.06865599726487,
          86.00643903
        ],
        [
          0.00009329434742,
          0.07841281503719,
          81.22633054
        ],
        [
          0.00014720654133,
          0.0663557996196,
          86.61838663
        ],
        [
          0.00009272750974,
          0.07845365698132,
          81.26821916
        ],
        [
          0.00010953113617,
          0.07286175379051,
          84.21103611
        ],
        [
          0.00009254077261,
          0.07844319991272,
          81.30301101
        ],
        [
          0.00010919199625,
          0.07286616226333,
          84.24923657
        ],
        [
          0.00009272750974,
          0.07845365698132,
          81.26821916
        ],
        [
          0.00012577236828,
          0.06821960761523,
          86.95677383
        ],
        [
          0.00009254077261,
          0.07844319991272,
          81.30301101
        ],
        [
          0.00014206480133,
          0.06594135989231,
          87.60553718
        ],
        [
          0.00009345132814,
          0.07831619249467,
          81.28939645
        ],
        [
          0.00012236546492,
          0.07111052407134,
          84.38898576
        ],
        [
          0.0000932627737,
          0.07830579767629,
          81.32424348
        ],
        [
          0.00015477119465,
          0.06532850593136,
          86.9778818
        ],
        [
          0.00009345132814,
          0.07831619249467,
          81.28939645
        ],
        [
          0.00014002064014,
          0.06650329272458,
          87.20977093
        ],
        [
          0.0000932627737,
          0.07830579767629,
          81.32424348
        ],
        [
          0.00016634984574,
          0.06151279683255,
          90.22981735
        ],
        [
          0.00009269180044,
          0.07834726659451,
          81.36619288
        ],
        [
          0.00012055520561,
          0.07041602624571,
          85.29340102
        ],
        [
          0.00009250166953,
          0.07833731539099,
          81.4010768
        ],
        [
          0.00014946406002,
          0.06489956926523,
          87.98740075
        ],
        [
          0.00009269180044,
          0.07834726659451,
          81.36619288
        ],
        [
          0.00013416553869,
          0.06618162483407,
          88.20410855
        ],
        [
          0.00009250166953,
          0.07833731539099,
          81.4010768
        ],
        [
          0.00015655552261,
          0.0614059594593,
          91.34308789
        ],
        [
          0.00009345132814,
          0.07831619249467,
          81.28939645
        ],
        [
          0.00014565696131,
          0.06733837864257,
          85.72873762
        ],
        [
          0.0000932627737,
          0.07830579767629,
          81.32424348
        ],
        [
          0.00017822542925,
          0.06196414067792,
          88.58171719
        ],
        [
          0.00009345132814,
          0.07831619249467,
          81.28939645
        ],
        [
          0.00016106769189,
          0.06316748998901,
          88.79376581
        ],
        [
          0.0000932627737,
          0.07830579767629,
          81.32424348
        ],
        [
          0.00020821762892,
          0.0562710369301,
          93.08807749
        ],
        [
          0.00009269180044,
          0.07834726659451,
          81.36619288
        ],
        [
          0.00014209082209,
          0.06677693747487,
          86.69458396
        ],
        [
          0.00009250166953,
          0.07833731539099,
          81.4010768
        ],
        [
          0.00017071722623,
          0.06163429407148,
          89.66502193
        ],
        [
          0.00009269180044,
          0.07834726659451,
          81.36619288
        ],
        [
          0.00015306987831,
          0.06294484130113,
          89.8581795
        ],
        [
          0.00009250166953,
          0.07833731539099,
          81.4010768
        ],
        [
          0.00019491280683,
          0.05619600291764,
          94.35772711
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00011067599968,
          0.07363108851855,
          83.33258403
        ],
        [
          0.00009363555107,
          0.07837369834769,
          81.21401571
        ],
        [
          0.00011038135658,
          0.07362959190885,
          83.37012921
        ],
        [
          0.000093821063,
          0.07838462914296,
          81.17925944
        ],
        [
          0.00013074364041,
          0.06860124059474,
          85.99057758
        ],
        [
          0.00009363555107,
          0.07837369834769,
          81.21401571
        ],
        [
          0.0001302448785,
          0.06861573174918,
          86.03103737
        ],
        [
          0.00009306735027,
          0.0784144532584,
          81.25591328
        ],
        [
          0.00011006927741,
          0.07280896602729,
          84.19498949
        ],
        [
          0.00009288027298,
          0.07840395655405,
          81.29070734
        ],
        [
          0.00010972938616,
          0.07281327684449,
          84.23319901
        ],
        [
          0.00009306735027,
          0.0784144532584,
          81.25591328
        ],
        [
          0.00012644949937,
          0.06816068373202,
          86.94073768
        ],
        [
          0.00009288027298,
          0.07840395655405,
          81.29070734
        ],
        [
          0.00012590519544,
          0.06818157089938,
          86.98168643
        ],
        [
          0.000093821063,
          0.07838462914296,
          81.17925944
        ],
        [
          0.00011067599968,
          0.07363108851855,
          83.33258403
        ],
        [
          0.00009363555107,
          0.07837369834769,
          81.21401571
        ],
        [
          0.00011038135658,
          0.07362959190885,
          83.37012921
        ],
        [
          0.000093821063,
          0.07838462914296,
          81.17925944
        ],
        [
          0.00013074364041,
          0.06860124059474,
          85.99057758
        ],
        [
          0.00009363555107,
          0.07837369834769,
          81.21401571
        ],
        [
          0.00014794003455,
          0.06630146230668,
          86.60233185
        ],
        [
          0.00009306735027,
          0.0784144532584,
          81.25591328
        ],
        [
          0.00011006927741,
          0.07280896602729,
          84.19498949
        ],
        [
          0.00009288027298,
          0.07840395655405,
          81.29070734
        ],
        [
          0.00010972938616,
          0.07281327684449,
          84.23319901
        ],
        [
          0.00009306735027,
          0.0784144532584,
          81.25591328
        ],
        [
          0.00012644949937,
          0.06816068373202,
          86.94073768
        ],
        [
          0.00009288027298,
          0.07840395655405,
          81.29070734
        ],
        [
          0.0001428242937,
          0.06588274177371,
          87.58934799
        ],
        [
          0.00009379358152,
          0.07827701841198,
          81.27707591
        ],
        [
          0.00012296230826,
          0.07105821096032,
          84.37247733
        ],
        [
          0.00009360468708,
          0.0782665833813,
          81.31192519
        ],
        [
          0.00015556007883,
          0.06527311813561,
          86.96111276
        ],
        [
          0.00009379358152,
          0.07827701841198,
          81.27707591
        ],
        [
          0.00014077094584,
          0.06644465851944,
          87.19330755
        ],
        [
          0.00009360468708,
          0.0782665833813,
          81.31192519
        ],
        [
          0.00016730430502,
          0.06144910862584,
          90.21380016
        ],
        [
          0.0000930323379,
          0.07830796427241,
          81.35388371
        ],
        [
          0.00012118013041,
          0.07036013614934,
          85.27659369
        ],
        [
          0.00009284186123,
          0.07829797219239,
          81.38876998
        ],
        [
          0.00015028111174,
          0.06483982173384,
          87.97052078
        ],
        [
          0.0000930323379,
          0.07830796427241,
          81.35388371
        ],
        [
          0.00013493767052,
          0.06611833060713,
          88.1875776
        ],
        [
          0.00009284186123,
          0.07829797219239,
          81.38876998
        ],
        [
          0.00015752879774,
          0.06133661788517,
          91.32732885
        ],
        [
          0.00009379358152,
          0.07827701841198,
          81.27707591
        ],
        [
          0.00014637395286,
          0.06728529959704,
          85.71193207
        ],
        [
          0.00009360468708,
          0.0782665833813,
          81.31192519
        ],
        [
          0.00017915427376,
          0.06190708213992,
          88.56492361
        ],
        [
          0.00009379358152,
          0.07827701841198,
          81.27707591
        ],
        [
          0.00016195061146,
          0.06310709024638,
          88.77733975
        ],
        [
          0.00009360468708,
          0.0782665833813,
          81.31192519
        ],
        [
          0.00020944739368,
          0.05620478827715,
          93.07273772
        ],
        [
          0.0000930323379,
          0.07830796427241,
          81.35388371
        ],
        [
          0.0001428380916,
          0.06671988898688,
          86.67756541
        ],
        [
          0.00009284186123,
          0.07829797219239,
          81.38876998
        ],
        [
          0.00017167546964,
          0.06157248178596,
          89.64826147
        ],
        [
          0.0000930323379,
          0.07830796427241,
          81.35388371
        ],
        [
          0.00015397517414,
          0.06287933659099,
          89.8418374
        ],
        [
          0.00009284186123,
          0.07829797219239,
          81.38876998
        ],
        [
          0.00019616733886,
          0.05612344854852,
          94.3430614
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00011118331872,
          0.0735820409563,
          83.3170766
        ],
        [
          0.00009399213525,
          0.07833296299714,
          81.20118405
        ],
        [
          0.00011090333789,
          0.07357898854421,
          83.35416346
        ],
        [
          0.00009416535757,
          0.07834537276113,
          81.16687935
        ],
        [
          0.00013139261615,
          0.06854717496869,
          85.97489561
        ],
        [
          0.00009399213525,
          0.07833296299714,
          81.20118405
        ],
        [
          0.00013091218561,
          0.06855992089422,
          86.01489935
        ],
        [
          0.00009340993739,
          0.07837507027382,
          81.24354428
        ],
        [
          0.00011060642035,
          0.07275652303887,
          84.17903101
        ],
        [
          0.00009323508139,
          0.07836308926158,
          81.27788729
        ],
        [
          0.00011028140686,
          0.07275921022499,
          84.21678584
        ],
        [
          0.00009340993739,
          0.07837507027382,
          81.24354428
        ],
        [
          0.00012712552374,
          0.06810215975087,
          86.92478734
        ],
        [
          0.00009323508139,
          0.07836308926158,
          81.27788729
        ],
        [
          0.00012659944433,
          0.06812120507521,
          86.96529014
        ],
        [
          0.00009416535757,
          0.07834537276113,
          81.16687935
        ],
        [
          0.00011118331872,
          0.0735820409563,
          83.3170766
        ],
        [
          0.00009399213525,
          0.07833296299714,
          81.20118405
        ],
        [
          0.00011090333789,
          0.07357898854421,
          83.35416346
        ],
        [
          0.00009416535757,
          0.07834537276113,
          81.16687935
        ],
        [
          0.00013139261615,
          0.06854717496869,
          85.97489561
        ],
        [
          0.00009399213525,
          0.07833296299714,
          81.20118405
        ],
        [
          0.00014868955291,
          0.06624620660353,
          86.58598218
        ],
        [
          0.00009340993739,
          0.07837507027382,
          81.24354428
        ],
        [
          0.00011060642035,
          0.07275652303887,
          84.17903101
        ],
        [
          0.00009323508139,
          0.07836308926158,
          81.27788729
        ],
        [
          0.00011028140686,
          0.07275921022499,
          84.21678584
        ],
        [
          0.00009340993739,
          0.07837507027382,
          81.24354428
        ],
        [
          0.00012712552374,
          0.06810215975087,
          86.92478734
        ],
        [
          0.00009323508139,
          0.07836308926158,
          81.27788729
        ],
        [
          0.00014360454442,
          0.06582283488836,
          87.57277681
        ],
        [
          0.0000941412584,
          0.07823736255865,
          81.26459687
        ],
        [
          0.0001235717413,
          0.07100504601591,
          84.35568118
        ],
        [
          0.00009396467204,
          0.07822544345213,
          81.2989946
        ],
        [
          0.00015638821187,
          0.06521526633847,
          86.94357115
        ],
        [
          0.0000941412584,
          0.07823736255865,
          81.26459687
        ],
        [
          0.00014153725441,
          0.06638508511406,
          87.17655465
        ],
        [
          0.00009396467204,
          0.07822544345213,
          81.2989946
        ],
        [
          0.00016830663852,
          0.06138260358694,
          90.19704146
        ],
        [
          0.00009337827583,
          0.07826817857177,
          81.34141616
        ],
        [
          0.0001218215218,
          0.07030306155842,
          85.25940871
        ],
        [
          0.00009320003792,
          0.07825669699745,
          81.37585142
        ],
        [
          0.00015114260148,
          0.06477716405005,
          87.95278936
        ],
        [
          0.00009337827583,
          0.07826817857177,
          81.34141616
        ],
        [
          0.00013573039841,
          0.06605371161076,
          88.17067233
        ],
        [
          0.00009320003792,
          0.07825669699745,
          81.37585142
        ],
        [
          0.00015855550309,
          0.06126391752587,
          91.31077102
        ],
        [
          0.0000941412584,
          0.07823736255865,
          81.26459687
        ],
        [
          0.00014710599908,
          0.06723136468703,
          85.69483272
        ],
        [
          0.00009396467204,
          0.07822544345213,
          81.2989946
        ],
        [
          0.00018012930911,
          0.06184749364841,
          88.54735486
        ],
        [
          0.0000941412584,
          0.07823736255865,
          81.26459687
        ],
        [
          0.00016285234857,
          0.06304573157801,
          88.76062345
        ],
        [
          0.00009396467204,
          0.07822544345213,
          81.2989946
        ],
        [
          0.00021073842308,
          0.05613564715499,
          93.05668304
        ],
        [
          0.00009337827583,
          0.07826817857177,
          81.34141616
        ],
        [
          0.00014360499895,
          0.06666164054983,
          86.66016339
        ],
        [
          0.00009320003792,
          0.07825669699745,
          81.37585142
        ],
        [
          0.00017268583113,
          0.06150766831611,
          89.63065391
        ],
        [
          0.00009337827583,
          0.07826817857177,
          81.34141616
        ],
        [
          0.00015490462903,
          0.06281247056443,
          89.82512368
        ],
        [
          0.00009320003792,
          0.07825669699745,
          81.37585142
        ],
        [
          0.00019749068527,
          0.05604739894332,
          94.32764832
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00011173011777,
          0.07352941630167,
          83.30042223
        ],
        [
          0.00009437270571,
          0.07828964934826,
          81.18753212
        ],
        [
          0.00011146234675,
          0.07352504831768,
          83.33712808
        ],
        [
          0.00009453567977,
          0.07830330080505,
          81.1536037
        ],
        [
          0.00013209219463,
          0.06848918206802,
          85.95805156
        ],
        [
          0.00009437270571,
          0.07828964934826,
          81.18753212
        ],
        [
          0.00013162693541,
          0.06850044637202,
          85.99767784
        ],
        [
          0.00009377842761,
          0.07833286259858,
          81.2302805
        ],
        [
          0.00011117896298,
          0.07270089276735,
          84.16208442
        ],
        [
          0.00009361376146,
          0.07831963528324,
          81.26424768
        ],
        [
          0.00011086631391,
          0.07270220579017,
          84.19946168
        ],
        [
          0.00009377842761,
          0.07833286259858,
          81.2302805
        ],
        [
          0.00012784626285,
          0.06804009532704,
          86.90784693
        ],
        [
          0.00009361376146,
          0.07831963528324,
          81.26424768
        ],
        [
          0.00012733522552,
          0.06805757638387,
          86.9479812
        ],
        [
          0.00009453567977,
          0.07830330080505,
          81.1536037
        ],
        [
          0.00011173011777,
          0.07352941630167,
          83.30042223
        ],
        [
          0.00009437270571,
          0.07828964934826,
          81.18753212
        ],
        [
          0.00011146234675,
          0.07352504831768,
          83.33712808
        ],
        [
          0.00009453567977,
          0.07830330080505,
          81.1536037
        ],
        [
          0.00013209219463,
          0.06848918206802,
          85.95805156
        ],
        [
          0.00009437270571,
          0.07828964934826,
          81.18753212
        ],
        [
          0.00014949225317,
          0.06618732848067,
          86.56853443
        ],
        [
          0.00009377842761,
          0.07833286259858,
          81.2302805
        ],
        [
          0.00011117896298,
          0.07270089276735,
          84.16208442
        ],
        [
          0.00009361376146,
          0.07831963528324,
          81.26424768
        ],
        [
          0.00011086631391,
          0.07270220579017,
          84.19946168
        ],
        [
          0.00009377842761,
          0.07833286259858,
          81.2302805
        ],
        [
          0.00012784626285,
          0.06804009532704,
          86.90784693
        ],
        [
          0.00009361376146,
          0.07831963528324,
          81.26424768
        ],
        [
          0.00014443136514,
          0.06575969527797,
          87.5552828
        ],
        [
          0.00009451668144,
          0.07819469814221,
          81.2511632
        ],
        [
          0.00012422878756,
          0.07094800950292,
          84.33764064
        ],
        [
          0.00009435035656,
          0.07818153259192,
          81.28518471
        ],
        [
          0.00015727568994,
          0.06515359697866,
          86.92484198
        ],
        [
          0.00009451668144,
          0.07819469814221,
          81.2511632
        ],
        [
          0.00014236362925,
          0.06632119093055,
          87.15855768
        ],
        [
          0.00009435035656,
          0.07818153259192,
          81.28518471
        ],
        [
          0.0001693812365,
          0.06131172849065,
          90.17914417
        ],
        [
          0.00009375182573,
          0.07822537444285,
          81.32799484
        ],
        [
          0.00012250589956,
          0.07024248038711,
          85.24114411
        ],
        [
          0.00009358379008,
          0.07821264172351,
          81.36205434
        ],
        [
          0.00015205673509,
          0.06471105420422,
          87.93404841
        ],
        [
          0.00009375182573,
          0.07822537444285,
          81.32799484
        ],
        [
          0.00013657653213,
          0.06598514094445,
          88.15270186
        ],
        [
          0.00009358379008,
          0.07821264172351,
          81.36205434
        ],
        [
          0.0001596454987,
          0.06118723246136,
          91.29326611
        ],
        [
          0.00009451668144,
          0.07819469814221,
          81.2511632
        ],
        [
          0.00014789515918,
          0.06717351160055,
          85.67646548
        ],
        [
          0.00009435035656,
          0.07818153259192,
          81.28518471
        ],
        [
          0.00018117419144,
          0.06178398242859,
          88.52859506
        ],
        [
          0.00009451668144,
          0.07819469814221,
          81.2511632
        ],
        [
          0.00016382475102,
          0.06297993223259,
          88.74266421
        ],
        [
          0.00009435035656,
          0.07818153259192,
          81.28518471
        ],
        [
          0.00021212242812,
          0.05606198060573,
          93.03953369
        ],
        [
          0.00009375182573,
          0.07822537444285,
          81.32799484
        ],
        [
          0.00014442324574,
          0.06659982347214,
          86.64166695
        ],
        [
          0.00009358379008,
          0.07821264172351,
          81.36205434
        ],
        [
          0.00017375793363,
          0.0614392944997,
          89.612042
        ],
        [
          0.00009375182573,
          0.07822537444285,
          81.32799484
        ],
        [
          0.00015589671196,
          0.0627415262097,
          89.80735506
        ],
        [
          0.00009358379008,
          0.07821264172351,
          81.36205434
        ],
        [
          0.00019889554251,
          0.05596720234302,
          94.31134919
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00011230224501,
          0.0734746178813,
          83.28306227
        ],
        [
          0.00009475843917,
          0.07824591729928,
          81.1737398
        ],
        [
          0.00011203397286,
          0.07347015836007,
          83.31977488
        ],
        [
          0.00009492169796,
          0.07825961217538,
          81.13980954
        ],
        [
          0.00013282679814,
          0.06842860647461,
          85.94042922
        ],
        [
          0.00009475843917,
          0.07824591729928,
          81.1737398
        ],
        [
          0.00013236043829,
          0.0684397371684,
          85.98007036
        ],
        [
          0.00009416254114,
          0.07828903299685,
          81.21649865
        ],
        [
          0.00011178377737,
          0.07264242521908,
          84.14425324
        ],
        [
          0.00009399758406,
          0.07827576148874,
          81.25046779
        ],
        [
          0.00011147043919,
          0.07264363112709,
          84.18163978
        ],
        [
          0.00009416254114,
          0.07828903299685,
          81.21649865
        ],
        [
          0.00012861034241,
          0.06797466717468,
          86.88996026
        ],
        [
          0.00009399758406,
          0.07827576148874,
          81.25046779
        ],
        [
          0.00012809789769,
          0.06799199640163,
          86.930113
        ],
        [
          0.00009492169796,
          0.07825961217538,
          81.13980954
        ],
        [
          0.00011230224501,
          0.0734746178813,
          83.28306227
        ],
        [
          0.00009475843917,
          0.07824591729928,
          81.1737398
        ],
        [
          0.00011203397286,
          0.07347015836007,
          83.31977488
        ],
        [
          0.00009492169796,
          0.07825961217538,
          81.13980954
        ],
        [
          0.00013282679814,
          0.06842860647461,
          85.94042922
        ],
        [
          0.00009475843917,
          0.07824591729928,
          81.1737398
        ],
        [
          0.00015031589804,
          0.06612723137298,
          86.55069746
        ],
        [
          0.00009416254114,
          0.07828903299685,
          81.21649865
        ],
        [
          0.00011178377737,
          0.07264242521908,
          84.14425324
        ],
        [
          0.00009399758406,
          0.07827576148874,
          81.25046779
        ],
        [
          0.00011147043919,
          0.07264363112709,
          84.18163978
        ],
        [
          0.00009416254114,
          0.07828903299685,
          81.21649865
        ],
        [
          0.00012861034241,
          0.06797466717468,
          86.88996026
        ],
        [
          0.00009399758406,
          0.07827576148874,
          81.25046779
        ],
        [
          0.00014528828796,
          0.06569462510506,
          87.53722306
        ],
        [
          0.0000949057744,
          0.0781506500521,
          81.23728526
        ],
        [
          0.0001249080462,
          0.07088934931986,
          84.3190635
        ],
        [
          0.00009473915733,
          0.07813743947705,
          81.27130877
        ],
        [
          0.00015818965206,
          0.06509043828739,
          86.90562828
        ],
        [
          0.0000949057744,
          0.0781506500521,
          81.23728526
        ],
        [
          0.00014322092441,
          0.066255284275,
          87.13996227
        ],
        [
          0.00009473915733,
          0.07813743947705,
          81.27130877
        ],
        [
          0.00017049189774,
          0.06123893102154,
          90.16072111
        ],
        [
          0.00009413898268,
          0.07818118203781,
          81.31412961
        ],
        [
          0.00012322004433,
          0.07017961112483,
          85.22216368
        ],
        [
          0.00009397064811,
          0.07816840355505,
          81.34819124
        ],
        [
          0.00015300695604,
          0.06464274088386,
          87.91464749
        ],
        [
          0.00009413898268,
          0.07818118203781,
          81.31412961
        ],
        [
          0.00013746255625,
          0.06591377677064,
          88.1339648
        ],
        [
          0.00009397064811,
          0.07816840355505,
          81.34819124
        ],
        [
          0.0001607826347,
          0.06110776901609,
          91.27508395
        ],
        [
          0.0000949057744,
          0.0781506500521,
          81.23728526
        ],
        [
          0.00014871091185,
          0.06711402181389,
          85.65755083
        ],
        [
          0.00009473915733,
          0.07813743947705,
          81.27130877
        ],
        [
          0.00018225022701,
          0.0617189474841,
          88.50934814
        ],
        [
          0.0000949057744,
          0.0781506500521,
          81.23728526
        ],
        [
          0.00016483351879,
          0.06291207081288,
          88.72410609
        ],
        [
          0.00009473915733,
          0.07813743947705,
          81.27130877
        ],
        [
          0.00021355255351,
          0.05598634895149,
          93.02187547
        ],
        [
          0.00009413898268,
          0.07818118203781,
          81.31412961
        ],
        [
          0.00014527701673,
          0.06653568257661,
          86.62244428
        ],
        [
          0.00009397064811,
          0.07816840355505,
          81.34819124
        ],
        [
          0.0001748723581,
          0.06136865319312,
          89.59277262
        ],
        [
          0.00009413898268,
          0.07818118203781,
          81.31412961
        ],
        [
          0.0001569355769,
          0.06266770340739,
          89.78882654
        ],
        [
          0.00009397064811,
          0.07816840355505,
          81.34819124
        ],
        [
          0.00020036108268,
          0.05588412319063,
          94.29441458
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00011292249192,
          0.07341551231009,
          83.26431757
        ],
        [
          0.00009519303339,
          0.07819684814252,
          81.15825403
        ],
        [
          0.00011266655488,
          0.07340972750255,
          83.30064902
        ],
        [
          0.00009534595549,
          0.07821179021491,
          81.12470052
        ],
        [
          0.00013362059064,
          0.06836351114699,
          85.92146563
        ],
        [
          0.00009519303339,
          0.07819684814252,
          81.15825403
        ],
        [
          0.00013316951675,
          0.06837314693454,
          85.96072992
        ],
        [
          0.00009458471116,
          0.07824105668403,
          81.20140307
        ],
        [
          0.00011243209878,
          0.0725800886289,
          84.12521912
        ],
        [
          0.00009443003123,
          0.07822653327924,
          81.23499593
        ],
        [
          0.00011213124384,
          0.07257990945991,
          84.16222813
        ],
        [
          0.00009458471116,
          0.07824105668403,
          81.20140307
        ],
        [
          0.00012942688326,
          0.0679051609756,
          86.87092698
        ],
        [
          0.00009443003123,
          0.07822653327924,
          81.23499593
        ],
        [
          0.00012892958097,
          0.06792091135517,
          86.9107121
        ],
        [
          0.00009534595549,
          0.07821179021491,
          81.12470052
        ],
        [
          0.00011292249192,
          0.07341551231009,
          83.26431757
        ],
        [
          0.00009519303339,
          0.07819684814252,
          81.15825403
        ],
        [
          0.00011266655488,
          0.07340972750255,
          83.30064902
        ],
        [
          0.00009534595549,
          0.07821179021491,
          81.12470052
        ],
        [
          0.00013362059064,
          0.06836351114699,
          85.92146563
        ],
        [
          0.00009519303339,
          0.07819684814252,
          81.15825403
        ],
        [
          0.00015122428615,
          0.06606131958517,
          86.53110202
        ],
        [
          0.00009458471116,
          0.07824105668403,
          81.20140307
        ],
        [
          0.00011243209878,
          0.0725800886289,
          84.12521912
        ],
        [
          0.00009443003123,
          0.07822653327924,
          81.23499593
        ],
        [
          0.00011213124384,
          0.07257990945991,
          84.16222813
        ],
        [
          0.00009458471116,
          0.07824105668403,
          81.20140307
        ],
        [
          0.00012942688326,
          0.0679051609756,
          86.87092698
        ],
        [
          0.00009443003123,
          0.07822653327924,
          81.23499593
        ],
        [
          0.00014622261589,
          0.06562409923027,
          87.51761364
        ],
        [
          0.0000953338843,
          0.07810238306858,
          81.22206802
        ],
        [
          0.00012565203747,
          0.07082545028876,
          84.29880059
        ],
        [
          0.0000951776193,
          0.07808792049467,
          81.25571485
        ],
        [
          0.00015919239957,
          0.06502154914724,
          86.88463397
        ],
        [
          0.0000953338843,
          0.07810238306858,
          81.22206802
        ],
        [
          0.00014415714224,
          0.06618374501327,
          87.11974117
        ],
        [
          0.0000951776193,
          0.07808792049467,
          81.25571485
        ],
        [
          0.0001717071394,
          0.06115980325111,
          90.14064943
        ],
        [
          0.00009456496848,
          0.07813275686665,
          81.29892629
        ],
        [
          0.00012399383776,
          0.07011188603286,
          85.20168751
        ],
        [
          0.00009440692533,
          0.07811872164473,
          81.33261172
        ],
        [
          0.00015403851885,
          0.06456904286387,
          87.89367689
        ],
        [
          0.00009456496848,
          0.07813275686665,
          81.29892629
        ],
        [
          0.00013841992492,
          0.06583716480612,
          88.11381058
        ],
        [
          0.00009440692533,
          0.07811872164473,
          81.33261172
        ],
        [
          0.00016201399515,
          0.06102233212301,
          91.25548585
        ],
        [
          0.0000953338843,
          0.07810238306858,
          81.22206802
        ],
        [
          0.00014962228282,
          0.0670479308622,
          85.63650417
        ],
        [
          0.0000951776193,
          0.07808792049467,
          81.25571485
        ],
        [
          0.0001834540651,
          0.06164662775043,
          88.48790111
        ],
        [
          0.0000953338843,
          0.07810238306858,
          81.22206802
        ],
        [
          0.00016595730378,
          0.06283694416361,
          88.70351824
        ],
        [
          0.0000951776193,
          0.07808792049467,
          81.25571485
        ],
        [
          0.0002151483493,
          0.05590252951579,
          93.00225398
        ],
        [
          0.00009456496848,
          0.07813275686665,
          81.29892629
        ],
        [
          0.00014622033114,
          0.06646523704793,
          86.60129575
        ],
        [
          0.00009440692533,
          0.07811872164473,
          81.33261172
        ],
        [
          0.00017610567761,
          0.06129098168499,
          89.57153816
        ],
        [
          0.00009456496848,
          0.07813275686665,
          81.29892629
        ],
        [
          0.0001580803276,
          0.06258690218243,
          89.76850075
        ],
        [
          0.00009440692533,
          0.07811872164473,
          81.33261172
        ],
        [
          0.00020197814594,
          0.05579313891528,
          94.27580176
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00011359969127,
          0.0733513341793,
          83.24394029
        ],
        [
          0.00009565945384,
          0.07814442208042,
          81.14169686
        ],
        [
          0.00011335618652,
          0.07334421647413,
          83.27989045
        ],
        [
          0.00009580196373,
          0.07816061451959,
          81.10852049
        ],
        [
          0.00013448741378,
          0.06829285262085,
          85.9008471
        ],
        [
          0.00009565945384,
          0.07814442208042,
          81.14169686
        ],
        [
          0.00013405171409,
          0.0683009830747,
          85.93973503
        ],
        [
          0.00009503848246,
          0.07818971575878,
          81.18523741
        ],
        [
          0.00011315685775,
          0.07251081033275,
          84.10403746
        ],
        [
          0.00009489415457,
          0.07817393722554,
          81.21845359
        ],
        [
          0.00011286856114,
          0.07250923445917,
          84.14066923
        ],
        [
          0.00009503848246,
          0.07818971575878,
          81.18523741
        ],
        [
          0.00013033993868,
          0.06782793965663,
          86.84974248
        ],
        [
          0.00009489415457,
          0.07817393722554,
          81.21845359
        ],
        [
          0.00012985781928,
          0.06784209541113,
          86.88916123
        ],
        [
          0.00009580196373,
          0.07816061451959,
          81.10852049
        ],
        [
          0.00011359969127,
          0.0733513341793,
          83.24394029
        ],
        [
          0.00009565945384,
          0.07814442208042,
          81.14169686
        ],
        [
          0.00011335618652,
          0.07334421647413,
          83.27989045
        ],
        [
          0.00009580196373,
          0.07816061451959,
          81.10852049
        ],
        [
          0.00013448741378,
          0.06829285262085,
          85.9008471
        ],
        [
          0.00009565945384,
          0.07814442208042,
          81.14169686
        ],
        [
          0.00015221461034,
          0.0659898979338,
          86.50982979
        ],
        [
          0.00009503848246,
          0.07818971575878,
          81.18523741
        ],
        [
          0.00011315685775,
          0.07251081033275,
          84.10403746
        ],
        [
          0.00009489415457,
          0.07817393722554,
          81.21845359
        ],
        [
          0.00011286856114,
          0.07250923445917,
          84.14066923
        ],
        [
          0.00009503848246,
          0.07818971575878,
          81.18523741
        ],
        [
          0.00013033993868,
          0.06782793965663,
          86.84974248
        ],
        [
          0.00009489415457,
          0.07817393722554,
          81.21845359
        ],
        [
          0.00014726525043,
          0.06554591125747,
          87.49583045
        ],
        [
          0.00009579997011,
          0.07805006845845,
          81.20556275
        ],
        [
          0.0001264855188,
          0.07075429647755,
          84.27620425
        ],
        [
          0.00009565412978,
          0.07803434996823,
          81.23883252
        ],
        [
          0.00016033144526,
          0.06494380391702,
          86.86089374
        ],
        [
          0.00009579997011,
          0.07805006845845,
          81.20556275
        ],
        [
          0.00014520626992,
          0.06610411034321,
          87.09718701
        ],
        [
          0.00009565412978,
          0.07803434996823,
          81.23883252
        ],
        [
          0.00017308823672,
          0.06107053198497,
          90.11794616
        ],
        [
          0.0000950287489,
          0.0780802707494,
          81.28243607
        ],
        [
          0.00012487933158,
          0.07003488270862,
          85.17836849
        ],
        [
          0.00009488106923,
          0.078064974763,
          81.31574494
        ],
        [
          0.00015523451263,
          0.06448419282146,
          87.86948079
        ],
        [
          0.0000950287489,
          0.0780802707494,
          81.28243607
        ],
        [
          0.00013951592524,
          0.06575008607553,
          88.09085321
        ],
        [
          0.00009488106923,
          0.078064974763,
          81.31574494
        ],
        [
          0.00016344250597,
          0.06092399996798,
          91.23286637
        ],
        [
          0.00009579997011,
          0.07805006845845,
          81.20556275
        ],
        [
          0.00015064119786,
          0.06697450017678,
          85.61307904
        ],
        [
          0.00009565412978,
          0.07803434996823,
          81.23883252
        ],
        [
          0.00018481860522,
          0.06156520791856,
          88.4636994
        ],
        [
          0.00009579997011,
          0.07805006845845,
          81.20556275
        ],
        [
          0.00016721419129,
          0.06275350109352,
          88.68059824
        ],
        [
          0.00009565412978,
          0.07803434996823,
          81.23883252
        ],
        [
          0.00021695795085,
          0.05580820502777,
          92.98010207
        ],
        [
          0.0000950287489,
          0.0780802707494,
          81.28243607
        ],
        [
          0.00014729730559,
          0.06638534523544,
          86.577265
        ],
        [
          0.00009488106923,
          0.078064974763,
          81.31574494
        ],
        [
          0.00017753214616,
          0.06120180031591,
          89.54709547
        ],
        [
          0.0000950287489,
          0.0780802707494,
          81.28243607
        ],
        [
          0.00015938793934,
          0.06249529581089,
          89.74539871
        ],
        [
          0.00009488106923,
          0.078064974763,
          81.31574494
        ],
        [
          0.00020385052051,
          0.05568865630727,
          94.25436596
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00011435156239,
          0.07328050802973,
          83.22142319
        ],
        [
          0.00009616188427,
          0.07808821985049,
          81.12393328
        ],
        [
          0.00011410757153,
          0.07327327314169,
          83.25738123
        ],
        [
          0.00009630465345,
          0.07810446780972,
          81.09075517
        ],
        [
          0.00013545432895,
          0.06821455285996,
          85.87795698
        ],
        [
          0.00009616188427,
          0.07808821985049,
          81.12393328
        ],
        [
          0.00013501741969,
          0.06822251280511,
          85.91686314
        ],
        [
          0.00009553871435,
          0.07813338770778,
          81.16748781
        ],
        [
          0.00011395333048,
          0.07243516740467,
          84.08087612
        ],
        [
          0.00009539411876,
          0.07811755269702,
          81.20070589
        ],
        [
          0.00011366431674,
          0.07243345428523,
          84.11751897
        ],
        [
          0.00009553871435,
          0.07813338770778,
          81.16748781
        ],
        [
          0.00013134800878,
          0.06774328832944,
          86.82647218
        ],
        [
          0.00009539411876,
          0.07811755269702,
          81.20070589
        ],
        [
          0.00013086431013,
          0.06775724844695,
          86.86591402
        ],
        [
          0.00009630465345,
          0.07810446780972,
          81.09075517
        ],
        [
          0.00011435156239,
          0.07328050802973,
          83.22142319
        ],
        [
          0.00009616188427,
          0.07808821985049,
          81.12393328
        ],
        [
          0.00011410757153,
          0.07327327314169,
          83.25738123
        ],
        [
          0.00009630465345,
          0.07810446780972,
          81.09075517
        ],
        [
          0.00013545432895,
          0.06821455285996,
          85.87795698
        ],
        [
          0.00009616188427,
          0.07808821985049,
          81.12393328
        ],
        [
          0.00015329848992,
          0.06591224297724,
          86.48665513
        ],
        [
          0.00009553871435,
          0.07813338770778,
          81.16748781
        ],
        [
          0.00011395333048,
          0.07243516740467,
          84.08087612
        ],
        [
          0.00009539411876,
          0.07811755269702,
          81.20070589
        ],
        [
          0.00011366431674,
          0.07243345428523,
          84.11751897
        ],
        [
          0.00009553871435,
          0.07813338770778,
          81.16748781
        ],
        [
          0.00013134800878,
          0.06774328832944,
          86.82647218
        ],
        [
          0.00009539411876,
          0.07811755269702,
          81.20070589
        ],
        [
          0.00014839558534,
          0.06546174969432,
          87.47233183
        ],
        [
          0.00009631270966,
          0.07799279636844,
          81.18747909
        ],
        [
          0.00012740954566,
          0.07067593864862,
          84.25127988
        ],
        [
          0.00009616659828,
          0.07797701965773,
          81.22075084
        ],
        [
          0.00016155336541,
          0.06486099421923,
          86.83555197
        ],
        [
          0.00009631270966,
          0.07799279636844,
          81.18747909
        ],
        [
          0.00014637453191,
          0.06601608546018,
          87.07220133
        ],
        [
          0.00009616659828,
          0.07797701965773,
          81.22075084
        ],
        [
          0.00017457672217,
          0.06097508856256,
          90.09360411
        ],
        [
          0.00009553896095,
          0.07802281081726,
          81.26436887
        ],
        [
          0.00012585198449,
          0.06995090434339,
          85.15289133
        ],
        [
          0.00009539100123,
          0.07800745565572,
          81.29767985
        ],
        [
          0.00015650734851,
          0.06439458320305,
          87.84386644
        ],
        [
          0.00009553896095,
          0.07802281081726,
          81.26436887
        ],
        [
          0.00014072516022,
          0.06565477551685,
          88.06566469
        ],
        [
          0.00009539100123,
          0.07800745565572,
          81.29767985
        ],
        [
          0.00016496991707,
          0.06081977581642,
          91.20881702
        ],
        [
          0.00009631270966,
          0.07799279636844,
          81.18747909
        ],
        [
          0.00015176891396,
          0.06689378615114,
          85.58728029
        ],
        [
          0.00009616659828,
          0.07797701965773,
          81.22075084
        ],
        [
          0.00018628096817,
          0.06147859530841,
          88.43788874
        ],
        [
          0.00009631270966,
          0.07799279636844,
          81.18747909
        ],
        [
          0.00016861153823,
          0.06266144348114,
          88.65524683
        ],
        [
          0.00009616659828,
          0.07797701965773,
          81.22075084
        ],
        [
          0.00021890606223,
          0.05570750833472,
          92.95636983
        ],
        [
          0.00009553896095,
          0.07802281081726,
          81.26436887
        ],
        [
          0.00014847860291,
          0.06629836157258,
          86.55104483
        ],
        [
          0.00009539100123,
          0.07800745565572,
          81.29767985
        ],
        [
          0.00017904906341,
          0.06110772224085,
          89.52123898
        ],
        [
          0.00009553896095,
          0.07802281081726,
          81.26436887
        ],
        [
          0.00016082868023,
          0.06239520166632,
          89.72008505
        ],
        [
          0.00009539100123,
          0.07800745565572,
          81.29767985
        ],
        [
          0.00020585055276,
          0.05557807166561,
          94.23158699
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00011512823082,
          0.07320781362375,
          83.19828038
        ],
        [
          0.00009669002791,
          0.07802944172186,
          81.10534019
        ],
        [
          0.000114913888,
          0.07319764026556,
          83.23335036
        ],
        [
          0.00009680820345,
          0.07804850385001,
          81.07303341
        ],
        [
          0.00013645220313,
          0.06813431073605,
          85.85445319
        ],
        [
          0.00009669002791,
          0.07802944172186,
          81.10534019
        ],
        [
          0.00013605263941,
          0.06813899446726,
          85.89247129
        ],
        [
          0.00009603981079,
          0.07807724293425,
          81.14978169
        ],
        [
          0.00011479157497,
          0.07235610441439,
          84.05662979
        ],
        [
          0.0000959196791,
          0.07805858384857,
          81.18212935
        ],
        [
          0.00011453279612,
          0.07235132862307,
          84.09239022
        ],
        [
          0.00009603981079,
          0.07807724293425,
          81.14978169
        ],
        [
          0.00013240807682,
          0.06765494515662,
          86.80213521
        ],
        [
          0.0000959196791,
          0.07805858384857,
          81.18212935
        ],
        [
          0.00013196174263,
          0.06766545187475,
          86.84070655
        ],
        [
          0.00009680820345,
          0.07804850385001,
          81.07303341
        ],
        [
          0.00011512823082,
          0.07320781362375,
          83.19828038
        ],
        [
          0.00009669002791,
          0.07802944172186,
          81.10534019
        ],
        [
          0.000114913888,
          0.07319764026556,
          83.23335036
        ],
        [
          0.00009680820345,
          0.07804850385001,
          81.07303341
        ],
        [
          0.00013645220313,
          0.06813431073605,
          85.85445319
        ],
        [
          0.00009669002791,
          0.07802944172186,
          81.10534019
        ],
        [
          0.00015446017269,
          0.06582960182399,
          86.46193966
        ],
        [
          0.00009603981079,
          0.07807724293425,
          81.14978169
        ],
        [
          0.00011479157497,
          0.07235610441439,
          84.05662979
        ],
        [
          0.0000959196791,
          0.07805858384857,
          81.18212935
        ],
        [
          0.00011453279612,
          0.07235132862307,
          84.09239022
        ],
        [
          0.00009603981079,
          0.07807724293425,
          81.14978169
        ],
        [
          0.00013240807682,
          0.06765494515662,
          86.80213521
        ],
        [
          0.0000959196791,
          0.07805858384857,
          81.18212935
        ],
        [
          0.00014962783473,
          0.06537070405599,
          87.44685104
        ],
        [
          0.00009682309828,
          0.07793607432093,
          81.16955432
        ],
        [
          0.00012835595828,
          0.07059624773462,
          84.225888
        ],
        [
          0.00009670163224,
          0.07791747435602,
          81.20195463
        ],
        [
          0.00016286937322,
          0.06477248351841,
          86.80840243
        ],
        [
          0.00009682309828,
          0.07793607432093,
          81.16955432
        ],
        [
          0.000147570297,
          0.06592668977912,
          87.04676687
        ],
        [
          0.00009670163224,
          0.07791747435602,
          81.20195463
        ],
        [
          0.0001761788879,
          0.06087323265931,
          90.06754735
        ],
        [
          0.00009604684227,
          0.07796590270171,
          81.24646035
        ],
        [
          0.00012686590347,
          0.06986402666685,
          85.12648396
        ],
        [
          0.00009592339659,
          0.0779477141873,
          81.27890084
        ],
        [
          0.0001578996682,
          0.06429736576688,
          87.81600618
        ],
        [
          0.00009604684227,
          0.07796590270171,
          81.24646035
        ],
        [
          0.00014198499394,
          0.06555631618184,
          88.03957677
        ],
        [
          0.00009592339659,
          0.0779477141873,
          81.27890084
        ],
        [
          0.00016663996761,
          0.06070688195084,
          91.18268
        ],
        [
          0.00009682309828,
          0.07793607432093,
          81.16955432
        ],
        [
          0.00015293884315,
          0.0668106612574,
          85.56065577
        ],
        [
          0.00009670163224,
          0.07791747435602,
          81.20195463
        ],
        [
          0.00018787418168,
          0.06138497952903,
          88.40991487
        ],
        [
          0.00009682309828,
          0.07793607432093,
          81.16955432
        ],
        [
          0.00017006037457,
          0.06256677101549,
          88.62910358
        ],
        [
          0.00009670163224,
          0.07791747435602,
          81.20195463
        ],
        [
          0.00022102707911,
          0.05559885602517,
          92.93066476
        ],
        [
          0.00009604684227,
          0.07796590270171,
          81.24646035
        ],
        [
          0.00014972492591,
          0.0662073123321,
          86.52353598
        ],
        [
          0.00009592339659,
          0.0779477141873,
          81.27890084
        ],
        [
          0.00018072648838,
          0.06100458404186,
          89.49280723
        ],
        [
          0.00009604684227,
          0.07796590270171,
          81.24646035
        ],
        [
          0.00016234804972,
          0.06229058107692,
          89.69354678
        ],
        [
          0.00009592339659,
          0.0779477141873,
          81.27890084
        ],
        [
          0.00020806081066,
          0.05545706795861,
          94.20655211
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00011598998286,
          0.07312770427421,
          83.17273951
        ],
        [
          0.00009724111142,
          0.07796842954893,
          81.08603063
        ],
        [
          0.00011577530241,
          0.07311739977396,
          83.20781729
        ],
        [
          0.00009735943882,
          0.07798755075032,
          81.05372277
        ],
        [
          0.0001375595479,
          0.06804592730968,
          85.82851072
        ],
        [
          0.00009724111142,
          0.07796842954893,
          81.08603063
        ],
        [
          0.00013715889957,
          0.06805042131277,
          85.86654811
        ],
        [
          0.00009659657611,
          0.07801518138074,
          81.13019938
        ],
        [
          0.00011573291754,
          0.07226797633635,
          84.02955769
        ],
        [
          0.0000964762814,
          0.07799646119308,
          81.16254831
        ],
        [
          0.00011547353989,
          0.07226304239612,
          84.06532981
        ],
        [
          0.00009659657611,
          0.07801518138074,
          81.13019938
        ],
        [
          0.00013359881283,
          0.06755652457615,
          86.77495859
        ],
        [
          0.0000964762814,
          0.07799646119308,
          81.16254831
        ],
        [
          0.00013315093883,
          0.06756680888302,
          86.81355511
        ],
        [
          0.00009735943882,
          0.07798755075032,
          81.05372277
        ],
        [
          0.00011598998286,
          0.07312770427421,
          83.17273951
        ],
        [
          0.00009724111142,
          0.07796842954893,
          81.08603063
        ],
        [
          0.00011577530241,
          0.07311739977396,
          83.20781729
        ],
        [
          0.00009735943882,
          0.07798755075032,
          81.05372277
        ],
        [
          0.0001375595479,
          0.06804592730968,
          85.82851072
        ],
        [
          0.00009724111142,
          0.07796842954893,
          81.08603063
        ],
        [
          0.00015570132698,
          0.06574196951944,
          86.43567172
        ],
        [
          0.00009659657611,
          0.07801518138074,
          81.13019938
        ],
        [
          0.00011573291754,
          0.07226797633635,
          84.02955769
        ],
        [
          0.0000964762814,
          0.07799646119308,
          81.16254831
        ],
        [
          0.00011547353989,
          0.07226304239612,
          84.06532981
        ],
        [
          0.00009659657611,
          0.07801518138074,
          81.13019938
        ],
        [
          0.00013359881283,
          0.06755652457615,
          86.77495859
        ],
        [
          0.0000964762814,
          0.07799646119308,
          81.16254831
        ],
        [
          0.00015096283368,
          0.06527288234228,
          87.41940386
        ],
        [
          0.00009738133776,
          0.07787435402878,
          81.15003952
        ],
        [
          0.00012940751954,
          0.07050836391021,
          84.19783453
        ],
        [
          0.00009725971181,
          0.07785569245083,
          81.18244114
        ],
        [
          0.00016429991717,
          0.06467705131235,
          86.77905633
        ],
        [
          0.00009738133776,
          0.07787435402878,
          81.15003952
        ],
        [
          0.00014889929739,
          0.06582815246704,
          87.01866139
        ],
        [
          0.00009725971181,
          0.07785569245083,
          81.18244114
        ],
        [
          0.00017792156341,
          0.06076345772099,
          90.0393725
        ],
        [
          0.00009661057766,
          0.07790306593769,
          81.22667445
        ],
        [
          0.00012800517937,
          0.06976720701332,
          85.09698833
        ],
        [
          0.00009648696053,
          0.07788481371137,
          81.25911645
        ],
        [
          0.00015943138896,
          0.06419136843273,
          87.78554476
        ],
        [
          0.00009661057766,
          0.07790306593769,
          81.22667445
        ],
        [
          0.00014340114512,
          0.06544664457625,
          88.01043707
        ],
        [
          0.00009648696053,
          0.07788481371137,
          81.25911645
        ],
        [
          0.0001684786037,
          0.06058385128095,
          91.15409214
        ],
        [
          0.00009738133776,
          0.07787435402878,
          81.15003952
        ],
        [
          0.00015424299222,
          0.06671872138567,
          85.53114229
        ],
        [
          0.00009725971181,
          0.07785569245083,
          81.18244114
        ],
        [
          0.00018961281317,
          0.06128369303087,
          88.3795591
        ],
        [
          0.00009738133776,
          0.07787435402878,
          81.15003952
        ],
        [
          0.00017167610544,
          0.06246211040313,
          88.60011696
        ],
        [
          0.00009725971181,
          0.07785569245083,
          81.18244114
        ],
        [
          0.00022334291919,
          0.05548137042994,
          92.90275473
        ],
        [
          0.00009661057766,
          0.07790306593769,
          81.22667445
        ],
        [
          0.00015112929803,
          0.06610559106943,
          86.49272594
        ],
        [
          0.00009648696053,
          0.07788481371137,
          81.25911645
        ],
        [
          0.00018257824131,
          0.06089179817746,
          89.46161328
        ],
        [
          0.00009661057766,
          0.07790306593769,
          81.22667445
        ],
        [
          0.00016406103866,
          0.06217375923951,
          89.66381636
        ],
        [
          0.00009648696053,
          0.07788481371137,
          81.25911645
        ],
        [
          0.0002105024272,
          0.05532483458435,
          94.17906678
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00011682015884,
          0.07305126550531,
          83.14808187
        ],
        [
          0.00009776741922,
          0.07791062586778,
          81.06753095
        ],
        [
          0.00011660517417,
          0.0730408339902,
          83.18316697
        ],
        [
          0.00009788587795,
          0.07792980491399,
          81.03522211
        ],
        [
          0.00013862319042,
          0.06796186710481,
          85.8035301
        ],
        [
          0.00009776741922,
          0.07791062586778,
          81.06753095
        ],
        [
          0.00013822153377,
          0.06796617842595,
          85.84158577
        ],
        [
          0.00009713281805,
          0.07795589021355,
          81.111282
        ],
        [
          0.00011665879193,
          0.07218217175576,
          84.00288965
        ],
        [
          0.00009701237988,
          0.0779371098046,
          81.14363209
        ],
        [
          0.00011639885144,
          0.07217708167207,
          84.03867303
        ],
        [
          0.00009713281805,
          0.07795589021355,
          81.111282
        ],
        [
          0.00013476696443,
          0.06746099020271,
          86.74824785
        ],
        [
          0.00009701237988,
          0.0779371098046,
          81.14363209
        ],
        [
          0.00013431762037,
          0.06747105608711,
          86.78686876
        ],
        [
          0.00009788587795,
          0.07792980491399,
          81.03522211
        ],
        [
          0.00011682015884,
          0.07305126550531,
          83.14808187
        ],
        [
          0.00009776741922,
          0.07791062586778,
          81.06753095
        ],
        [
          0.00011660517417,
          0.0730408339902,
          83.18316697
        ],
        [
          0.00009788587795,
          0.07792980491399,
          81.03522211
        ],
        [
          0.00013862319042,
          0.06796186710481,
          85.8035301
        ],
        [
          0.00009776741922,
          0.07791062586778,
          81.06753095
        ],
        [
          0.00015689284251,
          0.06565867406845,
          86.41037211
        ],
        [
          0.00009713281805,
          0.07795589021355,
          81.111282
        ],
        [
          0.00011665879193,
          0.07218217175576,
          84.00288965
        ],
        [
          0.00009701237988,
          0.0779371098046,
          81.14363209
        ],
        [
          0.00011639885144,
          0.07217708167207,
          84.03867303
        ],
        [
          0.00009713281805,
          0.07795589021355,
          81.111282
        ],
        [
          0.00013476696443,
          0.06746099020271,
          86.74824785
        ],
        [
          0.00009701237988,
          0.0779371098046,
          81.14363209
        ],
        [
          0.00015227178671,
          0.06517798683546,
          87.39241958
        ],
        [
          0.00009791837339,
          0.07781545607425,
          81.1312084
        ],
        [
          0.00013043098604,
          0.07042370294743,
          84.17047384
        ],
        [
          0.00009779660718,
          0.07779673386435,
          81.16361121
        ],
        [
          0.00016570286283,
          0.06458446940597,
          86.75018675
        ],
        [
          0.00009791837339,
          0.07781545607425,
          81.1312084
        ],
        [
          0.00015018955382,
          0.06573350910828,
          86.99130717
        ],
        [
          0.00009779660718,
          0.07779673386435,
          81.16361121
        ],
        [
          0.00017962684971,
          0.06065727353931,
          90.01168637
        ],
        [
          0.00009715737782,
          0.07784261252421,
          81.20742719
        ],
        [
          0.00012913489634,
          0.06967223795731,
          85.06770142
        ],
        [
          0.00009703360767,
          0.07782429722988,
          81.23987056
        ],
        [
          0.00016096053658,
          0.06408676848855,
          87.75505649
        ],
        [
          0.00009715737782,
          0.07784261252421,
          81.20742719
        ],
        [
          0.00014480239754,
          0.06533937285218,
          87.98154954
        ],
        [
          0.00009703360767,
          0.07782429722988,
          81.23987056
        ],
        [
          0.00017031071621,
          0.06046278673308,
          91.12549642
        ],
        [
          0.00009791837339,
          0.07781545607425,
          81.1312084
        ],
        [
          0.00015550223975,
          0.06663088663283,
          85.50256541
        ],
        [
          0.00009779660718,
          0.07779673386435,
          81.16361121
        ],
        [
          0.00019130460302,
          0.0611862435705,
          88.34989814
        ],
        [
          0.00009791837339,
          0.07781545607425,
          81.1312084
        ],
        [
          0.00017323264238,
          0.06236240900897,
          88.57209398
        ],
        [
          0.00009779660718,
          0.07779673386435,
          81.16361121
        ],
        [
          0.00022559026704,
          0.05536875457577,
          92.87545402
        ],
        [
          0.00009715737782,
          0.07784261252421,
          81.20742719
        ],
        [
          0.00015251096961,
          0.06600664034817,
          86.462347
        ],
        [
          0.00009703360767,
          0.07782429722988,
          81.23987056
        ],
        [
          0.0001844125741,
          0.06078141986347,
          89.4305965
        ],
        [
          0.00009715737782,
          0.07784261252421,
          81.20742719
        ],
        [
          0.00016574329199,
          0.06206041356709,
          89.63453145
        ],
        [
          0.00009703360767,
          0.07782429722988,
          81.23987056
        ],
        [
          0.00021291529741,
          0.05519589722363,
          94.1516764
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00011760752203,
          0.07297945045566,
          83.12462552
        ],
        [
          0.00009827409648,
          0.07785541862505,
          81.04965457
        ],
        [
          0.00011740533487,
          0.07296770907843,
          83.15932761
        ],
        [
          0.00009838189898,
          0.07787582364609,
          81.01772419
        ],
        [
          0.00013963714759,
          0.06788250835245,
          85.77963493
        ],
        [
          0.00009827409648,
          0.07785541862505,
          81.04965457
        ],
        [
          0.00013925136711,
          0.06788533031081,
          85.81731266
        ],
        [
          0.00009763555742,
          0.07790074575997,
          81.09348148
        ],
        [
          0.00011754743692,
          0.07210064553224,
          83.97723265
        ],
        [
          0.00009752571701,
          0.0778807334477,
          81.12545358
        ],
        [
          0.00011730049849,
          0.07209416644318,
          84.01263741
        ],
        [
          0.00009763555742,
          0.07790074575997,
          81.09348148
        ],
        [
          0.00013589367037,
          0.0673698087659,
          86.72241431
        ],
        [
          0.00009752571701,
          0.0778807334477,
          81.12545358
        ],
        [
          0.00013546000221,
          0.06737828423521,
          86.7606684
        ],
        [
          0.00009838189898,
          0.07787582364609,
          81.01772419
        ],
        [
          0.00011760752203,
          0.07297945045566,
          83.12462552
        ],
        [
          0.00009827409648,
          0.07785541862505,
          81.04965457
        ],
        [
          0.00011740533487,
          0.07296770907843,
          83.15932761
        ],
        [
          0.00009838189898,
          0.07787582364609,
          81.01772419
        ],
        [
          0.00013963714759,
          0.06788250835245,
          85.77963493
        ],
        [
          0.00009827409648,
          0.07785541862505,
          81.04965457
        ],
        [
          0.00015804689525,
          0.06557878729793,
          86.38576567
        ],
        [
          0.00009763555742,
          0.07790074575997,
          81.09348148
        ],
        [
          0.00011754743692,
          0.07210064553224,
          83.97723265
        ],
        [
          0.00009752571701,
          0.0778807334477,
          81.12545358
        ],
        [
          0.00011730049849,
          0.07209416644318,
          84.01263741
        ],
        [
          0.00009763555742,
          0.07790074575997,
          81.09348148
        ],
        [
          0.00013589367037,
          0.0673698087659,
          86.72241431
        ],
        [
          0.00009752571701,
          0.0778807334477,
          81.12545358
        ],
        [
          0.00015355270326,
          0.06508610585052,
          87.36591923
        ],
        [
          0.00009842605274,
          0.07776022060714,
          81.11334072
        ],
        [
          0.00013141554627,
          0.07034308865786,
          84.14407478
        ],
        [
          0.00009831496443,
          0.0777402666539,
          81.14536511
        ],
        [
          0.00016706208503,
          0.06449573649029,
          86.72210434
        ],
        [
          0.00009842605274,
          0.07776022060714,
          81.11334072
        ],
        [
          0.00015143681944,
          0.06564298467003,
          86.964774
        ],
        [
          0.00009831496443,
          0.0777402666539,
          81.14536511
        ],
        [
          0.00018128707526,
          0.06055507337838,
          89.98459186
        ],
        [
          0.00009767172851,
          0.07778620437411,
          81.1892575
        ],
        [
          0.00013023265646,
          0.06958095706353,
          85.03917778
        ],
        [
          0.00009755857664,
          0.07776665128333,
          81.22132294
        ],
        [
          0.0001624559003,
          0.06398566064764,
          87.72513955
        ],
        [
          0.00009767172851,
          0.07778620437411,
          81.1892575
        ],
        [
          0.00014617040628,
          0.06523584282146,
          87.95326943
        ],
        [
          0.00009755857664,
          0.07776665128333,
          81.22132294
        ],
        [
          0.00017211087005,
          0.06034531460358,
          91.09726427
        ],
        [
          0.00009842605274,
          0.07776022060714,
          81.11334072
        ],
        [
          0.00015674027547,
          0.06654544384317,
          85.47436633
        ],
        [
          0.00009831496443,
          0.0777402666539,
          81.14536511
        ],
        [
          0.00019297811258,
          0.06109093075364,
          88.32040806
        ],
        [
          0.00009842605274,
          0.07776022060714,
          81.11334072
        ],
        [
          0.00017477037319,
          0.06226500708378,
          88.5442809
        ],
        [
          0.00009831496443,
          0.0777402666539,
          81.14536511
        ],
        [
          0.00022782241365,
          0.05525826317035,
          92.84809065
        ],
        [
          0.00009767172851,
          0.07778620437411,
          81.1892575
        ],
        [
          0.00015388057391,
          0.06590966184858,
          86.43214157
        ],
        [
          0.00009755857664,
          0.07776665128333,
          81.22132294
        ],
        [
          0.00018624098001,
          0.06067273135827,
          89.39953567
        ],
        [
          0.00009767172851,
          0.07778620437411,
          81.1892575
        ],
        [
          0.00016741830358,
          0.06194891363651,
          89.6052561
        ],
        [
          0.00009755857664,
          0.07776665128333,
          81.22132294
        ],
        [
          0.00021532995789,
          0.05506858764932,
          94.12399865
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00011849054811,
          0.07289970734067,
          83.09822094
        ],
        [
          0.00009882668926,
          0.07779570819327,
          81.03007348
        ],
        [
          0.00011830131505,
          0.07288664255288,
          83.13254024
        ],
        [
          0.00009892383707,
          0.07781732889814,
          80.99852152
        ],
        [
          0.00014077374335,
          0.0677944493047,
          85.75274295
        ],
        [
          0.00009882668926,
          0.07779570819327,
          81.03007348
        ],
        [
          0.00014040382673,
          0.06779577952436,
          85.79004382
        ],
        [
          0.00009818647542,
          0.07784081739662,
          81.07389096
        ],
        [
          0.00011855169468,
          0.07200948663382,
          83.94815385
        ],
        [
          0.0000980872334,
          0.07781958305416,
          81.1054851
        ],
        [
          0.00011831779043,
          0.0720016157964,
          83.98318057
        ],
        [
          0.00009818647542,
          0.07784081739662,
          81.07389096
        ],
        [
          0.00013716651971,
          0.06726793018675,
          86.69313559
        ],
        [
          0.0000980872334,
          0.07781958305416,
          81.1054851
        ],
        [
          0.00013674849843,
          0.06727480760649,
          86.73102451
        ],
        [
          0.00009892383707,
          0.07781732889814,
          80.99852152
        ],
        [
          0.00011849054811,
          0.07289970734067,
          83.09822094
        ],
        [
          0.00009882668926,
          0.07779570819327,
          81.03007348
        ],
        [
          0.00011830131505,
          0.07288664255288,
          83.13254024
        ],
        [
          0.00009892383707,
          0.07781732889814,
          80.99852152
        ],
        [
          0.00014077374335,
          0.0677944493047,
          85.75274295
        ],
        [
          0.00009882668926,
          0.07779570819327,
          81.03007348
        ],
        [
          0.00015933756625,
          0.06549036176665,
          86.35811591
        ],
        [
          0.00009818647542,
          0.07784081739662,
          81.07389096
        ],
        [
          0.00011855169468,
          0.07200948663382,
          83.94815385
        ],
        [
          0.0000980872334,
          0.07781958305416,
          81.1054851
        ],
        [
          0.00011831779043,
          0.0720016157964,
          83.98318057
        ],
        [
          0.00009818647542,
          0.07784081739662,
          81.07389096
        ],
        [
          0.00013716651971,
          0.06726793018675,
          86.69313559
        ],
        [
          0.0000980872334,
          0.07781958305416,
          81.1054851
        ],
        [
          0.00015499653723,
          0.06498369344952,
          87.33592693
        ],
        [
          0.0000989810609,
          0.07770033684785,
          81.09372257
        ],
        [
          0.00013250857589,
          0.07025454514823,
          84.11466314
        ],
        [
          0.00009888065136,
          0.07767916113094,
          81.12536858
        ],
        [
          0.00016858732663,
          0.06439728912025,
          86.69044695
        ],
        [
          0.0000989810609,
          0.07770033684785,
          81.09372257
        ],
        [
          0.00015282112937,
          0.06554361992681,
          86.93520781
        ],
        [
          0.00009888065136,
          0.07767916113094,
          81.12536858
        ],
        [
          0.00018314995091,
          0.06044176874753,
          89.95401295
        ],
        [
          0.00009823567228,
          0.07772487599223,
          81.16925212
        ],
        [
          0.00013146108099,
          0.06947997529548,
          85.00716986
        ],
        [
          0.00009813314168,
          0.07770409466153,
          81.20093965
        ],
        [
          0.00016414563514,
          0.06387280724268,
          87.69119391
        ],
        [
          0.00009823567228,
          0.07772487599223,
          81.16925212
        ],
        [
          0.00014770115955,
          0.06512138360713,
          87.92152116
        ],
        [
          0.00009813314168,
          0.07770409466153,
          81.20093965
        ],
        [
          0.00017414522405,
          0.06021429904823,
          91.0651863
        ],
        [
          0.0000989810609,
          0.07770033684785,
          81.09372257
        ],
        [
          0.00015809275622,
          0.06645313514638,
          85.44342861
        ],
        [
          0.00009888065136,
          0.07767916113094,
          81.12536858
        ],
        [
          0.00019482681791,
          0.06098688409708,
          88.28764438
        ],
        [
          0.0000989810609,
          0.07770033684785,
          81.09372257
        ],
        [
          0.0001764500711,
          0.06215983859459,
          88.51375074
        ],
        [
          0.00009888065136,
          0.07767916113094,
          81.12536858
        ],
        [
          0.00023028692896,
          0.05513782595101,
          92.81758272
        ],
        [
          0.00009823567228,
          0.07772487599223,
          81.16925212
        ],
        [
          0.00015539033489,
          0.06580402798115,
          86.39872587
        ],
        [
          0.00009813314168,
          0.07770409466153,
          81.20093965
        ],
        [
          0.00018827687781,
          0.06055325558411,
          89.36476852
        ],
        [
          0.00009823567228,
          0.07772487599223,
          81.16925212
        ],
        [
          0.00016926496553,
          0.06182753754625,
          89.57283412
        ],
        [
          0.00009813314168,
          0.07770409466153,
          81.20093965
        ],
        [
          0.00021801738992,
          0.05492888378244,
          94.09287693
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.0001193387848,
          0.07282389991981,
          83.07274921
        ],
        [
          0.00009935621874,
          0.07773898750506,
          81.01121554
        ],
        [
          0.00011916638258,
          0.0728091966488,
          83.10656743
        ],
        [
          0.00009943952128,
          0.0777621456532,
          80.9801555
        ],
        [
          0.00014186573564,
          0.06771073959593,
          85.72678789
        ],
        [
          0.00009935621874,
          0.07773898750506,
          81.01121554
        ],
        [
          0.00014151679474,
          0.06771022246341,
          85.76359165
        ],
        [
          0.00009869999373,
          0.0777854390402,
          81.0555386
        ],
        [
          0.00011951378029,
          0.07192312409675,
          83.92019981
        ],
        [
          0.00009861453022,
          0.07776266100195,
          81.08664133
        ],
        [
          0.00011929703488,
          0.0719135255988,
          83.95473061
        ],
        [
          0.00009869999373,
          0.0777854390402,
          81.0555386
        ],
        [
          0.00013838633572,
          0.06717141506765,
          86.66496988
        ],
        [
          0.00009861453022,
          0.07776266100195,
          81.08664133
        ],
        [
          0.00013798922947,
          0.06717632288138,
          86.70237412
        ],
        [
          0.00009943952128,
          0.0777621456532,
          80.9801555
        ],
        [
          0.0001193387848,
          0.07282389991981,
          83.07274921
        ],
        [
          0.00009935621874,
          0.07773898750506,
          81.01121554
        ],
        [
          0.00011916638258,
          0.0728091966488,
          83.10656743
        ],
        [
          0.00009943952128,
          0.0777621456532,
          80.9801555
        ],
        [
          0.00014186573564,
          0.06771073959593,
          85.72678789
        ],
        [
          0.00009935621874,
          0.07773898750506,
          81.01121554
        ],
        [
          0.00016058320578,
          0.06540594014226,
          86.33128762
        ],
        [
          0.00009869999373,
          0.0777854390402,
          81.0555386
        ],
        [
          0.00011951378029,
          0.07192312409675,
          83.92019981
        ],
        [
          0.00009861453022,
          0.07776266100195,
          81.08664133
        ],
        [
          0.00011929703488,
          0.0719135255988,
          83.95473061
        ],
        [
          0.00009869999373,
          0.0777854390402,
          81.0555386
        ],
        [
          0.00013838633572,
          0.06717141506765,
          86.66496988
        ],
        [
          0.00009861453022,
          0.07776266100195,
          81.08664133
        ],
        [
          0.00015638592687,
          0.06488629189115,
          87.30693061
        ],
        [
          0.00009951321447,
          0.07764341865809,
          81.07481824
        ],
        [
          0.00013357944529,
          0.07016876761668,
          84.08572853
        ],
        [
          0.00009942668801,
          0.07762069821467,
          81.10597227
        ],
        [
          0.00017008550309,
          0.06430173895459,
          86.65918972
        ],
        [
          0.00009951321447,
          0.07764341865809,
          81.07481824
        ],
        [
          0.0001541777544,
          0.06544736549793,
          86.90609985
        ],
        [
          0.00009942668801,
          0.07762069821467,
          81.10597227
        ],
        [
          0.00018498064933,
          0.06033181865073,
          89.92376697
        ],
        [
          0.00009876557209,
          0.0776677536411,
          81.15036229
        ],
        [
          0.000132659914,
          0.0693826054884,
          84.97582844
        ],
        [
          0.0000986768566,
          0.07764542120761,
          81.18155838
        ],
        [
          0.00016579908867,
          0.06376378609519,
          87.65783301
        ],
        [
          0.00009876557209,
          0.0776677536411,
          81.15036229
        ],
        [
          0.00014919576742,
          0.06501102703747,
          87.89040287
        ],
        [
          0.0000986768566,
          0.07764542120761,
          81.18155838
        ],
        [
          0.00017613740351,
          0.06008776291911,
          91.03358181
        ],
        [
          0.00009951321447,
          0.07764341865809,
          81.07481824
        ],
        [
          0.00015943473402,
          0.06636260701094,
          85.41258048
        ],
        [
          0.00009942668801,
          0.07762069821467,
          81.10597227
        ],
        [
          0.00019666467263,
          0.06088473387032,
          88.25486492
        ],
        [
          0.00009951321447,
          0.07764341865809,
          81.07481824
        ],
        [
          0.00017811733955,
          0.06205671028488,
          88.48327219
        ],
        [
          0.00009942668801,
          0.07762069821467,
          81.10597227
        ],
        [
          0.00023273599854,
          0.05501975208219,
          92.78693152
        ],
        [
          0.00009876557209,
          0.0776677536411,
          81.15036229
        ],
        [
          0.00015688130782,
          0.06570100635167,
          86.36558791
        ],
        [
          0.0000986768566,
          0.07764542120761,
          81.18155838
        ],
        [
          0.00019029175157,
          0.06043660081491,
          89.33015691
        ],
        [
          0.00009876557209,
          0.0776677536411,
          81.15036229
        ],
        [
          0.00017108967815,
          0.06170918319094,
          89.54063062
        ],
        [
          0.0000986768566,
          0.07764542120761,
          81.18155838
        ],
        [
          0.00022067697424,
          0.0547926601246,
          94.06172728
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.0001202040582,
          0.07274738728896,
          83.04663288
        ],
        [
          0.0000998713227,
          0.07768429959842,
          80.99276169
        ],
        [
          0.00012004462971,
          0.07273140999972,
          83.08006785
        ],
        [
          0.00009994397949,
          0.07770863470522,
          80.96207999
        ],
        [
          0.0001430041119,
          0.06762441561613,
          85.6995837
        ],
        [
          0.0000998713227,
          0.07768429959842,
          80.99276169
        ],
        [
          0.0001426712136,
          0.06762244801297,
          85.7360086
        ],
        [
          0.00009921116933,
          0.07773079561715,
          81.03716045
        ],
        [
          0.00012053896203,
          0.07183214821808,
          83.89028593
        ],
        [
          0.00009913630168,
          0.07770683453079,
          81.06788525
        ],
        [
          0.0001203354317,
          0.071821192108,
          83.92443735
        ],
        [
          0.00009921116933,
          0.07773079561715,
          81.03716045
        ],
        [
          0.00013971124744,
          0.0670678233934,
          86.6342384
        ],
        [
          0.00009913630168,
          0.07770683453079,
          81.06788525
        ],
        [
          0.0001393300348,
          0.06707116746204,
          86.6712756
        ],
        [
          0.00009994397949,
          0.07770863470522,
          80.96207999
        ],
        [
          0.0001202040582,
          0.07274738728896,
          83.04663288
        ],
        [
          0.0000998713227,
          0.07768429959842,
          80.99276169
        ],
        [
          0.00012004462971,
          0.07273140999972,
          83.08006785
        ],
        [
          0.00009994397949,
          0.07770863470522,
          80.96207999
        ],
        [
          0.0001430041119,
          0.06762441561613,
          85.6995837
        ],
        [
          0.0000998713227,
          0.07768429959842,
          80.99276169
        ],
        [
          0.00016187438096,
          0.06531939482919,
          86.3033051
        ],
        [
          0.00009921116933,
          0.07773079561715,
          81.03716045
        ],
        [
          0.00012053896203,
          0.07183214821808,
          83.89028593
        ],
        [
          0.00009913630168,
          0.07770683453079,
          81.06788525
        ],
        [
          0.0001203354317,
          0.071821192108,
          83.92443735
        ],
        [
          0.00009921116933,
          0.07773079561715,
          81.03716045
        ],
        [
          0.00013971124744,
          0.0670678233934,
          86.6342384
        ],
        [
          0.00009913630168,
          0.07770683453079,
          81.06788525
        ],
        [
          0.0001578863507,
          0.06478237116786,
          87.27544608
        ],
        [
          0.00010002939239,
          0.07758869688823,
          81.05637206
        ],
        [
          0.00013465567673,
          0.07008354314218,
          84.05650202
        ],
        [
          0.00009995354288,
          0.0775647936715,
          81.08714773
        ],
        [
          0.00017158783139,
          0.06420708002849,
          86.62765279
        ],
        [
          0.00010002939239,
          0.07758869688823,
          81.05637206
        ],
        [
          0.00015556874676,
          0.06534983256035,
          86.87609144
        ],
        [
          0.00009995354288,
          0.0775647936715,
          81.08714773
        ],
        [
          0.00018685199908,
          0.06022085898694,
          89.89261788
        ],
        [
          0.00009928842994,
          0.0776118896584,
          81.131614
        ],
        [
          0.00013391572027,
          0.06928186192035,
          84.94286104
        ],
        [
          0.00009921034046,
          0.07758836823756,
          81.16243215
        ],
        [
          0.00016752444305,
          0.06365151454942,
          87.62283329
        ],
        [
          0.00009928842994,
          0.0776118896584,
          81.131614
        ],
        [
          0.00015078959582,
          0.06489486065007,
          87.85706466
        ],
        [
          0.00009921034046,
          0.07758836823756,
          81.16243215
        ],
        [
          0.00017825239889,
          0.05995531791102,
          90.99979285
        ],
        [
          0.00010002939239,
          0.07758869688823,
          81.05637206
        ],
        [
          0.00016077346804,
          0.0662733663744,
          85.3816272
        ],
        [
          0.00009995354288,
          0.0775647936715,
          81.08714773
        ],
        [
          0.00019849498433,
          0.06078428605536,
          88.22197853
        ],
        [
          0.00010002939239,
          0.07758869688823,
          81.05637206
        ],
        [
          0.0001798132449,
          0.06195310395579,
          88.45206268
        ],
        [
          0.00009995354288,
          0.0775647936715,
          81.08714773
        ],
        [
          0.00023521895532,
          0.0549016753801,
          92.75548323
        ],
        [
          0.00009928842994,
          0.0776118896584,
          81.131614
        ],
        [
          0.000158430504,
          0.06559532941583,
          86.33098287
        ],
        [
          0.00009921034046,
          0.07758836823756,
          81.16243215
        ],
        [
          0.00019237841147,
          0.0603174490459,
          89.29406622
        ],
        [
          0.00009928842994,
          0.0776118896584,
          81.131614
        ],
        [
          0.00017301897803,
          0.06158574003722,
          89.50637491
        ],
        [
          0.00009921034046,
          0.07758836823756,
          81.16243215
        ],
        [
          0.00022347650466,
          0.05465142041236,
          94.02854068
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00012108151939,
          0.07267065161128,
          83.01999076
        ],
        [
          0.00010039044894,
          0.07762968872341,
          80.97403558
        ],
        [
          0.00012093895719,
          0.07265308083862,
          83.05292489
        ],
        [
          0.00010044934705,
          0.0776555117101,
          80.9438452
        ],
        [
          0.00014414835528,
          0.067538619706,
          85.67206992
        ],
        [
          0.00010039044894,
          0.07762968872341,
          80.97403558
        ],
        [
          0.00014383649502,
          0.0675348526133,
          85.70799651
        ],
        [
          0.0000997319813,
          0.0776756309662,
          81.01830779
        ],
        [
          0.00012155149754,
          0.07174336335372,
          83.86059308
        ],
        [
          0.00009967081664,
          0.07765017361146,
          81.04854171
        ],
        [
          0.00012136523279,
          0.07173072321171,
          83.89424771
        ],
        [
          0.0000997319813,
          0.0776756309662,
          81.01830779
        ],
        [
          0.00014101053228,
          0.0669674847686,
          86.60394233
        ],
        [
          0.00009967081664,
          0.07765017361146,
          81.04854171
        ],
        [
          0.00014065038491,
          0.06696890418553,
          86.64049336
        ],
        [
          0.00010044934705,
          0.0776555117101,
          80.9438452
        ],
        [
          0.00012108151939,
          0.07267065161128,
          83.01999076
        ],
        [
          0.00010039044894,
          0.07762968872341,
          80.97403558
        ],
        [
          0.00012093895719,
          0.07265308083862,
          83.05292489
        ],
        [
          0.00010044934705,
          0.0776555117101,
          80.9438452
        ],
        [
          0.00014414835528,
          0.067538619706,
          85.67206992
        ],
        [
          0.00010039044894,
          0.07762968872341,
          80.97403558
        ],
        [
          0.00016317681223,
          0.06523309286315,
          86.27487955
        ],
        [
          0.0000997319813,
          0.0776756309662,
          81.01830779
        ],
        [
          0.00012155149754,
          0.07174336335372,
          83.86059308
        ],
        [
          0.00009967081664,
          0.07765017361146,
          81.04854171
        ],
        [
          0.00012136523279,
          0.07173072321171,
          83.89424771
        ],
        [
          0.0000997319813,
          0.0776756309662,
          81.01830779
        ],
        [
          0.00014101053228,
          0.0669674847686,
          86.60394233
        ],
        [
          0.00009967081664,
          0.07765017361146,
          81.04854171
        ],
        [
          0.00015936283116,
          0.06468138790541,
          87.24427076
        ],
        [
          0.00010055429721,
          0.07753355942761,
          81.03748521
        ],
        [
          0.00013578122647,
          0.06999547356528,
          84.02575749
        ],
        [
          0.000100492254,
          0.07750816070127,
          81.06776942
        ],
        [
          0.00017319933961,
          0.06410682666311,
          86.59358946
        ],
        [
          0.00010055429721,
          0.07753355942761,
          81.03748521
        ],
        [
          0.0001570115883,
          0.06524990306598,
          86.84477066
        ],
        [
          0.000100492254,
          0.07750816070127,
          81.06776942
        ],
        [
          0.00018884355706,
          0.060104348305,
          89.85919274
        ],
        [
          0.00009982874445,
          0.07755469513991,
          81.11210981
        ],
        [
          0.00013519431806,
          0.06918060638551,
          84.90913102
        ],
        [
          0.00009976440418,
          0.07752966963428,
          81.14243697
        ],
        [
          0.00016932485231,
          0.06353596975514,
          87.58608626
        ],
        [
          0.00009982874445,
          0.07755469513991,
          81.11210981
        ],
        [
          0.00015240156381,
          0.06477895112064,
          87.82316591
        ],
        [
          0.00009976440418,
          0.07752966963428,
          81.14243697
        ],
        [
          0.0001804453095,
          0.05982002189842,
          90.96448433
        ],
        [
          0.00010055429721,
          0.07753355942761,
          81.03748521
        ],
        [
          0.0001622050887,
          0.066179117229,
          85.34830705
        ],
        [
          0.000100492254,
          0.07750816070127,
          81.06776942
        ],
        [
          0.0002004976995,
          0.06067583589094,
          88.18569963
        ],
        [
          0.00010055429721,
          0.07753355942761,
          81.03748521
        ],
        [
          0.00018161222378,
          0.06184461844595,
          88.418709
        ],
        [
          0.000100492254,
          0.07750816070127,
          81.06776942
        ],
        [
          0.000237912372,
          0.05477542778865,
          92.72092449
        ],
        [
          0.00009982874445,
          0.07755469513991,
          81.11210981
        ],
        [
          0.00016004169763,
          0.06548689521637,
          86.29478556
        ],
        [
          0.00009976440418,
          0.07752966963428,
          81.14243697
        ],
        [
          0.00019459794184,
          0.06019254257277,
          89.25538419
        ],
        [
          0.00009982874445,
          0.07755469513991,
          81.11210981
        ],
        [
          0.00017501231351,
          0.06146000880119,
          89.4707405
        ],
        [
          0.00009976440418,
          0.07752966963428,
          81.14243697
        ],
        [
          0.00022643233403,
          0.05450467113186,
          93.99301194
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00012201298931,
          0.07259014079128,
          82.991518
        ],
        [
          0.00010092640659,
          0.07757385117954,
          80.95455234
        ],
        [
          0.00012187074257,
          0.07257242571176,
          83.02445629
        ],
        [
          0.00010098508451,
          0.07759973636495,
          80.92436338
        ],
        [
          0.00014537811281,
          0.06744749990862,
          85.64229449
        ],
        [
          0.00010092640659,
          0.07757385117954,
          80.95455234
        ],
        [
          0.00014506601252,
          0.06744352572246,
          85.67823695
        ],
        [
          0.00010028065318,
          0.07761808025458,
          80.99829493
        ],
        [
          0.00012264593598,
          0.07164859454061,
          83.82831259
        ],
        [
          0.00010021970615,
          0.07759255786494,
          81.02852754
        ],
        [
          0.00012245981174,
          0.07163577008445,
          83.86197557
        ],
        [
          0.00010028065318,
          0.07761808025458,
          80.99829493
        ],
        [
          0.00014243036704,
          0.06685924589341,
          86.57063534
        ],
        [
          0.00010021970615,
          0.07759255786494,
          81.02852754
        ],
        [
          0.00014206956297,
          0.06686040807317,
          86.60720955
        ],
        [
          0.00010098508451,
          0.07759973636495,
          80.92436338
        ],
        [
          0.00012201298931,
          0.07259014079128,
          82.991518
        ],
        [
          0.00010092640659,
          0.07757385117954,
          80.95455234
        ],
        [
          0.00012187074257,
          0.07257242571176,
          83.02445629
        ],
        [
          0.00010098508451,
          0.07759973636495,
          80.92436338
        ],
        [
          0.00014537811281,
          0.06744749990862,
          85.64229449
        ],
        [
          0.00010092640659,
          0.07757385117954,
          80.95455234
        ],
        [
          0.00016455006431,
          0.06514318711571,
          86.244672
        ],
        [
          0.00010028065318,
          0.07761808025458,
          80.99829493
        ],
        [
          0.00012264593598,
          0.07164859454061,
          83.82831259
        ],
        [
          0.00010021970615,
          0.07759255786494,
          81.02852754
        ],
        [
          0.00012245981174,
          0.07163577008445,
          83.86197557
        ],
        [
          0.00010028065318,
          0.07761808025458,
          80.99829493
        ],
        [
          0.00014243036704,
          0.06685924589341,
          86.57063534
        ],
        [
          0.00010021970615,
          0.07759255786494,
          81.02852754
        ],
        [
          0.00016094865316,
          0.06457433748005,
          87.21054944
        ],
        [
          0.00010110989899,
          0.07747576613539,
          81.01734067
        ],
        [
          0.00013696328833,
          0.06990414889939,
          83.99325674
        ],
        [
          0.00010104807956,
          0.07745030128792,
          81.0476236
        ],
        [
          0.00017486995541,
          0.06400429150299,
          86.55800578
        ],
        [
          0.00010110989899,
          0.07747576613539,
          81.01734067
        ],
        [
          0.00015854426463,
          0.06514512530874,
          86.81126843
        ],
        [
          0.00010104807956,
          0.07745030128792,
          81.0476236
        ],
        [
          0.00019093112338,
          0.05998394603118,
          89.82383726
        ],
        [
          0.00010039724375,
          0.07749511138295,
          81.09143477
        ],
        [
          0.0001365608411,
          0.06907385077947,
          84.87287844
        ],
        [
          0.00010033312396,
          0.07747001683188,
          81.12176079
        ],
        [
          0.00017122481354,
          0.06341580321343,
          87.54703931
        ],
        [
          0.00010039724375,
          0.07749511138295,
          81.09143477
        ],
        [
          0.00015414219262,
          0.06465555576106,
          87.78633765
        ],
        [
          0.00010033312396,
          0.07747001683188,
          81.12176079
        ],
        [
          0.00018278291929,
          0.05967803765655,
          90.92651849
        ],
        [
          0.00010110989899,
          0.07747576613539,
          81.01734067
        ],
        [
          0.00016369473927,
          0.0660823409273,
          85.3133812
        ],
        [
          0.00010104807956,
          0.07745030128792,
          81.0476236
        ],
        [
          0.00020255747237,
          0.06056587165095,
          88.1480524
        ],
        [
          0.00010110989899,
          0.07747576613539,
          81.01734067
        ],
        [
          0.00018350504691,
          0.06173203453485,
          88.38332672
        ],
        [
          0.00010104807956,
          0.07745030128792,
          81.0476236
        ],
        [
          0.00024070945997,
          0.05464632372935,
          92.68452247
        ],
        [
          0.00010039724375,
          0.07749511138295,
          81.09143477
        ],
        [
          0.0001617480281,
          0.06537368283937,
          86.25620152
        ],
        [
          0.00010033312396,
          0.07747001683188,
          81.12176079
        ],
        [
          0.00019692164587,
          0.06006377255211,
          89.21454444
        ],
        [
          0.00010039724375,
          0.07749511138295,
          81.09143477
        ],
        [
          0.00017714472925,
          0.0613275141196,
          89.43232929
        ],
        [
          0.00010033312396,
          0.07747001683188,
          81.12176079
        ],
        [
          0.00022955440481,
          0.05435226568489,
          93.95492911
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00012293035634,
          0.07251181635604,
          82.96326093
        ],
        [
          0.00010146025197,
          0.07751879931538,
          80.93497659
        ],
        [
          0.00012281499101,
          0.0724916970179,
          82.9953881
        ],
        [
          0.00010149714252,
          0.07754696340309,
          80.90557846
        ],
        [
          0.00014660868981,
          0.0673574501771,
          85.61226728
        ],
        [
          0.00010146025197,
          0.07751879931538,
          80.93497659
        ],
        [
          0.00014633053442,
          0.06735077419382,
          85.64739479
        ],
        [
          0.0001008072422,
          0.07756340898113,
          80.97892166
        ],
        [
          0.00012373458084,
          0.07155556557324,
          83.79599016
        ],
        [
          0.00010076800885,
          0.07753559596783,
          81.008364
        ],
        [
          0.00012357620043,
          0.07154020720265,
          83.82884553
        ],
        [
          0.0001008072422,
          0.07756340898113,
          80.97892166
        ],
        [
          0.00014386269757,
          0.06675153595224,
          86.53680692
        ],
        [
          0.00010076800885,
          0.07753559596783,
          81.008364
        ],
        [
          0.00014353624592,
          0.06674981533336,
          86.5725813
        ],
        [
          0.00010149714252,
          0.07754696340309,
          80.90557846
        ],
        [
          0.00012293035634,
          0.07251181635604,
          82.96326093
        ],
        [
          0.00010146025197,
          0.07751879931538,
          80.93497659
        ],
        [
          0.00012281499101,
          0.0724916970179,
          82.9953881
        ],
        [
          0.00010149714252,
          0.07754696340309,
          80.90557846
        ],
        [
          0.00014660868981,
          0.0673574501771,
          85.61226728
        ],
        [
          0.00010146025197,
          0.07751879931538,
          80.93497659
        ],
        [
          0.00016596137238,
          0.06505195588886,
          86.21335598
        ],
        [
          0.0001008072422,
          0.07756340898113,
          80.97892166
        ],
        [
          0.00012373458084,
          0.07155556557324,
          83.79599016
        ],
        [
          0.00010076800885,
          0.07753559596783,
          81.008364
        ],
        [
          0.00012357620043,
          0.07154020720265,
          83.82884553
        ],
        [
          0.0001008072422,
          0.07756340898113,
          80.97892166
        ],
        [
          0.00014386269757,
          0.06675153595224,
          86.53680692
        ],
        [
          0.00010076800885,
          0.07753559596783,
          81.008364
        ],
        [
          0.00016258629365,
          0.06446531188041,
          87.17545227
        ],
        [
          0.00010163768655,
          0.07742142639506,
          80.99803865
        ],
        [
          0.0001381290613,
          0.06981526623571,
          83.9609615
        ],
        [
          0.00010159773988,
          0.07739367306093,
          81.02753037
        ],
        [
          0.00017656920888,
          0.06390146003172,
          86.52149894
        ],
        [
          0.00010163768655,
          0.07742142639506,
          80.99803865
        ],
        [
          0.00016007783325,
          0.06504170229959,
          86.77748355
        ],
        [
          0.00010159773988,
          0.07739367306093,
          81.02753037
        ],
        [
          0.00019308167213,
          0.05986174389422,
          89.7870482
        ],
        [
          0.00010093955383,
          0.07743885948903,
          81.07154475
        ],
        [
          0.00013792085671,
          0.06896910532821,
          84.83656328
        ],
        [
          0.00010089723153,
          0.0774114645011,
          81.10108013
        ],
        [
          0.00017316808907,
          0.06329476263251,
          87.5067901
        ],
        [
          0.00010093955383,
          0.07743885948903,
          81.07154475
        ],
        [
          0.00015589718454,
          0.06453298186284,
          87.74894768
        ],
        [
          0.00010089723153,
          0.0774114645011,
          81.10108013
        ],
        [
          0.00018520188584,
          0.05953350819959,
          90.88685265
        ],
        [
          0.00010163768655,
          0.07742142639506,
          80.99803865
        ],
        [
          0.0001651801963,
          0.0659871611941,
          85.27826246
        ],
        [
          0.00010159773988,
          0.07739367306093,
          81.02753037
        ],
        [
          0.00020467098396,
          0.06045469947456,
          88.10903668
        ],
        [
          0.00010163768655,
          0.07742142639506,
          80.99803865
        ],
        [
          0.00018541822615,
          0.06161986175358,
          88.34723523
        ],
        [
          0.00010159773988,
          0.07739367306093,
          81.02753037
        ],
        [
          0.00024361276796,
          0.05451442819375,
          92.64619238
        ],
        [
          0.00010093955383,
          0.07743885948903,
          81.07154475
        ],
        [
          0.00016346253427,
          0.06526160849281,
          86.21714443
        ],
        [
          0.00010089723153,
          0.0774114645011,
          81.10108013
        ],
        [
          0.00019931676207,
          0.05993316703641,
          89.17205246
        ],
        [
          0.00010093955383,
          0.07743885948903,
          81.07154475
        ],
        [
          0.00017931379735,
          0.06119484945213,
          89.39292433
        ],
        [
          0.00010089723153,
          0.0774114645011,
          81.10108013
        ],
        [
          0.00023280498597,
          0.05419637448079,
          93.91464614
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00012388388741,
          0.0724314417646,
          82.93363283
        ],
        [
          0.00010196030697,
          0.07746777388521,
          80.91645733
        ],
        [
          0.00012376908124,
          0.07241117428353,
          82.9657627
        ],
        [
          0.00010199687652,
          0.07749599696826,
          80.88706138
        ],
        [
          0.00014789825933,
          0.06726430579535,
          85.58052499
        ],
        [
          0.00010196030697,
          0.07746777388521,
          80.91645733
        ],
        [
          0.00014762019028,
          0.06725741483987,
          85.61566707
        ],
        [
          0.00010132963599,
          0.07750974677133,
          80.95951371
        ],
        [
          0.00012487871482,
          0.07145913704567,
          83.76176109
        ],
        [
          0.00010129073149,
          0.07748187082469,
          80.98895392
        ],
        [
          0.00012472077733,
          0.07144358656047,
          83.79462327
        ],
        [
          0.00010132963599,
          0.07750974677133,
          80.95951371
        ],
        [
          0.00014537872984,
          0.06663914902468,
          86.50072544
        ],
        [
          0.00010129073149,
          0.07748187082469,
          80.98895392
        ],
        [
          0.00014505199729,
          0.06663715794688,
          86.53652198
        ],
        [
          0.00010199687652,
          0.07749599696826,
          80.88706138
        ],
        [
          0.00012388388741,
          0.0724314417646,
          82.93363283
        ],
        [
          0.00010196030697,
          0.07746777388521,
          80.91645733
        ],
        [
          0.00012376908124,
          0.07241117428353,
          82.9657627
        ],
        [
          0.00010199687652,
          0.07749599696826,
          80.88706138
        ],
        [
          0.00014789825933,
          0.06726430579535,
          85.58052499
        ],
        [
          0.00010196030697,
          0.07746777388521,
          80.91645733
        ],
        [
          0.0001673996398,
          0.06496020742431,
          86.18113045
        ],
        [
          0.00010132963599,
          0.07750974677133,
          80.95951371
        ],
        [
          0.00012487871482,
          0.07145913704567,
          83.76176109
        ],
        [
          0.00010129073149,
          0.07748187082469,
          80.98895392
        ],
        [
          0.00012472077733,
          0.07144358656047,
          83.79462327
        ],
        [
          0.00010132963599,
          0.07750974677133,
          80.95951371
        ],
        [
          0.00014537872984,
          0.06663914902468,
          86.50072544
        ],
        [
          0.00010129073149,
          0.07748187082469,
          80.98895392
        ],
        [
          0.00016427736993,
          0.06435435016993,
          87.13888962
        ],
        [
          0.00010215482561,
          0.07736874362063,
          80.97893857
        ],
        [
          0.00013933573222,
          0.06972452226044,
          83.92724378
        ],
        [
          0.00010211520753,
          0.07734092775239,
          81.00842822
        ],
        [
          0.00017828564831,
          0.06379909672832,
          86.48426277
        ],
        [
          0.00010215482561,
          0.07736874362063,
          80.97893857
        ],
        [
          0.00016167758966,
          0.06493532941104,
          86.74192784
        ],
        [
          0.00010211520753,
          0.07734092775239,
          81.00842822
        ],
        [
          0.00019527200638,
          0.05973918696242,
          89.74915892
        ],
        [
          0.0001014793784,
          0.07738346396726,
          81.05155391
        ],
        [
          0.00013934382383,
          0.06886112300115,
          84.7982802
        ],
        [
          0.00010143739183,
          0.07735600239583,
          81.08108727
        ],
        [
          0.0001751564655,
          0.06317286204983,
          87.46524127
        ],
        [
          0.0001014793784,
          0.07738346396726,
          81.05155391
        ],
        [
          0.00015774607302,
          0.06440583655888,
          87.70924509
        ],
        [
          0.00010143739183,
          0.07735600239583,
          81.08108727
        ],
        [
          0.00018769522865,
          0.05938705674604,
          90.84552706
        ],
        [
          0.00010215482561,
          0.07736874362063,
          80.97893857
        ],
        [
          0.00016670779418,
          0.06589067683491,
          85.24180521
        ],
        [
          0.00010211520753,
          0.07734092775239,
          81.00842822
        ],
        [
          0.00020679590197,
          0.06034463162713,
          88.06937237
        ],
        [
          0.00010215482561,
          0.07736874362063,
          80.97893857
        ],
        [
          0.0001874009311,
          0.0615053333112,
          88.309448
        ],
        [
          0.00010211520753,
          0.07734092775239,
          81.00842822
        ],
        [
          0.00024655190629,
          0.05438311723752,
          92.60673444
        ],
        [
          0.0001014793784,
          0.07738346396726,
          81.05155391
        ],
        [
          0.00016524525187,
          0.06514686507791,
          86.1761884
        ],
        [
          0.00010143739183,
          0.07735600239583,
          81.08108727
        ],
        [
          0.00020175586917,
          0.05980236712508,
          89.12832199
        ],
        [
          0.0001014793784,
          0.07738346396726,
          81.05155391
        ],
        [
          0.00018158470534,
          0.06105821436855,
          89.35127332
        ],
        [
          0.00010143739183,
          0.07735600239583,
          81.08108727
        ],
        [
          0.00023613521891,
          0.05403958575437,
          93.87264628
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00012481321991,
          0.0723541495173,
          82.90446958
        ],
        [
          0.00010242751137,
          0.07742061379035,
          80.89895765
        ],
        [
          0.00012469899419,
          0.07233373572104,
          82.93660173
        ],
        [
          0.00010246376867,
          0.07744889322587,
          80.86956391
        ],
        [
          0.00014915252104,
          0.06717492821332,
          85.54934655
        ],
        [
          0.00010242751137,
          0.07742061379035,
          80.89895765
        ],
        [
          0.00014887458958,
          0.06716782669225,
          85.58450234
        ],
        [
          0.00010181635291,
          0.07746029714462,
          80.94122926
        ],
        [
          0.00012602700662,
          0.07136375324973,
          83.72710905
        ],
        [
          0.00010177776779,
          0.07743236128663,
          80.97066728
        ],
        [
          0.00012586956151,
          0.07134800804267,
          83.75997761
        ],
        [
          0.00010181635291,
          0.07746029714462,
          80.94122926
        ],
        [
          0.00014689642116,
          0.06652830512003,
          86.46428877
        ],
        [
          0.00010177776779,
          0.07743236128663,
          80.97066728
        ],
        [
          0.00014656947819,
          0.06652604221631,
          86.50010687
        ],
        [
          0.00010246376867,
          0.07744889322587,
          80.86956391
        ],
        [
          0.00012481321991,
          0.0723541495173,
          82.90446958
        ],
        [
          0.00010242751137,
          0.07742061379035,
          80.89895765
        ],
        [
          0.00012469899419,
          0.07233373572104,
          82.93660173
        ],
        [
          0.00010246376867,
          0.07744889322587,
          80.86956391
        ],
        [
          0.00014915252104,
          0.06717492821332,
          85.54934655
        ],
        [
          0.00010242751137,
          0.07742061379035,
          80.89895765
        ],
        [
          0.00016879750719,
          0.06487224517593,
          86.14946606
        ],
        [
          0.00010181635291,
          0.07746029714462,
          80.94122926
        ],
        [
          0.00012602700662,
          0.07136375324973,
          83.72710905
        ],
        [
          0.00010177776779,
          0.07743236128663,
          80.97066728
        ],
        [
          0.00012586956151,
          0.07134800804267,
          83.75997761
        ],
        [
          0.00010181635291,
          0.07746029714462,
          80.94122926
        ],
        [
          0.00014689642116,
          0.06652830512003,
          86.46428877
        ],
        [
          0.00010177776779,
          0.07743236128663,
          80.97066728
        ],
        [
          0.00016596898607,
          0.06424500860523,
          87.10195031
        ],
        [
          0.00010264263502,
          0.07731959105274,
          80.96071912
        ],
        [
          0.00014052898906,
          0.06963606610426,
          83.89357288
        ],
        [
          0.00010260334002,
          0.07729171491331,
          80.99020662
        ],
        [
          0.00018004420414,
          0.0636958074109,
          86.44569544
        ],
        [
          0.00010264263502,
          0.07731959105274,
          80.96071912
        ],
        [
          0.0001632562197,
          0.0648318871276,
          86.70649033
        ],
        [
          0.00010260334002,
          0.07729171491331,
          80.99020662
        ],
        [
          0.00019750918594,
          0.05961599287757,
          89.70997843
        ],
        [
          0.00010198702709,
          0.07733194797555,
          81.03254762
        ],
        [
          0.00014078640818,
          0.0687533400096,
          84.75913496
        ],
        [
          0.00010194537012,
          0.07730442245528,
          81.06207888
        ],
        [
          0.00017723258304,
          0.06304768079904,
          87.4214247
        ],
        [
          0.00010198702709,
          0.07733194797555,
          81.03254762
        ],
        [
          0.00015961604348,
          0.06427930420875,
          87.66872927
        ],
        [
          0.00010194537012,
          0.07730442245528,
          81.06207888
        ],
        [
          0.00019029098924,
          0.05923727799565,
          90.80198982
        ],
        [
          0.00010264263502,
          0.07731959105274,
          80.96071912
        ],
        [
          0.00016823552574,
          0.06579561848979,
          85.20495585
        ],
        [
          0.00010260334002,
          0.07729171491331,
          80.99020662
        ],
        [
          0.0002089915329,
          0.06023270558705,
          88.02788016
        ],
        [
          0.00010264263502,
          0.07731959105274,
          80.96071912
        ],
        [
          0.00018937926468,
          0.06139280866739,
          88.27131246
        ],
        [
          0.00010260334002,
          0.07729171491331,
          80.99020662
        ],
        [
          0.00024957631384,
          0.05425030368485,
          92.56540523
        ],
        [
          0.00010198702709,
          0.07733194797555,
          81.03254762
        ],
        [
          0.00016706830395,
          0.06503141380171,
          86.13390404
        ],
        [
          0.00010194537012,
          0.07730442245528,
          81.06207888
        ],
        [
          0.00020431973183,
          0.0596672605419,
          89.08181448
        ],
        [
          0.00010198702709,
          0.07733194797555,
          81.03254762
        ],
        [
          0.00018390137893,
          0.0609211873767,
          89.30832697
        ],
        [
          0.00010194537012,
          0.07730442245528,
          81.06207888
        ],
        [
          0.00023962297753,
          0.05387848047477,
          93.82786131
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00012570900256,
          0.07228066616418,
          82.87603848
        ],
        [
          0.00010287616455,
          0.07737583241879,
          80.8819368
        ],
        [
          0.00012560757675,
          0.07225911042633,
          82.9077863
        ],
        [
          0.0001029022707,
          0.07740514670386,
          80.85291829
        ],
        [
          0.00015037460285,
          0.06708903299494,
          85.51862537
        ],
        [
          0.00010287616455,
          0.07737583241879,
          80.8819368
        ],
        [
          0.00015011261677,
          0.06708061923752,
          85.55339911
        ],
        [
          0.00010228127034,
          0.07741359742932,
          80.92354261
        ],
        [
          0.00012712788754,
          0.07127365787624,
          83.69355163
        ],
        [
          0.00010225282483,
          0.07738461817338,
          80.95260553
        ],
        [
          0.00012698370421,
          0.07125668401915,
          83.72603878
        ],
        [
          0.00010228127034,
          0.07741359742932,
          80.92354261
        ],
        [
          0.00014836582163,
          0.06642260130974,
          86.42865454
        ],
        [
          0.00010225282483,
          0.07738461817338,
          80.95260553
        ],
        [
          0.00014805497165,
          0.06641890956037,
          86.46410072
        ],
        [
          0.0001029022707,
          0.07740514670386,
          80.85291829
        ],
        [
          0.00012570900256,
          0.07228066616418,
          82.87603848
        ],
        [
          0.00010287616455,
          0.07737583241879,
          80.8819368
        ],
        [
          0.00012560757675,
          0.07225911042633,
          82.9077863
        ],
        [
          0.0001029022707,
          0.07740514670386,
          80.85291829
        ],
        [
          0.00015037460285,
          0.06708903299494,
          85.51862537
        ],
        [
          0.00010287616455,
          0.07737583241879,
          80.8819368
        ],
        [
          0.00017017605287,
          0.0647867008803,
          86.11785302
        ],
        [
          0.00010228127034,
          0.07741359742932,
          80.92354261
        ],
        [
          0.00012712788754,
          0.07127365787624,
          83.69355163
        ],
        [
          0.00010225282483,
          0.07738461817338,
          80.95260553
        ],
        [
          0.00012698370421,
          0.07125668401915,
          83.72603878
        ],
        [
          0.00010228127034,
          0.07741359742932,
          80.92354261
        ],
        [
          0.00014836582163,
          0.06642260130974,
          86.42865454
        ],
        [
          0.00010225282483,
          0.07738461817338,
          80.95260553
        ],
        [
          0.000167623564,
          0.06413968778868,
          87.06540946
        ],
        [
          0.00010310126665,
          0.07727389999792,
          80.94337123
        ],
        [
          0.00014168504034,
          0.06955162261153,
          83.86058373
        ],
        [
          0.00010307217794,
          0.07724498227507,
          80.97248326
        ],
        [
          0.00018176592108,
          0.0635962626733,
          86.40747181
        ],
        [
          0.00010310126665,
          0.07727389999792,
          80.94337123
        ],
        [
          0.00016480043888,
          0.06473219600858,
          86.6714297
        ],
        [
          0.00010307217794,
          0.07724498227507,
          80.97248326
        ],
        [
          0.00019971809799,
          0.05949633350824,
          89.67075851
        ],
        [
          0.00010247213097,
          0.07728328452613,
          81.01415853
        ],
        [
          0.00014217677689,
          0.06865109874919,
          84.72102828
        ],
        [
          0.00010244066778,
          0.07725470867231,
          81.04331447
        ],
        [
          0.00017925359227,
          0.06292789278774,
          87.37828779
        ],
        [
          0.00010247213097,
          0.07728328452613,
          81.01415853
        ],
        [
          0.00016143453163,
          0.06415826004519,
          87.62892012
        ],
        [
          0.00010244066778,
          0.07725470867231,
          81.04331447
        ],
        [
          0.00019283823234,
          0.05909295297185,
          90.7586947
        ],
        [
          0.00010310126665,
          0.07727389999792,
          80.94337123
        ],
        [
          0.00016972447176,
          0.06570439118669,
          85.16860782
        ],
        [
          0.00010307217794,
          0.07724498227507,
          80.97248326
        ],
        [
          0.00021115147686,
          0.06012440845845,
          87.9865005
        ],
        [
          0.00010310126665,
          0.07727389999792,
          80.94337123
        ],
        [
          0.00019132457642,
          0.06128389345279,
          88.23332962
        ],
        [
          0.00010307217794,
          0.07724498227507,
          80.97248326
        ],
        [
          0.00025257193557,
          0.0541210678076,
          92.52367316
        ],
        [
          0.00010247213097,
          0.07728328452613,
          81.01415853
        ],
        [
          0.00016883523115,
          0.06492136486376,
          86.09247093
        ],
        [
          0.00010244066778,
          0.07725470867231,
          81.04331447
        ],
        [
          0.00020682704605,
          0.05953749973089,
          89.03573514
        ],
        [
          0.00010247213097,
          0.07728328452613,
          81.01415853
        ],
        [
          0.00018616557761,
          0.06078957515201,
          89.26584271
        ],
        [
          0.00010244066778,
          0.07725470867231,
          81.04331447
        ],
        [
          0.00024305589582,
          0.05372300004325,
          93.78288671
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00012657936013,
          0.07221027626599,
          82.84805594
        ],
        [
          0.00010330449699,
          0.07733358112287,
          80.8654531
        ],
        [
          0.00012649304129,
          0.07218741678196,
          82.87934243
        ],
        [
          0.00010331865895,
          0.07736409035457,
          80.83688324
        ],
        [
          0.00015158055302,
          0.06700545942741,
          85.48792424
        ],
        [
          0.00010330449699,
          0.07733358112287,
          80.8654531
        ],
        [
          0.00015133755596,
          0.06699555182456,
          85.52223618
        ],
        [
          0.00010272518449,
          0.07736953646599,
          80.90641505
        ],
        [
          0.00012822176261,
          0.07118548721886,
          83.65982357
        ],
        [
          0.00010270867551,
          0.07733935277173,
          80.93502942
        ],
        [
          0.00012809334854,
          0.07116710953319,
          83.69185169
        ],
        [
          0.00010272518449,
          0.07736953646599,
          80.90641505
        ],
        [
          0.00014984399251,
          0.06631789785167,
          86.39239322
        ],
        [
          0.00010270867551,
          0.07733935277173,
          80.93502942
        ],
        [
          0.00014955244928,
          0.06631258173889,
          86.42738787
        ],
        [
          0.00010331865895,
          0.07736409035457,
          80.83688324
        ],
        [
          0.00012657936013,
          0.07221027626599,
          82.84805594
        ],
        [
          0.00010330449699,
          0.07733358112287,
          80.8654531
        ],
        [
          0.00012649304129,
          0.07218741678196,
          82.87934243
        ],
        [
          0.00010331865895,
          0.07736409035457,
          80.83688324
        ],
        [
          0.00015158055302,
          0.06700545942741,
          85.48792424
        ],
        [
          0.00010330449699,
          0.07733358112287,
          80.8654531
        ],
        [
          0.00017153894755,
          0.06470333698984,
          86.08616764
        ],
        [
          0.00010272518449,
          0.07736953646599,
          80.90641505
        ],
        [
          0.00012822176261,
          0.07118548721886,
          83.65982357
        ],
        [
          0.00010270867551,
          0.07733935277173,
          80.93502942
        ],
        [
          0.00012809334854,
          0.07116710953319,
          83.69185169
        ],
        [
          0.00010272518449,
          0.07736953646599,
          80.90641505
        ],
        [
          0.00014984399251,
          0.06631789785167,
          86.39239322
        ],
        [
          0.00010270867551,
          0.07733935277173,
          80.93502942
        ],
        [
          0.00016929007919,
          0.06403526210917,
          87.02813399
        ],
        [
          0.00010354324213,
          0.07723038827241,
          80.92641441
        ],
        [
          0.00014283146625,
          0.06946914864205,
          83.82744995
        ],
        [
          0.00010352617065,
          0.07720026763435,
          80.9550774
        ],
        [
          0.00018349057345,
          0.06349815461861,
          86.36865479
        ],
        [
          0.00010354324213,
          0.07723038827241,
          80.92641441
        ],
        [
          0.00016635162426,
          0.06463357615158,
          86.63575864
        ],
        [
          0.00010352617065,
          0.07720026763435,
          80.9550774
        ],
        [
          0.00020195567135,
          0.05937714415673,
          89.63042143
        ],
        [
          0.00010294169569,
          0.07723674621749,
          80.99610894
        ],
        [
          0.00014357952913,
          0.06854961934166,
          84.68213819
        ],
        [
          0.00010292224102,
          0.077206957731,
          81.02481597
        ],
        [
          0.00018130768527,
          0.06280826392993,
          87.33388129
        ],
        [
          0.00010294169569,
          0.07723674621749,
          80.99610894
        ],
        [
          0.00016328907944,
          0.06403687049867,
          87.58784152
        ],
        [
          0.00010292224102,
          0.077206957731,
          81.02481597
        ],
        [
          0.00019545226362,
          0.05894757534107,
          90.71360074
        ],
        [
          0.00010354324213,
          0.07723038827241,
          80.92641441
        ],
        [
          0.00017123128113,
          0.06561353489156,
          85.1313243
        ],
        [
          0.00010352617065,
          0.07720026763435,
          80.9550774
        ],
        [
          0.00021335323518,
          0.06001589221543,
          87.94367597
        ],
        [
          0.00010354324213,
          0.07723038827241,
          80.92641441
        ],
        [
          0.0001933150971,
          0.06117424615691,
          88.19390773
        ],
        [
          0.00010352617065,
          0.07720026763435,
          80.9550774
        ],
        [
          0.0002556521701,
          0.05399059444329,
          92.47985814
        ],
        [
          0.00010294169569,
          0.07723674621749,
          80.99610894
        ],
        [
          0.0001706476795,
          0.06481040288949,
          86.04943995
        ],
        [
          0.00010292224102,
          0.077206957731,
          81.02481597
        ],
        [
          0.00020941283014,
          0.0594061439164,
          88.98751641
        ],
        [
          0.00010294169569,
          0.07723674621749,
          80.99610894
        ],
        [
          0.00018851022074,
          0.06065570166927,
          89.22124902
        ],
        [
          0.00010292224102,
          0.077206957731,
          81.02481597
        ],
        [
          0.00024662240115,
          0.05356471409134,
          93.73512087
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00012744810813,
          0.07214105533582,
          82.81971819
        ],
        [
          0.00010371274929,
          0.07729380985759,
          80.8494901
        ],
        [
          0.00012737558547,
          0.07211702231203,
          82.85058209
        ],
        [
          0.00010371610676,
          0.07732538408488,
          80.82133058
        ],
        [
          0.00015279762152,
          0.06692234593222,
          85.45650124
        ],
        [
          0.00010371274929,
          0.07729380985759,
          80.8494901
        ],
        [
          0.00015257197171,
          0.06691108596611,
          85.49039028
        ],
        [
          0.0001031362074,
          0.07732924818238,
          80.89030425
        ],
        [
          0.00012930028955,
          0.07109993090698,
          83.62612074
        ],
        [
          0.00010313049122,
          0.07729799221813,
          80.9185084
        ],
        [
          0.00012918628673,
          0.0710802906491,
          83.6577281
        ],
        [
          0.0001031362074,
          0.07732924818238,
          80.89030425
        ],
        [
          0.00015131725188,
          0.06621519785714,
          86.35578221
        ],
        [
          0.00010313049122,
          0.07729799221813,
          80.9185084
        ],
        [
          0.00015104339153,
          0.0662084096649,
          86.39036313
        ],
        [
          0.00010371610676,
          0.07732538408488,
          80.82133058
        ],
        [
          0.00012744810813,
          0.07214105533582,
          82.81971819
        ],
        [
          0.00010371274929,
          0.07729380985759,
          80.8494901
        ],
        [
          0.00012737558547,
          0.07211702231203,
          82.85058209
        ],
        [
          0.00010371610676,
          0.07732538408488,
          80.82133058
        ],
        [
          0.00015279762152,
          0.06692234593222,
          85.45650124
        ],
        [
          0.00010371274929,
          0.07729380985759,
          80.8494901
        ],
        [
          0.00017291128631,
          0.06462064616823,
          86.05377535
        ],
        [
          0.0001031362074,
          0.07732924818238,
          80.89030425
        ],
        [
          0.00012930028955,
          0.07109993090698,
          83.62612074
        ],
        [
          0.00010313049122,
          0.07729799221813,
          80.9185084
        ],
        [
          0.00012918628673,
          0.0710802906491,
          83.6577281
        ],
        [
          0.0001031362074,
          0.07732924818238,
          80.89030425
        ],
        [
          0.00015131725188,
          0.06621519785714,
          86.35578221
        ],
        [
          0.00010313049122,
          0.07729799221813,
          80.9185084
        ],
        [
          0.0001709478945,
          0.06393305909654,
          86.99052355
        ],
        [
          0.00010396537459,
          0.07718934889266,
          80.90996081
        ],
        [
          0.0001439658882,
          0.06938882717538,
          83.79419085
        ],
        [
          0.00010395918041,
          0.07715815575251,
          80.93821306
        ],
        [
          0.00018522694064,
          0.06340104040763,
          86.32897519
        ],
        [
          0.00010396537459,
          0.07718934889266,
          80.90996081
        ],
        [
          0.00016790283877,
          0.06453650935574,
          86.59957652
        ],
        [
          0.00010395918041,
          0.07715815575251,
          80.93821306
        ],
        [
          0.00020422779756,
          0.05925821227668,
          89.5887725
        ],
        [
          0.00010337741569,
          0.07719410747474,
          80.97909728
        ],
        [
          0.00014495514476,
          0.06845177634154,
          84.64350016
        ],
        [
          0.00010336882575,
          0.07716323904428,
          81.00739372
        ],
        [
          0.00018335536806,
          0.06269116123287,
          87.28897629
        ],
        [
          0.00010337741569,
          0.07719410747474,
          80.97909728
        ],
        [
          0.00016512610637,
          0.06391869293171,
          87.54660944
        ],
        [
          0.00010336882575,
          0.07716323904428,
          81.00739372
        ],
        [
          0.00019808015934,
          0.05880421086957,
          90.66751946
        ],
        [
          0.00010396537459,
          0.07718934889266,
          80.90996081
        ],
        [
          0.00017271757737,
          0.06552540265646,
          85.09399158
        ],
        [
          0.00010395918041,
          0.07715815575251,
          80.93821306
        ],
        [
          0.00021556090862,
          0.05990901702533,
          87.90001454
        ],
        [
          0.00010396537459,
          0.07718934889266,
          80.90996081
        ],
        [
          0.0001952982629,
          0.06106683763107,
          88.15401073
        ],
        [
          0.00010395918041,
          0.07715815575251,
          80.93821306
        ],
        [
          0.00025876270545,
          0.05386133002484,
          92.4346063
        ],
        [
          0.00010337741569,
          0.07719410747474,
          80.97909728
        ],
        [
          0.00017242164068,
          0.06470371728883,
          86.00673151
        ],
        [
          0.00010336882575,
          0.07716323904428,
          81.00739372
        ],
        [
          0.00021198326595,
          0.05927806549512,
          88.9388049
        ],
        [
          0.00010337741569,
          0.07719410747474,
          80.97909728
        ],
        [
          0.00019082706736,
          0.06052583794659,
          89.17651571
        ],
        [
          0.00010336882575,
          0.07716323904428,
          81.00739372
        ],
        [
          0.00025019191683,
          0.05340958654954,
          93.68617269
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00012836752543,
          0.07206896019436,
          82.78924435
        ],
        [
          0.00010413878124,
          0.07725286151325,
          80.8325368
        ],
        [
          0.00012830987995,
          0.07204368928331,
          82.81964762
        ],
        [
          0.00010413056335,
          0.07728555785671,
          80.8048235
        ],
        [
          0.00015410426311,
          0.06683450782848,
          85.42224152
        ],
        [
          0.00010413878124,
          0.07725286151325,
          80.8325368
        ],
        [
          0.00015389739535,
          0.06682181699375,
          85.45566841
        ],
        [
          0.00010356822169,
          0.0772874685996,
          80.87307243
        ],
        [
          0.00013044821152,
          0.0710103942467,
          83.58972165
        ],
        [
          0.00010357407649,
          0.07725508225059,
          80.90083043
        ],
        [
          0.00013034978901,
          0.07098942275953,
          83.62086985
        ],
        [
          0.00010356822169,
          0.0772874685996,
          80.87307243
        ],
        [
          0.00015290473451,
          0.06610639646893,
          86.31576534
        ],
        [
          0.00010357407649,
          0.07725508225059,
          80.90083043
        ],
        [
          0.00015265010146,
          0.06609804926729,
          86.34989331
        ],
        [
          0.00010413056335,
          0.07728555785671,
          80.8048235
        ],
        [
          0.00012836752543,
          0.07206896019436,
          82.78924435
        ],
        [
          0.00010413878124,
          0.07725286151325,
          80.8325368
        ],
        [
          0.00012830987995,
          0.07204368928331,
          82.81964762
        ],
        [
          0.00010413056335,
          0.07728555785671,
          80.8048235
        ],
        [
          0.00015410426311,
          0.06683450782848,
          85.42224152
        ],
        [
          0.00010413878124,
          0.07725286151325,
          80.8325368
        ],
        [
          0.00017438359068,
          0.06453334541971,
          86.01844342
        ],
        [
          0.00010356822169,
          0.0772874685996,
          80.87307243
        ],
        [
          0.00013044821152,
          0.0710103942467,
          83.58972165
        ],
        [
          0.00010357407649,
          0.07725508225059,
          80.90083043
        ],
        [
          0.00013034978901,
          0.07098942275953,
          83.62086985
        ],
        [
          0.00010356822169,
          0.0772874685996,
          80.87307243
        ],
        [
          0.00015290473451,
          0.06610639646893,
          86.31576534
        ],
        [
          0.00010357407649,
          0.07725508225059,
          80.90083043
        ],
        [
          0.00017273285591,
          0.06382490134207,
          86.94939258
        ],
        [
          0.00010440616583,
          0.07714707224131,
          80.89247751
        ],
        [
          0.00014517984365,
          0.06930432653061,
          83.75803264
        ],
        [
          0.00010441163111,
          0.07711474891358,
          80.92028305
        ],
        [
          0.00018710935503,
          0.06329765313628,
          86.28523621
        ],
        [
          0.00010440616583,
          0.07714707224131,
          80.89247751
        ],
        [
          0.00016958309974,
          0.0644331334608,
          86.55976912
        ],
        [
          0.00010441163111,
          0.07711474891358,
          80.92028305
        ],
        [
          0.00020671580768,
          0.05913039207461,
          89.54233449
        ],
        [
          0.00010383580455,
          0.07714985777036,
          80.96088913
        ],
        [
          0.00014643282204,
          0.06834854802534,
          84.60138801
        ],
        [
          0.00010383886886,
          0.07711785068794,
          80.98873894
        ],
        [
          0.00018557999146,
          0.06256637956555,
          87.23941745
        ],
        [
          0.00010383580455,
          0.07714985777036,
          80.96088913
        ],
        [
          0.00016712085205,
          0.06379269787273,
          87.50117856
        ],
        [
          0.00010383886886,
          0.07711785068794,
          80.98873894
        ],
        [
          0.00020096142578,
          0.05865019839041,
          90.61608681
        ],
        [
          0.00010440616583,
          0.07714707224131,
          80.89247751
        ],
        [
          0.00017428484971,
          0.06543410575767,
          85.0539663
        ],
        [
          0.00010441163111,
          0.07711474891358,
          80.92028305
        ],
        [
          0.00021792177332,
          0.05979688344124,
          87.85246614
        ],
        [
          0.00010440616583,
          0.07714707224131,
          80.89247751
        ],
        [
          0.00019741542777,
          0.0609542057725,
          88.11068104
        ],
        [
          0.00010441163111,
          0.07711474891358,
          80.92028305
        ],
        [
          0.00026211925526,
          0.05372464219661,
          92.38458423
        ],
        [
          0.00010383580455,
          0.07714985777036,
          80.96088913
        ],
        [
          0.00017430272982,
          0.06459269471666,
          85.96073639
        ],
        [
          0.00010383886886,
          0.07711785068794,
          80.98873894
        ],
        [
          0.00021474207256,
          0.0591433750724,
          88.88559131
        ],
        [
          0.00010383580455,
          0.07714985777036,
          80.96088913
        ],
        [
          0.00019331081564,
          0.06038929349283,
          89.12775902
        ],
        [
          0.00010383886886,
          0.07711785068794,
          80.98873894
        ],
        [
          0.00025405395922,
          0.05324541840673,
          93.63185875
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00012924504836,
          0.07200131656226,
          82.75963814
        ],
        [
          0.00010452452866,
          0.07721631917717,
          80.8168855
        ],
        [
          0.00012918842764,
          0.07197590248798,
          82.79003991
        ],
        [
          0.00010451586271,
          0.07724906571949,
          80.78917576
        ],
        [
          0.00015538969613,
          0.06674953111031,
          85.38796158
        ],
        [
          0.00010452452866,
          0.07721631917717,
          80.8168855
        ],
        [
          0.00015518369491,
          0.0667366258967,
          85.42139733
        ],
        [
          0.00010398397684,
          0.07724784551865,
          80.85616711
        ],
        [
          0.00013158060016,
          0.07092364801769,
          83.55322694
        ],
        [
          0.00010399031131,
          0.07721540403785,
          80.88392137
        ],
        [
          0.00013148330448,
          0.07090248135927,
          83.58437661
        ],
        [
          0.00010398397684,
          0.07724784551865,
          80.85616711
        ],
        [
          0.00015450769614,
          0.06599850395474,
          86.27471769
        ],
        [
          0.00010399031131,
          0.07721540403785,
          80.88392137
        ],
        [
          0.00015425379438,
          0.06598987659948,
          86.30886154
        ],
        [
          0.00010451586271,
          0.07724906571949,
          80.78917576
        ],
        [
          0.00012924504836,
          0.07200131656226,
          82.75963814
        ],
        [
          0.00010452452866,
          0.07721631917717,
          80.8168855
        ],
        [
          0.00012918842764,
          0.07197590248798,
          82.79003991
        ],
        [
          0.00010451586271,
          0.07724906571949,
          80.78917576
        ],
        [
          0.00015538969613,
          0.06674953111031,
          85.38796158
        ],
        [
          0.00010452452866,
          0.07721631917717,
          80.8168855
        ],
        [
          0.00017581124187,
          0.06445012440795,
          85.98355538
        ],
        [
          0.00010398397684,
          0.07724784551865,
          80.85616711
        ],
        [
          0.00013158060016,
          0.07092364801769,
          83.55322694
        ],
        [
          0.00010399031131,
          0.07721540403785,
          80.88392137
        ],
        [
          0.00013148330448,
          0.07090248135927,
          83.58437661
        ],
        [
          0.00010398397684,
          0.07724784551865,
          80.85616711
        ],
        [
          0.00015450769614,
          0.06599850395474,
          86.27471769
        ],
        [
          0.00010399031131,
          0.07721540403785,
          80.88392137
        ],
        [
          0.00017451285249,
          0.06371900689793,
          86.9076683
        ],
        [
          0.00010481335007,
          0.07710858592162,
          80.87601267
        ],
        [
          0.00014634300359,
          0.06922481875324,
          83.72277399
        ],
        [
          0.00010481928763,
          0.07707620842179,
          80.90381458
        ],
        [
          0.00018894514901,
          0.06319875782089,
          86.24179308
        ],
        [
          0.00010481335007,
          0.07710858592162,
          80.87601267
        ],
        [
          0.00017123624356,
          0.06433324065287,
          86.51992803
        ],
        [
          0.00010481928763,
          0.07707620842179,
          80.90381458
        ],
        [
          0.00020919553158,
          0.05900550558518,
          89.49513303
        ],
        [
          0.00010427357355,
          0.07710821858105,
          80.94316588
        ],
        [
          0.00014789007081,
          0.06824868042166,
          84.55918167
        ],
        [
          0.00010427714141,
          0.0770761522393,
          80.97101191
        ],
        [
          0.00018780037073,
          0.06244437799868,
          87.18909043
        ],
        [
          0.00010427357355,
          0.07710821858105,
          80.94316588
        ],
        [
          0.00016913013761,
          0.06366823446941,
          87.45467496
        ],
        [
          0.00010427714141,
          0.0770761522393,
          80.97101191
        ],
        [
          0.00020388954782,
          0.05849704666178,
          90.56279556
        ],
        [
          0.00010481335007,
          0.07710858592162,
          80.87601267
        ],
        [
          0.0001758264141,
          0.06534599046749,
          85.01387034
        ],
        [
          0.00010481928763,
          0.07707620842179,
          80.90381458
        ],
        [
          0.00022027377953,
          0.05968741385596,
          87.80414578
        ],
        [
          0.00010481335007,
          0.07710858592162,
          80.87601267
        ],
        [
          0.00019954519892,
          0.06084303823175,
          88.06626944
        ],
        [
          0.00010481928763,
          0.07707620842179,
          80.90381458
        ],
        [
          0.00026552273478,
          0.05358900418359,
          92.33253545
        ],
        [
          0.00010427357355,
          0.07710821858105,
          80.94316588
        ],
        [
          0.00017619640917,
          0.06448314404753,
          85.9136336
        ],
        [
          0.00010427714141,
          0.0770761522393,
          80.97101191
        ],
        [
          0.00021754362542,
          0.05900953525338,
          88.83049997
        ],
        [
          0.00010427357355,
          0.07710821858105,
          80.94316588
        ],
        [
          0.00019585769169,
          0.06025213956473,
          89.07685038
        ],
        [
          0.00010427714141,
          0.0770761522393,
          80.97101191
        ],
        [
          0.00025803368214,
          0.05308019169783,
          93.57435704
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00013021881925,
          0.07192763351996,
          82.7261346
        ],
        [
          0.00010494536899,
          0.07717707871667,
          80.79944075
        ],
        [
          0.00013018893486,
          0.07190012976234,
          82.75565811
        ],
        [
          0.00010491590097,
          0.07721177028243,
          80.77257632
        ],
        [
          0.00015679994779,
          0.06665796844223,
          85.34964727
        ],
        [
          0.00010494536899,
          0.07717707871667,
          80.79944075
        ],
        [
          0.00015662831025,
          0.0666426671341,
          85.38218927
        ],
        [
          0.0001044248773,
          0.077206493776,
          80.83785559
        ],
        [
          0.00013285794155,
          0.07082770402943,
          83.51131458
        ],
        [
          0.0001044520416,
          0.07717209139358,
          80.86476431
        ],
        [
          0.0001327889333,
          0.07080429730386,
          83.54158444
        ],
        [
          0.0001044248773,
          0.077206493776,
          80.83785559
        ],
        [
          0.00015629767362,
          0.06588035979356,
          86.22808472
        ],
        [
          0.0001044520416,
          0.07717209139358,
          80.86476431
        ],
        [
          0.00015607938758,
          0.06586913614682,
          86.26134479
        ],
        [
          0.00010491590097,
          0.07721177028243,
          80.77257632
        ],
        [
          0.00013021881925,
          0.07192763351996,
          82.7261346
        ],
        [
          0.00010494536899,
          0.07717707871667,
          80.79944075
        ],
        [
          0.00013018893486,
          0.07190012976234,
          82.75565811
        ],
        [
          0.00010491590097,
          0.07721177028243,
          80.77257632
        ],
        [
          0.00015679994779,
          0.06665796844223,
          85.34964727
        ],
        [
          0.00010494536899,
          0.07717707871667,
          80.79944075
        ],
        [
          0.0001774132358,
          0.06435844458481,
          85.9436237
        ],
        [
          0.0001044248773,
          0.077206493776,
          80.83785559
        ],
        [
          0.00013285794155,
          0.07082770402943,
          83.51131458
        ],
        [
          0.0001044520416,
          0.07717209139358,
          80.86476431
        ],
        [
          0.0001327889333,
          0.07080429730386,
          83.54158444
        ],
        [
          0.0001044248773,
          0.077206493776,
          80.83785559
        ],
        [
          0.00015629767362,
          0.06588035979356,
          86.22808472
        ],
        [
          0.0001044520416,
          0.07717209139358,
          80.86476431
        ],
        [
          0.00017653723987,
          0.06360094970022,
          86.85932264
        ],
        [
          0.00010523884884,
          0.07706900274289,
          80.85843675
        ],
        [
          0.00014763961759,
          0.06913791337663,
          83.68270157
        ],
        [
          0.00010526573468,
          0.07703466904441,
          80.88539233
        ],
        [
          0.00019108802049,
          0.06308573254678,
          86.19006304
        ],
        [
          0.00010523884884,
          0.07706900274289,
          80.85843675
        ],
        [
          0.00017306109054,
          0.06422508249314,
          86.47511637
        ],
        [
          0.00010526573468,
          0.07703466904441,
          80.88539233
        ],
        [
          0.00021205725331,
          0.05886445937929,
          89.4394923
        ],
        [
          0.00010474013499,
          0.07706455172988,
          80.92387647
        ],
        [
          0.00014953760075,
          0.06813809994929,
          84.51060702
        ],
        [
          0.00010476467813,
          0.0770305129802,
          80.95087597
        ],
        [
          0.00019040758867,
          0.06230432538909,
          87.12887126
        ],
        [
          0.00010474013499,
          0.07706455172988,
          80.92387647
        ],
        [
          0.00017138204904,
          0.06353164589378,
          87.401631
        ],
        [
          0.00010476467813,
          0.0770305129802,
          80.95087597
        ],
        [
          0.00020729463809,
          0.05832312333536,
          90.49951603
        ],
        [
          0.00010523884884,
          0.07706900274289,
          80.85843675
        ],
        [
          0.00017755768421,
          0.06524904845698,
          84.96792879
        ],
        [
          0.00010526573468,
          0.07703466904441,
          80.88539233
        ],
        [
          0.00022302608257,
          0.05956213251259,
          87.74637426
        ],
        [
          0.00010523884884,
          0.07706900274289,
          80.85843675
        ],
        [
          0.00020191480833,
          0.06072186648821,
          88.01584189
        ],
        [
          0.00010526573468,
          0.07703466904441,
          80.88539233
        ],
        [
          0.00026945815536,
          0.0534358270736,
          92.27066611
        ],
        [
          0.00010474013499,
          0.07706455172988,
          80.92387647
        ],
        [
          0.0001783487689,
          0.06436131955241,
          85.85908477
        ],
        [
          0.00010476467813,
          0.0770305129802,
          80.95087597
        ],
        [
          0.0002208394408,
          0.05885580208965,
          88.76432511
        ],
        [
          0.00010474013499,
          0.07706455172988,
          80.92387647
        ],
        [
          0.00019872850429,
          0.06010096756403,
          89.01832971
        ],
        [
          0.00010476467813,
          0.0770305129802,
          80.95087597
        ],
        [
          0.00026266641448,
          0.05289276884287,
          93.50546712
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00013120247889,
          0.07185470864917,
          82.69155435
        ],
        [
          0.0001053479386,
          0.07714019340165,
          80.78235581
        ],
        [
          0.00013119023197,
          0.07182584157857,
          82.72050492
        ],
        [
          0.00010530505172,
          0.07717611503056,
          80.75604183
        ],
        [
          0.00015831746166,
          0.06656138212711,
          85.30757735
        ],
        [
          0.0001053479386,
          0.07714019340165,
          80.78235581
        ],
        [
          0.000158168498,
          0.06654448064905,
          85.33953911
        ],
        [
          0.0001048487071,
          0.07716743819821,
          80.81983744
        ],
        [
          0.00013415264863,
          0.0707325360714,
          83.46798429
        ],
        [
          0.00010488932902,
          0.07713179413895,
          80.84619542
        ],
        [
          0.0001341024365,
          0.07070764783683,
          83.49768044
        ],
        [
          0.0001048487071,
          0.07716743819821,
          80.81983744
        ],
        [
          0.0001582099071,
          0.06575683926701,
          86.17732422
        ],
        [
          0.00010488932902,
          0.07713179413895,
          80.84619542
        ],
        [
          0.00015801519042,
          0.06574386008536,
          86.21001232
        ],
        [
          0.00010530505172,
          0.07717611503056,
          80.75604183
        ],
        [
          0.00013120247889,
          0.07185470864917,
          82.69155435
        ],
        [
          0.0001053479386,
          0.07714019340165,
          80.78235581
        ],
        [
          0.00013119023197,
          0.07182584157857,
          82.72050492
        ],
        [
          0.00010530505172,
          0.07717611503056,
          80.75604183
        ],
        [
          0.00015831746166,
          0.06656138212711,
          85.30757735
        ],
        [
          0.0001053479386,
          0.07714019340165,
          80.78235581
        ],
        [
          0.00017911969851,
          0.06426275697024,
          85.90016595
        ],
        [
          0.0001048487071,
          0.07716743819821,
          80.81983744
        ],
        [
          0.00013415264863,
          0.0707325360714,
          83.46798429
        ],
        [
          0.00010488932902,
          0.07713179413895,
          80.84619542
        ],
        [
          0.0001341024365,
          0.07070764783683,
          83.49768044
        ],
        [
          0.0001048487071,
          0.07716743819821,
          80.81983744
        ],
        [
          0.0001582099071,
          0.06575683926701,
          86.17732422
        ],
        [
          0.00010488932902,
          0.07713179413895,
          80.84619542
        ],
        [
          0.00017868173042,
          0.06347861185526,
          86.8070641
        ],
        [
          0.00010565650269,
          0.07703082450026,
          80.84077552
        ],
        [
          0.00014898354785,
          0.06904977163104,
          83.64027676
        ],
        [
          0.000105696924,
          0.07699525153267,
          80.86717983
        ],
        [
          0.00019331625063,
          0.06297093049891,
          86.13509843
        ],
        [
          0.00010565650269,
          0.07703082450026,
          80.84077552
        ],
        [
          0.00017505386767,
          0.06410947035936,
          86.42517694
        ],
        [
          0.000105696924,
          0.07699525153267,
          80.86717983
        ],
        [
          0.00021516403111,
          0.05871497707829,
          89.37769698
        ],
        [
          0.00010519265213,
          0.07702294618754,
          80.90473022
        ],
        [
          0.00015124370641,
          0.06802618682407,
          84.45931348
        ],
        [
          0.00010523076901,
          0.07698765628809,
          80.9311782
        ],
        [
          0.00019311708209,
          0.06216238086806,
          87.06499951
        ],
        [
          0.00010519265213,
          0.07702294618754,
          80.90473022
        ],
        [
          0.00017382112066,
          0.06338710450324,
          87.34307224
        ],
        [
          0.00010523076901,
          0.07698765628809,
          80.9311782
        ],
        [
          0.00021097070203,
          0.05814025022719,
          90.42965326
        ],
        [
          0.00010565650269,
          0.07703082450026,
          80.84077552
        ],
        [
          0.00017935990079,
          0.06515040452489,
          84.91904842
        ],
        [
          0.000105696924,
          0.07699525153267,
          80.86717983
        ],
        [
          0.00022589769235,
          0.05943461244878,
          87.68468534
        ],
        [
          0.00010565650269,
          0.07703082450026,
          80.84077552
        ],
        [
          0.00020450038827,
          0.06059262597289,
          87.95959718
        ],
        [
          0.000105696924,
          0.07699525153267,
          80.86717983
        ],
        [
          0.0002737239492,
          0.05327410120517,
          92.20160853
        ],
        [
          0.00010519265213,
          0.07702294618754,
          80.90473022
        ],
        [
          0.00018058647509,
          0.06423767887786,
          85.80120232
        ],
        [
          0.00010523076901,
          0.07698765628809,
          80.9311782
        ],
        [
          0.00022427512346,
          0.05869973565937,
          88.69377332
        ],
        [
          0.00010519265213,
          0.07702294618754,
          80.90473022
        ],
        [
          0.00020183835376,
          0.05994121583493,
          88.95358004
        ],
        [
          0.00010523076901,
          0.07698765628809,
          80.9311782
        ],
        [
          0.00026766161727,
          0.05269642053883,
          93.42887924
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00013226781099,
          0.07177749106332,
          82.65320311
        ],
        [
          0.00010572637958,
          0.07710617785863,
          80.76587044
        ],
        [
          0.00013225722539,
          0.07174844681631,
          82.68214828
        ],
        [
          0.00010568291735,
          0.07714215103703,
          80.73956137
        ],
        [
          0.00015998754855,
          0.06645740309853,
          85.26024753
        ],
        [
          0.00010572637958,
          0.07710617785863,
          80.76587044
        ],
        [
          0.00015984037559,
          0.06644022750745,
          85.2922154
        ],
        [
          0.00010526601061,
          0.0771297229409,
          80.80163263
        ],
        [
          0.0001355489146,
          0.07063230224669,
          83.42021993
        ],
        [
          0.00010530726515,
          0.07709402104384,
          80.8279853
        ],
        [
          0.00013550065834,
          0.07060717246528,
          83.44991315
        ],
        [
          0.00010526601061,
          0.0771297229409,
          80.80163263
        ],
        [
          0.00016030306276,
          0.06562479945948,
          86.12061005
        ],
        [
          0.00010530726515,
          0.07709402104384,
          80.8279853
        ],
        [
          0.00016011017376,
          0.06561146563128,
          86.15331169
        ],
        [
          0.00010568291735,
          0.07714215103703,
          80.73956137
        ],
        [
          0.00013226781099,
          0.07177749106332,
          82.65320311
        ],
        [
          0.00010572637958,
          0.07710617785863,
          80.76587044
        ],
        [
          0.00013225722539,
          0.07174844681631,
          82.68214828
        ],
        [
          0.00010568291735,
          0.07714215103703,
          80.73956137
        ],
        [
          0.00015998754855,
          0.06645740309853,
          85.26024753
        ],
        [
          0.00010572637958,
          0.07710617785863,
          80.76587044
        ],
        [
          0.00018097037501,
          0.06416128914836,
          85.85192234
        ],
        [
          0.00010526601061,
          0.0771297229409,
          80.80163263
        ],
        [
          0.0001355489146,
          0.07063230224669,
          83.42021993
        ],
        [
          0.00010530726515,
          0.07709402104384,
          80.8279853
        ],
        [
          0.00013550065834,
          0.07060717246528,
          83.44991315
        ],
        [
          0.00010526601061,
          0.0771297229409,
          80.80163263
        ],
        [
          0.00016030306276,
          0.06562479945948,
          86.12061005
        ],
        [
          0.00010530726515,
          0.07709402104384,
          80.8279853
        ],
        [
          0.00018100020619,
          0.06334949494232,
          86.74930524
        ],
        [
          0.00010606191675,
          0.07699447385882,
          80.82318161
        ],
        [
          0.00015043425177,
          0.06895687975999,
          83.59339968
        ],
        [
          0.00010610295507,
          0.07695884449932,
          80.84958081
        ],
        [
          0.00019567504524,
          0.06285246676174,
          86.07551738
        ],
        [
          0.00010606191675,
          0.07699447385882,
          80.82318161
        ],
        [
          0.00017723731052,
          0.06398576351515,
          86.36923785
        ],
        [
          0.00010610295507,
          0.07695884449932,
          80.84958081
        ],
        [
          0.00021850287284,
          0.05855850489086,
          89.30962839
        ],
        [
          0.00010563774,
          0.07698281586304,
          80.88541016
        ],
        [
          0.00015308073349,
          0.06790867458686,
          84.4028777
        ],
        [
          0.00010567653109,
          0.07694746308716,
          80.91185263
        ],
        [
          0.00019598889067,
          0.06201595362182,
          86.99576026
        ],
        [
          0.00010563774,
          0.07698281586304,
          80.88541016
        ],
        [
          0.00017648398818,
          0.06323328217957,
          87.27779531
        ],
        [
          0.00010567653109,
          0.07694746308716,
          80.91185263
        ],
        [
          0.00021492095733,
          0.05794929256056,
          90.35272974
        ],
        [
          0.00010606191675,
          0.07699447385882,
          80.82318161
        ],
        [
          0.00018130335789,
          0.06504666117638,
          84.86505887
        ],
        [
          0.00010610295507,
          0.07695884449932,
          80.84958081
        ],
        [
          0.00022894049422,
          0.05930307234339,
          87.61764347
        ],
        [
          0.00010606191675,
          0.07699447385882,
          80.82318161
        ],
        [
          0.00020732757994,
          0.06045481825047,
          87.89661781
        ],
        [
          0.00010610295507,
          0.07695884449932,
          80.84958081
        ],
        [
          0.00027830067885,
          0.05310550736827,
          92.12515186
        ],
        [
          0.00010563774,
          0.07698281586304,
          80.88541016
        ],
        [
          0.00018299496185,
          0.06410805607111,
          85.73748438
        ],
        [
          0.00010567653109,
          0.07694746308716,
          80.91185263
        ],
        [
          0.00022791974761,
          0.05853884603473,
          88.61706509
        ],
        [
          0.00010563774,
          0.07698281586304,
          80.88541016
        ],
        [
          0.0002052290566,
          0.05977170723996,
          88.88133968
        ],
        [
          0.00010567653109,
          0.07694746308716,
          80.91185263
        ],
        [
          0.00027302024735,
          0.05249227260776,
          93.3439874
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00013334582401,
          0.07170128770091,
          82.61336396
        ],
        [
          0.00010611235772,
          0.07707221851081,
          80.74856508
        ],
        [
          0.00013333699702,
          0.07167205844469,
          82.64230276
        ],
        [
          0.00010606828778,
          0.07710824681369,
          80.7222614
        ],
        [
          0.00016170303936,
          0.06635315602162,
          85.21044289
        ],
        [
          0.00010611235772,
          0.07707221851081,
          80.74856508
        ],
        [
          0.00016155782634,
          0.06633569405743,
          85.24241575
        ],
        [
          0.00010568460199,
          0.07709270096193,
          80.78284306
        ],
        [
          0.00013698450606,
          0.07053189993275,
          83.36990298
        ],
        [
          0.000105726514,
          0.0770569382924,
          80.80918997
        ],
        [
          0.00013693836725,
          0.0705065155327,
          83.399592
        ],
        [
          0.00010568460199,
          0.07709270096193,
          80.78284306
        ],
        [
          0.00016247972852,
          0.06549100661694,
          86.06028664
        ],
        [
          0.000105726514,
          0.0770569382924,
          80.80918997
        ],
        [
          0.00016228889787,
          0.06547729992369,
          86.09300065
        ],
        [
          0.00010606828778,
          0.07710824681369,
          80.7222614
        ],
        [
          0.00013334582401,
          0.07170128770091,
          82.61336396
        ],
        [
          0.00010611235772,
          0.07707221851081,
          80.74856508
        ],
        [
          0.00013333699702,
          0.07167205844469,
          82.64230276
        ],
        [
          0.00010606828778,
          0.07710824681369,
          80.7222614
        ],
        [
          0.00016170303936,
          0.06635315602162,
          85.21044289
        ],
        [
          0.00010611235772,
          0.07707221851081,
          80.74856508
        ],
        [
          0.00018286972798,
          0.06405968886592,
          85.80112835
        ],
        [
          0.00010568460199,
          0.07709270096193,
          80.78284306
        ],
        [
          0.00013698450606,
          0.07053189993275,
          83.36990298
        ],
        [
          0.000105726514,
          0.0770569382924,
          80.80918997
        ],
        [
          0.00013693836725,
          0.0705065155327,
          83.399592
        ],
        [
          0.00010568460199,
          0.07709270096193,
          80.78284306
        ],
        [
          0.00016247972852,
          0.06549100661694,
          86.06028664
        ],
        [
          0.000105726514,
          0.0770569382924,
          80.80918997
        ],
        [
          0.00018340884425,
          0.06321883567835,
          86.68782937
        ],
        [
          0.00010647974637,
          0.07695780946432,
          80.80452254
        ],
        [
          0.00015192172431,
          0.06886412623084,
          83.54407908
        ],
        [
          0.00010652144362,
          0.07692211922638,
          80.83091605
        ],
        [
          0.00019816493815,
          0.06273087935495,
          86.01096629
        ],
        [
          0.00010647974637,
          0.07695780946432,
          80.80452254
        ],
        [
          0.00017950257414,
          0.06386071344165,
          86.30978052
        ],
        [
          0.00010652144362,
          0.07692211922638,
          80.83091605
        ],
        [
          0.00022205142109,
          0.05839691433182,
          89.23531789
        ],
        [
          0.00010608901003,
          0.0769430046984,
          80.86525974
        ],
        [
          0.0001549872503,
          0.06779004022051,
          84.34288797
        ],
        [
          0.00010612850976,
          0.07690758521119,
          80.89169618
        ],
        [
          0.00019904054148,
          0.06186489456918,
          86.9203392
        ],
        [
          0.00010608901003,
          0.0769430046984,
          80.86525974
        ],
        [
          0.00017927387866,
          0.06307655435846,
          87.20782006
        ],
        [
          0.00010612850976,
          0.07690758521119,
          80.89169618
        ],
        [
          0.00021914384284,
          0.05775141685455,
          90.26828644
        ],
        [
          0.00010647974637,
          0.07695780946432,
          80.80452254
        ],
        [
          0.00018332339969,
          0.0649417755524,
          84.80744346
        ],
        [
          0.00010652144362,
          0.07692211922638,
          80.83091605
        ],
        [
          0.00023218061579,
          0.05916707416651,
          87.54425403
        ],
        [
          0.00010647974637,
          0.07695780946432,
          80.80452254
        ],
        [
          0.00021029310772,
          0.06031419936883,
          87.8288229
        ],
        [
          0.00010652144362,
          0.07692211922638,
          80.83091605
        ],
        [
          0.00028319310063,
          0.05293086218012,
          92.04061427
        ],
        [
          0.00010608901003,
          0.0769430046984,
          80.86525974
        ],
        [
          0.00018552135055,
          0.06397596250204,
          85.66896824
        ],
        [
          0.00010612850976,
          0.07690758521119,
          80.89169618
        ],
        [
          0.00023182054906,
          0.05837194591351,
          88.53272439
        ],
        [
          0.00010608901003,
          0.0769430046984,
          80.86525974
        ],
        [
          0.00020881299671,
          0.05959777587238,
          88.80303808
        ],
        [
          0.00010612850976,
          0.07690758521119,
          80.89169618
        ],
        [
          0.00027877371011,
          0.05228042412925,
          93.24957618
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00013445209999,
          0.07162522924421,
          82.5712714
        ],
        [
          0.00010651399003,
          0.0770377287048,
          80.72997638
        ],
        [
          0.00013446096389,
          0.0715947216157,
          82.59960357
        ],
        [
          0.00010645691164,
          0.07707487574915,
          80.70425064
        ],
        [
          0.00016351692809,
          0.06624581815822,
          85.15636255
        ],
        [
          0.00010651399003,
          0.0770377287048,
          80.72997638
        ],
        [
          0.00016339487614,
          0.06622681378234,
          85.18771679
        ],
        [
          0.00010610863585,
          0.07705610224512,
          80.76319932
        ],
        [
          0.00013844336346,
          0.07043275027281,
          83.31736505
        ],
        [
          0.00010616362039,
          0.07701920860947,
          80.78896776
        ],
        [
          0.00013841633202,
          0.07040596128066,
          83.34644444
        ],
        [
          0.00010610863585,
          0.07705610224512,
          80.76319932
        ],
        [
          0.00016475339319,
          0.06535513161154,
          85.99567773
        ],
        [
          0.00010616362039,
          0.07701920860947,
          80.78896776
        ],
        [
          0.0001645869248,
          0.06533972161141,
          86.02777902
        ],
        [
          0.00010645691164,
          0.07707487574915,
          80.70425064
        ],
        [
          0.00013445209999,
          0.07162522924421,
          82.5712714
        ],
        [
          0.00010651399003,
          0.0770377287048,
          80.72997638
        ],
        [
          0.00013446096389,
          0.0715947216157,
          82.59960357
        ],
        [
          0.00010645691164,
          0.07707487574915,
          80.70425064
        ],
        [
          0.00016351692809,
          0.06624581815822,
          85.15636255
        ],
        [
          0.00010651399003,
          0.0770377287048,
          80.72997638
        ],
        [
          0.00018489933602,
          0.06395402663601,
          85.74530696
        ],
        [
          0.00010610863585,
          0.07705610224512,
          80.76319932
        ],
        [
          0.00013844336346,
          0.07043275027281,
          83.31736505
        ],
        [
          0.00010616362039,
          0.07701920860947,
          80.78896776
        ],
        [
          0.00013841633202,
          0.07040596128066,
          83.34644444
        ],
        [
          0.00010610863585,
          0.07705610224512,
          80.76319932
        ],
        [
          0.00016475339319,
          0.06535513161154,
          85.99567773
        ],
        [
          0.00010616362039,
          0.07701920860947,
          80.78896776
        ],
        [
          0.00018594668182,
          0.06308505440065,
          86.62130401
        ],
        [
          0.00010690302866,
          0.07692156237261,
          80.78501335
        ],
        [
          0.00015342383117,
          0.06877315370418,
          83.49282495
        ],
        [
          0.00010695787797,
          0.07688474274326,
          80.81082779
        ],
        [
          0.00020068114426,
          0.06261171833707,
          85.94383093
        ],
        [
          0.00010690302866,
          0.07692156237261,
          80.78501335
        ],
        [
          0.0001818574641,
          0.0637343391181,
          86.24629674
        ],
        [
          0.00010695787797,
          0.07688474274326,
          80.81082779
        ],
        [
          0.00022572612008,
          0.05823470771361,
          89.1560755
        ],
        [
          0.00010654796198,
          0.07690349867351,
          80.84411543
        ],
        [
          0.000156902756,
          0.06767437995163,
          84.28098065
        ],
        [
          0.00010660067784,
          0.07686693728805,
          80.86997229
        ],
        [
          0.00020211324588,
          0.06171759228483,
          86.84228331
        ],
        [
          0.00010654796198,
          0.07690349867351,
          80.84411543
        ],
        [
          0.00018215194153,
          0.06291966294204,
          87.13377558
        ],
        [
          0.00010660067784,
          0.07686693728805,
          80.86997229
        ],
        [
          0.00022349271035,
          0.05755435080927,
          90.17875801
        ],
        [
          0.00010690302866,
          0.07692156237261,
          80.78501335
        ],
        [
          0.00018534315563,
          0.06484003955574,
          84.74812967
        ],
        [
          0.00010695787797,
          0.07688474274326,
          80.81082779
        ],
        [
          0.00023542860903,
          0.05903505478016,
          87.46841983
        ],
        [
          0.00010690302866,
          0.07692156237261,
          80.78501335
        ],
        [
          0.00021334208279,
          0.06017388067815,
          87.75710846
        ],
        [
          0.00010695787797,
          0.07688474274326,
          80.81082779
        ],
        [
          0.00028820596721,
          0.05275790527103,
          91.95078599
        ],
        [
          0.00010654796198,
          0.07690349867351,
          80.84411543
        ],
        [
          0.00018804031964,
          0.06384832408064,
          85.59874139
        ],
        [
          0.00010660067784,
          0.07686693728805,
          80.86997229
        ],
        [
          0.00023572223351,
          0.05821054688675,
          88.44582666
        ],
        [
          0.00010654796198,
          0.07690349867351,
          80.84411543
        ],
        [
          0.00021247787161,
          0.05942550019759,
          88.72071867
        ],
        [
          0.00010660067784,
          0.07686693728805,
          80.86997229
        ],
        [
          0.00028464366422,
          0.05207205702944,
          93.14953815
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00013553285168,
          0.07155318971001,
          82.5287925
        ],
        [
          0.00010688829492,
          0.07700646069153,
          80.71203157
        ],
        [
          0.00013556464034,
          0.07152109977657,
          82.55629641
        ],
        [
          0.00010681427577,
          0.07704502217304,
          80.68709293
        ],
        [
          0.00016536089999,
          0.06613984917544,
          85.09973929
        ],
        [
          0.00010688829492,
          0.07700646069153,
          80.71203157
        ],
        [
          0.00016526925066,
          0.06611893909925,
          85.13024157
        ],
        [
          0.00010650746309,
          0.07702261949733,
          80.74406533
        ],
        [
          0.00013992958029,
          0.0703348881086,
          83.26219412
        ],
        [
          0.00010657947814,
          0.07698429625645,
          80.76904586
        ],
        [
          0.00013992744631,
          0.07030636301545,
          83.29043888
        ],
        [
          0.00010650746309,
          0.07702261949733,
          80.74406533
        ],
        [
          0.00016713373334,
          0.06521719619973,
          85.92613585
        ],
        [
          0.00010657947814,
          0.07698429625645,
          80.76904586
        ],
        [
          0.00016699948261,
          0.0651996854772,
          85.95738906
        ],
        [
          0.00010681427577,
          0.07704502217304,
          80.68709293
        ],
        [
          0.00013553285168,
          0.07155318971001,
          82.5287925
        ],
        [
          0.00010688829492,
          0.07700646069153,
          80.71203157
        ],
        [
          0.00013556464034,
          0.07152109977657,
          82.55629641
        ],
        [
          0.00010681427577,
          0.07704502217304,
          80.68709293
        ],
        [
          0.00016536089999,
          0.06613984917544,
          85.09973929
        ],
        [
          0.00010688829492,
          0.07700646069153,
          80.71203157
        ],
        [
          0.00018696831396,
          0.06384949796457,
          85.68661917
        ],
        [
          0.00010650746309,
          0.07702261949733,
          80.74406533
        ],
        [
          0.00013992958029,
          0.0703348881086,
          83.26219412
        ],
        [
          0.00010657947814,
          0.07698429625645,
          80.76904586
        ],
        [
          0.00013992744631,
          0.07030636301545,
          83.29043888
        ],
        [
          0.00010650746309,
          0.07702261949733,
          80.74406533
        ],
        [
          0.00016713373334,
          0.06521719619973,
          85.92613585
        ],
        [
          0.00010657947814,
          0.07698429625645,
          80.76904586
        ],
        [
          0.00018860801668,
          0.06294911098022,
          86.5494575
        ],
        [
          0.0001072931997,
          0.07688906205991,
          80.76638869
        ],
        [
          0.00015489809976,
          0.06868669562444,
          83.44088394
        ],
        [
          0.00010736516826,
          0.07685081610856,
          80.7914145
        ],
        [
          0.00020321890407,
          0.0624954909353,
          85.87392849
        ],
        [
          0.0001072931997,
          0.07688906205991,
          80.76638869
        ],
        [
          0.00018425024148,
          0.06360982650976,
          86.17985521
        ],
        [
          0.00010736516826,
          0.07685081610856,
          80.7914145
        ],
        [
          0.00022952646647,
          0.05807250936393,
          89.07144517
        ],
        [
          0.00010697992453,
          0.07686733630559,
          80.8235116
        ],
        [
          0.00015885211251,
          0.06756048980988,
          84.21606273
        ],
        [
          0.00010704984972,
          0.07682933309984,
          80.84857907
        ],
        [
          0.0002052954864,
          0.06157025140935,
          86.7589397
        ],
        [
          0.00010697992453,
          0.07686733630559,
          80.8235116
        ],
        [
          0.00018515507764,
          0.06276120446047,
          87.05430258
        ],
        [
          0.00010704984972,
          0.07682933309984,
          80.84857907
        ],
        [
          0.00022808431779,
          0.0573536600438,
          90.08116589
        ],
        [
          0.0001072931997,
          0.07688906205991,
          80.76638869
        ],
        [
          0.00018734007746,
          0.06474274187455,
          84.68755171
        ],
        [
          0.00010736516826,
          0.07685081610856,
          80.7914145
        ],
        [
          0.00023871632209,
          0.05890599527174,
          87.3890474
        ],
        [
          0.0001072931997,
          0.07688906205991,
          80.76638869
        ],
        [
          0.00021645000099,
          0.06003540530756,
          87.68168053
        ],
        [
          0.00010736516826,
          0.07685081610856,
          80.7914145
        ],
        [
          0.00029338791399,
          0.05258556842001,
          91.85420032
        ],
        [
          0.00010697992453,
          0.07686733630559,
          80.8235116
        ],
        [
          0.00019061171789,
          0.06372239951307,
          85.52481226
        ],
        [
          0.00010704984972,
          0.07682933309984,
          80.84857907
        ],
        [
          0.00023976776056,
          0.05804917928771,
          88.35272884
        ],
        [
          0.00010697992453,
          0.07686733630559,
          80.8235116
        ],
        [
          0.00021630488498,
          0.05925168448494,
          88.63208861
        ],
        [
          0.00010704984972,
          0.07682933309984,
          80.84857907
        ],
        [
          0.00029082775167,
          0.05186101520843,
          93.03975941
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00013666987455,
          0.07148000782508,
          82.48245393
        ],
        [
          0.00010724798067,
          0.07697734963917,
          80.69409872
        ],
        [
          0.00013671309066,
          0.0714471293241,
          82.50957614
        ],
        [
          0.00010716620684,
          0.0770165371632,
          80.6695191
        ],
        [
          0.00016733297565,
          0.06603015153747,
          85.03717484
        ],
        [
          0.00010724798067,
          0.07697734963917,
          80.69409872
        ],
        [
          0.00016725658348,
          0.06600823741995,
          85.06728861
        ],
        [
          0.00010690264121,
          0.07699048085349,
          80.72435394
        ],
        [
          0.0001414736017,
          0.0702367681358,
          83.20290111
        ],
        [
          0.000106982504,
          0.07695152058106,
          80.74897462
        ],
        [
          0.00014148415499,
          0.07020734434574,
          83.23076104
        ],
        [
          0.00010690264121,
          0.07699048085349,
          80.72435394
        ],
        [
          0.00016964987875,
          0.06507628156694,
          85.85032141
        ],
        [
          0.000106982504,
          0.07695152058106,
          80.74897462
        ],
        [
          0.00016953196813,
          0.06505763099087,
          85.88119028
        ],
        [
          0.00010716620684,
          0.0770165371632,
          80.6695191
        ],
        [
          0.00013666987455,
          0.07148000782508,
          82.48245393
        ],
        [
          0.00010724798067,
          0.07697734963917,
          80.69409872
        ],
        [
          0.00013671309066,
          0.0714471293241,
          82.50957614
        ],
        [
          0.00010716620684,
          0.0770165371632,
          80.6695191
        ],
        [
          0.00016733297565,
          0.06603015153747,
          85.03717484
        ],
        [
          0.00010724798067,
          0.07697734963917,
          80.69409872
        ],
        [
          0.00018915990722,
          0.06374241201511,
          85.6223002
        ],
        [
          0.00010690264121,
          0.07699048085349,
          80.72435394
        ],
        [
          0.0001414736017,
          0.0702367681358,
          83.20290111
        ],
        [
          0.000106982504,
          0.07695152058106,
          80.74897462
        ],
        [
          0.00014148415499,
          0.07020734434574,
          83.23076104
        ],
        [
          0.00010690264121,
          0.07699048085349,
          80.72435394
        ],
        [
          0.00016964987875,
          0.06507628156694,
          85.85032141
        ],
        [
          0.000106982504,
          0.07695152058106,
          80.74897462
        ],
        [
          0.00019139871294,
          0.06281143960851,
          86.4716267
        ],
        [
          0.00010767721783,
          0.0768580718074,
          80.74732868
        ],
        [
          0.00015646879072,
          0.06859786328732,
          83.38353739
        ],
        [
          0.00010775705858,
          0.07681919124633,
          80.7719945
        ],
        [
          0.00020601195509,
          0.06237228946357,
          85.79423842
        ],
        [
          0.00010767721783,
          0.0768580718074,
          80.74732868
        ],
        [
          0.00018683233141,
          0.06347997500948,
          86.10577391
        ],
        [
          0.00010775705858,
          0.07681919124633,
          80.7719945
        ],
        [
          0.00023373417085,
          0.05789951629267,
          88.97438844
        ],
        [
          0.00010740755911,
          0.07683265875223,
          80.80231067
        ],
        [
          0.00016090305766,
          0.06744499542899,
          84.14543683
        ],
        [
          0.00010748545012,
          0.07679400967634,
          80.82701733
        ],
        [
          0.00020874852883,
          0.06141645393656,
          86.66539788
        ],
        [
          0.00010740755911,
          0.07683265875223,
          80.80231067
        ],
        [
          0.00018835954404,
          0.06259809198302,
          86.96680836
        ],
        [
          0.00010748545012,
          0.07679400967634,
          80.82701733
        ],
        [
          0.00023310655902,
          0.05714272710124,
          89.97062443
        ],
        [
          0.00010767721783,
          0.0768580718074,
          80.74732868
        ],
        [
          0.00018949660281,
          0.06464152317789,
          84.6197353
        ],
        [
          0.00010775705858,
          0.07681919124633,
          80.7719945
        ],
        [
          0.000242363254,
          0.05876832073992,
          87.29770906
        ],
        [
          0.00010767721783,
          0.0768580718074,
          80.74732868
        ],
        [
          0.00021983824702,
          0.05988976211352,
          87.59656846
        ],
        [
          0.00010775705858,
          0.07681919124633,
          80.7719945
        ],
        [
          0.00029915123786,
          0.05240158318728,
          91.74211862
        ],
        [
          0.00010740755911,
          0.07683265875223,
          80.80231067
        ],
        [
          0.00019335196165,
          0.06359322040436,
          85.44328902
        ],
        [
          0.00010748545012,
          0.07679400967634,
          80.82701733
        ],
        [
          0.00024419267951,
          0.05787969755703,
          88.24717308
        ],
        [
          0.00010740755911,
          0.07683265875223,
          80.80231067
        ],
        [
          0.00022042866346,
          0.05907135987298,
          88.5333184
        ],
        [
          0.00010748545012,
          0.07679400967634,
          80.82701733
        ],
        [
          0.00029762132428,
          0.05163907429006,
          92.91374197
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00013778976693,
          0.07141077018539,
          82.43492985
        ],
        [
          0.00010759855661,
          0.07695000488441,
          80.67584056
        ],
        [
          0.00013785019558,
          0.07137677459282,
          82.46141372
        ],
        [
          0.00010750467174,
          0.07699013603685,
          80.65186211
        ],
        [
          0.00016948231999,
          0.06591495382418,
          84.96648158
        ],
        [
          0.00010759855661,
          0.07695000488441,
          80.67584056
        ],
        [
          0.00016942947823,
          0.06589161638999,
          84.99593558
        ],
        [
          0.00010728413183,
          0.07696058494805,
          80.70448184
        ],
        [
          0.00014301564965,
          0.07014263770664,
          83.14138971
        ],
        [
          0.00010737621521,
          0.07692066765508,
          80.72850033
        ],
        [
          0.00014304522582,
          0.07011196237584,
          83.16860438
        ],
        [
          0.00010728413183,
          0.07696058494805,
          80.70448184
        ],
        [
          0.00017238011795,
          0.06492913671032,
          85.76518916
        ],
        [
          0.00010737621521,
          0.07692066765508,
          80.72850033
        ],
        [
          0.00017228745239,
          0.06490889695995,
          85.79539988
        ],
        [
          0.00010750467174,
          0.07699013603685,
          80.65186211
        ],
        [
          0.00013778976693,
          0.07141077018539,
          82.43492985
        ],
        [
          0.00010759855661,
          0.07695000488441,
          80.67584056
        ],
        [
          0.00013785019558,
          0.07137677459282,
          82.46141372
        ],
        [
          0.00010750467174,
          0.07699013603685,
          80.65186211
        ],
        [
          0.00016948231999,
          0.06591495382418,
          84.96648158
        ],
        [
          0.00010759855661,
          0.07695000488441,
          80.67584056
        ],
        [
          0.00019155384777,
          0.06362981117071,
          85.54935391
        ],
        [
          0.00010728413183,
          0.07696058494805,
          80.70448184
        ],
        [
          0.00014301564965,
          0.07014263770664,
          83.14138971
        ],
        [
          0.00010737621521,
          0.07692066765508,
          80.72850033
        ],
        [
          0.00014304522582,
          0.07011196237584,
          83.16860438
        ],
        [
          0.00010728413183,
          0.07696058494805,
          80.70448184
        ],
        [
          0.00017238011795,
          0.06492913671032,
          85.76518916
        ],
        [
          0.00010737621521,
          0.07692066765508,
          80.72850033
        ],
        [
          0.00019443182203,
          0.06266756641649,
          86.38393402
        ],
        [
          0.00010805190357,
          0.07682893295648,
          80.72790633
        ],
        [
          0.00015802860864,
          0.06851322927256,
          83.32427622
        ],
        [
          0.00010814402317,
          0.07678909762265,
          80.75196946
        ],
        [
          0.0002088854228,
          0.06225085214551,
          85.70899608
        ],
        [
          0.00010805190357,
          0.07682893295648,
          80.72790633
        ],
        [
          0.0001896294955,
          0.06334465913818,
          86.02257013
        ],
        [
          0.00010814402317,
          0.07678909762265,
          80.75196946
        ],
        [
          0.00023834725183,
          0.05771774446122,
          88.86380417
        ],
        [
          0.00010782567569,
          0.07679998891822,
          80.78066937
        ],
        [
          0.00016296267124,
          0.06733373025419,
          84.07180234
        ],
        [
          0.0001079159559,
          0.07676037137273,
          80.80477233
        ],
        [
          0.00021231733215,
          0.06126428847529,
          86.56502721
        ],
        [
          0.00010782567569,
          0.07679998891822,
          80.78066937
        ],
        [
          0.00019182216617,
          0.06242880489062,
          86.86893071
        ],
        [
          0.0001079159559,
          0.07676037137273,
          80.80477233
        ],
        [
          0.00023859631917,
          0.05692226144397,
          89.84507401
        ],
        [
          0.00010805190357,
          0.07682893295648,
          80.72790633
        ],
        [
          0.00019165952172,
          0.06454424377219,
          84.54894402
        ],
        [
          0.00010814402317,
          0.07678909762265,
          80.75196946
        ],
        [
          0.0002461316901,
          0.05863224346144,
          87.19943366
        ],
        [
          0.00010805190357,
          0.07682893295648,
          80.72790633
        ],
        [
          0.00022350665302,
          0.05973836795568,
          87.50086536
        ],
        [
          0.00010814402317,
          0.07678909762265,
          80.75196946
        ],
        [
          0.00030544839636,
          0.05220970740103,
          91.61389966
        ],
        [
          0.00010782567569,
          0.07679998891822,
          80.78066937
        ],
        [
          0.00019612437907,
          0.06346801111704,
          85.3576068
        ],
        [
          0.0001079159559,
          0.07676037137273,
          80.80477233
        ],
        [
          0.00024878196268,
          0.05771176190936,
          88.13327112
        ],
        [
          0.00010782567569,
          0.07679998891822,
          80.78066937
        ],
        [
          0.00022488398116,
          0.05888465165598,
          88.42257992
        ],
        [
          0.0001079159559,
          0.07676037137273,
          80.80477233
        ],
        [
          0.00030502286203,
          0.05140887823848,
          92.76977344
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00013895533136,
          0.07134201276918,
          82.38317152
        ],
        [
          0.00010796181991,
          0.07692289187305,
          80.65597722
        ],
        [
          0.00013905064582,
          0.07130590905569,
          82.40821553
        ],
        [
          0.00010784247215,
          0.07696492092738,
          80.63335748
        ],
        [
          0.00017182006042,
          0.06579492949642,
          84.88644722
        ],
        [
          0.00010796181991,
          0.07692289187305,
          80.65597722
        ],
        [
          0.00017181528509,
          0.06576896944115,
          84.9143964
        ],
        [
          0.00010766639053,
          0.0769319203137,
          80.68358052
        ],
        [
          0.0001446352245,
          0.07004825734912,
          83.07396264
        ],
        [
          0.00010778409256,
          0.07689008458428,
          80.70623875
        ],
        [
          0.00014470306399,
          0.07001526747915,
          83.09971979
        ],
        [
          0.00010766639053,
          0.0769319203137,
          80.68358052
        ],
        [
          0.00017535420202,
          0.06477574774195,
          85.6688466
        ],
        [
          0.00010778409256,
          0.07689008458428,
          80.70623875
        ],
        [
          0.00017531306226,
          0.06475263347102,
          85.69754638
        ],
        [
          0.00010784247215,
          0.07696492092738,
          80.63335748
        ],
        [
          0.00013895533136,
          0.07134201276918,
          82.38317152
        ],
        [
          0.00010796181991,
          0.07692289187305,
          80.65597722
        ],
        [
          0.00013905064582,
          0.07130590905569,
          82.40821553
        ],
        [
          0.00010784247215,
          0.07696492092738,
          80.63335748
        ],
        [
          0.00017182006042,
          0.06579492949642,
          84.88644722
        ],
        [
          0.00010796181991,
          0.07692289187305,
          80.65597722
        ],
        [
          0.00019418872717,
          0.06351124357721,
          85.4656579
        ],
        [
          0.00010766639053,
          0.0769319203137,
          80.68358052
        ],
        [
          0.0001446352245,
          0.07004825734912,
          83.07396264
        ],
        [
          0.00010778409256,
          0.07689008458428,
          80.70623875
        ],
        [
          0.00014470306399,
          0.07001526747915,
          83.09971979
        ],
        [
          0.00010766639053,
          0.0769319203137,
          80.68358052
        ],
        [
          0.00017535420202,
          0.06477574774195,
          85.6688466
        ],
        [
          0.00010778409256,
          0.07689008458428,
          80.70623875
        ],
        [
          0.00019776801465,
          0.06251630308783,
          86.28354994
        ],
        [
          0.00010842572092,
          0.07680111281378,
          80.70756541
        ],
        [
          0.00015965275668,
          0.0684292372596,
          83.25975693
        ],
        [
          0.00010854359302,
          0.07675936295945,
          80.73026694
        ],
        [
          0.00021188473009,
          0.06213014818998,
          85.61607326
        ],
        [
          0.00010842572092,
          0.07680111281378,
          80.70756541
        ],
        [
          0.00019265957482,
          0.06320446216265,
          85.9287506
        ],
        [
          0.00010854359302,
          0.07675936295945,
          80.73026694
        ],
        [
          0.00024331889683,
          0.05753109083871,
          88.73946239
        ],
        [
          0.00010824440012,
          0.07676868198711,
          80.7579273
        ],
        [
          0.00016512557083,
          0.06722230970244,
          83.99114716
        ],
        [
          0.00010836059002,
          0.07672712898524,
          80.78066716
        ],
        [
          0.00021606960902,
          0.06111200849865,
          86.4549886
        ],
        [
          0.00010824440012,
          0.07676868198711,
          80.7579273
        ],
        [
          0.00019558214831,
          0.06225322549217,
          86.75846881
        ],
        [
          0.00010836059002,
          0.07672712898524,
          80.78066716
        ],
        [
          0.00024453118645,
          0.05669568194081,
          89.70349269
        ],
        [
          0.00010842572092,
          0.07680111281378,
          80.70756541
        ],
        [
          0.00019393406685,
          0.06444685608093,
          84.47110335
        ],
        [
          0.00010854359302,
          0.07675936295945,
          80.73026694
        ],
        [
          0.00025009508388,
          0.05849619369653,
          87.09134231
        ],
        [
          0.00010842572092,
          0.07680111281378,
          80.70756541
        ],
        [
          0.00022749608226,
          0.05958122855642,
          87.39234637
        ],
        [
          0.00010854359302,
          0.07675936295945,
          80.73026694
        ],
        [
          0.00031226018289,
          0.05201289909727,
          91.46810456
        ],
        [
          0.00010824440012,
          0.07676868198711,
          80.7579273
        ],
        [
          0.00019905834635,
          0.06334183328016,
          85.26298746
        ],
        [
          0.00010836059002,
          0.07672712898524,
          80.78066716
        ],
        [
          0.00025363620322,
          0.05754305327027,
          88.00738659
        ],
        [
          0.00010824440012,
          0.07676868198711,
          80.7579273
        ],
        [
          0.0002297377719,
          0.05869084000346,
          88.29689348
        ],
        [
          0.00010836059002,
          0.07672712898524,
          80.78066716
        ],
        [
          0.00031304453696,
          0.05117292205943,
          92.60550362
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00014016656618,
          0.07127446501653,
          82.32656903
        ],
        [
          0.00010829385881,
          0.07689939990931,
          80.63680095
        ],
        [
          0.00014027972915,
          0.07123731762248,
          82.35090506
        ],
        [
          0.00010816245193,
          0.07694227910135,
          80.61484139
        ],
        [
          0.00017431898711,
          0.06567291314779,
          84.79697149
        ],
        [
          0.00010829385881,
          0.07689939990931,
          80.63680095
        ],
        [
          0.00017433956637,
          0.06564557144837,
          84.82417921
        ],
        [
          0.00010803368673,
          0.07690581124121,
          80.66237372
        ],
        [
          0.00014636921636,
          0.06995262371459,
          82.99820801
        ],
        [
          0.00010816359253,
          0.07686311127272,
          80.6843703
        ],
        [
          0.00014645721921,
          0.06991844049301,
          83.02324558
        ],
        [
          0.00010803368673,
          0.07690581124121,
          80.66237372
        ],
        [
          0.00017859503982,
          0.06461692479584,
          85.55927714
        ],
        [
          0.00010816359253,
          0.07686311127272,
          80.6843703
        ],
        [
          0.00017858157594,
          0.06459225241967,
          85.58723189
        ],
        [
          0.00010816245193,
          0.07694227910135,
          80.61484139
        ],
        [
          0.00014016656618,
          0.07127446501653,
          82.32656903
        ],
        [
          0.00010829385881,
          0.07689939990931,
          80.63680095
        ],
        [
          0.00014027972915,
          0.07123731762248,
          82.35090506
        ],
        [
          0.00010816245193,
          0.07694227910135,
          80.61484139
        ],
        [
          0.00017431898711,
          0.06567291314779,
          84.79697149
        ],
        [
          0.00010829385881,
          0.07689939990931,
          80.63680095
        ],
        [
          0.00019697084997,
          0.06339237107672,
          85.37309338
        ],
        [
          0.00010803368673,
          0.07690581124121,
          80.66237372
        ],
        [
          0.00014636921636,
          0.06995262371459,
          82.99820801
        ],
        [
          0.00010816359253,
          0.07686311127272,
          80.6843703
        ],
        [
          0.00014645721921,
          0.06991844049301,
          83.02324558
        ],
        [
          0.00010803368673,
          0.07690581124121,
          80.66237372
        ],
        [
          0.00017859503982,
          0.06461692479584,
          85.55927714
        ],
        [
          0.00010816359253,
          0.07686311127272,
          80.6843703
        ],
        [
          0.0002013645772,
          0.06236157934892,
          86.17040052
        ],
        [
          0.00010878403722,
          0.07677583175479,
          80.68697642
        ],
        [
          0.00016135286574,
          0.0683462000428,
          83.18874778
        ],
        [
          0.00010891416232,
          0.07673322001835,
          80.70901582
        ],
        [
          0.0002150311146,
          0.0620105503507,
          85.51374603
        ],
        [
          0.00010878403722,
          0.07677583175479,
          80.68697642
        ],
        [
          0.00019590853492,
          0.06306171723944,
          85.82354675
        ],
        [
          0.00010891416232,
          0.07673322001835,
          80.70901582
        ],
        [
          0.0002486389473,
          0.05734211648283,
          88.60000881
        ],
        [
          0.00010865054701,
          0.076739893404,
          80.73464223
        ],
        [
          0.00016744698292,
          0.06710924347374,
          83.90037408
        ],
        [
          0.00010877913612,
          0.07669746409475,
          80.75671851
        ],
        [
          0.00022008645413,
          0.06095805616366,
          86.33154567
        ],
        [
          0.00010865054701,
          0.076739893404,
          80.73464223
        ],
        [
          0.00019968345246,
          0.06207159398093,
          86.6326687
        ],
        [
          0.00010877913612,
          0.07669746409475,
          80.75671851
        ],
        [
          0.00025097699803,
          0.05646339502703,
          89.54236367
        ],
        [
          0.00010878403722,
          0.07677583175479,
          80.68697642
        ],
        [
          0.0001962763132,
          0.06435222756133,
          84.38683941
        ],
        [
          0.00010891416232,
          0.07673322001835,
          80.70901582
        ],
        [
          0.00025420131063,
          0.05836327554882,
          86.97364301
        ],
        [
          0.00010878403722,
          0.07677583175479,
          80.68697642
        ],
        [
          0.00023171401583,
          0.05942379538742,
          87.27216009
        ],
        [
          0.00010891416232,
          0.07673322001835,
          80.70901582
        ],
        [
          0.00031944646209,
          0.05181754267193,
          91.30568203
        ],
        [
          0.00010865054701,
          0.076739893404,
          80.73464223
        ],
        [
          0.00020215832125,
          0.06321593640876,
          85.15812498
        ],
        [
          0.00010877913612,
          0.07669746409475,
          80.75671851
        ],
        [
          0.00025876885193,
          0.05737494988356,
          87.86762582
        ],
        [
          0.00010865054701,
          0.076739893404,
          80.73464223
        ],
        [
          0.00023496136044,
          0.05849352079629,
          88.15533083
        ],
        [
          0.00010877913612,
          0.07669746409475,
          80.75671851
        ],
        [
          0.00032163321939,
          0.05093586335236,
          92.41948795
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00014135952384,
          0.0712123438683,
          82.26750407
        ],
        [
          0.00010861606539,
          0.0768780690445,
          80.61700783
        ],
        [
          0.00014149847113,
          0.07117380218663,
          82.29070448
        ],
        [
          0.00010846674288,
          0.07692213287244,
          80.59610964
        ],
        [
          0.00017686614383,
          0.06555567167906,
          84.7010414
        ],
        [
          0.00010861606539,
          0.0768780690445,
          80.61700783
        ],
        [
          0.00017692358066,
          0.06552649666617,
          84.72705079
        ],
        [
          0.00010839046327,
          0.07688208019828,
          80.64046839
        ],
        [
          0.00014807581501,
          0.06986453387,
          82.91945644
        ],
        [
          0.00010853847388,
          0.07683817744983,
          80.66140158
        ],
        [
          0.00014819272656,
          0.06982877730858,
          82.94333953
        ],
        [
          0.00010839046327,
          0.07688208019828,
          80.64046839
        ],
        [
          0.00018188548913,
          0.06446496539247,
          85.44252166
        ],
        [
          0.00010853847388,
          0.07683817744983,
          80.66140158
        ],
        [
          0.00018191218385,
          0.06443825283865,
          85.4692674
        ],
        [
          0.00010846674288,
          0.07692213287244,
          80.59610964
        ],
        [
          0.00014135952384,
          0.0712123438683,
          82.26750407
        ],
        [
          0.00010861606539,
          0.0768780690445,
          80.61700783
        ],
        [
          0.00014149847113,
          0.07117380218663,
          82.29070448
        ],
        [
          0.00010846674288,
          0.07692213287244,
          80.59610964
        ],
        [
          0.00017686614383,
          0.06555567167906,
          84.7010414
        ],
        [
          0.00010861606539,
          0.0768780690445,
          80.61700783
        ],
        [
          0.00019982222117,
          0.0632777491734,
          85.27315821
        ],
        [
          0.00010839046327,
          0.07688208019828,
          80.64046839
        ],
        [
          0.00014807581501,
          0.06986453387,
          82.91945644
        ],
        [
          0.00010853847388,
          0.07683817744983,
          80.66140158
        ],
        [
          0.00014819272656,
          0.06982877730858,
          82.94333953
        ],
        [
          0.00010839046327,
          0.07688208019828,
          80.64046839
        ],
        [
          0.00018188548913,
          0.06446496539247,
          85.44252166
        ],
        [
          0.00010853847388,
          0.07683817744983,
          80.66140158
        ],
        [
          0.00020503192634,
          0.06221316864876,
          86.04909203
        ],
        [
          0.00010912583992,
          0.0767532622962,
          80.66609079
        ],
        [
          0.00016303808393,
          0.06826939287491,
          83.11425226
        ],
        [
          0.0001092741376,
          0.07670945146764,
          80.68706603
        ],
        [
          0.00021822783589,
          0.0618969945096,
          85.40395137
        ],
        [
          0.00010912583992,
          0.0767532622962,
          80.66609079
        ],
        [
          0.00019922598739,
          0.06292450611699,
          85.71057479
        ],
        [
          0.0001092741376,
          0.07670945146764,
          80.68706603
        ],
        [
          0.00025414774982,
          0.05715853439271,
          88.44785118
        ],
        [
          0.00010904543176,
          0.0767136963687,
          80.71057643
        ],
        [
          0.00016974584476,
          0.06700452381699,
          83.80551155
        ],
        [
          0.00010919238489,
          0.07667004944453,
          80.73158656
        ],
        [
          0.00022415325367,
          0.06081229722693,
          86.19980334
        ],
        [
          0.00010904543176,
          0.0767136963687,
          80.71057643
        ],
        [
          0.00020385740546,
          0.06189772168914,
          86.49825919
        ],
        [
          0.00010919238489,
          0.07667004944453,
          80.73158656
        ],
        [
          0.00025762453282,
          0.0562391203355,
          89.36730831
        ],
        [
          0.00010912583992,
          0.0767532622962,
          80.66609079
        ],
        [
          0.00019865241359,
          0.06426270171017,
          84.29640836
        ],
        [
          0.0001092741376,
          0.07670945146764,
          80.68706603
        ],
        [
          0.00025843810086,
          0.05823530068899,
          86.84526087
        ],
        [
          0.00010912583992,
          0.0767532622962,
          80.66609079
        ],
        [
          0.00023608373207,
          0.05927058691352,
          87.14101364
        ],
        [
          0.0001092741376,
          0.07670945146764,
          80.68706603
        ],
        [
          0.00032695996685,
          0.05162718297572,
          91.12540963
        ],
        [
          0.00010904543176,
          0.0767136963687,
          80.71057643
        ],
        [
          0.0002052885602,
          0.06309715413662,
          85.04637604
        ],
        [
          0.00010919238489,
          0.07667004944453,
          80.73158656
        ],
        [
          0.00026403602812,
          0.05721398073708,
          87.71616351
        ],
        [
          0.00010904543176,
          0.0767136963687,
          80.71057643
        ],
        [
          0.00024034576358,
          0.05830270536967,
          88.00178263
        ],
        [
          0.00010919238489,
          0.07667004944453,
          80.73158656
        ],
        [
          0.00033056236539,
          0.05070676186001,
          92.21388303
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00014251808404,
          0.07115697648605,
          82.20623592
        ],
        [
          0.00010889501838,
          0.07686111056771,
          80.59862723
        ],
        [
          0.0001426786024,
          0.07111734744123,
          82.22845075
        ],
        [
          0.00010873121581,
          0.07690605556154,
          80.57864413
        ],
        [
          0.00017954933874,
          0.06544062761998,
          84.59402532
        ],
        [
          0.00010889501838,
          0.07686111056771,
          80.59862723
        ],
        [
          0.00017963866084,
          0.06540994994497,
          84.61898647
        ],
        [
          0.00010870527535,
          0.07686284921436,
          80.61974077
        ],
        [
          0.00014975245347,
          0.06978474489193,
          82.83709145
        ],
        [
          0.00010886795336,
          0.07681804920466,
          80.63975676
        ],
        [
          0.00014989387473,
          0.06974773825946,
          82.85996985
        ],
        [
          0.00010870527535,
          0.07686284921436,
          80.61974077
        ],
        [
          0.00018534166494,
          0.06431615617683,
          85.31295127
        ],
        [
          0.00010886795336,
          0.07681804920466,
          80.63975676
        ],
        [
          0.00018540339942,
          0.06428775865996,
          85.33863621
        ],
        [
          0.00010873121581,
          0.07690605556154,
          80.57864413
        ],
        [
          0.00014251808404,
          0.07115697648605,
          82.20623592
        ],
        [
          0.00010889501838,
          0.07686111056771,
          80.59862723
        ],
        [
          0.0001426786024,
          0.07111734744123,
          82.22845075
        ],
        [
          0.00010873121581,
          0.07690605556154,
          80.57864413
        ],
        [
          0.00017954933874,
          0.06544062761998,
          84.59402532
        ],
        [
          0.00010889501838,
          0.07686111056771,
          80.59862723
        ],
        [
          0.00020281570187,
          0.06316594860887,
          85.16189049
        ],
        [
          0.00010870527535,
          0.07686284921436,
          80.61974077
        ],
        [
          0.00014975245347,
          0.06978474489193,
          82.83709145
        ],
        [
          0.00010886795336,
          0.07681804920466,
          80.63975676
        ],
        [
          0.00014989387473,
          0.06974773825946,
          82.85996985
        ],
        [
          0.00010870527535,
          0.07686284921436,
          80.61974077
        ],
        [
          0.00018534166494,
          0.06431615617683,
          85.31295127
        ],
        [
          0.00010886795336,
          0.07681804920466,
          80.63975676
        ],
        [
          0.00020887222927,
          0.06206862077744,
          85.91464277
        ],
        [
          0.00010943261612,
          0.07673465494718,
          80.64598909
        ],
        [
          0.00016469914347,
          0.0681999182416,
          83.03592453
        ],
        [
          0.00010959564539,
          0.07668994883779,
          80.66604635
        ],
        [
          0.00022144509142,
          0.06179171279772,
          85.28641835
        ],
        [
          0.00010943261612,
          0.07673465494718,
          80.64598909
        ],
        [
          0.00020272584797,
          0.06278980582594,
          85.58439684
        ],
        [
          0.00010959564539,
          0.07668994883779,
          80.66604635
        ],
        [
          0.00025997559383,
          0.05697834736648,
          88.27716467
        ],
        [
          0.0001094031809,
          0.07669189032483,
          80.68720523
        ],
        [
          0.00017202956187,
          0.06690862258145,
          83.7053002
        ],
        [
          0.00010956505542,
          0.0766473316755,
          80.70729529
        ],
        [
          0.00022826251256,
          0.06067631018599,
          86.05849715
        ],
        [
          0.0001094031809,
          0.07669189032483,
          80.68720523
        ],
        [
          0.00020825053137,
          0.061727388462,
          86.34876384
        ],
        [
          0.00010956505542,
          0.0766473316755,
          80.70729529
        ],
        [
          0.00026464392087,
          0.05601970397447,
          89.17135595
        ],
        [
          0.00010943261612,
          0.07673465494718,
          80.64598909
        ],
        [
          0.00020098014928,
          0.06418221528086,
          84.20198374
        ],
        [
          0.00010959564539,
          0.07668994883779,
          80.66604635
        ],
        [
          0.00026267549493,
          0.0581175330284,
          86.70859722
        ],
        [
          0.00010943261612,
          0.07673465494718,
          80.64598909
        ],
        [
          0.00024064612011,
          0.05912205485986,
          86.99585963
        ],
        [
          0.00010959564539,
          0.07668994883779,
          80.66604635
        ],
        [
          0.00033482125261,
          0.05144390615588,
          90.92395655
        ],
        [
          0.0001094031809,
          0.07669189032483,
          80.68720523
        ],
        [
          0.00020838170613,
          0.06298900743682,
          84.92898495
        ],
        [
          0.00010956505542,
          0.0766473316755,
          80.70729529
        ],
        [
          0.00026932789261,
          0.05706498712145,
          87.55437882
        ],
        [
          0.0001094031809,
          0.07669189032483,
          80.68720523
        ],
        [
          0.00024596350583,
          0.05811791854161,
          87.83212593
        ],
        [
          0.00010956505542,
          0.0766473316755,
          80.70729529
        ],
        [
          0.00033989280454,
          0.05048690497541,
          91.98408686
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00014360322111,
          0.07111060447719,
          82.14434374
        ],
        [
          0.00010913379702,
          0.07684815845475,
          80.58157895
        ],
        [
          0.00014378689507,
          0.07106992074581,
          82.16540491
        ],
        [
          0.00010895448135,
          0.07689394897058,
          80.56266543
        ],
        [
          0.00018221387284,
          0.06533596938327,
          84.48056146
        ],
        [
          0.00010913379702,
          0.07684815845475,
          80.58157895
        ],
        [
          0.00018233808065,
          0.06530378664765,
          84.50428753
        ],
        [
          0.00010897220756,
          0.07684829477428,
          80.60070117
        ],
        [
          0.00015135396842,
          0.06971602527925,
          82.75254499
        ],
        [
          0.00010915058523,
          0.07680263353797,
          80.61964536
        ],
        [
          0.00015152182325,
          0.06967779264973,
          82.77424577
        ],
        [
          0.00010897220756,
          0.07684829477428,
          80.60070117
        ],
        [
          0.00018879565348,
          0.06417955896919,
          85.17504551
        ],
        [
          0.00010915058523,
          0.07680263353797,
          80.61964536
        ],
        [
          0.00018889589848,
          0.06414947053183,
          85.19947681
        ],
        [
          0.00010895448135,
          0.07689394897058,
          80.56266543
        ],
        [
          0.00014360322111,
          0.07111060447719,
          82.14434374
        ],
        [
          0.00010913379702,
          0.07684815845475,
          80.58157895
        ],
        [
          0.00014378689507,
          0.07106992074581,
          82.16540491
        ],
        [
          0.00010895448135,
          0.07689394897058,
          80.56266543
        ],
        [
          0.00018221387284,
          0.06533596938327,
          84.48056146
        ],
        [
          0.00010913379702,
          0.07684815845475,
          80.58157895
        ],
        [
          0.00020578841572,
          0.06306459625103,
          85.04375431
        ],
        [
          0.00010897220756,
          0.07684829477428,
          80.60070117
        ],
        [
          0.00015135396842,
          0.06971602527925,
          82.75254499
        ],
        [
          0.00010915058523,
          0.07680263353797,
          80.61964536
        ],
        [
          0.00015152182325,
          0.06967779264973,
          82.77424577
        ],
        [
          0.00010897220756,
          0.07684829477428,
          80.60070117
        ],
        [
          0.00018879565348,
          0.06417955896919,
          85.17504551
        ],
        [
          0.00010915058523,
          0.07680263353797,
          80.61964536
        ],
        [
          0.00021270888335,
          0.06193639799202,
          85.77134762
        ],
        [
          0.00010969721372,
          0.07672032763422,
          80.62720755
        ],
        [
          0.00016626956984,
          0.06814111930978,
          82.95617938
        ],
        [
          0.00010987602981,
          0.07667476110946,
          80.64619183
        ],
        [
          0.00022461925455,
          0.06169798539767,
          85.16202601
        ],
        [
          0.00010969721372,
          0.07672032763422,
          80.62720755
        ],
        [
          0.00020620397789,
          0.0626672246751,
          85.45058441
        ],
        [
          0.00010987602981,
          0.07667476110946,
          80.64619183
        ],
        [
          0.00026589445429,
          0.05681113182339,
          88.09197476
        ],
        [
          0.00010971204964,
          0.07667507287739,
          80.66535531
        ],
        [
          0.00017422309168,
          0.06682548235277,
          83.6020074
        ],
        [
          0.00010988990029,
          0.07662963777065,
          80.6843702
        ],
        [
          0.00023234325332,
          0.06055387188391,
          85.90830117
        ],
        [
          0.00010971204964,
          0.07667507287739,
          80.66535531
        ],
        [
          0.00021264264089,
          0.06157116484836,
          86.18958478
        ],
        [
          0.00010988990029,
          0.07662963777065,
          80.6843702
        ],
        [
          0.00027179151904,
          0.0558156218019,
          88.95827484
        ],
        [
          0.00010969721372,
          0.07672032763422,
          80.62720755
        ],
        [
          0.00020325109385,
          0.06411184045013,
          84.10291366
        ],
        [
          0.00010987602981,
          0.07667476110946,
          80.64619183
        ],
        [
          0.00026693621364,
          0.0580107733343,
          86.56112813
        ],
        [
          0.00010969721372,
          0.07672032763422,
          80.62720755
        ],
        [
          0.00024525861561,
          0.05898483500261,
          86.83910542
        ],
        [
          0.00010987602981,
          0.07667476110946,
          80.64619183
        ],
        [
          0.00034287829517,
          0.0512740703337,
          90.70185465
        ],
        [
          0.00010971204964,
          0.07667507287739,
          80.66535531
        ],
        [
          0.00021142588563,
          0.0628929133904,
          84.80509498
        ],
        [
          0.00010988990029,
          0.07662963777065,
          80.6843702
        ],
        [
          0.00027466650954,
          0.05692899988706,
          87.37947376
        ],
        [
          0.00010971204964,
          0.07667507287739,
          80.66535531
        ],
        [
          0.00025166071115,
          0.05794651398099,
          87.64853445
        ],
        [
          0.00010988990029,
          0.07662963777065,
          80.6843702
        ],
        [
          0.00034946063371,
          0.05028330490498,
          91.7302695
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00014463269333,
          0.07107291297871,
          82.0802553
        ],
        [
          0.00010935674998,
          0.07683788156995,
          80.5641135
        ],
        [
          0.00014482761245,
          0.07103173411229,
          82.10079939
        ],
        [
          0.00010917091701,
          0.07688398243752,
          80.54566733
        ],
        [
          0.00018488080643,
          0.06524233362476,
          84.35810282
        ],
        [
          0.00010935674998,
          0.07683788156995,
          80.5641135
        ],
        [
          0.000185023533,
          0.06520934988429,
          84.38126315
        ],
        [
          0.00010923020841,
          0.07683633185826,
          80.58051417
        ],
        [
          0.00015286282444,
          0.06965967414616,
          82.66596065
        ],
        [
          0.00010941525739,
          0.07679034912114,
          80.59898905
        ],
        [
          0.00015304408114,
          0.06962083041,
          82.6871287
        ],
        [
          0.00010923020841,
          0.07683633185826,
          80.58051417
        ],
        [
          0.00019221939673,
          0.06405780819773,
          85.0280521
        ],
        [
          0.00010941525739,
          0.07679034912114,
          80.59898905
        ],
        [
          0.00019234052368,
          0.06402680014342,
          85.05190505
        ],
        [
          0.00010917091701,
          0.07688398243752,
          80.54566733
        ],
        [
          0.00014463269333,
          0.07107291297871,
          82.0802553
        ],
        [
          0.00010935674998,
          0.07683788156995,
          80.5641135
        ],
        [
          0.00014482761245,
          0.07103173411229,
          82.10079939
        ],
        [
          0.00010917091701,
          0.07688398243752,
          80.54566733
        ],
        [
          0.00018488080643,
          0.06524233362476,
          84.35810282
        ],
        [
          0.00010935674998,
          0.07683788156995,
          80.5641135
        ],
        [
          0.00020874867664,
          0.06297482646421,
          84.91674438
        ],
        [
          0.00010923020841,
          0.07683633185826,
          80.58051417
        ],
        [
          0.00015286282444,
          0.06965967414616,
          82.66596065
        ],
        [
          0.00010941525739,
          0.07679034912114,
          80.59898905
        ],
        [
          0.00015304408114,
          0.06962083041,
          82.6871287
        ],
        [
          0.00010923020841,
          0.07683633185826,
          80.58051417
        ],
        [
          0.00019221939673,
          0.06405780819773,
          85.0280521
        ],
        [
          0.00010941525739,
          0.07679034912114,
          80.59898905
        ],
        [
          0.00021649512653,
          0.06181958683301,
          85.61904911
        ],
        [
          0.00010994982014,
          0.07670869272715,
          80.60754048
        ],
        [
          0.00016776698713,
          0.06809290940867,
          82.87335146
        ],
        [
          0.00011013533016,
          0.07666280557614,
          80.62605516
        ],
        [
          0.00022762901487,
          0.06162028113085,
          85.03420291
        ],
        [
          0.00010994982014,
          0.07670869272715,
          80.60754048
        ],
        [
          0.00020968139232,
          0.06255757915654,
          85.30644283
        ],
        [
          0.00011013533016,
          0.07666280557614,
          80.62605516
        ],
        [
          0.00027174040109,
          0.05666336982689,
          87.89484358
        ],
        [
          0.0001100068191,
          0.07666140172397,
          80.64249143
        ],
        [
          0.00017630306551,
          0.06675663714311,
          83.4957352
        ],
        [
          0.00011019152015,
          0.07661563458835,
          80.66103478
        ],
        [
          0.00023620629667,
          0.06045156771891,
          85.75461
        ],
        [
          0.0001100068191,
          0.07666140172397,
          80.64249143
        ],
        [
          0.0002169985807,
          0.0614318971988,
          86.01987141
        ],
        [
          0.00011019152015,
          0.07661563458835,
          80.66103478
        ],
        [
          0.00027881705296,
          0.05563586572215,
          88.73266395
        ],
        [
          0.00010994982014,
          0.07670869272715,
          80.60754048
        ],
        [
          0.00020542217052,
          0.06405378242471,
          83.99994655
        ],
        [
          0.00011013533016,
          0.07666280557614,
          80.62605516
        ],
        [
          0.00027099009003,
          0.05792193619455,
          86.40911614
        ],
        [
          0.00010994982014,
          0.07670869272715,
          80.60754048
        ],
        [
          0.00024985952712,
          0.05886262834421,
          86.67052921
        ],
        [
          0.00011013533016,
          0.07666280557614,
          80.62605516
        ],
        [
          0.00035081744124,
          0.05112648696196,
          90.46445583
        ],
        [
          0.0001100068191,
          0.07666140172397,
          80.64249143
        ],
        [
          0.00021432315508,
          0.06281289454293,
          84.67733189
        ],
        [
          0.00011019152015,
          0.07661563458835,
          80.66103478
        ],
        [
          0.00027973614421,
          0.05681524295069,
          87.19980934
        ],
        [
          0.0001100068191,
          0.07666140172397,
          80.64249143
        ],
        [
          0.00025730399683,
          0.05779439830115,
          87.45273819
        ],
        [
          0.00011019152015,
          0.07661563458835,
          80.66103478
        ],
        [
          0.00035884031633,
          0.05010721266281,
          91.46005875
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00014555321763,
          0.0710462352985,
          82.0167702
        ],
        [
          0.00010953493751,
          0.07683152820425,
          80.54855457
        ],
        [
          0.00014576140322,
          0.07100456391654,
          82.03659575
        ],
        [
          0.0001093411502,
          0.07687792832989,
          80.53076217
        ],
        [
          0.0001874268485,
          0.06516553041572,
          84.2305003
        ],
        [
          0.00010953493751,
          0.07683152820425,
          80.54855457
        ],
        [
          0.00018759163147,
          0.06513170170361,
          84.25287246
        ],
        [
          0.00010944090487,
          0.07682876344298,
          80.56214147
        ],
        [
          0.00015426248368,
          0.06961693952912,
          82.57740805
        ],
        [
          0.00010963407714,
          0.07678246887719,
          80.57996027
        ],
        [
          0.0001544595615,
          0.0695774697789,
          82.59783623
        ],
        [
          0.00010944090487,
          0.07682876344298,
          80.56214147
        ],
        [
          0.00019554063549,
          0.06395512091967,
          84.87290715
        ],
        [
          0.00010963407714,
          0.07678246887719,
          80.57996027
        ],
        [
          0.00019568671145,
          0.0639231359513,
          84.89595262
        ],
        [
          0.0001093411502,
          0.07687792832989,
          80.53076217
        ],
        [
          0.00014555321763,
          0.0710462352985,
          82.0167702
        ],
        [
          0.00010953493751,
          0.07683152820425,
          80.54855457
        ],
        [
          0.00014576140322,
          0.07100456391654,
          82.03659575
        ],
        [
          0.0001093411502,
          0.07687792832989,
          80.53076217
        ],
        [
          0.0001874268485,
          0.06516553041572,
          84.2305003
        ],
        [
          0.00010953493751,
          0.07683152820425,
          80.54855457
        ],
        [
          0.00021158162574,
          0.06290157943191,
          84.78394129
        ],
        [
          0.00010944090487,
          0.07682876344298,
          80.56214147
        ],
        [
          0.00015426248368,
          0.06961693952912,
          82.57740805
        ],
        [
          0.00010963407714,
          0.07678246887719,
          80.57996027
        ],
        [
          0.0001544595615,
          0.0695774697789,
          82.59783623
        ],
        [
          0.00010944090487,
          0.07682876344298,
          80.56214147
        ],
        [
          0.00019554063549,
          0.06395512091967,
          84.87290715
        ],
        [
          0.00010963407714,
          0.07678246887719,
          80.57996027
        ],
        [
          0.00022017411326,
          0.06172156248669,
          85.45782119
        ],
        [
          0.00011015276239,
          0.07670144590889,
          80.58993463
        ],
        [
          0.00016912367827,
          0.06805799536947,
          82.79043407
        ],
        [
          0.00011034642046,
          0.07665524819393,
          80.60779282
        ],
        [
          0.00023043023686,
          0.06156031702367,
          84.90367863
        ],
        [
          0.00011015276239,
          0.07670144590889,
          80.58993463
        ],
        [
          0.00021301013029,
          0.06246709184767,
          85.15603707
        ],
        [
          0.00011034642046,
          0.07665524819393,
          80.60779282
        ],
        [
          0.00027738710689,
          0.05653973156731,
          87.68745109
        ],
        [
          0.00011025083264,
          0.07665260124333,
          80.62140929
        ],
        [
          0.00017824413089,
          0.06670366781525,
          83.38665738
        ],
        [
          0.0001104438535,
          0.07660651070623,
          80.63929384
        ],
        [
          0.00023987228984,
          0.06036956098191,
          85.59506932
        ],
        [
          0.00011025083264,
          0.07665260124333,
          80.62140929
        ],
        [
          0.00022122864673,
          0.06131415025548,
          85.8406768
        ],
        [
          0.0001104438535,
          0.07660651070623,
          80.63929384
        ],
        [
          0.00028567730955,
          0.05548307937425,
          88.49289689
        ],
        [
          0.00011015276239,
          0.07670144590889,
          80.58993463
        ],
        [
          0.00020741319857,
          0.06401080338092,
          83.89591856
        ],
        [
          0.00011034642046,
          0.07665524819393,
          80.60779282
        ],
        [
          0.00027478852597,
          0.05785270952218,
          86.25300385
        ],
        [
          0.00011015276239,
          0.07670144590889,
          80.58993463
        ],
        [
          0.00025427807946,
          0.05876155956447,
          86.49405099
        ],
        [
          0.00011034642046,
          0.07665524819393,
          80.60779282
        ],
        [
          0.0003584854364,
          0.05100555491852,
          90.21326394
        ],
        [
          0.00011025083264,
          0.07665260124333,
          80.62140929
        ],
        [
          0.00021704589215,
          0.06275051260827,
          84.5455719
        ],
        [
          0.0001104438535,
          0.07660651070623,
          80.63929384
        ],
        [
          0.00028456593388,
          0.05672378278761,
          87.01257575
        ],
        [
          0.00011025083264,
          0.07665260124333,
          80.62140929
        ],
        [
          0.00026279259144,
          0.05766599737817,
          87.24548695
        ],
        [
          0.0001104438535,
          0.07660651070623,
          80.63929384
        ],
        [
          0.00036798201583,
          0.04996115625791,
          91.17130935
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00014636474029,
          0.07103071487159,
          81.9535804
        ],
        [
          0.00010967303322,
          0.0768285186194,
          80.53483522
        ],
        [
          0.00014658697069,
          0.07098863756745,
          81.97252578
        ],
        [
          0.00010947078526,
          0.07687512359438,
          80.51784494
        ],
        [
          0.00018979198098,
          0.0651084370262,
          84.09915477
        ],
        [
          0.00010967303322,
          0.0768285186194,
          80.53483522
        ],
        [
          0.00018998053078,
          0.06507382076609,
          84.12055837
        ],
        [
          0.00010960355025,
          0.07682517512092,
          80.54600711
        ],
        [
          0.00015550180154,
          0.06958982015732,
          82.48939154
        ],
        [
          0.00010980534183,
          0.07677866350803,
          80.56302143
        ],
        [
          0.00015571560333,
          0.06954980706189,
          82.5089143
        ],
        [
          0.00010960355025,
          0.07682517512092,
          80.54600711
        ],
        [
          0.00019862158404,
          0.06387697135277,
          84.71403182
        ],
        [
          0.00010980534183,
          0.07677866350803,
          80.56302143
        ],
        [
          0.00019879453555,
          0.06384406863237,
          84.73608409
        ],
        [
          0.00010947078526,
          0.07687512359438,
          80.51784494
        ],
        [
          0.00014636474029,
          0.07103071487159,
          81.9535804
        ],
        [
          0.00010967303322,
          0.0768285186194,
          80.53483522
        ],
        [
          0.00014658697069,
          0.07098863756745,
          81.97252578
        ],
        [
          0.00010947078526,
          0.07687512359438,
          80.51784494
        ],
        [
          0.00018979198098,
          0.0651084370262,
          84.09915477
        ],
        [
          0.00010967303322,
          0.0768285186194,
          80.53483522
        ],
        [
          0.00021422685773,
          0.06284759823898,
          84.6464354
        ],
        [
          0.00010960355025,
          0.07682517512092,
          80.54600711
        ],
        [
          0.00015550180154,
          0.06958982015732,
          82.48939154
        ],
        [
          0.00010980534183,
          0.07677866350803,
          80.56302143
        ],
        [
          0.00015571560333,
          0.06954980706189,
          82.5089143
        ],
        [
          0.00010960355025,
          0.07682517512092,
          80.54600711
        ],
        [
          0.00019862158404,
          0.06387697135277,
          84.71403182
        ],
        [
          0.00010980534183,
          0.07677866350803,
          80.56302143
        ],
        [
          0.00022360113246,
          0.06164751466775,
          85.29185059
        ],
        [
          0.00011030872006,
          0.07669801688753,
          80.57454737
        ],
        [
          0.00017033607179,
          0.06803678257288,
          82.70706893
        ],
        [
          0.00011051103035,
          0.07665160292191,
          80.59160045
        ],
        [
          0.00023308218493,
          0.0615179829316,
          84.76597892
        ],
        [
          0.00011030872006,
          0.07669801688753,
          80.57454737
        ],
        [
          0.0002161176953,
          0.06239885793654,
          85.00076246
        ],
        [
          0.00011051103035,
          0.07665160292191,
          80.59160045
        ],
        [
          0.00028283048972,
          0.05644208996453,
          87.46687256
        ],
        [
          0.00011044032797,
          0.07664835436934,
          80.60279659
        ],
        [
          0.00017998326339,
          0.06666885634365,
          83.2773193
        ],
        [
          0.00011064216249,
          0.07660203514732,
          80.61987368
        ],
        [
          0.00024332466444,
          0.06030953971854,
          85.42827348
        ],
        [
          0.00011044032797,
          0.07664835436934,
          80.60279659
        ],
        [
          0.00022517184086,
          0.06122364069793,
          85.65651848
        ],
        [
          0.00011064216249,
          0.07660203514732,
          80.61987368
        ],
        [
          0.00029225951639,
          0.05536161577653,
          88.23936767
        ],
        [
          0.00011030872006,
          0.07669801688753,
          80.57454737
        ],
        [
          0.00020920484642,
          0.06398370908955,
          83.79106292
        ],
        [
          0.00011051103035,
          0.07665160292191,
          80.59160045
        ],
        [
          0.00027838338734,
          0.05780330659982,
          86.08872809
        ],
        [
          0.00011030872006,
          0.07669801688753,
          80.57454737
        ],
        [
          0.00025840847902,
          0.05868515388347,
          86.31177986
        ],
        [
          0.00011051103035,
          0.07665160292191,
          80.59160045
        ],
        [
          0.00036586293174,
          0.05091344025237,
          89.94529387
        ],
        [
          0.00011044032797,
          0.07664835436934,
          80.60279659
        ],
        [
          0.00021950136108,
          0.0627084876822,
          84.41310182
        ],
        [
          0.00011064216249,
          0.07660203514732,
          80.61987368
        ],
        [
          0.00028911576081,
          0.05665667696554,
          86.81695299
        ],
        [
          0.00011044032797,
          0.07664835436934,
          80.60279659
        ],
        [
          0.00026791556413,
          0.0575674276366,
          87.03218798
        ],
        [
          0.00011064216249,
          0.07660203514732,
          80.61987368
        ],
        [
          0.00037673204191,
          0.04984949412759,
          90.8647242
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00014708837906,
          0.07102656538016,
          81.88831717
        ],
        [
          0.00010979466099,
          0.07682822463368,
          80.52069651
        ],
        [
          0.00014733184438,
          0.07098418965447,
          81.90559045
        ],
        [
          0.00010957881541,
          0.0768748896415,
          80.50524616
        ],
        [
          0.00019199710587,
          0.06507210197214,
          83.96079871
        ],
        [
          0.00010979466099,
          0.07682822463368,
          80.52069651
        ],
        [
          0.00019222113267,
          0.06503664403284,
          83.98037447
        ],
        [
          0.00010973789377,
          0.07682480996236,
          80.53041599
        ],
        [
          0.00015661635897,
          0.06957826243133,
          82.39839958
        ],
        [
          0.00010995345755,
          0.07677822391664,
          80.54588759
        ],
        [
          0.00015685505599,
          0.06953776722527,
          82.4162094
        ],
        [
          0.00010973789377,
          0.07682480996236,
          80.53041599
        ],
        [
          0.00020150336948,
          0.06382380880442,
          84.5469295
        ],
        [
          0.00010995345755,
          0.07677822391664,
          80.54588759
        ],
        [
          0.00020171619962,
          0.06378989389071,
          84.56711178
        ],
        [
          0.00010957881541,
          0.0768748896415,
          80.50524616
        ],
        [
          0.00014708837906,
          0.07102656538016,
          81.88831717
        ],
        [
          0.00010979466099,
          0.07682822463368,
          80.52069651
        ],
        [
          0.00014733184438,
          0.07098418965447,
          81.90559045
        ],
        [
          0.00010957881541,
          0.0768748896415,
          80.50524616
        ],
        [
          0.00019199710587,
          0.06507210197214,
          83.96079871
        ],
        [
          0.00010979466099,
          0.07682822463368,
          80.52069651
        ],
        [
          0.00021670928693,
          0.06281412655808,
          84.50058679
        ],
        [
          0.00010973789377,
          0.07682480996236,
          80.53041599
        ],
        [
          0.00015661635897,
          0.06957826243133,
          82.39839958
        ],
        [
          0.00010995345755,
          0.07677822391664,
          80.54588759
        ],
        [
          0.00015685505599,
          0.06953776722527,
          82.4162094
        ],
        [
          0.00010973789377,
          0.07682480996236,
          80.53041599
        ],
        [
          0.00020150336948,
          0.06382380880442,
          84.5469295
        ],
        [
          0.00010995345755,
          0.07677822391664,
          80.54588759
        ],
        [
          0.00022682378524,
          0.06159810844467,
          85.11622538
        ],
        [
          0.00011044441264,
          0.07669763173352,
          80.55889121
        ],
        [
          0.00017143287257,
          0.06802969387668,
          82.62015458
        ],
        [
          0.00011066059842,
          0.07665114093229,
          80.5743994
        ],
        [
          0.00023552081583,
          0.06149613762446,
          84.62202218
        ],
        [
          0.00011044441264,
          0.07669763173352,
          80.55889121
        ],
        [
          0.00021903576991,
          0.06235390187868,
          84.83652951
        ],
        [
          0.00011066059842,
          0.07665114093229,
          80.5743994
        ],
        [
          0.00028797224084,
          0.05637461134141,
          87.23323485
        ],
        [
          0.00011060282296,
          0.07664780407598,
          80.58413965
        ],
        [
          0.00018156666655,
          0.06665226470413,
          83.16342797
        ],
        [
          0.0001108187108,
          0.07660139336287,
          80.59966909
        ],
        [
          0.00024651422091,
          0.06027417236703,
          85.25392019
        ],
        [
          0.00011060282296,
          0.07664780407598,
          80.58413965
        ],
        [
          0.00022888364095,
          0.0611607119939,
          85.4620225
        ],
        [
          0.0001108187108,
          0.07660139336287,
          80.59966909
        ],
        [
          0.00029848631643,
          0.05527512523768,
          87.97088418
        ],
        [
          0.00011044441264,
          0.07669763173352,
          80.55889121
        ],
        [
          0.00021084449961,
          0.06397283232807,
          83.68120339
        ],
        [
          0.00011066059842,
          0.07665114093229,
          80.5743994
        ],
        [
          0.00028171601133,
          0.05777642606936,
          85.91624529
        ],
        [
          0.00011044441264,
          0.07669763173352,
          80.55889121
        ],
        [
          0.00026230726411,
          0.05863410248241,
          86.11840874
        ],
        [
          0.00011066059842,
          0.07665114093229,
          80.5743994
        ],
        [
          0.0003728389798,
          0.05085405434103,
          89.66005313
        ],
        [
          0.00011060282296,
          0.07664780407598,
          80.58413965
        ],
        [
          0.00022175968981,
          0.06268668672711,
          84.27447821
        ],
        [
          0.0001108187108,
          0.07660139336287,
          80.59966909
        ],
        [
          0.00029334731418,
          0.05661631792911,
          86.61159487
        ],
        [
          0.00011060282296,
          0.07664780407598,
          80.58413965
        ],
        [
          0.00027275876834,
          0.05749863962737,
          86.80616393
        ],
        [
          0.0001108187108,
          0.07660139336287,
          80.59966909
        ],
        [
          0.00038500753446,
          0.0497756081235,
          90.53835679
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00014765242677,
          0.07103424454527,
          81.82726151
        ],
        [
          0.00010986639629,
          0.07683013015933,
          80.51053794
        ],
        [
          0.00014790277058,
          0.07099175573904,
          81.84404122
        ],
        [
          0.00010964722329,
          0.07687673548613,
          80.49552355
        ],
        [
          0.00019390113348,
          0.06506021992047,
          83.82230729
        ],
        [
          0.00010986639629,
          0.07683013015933,
          80.51053794
        ],
        [
          0.00019413889888,
          0.06502436935856,
          83.84131605
        ],
        [
          0.00010982929493,
          0.07682720546721,
          80.51749558
        ],
        [
          0.00015751574109,
          0.06958353402902,
          82.3112177
        ],
        [
          0.00011004830182,
          0.07678067016188,
          80.53252908
        ],
        [
          0.00015776294694,
          0.06954284957547,
          82.32851313
        ],
        [
          0.00010982929493,
          0.07682720546721,
          80.51749558
        ],
        [
          0.00020401701495,
          0.06380019580482,
          84.37901985
        ],
        [
          0.00011004830182,
          0.07678067016188,
          80.53252908
        ],
        [
          0.00020424586417,
          0.06376580366716,
          84.39861205
        ],
        [
          0.00010964722329,
          0.07687673548613,
          80.49552355
        ],
        [
          0.00014765242677,
          0.07103424454527,
          81.82726151
        ],
        [
          0.00010986639629,
          0.07683013015933,
          80.51053794
        ],
        [
          0.00014790277058,
          0.07099175573904,
          81.84404122
        ],
        [
          0.00010964722329,
          0.07687673548613,
          80.49552355
        ],
        [
          0.00019390113348,
          0.06506021992047,
          83.82230729
        ],
        [
          0.00010986639629,
          0.07683013015933,
          80.51053794
        ],
        [
          0.0002188330883,
          0.06280506861872,
          84.35597942
        ],
        [
          0.00010982929493,
          0.07682720546721,
          80.51749558
        ],
        [
          0.00015751574109,
          0.06958353402902,
          82.3112177
        ],
        [
          0.00011004830182,
          0.07678067016188,
          80.53252908
        ],
        [
          0.00015776294694,
          0.06954284957547,
          82.32851313
        ],
        [
          0.00010982929493,
          0.07682720546721,
          80.51749558
        ],
        [
          0.00020401701495,
          0.06380019580482,
          84.37901985
        ],
        [
          0.00011004830182,
          0.07678067016188,
          80.53252908
        ],
        [
          0.00022961240856,
          0.06157820333985,
          84.94113871
        ],
        [
          0.0001105368963,
          0.07670001564219,
          80.54590139
        ],
        [
          0.00017231641659,
          0.06803782726364,
          82.53674744
        ],
        [
          0.00011075655535,
          0.0766535744404,
          80.56097084
        ],
        [
          0.00023759753795,
          0.06149719358654,
          84.47888139
        ],
        [
          0.0001105368963,
          0.07670001564219,
          80.54590139
        ],
        [
          0.00022158383764,
          0.06233659390907,
          84.67105427
        ],
        [
          0.00011075655535,
          0.0766535744404,
          80.56097084
        ],
        [
          0.00029256391677,
          0.05634239367751,
          86.99434924
        ],
        [
          0.00011071876671,
          0.07665070393364,
          80.56794292
        ],
        [
          0.00018287348119,
          0.06665586642112,
          83.05257213
        ],
        [
          0.00011093824599,
          0.07660433369897,
          80.58303148
        ],
        [
          0.00024926250245,
          0.06026661345615,
          85.07966555
        ],
        [
          0.00011071876671,
          0.07665070393364,
          80.56794292
        ],
        [
          0.00023215131559,
          0.06113058444644,
          85.26548856
        ],
        [
          0.00011093824599,
          0.07660433369897,
          80.58303148
        ],
        [
          0.000304070718,
          0.05522933268798,
          87.69593168
        ],
        [
          0.0001105368963,
          0.07670001564219,
          80.54590139
        ],
        [
          0.00021220254074,
          0.06397980128505,
          83.57391038
        ],
        [
          0.00011075655535,
          0.0766535744404,
          80.56097084
        ],
        [
          0.0002845979018,
          0.05777484426707,
          85.74320063
        ],
        [
          0.0001105368963,
          0.07670001564219,
          80.54590139
        ],
        [
          0.00026574915233,
          0.05861307975015,
          85.922242
        ],
        [
          0.00011075655535,
          0.0766535744404,
          80.56097084
        ],
        [
          0.00037908744117,
          0.05083209471978,
          89.36686679
        ],
        [
          0.00011071876671,
          0.07665070393364,
          80.56794292
        ],
        [
          0.00022366350741,
          0.06268757534235,
          84.13783871
        ],
        [
          0.00011093824599,
          0.07660433369897,
          80.58303148
        ],
        [
          0.00029703799285,
          0.05660614389584,
          86.40478679
        ],
        [
          0.00011071876671,
          0.07665070393364,
          80.56794292
        ],
        [
          0.00027706040999,
          0.05746505964541,
          86.57635812
        ],
        [
          0.00011093824599,
          0.07660433369897,
          80.58303148
        ],
        [
          0.00039243735927,
          0.04974464062355,
          90.20238759
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00014811058813,
          0.07105452358977,
          81.76444097
        ],
        [
          0.0001099223619,
          0.07683430792126,
          80.50025204
        ],
        [
          0.00014836863825,
          0.07101208820135,
          81.78047428
        ],
        [
          0.00010969931932,
          0.07688066490371,
          80.48590697
        ],
        [
          0.00019552537237,
          0.06507382102197,
          83.68034807
        ],
        [
          0.0001099223619,
          0.07683430792126,
          80.50025204
        ],
        [
          0.00019577862501,
          0.06503769453759,
          83.69851213
        ],
        [
          0.00010989668292,
          0.07683220647531,
          80.50513319
        ],
        [
          0.00015825745935,
          0.06960644774857,
          82.22156566
        ],
        [
          0.00011011966015,
          0.07678591081296,
          80.5194953
        ],
        [
          0.00015851475303,
          0.06956567364771,
          82.23808704
        ],
        [
          0.00010989668292,
          0.07683220647531,
          80.50513319
        ],
        [
          0.00020618309369,
          0.06380720897483,
          84.2067073
        ],
        [
          0.00011011966015,
          0.07678591081296,
          80.5194953
        ],
        [
          0.00020642999271,
          0.06377244602096,
          84.22542453
        ],
        [
          0.00010969931932,
          0.07688066490371,
          80.48590697
        ],
        [
          0.00014811058813,
          0.07105452358977,
          81.76444097
        ],
        [
          0.0001099223619,
          0.07683430792126,
          80.50025204
        ],
        [
          0.00014836863825,
          0.07101208820135,
          81.78047428
        ],
        [
          0.00010969931932,
          0.07688066490371,
          80.48590697
        ],
        [
          0.00019552537237,
          0.06507382102197,
          83.68034807
        ],
        [
          0.0001099223619,
          0.07683430792126,
          80.50025204
        ],
        [
          0.00022065579408,
          0.06282114679113,
          84.20706997
        ],
        [
          0.00010989668292,
          0.07683220647531,
          80.50513319
        ],
        [
          0.00015825745935,
          0.06960644774857,
          82.22156566
        ],
        [
          0.00011011966015,
          0.07678591081296,
          80.5194953
        ],
        [
          0.00015851475303,
          0.06956567364771,
          82.23808704
        ],
        [
          0.00010989668292,
          0.07683220647531,
          80.50513319
        ],
        [
          0.00020618309369,
          0.06380720897483,
          84.2067073
        ],
        [
          0.00011011966015,
          0.07678591081296,
          80.5194953
        ],
        [
          0.0002320273481,
          0.06158844061691,
          84.76073971
        ],
        [
          0.00011060485376,
          0.07670498858037,
          80.53352696
        ],
        [
          0.00017304076568,
          0.06806203880615,
          82.4511882
        ],
        [
          0.00011082851988,
          0.07665878534972,
          80.54792404
        ],
        [
          0.00023935341108,
          0.06152213098784,
          84.33217803
        ],
        [
          0.00011060485376,
          0.07670498858037,
          80.53352696
        ],
        [
          0.00022377343286,
          0.0623481104419,
          84.50145836
        ],
        [
          0.00011082851988,
          0.07665878534972,
          80.54792404
        ],
        [
          0.00029656950133,
          0.0563470832,
          86.74904822
        ],
        [
          0.00011080236453,
          0.07665672140998,
          80.55281485
        ],
        [
          0.00018396189678,
          0.06668048477097,
          82.93878397
        ],
        [
          0.00011102595392,
          0.07661058028672,
          80.56722897
        ],
        [
          0.000251611907,
          0.06028784232003,
          84.9008328
        ],
        [
          0.00011080236453,
          0.07665672140998,
          80.55281485
        ],
        [
          0.00023498436194,
          0.06113447184236,
          85.06378054
        ],
        [
          0.00011102595392,
          0.07661058028672,
          80.56722897
        ],
        [
          0.00030897034823,
          0.05522589384863,
          87.41312526
        ],
        [
          0.00011060485376,
          0.07670498858037,
          80.53352696
        ],
        [
          0.00021335224475,
          0.06400595949995,
          83.4620948
        ],
        [
          0.00011082851988,
          0.07665878534972,
          80.54792404
        ],
        [
          0.00028708998048,
          0.05779989448128,
          85.56371819
        ],
        [
          0.00011060485376,
          0.07670498858037,
          80.53352696
        ],
        [
          0.0002687603399,
          0.05862352178801,
          85.71901589
        ],
        [
          0.00011082851988,
          0.07665878534972,
          80.54792404
        ],
        [
          0.00038459893509,
          0.05084928370536,
          89.06241603
        ],
        [
          0.00011080236453,
          0.07665672140998,
          80.55281485
        ],
        [
          0.00022529251784,
          0.06271234923169,
          83.99574616
        ],
        [
          0.00011102595392,
          0.07661058028672,
          80.56722897
        ],
        [
          0.00030025156807,
          0.05662742713977,
          86.1903102
        ],
        [
          0.00011080236453,
          0.07665672140998,
          80.55281485
        ],
        [
          0.00028084590122,
          0.05746808313518,
          86.3382138
        ],
        [
          0.00011102595392,
          0.07661058028672,
          80.56722897
        ],
        [
          0.00039900847983,
          0.04975823346498,
          89.85323246
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00014843136906,
          0.07108679767796,
          81.70334511
        ],
        [
          0.00010995516878,
          0.07683988920029,
          80.49147273
        ],
        [
          0.00014869581486,
          0.07104461174133,
          81.7185501
        ],
        [
          0.00010972917434,
          0.07688579418518,
          80.47787149
        ],
        [
          0.00019681486771,
          0.06511425110026,
          83.53737308
        ],
        [
          0.00010995516878,
          0.07683988920029,
          80.49147273
        ],
        [
          0.00019708210618,
          0.06507802750376,
          83.55459826
        ],
        [
          0.0001099364346,
          0.07683894310215,
          80.49451687
        ],
        [
          0.00015878860369,
          0.06964616922289,
          82.13488538
        ],
        [
          0.00011016244968,
          0.07679309114715,
          80.5081331
        ],
        [
          0.00015905421292,
          0.06960552971263,
          82.15054956
        ],
        [
          0.0001099364346,
          0.07683894310215,
          80.49451687
        ],
        [
          0.0002079134502,
          0.06384617255897,
          84.03454725
        ],
        [
          0.00011016244968,
          0.07679309114715,
          80.5081331
        ],
        [
          0.0002081767543,
          0.06381122202837,
          84.05229272
        ],
        [
          0.00010972917434,
          0.07688579418518,
          80.47787149
        ],
        [
          0.00014843136906,
          0.07108679767796,
          81.70334511
        ],
        [
          0.00010995516878,
          0.07683988920029,
          80.49147273
        ],
        [
          0.00014869581486,
          0.07104461174133,
          81.7185501
        ],
        [
          0.00010972917434,
          0.07688579418518,
          80.47787149
        ],
        [
          0.00019681486771,
          0.06511425110026,
          83.53737308
        ],
        [
          0.00010995516878,
          0.07683988920029,
          80.49147273
        ],
        [
          0.00022211762837,
          0.06286389175408,
          84.05607088
        ],
        [
          0.0001099364346,
          0.07683894310215,
          80.49451687
        ],
        [
          0.00015878860369,
          0.06964616922289,
          82.13488538
        ],
        [
          0.00011016244968,
          0.07679309114715,
          80.5081331
        ],
        [
          0.00015905421292,
          0.06960552971263,
          82.15054956
        ],
        [
          0.0001099364346,
          0.07683894310215,
          80.49451687
        ],
        [
          0.0002079134502,
          0.06384617255897,
          84.03454725
        ],
        [
          0.00011016244968,
          0.07679309114715,
          80.5081331
        ],
        [
          0.00023397313842,
          0.06163026333266,
          84.57940794
        ],
        [
          0.00011064675924,
          0.07671198495797,
          80.52244079
        ],
        [
          0.00017356441728,
          0.06810195710502,
          82.36723057
        ],
        [
          0.00011087350847,
          0.07666622231155,
          80.53609058
        ],
        [
          0.00024073056596,
          0.06157181206971,
          84.18451174
        ],
        [
          0.00011064675924,
          0.07671198495797,
          80.52244079
        ],
        [
          0.00022553611851,
          0.06238988771689,
          84.33044446
        ],
        [
          0.00011087350847,
          0.07666622231155,
          80.53609058
        ],
        [
          0.00029990798889,
          0.05639056583981,
          86.49872522
        ],
        [
          0.00011085445742,
          0.07666529944091,
          80.53914014
        ],
        [
          0.00018476451749,
          0.06672556787782,
          82.82784994
        ],
        [
          0.00011108121807,
          0.07661959046821,
          80.55280493
        ],
        [
          0.00025346832949,
          0.06033854454406,
          84.72224125
        ],
        [
          0.00011085445742,
          0.07666529944091,
          80.53914014
        ],
        [
          0.00023727599281,
          0.06117377833952,
          84.86180453
        ],
        [
          0.00011108121807,
          0.07661959046821,
          80.55280493
        ],
        [
          0.00031305550996,
          0.05526651554084,
          87.1263169
        ],
        [
          0.00011064675924,
          0.07671198495797,
          80.52244079
        ],
        [
          0.00021420609739,
          0.06405054441112,
          83.35275768
        ],
        [
          0.00011087350847,
          0.07666622231155,
          80.53609058
        ],
        [
          0.00028907089299,
          0.05785216058697,
          85.38391699
        ],
        [
          0.00011064675924,
          0.07671198495797,
          80.52244079
        ],
        [
          0.00027120564061,
          0.05866679191891,
          85.51491994
        ],
        [
          0.00011087350847,
          0.07666622231155,
          80.53609058
        ],
        [
          0.00038920835516,
          0.05090729978375,
          88.75158433
        ],
        [
          0.00011085445742,
          0.07666529944091,
          80.53914014
        ],
        [
          0.00022652220872,
          0.06276028877188,
          83.85741433
        ],
        [
          0.00011108121807,
          0.07661959046821,
          80.55280493
        ],
        [
          0.00030281953202,
          0.05668063410991,
          85.97673864
        ],
        [
          0.00011085445742,
          0.07666529944091,
          80.53914014
        ],
        [
          0.00028393031157,
          0.057509107607,
          86.10035178
        ],
        [
          0.00011108121807,
          0.07661959046821,
          80.55280493
        ],
        [
          0.00040449512711,
          0.04981769397867,
          89.49869875
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00014861858599,
          0.07113144691302,
          81.64319307
        ],
        [
          0.00010997183342,
          0.07684739549355,
          80.482911
        ],
        [
          0.00014888931946,
          0.07109013700742,
          81.65696381
        ],
        [
          0.0001097431628,
          0.07689217498928,
          80.47061577
        ],
        [
          0.00019774217649,
          0.06518220764354,
          83.39441367
        ],
        [
          0.00010997183342,
          0.07684739549355,
          80.482911
        ],
        [
          0.00019802484953,
          0.06514638378365,
          83.41003863
        ],
        [
          0.0001099543816,
          0.07684699450348,
          80.48532417
        ],
        [
          0.00015912529084,
          0.06970404506016,
          82.04827846
        ],
        [
          0.0001101831457,
          0.07680225987065,
          80.49763239
        ],
        [
          0.0001593994232,
          0.06966413025927,
          82.06246683
        ],
        [
          0.0001099543816,
          0.07684699450348,
          80.48532417
        ],
        [
          0.0002091982703,
          0.06391833592453,
          83.86133286
        ],
        [
          0.0001101831457,
          0.07680225987065,
          80.49763239
        ],
        [
          0.00020947992423,
          0.0638836654981,
          83.87743057
        ],
        [
          0.0001097431628,
          0.07689217498928,
          80.47061577
        ],
        [
          0.00014861858599,
          0.07113144691302,
          81.64319307
        ],
        [
          0.00010997183342,
          0.07684739549355,
          80.482911
        ],
        [
          0.00014888931946,
          0.07109013700742,
          81.65696381
        ],
        [
          0.0001097431628,
          0.07689217498928,
          80.47061577
        ],
        [
          0.00019774217649,
          0.06518220764354,
          83.39441367
        ],
        [
          0.00010997183342,
          0.07684739549355,
          80.482911
        ],
        [
          0.00022318557006,
          0.06293437694935,
          83.90381858
        ],
        [
          0.0001099543816,
          0.07684699450348,
          80.48532417
        ],
        [
          0.00015912529084,
          0.06970404506016,
          82.04827846
        ],
        [
          0.0001101831457,
          0.07680225987065,
          80.49763239
        ],
        [
          0.0001593994232,
          0.06966413025927,
          82.06246683
        ],
        [
          0.0001099543816,
          0.07684699450348,
          80.48532417
        ],
        [
          0.0002091982703,
          0.06391833592453,
          83.86133286
        ],
        [
          0.0001101831457,
          0.07680225987065,
          80.49763239
        ],
        [
          0.00023543701982,
          0.06170527612815,
          84.39566597
        ],
        [
          0.00011066621978,
          0.07672054185938,
          80.51262316
        ],
        [
          0.00017389012895,
          0.06815819527978,
          82.28392835
        ],
        [
          0.00011089577658,
          0.0766758912145,
          80.52496252
        ],
        [
          0.00024172083647,
          0.06164829404118,
          84.03387835
        ],
        [
          0.00011066621978,
          0.07672054185938,
          80.51262316
        ],
        [
          0.0002268386391,
          0.0624627475858,
          84.15895182
        ],
        [
          0.00011089577658,
          0.0766758912145,
          80.52496252
        ],
        [
          0.00030252393523,
          0.05647472518789,
          86.24342414
        ],
        [
          0.00011087806104,
          0.07667550756536,
          80.52737959
        ],
        [
          0.00018529868523,
          0.06679262254945,
          82.71662551
        ],
        [
          0.00011110770398,
          0.07663090231112,
          80.53973194
        ],
        [
          0.0002548477896,
          0.06042129529011,
          84.53946762
        ],
        [
          0.00011087806104,
          0.07667550756536,
          80.52737959
        ],
        [
          0.00023901428316,
          0.06124976123203,
          84.65817528
        ],
        [
          0.00011110770398,
          0.07663090231112,
          80.53973194
        ],
        [
          0.00031630180301,
          0.05535328924892,
          86.83299191
        ],
        [
          0.00011066621978,
          0.07672054185938,
          80.51262316
        ],
        [
          0.00021478672265,
          0.0641156468911,
          83.24187427
        ],
        [
          0.00011089577658,
          0.0766758912145,
          80.52496252
        ],
        [
          0.00029056572521,
          0.05793468055849,
          85.19833602
        ],
        [
          0.00011066621978,
          0.07672054185938,
          80.51262316
        ],
        [
          0.00027308031483,
          0.05874452188493,
          85.30767283
        ],
        [
          0.00011089577658,
          0.0766758912145,
          80.52496252
        ],
        [
          0.00039289397058,
          0.05100862188815,
          88.43109572
        ],
        [
          0.00011087806104,
          0.07667550756536,
          80.52737959
        ],
        [
          0.00022739821013,
          0.06283407075711,
          83.71643933
        ],
        [
          0.00011110770398,
          0.07663090231112,
          80.53973194
        ],
        [
          0.00030480016724,
          0.05676917596498,
          85.75596796
        ],
        [
          0.00011087806104,
          0.07667550756536,
          80.52737959
        ],
        [
          0.00028633975164,
          0.05758999190389,
          85.85796734
        ],
        [
          0.00011110770398,
          0.07663090231112,
          80.53973194
        ],
        [
          0.00040891848811,
          0.04992575213603,
          89.13257073
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00014867189526,
          0.071190189786,
          81.58236308
        ],
        [
          0.00010997230791,
          0.07685542378465,
          80.4758042
        ],
        [
          0.00014894523429,
          0.07114981139044,
          81.594973
        ],
        [
          0.00010974347561,
          0.07689903472937,
          80.46455813
        ],
        [
          0.0001982964589,
          0.06527935563971,
          83.25032943
        ],
        [
          0.00010997230791,
          0.07685542378465,
          80.4758042
        ],
        [
          0.00019858866511,
          0.06524405471533,
          83.26464792
        ],
        [
          0.00010995497209,
          0.07685633539651,
          80.47705069
        ],
        [
          0.00015925978233,
          0.06978145302419,
          81.96104915
        ],
        [
          0.0001101839532,
          0.07681276185745,
          80.48830777
        ],
        [
          0.00015953819651,
          0.06974234010067,
          81.97403988
        ],
        [
          0.00010995497209,
          0.07685633539651,
          80.47705069
        ],
        [
          0.00021001320884,
          0.06402513447357,
          83.68695868
        ],
        [
          0.0001101839532,
          0.07681276185745,
          80.48830777
        ],
        [
          0.00021030664408,
          0.06399088837556,
          83.70170736
        ],
        [
          0.00010974347561,
          0.07689903472937,
          80.46455813
        ],
        [
          0.00014867189526,
          0.071190189786,
          81.58236308
        ],
        [
          0.00010997230791,
          0.07685542378465,
          80.4758042
        ],
        [
          0.00014894523429,
          0.07114981139044,
          81.594973
        ],
        [
          0.00010974347561,
          0.07689903472937,
          80.46455813
        ],
        [
          0.0001982964589,
          0.06527935563971,
          83.25032943
        ],
        [
          0.00010997230791,
          0.07685542378465,
          80.4758042
        ],
        [
          0.00022383579085,
          0.06303366887332,
          83.75061713
        ],
        [
          0.00010995497209,
          0.07685633539651,
          80.47705069
        ],
        [
          0.00015925978233,
          0.06978145302419,
          81.96104915
        ],
        [
          0.0001101839532,
          0.07681276185745,
          80.48830777
        ],
        [
          0.00015953819651,
          0.06974234010067,
          81.97403988
        ],
        [
          0.00010995497209,
          0.07685633539651,
          80.47705069
        ],
        [
          0.00021001320884,
          0.06402513447357,
          83.68695868
        ],
        [
          0.0001101839532,
          0.07681276185745,
          80.48830777
        ],
        [
          0.00023637810471,
          0.06181440516612,
          84.21091836
        ],
        [
          0.00011066707905,
          0.07673067797683,
          80.50360461
        ],
        [
          0.00017401642037,
          0.06823344081902,
          82.19869866
        ],
        [
          0.00011089689215,
          0.07668718327664,
          80.51489071
        ],
        [
          0.00024229294702,
          0.06175347020617,
          83.88013698
        ],
        [
          0.00011066707905,
          0.07673067797683,
          80.50360461
        ],
        [
          0.00022767038472,
          0.06256903426959,
          83.98483095
        ],
        [
          0.00011089689215,
          0.07668718327664,
          80.51489071
        ],
        [
          0.00030435772264,
          0.05660135273491,
          85.98379768
        ],
        [
          0.00011087935813,
          0.07668810341637,
          80.5161384
        ],
        [
          0.00018555491475,
          0.06688392408921,
          82.60347543
        ],
        [
          0.00011110931447,
          0.0766446465394,
          80.52743552
        ],
        [
          0.00025570237659,
          0.06053775760219,
          84.35348255
        ],
        [
          0.00011087935813,
          0.07668810341637,
          80.5161384
        ],
        [
          0.00024017372329,
          0.06136447994819,
          84.45181455
        ],
        [
          0.00011110931447,
          0.0766446465394,
          80.52743552
        ],
        [
          0.00031862586724,
          0.05548774117945,
          86.5350979
        ],
        [
          0.00011066707905,
          0.07673067797683,
          80.50360461
        ],
        [
          0.00021507811207,
          0.06420356999303,
          83.12810646
        ],
        [
          0.00011089689215,
          0.07668718327664,
          80.51489071
        ],
        [
          0.0002915147993,
          0.05804909697023,
          85.00837905
        ],
        [
          0.00011066707905,
          0.07673067797683,
          80.50360461
        ],
        [
          0.00027434947913,
          0.05885884496004,
          85.09653586
        ],
        [
          0.00011089689215,
          0.07668718327664,
          80.51489071
        ],
        [
          0.00039554555546,
          0.05115441181995,
          88.10420613
        ],
        [
          0.00011087935813,
          0.07668810341637,
          80.5161384
        ],
        [
          0.00022789231756,
          0.06293567532912,
          83.57251647
        ],
        [
          0.00011110931447,
          0.0766446465394,
          80.52743552
        ],
        [
          0.00030611241,
          0.05689447169763,
          85.53063669
        ],
        [
          0.00011087935813,
          0.07668810341637,
          80.5161384
        ],
        [
          0.00028801957186,
          0.05771261587636,
          85.61150342
        ],
        [
          0.00011110931447,
          0.0766446465394,
          80.52743552
        ],
        [
          0.00041213765658,
          0.05008324738954,
          88.75969193
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00014858307658,
          0.0712632037646,
          81.5214784
        ],
        [
          0.00010995854927,
          0.07686549681197,
          80.46858395
        ],
        [
          0.0001488561002,
          0.07122399525681,
          81.53295384
        ],
        [
          0.00010973159329,
          0.07690769773738,
          80.4583612
        ],
        [
          0.00019845756375,
          0.06540821663779,
          83.10397402
        ],
        [
          0.00010995854927,
          0.07686549681197,
          80.46858395
        ],
        [
          0.00019875520391,
          0.06537367815676,
          83.11701137
        ],
        [
          0.00010993993175,
          0.07686736194728,
          80.46914478
        ],
        [
          0.00015918209184,
          0.06987732317521,
          81.87514348
        ],
        [
          0.00011016707004,
          0.07682519248047,
          80.47937692
        ],
        [
          0.00015946151189,
          0.06983925626232,
          81.88696415
        ],
        [
          0.00010993993175,
          0.07686736194728,
          80.46914478
        ],
        [
          0.00021033249591,
          0.06416794535648,
          83.51170216
        ],
        [
          0.00011016707004,
          0.07682519248047,
          80.47937692
        ],
        [
          0.00021063320147,
          0.06413437070591,
          83.52512801
        ],
        [
          0.00010973159329,
          0.07690769773738,
          80.4583612
        ],
        [
          0.00014858307658,
          0.0712632037646,
          81.5214784
        ],
        [
          0.00010995854927,
          0.07686549681197,
          80.46858395
        ],
        [
          0.0001488561002,
          0.07122399525681,
          81.53295384
        ],
        [
          0.00010973159329,
          0.07690769773738,
          80.4583612
        ],
        [
          0.00019845756375,
          0.06540821663779,
          83.10397402
        ],
        [
          0.00010995854927,
          0.07686549681197,
          80.46858395
        ],
        [
          0.00022404982203,
          0.06316460230159,
          83.59464126
        ],
        [
          0.00010993993175,
          0.07686736194728,
          80.46914478
        ],
        [
          0.00015918209184,
          0.06987732317521,
          81.87514348
        ],
        [
          0.00011016707004,
          0.07682519248047,
          80.47937692
        ],
        [
          0.00015946151189,
          0.06983925626232,
          81.88696415
        ],
        [
          0.00010993993175,
          0.07686736194728,
          80.46914478
        ],
        [
          0.00021033249591,
          0.06416794535648,
          83.51170216
        ],
        [
          0.00011016707004,
          0.07682519248047,
          80.47937692
        ],
        [
          0.00023677298168,
          0.06195927555005,
          84.02480261
        ],
        [
          0.00011065036623,
          0.07674299211477,
          80.49473766
        ],
        [
          0.00017392671071,
          0.06832756079985,
          82.11309062
        ],
        [
          0.00011087836416,
          0.0767008956694,
          80.50499656
        ],
        [
          0.00024241199195,
          0.06188735104581,
          83.7255832
        ],
        [
          0.00011065036623,
          0.07674299211477,
          80.49473766
        ],
        [
          0.00022799826436,
          0.06271095072809,
          83.80788149
        ],
        [
          0.00011087836416,
          0.0767008956694,
          80.50499656
        ],
        [
          0.00030535636467,
          0.05677229505747,
          85.72035083
        ],
        [
          0.00011085957665,
          0.07670276415495,
          80.50555705
        ],
        [
          0.00018551278574,
          0.06699818873893,
          82.49134783
        ],
        [
          0.00011108775262,
          0.07666069950901,
          80.51582536
        ],
        [
          0.00025598886967,
          0.06068687935584,
          84.16816102
        ],
        [
          0.00011085957665,
          0.07670276415495,
          80.50555705
        ],
        [
          0.0002407137127,
          0.06151900578201,
          84.24403642
        ],
        [
          0.00011108775262,
          0.07666069950901,
          80.51582536
        ],
        [
          0.00031996290658,
          0.05567058300244,
          86.23489294
        ],
        [
          0.00011065036623,
          0.07674299211477,
          80.49473766
        ],
        [
          0.00021505289338,
          0.06431627211489,
          83.01139266
        ],
        [
          0.00011087836416,
          0.0767008956694,
          80.50499656
        ],
        [
          0.0002918724576,
          0.05819717836294,
          84.81462253
        ],
        [
          0.00011065036623,
          0.07674299211477,
          80.49473766
        ],
        [
          0.00027497418449,
          0.05901346156916,
          84.87945553
        ],
        [
          0.00011087836416,
          0.0767008956694,
          80.50499656
        ],
        [
          0.00039710688527,
          0.05134797810007,
          87.76894656
        ],
        [
          0.00011085957665,
          0.07670276415495,
          80.50555705
        ],
        [
          0.00022797245972,
          0.06306586805071,
          83.42704132
        ],
        [
          0.00011108775262,
          0.07666069950901,
          80.51582536
        ],
        [
          0.00030670154105,
          0.05705715675952,
          85.30298588
        ],
        [
          0.00011085957665,
          0.07670276415495,
          80.50555705
        ],
        [
          0.00028892210945,
          0.05787951851403,
          85.3604997
        ],
        [
          0.00011108775262,
          0.07666069950901,
          80.51582536
        ],
        [
          0.00041408882018,
          0.05029209321236,
          88.38006415
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00014835107124,
          0.0713492757205,
          81.46183854
        ],
        [
          0.00010993530902,
          0.0768752842299,
          80.46273582
        ],
        [
          0.00014861954651,
          0.07131197227956,
          81.47186108
        ],
        [
          0.00010971354933,
          0.07691529397077,
          80.45383018
        ],
        [
          0.00019819940241,
          0.06556980445794,
          82.9564077
        ],
        [
          0.00010993530902,
          0.0768752842299,
          80.46273582
        ],
        [
          0.00019849762201,
          0.06553668385401,
          82.96781407
        ],
        [
          0.00010991593103,
          0.07687747463625,
          80.46310144
        ],
        [
          0.0001588914125,
          0.06999154435884,
          81.7908164
        ],
        [
          0.00011013789415,
          0.07683749053273,
          80.47201485
        ],
        [
          0.00015916734367,
          0.06995524667995,
          81.80114231
        ],
        [
          0.00010991593103,
          0.07687747463625,
          80.46310144
        ],
        [
          0.00021013319981,
          0.06434850264467,
          83.33549837
        ],
        [
          0.00011013789415,
          0.07683749053273,
          80.47201485
        ],
        [
          0.00021043616229,
          0.06431624056346,
          83.34724465
        ],
        [
          0.00010971354933,
          0.07691529397077,
          80.45383018
        ],
        [
          0.00014835107124,
          0.0713492757205,
          81.46183854
        ],
        [
          0.00010993530902,
          0.0768752842299,
          80.46273582
        ],
        [
          0.00014861954651,
          0.07131197227956,
          81.47186108
        ],
        [
          0.00010971354933,
          0.07691529397077,
          80.45383018
        ],
        [
          0.00019819940241,
          0.06556980445794,
          82.9564077
        ],
        [
          0.00010993530902,
          0.0768752842299,
          80.46273582
        ],
        [
          0.00022379625587,
          0.06332904118782,
          83.43621726
        ],
        [
          0.00010991593103,
          0.07687747463625,
          80.46310144
        ],
        [
          0.0001588914125,
          0.06999154435884,
          81.7908164
        ],
        [
          0.00011013789415,
          0.07683749053273,
          80.47201485
        ],
        [
          0.00015916734367,
          0.06995524667995,
          81.80114231
        ],
        [
          0.00010991593103,
          0.07687747463625,
          80.46310144
        ],
        [
          0.00021013319981,
          0.06434850264467,
          83.33549837
        ],
        [
          0.00011013789415,
          0.07683749053273,
          80.47201485
        ],
        [
          0.00023659425432,
          0.06214243802631,
          83.83646864
        ],
        [
          0.00011062016808,
          0.0767556981865,
          80.48711377
        ],
        [
          0.00017361357175,
          0.06844047292656,
          82.02789252
        ],
        [
          0.00011084300755,
          0.07671577875039,
          80.49605082
        ],
        [
          0.00024206052452,
          0.06205047986206,
          83.57090922
        ],
        [
          0.00011062016808,
          0.0767556981865,
          80.48711377
        ],
        [
          0.00022778802088,
          0.0628903369709,
          83.62860645
        ],
        [
          0.00011084300755,
          0.07671577875039,
          80.49605082
        ],
        [
          0.00030547176426,
          0.0569895241827,
          85.45352575
        ],
        [
          0.00011082347008,
          0.07671797051296,
          80.4964157
        ],
        [
          0.00018516601371,
          0.06713632228253,
          82.37993583
        ],
        [
          0.00011104650993,
          0.07667807697714,
          80.50536053
        ],
        [
          0.00025569410791,
          0.06086996599664,
          83.98300053
        ],
        [
          0.00011082347008,
          0.07671797051296,
          80.4964157
        ],
        [
          0.00024060359893,
          0.06171586477826,
          84.03416739
        ],
        [
          0.00011104650993,
          0.07667807697714,
          80.50536053
        ],
        [
          0.00032027375595,
          0.05590424135047,
          85.9315423
        ],
        [
          0.00011062016808,
          0.0767556981865,
          80.48711377
        ],
        [
          0.00021469355853,
          0.06445187241683,
          82.89508809
        ],
        [
          0.00011084300755,
          0.07671577875039,
          80.49605082
        ],
        [
          0.00029160282795,
          0.05837780085722,
          84.62062366
        ],
        [
          0.00011062016808,
          0.0767556981865,
          80.48711377
        ],
        [
          0.00027489723383,
          0.05920863080346,
          84.65975608
        ],
        [
          0.00011084300755,
          0.07671577875039,
          80.49605082
        ],
        [
          0.0003974964671,
          0.05158987193293,
          87.42871529
        ],
        [
          0.00011082347008,
          0.07671797051296,
          80.4964157
        ],
        [
          0.00022762130695,
          0.06322378654163,
          83.28226684
        ],
        [
          0.00011104650993,
          0.07667807697714,
          80.50536053
        ],
        [
          0.00030653582162,
          0.05725686504478,
          85.07537666
        ],
        [
          0.00011082347008,
          0.07671797051296,
          80.4964157
        ],
        [
          0.00028899440911,
          0.05809159418491,
          85.10710638
        ],
        [
          0.00011104650993,
          0.07667807697714,
          80.50536053
        ],
        [
          0.00041469797817,
          0.05055343856805,
          87.99575531
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00014797133358,
          0.07144973243754,
          81.40270232
        ],
        [
          0.00010990409922,
          0.07688527334476,
          80.4576537
        ],
        [
          0.00014823423875,
          0.07141392738562,
          81.41173438
        ],
        [
          0.00010968777508,
          0.07692354914001,
          80.44963654
        ],
        [
          0.00019748025046,
          0.06577150667119,
          82.80352896
        ],
        [
          0.00010990409922,
          0.07688527334476,
          80.4576537
        ],
        [
          0.00019777606257,
          0.0657394953419,
          82.81380558
        ],
        [
          0.00010988181461,
          0.07688839723868,
          80.45754409
        ],
        [
          0.00015837852139,
          0.07012670857525,
          81.7065467
        ],
        [
          0.00011009834796,
          0.0768501427624,
          80.46556779
        ],
        [
          0.00015864952096,
          0.07009179772765,
          81.71584947
        ],
        [
          0.00010988181461,
          0.07688839723868,
          80.45754409
        ],
        [
          0.00020937014161,
          0.06457507657045,
          83.15334922
        ],
        [
          0.00011009834796,
          0.0768501427624,
          80.46556779
        ],
        [
          0.00020967175395,
          0.06454384381758,
          83.16392738
        ],
        [
          0.00010968777508,
          0.07692354914001,
          80.44963654
        ],
        [
          0.00014797133358,
          0.07144973243754,
          81.40270232
        ],
        [
          0.00010990409922,
          0.07688527334476,
          80.4576537
        ],
        [
          0.00014823423875,
          0.07141392738562,
          81.41173438
        ],
        [
          0.00010968777508,
          0.07692354914001,
          80.44963654
        ],
        [
          0.00019748025046,
          0.06577150667119,
          82.80352896
        ],
        [
          0.00010990409922,
          0.07688527334476,
          80.4576537
        ],
        [
          0.00022302399483,
          0.06353455287979,
          83.27119862
        ],
        [
          0.00010988181461,
          0.07688839723868,
          80.45754409
        ],
        [
          0.00015837852139,
          0.07012670857525,
          81.7065467
        ],
        [
          0.00011009834796,
          0.0768501427624,
          80.46556779
        ],
        [
          0.00015864952096,
          0.07009179772765,
          81.71584947
        ],
        [
          0.00010988181461,
          0.07688839723868,
          80.45754409
        ],
        [
          0.00020937014161,
          0.06457507657045,
          83.15334922
        ],
        [
          0.00011009834796,
          0.0768501427624,
          80.46556779
        ],
        [
          0.00023578793348,
          0.06237227233339,
          83.64084265
        ],
        [
          0.00011057518223,
          0.07677005220357,
          80.47978277
        ],
        [
          0.00017306794045,
          0.06857359587915,
          81.94262108
        ],
        [
          0.00011079258948,
          0.07673185535085,
          80.4878276
        ],
        [
          0.00024118745828,
          0.06225231310228,
          83.40955176
        ],
        [
          0.00011057518223,
          0.07677005220357,
          80.47978277
        ],
        [
          0.00022698993467,
          0.06311443905354,
          83.44305273
        ],
        [
          0.00011079258948,
          0.07673185535085,
          80.4878276
        ],
        [
          0.00030462243587,
          0.0572666136601,
          85.17234881
        ],
        [
          0.00011077015066,
          0.07673497720541,
          80.48771628
        ],
        [
          0.00018450023069,
          0.0673009779295,
          82.26795233
        ],
        [
          0.00011098776495,
          0.07669680188065,
          80.49576766
        ],
        [
          0.0002547649164,
          0.06109725816748,
          83.79043583
        ],
        [
          0.00011077015066,
          0.07673497720541,
          80.48771628
        ],
        [
          0.00023979081642,
          0.06196310552055,
          83.81733063
        ],
        [
          0.00011098776495,
          0.07669680188065,
          80.49576766
        ],
        [
          0.00031947832143,
          0.05620282703117,
          85.61290662
        ],
        [
          0.00011057518223,
          0.07677005220357,
          80.47978277
        ],
        [
          0.0002139895696,
          0.06461181013411,
          82.77865932
        ],
        [
          0.00011079258948,
          0.07673185535085,
          80.4878276
        ],
        [
          0.00029065499241,
          0.05859993701502,
          84.41936171
        ],
        [
          0.00011057518223,
          0.07677005220357,
          80.47978277
        ],
        [
          0.00027406557591,
          0.0594512474693,
          84.43321991
        ],
        [
          0.00011079258948,
          0.07673185535085,
          80.4878276
        ],
        [
          0.00039662224948,
          0.05189407841967,
          87.07021924
        ],
        [
          0.00011077015066,
          0.07673497720541,
          80.48771628
        ],
        [
          0.00022682156625,
          0.06341211354108,
          83.13680913
        ],
        [
          0.00011098776495,
          0.07669680188065,
          80.49576766
        ],
        [
          0.00030556302284,
          0.05750332815065,
          84.83971787
        ],
        [
          0.00011077015066,
          0.07673497720541,
          80.48771628
        ],
        [
          0.00028818104581,
          0.05835650609117,
          84.84612616
        ],
        [
          0.00011098776495,
          0.07669680188065,
          80.49576766
        ],
        [
          0.00041387759519,
          0.05088179738994,
          87.5921109
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00014740472713,
          0.07157284847273,
          81.34010394
        ],
        [
          0.00010986191239,
          0.07689666629997,
          80.45263853
        ],
        [
          0.00014765780059,
          0.07153911538613,
          81.34798112
        ],
        [
          0.00010965431289,
          0.07693259601565,
          80.44565943
        ],
        [
          0.00019621153697,
          0.06602553834494,
          82.64027719
        ],
        [
          0.00010986191239,
          0.07689666629997,
          80.45263853
        ],
        [
          0.00019649964276,
          0.06599515437236,
          82.64924178
        ],
        [
          0.00010983663727,
          0.0769006004842,
          80.45217242
        ],
        [
          0.0001575966837,
          0.07029199009485,
          81.61798256
        ],
        [
          0.00011004444166,
          0.07686468768994,
          80.45915678
        ],
        [
          0.00015785819246,
          0.07025903109832,
          81.62609448
        ],
        [
          0.00010983663727,
          0.0769006004842,
          80.45217242
        ],
        [
          0.00020794568739,
          0.06486058957526,
          82.95978085
        ],
        [
          0.00011004444166,
          0.07686468768994,
          80.45915678
        ],
        [
          0.00020824039091,
          0.06483089413784,
          82.96900505
        ],
        [
          0.00010965431289,
          0.07693259601565,
          80.44565943
        ],
        [
          0.00014740472713,
          0.07157284847273,
          81.34010394
        ],
        [
          0.00010986191239,
          0.07689666629997,
          80.45263853
        ],
        [
          0.00014765780059,
          0.07153911538613,
          81.34798112
        ],
        [
          0.00010965431289,
          0.07693259601565,
          80.44565943
        ],
        [
          0.00019621153697,
          0.06602553834494,
          82.64027719
        ],
        [
          0.00010986191239,
          0.07689666629997,
          80.45263853
        ],
        [
          0.00022163452959,
          0.06379313152524,
          83.09449292
        ],
        [
          0.00010983663727,
          0.0769006004842,
          80.45217242
        ],
        [
          0.0001575966837,
          0.07029199009485,
          81.61798256
        ],
        [
          0.00011004444166,
          0.07686468768994,
          80.45915678
        ],
        [
          0.00015785819246,
          0.07025903109832,
          81.62609448
        ],
        [
          0.00010983663727,
          0.0769006004842,
          80.45217242
        ],
        [
          0.00020794568739,
          0.06486058957526,
          82.95978085
        ],
        [
          0.00011004444166,
          0.07686468768994,
          80.45915678
        ],
        [
          0.00023424414974,
          0.06266156522311,
          83.43240887
        ],
        [
          0.00011051557537,
          0.07678608551375,
          80.4726998
        ],
        [
          0.00017222821916,
          0.06873826731813,
          81.8515863
        ],
        [
          0.00011072423025,
          0.0767502227457,
          80.47970259
        ],
        [
          0.00023969623992,
          0.06250332647912,
          83.23728303
        ],
        [
          0.00011051557537,
          0.07678608551375,
          80.4726998
        ],
        [
          0.00022548973851,
          0.06339798503085,
          83.24425365
        ],
        [
          0.00011072423025,
          0.0767502227457,
          80.47970259
        ],
        [
          0.0003026406893,
          0.05761736605478,
          84.87145068
        ],
        [
          0.00011069879965,
          0.07675415264755,
          80.47923412
        ],
        [
          0.00018344623598,
          0.0675042339073,
          82.14927654
        ],
        [
          0.00011090765801,
          0.07671830695964,
          80.48624217
        ],
        [
          0.00025309410242,
          0.06137997812181,
          83.58582105
        ],
        [
          0.00011069879965,
          0.07675415264755,
          80.47923412
        ],
        [
          0.00023815235834,
          0.06227602460494,
          83.58610208
        ],
        [
          0.00011090765801,
          0.07671830695964,
          80.48624217
        ],
        [
          0.00031739628051,
          0.05658073771703,
          85.27319477
        ],
        [
          0.00011051557537,
          0.07678608551375,
          80.4726998
        ],
        [
          0.00021283669094,
          0.06481317461875,
          82.65221582
        ],
        [
          0.00011072423025,
          0.0767502227457,
          80.47970259
        ],
        [
          0.0002888878585,
          0.05887912700994,
          84.20206384
        ],
        [
          0.00011051557537,
          0.07678608551375,
          80.4726998
        ],
        [
          0.00027232578675,
          0.05976065730901,
          84.18822332
        ],
        [
          0.00011072423025,
          0.0767502227457,
          80.47970259
        ],
        [
          0.00039425772038,
          0.05227776807635,
          86.68369692
        ],
        [
          0.00011069879965,
          0.07675415264755,
          80.47923412
        ],
        [
          0.00022546661765,
          0.06364813770078,
          82.98024232
        ],
        [
          0.00011090765801,
          0.07671830695964,
          80.48624217
        ],
        [
          0.00030363248107,
          0.05781263545057,
          84.58670216
        ],
        [
          0.00011069879965,
          0.07675415264755,
          80.47923412
        ],
        [
          0.00028632053748,
          0.05869402735469,
          84.5653587
        ],
        [
          0.00011090765801,
          0.07671830695964,
          80.48624217
        ],
        [
          0.00041138850272,
          0.05129485110241,
          87.15882209
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00014662114145,
          0.07172237249718,
          81.2736366
        ],
        [
          0.00010981207807,
          0.07690864057147,
          80.44802011
        ],
        [
          0.00014686267138,
          0.07169070905687,
          81.28049979
        ],
        [
          0.00010961425985,
          0.07694223248345,
          80.4419471
        ],
        [
          0.00019429728493,
          0.06634144593146,
          82.4655555
        ],
        [
          0.00010981207807,
          0.07690864057147,
          80.44802011
        ],
        [
          0.0001945746837,
          0.06631271091926,
          82.47336042
        ],
        [
          0.00010978258269,
          0.07691359152506,
          80.44716237
        ],
        [
          0.0001565102696,
          0.07049144199345,
          81.52493321
        ],
        [
          0.00010998059266,
          0.07688001284535,
          80.45323953
        ],
        [
          0.00015676027219,
          0.07046044228516,
          81.53199835
        ],
        [
          0.00010978258269,
          0.07691359152506,
          80.44716237
        ],
        [
          0.00020575344763,
          0.06521493086238,
          82.75395707
        ],
        [
          0.00010998059266,
          0.07688001284535,
          80.45323953
        ],
        [
          0.00020603787518,
          0.06518680121526,
          82.76198346
        ],
        [
          0.00010961425985,
          0.07694223248345,
          80.4419471
        ],
        [
          0.00014662114145,
          0.07172237249718,
          81.2736366
        ],
        [
          0.00010981207807,
          0.07690864057147,
          80.44802011
        ],
        [
          0.00014686267138,
          0.07169070905687,
          81.28049979
        ],
        [
          0.00010961425985,
          0.07694223248345,
          80.4419471
        ],
        [
          0.00019429728493,
          0.06634144593146,
          82.4655555
        ],
        [
          0.00010981207807,
          0.07690864057147,
          80.44802011
        ],
        [
          0.00021951147744,
          0.0641154394276,
          82.9043717
        ],
        [
          0.00010978258269,
          0.07691359152506,
          80.44716237
        ],
        [
          0.0001565102696,
          0.07049144199345,
          81.52493321
        ],
        [
          0.00010998059266,
          0.07688001284535,
          80.45323953
        ],
        [
          0.00015676027219,
          0.07046044228516,
          81.53199835
        ],
        [
          0.00010978258269,
          0.07691359152506,
          80.44716237
        ],
        [
          0.00020575344763,
          0.06521493086238,
          82.75395707
        ],
        [
          0.00010998059266,
          0.07688001284535,
          80.45323953
        ],
        [
          0.00023183582564,
          0.06302123278091,
          83.20969857
        ],
        [
          0.00011044451086,
          0.07680308640391,
          80.46612085
        ],
        [
          0.00017105604265,
          0.06893791690139,
          81.75516601
        ],
        [
          0.00011064333389,
          0.07676955095091,
          80.47221408
        ],
        [
          0.00023751192723,
          0.06280805446591,
          83.05540874
        ],
        [
          0.00011044451086,
          0.07680308640391,
          80.46612085
        ],
        [
          0.00022317507613,
          0.06375006977865,
          83.03197073
        ],
        [
          0.00011064333389,
          0.07676955095091,
          80.47221408
        ],
        [
          0.0002993568214,
          0.05805143461339,
          84.5517023
        ],
        [
          0.00011061367401,
          0.07677449556408,
          80.47135333
        ],
        [
          0.00018195870361,
          0.06774988252947,
          82.02453404
        ],
        [
          0.00011081268792,
          0.07674097346149,
          80.47745071
        ],
        [
          0.00025059636852,
          0.06172301037743,
          83.37078592
        ],
        [
          0.00011061367401,
          0.07677449556408,
          80.47135333
        ],
        [
          0.00023556335073,
          0.06266409298419,
          83.34054602
        ],
        [
          0.00011081268792,
          0.07674097346149,
          80.47745071
        ],
        [
          0.00031384443075,
          0.057047799747,
          84.91370433
        ],
        [
          0.00011044451086,
          0.07680308640391,
          80.46612085
        ],
        [
          0.00021115869089,
          0.06506208254762,
          82.51573682
        ],
        [
          0.00011064333389,
          0.07676955095091,
          80.47221408
        ],
        [
          0.0002861769777,
          0.05922227952537,
          83.96969971
        ],
        [
          0.00011044451086,
          0.07680308640391,
          80.46612085
        ],
        [
          0.00026951192756,
          0.06014820955773,
          83.92411084
        ],
        [
          0.00011064333389,
          0.07676955095091,
          80.47221408
        ],
        [
          0.00039014291255,
          0.05275345321896,
          86.26869452
        ],
        [
          0.00011061367401,
          0.07677449556408,
          80.47135333
        ],
        [
          0.00022346733989,
          0.06393851935491,
          82.81281338
        ],
        [
          0.00011081268792,
          0.07674097346149,
          80.47745071
        ],
        [
          0.00030060714258,
          0.05819195960236,
          84.31766805
        ],
        [
          0.00011061367401,
          0.07677449556408,
          80.47135333
        ],
        [
          0.00028323375547,
          0.05911570349661,
          84.2644939
        ],
        [
          0.00011081268792,
          0.07674097346149,
          80.47745071
        ],
        [
          0.00040695919284,
          0.05180501655444,
          86.6959653
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00014582616861,
          0.07186082327145,
          81.21924309
        ],
        [
          0.00010976965656,
          0.0769179969992,
          80.44482559
        ],
        [
          0.00014605550349,
          0.07183113724122,
          81.22526084
        ],
        [
          0.00010958188221,
          0.07694938331888,
          80.43950825
        ],
        [
          0.0001922222585,
          0.06664412503099,
          82.31947674
        ],
        [
          0.00010976965656,
          0.0769179969992,
          80.44482559
        ],
        [
          0.00019248712672,
          0.06661700938854,
          82.326316
        ],
        [
          0.00010974357366,
          0.07692219712327,
          80.44422456
        ],
        [
          0.00015541228491,
          0.07067441710215,
          81.44972695
        ],
        [
          0.00010993152843,
          0.07689082206377,
          80.44954547
        ],
        [
          0.00015564990249,
          0.07064530480202,
          81.45592044
        ],
        [
          0.00010974357366,
          0.07692219712327,
          80.44422456
        ],
        [
          0.00020336651069,
          0.06555249381096,
          82.58342632
        ],
        [
          0.00010993152843,
          0.07689082206377,
          80.44954547
        ],
        [
          0.00020363850153,
          0.06552591448462,
          82.59045688
        ],
        [
          0.00010958188221,
          0.07694938331888,
          80.43950825
        ],
        [
          0.00014582616861,
          0.07186082327145,
          81.21924309
        ],
        [
          0.00010976965656,
          0.0769179969992,
          80.44482559
        ],
        [
          0.00014605550349,
          0.07183113724122,
          81.22526084
        ],
        [
          0.00010958188221,
          0.07694938331888,
          80.43950825
        ],
        [
          0.0001922222585,
          0.06664412503099,
          82.31947674
        ],
        [
          0.00010976965656,
          0.0769179969992,
          80.44482559
        ],
        [
          0.00021718376984,
          0.06442591811298,
          82.7441236
        ],
        [
          0.00010974357366,
          0.07692219712327,
          80.44422456
        ],
        [
          0.00015541228491,
          0.07067441710215,
          81.44972695
        ],
        [
          0.00010993152843,
          0.07689082206377,
          80.44954547
        ],
        [
          0.00015564990249,
          0.07064530480202,
          81.45592044
        ],
        [
          0.00010974357366,
          0.07692219712327,
          80.44422456
        ],
        [
          0.00020336651069,
          0.06555249381096,
          82.58342632
        ],
        [
          0.00010993152843,
          0.07689082206377,
          80.44954547
        ],
        [
          0.00022918366781,
          0.06336548304104,
          83.02378697
        ],
        [
          0.00011038265266,
          0.07681666817427,
          80.46146908
        ],
        [
          0.00016986050375,
          0.06912267137501,
          81.67633659
        ],
        [
          0.00011057137158,
          0.07678532998749,
          80.4668039
        ],
        [
          0.00023519316634,
          0.0630942586274,
          82.90498277
        ],
        [
          0.00011038265266,
          0.07681666817427,
          80.46146908
        ],
        [
          0.00022064225727,
          0.06408644061317,
          82.85508148
        ],
        [
          0.00011057137158,
          0.07678532998749,
          80.4668039
        ],
        [
          0.00029562314435,
          0.05846705995731,
          84.28486954
        ],
        [
          0.00011054514167,
          0.07678952568541,
          80.46620057
        ],
        [
          0.00018043978632,
          0.06797585338305,
          81.92350331
        ],
        [
          0.00011073404039,
          0.07675819885544,
          80.47153896
        ],
        [
          0.00024792998637,
          0.06204372254812,
          83.19429626
        ],
        [
          0.00011054514167,
          0.07678952568541,
          80.46620057
        ],
        [
          0.00023270981609,
          0.06303322494352,
          83.13749092
        ],
        [
          0.00011073404039,
          0.07675819885544,
          80.47153896
        ],
        [
          0.00030977153583,
          0.05749311891382,
          84.61561706
        ],
        [
          0.00011038265266,
          0.07681666817427,
          80.46146908
        ],
        [
          0.00020940224087,
          0.06529549054917,
          82.40269479
        ],
        [
          0.00011057137158,
          0.07678532998749,
          80.4668039
        ],
        [
          0.00028322810631,
          0.05954654687414,
          83.7762548
        ],
        [
          0.00011038265266,
          0.07681666817427,
          80.46146908
        ],
        [
          0.0002663607084,
          0.06051979204079,
          83.70304561
        ],
        [
          0.00011057137158,
          0.07678532998749,
          80.4668039
        ],
        [
          0.000385355694,
          0.05320865306169,
          85.92006442
        ],
        [
          0.00011054514167,
          0.07678952568541,
          80.46620057
        ],
        [
          0.00022136863146,
          0.06420914775422,
          82.67545106
        ],
        [
          0.00011073404039,
          0.07675819885544,
          80.47153896
        ],
        [
          0.00029729638662,
          0.05854864387782,
          84.09536672
        ],
        [
          0.00011054514167,
          0.07678952568541,
          80.46620057
        ],
        [
          0.00027975028445,
          0.05951810518743,
          84.01449745
        ],
        [
          0.00011073404039,
          0.07675819885544,
          80.47153896
        ],
        [
          0.00040177162662,
          0.05229077878578,
          86.30971857
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00014489530491,
          0.0720124061795,
          81.16612482
        ],
        [
          0.00010972821945,
          0.07692655585305,
          80.44221672
        ],
        [
          0.00014511817279,
          0.07198360256999,
          81.17177165
        ],
        [
          0.0001095455208,
          0.07695690406216,
          80.43721814
        ],
        [
          0.00018966160345,
          0.06698764588973,
          82.17314431
        ],
        [
          0.00010972821945,
          0.07692655585305,
          80.44221672
        ],
        [
          0.00018991948558,
          0.06696117948301,
          82.17953645
        ],
        [
          0.00010969923243,
          0.07693135779501,
          80.44143261
        ],
        [
          0.00015411955148,
          0.07087529760118,
          81.37627861
        ],
        [
          0.00010988210126,
          0.07690101952358,
          80.44643437
        ],
        [
          0.00015435048735,
          0.07084701045574,
          81.38208478
        ],
        [
          0.00010969923243,
          0.07693135779501,
          80.44143261
        ],
        [
          0.00020040792424,
          0.06593529797243,
          82.41316829
        ],
        [
          0.00010988210126,
          0.07690101952358,
          80.44643437
        ],
        [
          0.00020067291333,
          0.065909324952,
          82.41973253
        ],
        [
          0.0001095455208,
          0.07695690406216,
          80.43721814
        ],
        [
          0.00014489530491,
          0.0720124061795,
          81.16612482
        ],
        [
          0.00010972821945,
          0.07692655585305,
          80.44221672
        ],
        [
          0.00014511817279,
          0.07198360256999,
          81.17177165
        ],
        [
          0.0001095455208,
          0.07695690406216,
          80.43721814
        ],
        [
          0.00018966160345,
          0.06698764588973,
          82.17314431
        ],
        [
          0.00010972821945,
          0.07692655585305,
          80.44221672
        ],
        [
          0.00021428925245,
          0.06477945176518,
          82.58274763
        ],
        [
          0.00010969923243,
          0.07693135779501,
          80.44143261
        ],
        [
          0.00015411955148,
          0.07087529760118,
          81.37627861
        ],
        [
          0.00010988210126,
          0.07690101952358,
          80.44643437
        ],
        [
          0.00015435048735,
          0.07084701045574,
          81.38208478
        ],
        [
          0.00010969923243,
          0.07693135779501,
          80.44143261
        ],
        [
          0.00020040792424,
          0.06593529797243,
          82.41316829
        ],
        [
          0.00010988210126,
          0.07690101952358,
          80.44643437
        ],
        [
          0.00022587290985,
          0.0637568638322,
          82.83727341
        ],
        [
          0.00011031554027,
          0.07683046753783,
          80.45725019
        ],
        [
          0.00016843578106,
          0.06932789579304,
          81.59823798
        ],
        [
          0.00011049913771,
          0.07680016221465,
          80.46226461
        ],
        [
          0.00023234666074,
          0.06341706640188,
          82.75401231
        ],
        [
          0.00011031554027,
          0.07683046753783,
          80.45725019
        ],
        [
          0.00021748389093,
          0.06446955885931,
          82.67724892
        ],
        [
          0.00011049913771,
          0.07680016221465,
          80.46226461
        ],
        [
          0.00029085249272,
          0.05894230463792,
          84.01570019
        ],
        [
          0.0001104699969,
          0.07680495892671,
          80.46147794
        ],
        [
          0.00017862323522,
          0.06822684222969,
          81.82368496
        ],
        [
          0.00011065376408,
          0.07677466362245,
          80.46649554
        ],
        [
          0.00024464276127,
          0.06240505072174,
          83.01778878
        ],
        [
          0.0001104699969,
          0.07680495892671,
          80.46147794
        ],
        [
          0.00022913424665,
          0.06345323826856,
          82.93404439
        ],
        [
          0.00011065376408,
          0.07677466362245,
          80.46649554
        ],
        [
          0.00030454078496,
          0.05800156069324,
          84.31589794
        ],
        [
          0.00011031554027,
          0.07683046753783,
          80.45725019
        ],
        [
          0.00020724399806,
          0.06556080736615,
          82.28809162
        ],
        [
          0.00011049913771,
          0.07680016221465,
          80.46226461
        ],
        [
          0.000279522659,
          0.05991680495977,
          83.57962181
        ],
        [
          0.00011031554027,
          0.07683046753783,
          80.45725019
        ],
        [
          0.00026234496839,
          0.06094725182605,
          83.4784421
        ],
        [
          0.00011049913771,
          0.07680016221465,
          80.46226461
        ],
        [
          0.00037910833632,
          0.05373207421193,
          85.5644984
        ],
        [
          0.0001104699969,
          0.07680495892671,
          80.46147794
        ],
        [
          0.0002187855933,
          0.06451581428386,
          82.53698877
        ],
        [
          0.00011065376408,
          0.07677466362245,
          80.46649554
        ],
        [
          0.00029312230595,
          0.05895490258276,
          83.87042336
        ],
        [
          0.0001104699969,
          0.07680495892671,
          80.46147794
        ],
        [
          0.00027529258251,
          0.05998002549047,
          83.76153915
        ],
        [
          0.00011065376408,
          0.07677466362245,
          80.46649554
        ],
        [
          0.0003949913946,
          0.05284740215731,
          85.91741508
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00014374111562,
          0.07219109765772,
          81.10991345
        ],
        [
          0.00010967698643,
          0.07693660318098,
          80.43946331
        ],
        [
          0.00014395460767,
          0.07216353748317,
          81.11510667
        ],
        [
          0.00010950161685,
          0.07696552582869,
          80.43485772
        ],
        [
          0.0001864330615,
          0.06739628222456,
          82.01851274
        ],
        [
          0.00010967698643,
          0.07693660318098,
          80.43946331
        ],
        [
          0.00018668029923,
          0.06737078563599,
          82.02436573
        ],
        [
          0.00010964480077,
          0.07694203493678,
          80.43850707
        ],
        [
          0.0001525242985,
          0.0711107793924,
          81.29916531
        ],
        [
          0.00010982032605,
          0.07691312066088,
          80.4431154
        ],
        [
          0.00015274548606,
          0.07108367015606,
          81.30449963
        ],
        [
          0.00010964480077,
          0.07694203493678,
          80.43850707
        ],
        [
          0.00019667293956,
          0.06638999576354,
          82.23394574
        ],
        [
          0.00010982032605,
          0.07691312066088,
          80.4431154
        ],
        [
          0.00019692711066,
          0.06636494120427,
          82.23994994
        ],
        [
          0.00010950161685,
          0.07696552582869,
          80.43485772
        ],
        [
          0.00014374111562,
          0.07219109765772,
          81.10991345
        ],
        [
          0.00010967698643,
          0.07693660318098,
          80.43946331
        ],
        [
          0.00014395460767,
          0.07216353748317,
          81.11510667
        ],
        [
          0.00010950161685,
          0.07696552582869,
          80.43485772
        ],
        [
          0.0001864330615,
          0.06739628222456,
          82.01851274
        ],
        [
          0.00010967698643,
          0.07693660318098,
          80.43946331
        ],
        [
          0.00021059892846,
          0.06520341001654,
          82.4105291
        ],
        [
          0.00010964480077,
          0.07694203493678,
          80.43850707
        ],
        [
          0.0001525242985,
          0.0711107793924,
          81.29916531
        ],
        [
          0.00010982032605,
          0.07691312066088,
          80.4431154
        ],
        [
          0.00015274548606,
          0.07108367015606,
          81.30449963
        ],
        [
          0.00010964480077,
          0.07694203493678,
          80.43850707
        ],
        [
          0.00019667293956,
          0.06638999576354,
          82.23394574
        ],
        [
          0.00010982032605,
          0.07691312066088,
          80.4431154
        ],
        [
          0.00022165079731,
          0.06422495821683,
          82.63917738
        ],
        [
          0.00011022930672,
          0.07684730409276,
          80.4526232
        ],
        [
          0.00016666295279,
          0.06957034624475,
          81.51544044
        ],
        [
          0.00011040550854,
          0.07681841791718,
          80.45724266
        ],
        [
          0.0002288065469,
          0.06379504342836,
          82.59578977
        ],
        [
          0.00011022930672,
          0.07684730409276,
          80.4526232
        ],
        [
          0.00021347741029,
          0.06492603649743,
          82.48913268
        ],
        [
          0.00011040550854,
          0.07681841791718,
          80.45724266
        ],
        [
          0.00028476596663,
          0.05950464817129,
          83.73311527
        ],
        [
          0.00011037316287,
          0.07682384396474,
          80.45628371
        ],
        [
          0.00017636769937,
          0.06852222767141,
          81.71853363
        ],
        [
          0.00011054952007,
          0.07679496622961,
          80.46090591
        ],
        [
          0.00024054441474,
          0.06282793377286,
          82.83331015
        ],
        [
          0.00011037316287,
          0.07682384396474,
          80.45628371
        ],
        [
          0.00022459289525,
          0.06395282639506,
          82.71960306
        ],
        [
          0.00011054952007,
          0.07679496622961,
          80.46090591
        ],
        [
          0.0002978492351,
          0.05860262442225,
          84.00204311
        ],
        [
          0.00011022930672,
          0.07684730409276,
          80.4526232
        ],
        [
          0.00020453357559,
          0.06587571800808,
          82.16607906
        ],
        [
          0.00011040550854,
          0.07681841791718,
          80.45724266
        ],
        [
          0.00027485879166,
          0.06035237861098,
          83.37258998
        ],
        [
          0.00011022930672,
          0.07684730409276,
          80.4526232
        ],
        [
          0.0002572039395,
          0.06145747492325,
          83.24029184
        ],
        [
          0.00011040550854,
          0.07681841791718,
          80.45724266
        ],
        [
          0.00037103109751,
          0.0543529169508,
          85.18871034
        ],
        [
          0.00011037316287,
          0.07682384396474,
          80.45628371
        ],
        [
          0.00021554342205,
          0.06487869074885,
          82.39039184
        ],
        [
          0.00011054952007,
          0.07679496622961,
          80.46090591
        ],
        [
          0.00028785712292,
          0.05943230932067,
          83.63429723
        ],
        [
          0.00011037316287,
          0.07682384396474,
          80.45628371
        ],
        [
          0.00026957374955,
          0.06053053735546,
          83.49426709
        ],
        [
          0.00011054952007,
          0.07679496622961,
          80.46090591
        ],
        [
          0.00038621365835,
          0.05350630899651,
          85.50413857
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00014238218364,
          0.07239361874107,
          81.05243506
        ],
        [
          0.00010962182303,
          0.07694697665603,
          80.43689227
        ],
        [
          0.00014258253233,
          0.0723677811605,
          81.05707931
        ],
        [
          0.00010945676693,
          0.07697397104901,
          80.43276654
        ],
        [
          0.00018253713176,
          0.06787031296439,
          81.85847158
        ],
        [
          0.00010962182303,
          0.07694697665603,
          80.43689227
        ],
        [
          0.0001827690414,
          0.06784622476217,
          81.86368126
        ],
        [
          0.00010959091507,
          0.07695217064364,
          80.4359954
        ],
        [
          0.00015065459946,
          0.07137653300122,
          81.220843
        ],
        [
          0.00010975611143,
          0.07692518320048,
          80.44012346
        ],
        [
          0.00015086208357,
          0.0713510742618,
          81.2256086
        ],
        [
          0.00010959091507,
          0.07695217064364,
          80.4359954
        ],
        [
          0.00019217230281,
          0.06691609304963,
          82.04938229
        ],
        [
          0.00010975611143,
          0.07692518320048,
          80.44012346
        ],
        [
          0.0001924107791,
          0.06689238738832,
          82.05472095
        ],
        [
          0.00010945676693,
          0.07697397104901,
          80.43276654
        ],
        [
          0.00014238218364,
          0.07239361874107,
          81.05243506
        ],
        [
          0.00010962182303,
          0.07694697665603,
          80.43689227
        ],
        [
          0.00014258253233,
          0.0723677811605,
          81.05707931
        ],
        [
          0.00010945676693,
          0.07697397104901,
          80.43276654
        ],
        [
          0.00018253713176,
          0.06787031296439,
          81.85847158
        ],
        [
          0.00010962182303,
          0.07694697665603,
          80.43689227
        ],
        [
          0.00020608683198,
          0.06570060891833,
          82.23010747
        ],
        [
          0.00010959091507,
          0.07695217064364,
          80.4359954
        ],
        [
          0.00015065459946,
          0.07137653300122,
          81.220843
        ],
        [
          0.00010975611143,
          0.07692518320048,
          80.44012346
        ],
        [
          0.00015086208357,
          0.0713510742618,
          81.2256086
        ],
        [
          0.00010959091507,
          0.07695217064364,
          80.4359954
        ],
        [
          0.00019217230281,
          0.06691609304963,
          82.04938229
        ],
        [
          0.00010975611143,
          0.07692518320048,
          80.44012346
        ],
        [
          0.00021649886078,
          0.06477195613159,
          82.43290327
        ],
        [
          0.00011013952418,
          0.07686411619221,
          80.44844539
        ],
        [
          0.00016454940474,
          0.06984856196918,
          81.42979297
        ],
        [
          0.00011030533129,
          0.07683715167886,
          80.45258296
        ],
        [
          0.00022448649447,
          0.06423716636168,
          82.42950489
        ],
        [
          0.00011013952418,
          0.07686411619221,
          80.44844539
        ],
        [
          0.00020860868034,
          0.06545793477684,
          82.29372263
        ],
        [
          0.00011030533129,
          0.07683715167886,
          80.45258296
        ],
        [
          0.00027724241334,
          0.06016578600231,
          83.43745149
        ],
        [
          0.00011027427597,
          0.07684234097701,
          80.45168371
        ],
        [
          0.0001736910141,
          0.06885953840886,
          81.61056182
        ],
        [
          0.00011044022314,
          0.07681538346927,
          80.45582361
        ],
        [
          0.00023555842221,
          0.06332036631619,
          82.64075762
        ],
        [
          0.00011027427597,
          0.07684234097701,
          80.45168371
        ],
        [
          0.00021907852547,
          0.06453352625863,
          82.49793592
        ],
        [
          0.00011044022314,
          0.07681538346927,
          80.45582361
        ],
        [
          0.0002895862246,
          0.05930713330194,
          83.67523953
        ],
        [
          0.00011013952418,
          0.07686411619221,
          80.44844539
        ],
        [
          0.00020119250582,
          0.06624853080022,
          82.03601185
        ],
        [
          0.00011030533129,
          0.07683715167886,
          80.45258296
        ],
        [
          0.00026904260846,
          0.06087065250983,
          83.1514019
        ],
        [
          0.00011013952418,
          0.07686411619221,
          80.44844539
        ],
        [
          0.00025082412625,
          0.06206161061208,
          82.98901183
        ],
        [
          0.00011030533129,
          0.07683715167886,
          80.45258296
        ],
        [
          0.00036084106092,
          0.0550918172443,
          84.78956075
        ],
        [
          0.00011027427597,
          0.07684234097701,
          80.45168371
        ],
        [
          0.00021157289451,
          0.06530504294053,
          82.23568785
        ],
        [
          0.00011044022314,
          0.07681538346927,
          80.45582361
        ],
        [
          0.00028131572567,
          0.05999720728312,
          83.38395627
        ],
        [
          0.00011027427597,
          0.07684234097701,
          80.45168371
        ],
        [
          0.00026249088242,
          0.06117986215807,
          83.21389899
        ],
        [
          0.00011044022314,
          0.07681538346927,
          80.45582361
        ],
        [
          0.0003751685709,
          0.05428703956408,
          85.06769409
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00014098585024,
          0.07259575608941,
          81.0004262
        ],
        [
          0.00010956388314,
          0.07695750151178,
          80.43452087
        ],
        [
          0.00014116094703,
          0.07257334898401,
          81.00413885
        ],
        [
          0.00010941922337,
          0.07698079928234,
          80.43122933
        ],
        [
          0.00017856965477,
          0.06834067163812,
          81.7160723
        ],
        [
          0.00010956388314,
          0.07695750151178,
          80.43452087
        ],
        [
          0.00017877227279,
          0.06831961119384,
          81.72023145
        ],
        [
          0.00010954171032,
          0.07696111065531,
          80.43398138
        ],
        [
          0.00014872822126,
          0.07164282423925,
          81.14986127
        ],
        [
          0.00010968648593,
          0.07693781790966,
          80.43727469
        ],
        [
          0.00014890947806,
          0.07162070506314,
          81.15366982
        ],
        [
          0.00010954171032,
          0.07696111065531,
          80.43398138
        ],
        [
          0.00018756794349,
          0.06744049261818,
          81.88480043
        ],
        [
          0.00010968648593,
          0.07693781790966,
          80.43727469
        ],
        [
          0.00018777636014,
          0.06741973198733,
          81.8890608
        ],
        [
          0.00010941922337,
          0.07698079928234,
          80.43122933
        ],
        [
          0.00014098585024,
          0.07259575608941,
          81.0004262
        ],
        [
          0.00010956388314,
          0.07695750151178,
          80.43452087
        ],
        [
          0.00014116094703,
          0.07257334898401,
          81.00413885
        ],
        [
          0.00010941922337,
          0.07698079928234,
          80.43122933
        ],
        [
          0.00017856965477,
          0.06834067163812,
          81.7160723
        ],
        [
          0.00010956388314,
          0.07695750151178,
          80.43452087
        ],
        [
          0.00020140213587,
          0.06620288541659,
          82.06654656
        ],
        [
          0.00010954171032,
          0.07696111065531,
          80.43398138
        ],
        [
          0.00014872822126,
          0.07164282423925,
          81.14986127
        ],
        [
          0.00010968648593,
          0.07693781790966,
          80.43727469
        ],
        [
          0.00014890947806,
          0.07162070506314,
          81.15366982
        ],
        [
          0.00010954171032,
          0.07696111065531,
          80.43398138
        ],
        [
          0.00018756794349,
          0.06744049261818,
          81.88480043
        ],
        [
          0.00010968648593,
          0.07693781790966,
          80.43727469
        ],
        [
          0.00021113591509,
          0.0653257923373,
          82.2459101
        ],
        [
          0.00011005664433,
          0.07687911038669,
          80.44505856
        ],
        [
          0.00016235139162,
          0.07012993260014,
          81.3513298
        ],
        [
          0.00011020193561,
          0.07685583454332,
          80.44835939
        ],
        [
          0.00021989227937,
          0.06469395724773,
          82.2745165
        ],
        [
          0.00011005664433,
          0.07687911038669,
          80.44505856
        ],
        [
          0.00020359887684,
          0.06599059609303,
          82.1184288
        ],
        [
          0.00011020193561,
          0.07685583454332,
          80.44835939
        ],
        [
          0.00026932860289,
          0.06083948141695,
          83.16828639
        ],
        [
          0.00011017965713,
          0.07685944156754,
          80.44781839
        ],
        [
          0.00017090477251,
          0.06920118283619,
          81.51176367
        ],
        [
          0.0001103250642,
          0.07683617078664,
          80.45112099
        ],
        [
          0.00023025775763,
          0.06382877046126,
          82.46184148
        ],
        [
          0.00011017965713,
          0.07685944156754,
          80.44781839
        ],
        [
          0.00021338383096,
          0.06511691822355,
          82.2988988
        ],
        [
          0.0001103250642,
          0.07683617078664,
          80.45112099
        ],
        [
          0.00028087940427,
          0.06002562158607,
          83.37800538
        ],
        [
          0.00011005664433,
          0.07687911038669,
          80.44505856
        ],
        [
          0.00019772943799,
          0.06662410856094,
          81.91752054
        ],
        [
          0.00011020193561,
          0.07685583454332,
          80.44835939
        ],
        [
          0.00026287858926,
          0.0614027962964,
          82.94675888
        ],
        [
          0.00011005664433,
          0.07687911038669,
          80.44505856
        ],
        [
          0.00024423693981,
          0.06266690805,
          82.76368204
        ],
        [
          0.00011020193561,
          0.07685583454332,
          80.44835939
        ],
        [
          0.00035003592724,
          0.05584625184646,
          84.42484093
        ],
        [
          0.00011017965713,
          0.07685944156754,
          80.44781839
        ],
        [
          0.00020744798004,
          0.06573553115805,
          82.0947783
        ],
        [
          0.0001103250642,
          0.07683617078664,
          80.45112099
        ],
        [
          0.00027437809416,
          0.06057721537175,
          83.15283861
        ],
        [
          0.00011017965713,
          0.07685944156754,
          80.44781839
        ],
        [
          0.00025515281943,
          0.06183213091072,
          82.96234436
        ],
        [
          0.0001103250642,
          0.07683617078664,
          80.45112099
        ],
        [
          0.00036344840626,
          0.05508399593099,
          84.66956943
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00013949615587,
          0.0728066755986,
          80.95100176
        ],
        [
          0.00010951897947,
          0.07696542473463,
          80.43289057
        ],
        [
          0.00013964927436,
          0.07278716798209,
          80.95399544
        ],
        [
          0.00010939199167,
          0.07698560956939,
          80.43024027
        ],
        [
          0.00017436545513,
          0.06883104846001,
          81.58225144
        ],
        [
          0.00010951897947,
          0.07696542473463,
          80.43289057
        ],
        [
          0.00017454225629,
          0.06881256856444,
          81.58559864
        ],
        [
          0.00010950549092,
          0.07696750249205,
          80.43266628
        ],
        [
          0.00014668649247,
          0.07191934469119,
          81.0828888
        ],
        [
          0.00010963257539,
          0.07694732137912,
          80.43531798
        ],
        [
          0.00014684487085,
          0.07190005405263,
          81.08595848
        ],
        [
          0.00010950549092,
          0.07696750249205,
          80.43266628
        ],
        [
          0.00018269371139,
          0.06798705585857,
          81.73052751
        ],
        [
          0.00010963257539,
          0.07694732137912,
          80.43531798
        ],
        [
          0.00018287555283,
          0.06796880927626,
          81.73395446
        ],
        [
          0.00010939199167,
          0.07698560956939,
          80.43024027
        ],
        [
          0.00013949615587,
          0.0728066755986,
          80.95100176
        ],
        [
          0.00010951897947,
          0.07696542473463,
          80.43289057
        ],
        [
          0.00013964927436,
          0.07278716798209,
          80.95399544
        ],
        [
          0.00010939199167,
          0.07698560956939,
          80.43024027
        ],
        [
          0.00017436545513,
          0.06883104846001,
          81.58225144
        ],
        [
          0.00010951897947,
          0.07696542473463,
          80.43289057
        ],
        [
          0.00019640189562,
          0.06672998119763,
          81.91176973
        ],
        [
          0.00010950549092,
          0.07696750249205,
          80.43266628
        ],
        [
          0.00014668649247,
          0.07191934469119,
          81.0828888
        ],
        [
          0.00010963257539,
          0.07694732137912,
          80.43531798
        ],
        [
          0.00014684487085,
          0.07190005405263,
          81.08595848
        ],
        [
          0.00010950549092,
          0.07696750249205,
          80.43266628
        ],
        [
          0.00018269371139,
          0.06798705585857,
          81.73052751
        ],
        [
          0.00010963257539,
          0.07694732137912,
          80.43531798
        ],
        [
          0.00020541948523,
          0.06590646559679,
          82.06950959
        ],
        [
          0.00010997881368,
          0.07689279053455,
          80.44223698
        ],
        [
          0.00015998100958,
          0.07042725270785,
          81.27591461
        ],
        [
          0.00011010632538,
          0.07687262140163,
          80.44489453
        ],
        [
          0.00021499407528,
          0.06517183248094,
          82.12761604
        ],
        [
          0.00010997881368,
          0.07689279053455,
          80.44223698
        ],
        [
          0.00019824576748,
          0.06655053299389,
          81.95253376
        ],
        [
          0.00011010632538,
          0.07687262140163,
          80.44489453
        ],
        [
          0.00026088184624,
          0.06154547401268,
          82.91507847
        ],
        [
          0.00011009277062,
          0.07687469900678,
          80.44466946
        ],
        [
          0.00016791903806,
          0.06956036306827,
          81.41751556
        ],
        [
          0.00011022037895,
          0.07685453362809,
          80.44732841
        ],
        [
          0.00022461496347,
          0.0643600491735,
          82.29282274
        ],
        [
          0.00011009277062,
          0.07687469900678,
          80.44466946
        ],
        [
          0.00020730648126,
          0.06572964629735,
          82.11110622
        ],
        [
          0.00011022037895,
          0.07685453362809,
          80.44732841
        ],
        [
          0.00027158787048,
          0.06077825373518,
          83.09904228
        ],
        [
          0.00010997881368,
          0.07689279053455,
          80.44223698
        ],
        [
          0.00019396777618,
          0.06702415896747,
          81.80289019
        ],
        [
          0.00011010632538,
          0.07687262140163,
          80.44489453
        ],
        [
          0.00025624648474,
          0.06196383082949,
          82.75153008
        ],
        [
          0.00010997881368,
          0.07689279053455,
          80.44223698
        ],
        [
          0.00023713929239,
          0.06330756247,
          82.54920559
        ],
        [
          0.00011010632538,
          0.07687262140163,
          80.44489453
        ],
        [
          0.00033837470133,
          0.05664212838756,
          84.07916953
        ],
        [
          0.00011009277062,
          0.07687469900678,
          80.44466946
        ],
        [
          0.00020298974303,
          0.06619210365733,
          81.95936228
        ],
        [
          0.00011022037895,
          0.07685453362809,
          80.44732841
        ],
        [
          0.00026692666539,
          0.06118769317363,
          82.93315434
        ],
        [
          0.00011009277062,
          0.07687469900678,
          80.44466946
        ],
        [
          0.00024725754307,
          0.06252153232862,
          82.72369531
        ],
        [
          0.00011022037895,
          0.07685453362809,
          80.44732841
        ],
        [
          0.00035081442696,
          0.05592348096118,
          84.29337232
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00013789852779,
          0.07302914986378,
          80.90335742
        ],
        [
          0.00010948576284,
          0.0769711423993,
          80.4318118
        ],
        [
          0.00013804090082,
          0.07301093276531,
          80.90604075
        ],
        [
          0.00010936702946,
          0.07698991068449,
          80.4294293
        ],
        [
          0.00016995649259,
          0.06934102597925,
          81.45634391
        ],
        [
          0.00010948576284,
          0.0769711423993,
          80.4318118
        ],
        [
          0.00017012010469,
          0.06932364988672,
          81.45932761
        ],
        [
          0.00010947208029,
          0.07697325421216,
          80.43158114
        ],
        [
          0.00014453626397,
          0.07220637630425,
          81.01949263
        ],
        [
          0.00010959089857,
          0.0769544889598,
          80.43396483
        ],
        [
          0.00014468333743,
          0.07218833557112,
          81.02224078
        ],
        [
          0.00010947208029,
          0.07697325421216,
          80.43158114
        ],
        [
          0.00017760969736,
          0.06855309904581,
          81.58629491
        ],
        [
          0.00010959089857,
          0.0769544889598,
          80.43396483
        ],
        [
          0.0001777778693,
          0.0685359179904,
          81.58934629
        ],
        [
          0.00010936702946,
          0.07698991068449,
          80.4294293
        ],
        [
          0.00013789852779,
          0.07302914986378,
          80.90335742
        ],
        [
          0.00010948576284,
          0.0769711423993,
          80.4318118
        ],
        [
          0.00013804090082,
          0.07301093276531,
          80.90604075
        ],
        [
          0.00010936702946,
          0.07698991068449,
          80.4294293
        ],
        [
          0.00016995649259,
          0.06934102597925,
          81.45634391
        ],
        [
          0.00010948576284,
          0.0769711423993,
          80.4318118
        ],
        [
          0.00019109457792,
          0.06728475919445,
          81.7643803
        ],
        [
          0.00010947208029,
          0.07697325421216,
          80.43158114
        ],
        [
          0.00014453626397,
          0.07220637630425,
          81.01949263
        ],
        [
          0.00010959089857,
          0.0769544889598,
          80.43396483
        ],
        [
          0.00014468333743,
          0.07218833557112,
          81.02224078
        ],
        [
          0.00010947208029,
          0.07697325421216,
          80.43158114
        ],
        [
          0.00017760969736,
          0.06855309904581,
          81.58629491
        ],
        [
          0.00010959089857,
          0.0769544889598,
          80.43396483
        ],
        [
          0.00019938756949,
          0.06651464254191,
          81.90270766
        ],
        [
          0.00010990485141,
          0.07690547610929,
          80.43983823
        ],
        [
          0.0001574247061,
          0.07074344342639,
          81.20272248
        ],
        [
          0.00011002404208,
          0.07688672004635,
          80.44222684
        ],
        [
          0.0002097062249,
          0.06568220730438,
          81.98503983
        ],
        [
          0.00010990485141,
          0.07690547610929,
          80.43983823
        ],
        [
          0.00019258913986,
          0.06713779407475,
          81.79536405
        ],
        [
          0.00011002404208,
          0.07688672004635,
          80.44222684
        ],
        [
          0.00025187916072,
          0.06229226789886,
          82.67393345
        ],
        [
          0.00011001029794,
          0.07688883172465,
          80.44199546
        ],
        [
          0.00016474542432,
          0.06993752382349,
          81.32738533
        ],
        [
          0.00011012957354,
          0.07687007871615,
          80.44438526
        ],
        [
          0.00021857292345,
          0.06492334711216,
          82.13031912
        ],
        [
          0.00011001029794,
          0.07688883172465,
          80.44199546
        ],
        [
          0.00020091687671,
          0.06636962171694,
          81.93429868
        ],
        [
          0.00011012957354,
          0.07687007871615,
          80.44438526
        ],
        [
          0.00026172459859,
          0.06157146853089,
          82.83482708
        ],
        [
          0.00010990485141,
          0.07690547610929,
          80.43983823
        ],
        [
          0.00018980663166,
          0.06746145778468,
          81.6887752
        ],
        [
          0.00011002404208,
          0.07688672004635,
          80.44222684
        ],
        [
          0.00024895565379,
          0.06257398160931,
          82.55892423
        ],
        [
          0.00010990485141,
          0.07690547610929,
          80.43983823
        ],
        [
          0.00022948426986,
          0.06399326364628,
          82.34219762
        ],
        [
          0.00011002404208,
          0.07688672004635,
          80.44222684
        ],
        [
          0.00032567290732,
          0.05750004343829,
          83.74380756
        ],
        [
          0.00011001029794,
          0.07688883172465,
          80.44199546
        ],
        [
          0.00019812317649,
          0.06668518047089,
          81.82647546
        ],
        [
          0.00011012957354,
          0.07687007871615,
          80.44438526
        ],
        [
          0.00025880026207,
          0.06184668321026,
          82.7184719
        ],
        [
          0.00011001029794,
          0.07688883172465,
          80.44199546
        ],
        [
          0.00023878949124,
          0.06325570086089,
          82.49496169
        ],
        [
          0.00011012957354,
          0.07687007871615,
          80.44438526
        ],
        [
          0.00033711904594,
          0.05682417073883,
          83.93066833
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00013611740547,
          0.07327428899511,
          80.8552476
        ],
        [
          0.00010943667345,
          0.07697941455012,
          80.43037565
        ],
        [
          0.00013624178411,
          0.07325833789911,
          80.85745483
        ],
        [
          0.00010933231831,
          0.07699576529229,
          80.42841348
        ],
        [
          0.00016522966461,
          0.06988691327622,
          81.33410346
        ],
        [
          0.00010943667345,
          0.07697941455012,
          80.43037565
        ],
        [
          0.00016537185343,
          0.0698715855807,
          81.33654806
        ],
        [
          0.00010942908088,
          0.07698050079087,
          80.4303231
        ],
        [
          0.00014218301642,
          0.0725176072069,
          80.9566332
        ],
        [
          0.00010953350629,
          0.07696415227727,
          80.43228622
        ],
        [
          0.00014231133179,
          0.07250178570417,
          80.9588919
        ],
        [
          0.00010942908088,
          0.07698050079087,
          80.4303231
        ],
        [
          0.00017218378313,
          0.06915726173722,
          81.4469569
        ],
        [
          0.00010953350629,
          0.07696415227727,
          80.43228622
        ],
        [
          0.00017232985172,
          0.06914208138181,
          81.44945491
        ],
        [
          0.00010933231831,
          0.07699576529229,
          80.42841348
        ],
        [
          0.00013611740547,
          0.07327428899511,
          80.8552476
        ],
        [
          0.00010943667345,
          0.07697941455012,
          80.43037565
        ],
        [
          0.00013624178411,
          0.07325833789911,
          80.85745483
        ],
        [
          0.00010933231831,
          0.07699576529229,
          80.42841348
        ],
        [
          0.00016522966461,
          0.06988691327622,
          81.33410346
        ],
        [
          0.00010943667345,
          0.07697941455012,
          80.43037565
        ],
        [
          0.00018531535495,
          0.06788833391868,
          81.61900069
        ],
        [
          0.00010942908088,
          0.07698050079087,
          80.4303231
        ],
        [
          0.00014218301642,
          0.0725176072069,
          80.9566332
        ],
        [
          0.00010953350629,
          0.07696415227727,
          80.43228622
        ],
        [
          0.00014231133179,
          0.07250178570417,
          80.9588919
        ],
        [
          0.00010942908088,
          0.07698050079087,
          80.4303231
        ],
        [
          0.00017218378313,
          0.06915726173722,
          81.4469569
        ],
        [
          0.00010953350629,
          0.07696415227727,
          80.43228622
        ],
        [
          0.00019285428739,
          0.06717369834795,
          81.73917393
        ],
        [
          0.00010981870652,
          0.07691994468709,
          80.43732118
        ],
        [
          0.00015460940299,
          0.07108876162084,
          81.12959496
        ],
        [
          0.00010992343419,
          0.07690360232081,
          80.43928811
        ],
        [
          0.00020388091649,
          0.06624256897541,
          81.84253934
        ],
        [
          0.00010981870652,
          0.07691994468709,
          80.43732118
        ],
        [
          0.00018652038767,
          0.0677679006294,
          81.64268516
        ],
        [
          0.00010992343419,
          0.07690360232081,
          80.43928811
        ],
        [
          0.0002421320918,
          0.06310232048375,
          82.43812588
        ],
        [
          0.00010991580538,
          0.07690468927773,
          80.43923521
        ],
        [
          0.00016129045852,
          0.07034553046154,
          81.23838342
        ],
        [
          0.00011002060335,
          0.07688834915823,
          80.44120309
        ],
        [
          0.00021196149026,
          0.06553845506436,
          81.9691258
        ],
        [
          0.00010991580538,
          0.07690468927773,
          80.43923521
        ],
        [
          0.00019408683284,
          0.06705468463817,
          81.76330013
        ],
        [
          0.00011002060335,
          0.07688834915823,
          80.44120309
        ],
        [
          0.00025107981938,
          0.06242981831448,
          82.57752586
        ],
        [
          0.00010981870652,
          0.07691994468709,
          80.43732118
        ],
        [
          0.00018523205432,
          0.06793977234431,
          81.57490176
        ],
        [
          0.00010992343419,
          0.07690360232081,
          80.43928811
        ],
        [
          0.00024092265234,
          0.06324474036449,
          82.36667701
        ],
        [
          0.00010981870652,
          0.07691994468709,
          80.43732118
        ],
        [
          0.00022123006551,
          0.06473357485601,
          82.14033524
        ],
        [
          0.00010992343419,
          0.07690360232081,
          80.43928811
        ],
        [
          0.00031177737571,
          0.0584391282207,
          83.4133945
        ],
        [
          0.00010991580538,
          0.07690468927773,
          80.43923521
        ],
        [
          0.00019281516024,
          0.06722109594875,
          81.69499536
        ],
        [
          0.00011002060335,
          0.07688834915823,
          80.44120309
        ],
        [
          0.00024989508343,
          0.06256792076054,
          82.50552983
        ],
        [
          0.00010991580538,
          0.07690468927773,
          80.43923521
        ],
        [
          0.00022968693144,
          0.06404660700439,
          82.27284731
        ],
        [
          0.00011002060335,
          0.07688834915823,
          80.44120309
        ],
        [
          0.00032218393066,
          0.05780738526179,
          83.57487282
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00013426578474,
          0.07352719841961,
          80.80965363
        ],
        [
          0.00010939865502,
          0.07698570428632,
          80.42936769
        ],
        [
          0.0001343765968,
          0.07351290468996,
          80.81153566
        ],
        [
          0.00010930501029,
          0.07700028680692,
          80.42768926
        ],
        [
          0.00016037209249,
          0.07045027768419,
          81.21943283
        ],
        [
          0.00010939865502,
          0.07698570428632,
          80.42936769
        ],
        [
          0.00016049792721,
          0.07043644522129,
          81.22150532
        ],
        [
          0.00010939206316,
          0.07698662535108,
          80.42934161
        ],
        [
          0.00013971373375,
          0.07284263132299,
          80.89646624
        ],
        [
          0.00010948576572,
          0.07697204446632,
          80.43102079
        ],
        [
          0.000139827846,
          0.07282843229745,
          80.89838956
        ],
        [
          0.00010939206316,
          0.07698662535108,
          80.42934161
        ],
        [
          0.00016657583385,
          0.06978564596095,
          81.31554426
        ],
        [
          0.00010948576572,
          0.07697204446632,
          80.43102079
        ],
        [
          0.00016670493036,
          0.06977192684537,
          81.31765976
        ],
        [
          0.00010930501029,
          0.07700028680692,
          80.42768926
        ],
        [
          0.00013426578474,
          0.07352719841961,
          80.80965363
        ],
        [
          0.00010939865502,
          0.07698570428632,
          80.42936769
        ],
        [
          0.0001343765968,
          0.07351290468996,
          80.81153566
        ],
        [
          0.00010930501029,
          0.07700028680692,
          80.42768926
        ],
        [
          0.00016037209249,
          0.07045027768419,
          81.21943283
        ],
        [
          0.00010939865502,
          0.07698570428632,
          80.42936769
        ],
        [
          0.00017923534067,
          0.06852702732973,
          81.4793438
        ],
        [
          0.00010939206316,
          0.07698662535108,
          80.42934161
        ],
        [
          0.00013971373375,
          0.07284263132299,
          80.89646624
        ],
        [
          0.00010948576572,
          0.07697204446632,
          80.43102079
        ],
        [
          0.000139827846,
          0.07282843229745,
          80.89838956
        ],
        [
          0.00010939206316,
          0.07698662535108,
          80.42934161
        ],
        [
          0.00016657583385,
          0.06978564596095,
          81.31554426
        ],
        [
          0.00010948576572,
          0.07697204446632,
          80.43102079
        ],
        [
          0.00018596148878,
          0.06787436548973,
          81.5816993
        ],
        [
          0.0001097344068,
          0.07693384970578,
          80.43508868
        ],
        [
          0.00015161333077,
          0.0714549588628,
          81.05851282
        ],
        [
          0.00010982835393,
          0.07691927274946,
          80.43677082
        ],
        [
          0.0001975959262,
          0.06684921285742,
          81.70197975
        ],
        [
          0.0001097344068,
          0.07693384970578,
          80.43508868
        ],
        [
          0.00018019319133,
          0.068429270519,
          81.49736563
        ],
        [
          0.00010982835393,
          0.07691927274946,
          80.43677082
        ],
        [
          0.00023180738915,
          0.06396939115271,
          82.21048335
        ],
        [
          0.00010982173316,
          0.07692019453289,
          80.43674449
        ],
        [
          0.00015760281606,
          0.07078055115682,
          81.15161149
        ],
        [
          0.00010991573813,
          0.07690561922754,
          80.43842738
        ],
        [
          0.00020482408158,
          0.06620591517629,
          81.81012347
        ],
        [
          0.00010982173316,
          0.07692019453289,
          80.43674449
        ],
        [
          0.0001869404671,
          0.06777760867313,
          81.6000359
        ],
        [
          0.00010991573813,
          0.07690561922754,
          80.43842738
        ],
        [
          0.00023978373023,
          0.06335133823752,
          82.32891147
        ],
        [
          0.0001097344068,
          0.07693384970578,
          80.43508868
        ],
        [
          0.00018028351993,
          0.06845770308305,
          81.46226951
        ],
        [
          0.00010982835393,
          0.07691927274946,
          80.43677082
        ],
        [
          0.0002321778918,
          0.06397909627746,
          82.1755394
        ],
        [
          0.0001097344068,
          0.07693384970578,
          80.43508868
        ],
        [
          0.00021249615647,
          0.06552409601736,
          81.94549058
        ],
        [
          0.00010982835393,
          0.07691927274946,
          80.43677082
        ],
        [
          0.00029675812607,
          0.05946518750712,
          83.08878037
        ],
        [
          0.00010982173316,
          0.07692019453289,
          80.43674449
        ],
        [
          0.00018707168097,
          0.06780271031225,
          81.56495836
        ],
        [
          0.00010991573813,
          0.07690561922754,
          80.43842738
        ],
        [
          0.00024020118228,
          0.06335856041384,
          82.29401165
        ],
        [
          0.00010982173316,
          0.07692019453289,
          80.43674449
        ],
        [
          0.00022003668181,
          0.06489398752862,
          82.05818605
        ],
        [
          0.00010991573813,
          0.07690561922754,
          80.43842738
        ],
        [
          0.00030603868097,
          0.05888271946824,
          83.22558623
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00013233553734,
          0.07378969725375,
          80.76608335
        ],
        [
          0.00010936701903,
          0.07699085431038,
          80.42860363
        ],
        [
          0.00013243471358,
          0.07377680075338,
          80.76771052
        ],
        [
          0.00010928251354,
          0.07700395176345,
          80.4271458
        ],
        [
          0.00015552385773,
          0.07101735336637,
          81.11428598
        ],
        [
          0.00010936701903,
          0.07699085431038,
          80.42860363
        ],
        [
          0.00015563562172,
          0.07100479270648,
          81.11606636
        ],
        [
          0.00010935729061,
          0.07699228637462,
          80.42850177
        ],
        [
          0.000137187233,
          0.07317476681339,
          80.83999037
        ],
        [
          0.00010944184184,
          0.07697919005379,
          80.42996017
        ],
        [
          0.00013728916339,
          0.07316193834359,
          80.84165075
        ],
        [
          0.00010935729061,
          0.07699228637462,
          80.42850177
        ],
        [
          0.00016100803456,
          0.07041644395032,
          81.19563975
        ],
        [
          0.00010944184184,
          0.07697919005379,
          80.42996017
        ],
        [
          0.00016112255809,
          0.07040396684446,
          81.19745449
        ],
        [
          0.00010928251354,
          0.07700395176345,
          80.4271458
        ],
        [
          0.00013233553734,
          0.07378969725375,
          80.76608335
        ],
        [
          0.00010936701903,
          0.07699085431038,
          80.42860363
        ],
        [
          0.00013243471358,
          0.07377680075338,
          80.76771052
        ],
        [
          0.00010928251354,
          0.07700395176345,
          80.4271458
        ],
        [
          0.00015552385773,
          0.07101735336637,
          81.11428598
        ],
        [
          0.00010936701903,
          0.07699085431038,
          80.42860363
        ],
        [
          0.00017311444123,
          0.0691771100628,
          81.35007826
        ],
        [
          0.00010935729061,
          0.07699228637462,
          80.42850177
        ],
        [
          0.000137187233,
          0.07317476681339,
          80.83999037
        ],
        [
          0.00010944184184,
          0.07697919005379,
          80.42996017
        ],
        [
          0.00013728916339,
          0.07316193834359,
          80.84165075
        ],
        [
          0.00010935729061,
          0.07699228637462,
          80.42850177
        ],
        [
          0.00016100803456,
          0.07041644395032,
          81.19563975
        ],
        [
          0.00010944184184,
          0.07697919005379,
          80.42996017
        ],
        [
          0.00017905806649,
          0.06858542305922,
          81.43671636
        ],
        [
          0.00010965945105,
          0.07694601984967,
          80.43328017
        ],
        [
          0.0001484653394,
          0.07183992775442,
          80.98989641
        ],
        [
          0.00010974420172,
          0.07693292597322,
          80.43474092
        ],
        [
          0.00019089690702,
          0.06750196278894,
          81.56410493
        ],
        [
          0.00010965945105,
          0.07694601984967,
          80.43328017
        ],
        [
          0.00017380476708,
          0.06910507008891,
          81.362478
        ],
        [
          0.00010974420172,
          0.07693292597322,
          80.43474092
        ],
        [
          0.0002211532828,
          0.06488021413576,
          81.9947139
        ],
        [
          0.00010973443962,
          0.07693435841838,
          80.43463871
        ],
        [
          0.0001537863717,
          0.07123226091414,
          81.06907622
        ],
        [
          0.00010981923607,
          0.07692126568273,
          80.43610004
        ],
        [
          0.00019729619021,
          0.06691805286791,
          81.65583597
        ],
        [
          0.00010973443962,
          0.07693435841838,
          80.43463871
        ],
        [
          0.00017976303417,
          0.06851400614471,
          81.44931923
        ],
        [
          0.00010981923607,
          0.07692126568273,
          80.43610004
        ],
        [
          0.00022818740757,
          0.06431586939154,
          82.09462245
        ],
        [
          0.00010965945105,
          0.07694601984967,
          80.43328017
        ],
        [
          0.00017502254077,
          0.06901184775105,
          81.3520887
        ],
        [
          0.00010974420172,
          0.07693292597322,
          80.43474092
        ],
        [
          0.00022280817828,
          0.06477623926206,
          81.98716335
        ],
        [
          0.00010965945105,
          0.07694601984967,
          80.43328017
        ],
        [
          0.00020353631936,
          0.06634794881337,
          81.76178533
        ],
        [
          0.00010974420172,
          0.07693292597322,
          80.43474092
        ],
        [
          0.00028108421921,
          0.06055753233953,
          82.77840575
        ],
        [
          0.00010973443962,
          0.07693435841838,
          80.43463871
        ],
        [
          0.00018103924432,
          0.0684189075582,
          81.43929953
        ],
        [
          0.00010981923607,
          0.07692126568273,
          80.43610004
        ],
        [
          0.00022990548528,
          0.06421071381616,
          82.08749109
        ],
        [
          0.00010973443962,
          0.07693435841838,
          80.43463871
        ],
        [
          0.000210189795,
          0.06577392493684,
          81.85697716
        ],
        [
          0.00010981923607,
          0.07692126568273,
          80.43610004
        ],
        [
          0.00028926930281,
          0.06002336654573,
          82.89349908
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00013028299617,
          0.0740684473298,
          80.72340714
        ],
        [
          0.0001093343256,
          0.07699610131806,
          80.42788108
        ],
        [
          0.00013036763213,
          0.07405734941592,
          80.72473881
        ],
        [
          0.00010926155181,
          0.07700731814386,
          80.42668243
        ],
        [
          0.00015053743757,
          0.0716078300356,
          81.01437073
        ],
        [
          0.0001093343256,
          0.07699610131806,
          80.42788108
        ],
        [
          0.00015063201984,
          0.0715969512797,
          81.01581859
        ],
        [
          0.00010931974015,
          0.07699831351497,
          80.42767183
        ],
        [
          0.00013453802529,
          0.07352367963245,
          80.78539445
        ],
        [
          0.00010939254549,
          0.07698709731514,
          80.42887086
        ],
        [
          0.0001346248315,
          0.07351262536953,
          80.78675134
        ],
        [
          0.00010931974015,
          0.07699831351497,
          80.42767183
        ],
        [
          0.00015530647465,
          0.07107216157361,
          81.08217256
        ],
        [
          0.00010939254549,
          0.07698709731514,
          80.42887086
        ],
        [
          0.00015540324851,
          0.07106133913362,
          81.08364646
        ],
        [
          0.00010926155181,
          0.07700731814386,
          80.42668243
        ],
        [
          0.00013028299617,
          0.0740684473298,
          80.72340714
        ],
        [
          0.0001093343256,
          0.07699610131806,
          80.42788108
        ],
        [
          0.00013036763213,
          0.07405734941592,
          80.72473881
        ],
        [
          0.00010926155181,
          0.07700731814386,
          80.42668243
        ],
        [
          0.00015053743757,
          0.0716078300356,
          81.01437073
        ],
        [
          0.0001093343256,
          0.07699610131806,
          80.42788108
        ],
        [
          0.00016670908938,
          0.0698681325633,
          81.22498652
        ],
        [
          0.00010931974015,
          0.07699831351497,
          80.42767183
        ],
        [
          0.00013453802529,
          0.07352367963245,
          80.78539445
        ],
        [
          0.00010939254549,
          0.07698709731514,
          80.42887086
        ],
        [
          0.0001346248315,
          0.07351262536953,
          80.78675134
        ],
        [
          0.00010931974015,
          0.07699831351497,
          80.42767183
        ],
        [
          0.00015530647465,
          0.07107216157361,
          81.08217256
        ],
        [
          0.00010939254549,
          0.07698709731514,
          80.42887086
        ],
        [
          0.00017187279164,
          0.06933902580671,
          81.29715175
        ],
        [
          0.00010958796225,
          0.07695746698333,
          80.43170154
        ],
        [
          0.00014510102639,
          0.07225312742382,
          80.9221832
        ],
        [
          0.00010966092397,
          0.07694625207797,
          80.43290236
        ],
        [
          0.00018375160945,
          0.06820887042261,
          81.42798833
        ],
        [
          0.00010958796225,
          0.07695746698333,
          80.43170154
        ],
        [
          0.0001671803761,
          0.06981762515395,
          81.23312888
        ],
        [
          0.00010966092397,
          0.07694625207797,
          80.43290236
        ],
        [
          0.0002100203544,
          0.06585576129927,
          81.78624098
        ],
        [
          0.00010964629755,
          0.07694846436609,
          80.43269267
        ],
        [
          0.00014975339122,
          0.07171306812534,
          80.98849722
        ],
        [
          0.00010971929083,
          0.0769372500934,
          80.43389386
        ],
        [
          0.00018932068314,
          0.06768583952304,
          81.50455468
        ],
        [
          0.00010964629755,
          0.07694846436609,
          80.43269267
        ],
        [
          0.00017235344052,
          0.06928888121456,
          81.30542272
        ],
        [
          0.00010971929083,
          0.0769372500934,
          80.43389386
        ],
        [
          0.00021611330466,
          0.06534710884378,
          81.86915532
        ],
        [
          0.00010958796225,
          0.07695746698333,
          80.43170154
        ],
        [
          0.00016940200788,
          0.06961063944402,
          81.24318255
        ],
        [
          0.00010966092397,
          0.07694625207797,
          80.43290236
        ],
        [
          0.000212809244,
          0.06564407295788,
          81.80113381
        ],
        [
          0.00010958796225,
          0.07695746698333,
          80.43170154
        ],
        [
          0.00019418905863,
          0.06722642788081,
          81.58451139
        ],
        [
          0.00010966092397,
          0.07694625207797,
          80.43290236
        ],
        [
          0.00026451853304,
          0.0617456155607,
          82.47574272
        ],
        [
          0.00010964629755,
          0.07694846436609,
          80.43269267
        ],
        [
          0.00017464641431,
          0.06908104552607,
          81.31608258
        ],
        [
          0.00010971929083,
          0.0769372500934,
          80.43389386
        ],
        [
          0.0002189775255,
          0.06513519208987,
          81.88471602
        ],
        [
          0.00010964629755,
          0.07694846436609,
          80.43269267
        ],
        [
          0.00019995728573,
          0.06671041907155,
          81.66362632
        ],
        [
          0.00010971929083,
          0.0769372500934,
          80.43389386
        ],
        [
          0.00027160555762,
          0.06126146306413,
          82.57096906
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00012818785184,
          0.07435332966305,
          80.68311441
        ],
        [
          0.00010930026967,
          0.07700149868604,
          80.42718954
        ],
        [
          0.00012825456543,
          0.07434451703471,
          80.68410688
        ],
        [
          0.00010924236562,
          0.07701036053931,
          80.42629277
        ],
        [
          0.00014559100478,
          0.07220285041483,
          80.92236451
        ],
        [
          0.00010930026967,
          0.07700149868604,
          80.42718954
        ],
        [
          0.00014566490661,
          0.07219415663928,
          80.92343742
        ],
        [
          0.00010928747107,
          0.07700342828518,
          80.42701655
        ],
        [
          0.00013185912041,
          0.07387811837255,
          80.73427876
        ],
        [
          0.00010934539526,
          0.07699456671883,
          80.42791355
        ],
        [
          0.0001319273982,
          0.07386932875655,
          80.73528868
        ],
        [
          0.00010928747107,
          0.07700342828518,
          80.42701655
        ],
        [
          0.0001496674481,
          0.07173288120474,
          80.97794588
        ],
        [
          0.00010934539526,
          0.07699456671883,
          80.42791355
        ],
        [
          0.0001497429412,
          0.07172421952603,
          80.97903682
        ],
        [
          0.00010924236562,
          0.07701036053931,
          80.42629277
        ],
        [
          0.00012818785184,
          0.07435332966305,
          80.68311441
        ],
        [
          0.00010930026967,
          0.07700149868604,
          80.42718954
        ],
        [
          0.00012825456543,
          0.07434451703471,
          80.68410688
        ],
        [
          0.00010924236562,
          0.07701036053931,
          80.42629277
        ],
        [
          0.00014559100478,
          0.07220285041483,
          80.92236451
        ],
        [
          0.00010930026967,
          0.07700149868604,
          80.42718954
        ],
        [
          0.00016023800541,
          0.07058046072555,
          81.10751026
        ],
        [
          0.00010928747107,
          0.07700342828518,
          80.42701655
        ],
        [
          0.00013185912041,
          0.07387811837255,
          80.73427876
        ],
        [
          0.00010934539526,
          0.07699456671883,
          80.42791355
        ],
        [
          0.0001319273982,
          0.07386932875655,
          80.73528868
        ],
        [
          0.00010928747107,
          0.07700342828518,
          80.42701655
        ],
        [
          0.0001496674481,
          0.07173288120474,
          80.97794588
        ],
        [
          0.00010934539526,
          0.07699456671883,
          80.42791355
        ],
        [
          0.00016464383403,
          0.07011469530193,
          81.16661139
        ],
        [
          0.00010952481368,
          0.07696745504047,
          80.43042019
        ],
        [
          0.00014160769586,
          0.07268551415429,
          80.85697348
        ],
        [
          0.00010958285133,
          0.07695859389274,
          80.43131844
        ],
        [
          0.00017632906653,
          0.06895844464944,
          81.29644955
        ],
        [
          0.00010952481368,
          0.07696745504047,
          80.43042019
        ],
        [
          0.00016051710047,
          0.07054963529493,
          81.11219085
        ],
        [
          0.00010958285133,
          0.07695859389274,
          80.43131844
        ],
        [
          0.00019871528004,
          0.06687776395468,
          81.58935155
        ],
        [
          0.00010957002063,
          0.07696052370471,
          80.43114511
        ],
        [
          0.00014560626617,
          0.0722128783426,
          80.91159739
        ],
        [
          0.0001096280784,
          0.07695166285017,
          80.43204361
        ],
        [
          0.0001810866928,
          0.06849697867858,
          81.35925182
        ],
        [
          0.00010957002063,
          0.07696052370471,
          80.43114511
        ],
        [
          0.00016492809972,
          0.0700840484829,
          81.17135648
        ],
        [
          0.0001096280784,
          0.07695166285017,
          80.43204361
        ],
        [
          0.00020389234773,
          0.06642617725793,
          81.65696364
        ],
        [
          0.00010952481368,
          0.07696745504047,
          80.43042019
        ],
        [
          0.00016349492301,
          0.07025021341409,
          81.136775
        ],
        [
          0.00010958285133,
          0.07695859389274,
          80.43131844
        ],
        [
          0.00020234201878,
          0.06657709689965,
          81.61993967
        ],
        [
          0.00010952481368,
          0.07696745504047,
          80.43042019
        ],
        [
          0.00018464983068,
          0.06814815908153,
          81.4162373
        ],
        [
          0.00010958285133,
          0.07695859389274,
          80.43131844
        ],
        [
          0.00024742159194,
          0.06301852742828,
          82.18576179
        ],
        [
          0.00010957002063,
          0.07696052370471,
          80.43114511
        ],
        [
          0.00016798335175,
          0.06978431832645,
          81.19666057
        ],
        [
          0.0001096280784,
          0.07695166285017,
          80.43204361
        ],
        [
          0.00020760007951,
          0.0661258131402,
          81.68832756
        ],
        [
          0.00010957002063,
          0.07696052370471,
          80.43114511
        ],
        [
          0.00018955620874,
          0.06769133617798,
          81.48083809
        ],
        [
          0.0001096280784,
          0.07695166285017,
          80.43204361
        ],
        [
          0.00025343627377,
          0.0625856399472,
          82.26313434
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00012613312603,
          0.07463355353737,
          80.64643297
        ],
        [
          0.00010927565887,
          0.07700535562264,
          80.42672873
        ],
        [
          0.00012618583013,
          0.07462653144979,
          80.64717938
        ],
        [
          0.00010922944994,
          0.07701238553319,
          80.42605091
        ],
        [
          0.00014099023643,
          0.07276597368166,
          80.84261522
        ],
        [
          0.00010927565887,
          0.07700535562264,
          80.42672873
        ],
        [
          0.00014104810195,
          0.072759009543,
          80.84341734
        ],
        [
          0.00010926392092,
          0.07700711938191,
          80.42657558
        ],
        [
          0.00012926395035,
          0.07422365921422,
          80.68826446
        ],
        [
          0.00010931014253,
          0.07700008958752,
          80.42725355
        ],
        [
          0.00012931776999,
          0.07421664771603,
          80.6890229
        ],
        [
          0.00010926392092,
          0.07700711938191,
          80.42657558
        ],
        [
          0.00014443442541,
          0.07235863015989,
          80.88775432
        ],
        [
          0.00010931014253,
          0.07700008958752,
          80.42725355
        ],
        [
          0.00014449343223,
          0.0723516828113,
          80.88856886
        ],
        [
          0.00010922944994,
          0.07701238553319,
          80.42605091
        ],
        [
          0.00012613312603,
          0.07463355353737,
          80.64643297
        ],
        [
          0.00010927565887,
          0.07700535562264,
          80.42672873
        ],
        [
          0.00012618583013,
          0.07462653144979,
          80.64717938
        ],
        [
          0.00010922944994,
          0.07701238553319,
          80.42605091
        ],
        [
          0.00014099023643,
          0.07276597368166,
          80.84261522
        ],
        [
          0.00010927565887,
          0.07700535562264,
          80.42672873
        ],
        [
          0.00015410365259,
          0.07127123482304,
          81.0035675
        ],
        [
          0.00010926392092,
          0.07700711938191,
          80.42657558
        ],
        [
          0.00012926395035,
          0.07422365921422,
          80.68826446
        ],
        [
          0.00010931014253,
          0.07700008958752,
          80.42725355
        ],
        [
          0.00012931776999,
          0.07421664771603,
          80.6890229
        ],
        [
          0.00010926392092,
          0.07700711938191,
          80.42657558
        ],
        [
          0.00014443442541,
          0.07235863015989,
          80.88775432
        ],
        [
          0.00010931014253,
          0.07700008958752,
          80.42725355
        ],
        [
          0.00015781645501,
          0.0708661966534,
          81.05149103
        ],
        [
          0.00010946886837,
          0.0769762072295,
          80.42937331
        ],
        [
          0.00013817786567,
          0.07311436440457,
          80.79736917
        ],
        [
          0.00010951517067,
          0.07696917735712,
          80.43005214
        ],
        [
          0.00016898475111,
          0.06971853589071,
          81.17483752
        ],
        [
          0.00010946886837,
          0.0769762072295,
          80.42937331
        ],
        [
          0.00015425869184,
          0.0712535220352,
          81.00615795
        ],
        [
          0.00010951517067,
          0.07696917735712,
          80.43005214
        ],
        [
          0.00018789780799,
          0.06789109057629,
          81.4132427
        ],
        [
          0.00010950340714,
          0.07697094137516,
          80.42989873
        ],
        [
          0.00014157294147,
          0.07270546159897,
          80.8419197
        ],
        [
          0.00010954972213,
          0.07696391161933,
          80.4305777
        ],
        [
          0.00017299409696,
          0.06931612017125,
          81.22578805
        ],
        [
          0.00010950340714,
          0.07697094137516,
          80.42989873
        ],
        [
          0.0001579741038,
          0.07084856557041,
          81.05411294
        ],
        [
          0.00010954972213,
          0.07696391161933,
          80.4305777
        ],
        [
          0.00019223634102,
          0.06749503508957,
          81.46779144
        ],
        [
          0.00010946886837,
          0.0769762072295,
          80.42937331
        ],
        [
          0.00015766055859,
          0.07089447968951,
          81.03866245
        ],
        [
          0.00010951517067,
          0.07696917735712,
          80.43005214
        ],
        [
          0.00019196903594,
          0.06753173357114,
          81.45205644
        ],
        [
          0.00010946886837,
          0.0769762072295,
          80.42937331
        ],
        [
          0.00017556993606,
          0.06905363234165,
          81.26653957
        ],
        [
          0.00010951517067,
          0.07696917735712,
          80.43005214
        ],
        [
          0.00023083920642,
          0.06430884363706,
          81.92315515
        ],
        [
          0.00010950340714,
          0.07697094137516,
          80.42989873
        ],
        [
          0.00016145192534,
          0.07048937728168,
          81.08733744
        ],
        [
          0.00010954972213,
          0.07696391161933,
          80.4305777
        ],
        [
          0.00019638696756,
          0.06713611491229,
          81.50737875
        ],
        [
          0.00010950340714,
          0.07697094137516,
          80.42989873
        ],
        [
          0.00017968814583,
          0.06865415926339,
          81.31874538
        ],
        [
          0.00010954972213,
          0.07696391161933,
          80.4305777
        ],
        [
          0.00023586784888,
          0.06392617712543,
          81.98532784
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00012402569682,
          0.07492228762332,
          80.61139832
        ],
        [
          0.00010924873605,
          0.07700953267168,
          80.42626239
        ],
        [
          0.00012406350209,
          0.07491721101167,
          80.61190005
        ],
        [
          0.00010921523666,
          0.07701459144938,
          80.42580469
        ],
        [
          0.00013636557285,
          0.07334279684437,
          80.76766081
        ],
        [
          0.00010924873605,
          0.07700953267168,
          80.42626239
        ],
        [
          0.00013640668253,
          0.07333773609524,
          80.76819684
        ],
        [
          0.00010924215452,
          0.07701049668061,
          80.42619854
        ],
        [
          0.00012664563059,
          0.07457502679501,
          80.64498886
        ],
        [
          0.00010927566137,
          0.07700543792763,
          80.42665632
        ],
        [
          0.00012668415075,
          0.07456995253227,
          80.64549802
        ],
        [
          0.00010924215452,
          0.07701049668061,
          80.42619854
        ],
        [
          0.00013921766741,
          0.07299621543732,
          80.80362761
        ],
        [
          0.00010927566137,
          0.07700543792763,
          80.42665632
        ],
        [
          0.00013925951173,
          0.07299116069316,
          80.80417131
        ],
        [
          0.00010921523666,
          0.07701459144938,
          80.42580469
        ],
        [
          0.00012402569682,
          0.07492228762332,
          80.61139832
        ],
        [
          0.00010924873605,
          0.07700953267168,
          80.42626239
        ],
        [
          0.00012406350209,
          0.07491721101167,
          80.61190005
        ],
        [
          0.00010921523666,
          0.07701459144938,
          80.42580469
        ],
        [
          0.00013636557285,
          0.07334279684437,
          80.76766081
        ],
        [
          0.00010924873605,
          0.07700953267168,
          80.42626239
        ],
        [
          0.00014789484928,
          0.07198814599347,
          80.90501204
        ],
        [
          0.00010924215452,
          0.07701049668061,
          80.42619854
        ],
        [
          0.00012664563059,
          0.07457502679501,
          80.64498886
        ],
        [
          0.00010927566137,
          0.07700543792763,
          80.42665632
        ],
        [
          0.00012668415075,
          0.07456995253227,
          80.64549802
        ],
        [
          0.00010924215452,
          0.07701049668061,
          80.42619854
        ],
        [
          0.00013921766741,
          0.07299621543732,
          80.80362761
        ],
        [
          0.00010927566137,
          0.07700543792763,
          80.42665632
        ],
        [
          0.00015095872638,
          0.07164239414336,
          80.94311017
        ],
        [
          0.00010941448428,
          0.07698463210231,
          80.42843178
        ],
        [
          0.00013464734001,
          0.07356123495732,
          80.74006276
        ],
        [
          0.00010944804233,
          0.07697957300772,
          80.42889009
        ],
        [
          0.00016152248138,
          0.07051278466,
          81.05893697
        ],
        [
          0.00010941448428,
          0.07698463210231,
          80.42843178
        ],
        [
          0.00014794148902,
          0.0719825192021,
          80.90588621
        ],
        [
          0.00010944804233,
          0.07697957300772,
          80.42889009
        ],
        [
          0.00017703362884,
          0.06894983380127,
          81.24717515
        ],
        [
          0.00010944144752,
          0.07698053733256,
          80.42882612
        ],
        [
          0.00013747366451,
          0.07321382371747,
          80.7757228
        ],
        [
          0.00010947501303,
          0.07697547826264,
          80.42928451
        ],
        [
          0.00016483007127,
          0.07016824179086,
          81.09945774
        ],
        [
          0.00010944144752,
          0.07698053733256,
          80.42882612
        ],
        [
          0.00015100602978,
          0.07163679094953,
          80.94399253
        ],
        [
          0.00010947501303,
          0.07697547826264,
          80.42928451
        ],
        [
          0.00018058848358,
          0.06860885632286,
          81.2902824
        ],
        [
          0.00010941448428,
          0.07698463210231,
          80.42843178
        ],
        [
          0.00015168453561,
          0.07156955287396,
          80.94450661
        ],
        [
          0.00010944804233,
          0.07697957300772,
          80.42889009
        ],
        [
          0.00018144446613,
          0.06853641394665,
          81.2921152
        ],
        [
          0.00010941448428,
          0.07698463210231,
          80.42843178
        ],
        [
          0.00016640821638,
          0.0699997400052,
          81.124784
        ],
        [
          0.00010944804233,
          0.07697957300772,
          80.42889009
        ],
        [
          0.00021412163603,
          0.06567688718228,
          81.67466365
        ],
        [
          0.00010944144752,
          0.07698053733256,
          80.42882612
        ],
        [
          0.00015482097084,
          0.07122369092699,
          80.98330039
        ],
        [
          0.00010947501303,
          0.07697547826264,
          80.42928451
        ],
        [
          0.00018507461862,
          0.06819584988289,
          81.33595566
        ],
        [
          0.00010944144752,
          0.07698053733256,
          80.42882612
        ],
        [
          0.0001697893145,
          0.06965684168441,
          81.16611694
        ],
        [
          0.00010947501303,
          0.07697547826264,
          80.42928451
        ],
        [
          0.00021822676013,
          0.06534453248111,
          81.72356161
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.0001219389146,
          0.07520993909747,
          80.57900236
        ],
        [
          0.00010922931706,
          0.07701251837364,
          80.42595029
        ],
        [
          0.00012196643097,
          0.0752062105646,
          80.57934643
        ],
        [
          0.000109204647,
          0.07701622002749,
          80.42563448
        ],
        [
          0.00013196430335,
          0.07390311934318,
          80.70077166
        ],
        [
          0.00010922931706,
          0.07701251837364,
          80.42595029
        ],
        [
          0.00013199391829,
          0.07389938748767,
          80.70113677
        ],
        [
          0.00010922308979,
          0.07701342807556,
          80.42589213
        ],
        [
          0.00012405573559,
          0.07492584933168,
          80.60497488
        ],
        [
          0.00010924776379,
          0.07700972640896,
          80.42620798
        ],
        [
          0.00012408370142,
          0.07492211945062,
          80.60532346
        ],
        [
          0.00010922308979,
          0.07701342807556,
          80.42589213
        ],
        [
          0.00013424404488,
          0.07361858465978,
          80.72836262
        ],
        [
          0.00010924776379,
          0.07700972640896,
          80.42620798
        ],
        [
          0.00013427412283,
          0.07361485347962,
          80.72873238
        ],
        [
          0.000109204647,
          0.07701622002749,
          80.42563448
        ],
        [
          0.0001219389146,
          0.07520993909747,
          80.57900236
        ],
        [
          0.00010922931706,
          0.07701251837364,
          80.42595029
        ],
        [
          0.00012196643097,
          0.0752062105646,
          80.57934643
        ],
        [
          0.000109204647,
          0.07701622002749,
          80.42563448
        ],
        [
          0.00013196430335,
          0.07390311934318,
          80.70077166
        ],
        [
          0.00010922931706,
          0.07701251837364,
          80.42595029
        ],
        [
          0.00014191390311,
          0.07269801688929,
          80.81579783
        ],
        [
          0.00010922308979,
          0.07701342807556,
          80.42589213
        ],
        [
          0.00012405573559,
          0.07492584933168,
          80.60497488
        ],
        [
          0.00010924776379,
          0.07700972640896,
          80.42620798
        ],
        [
          0.00012408370142,
          0.07492211945062,
          80.60532346
        ],
        [
          0.00010922308979,
          0.07701342807556,
          80.42589213
        ],
        [
          0.00013424404488,
          0.07361858465978,
          80.72836262
        ],
        [
          0.00010924776379,
          0.07700972640896,
          80.42620798
        ],
        [
          0.00014435231679,
          0.07241327253602,
          80.84494205
        ],
        [
          0.00010936686514,
          0.07699194424566,
          80.42766678
        ],
        [
          0.00013112582728,
          0.07401340325559,
          80.68651908
        ],
        [
          0.00010939157186,
          0.07698824218579,
          80.42798296
        ],
        [
          0.00015413664593,
          0.07132401479029,
          80.95097932
        ],
        [
          0.00010936686514,
          0.07699194424566,
          80.42766678
        ],
        [
          0.00014186669503,
          0.07270353401966,
          80.81526936
        ],
        [
          0.00010939157186,
          0.07698824218579,
          80.42798296
        ],
        [
          0.00016654693655,
          0.0700173562085,
          81.09609456
        ],
        [
          0.00010938533414,
          0.07698915216328,
          80.4279247
        ],
        [
          0.00013339587356,
          0.07372844205697,
          80.71398881
        ],
        [
          0.00010941004477,
          0.07698545009395,
          80.42824092
        ],
        [
          0.00015676530245,
          0.0710393345519,
          80.98196475
        ],
        [
          0.00010938533414,
          0.07698915216328,
          80.4279247
        ],
        [
          0.00014430440474,
          0.07241878569104,
          80.84440651
        ],
        [
          0.00010941004477,
          0.07698545009395,
          80.42824092
        ],
        [
          0.00016935126419,
          0.06973420897424,
          81.12884473
        ],
        [
          0.00010936686514,
          0.07699194424566,
          80.42766678
        ],
        [
          0.00014562653797,
          0.07227198403756,
          80.85479307
        ],
        [
          0.00010939157186,
          0.07698824218579,
          80.42798296
        ],
        [
          0.00017091813047,
          0.06958386101807,
          81.14134046
        ],
        [
          0.00010936686514,
          0.07699194424566,
          80.42766678
        ],
        [
          0.00015743474323,
          0.07096310912055,
          80.99401377
        ],
        [
          0.00010939157186,
          0.07698824218579,
          80.42798296
        ],
        [
          0.00019773924558,
          0.06709632904738,
          81.44507001
        ],
        [
          0.00010938533414,
          0.07698915216328,
          80.4279247
        ],
        [
          0.00014812571717,
          0.07198696142573,
          80.88451158
        ],
        [
          0.00010941004477,
          0.07698545009395,
          80.42824092
        ],
        [
          0.00017378710781,
          0.06930090225137,
          81.17470932
        ],
        [
          0.00010938533414,
          0.07698915216328,
          80.4279247
        ],
        [
          0.00016010707443,
          0.07067918043964,
          81.0254636
        ],
        [
          0.00010941004477,
          0.07698545009395,
          80.42824092
        ],
        [
          0.00020095876261,
          0.066817711119,
          81.48199541
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.0001199190536,
          0.0754903227847,
          80.54964922
        ],
        [
          0.00010921884971,
          0.07701411457389,
          80.42579378
        ],
        [
          0.000119939368,
          0.0754875429248,
          80.54989001
        ],
        [
          0.00010920040425,
          0.07701686713656,
          80.42557104
        ],
        [
          0.0001279076322,
          0.07443034810992,
          80.64283024
        ],
        [
          0.00010921884971,
          0.07701411457389,
          80.42579378
        ],
        [
          0.00012792926953,
          0.07442755796958,
          80.6430839
        ],
        [
          0.00010921232889,
          0.07701506912931,
          80.42573122
        ],
        [
          0.00012158612635,
          0.07526381165087,
          80.56922309
        ],
        [
          0.00010923077633,
          0.07701231655085,
          80.42595398
        ],
        [
          0.00012160671988,
          0.07526102924351,
          80.5694666
        ],
        [
          0.00010921232889,
          0.07701506912931,
          80.42573122
        ],
        [
          0.00012968404914,
          0.07420290028514,
          80.66346044
        ],
        [
          0.00010923077633,
          0.07701231655085,
          80.42595398
        ],
        [
          0.00012970597428,
          0.07420010864331,
          80.6637169
        ],
        [
          0.00010920040425,
          0.07701686713656,
          80.42557104
        ],
        [
          0.0001199190536,
          0.0754903227847,
          80.54964922
        ],
        [
          0.00010921884971,
          0.07701411457389,
          80.42579378
        ],
        [
          0.000119939368,
          0.0754875429248,
          80.54989001
        ],
        [
          0.00010920040425,
          0.07701686713656,
          80.42557104
        ],
        [
          0.0001279076322,
          0.07443034810992,
          80.64283024
        ],
        [
          0.00010921884971,
          0.07701411457389,
          80.42579378
        ],
        [
          0.00013624074981,
          0.07339089912366,
          80.73607797
        ],
        [
          0.00010921232889,
          0.07701506912931,
          80.42573122
        ],
        [
          0.00012158612635,
          0.07526381165087,
          80.56922309
        ],
        [
          0.00010923077633,
          0.07701231655085,
          80.42595398
        ],
        [
          0.00012160671988,
          0.07526102924351,
          80.5694666
        ],
        [
          0.00010921232889,
          0.07701506912931,
          80.42573122
        ],
        [
          0.00012968404914,
          0.07420290028514,
          80.66346044
        ],
        [
          0.00010923077633,
          0.07701231655085,
          80.42595398
        ],
        [
          0.00013812980935,
          0.07316265462503,
          80.75778123
        ],
        [
          0.00010932812268,
          0.07699784604167,
          80.42708765
        ],
        [
          0.00012767090529,
          0.07446407479872,
          80.63718989
        ],
        [
          0.00010934659064,
          0.07699509310701,
          80.42731061
        ],
        [
          0.00014685022132,
          0.07215220471841,
          80.85046119
        ],
        [
          0.00010932812268,
          0.07699784604167,
          80.42708765
        ],
        [
          0.00013617337508,
          0.07339914011943,
          80.73526005
        ],
        [
          0.00010934659064,
          0.07699509310701,
          80.42731061
        ],
        [
          0.00015655429588,
          0.07108273034318,
          80.95997784
        ],
        [
          0.00010934006114,
          0.07699604789838,
          80.42724798
        ],
        [
          0.00012944638716,
          0.07423637274832,
          80.65779679
        ],
        [
          0.00010935853107,
          0.07699329494764,
          80.42747096
        ],
        [
          0.00014887984222,
          0.07192325088922,
          80.87348983
        ],
        [
          0.00010934006114,
          0.07699604789838,
          80.42724798
        ],
        [
          0.00013806160697,
          0.07317089255073,
          80.75695501
        ],
        [
          0.00010935853107,
          0.07699329494764,
          80.42747096
        ],
        [
          0.00015870285899,
          0.07085407081852,
          80.98415926
        ],
        [
          0.00010932812268,
          0.07699784604167,
          80.42708765
        ],
        [
          0.00013973879001,
          0.07297442397945,
          80.77261834
        ],
        [
          0.00010934659064,
          0.07699509310701,
          80.42731061
        ],
        [
          0.00016064013129,
          0.07065431188143,
          81.00212775
        ],
        [
          0.00010932812268,
          0.07699784604167,
          80.42708765
        ],
        [
          0.00014900576506,
          0.07190585078506,
          80.87798247
        ],
        [
          0.00010934659064,
          0.07699509310701,
          80.42731061
        ],
        [
          0.00018203407084,
          0.06854491398564,
          81.23668704
        ],
        [
          0.00010934006114,
          0.07699604789838,
          80.42724798
        ],
        [
          0.00014167589062,
          0.0727457595227,
          80.79476801
        ],
        [
          0.00010935853107,
          0.07699329494764,
          80.42747096
        ],
        [
          0.00016284035576,
          0.07042558050543,
          81.02679256
        ],
        [
          0.00010934006114,
          0.07699604789838,
          80.42724798
        ],
        [
          0.00015105976928,
          0.07167719057408,
          80.90126263
        ],
        [
          0.00010935853107,
          0.07699329494764,
          80.42747096
        ],
        [
          0.00018448005552,
          0.06831779178549,
          81.26374193
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00011791054177,
          0.07577132099732,
          80.52226682
        ],
        [
          0.00010920246142,
          0.07701659514707,
          80.4255652
        ],
        [
          0.00011792474265,
          0.07576935880517,
          80.52242521
        ],
        [
          0.00010918939071,
          0.07701853439515,
          80.42541742
        ],
        [
          0.00012405300742,
          0.07494175010291,
          80.59099002
        ],
        [
          0.00010920246142,
          0.07701659514707,
          80.4255652
        ],
        [
          0.00012406797397,
          0.07493977679632,
          80.59115562
        ],
        [
          0.00010919615655,
          0.07701751714983,
          80.42550565
        ],
        [
          0.00011921269303,
          0.07559209184642,
          80.53696186
        ],
        [
          0.00010920922808,
          0.07701557789001,
          80.42565344
        ],
        [
          0.00011922705717,
          0.0755901271295,
          80.53712179
        ],
        [
          0.00010919615655,
          0.07701751714983,
          80.42550565
        ],
        [
          0.00012542544898,
          0.07476149921776,
          80.60634626
        ],
        [
          0.00010920922808,
          0.07701557789001,
          80.42565344
        ],
        [
          0.00012544058366,
          0.07475952387063,
          80.60651344
        ],
        [
          0.00010918939071,
          0.07701853439515,
          80.42541742
        ],
        [
          0.00011791054177,
          0.07577132099732,
          80.52226682
        ],
        [
          0.00010920246142,
          0.07701659514707,
          80.4255652
        ],
        [
          0.00011792474265,
          0.07576935880517,
          80.52242521
        ],
        [
          0.00010918939071,
          0.07701853439515,
          80.42541742
        ],
        [
          0.00012405300742,
          0.07494175010291,
          80.59099002
        ],
        [
          0.00010920246142,
          0.07701659514707,
          80.4255652
        ],
        [
          0.00013081651046,
          0.074073131758,
          80.66412281
        ],
        [
          0.00010919615655,
          0.07701751714983,
          80.42550565
        ],
        [
          0.00011921269303,
          0.07559209184642,
          80.53696186
        ],
        [
          0.00010920922808,
          0.07701557789001,
          80.42565344
        ],
        [
          0.00011922705717,
          0.0755901271295,
          80.53712179
        ],
        [
          0.00010919615655,
          0.07701751714983,
          80.42550565
        ],
        [
          0.00012542544898,
          0.07476149921776,
          80.60634626
        ],
        [
          0.00010920922808,
          0.07701557789001,
          80.42565344
        ],
        [
          0.00013226579172,
          0.07389187650796,
          80.6801931
        ],
        [
          0.00010929162186,
          0.07700336624984,
          80.42657869
        ],
        [
          0.00012427544948,
          0.07491454057962,
          80.59156834
        ],
        [
          0.00010930470588,
          0.07700142671052,
          80.42672659
        ],
        [
          0.0001398551,
          0.07297668436072,
          80.75917038
        ],
        [
          0.00010929162186,
          0.07700336624984,
          80.42657869
        ],
        [
          0.00013076544824,
          0.07407959562754,
          80.66351609
        ],
        [
          0.00010930470588,
          0.07700142671052,
          80.42672659
        ],
        [
          0.00014715975146,
          0.07213357234998,
          80.83867081
        ],
        [
          0.00010929839417,
          0.07700234891363,
          80.42666699
        ],
        [
          0.00012565170935,
          0.07473409402671,
          80.60695269
        ],
        [
          0.00010931147901,
          0.07700040936366,
          80.4268149
        ],
        [
          0.00014140534094,
          0.07279434817687,
          80.77617095
        ],
        [
          0.00010929839417,
          0.07700234891363,
          80.42666699
        ],
        [
          0.00013221420424,
          0.07389834125328,
          80.67958123
        ],
        [
          0.00010931147901,
          0.07700040936366,
          80.4268149
        ],
        [
          0.00014878681879,
          0.07195090640437,
          80.85639283
        ],
        [
          0.00010929162186,
          0.07700336624984,
          80.42657869
        ],
        [
          0.00013395159793,
          0.07368609721685,
          80.69632393
        ],
        [
          0.00010930470588,
          0.07700142671052,
          80.42672659
        ],
        [
          0.00015075616988,
          0.07173505101615,
          80.87518353
        ],
        [
          0.00010929162186,
          0.07700336624984,
          80.42657869
        ],
        [
          0.00014095226917,
          0.07284548473698,
          80.77301243
        ],
        [
          0.00010930470588,
          0.07700142671052,
          80.42672659
        ],
        [
          0.00016719805098,
          0.07000781498724,
          81.0496632
        ],
        [
          0.00010929839417,
          0.07700234891363,
          80.42666699
        ],
        [
          0.00013543688304,
          0.07350434631166,
          80.71272257
        ],
        [
          0.00010931147901,
          0.07700040936366,
          80.4268149
        ],
        [
          0.00015242197893,
          0.07155211950039,
          80.8932597
        ],
        [
          0.00010929839417,
          0.07700234891363,
          80.42666699
        ],
        [
          0.00014251285915,
          0.07266323316817,
          80.79011794
        ],
        [
          0.00010931147901,
          0.07700040936366,
          80.4268149
        ],
        [
          0.00016902844615,
          0.06982486618369,
          81.06928319
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00011611791856,
          0.07602411549722,
          80.49929719
        ],
        [
          0.00010920246142,
          0.07701659514707,
          80.4255652
        ],
        [
          0.00011613190824,
          0.07602215498643,
          80.49945348
        ],
        [
          0.00010918939071,
          0.07701853439515,
          80.42541742
        ],
        [
          0.00012067955018,
          0.0753982558619,
          80.54820639
        ],
        [
          0.00010920246142,
          0.07701659514707,
          80.4255652
        ],
        [
          0.00012069412733,
          0.07539628451789,
          80.54836815
        ],
        [
          0.00010918939071,
          0.07701853439515,
          80.42541742
        ],
        [
          0.00011707368611,
          0.07589107214862,
          80.50961478
        ],
        [
          0.00010920246142,
          0.07701659514707,
          80.4255652
        ],
        [
          0.00011708779933,
          0.0758891092683,
          80.50977222
        ],
        [
          0.00010918939071,
          0.07701853439515,
          80.42541742
        ],
        [
          0.00012167639946,
          0.0752643540272,
          80.55889988
        ],
        [
          0.00010920246142,
          0.07701659514707,
          80.4255652
        ],
        [
          0.00012169110334,
          0.07526238059181,
          80.55906281
        ],
        [
          0.00010918939071,
          0.07701853439515,
          80.42541742
        ],
        [
          0.00011611791856,
          0.07602411549722,
          80.49929719
        ],
        [
          0.00010920246142,
          0.07701659514707,
          80.4255652
        ],
        [
          0.00011613190824,
          0.07602215498643,
          80.49945348
        ],
        [
          0.00010918939071,
          0.07701853439515,
          80.42541742
        ],
        [
          0.00012067955018,
          0.0753982558619,
          80.54820639
        ],
        [
          0.00010920246142,
          0.07701659514707,
          80.4255652
        ],
        [
          0.00012604442843,
          0.07469078386554,
          80.60427225
        ],
        [
          0.00010918939071,
          0.07701853439515,
          80.42541742
        ],
        [
          0.00011707368611,
          0.07589107214862,
          80.50961478
        ],
        [
          0.00010920246142,
          0.07701659514707,
          80.4255652
        ],
        [
          0.00011708779933,
          0.0758891092683,
          80.50977222
        ],
        [
          0.00010918939071,
          0.07701853439515,
          80.42541742
        ],
        [
          0.00012167639946,
          0.0752643540272,
          80.55889988
        ],
        [
          0.00010920246142,
          0.07701659514707,
          80.4255652
        ],
        [
          0.00012708941137,
          0.07455594549124,
          80.61540187
        ],
        [
          0.00010926914101,
          0.07700674373932,
          80.42628557
        ],
        [
          0.00012122105572,
          0.07532666009335,
          80.55288375
        ],
        [
          0.00010928222232,
          0.07700480423253,
          80.42643345
        ],
        [
          0.00013353238583,
          0.07374949615535,
          80.68097494
        ],
        [
          0.00010926914101,
          0.07700674373932,
          80.42628557
        ],
        [
          0.00012600412579,
          0.07469605540658,
          80.60379725
        ],
        [
          0.00010928222232,
          0.07700480423253,
          80.42643345
        ],
        [
          0.00013883321188,
          0.07311029443597,
          80.736566
        ],
        [
          0.00010926914101,
          0.07700674373932,
          80.42628557
        ],
        [
          0.00012222337924,
          0.07519258239975,
          80.56362368
        ],
        [
          0.00010928222232,
          0.07700480423253,
          80.42643345
        ],
        [
          0.00013464369314,
          0.0736135292105,
          80.69270113
        ],
        [
          0.00010926914101,
          0.07700674373932,
          80.42628557
        ],
        [
          0.00012704878408,
          0.07456121931653,
          80.61492375
        ],
        [
          0.00010928222232,
          0.07700480423253,
          80.42643345
        ],
        [
          0.00013998939368,
          0.07297380544803,
          80.7487013
        ],
        [
          0.00010926914101,
          0.07700674373932,
          80.42628557
        ],
        [
          0.00012880876742,
          0.07433796497174,
          80.63217729
        ],
        [
          0.00010928222232,
          0.07700480423253,
          80.42643345
        ],
        [
          0.00014194679033,
          0.07274673205543,
          80.76768543
        ],
        [
          0.00010926914101,
          0.07700674373932,
          80.42628557
        ],
        [
          0.00013391315489,
          0.07370169198284,
          80.68599723
        ],
        [
          0.00010928222232,
          0.07700480423253,
          80.42643345
        ],
        [
          0.00015419568103,
          0.07137954407176,
          80.893525
        ],
        [
          0.00010926914101,
          0.07700674373932,
          80.42628557
        ],
        [
          0.00012987869939,
          0.07420264493184,
          80.64352999
        ],
        [
          0.00010928222232,
          0.07700480423253,
          80.42643345
        ],
        [
          0.00014312980465,
          0.07260989107498,
          80.78006053
        ],
        [
          0.00010926914101,
          0.07700674373932,
          80.42628557
        ],
        [
          0.00013502713836,
          0.0735657513952,
          80.69775076
        ],
        [
          0.00010928222232,
          0.07700480423253,
          80.42643345
        ],
        [
          0.00015547888942,
          0.0712419342464,
          80.90680955
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00011448137662,
          0.07625660498636,
          80.47955662
        ],
        [
          0.00010918921588,
          0.07701857417288,
          80.42540332
        ],
        [
          0.0001144888043,
          0.07625555667493,
          80.47963413
        ],
        [
          0.0001091821877,
          0.07701961069433,
          80.42532939
        ],
        [
          0.00011775860539,
          0.07580058671938,
          80.51323358
        ],
        [
          0.00010918921588,
          0.07701857417288,
          80.42540332
        ],
        [
          0.00011776627529,
          0.07579953214652,
          80.51331327
        ],
        [
          0.0001091821877,
          0.07701961069433,
          80.42532939
        ],
        [
          0.00011514948971,
          0.07616265811932,
          80.48644081
        ],
        [
          0.00010918921588,
          0.07701857417288,
          80.42540332
        ],
        [
          0.00011515696692,
          0.07616160849123,
          80.48651878
        ],
        [
          0.0001091821877,
          0.07701961069433,
          80.42532939
        ],
        [
          0.00011844885306,
          0.07570603365983,
          80.52031469
        ],
        [
          0.00010918921588,
          0.07701857417288,
          80.42540332
        ],
        [
          0.00011845657362,
          0.07570497784646,
          80.52039484
        ],
        [
          0.0001091821877,
          0.07701961069433,
          80.42532939
        ],
        [
          0.00011448137662,
          0.07625660498636,
          80.47955662
        ],
        [
          0.00010918921588,
          0.07701857417288,
          80.42540332
        ],
        [
          0.0001144888043,
          0.07625555667493,
          80.47963413
        ],
        [
          0.0001091821877,
          0.07701961069433,
          80.42532939
        ],
        [
          0.00011775860539,
          0.07580058671938,
          80.51323358
        ],
        [
          0.00010918921588,
          0.07701857417288,
          80.42540332
        ],
        [
          0.00012183035338,
          0.07525080626472,
          80.55425228
        ],
        [
          0.0001091821877,
          0.07701961069433,
          80.42532939
        ],
        [
          0.00011514948971,
          0.07616265811932,
          80.48644081
        ],
        [
          0.00010918921588,
          0.07701857417288,
          80.42540332
        ],
        [
          0.00011515696692,
          0.07616160849123,
          80.48651878
        ],
        [
          0.0001091821877,
          0.07701961069433,
          80.42532939
        ],
        [
          0.00011844885306,
          0.07570603365983,
          80.52031469
        ],
        [
          0.00010918921588,
          0.07701857417288,
          80.42540332
        ],
        [
          0.00012254809123,
          0.07515553395843,
          80.56157602
        ],
        [
          0.00010923937006,
          0.07701118962978,
          80.42592177
        ],
        [
          0.00011841131648,
          0.07571187826228,
          80.5192931
        ],
        [
          0.00010924640257,
          0.07701015297337,
          80.42599574
        ],
        [
          0.00012771179461,
          0.07448648241293,
          80.61267287
        ],
        [
          0.00010923937006,
          0.07701118962978,
          80.42592177
        ],
        [
          0.00012181965884,
          0.07525224729659,
          80.55412743
        ],
        [
          0.00010924640257,
          0.07701015297337,
          80.42599574
        ],
        [
          0.00013142405415,
          0.07401970552764,
          80.65018342
        ],
        [
          0.00010923937006,
          0.07701118962978,
          80.42592177
        ],
        [
          0.00011910623618,
          0.07561717276947,
          80.5264142
        ],
        [
          0.00010924640257,
          0.07701015297337,
          80.42599574
        ],
        [
          0.00012846889392,
          0.07439027104732,
          80.62034206
        ],
        [
          0.00010923937006,
          0.07701118962978,
          80.42592177
        ],
        [
          0.00012253733561,
          0.07515697542052,
          80.56145058
        ],
        [
          0.00010924640257,
          0.07701015297337,
          80.42599574
        ],
        [
          0.00013220523484,
          0.07392302193749,
          80.6580657
        ],
        [
          0.00010923937006,
          0.07701118962978,
          80.42592177
        ],
        [
          0.00012415788875,
          0.07494454737678,
          80.5772294
        ],
        [
          0.00010924640257,
          0.07701015297337,
          80.42599574
        ],
        [
          0.00013397334344,
          0.073706956759,
          80.67511992
        ],
        [
          0.00010923937006,
          0.07701118962978,
          80.42592177
        ],
        [
          0.00012775474005,
          0.07448032550512,
          80.61372665
        ],
        [
          0.00010924640257,
          0.07701015297337,
          80.42599574
        ],
        [
          0.00014273363952,
          0.07267048450752,
          80.76218424
        ],
        [
          0.00010923937006,
          0.07701118962978,
          80.42592177
        ],
        [
          0.00012489137243,
          0.07484887495803,
          80.58469099
        ],
        [
          0.00010924640257,
          0.07701015297337,
          80.42599574
        ],
        [
          0.00013477124998,
          0.07360993630611,
          80.6831483
        ],
        [
          0.00010923937006,
          0.07701118962978,
          80.42592177
        ],
        [
          0.00012851182086,
          0.07438414486732,
          80.62139722
        ],
        [
          0.00010924640257,
          0.07701015297337,
          80.42599574
        ],
        [
          0.00014358710419,
          0.07257257696661,
          80.77070194
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00011304950674,
          0.07646138325111,
          80.46327256
        ],
        [
          0.00010918246566,
          0.07701957709071,
          80.42532584
        ],
        [
          0.0001130568341,
          0.0764603369929,
          80.46334914
        ],
        [
          0.00010917543794,
          0.07702061360345,
          80.4252519
        ],
        [
          0.00011532059811,
          0.07614156483513,
          80.48564897
        ],
        [
          0.00010918246566,
          0.07701957709071,
          80.42532584
        ],
        [
          0.00011532809864,
          0.07614051342853,
          80.48572709
        ],
        [
          0.00010917543794,
          0.07702061360345,
          80.4252519
        ],
        [
          0.00011351891004,
          0.07639477975308,
          80.46791669
        ],
        [
          0.00010918246566,
          0.07701957709071,
          80.42532584
        ],
        [
          0.0001135262732,
          0.07639373241689,
          80.46799359
        ],
        [
          0.00010917543794,
          0.07702061360345,
          80.4252519
        ],
        [
          0.00011580151175,
          0.07607457644811,
          80.49039285
        ],
        [
          0.00010918246566,
          0.07701957709071,
          80.42532584
        ],
        [
          0.00011580904871,
          0.07607352400238,
          80.49047129
        ],
        [
          0.00010917543794,
          0.07702061360345,
          80.4252519
        ],
        [
          0.00011304950674,
          0.07646138325111,
          80.46327256
        ],
        [
          0.00010918246566,
          0.07701957709071,
          80.42532584
        ],
        [
          0.0001130568341,
          0.0764603369929,
          80.46334914
        ],
        [
          0.00010917543794,
          0.07702061360345,
          80.4252519
        ],
        [
          0.00011532059811,
          0.07614156483513,
          80.48564897
        ],
        [
          0.00010918246566,
          0.07701957709071,
          80.42532584
        ],
        [
          0.00011831595888,
          0.07572893106908,
          80.51474319
        ],
        [
          0.00010917543794,
          0.07702061360345,
          80.4252519
        ],
        [
          0.00011351891004,
          0.07639477975308,
          80.46791669
        ],
        [
          0.00010918246566,
          0.07701957709071,
          80.42532584
        ],
        [
          0.0001135262732,
          0.07639373241689,
          80.46799359
        ],
        [
          0.00010917543794,
          0.07702061360345,
          80.4252519
        ],
        [
          0.00011580151175,
          0.07607457644811,
          80.49039285
        ],
        [
          0.00010918246566,
          0.07701957709071,
          80.42532584
        ],
        [
          0.00011881207395,
          0.07566144962562,
          80.51961801
        ],
        [
          0.000109215333,
          0.07701475968887,
          80.42564587
        ],
        [
          0.00011595392559,
          0.07605381451651,
          80.49152846
        ],
        [
          0.0001092223638,
          0.07701372307385,
          80.42571983
        ],
        [
          0.00012270995895,
          0.07514114438218,
          80.55693589
        ],
        [
          0.000109215333,
          0.07701475968887,
          80.42564587
        ],
        [
          0.00011829678276,
          0.07573158087966,
          80.5145225
        ],
        [
          0.0001092223638,
          0.07701372307385,
          80.42571983
        ],
        [
          0.00012521762874,
          0.07481389745966,
          80.5813456
        ],
        [
          0.000109215333,
          0.07701475968887,
          80.42564587
        ],
        [
          0.00011643816456,
          0.07598670540955,
          80.49630048
        ],
        [
          0.0001092223638,
          0.07701372307385,
          80.42571983
        ],
        [
          0.00012322828287,
          0.07507298423512,
          80.56200106
        ],
        [
          0.000109215333,
          0.07701475968887,
          80.42564587
        ],
        [
          0.0001187928129,
          0.07566410090576,
          80.51939652
        ],
        [
          0.0001092223638,
          0.07701372307385,
          80.42571983
        ],
        [
          0.00012574835589,
          0.0747453997595,
          80.58651767
        ],
        [
          0.000109215333,
          0.07701475968887,
          80.42564587
        ],
        [
          0.00012011554401,
          0.07548590198451,
          80.53195356
        ],
        [
          0.0001092223638,
          0.07701372307385,
          80.42571983
        ],
        [
          0.0001271656134,
          0.07456427070836,
          80.59987567
        ],
        [
          0.000109215333,
          0.07701475968887,
          80.42564587
        ],
        [
          0.00012256013479,
          0.07516050370163,
          80.55582243
        ],
        [
          0.0001092223638,
          0.07701372307385,
          80.42571983
        ],
        [
          0.00013322011674,
          0.07380942937851,
          80.65807706
        ],
        [
          0.000109215333,
          0.07701475968887,
          80.42564587
        ],
        [
          0.00012062081849,
          0.07541812985219,
          80.53690676
        ],
        [
          0.0001092223638,
          0.07701372307385,
          80.42571983
        ],
        [
          0.00012770606143,
          0.07449550687164,
          80.60513075
        ],
        [
          0.000109215333,
          0.07701475968887,
          80.42564587
        ],
        [
          0.00012307758179,
          0.07509238127682,
          80.5608807
        ],
        [
          0.0001092223638,
          0.07701372307385,
          80.42571983
        ],
        [
          0.00013379012895,
          0.07373995074344,
          80.66358586
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00011189308603,
          0.07662766367607,
          80.45085581
        ],
        [
          0.00010917645454,
          0.07702046561943,
          80.42526088
        ],
        [
          0.0001118964587,
          0.07662717871293,
          80.45089003
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011340994292,
          0.07641207281396,
          80.46520284
        ],
        [
          0.00010917645454,
          0.07702046561943,
          80.42526088
        ],
        [
          0.00011341337194,
          0.07641158587828,
          80.46523754
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011220324394,
          0.07658335155413,
          80.45379993
        ],
        [
          0.00010917645454,
          0.07702046561943,
          80.42526088
        ],
        [
          0.00011220662813,
          0.07658286618431,
          80.45383425
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011372551435,
          0.07636754795908,
          80.46819264
        ],
        [
          0.00010917645454,
          0.07702046561943,
          80.42526088
        ],
        [
          0.00011372895505,
          0.07636706062375,
          80.46822744
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011189308603,
          0.07662766367607,
          80.45085581
        ],
        [
          0.00010917645454,
          0.07702046561943,
          80.42526088
        ],
        [
          0.0001118964587,
          0.07662717871293,
          80.45089003
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011340994292,
          0.07641207281396,
          80.46520284
        ],
        [
          0.00010917645454,
          0.07702046561943,
          80.42526088
        ],
        [
          0.00011551240268,
          0.07611782706234,
          80.48487652
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011220324394,
          0.07658335155413,
          80.45379993
        ],
        [
          0.00010917645454,
          0.07702046561943,
          80.42526088
        ],
        [
          0.00011220662813,
          0.07658286618431,
          80.45383425
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011372551435,
          0.07636754795908,
          80.46819264
        ],
        [
          0.00010917645454,
          0.07702046561943,
          80.42526088
        ],
        [
          0.00011583549797,
          0.07607301195261,
          80.4879295
        ],
        [
          0.00010920189759,
          0.07701674513855,
          80.42550071
        ],
        [
          0.00011396502879,
          0.07633404677803,
          80.47027032
        ],
        [
          0.0001092051693,
          0.07701626392047,
          80.42553406
        ],
        [
          0.00011867122316,
          0.07568513214666,
          80.51418575
        ],
        [
          0.00010920189759,
          0.07701674513855,
          80.42550071
        ],
        [
          0.00011551828907,
          0.07611702005441,
          80.48492286
        ],
        [
          0.0001092051693,
          0.07701626392047,
          80.42553406
        ],
        [
          0.00012030664431,
          0.07546506066743,
          80.52952634
        ],
        [
          0.00010920189759,
          0.07701674513855,
          80.42550071
        ],
        [
          0.00011428262518,
          0.07628943923728,
          80.47327695
        ],
        [
          0.0001092051693,
          0.07701626392047,
          80.42553406
        ],
        [
          0.00011900560993,
          0.07563989793345,
          80.51733319
        ],
        [
          0.00010920189759,
          0.07701674513855,
          80.42550071
        ],
        [
          0.00011584140783,
          0.07607220382106,
          80.48797602
        ],
        [
          0.0001092051693,
          0.07701626392047,
          80.42553406
        ],
        [
          0.00012064679094,
          0.07541962738746,
          80.53272217
        ],
        [
          0.00010920189759,
          0.07701674513855,
          80.42550071
        ],
        [
          0.00011684993499,
          0.07593333257043,
          80.49726027
        ],
        [
          0.0001092051693,
          0.07701626392047,
          80.42553406
        ],
        [
          0.00012170935013,
          0.07527873415667,
          80.54245449
        ],
        [
          0.00010920189759,
          0.07701674513855,
          80.42550071
        ],
        [
          0.00011845359158,
          0.07571441236387,
          80.51233535
        ],
        [
          0.0001092051693,
          0.07701626392047,
          80.42553406
        ],
        [
          0.00012573362153,
          0.07475454873099,
          80.579852
        ],
        [
          0.00010920189759,
          0.07701674513855,
          80.42550071
        ],
        [
          0.00011717783007,
          0.07588833535001,
          80.50035338
        ],
        [
          0.0001092051693,
          0.07701626392047,
          80.42553406
        ],
        [
          0.00012205447858,
          0.07523312812862,
          80.54569187
        ],
        [
          0.00010920189759,
          0.07701674513855,
          80.42550071
        ],
        [
          0.00011878715581,
          0.07566921229764,
          80.51547614
        ],
        [
          0.0001092051693,
          0.07701626392047,
          80.42553406
        ],
        [
          0.00012609284381,
          0.07470848836667,
          80.58320728
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00011097425405,
          0.07676029173014,
          80.44152816
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011097425405,
          0.07676029173014,
          80.44152816
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011192041283,
          0.07662489382022,
          80.45011305
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011192041283,
          0.07662489382022,
          80.45011305
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011116301852,
          0.07673319040022,
          80.4432444
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011116301852,
          0.07673319040022,
          80.4432444
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011211136759,
          0.07659769371009,
          80.45184725
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011211136759,
          0.07659769371009,
          80.45184725
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011097425405,
          0.07676029173014,
          80.44152816
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011097425405,
          0.07676029173014,
          80.44152816
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011192041283,
          0.07662489382022,
          80.45011305
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011330964884,
          0.07642809062633,
          80.46262695
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011116301852,
          0.07673319040022,
          80.4432444
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011116301852,
          0.07673319040022,
          80.4432444
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011211136759,
          0.07659769371009,
          80.45184725
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011350382888,
          0.07640074665321,
          80.46438751
        ],
        [
          0.00010919129149,
          0.077018305224,
          80.42539261
        ],
        [
          0.00011235682665,
          0.0765628870888,
          80.45399308
        ],
        [
          0.00010919129149,
          0.077018305224,
          80.42539261
        ],
        [
          0.00011547014867,
          0.07612650276723,
          80.48199347
        ],
        [
          0.00010919129149,
          0.077018305224,
          80.42539261
        ],
        [
          0.00011331910297,
          0.07642676169907,
          80.46270969
        ],
        [
          0.00010919129149,
          0.077018305224,
          80.42539261
        ],
        [
          0.00011646861624,
          0.0759888051544,
          80.49100542
        ],
        [
          0.00010919129149,
          0.077018305224,
          80.42539261
        ],
        [
          0.0001125488052,
          0.07653564001603,
          80.4557356
        ],
        [
          0.00010919129149,
          0.077018305224,
          80.42539261
        ],
        [
          0.00011566934472,
          0.07609894066027,
          80.48379493
        ],
        [
          0.00010919129149,
          0.077018305224,
          80.42539261
        ],
        [
          0.00011351330548,
          0.07639941668498,
          80.46447043
        ],
        [
          0.00010919129149,
          0.077018305224,
          80.42539261
        ],
        [
          0.00011667011038,
          0.07596114712347,
          80.49282567
        ],
        [
          0.00010919129149,
          0.077018305224,
          80.42539261
        ],
        [
          0.00011425840232,
          0.07629500386355,
          80.47113394
        ],
        [
          0.00010919129149,
          0.077018305224,
          80.42539261
        ],
        [
          0.00011744343565,
          0.07585550801422,
          80.49971827
        ],
        [
          0.00010919129149,
          0.077018305224,
          80.42539261
        ],
        [
          0.00011524277555,
          0.07615791100075,
          80.48003106
        ],
        [
          0.00010919129149,
          0.077018305224,
          80.42539261
        ],
        [
          0.00011996460406,
          0.07551533335124,
          80.52233027
        ],
        [
          0.00010919129149,
          0.077018305224,
          80.42539261
        ],
        [
          0.00011445478753,
          0.07626756294195,
          80.47291248
        ],
        [
          0.00010919129149,
          0.077018305224,
          80.42539261
        ],
        [
          0.00011764718524,
          0.07582775604707,
          80.50155688
        ],
        [
          0.00010919129149,
          0.077018305224,
          80.42539261
        ],
        [
          0.00011544143016,
          0.07613037335446,
          80.48182818
        ],
        [
          0.00010919129149,
          0.077018305224,
          80.42539261
        ],
        [
          0.00012017414752,
          0.07548734925295,
          80.52421612
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00011028612514,
          0.07685985684804,
          80.43491349
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011028612514,
          0.07685985684804,
          80.43491349
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011084551086,
          0.07677944307259,
          80.43979279
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011084551086,
          0.07677944307259,
          80.43979279
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011039425491,
          0.0768442838509,
          80.43585636
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011039425491,
          0.0768442838509,
          80.43585636
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011095442851,
          0.07676383032654,
          80.44074194
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011095442851,
          0.07676383032654,
          80.44074194
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011028612514,
          0.07685985684804,
          80.43491349
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011028612514,
          0.07685985684804,
          80.43491349
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011084551086,
          0.07677944307259,
          80.43979279
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011171025032,
          0.07665590939027,
          80.44729835
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011039425491,
          0.0768442838509,
          80.43585636
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011039425491,
          0.0768442838509,
          80.43585636
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011095442851,
          0.07676383032654,
          80.44074194
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011182038927,
          0.07664023538768,
          80.44825721
        ],
        [
          0.00010918356256,
          0.07701943727256,
          80.42531814
        ],
        [
          0.00011114517746,
          0.07673656379709,
          80.44236705
        ],
        [
          0.00010918356256,
          0.07701943727256,
          80.42531814
        ],
        [
          0.00011304965974,
          0.0764663695357,
          80.45885897
        ],
        [
          0.00010918356256,
          0.07701943727256,
          80.42531814
        ],
        [
          0.00011171084132,
          0.07665583341583,
          80.44729631
        ],
        [
          0.00010918356256,
          0.07701943727256,
          80.42531814
        ],
        [
          0.0001136292366,
          0.07638495230652,
          80.4638988
        ],
        [
          0.00010918356256,
          0.07701943727256,
          80.42531814
        ],
        [
          0.00011125452158,
          0.07672092928257,
          80.44331958
        ],
        [
          0.00010918356256,
          0.07701943727256,
          80.42531814
        ],
        [
          0.00011316169514,
          0.07645060154423,
          80.45983288
        ],
        [
          0.00010918356256,
          0.07701943727256,
          80.42531814
        ],
        [
          0.00011182098187,
          0.07664015926615,
          80.44825518
        ],
        [
          0.00010918356256,
          0.07701943727256,
          80.42531814
        ],
        [
          0.0001137420871,
          0.07636914496536,
          80.4648792
        ],
        [
          0.00010918356256,
          0.07701943727256,
          80.42531814
        ],
        [
          0.00011229450035,
          0.07657298302252,
          80.45233477
        ],
        [
          0.00010918356256,
          0.07701943727256,
          80.42531814
        ],
        [
          0.0001142273383,
          0.07630138748061,
          80.46905161
        ],
        [
          0.00010918356256,
          0.07701943727256,
          80.42531814
        ],
        [
          0.00011286855531,
          0.07649183652807,
          80.45733077
        ],
        [
          0.00010918356256,
          0.07701943727256,
          80.42531814
        ],
        [
          0.00011572485087,
          0.07609384103525,
          80.48201902
        ],
        [
          0.00010918356256,
          0.07701943727256,
          80.42531814
        ],
        [
          0.00011240546761,
          0.07655726764397,
          80.45330021
        ],
        [
          0.00010918356256,
          0.07701943727256,
          80.42531814
        ],
        [
          0.00011434103497,
          0.07628553920256,
          80.47003872
        ],
        [
          0.00010918356256,
          0.07701943727256,
          80.42531814
        ],
        [
          0.00011298033027,
          0.07647608168584,
          80.45830264
        ],
        [
          0.00010918356256,
          0.07701943727256,
          80.42531814
        ],
        [
          0.00011584065508,
          0.07607789327684,
          80.48302287
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00010979329147,
          0.07693123774243,
          80.43042019
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010979329147,
          0.07693123774243,
          80.43042019
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011008821855,
          0.07688873258785,
          80.43289263
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011008821855,
          0.07688873258785,
          80.43289263
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010984993832,
          0.07692306648079,
          80.43089427
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010984993832,
          0.07692306648079,
          80.43089427
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011014509633,
          0.07688054849874,
          80.4333685
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011014509633,
          0.07688054849874,
          80.4333685
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010979329147,
          0.07693123774243,
          80.43042019
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010979329147,
          0.07693123774243,
          80.43042019
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011008821855,
          0.07688873258785,
          80.43289263
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011057040342,
          0.07681947964768,
          80.43692275
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010984993832,
          0.07692306648079,
          80.43089427
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010984993832,
          0.07692306648079,
          80.43089427
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011014509633,
          0.07688054849874,
          80.4333685
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00011062765952,
          0.07681127460502,
          80.43740155
        ],
        [
          0.0001091788048,
          0.07702013142294,
          80.42527471
        ],
        [
          0.0001102854072,
          0.07686038316495,
          80.43453613
        ],
        [
          0.0001091788048,
          0.07702013142294,
          80.42527471
        ],
        [
          0.00011137056057,
          0.07670518536617,
          80.44359866
        ],
        [
          0.0001091788048,
          0.07702013142294,
          80.42527471
        ],
        [
          0.00011058234108,
          0.07681776685798,
          80.43702411
        ],
        [
          0.0001091788048,
          0.07702013142294,
          80.42527471
        ],
        [
          0.00011167192258,
          0.07666232648931,
          80.4461209
        ],
        [
          0.0001091788048,
          0.07702013142294,
          80.42527471
        ],
        [
          0.00011034244003,
          0.07685219044198,
          80.4350132
        ],
        [
          0.0001091788048,
          0.07702013142294,
          80.42527471
        ],
        [
          0.00011142844508,
          0.07669694580597,
          80.44408232
        ],
        [
          0.0001091788048,
          0.07702013142294,
          80.42527471
        ],
        [
          0.00011063960645,
          0.07680956131276,
          80.43750298
        ],
        [
          0.0001091788048,
          0.07702013142294,
          80.42527471
        ],
        [
          0.00011173004313,
          0.07665407412517,
          80.44660638
        ],
        [
          0.0001091788048,
          0.07702013142294,
          80.42527471
        ],
        [
          0.00011093401049,
          0.0767674442668,
          80.43995941
        ],
        [
          0.0001091788048,
          0.07702013142294,
          80.42527471
        ],
        [
          0.00011202885078,
          0.07661171605583,
          80.44909682
        ],
        [
          0.0001091788048,
          0.07702013142294,
          80.42527471
        ],
        [
          0.00011123358911,
          0.07672468276718,
          80.44246786
        ],
        [
          0.0001091788048,
          0.07702013142294,
          80.42527471
        ],
        [
          0.00011283002332,
          0.07649864448799,
          80.45578539
        ],
        [
          0.0001091788048,
          0.07702013142294,
          80.42527471
        ],
        [
          0.000110991552,
          0.07675922350758,
          80.44044041
        ],
        [
          0.0001091788048,
          0.07702013142294,
          80.42527471
        ],
        [
          0.00011208725168,
          0.07660344849406,
          80.44958446
        ],
        [
          0.0001091788048,
          0.07702013142294,
          80.42527471
        ],
        [
          0.00011129136524,
          0.07671644919788,
          80.44295068
        ],
        [
          0.0001091788048,
          0.07702013142294,
          80.42527471
        ],
        [
          0.00011288905258,
          0.07649034323387,
          80.45627789
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00010947579738,
          0.07697721494878,
          80.42766955
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010947579738,
          0.07697721494878,
          80.42766955
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010961505443,
          0.07695712659458,
          80.42879451
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010961505443,
          0.07695712659458,
          80.42879451
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010950332586,
          0.07697324244532,
          80.42789153
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010950332586,
          0.07697324244532,
          80.42789153
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010964263888,
          0.07695315073081,
          80.42901691
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010964263888,
          0.07695315073081,
          80.42901691
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010947579738,
          0.07697721494878,
          80.42766955
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010947579738,
          0.07697721494878,
          80.42766955
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010961505443,
          0.07695712659458,
          80.42879451
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010985366088,
          0.07692276622883,
          80.43071795
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010950332586,
          0.07697324244532,
          80.42789153
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010950332586,
          0.07697324244532,
          80.42789153
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010964263888,
          0.07695315073081,
          80.42901691
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010988134136,
          0.0769187846042,
          80.43094108
        ],
        [
          0.00010917596405,
          0.0770205444059,
          80.42525008
        ],
        [
          0.00010971804721,
          0.07694228851052,
          80.42962316
        ],
        [
          0.00010917596405,
          0.0770205444059,
          80.42525008
        ],
        [
          0.00011026061454,
          0.07686432315802,
          80.43399763
        ],
        [
          0.00010917596405,
          0.0770205444059,
          80.42525008
        ],
        [
          0.0001098577967,
          0.07692217064365,
          80.43075183
        ],
        [
          0.00010917596405,
          0.0770205444059,
          80.42525008
        ],
        [
          0.0001104014673,
          0.07684413954601,
          80.4351346
        ],
        [
          0.00010917596405,
          0.0770205444059,
          80.42525008
        ],
        [
          0.00010974567316,
          0.07693831014977,
          80.42984588
        ],
        [
          0.00010917596405,
          0.0770205444059,
          80.42525008
        ],
        [
          0.00011028845888,
          0.0768603317486,
          80.43422198
        ],
        [
          0.00010917596405,
          0.0770205444059,
          80.42525008
        ],
        [
          0.00010988547883,
          0.07691818892205,
          80.43097497
        ],
        [
          0.00010917596405,
          0.0770205444059,
          80.42525008
        ],
        [
          0.00011042936829,
          0.07684014477414,
          80.43535939
        ],
        [
          0.00010917596405,
          0.0770205444059,
          80.42525008
        ],
        [
          0.00011003332745,
          0.07689694040091,
          80.43216506
        ],
        [
          0.00010917596405,
          0.0770205444059,
          80.42525008
        ],
        [
          0.0001105783871,
          0.07681882646903,
          80.43655828
        ],
        [
          0.00010917596405,
          0.0770205444059,
          80.42525008
        ],
        [
          0.00011017371802,
          0.07687678426627,
          80.43329856
        ],
        [
          0.00010917596405,
          0.0770205444059,
          80.42525008
        ],
        [
          0.00011096234109,
          0.07676401514795,
          80.43965253
        ],
        [
          0.00010917596405,
          0.0770205444059,
          80.42525008
        ],
        [
          0.0001100610803,
          0.07689295444536,
          80.43238873
        ],
        [
          0.00010917596405,
          0.0770205444059,
          80.42525008
        ],
        [
          0.00011060635942,
          0.07681482745901,
          80.4367836
        ],
        [
          0.00010917596405,
          0.0770205444059,
          80.42525008
        ],
        [
          0.00011020152731,
          0.07687279494914,
          80.43352266
        ],
        [
          0.00010917596405,
          0.0770205444059,
          80.42525008
        ],
        [
          0.00011099046804,
          0.07676000700373,
          80.43987901
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00010929166939,
          0.07700384845351,
          80.42615057
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010929166939,
          0.07700384845351,
          80.42615057
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010934315948,
          0.07699642334271,
          80.42655174
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010934315948,
          0.07699642334271,
          80.42655174
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010930280095,
          0.07700224292958,
          80.42623732
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010930280095,
          0.07700224292958,
          80.42623732
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010935429984,
          0.07699481725478,
          80.42663855
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010935429984,
          0.07699481725478,
          80.42663855
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010929166939,
          0.07700384845351,
          80.42615057
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010929166939,
          0.07700384845351,
          80.42615057
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010934315948,
          0.07699642334271,
          80.42655174
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010943813425,
          0.07698273673842,
          80.42729109
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010930280095,
          0.07700224292958,
          80.42623732
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010930280095,
          0.07700224292958,
          80.42623732
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010935429984,
          0.07699481725478,
          80.42663855
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010944929088,
          0.07698112960692,
          80.42737802
        ],
        [
          0.00010917426593,
          0.07702079047014,
          80.42523607
        ],
        [
          0.00010938731849,
          0.07699005850707,
          80.42689533
        ],
        [
          0.00010917426593,
          0.07702079047014,
          80.42523607
        ],
        [
          0.00010959881368,
          0.0769596070483,
          80.42854157
        ],
        [
          0.00010917426593,
          0.07702079047014,
          80.42523607
        ],
        [
          0.00010943888436,
          0.07698262853723,
          80.42729706
        ],
        [
          0.00010917426593,
          0.07702079047014,
          80.42523607
        ],
        [
          0.00010965054722,
          0.07695216634422,
          80.42894452
        ],
        [
          0.00010917426593,
          0.07702079047014,
          80.42523607
        ],
        [
          0.00010939846643,
          0.07698845193274,
          80.42698221
        ],
        [
          0.00010917426593,
          0.07702079047014,
          80.42523607
        ],
        [
          0.00010960999785,
          0.07695799815438,
          80.42862871
        ],
        [
          0.00010917426593,
          0.07702079047014,
          80.42523607
        ],
        [
          0.00010945004113,
          0.07698102139793,
          80.42738399
        ],
        [
          0.00010917426593,
          0.07702079047014,
          80.42523607
        ],
        [
          0.00010966174026,
          0.07695055688523,
          80.42903172
        ],
        [
          0.00010917426593,
          0.07702079047014,
          80.42523607
        ],
        [
          0.00010951250697,
          0.07697202624489,
          80.42787049
        ],
        [
          0.00010917426593,
          0.07702079047014,
          80.42523607
        ],
        [
          0.00010972440929,
          0.07694154873339,
          80.42951971
        ],
        [
          0.00010917426593,
          0.07702079047014,
          80.42523607
        ],
        [
          0.00010956417203,
          0.07696458992502,
          80.42827294
        ],
        [
          0.00010917426593,
          0.07702079047014,
          80.42523607
        ],
        [
          0.00010987185033,
          0.0769203745662,
          80.43066738
        ],
        [
          0.00010917426593,
          0.07702079047014,
          80.42523607
        ],
        [
          0.00010952367634,
          0.07697041829897,
          80.42795752
        ],
        [
          0.00010917426593,
          0.07702079047014,
          80.42523607
        ],
        [
          0.00010973561497,
          0.0769399384671,
          80.429607
        ],
        [
          0.00010917426593,
          0.07702079047014,
          80.42523607
        ],
        [
          0.00010957535026,
          0.07696298141252,
          80.42836003
        ],
        [
          0.00010917426593,
          0.07702079047014,
          80.42523607
        ],
        [
          0.00010988308129,
          0.07691876268823,
          80.43075486
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00010920230426,
          0.07701675143151,
          80.42544694
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010920230426,
          0.07701675143151,
          80.42544694
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010921469803,
          0.07701496617967,
          80.42554032
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010921469803,
          0.07701496617967,
          80.42554032
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.0001092049202,
          0.0770163746047,
          80.42546665
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.0001092049202,
          0.0770163746047,
          80.42546665
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010921731451,
          0.07701458931507,
          80.42556003
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010921731451,
          0.07701458931507,
          80.42556003
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010920230426,
          0.07701675143151,
          80.42544694
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010920230426,
          0.07701675143151,
          80.42544694
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010921469803,
          0.07701496617967,
          80.42554032
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010923919656,
          0.07701143786337,
          80.42572488
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.0001092049202,
          0.0770163746047,
          80.42546665
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.0001092049202,
          0.0770163746047,
          80.42546665
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010921731451,
          0.07701458931507,
          80.42556003
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010924181408,
          0.07701106092836,
          80.4257446
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010922661139,
          0.07701325030751,
          80.42563007
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010928122961,
          0.07700538591982,
          80.42604154
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010923901003,
          0.07701146472501,
          80.42572348
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010929363922,
          0.07700359959245,
          80.42613503
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010922922836,
          0.07701287340998,
          80.42564978
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010928384888,
          0.07700500886725,
          80.42606127
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010924162753,
          0.07701108779139,
          80.4257432
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010929625901,
          0.07700322250433,
          80.42615476
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010925697216,
          0.0770088782569,
          80.4258588
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.0001093116172,
          0.07700101204932,
          80.42627046
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.0001092693769,
          0.07700709225905,
          80.42595225
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010934857478,
          0.07699569405037,
          80.42654886
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010925959042,
          0.07700850127139,
          80.42587852
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010931423778,
          0.07700063490688,
          80.4262902
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010927199568,
          0.07700671523923,
          80.42597198
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010935119691,
          0.07699531680326,
          80.42656862
        ]
      ],
      [
        [
          null,
          null,
          81.03022955
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ],
        [
          0.00010917318391,
          0.0770209467964,
          80.42522755
        ]
      ]
    ]
}
};
